import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** Represents an ISO 8601 date and time in UTC. For example, "2022-08-18T08:53:33Z". */
  DateTime: any;
  JSON: any;
  JSONObject: any;
  Void: any;
};

/** The Account object. */
export type Account = {
  __typename?: 'Account';
  /** The Account's unique identifier. */
  id: Scalars['ID'];
};

export type ActivationDashboard = {
  __typename?: 'ActivationDashboard';
  verticals: Array<ProductVertical>;
};

/**
 * AddColumnToDataPoolJob scheduled for a specific Data Pool.
 *
 * The Add Column Job represents the asynchronous process of adding a column,
 * given its name and type, to a Data Pool. It tracks the process of adding a column
 * until it is finished, showing the progress and the outcome when it is finished.
 */
export type AddColumnToDataPoolJob = Job & Node & {
  __typename?: 'AddColumnToDataPoolJob';
  /** Account to which the AddColumnToDataPoolJob belongs. */
  account: Account;
  /** Name of the new column. */
  columnName: Scalars['String'];
  /** Type of the new column. */
  columnType: ColumnType;
  /** The AddColumnToDataPoolJob's creation date and time in UTC. */
  createdAt: Scalars['DateTime'];
  /** Who created the AddColumnToDataPoolJob. */
  createdBy: Scalars['String'];
  /** The Data Pool to which a column will be added by the Job. */
  dataPool: DataPool;
  /** Environment to which the AddColumnToDataPoolJob belongs. */
  environment: Environment;
  /** The error that occurred while adding the column data, if any. */
  error?: Maybe<Error>;
  /** The time at which the AddColumnToDataPool Job failed. */
  failedAt?: Maybe<Scalars['DateTime']>;
  /** The AddColumnToDataPoolJob's ID. */
  id: Scalars['ID'];
  /** JSON property to which the new column corresponds. */
  jsonProperty?: Maybe<Scalars['String']>;
  /** The AddColumnToDataPoolJob's last modification date and time in UTC. */
  modifiedAt: Scalars['DateTime'];
  /** Who modified the AddColumnToDataPoolJob last. */
  modifiedBy: Scalars['String'];
  /** The current progress of the AddColumnToDataPool Job, from 0.0 to 1.0. */
  progress: Scalars['Float'];
  /** The time at which the AddColumnToDataPool Job started. */
  startedAt?: Maybe<Scalars['DateTime']>;
  /** The current AddColumnToDataPoolJob's status. */
  status: JobStatus;
  /** The time at which the AddColumnToDataPool Job succeeded. */
  succeededAt?: Maybe<Scalars['DateTime']>;
};

/**
 * The Add column to Data Pool Job connection object.
 *
 * Learn more about [pagination in GraphQL](https://www.propeldata.com/docs/api/pagination).
 */
export type AddColumnToDataPoolJobConnection = {
  __typename?: 'AddColumnToDataPoolJobConnection';
  /** The Add column to Data Pool Job connection's edges. */
  edges: Array<AddColumnToDataPoolJobEdge>;
  /** The Add column to Data Pool Job connection's nodes. */
  nodes: Array<AddColumnToDataPoolJob>;
  /** The Add column to Data Pool Job connection's page info. */
  pageInfo: PageInfo;
};

/**
 * The Add column to Data Pool Job edge object.
 *
 * Learn more about [pagination in GraphQL](https://www.propeldata.com/docs/api/pagination).
 */
export type AddColumnToDataPoolJobEdge = {
  __typename?: 'AddColumnToDataPoolJobEdge';
  /** The edge's cursor. */
  cursor: Scalars['String'];
  /** The edge's node. */
  node: AddColumnToDataPoolJob;
};

export type AdminContacts = {
  __typename?: 'AdminContacts';
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type AdminContactsInput = {
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Parameters for the AggregatingMergeTree table engine. */
export type AggregatingMergeTreeTableEngine = HasTableEngineType & {
  __typename?: 'AggregatingMergeTreeTableEngine';
  /** The type is always `AGGREGATING_MERGE_TREE`. */
  type: TableEngineType;
};

export type Aggregation = {
  __typename?: 'Aggregation';
  entries?: Maybe<Array<Maybe<AggregationEntry>>>;
};

export type AggregationEntry = {
  __typename?: 'AggregationEntry';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<AggregationValue>;
};

export type AggregationValue = LanguageAggregation | StatsAggregation;

export type AllRules = CloseDateRule | OpportunitiesExistRule | OpportunityRule | SalesStageRule | TcvRule;

export type AllRulesInput = {
  TCVRule?: InputMaybe<TcvRuleInput>;
  closeDateRule?: InputMaybe<CloseDateRuleInput>;
  opportunitiesExistRule?: InputMaybe<OpportunitiesExistRuleInput>;
  opportunityRule?: InputMaybe<OpportunityRuleInput>;
  salesStageRule?: InputMaybe<SalesStageRuleInput>;
};

/**
 * The Application object.
 *
 * Propel Applications represent the web or mobile app you are building. They provide the API credentials that allow your client- or server-side app to access the Propel API. The Application's Propeller determines the speed and cost of your Metric Queries.
 *
 * [Learn more about Applications](https://www.propeldata.com/docs/applications).
 */
export type Application = Common & Node & {
  __typename?: 'Application';
  /** The Application's Account. */
  account: Account;
  /** The Application's OAuth 2.0 client identifier. */
  clientId: Scalars['String'];
  /** The Application's creation date and time in UTC. */
  createdAt: Scalars['DateTime'];
  /** The Application's creator. It can be either a User ID, an Application ID, or "system" if it was created by Propel. */
  createdBy: Scalars['String'];
  /** A paginated list of Data Pool Access Policies associated with the Application. */
  dataPoolAccessPolicies: DataPoolAccessPolicyConnection;
  /** The Application's description. */
  description: Scalars['String'];
  /** The Application's Environment. */
  environment: Environment;
  /** The Application's unique identifier. */
  id: Scalars['ID'];
  /** The Application's last modification date and time in UTC. */
  modifiedAt: Scalars['DateTime'];
  /** The Application's last modifier. It can be either a User ID, an Application ID, or "system" if it was modified by Propel. */
  modifiedBy: Scalars['String'];
  /**
   * A paginated list of Policies associated with the Application.
   * @deprecated Use Data Pool Access Policies instead
   */
  policies: PolicyConnection;
  /** The Application's Propeller. */
  propeller: Propeller;
  /** The Application's OAuth 2.0 scopes. */
  scopes: Array<ApplicationScope>;
  /** The Application's OAuth 2.0 client secret. */
  secret?: Maybe<Scalars['String']>;
  /** The Application's unique name. */
  uniqueName: Scalars['String'];
};


/**
 * The Application object.
 *
 * Propel Applications represent the web or mobile app you are building. They provide the API credentials that allow your client- or server-side app to access the Propel API. The Application's Propeller determines the speed and cost of your Metric Queries.
 *
 * [Learn more about Applications](https://www.propeldata.com/docs/applications).
 */
export type ApplicationDataPoolAccessPoliciesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/**
 * The Application object.
 *
 * Propel Applications represent the web or mobile app you are building. They provide the API credentials that allow your client- or server-side app to access the Propel API. The Application's Propeller determines the speed and cost of your Metric Queries.
 *
 * [Learn more about Applications](https://www.propeldata.com/docs/applications).
 */
export type ApplicationPoliciesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/**
 * The Application connection object.
 *
 * Learn more about [pagination in GraphQL](https://www.propeldata.com/docs/api/pagination).
 */
export type ApplicationConnection = {
  __typename?: 'ApplicationConnection';
  /** The Application connection's edges. */
  edges: Array<ApplicationEdge>;
  /** The Application connection's nodes. */
  nodes: Array<Application>;
  /** The Application connection's page info. */
  pageInfo: PageInfo;
};

/**
 * The Application edge object.
 *
 * Learn more about [pagination in GraphQL](https://www.propeldata.com/docs/api/pagination).
 */
export type ApplicationEdge = {
  __typename?: 'ApplicationEdge';
  /** The edge's cursor. */
  cursor: Scalars['String'];
  /** The edge's node. */
  node: Application;
};

/** The API operations an Application is authorized to perform. */
export const ApplicationScope = {
  /** Grant read/write access to Data Sources, Data Pools, Metrics and Policies. */
  Admin: 'ADMIN',
  /** Grant read/write access to Applications. */
  ApplicationAdmin: 'APPLICATION_ADMIN',
  /** Grant read access to query Data Pools. */
  DataPoolQuery: 'DATA_POOL_QUERY',
  /** Grant read access to read Data Pools. */
  DataPoolRead: 'DATA_POOL_READ',
  /** Grant read access to fetch column statistics from Data Pools. */
  DataPoolStats: 'DATA_POOL_STATS',
  /** Grant read access to query Metrics. */
  MetricQuery: 'METRIC_QUERY',
  /**
   * Grant read access to Metrics.
   *
   * This does not allow querying Metrics. For that, see `METRIC_QUERY`.
   */
  MetricRead: 'METRIC_READ',
  /** Grant read access to fetch Dimension statistics from Metrics. */
  MetricStats: 'METRIC_STATS'
} as const;

export type ApplicationScope = typeof ApplicationScope[keyof typeof ApplicationScope];
export type Auth0User = {
  __typename?: 'Auth0User';
  app_metadata?: Maybe<Auth0UserAppMetadata>;
  email?: Maybe<Scalars['String']>;
  email_verified?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  logins_count?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
  picture?: Maybe<Scalars['String']>;
};

export type Auth0UserAppMetadata = {
  __typename?: 'Auth0UserAppMetadata';
  allowed_vendors?: Maybe<Array<Maybe<Scalars['String']>>>;
  organization_id?: Maybe<Scalars['String']>;
  password_set?: Maybe<Scalars['Boolean']>;
  role?: Maybe<Scalars['String']>;
  sso_user?: Maybe<Scalars['Boolean']>;
  superadmin?: Maybe<Scalars['Boolean']>;
  supportapi?: Maybe<Scalars['Boolean']>;
  vendor_type?: Maybe<Scalars['String']>;
  vendorid?: Maybe<Scalars['String']>;
};

export type Auth0UserCreateInput = {
  email: Scalars['String'];
  role: Auth0UserCreateInputRole;
};

export type Auth0UserCreateInputRole = {
  id: Scalars['String'];
};

export type Auth0UserUserResponse = {
  __typename?: 'Auth0UserUserResponse';
  app_metadata?: Maybe<Auth0UserAppMetadata>;
  email?: Maybe<Scalars['String']>;
  email_verified?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  logins_count?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
  picture?: Maybe<Scalars['String']>;
};

export type AutoScoringDomainCountResponse = {
  __typename?: 'AutoScoringDomainCountResponse';
  domainCount: Scalars['Int'];
};

export type AverageMetricQueryInput = {
  /** The Data Pool to which this Metric belongs. */
  dataPool: DataPoolInput;
  /** The column to be averaged. */
  measure: DimensionInput;
};

/** Settings for Average Metrics. */
export type AverageMetricSettings = {
  __typename?: 'AverageMetricSettings';
  /**
   * Metric Filters allow defining a Metric with a subset of records from the given Data Pool. If no Metric Filters are present, all records will be included. To filter at query time, add Dimensions and use the `filters` property on the `timeSeriesInput`, `counterInput`, or `leaderboardInput` objects. There is no need to add `filters` to be able to filter at query time.
   *
   * You can provide the filters in the form of SQL.
   */
  filterSql?: Maybe<Scalars['String']>;
  /**
   * Metric Filters allow defining a Metric with a subset of records from the given Data Pool. If no Metric Filters are present, all records will be included. To filter at query time, add Dimensions and use the `filters` property on the `timeSeriesInput`, `counterInput`, or `leaderboardInput` objects. There is no need to add `filters` to be able to filter at query time.
   * @deprecated Use `filterSql` instead
   */
  filters?: Maybe<Array<Filter>>;
  /** The Dimension to be averaged. */
  measure: Dimension;
};

export type AwsAmiPricing = {
  __typename?: 'AwsAmiPricing';
  pricing_setting?: Maybe<AwsAmiPricingSetting>;
  pricing_template_url?: Maybe<Scalars['String']>;
};

export type AwsAmiPricingInput = {
  pricing_setting?: InputMaybe<AwsAmiPricingSetting>;
  pricing_template_url?: InputMaybe<Scalars['String']>;
};

export const AwsAmiPricingSetting = {
  Custom: 'custom',
  Standard: 'standard'
} as const;

export type AwsAmiPricingSetting = typeof AwsAmiPricingSetting[keyof typeof AwsAmiPricingSetting];
export type AwsCallbackAuthentication = {
  __typename?: 'AwsCallbackAuthentication';
  api_key?: Maybe<Scalars['String']>;
  auth_header_name?: Maybe<Scalars['String']>;
  auth_type?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

export type AwsCallbackAuthenticationInput = {
  api_key?: InputMaybe<Scalars['String']>;
  auth_header_name?: InputMaybe<Scalars['String']>;
  auth_type?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
};

export type AwsCallbackConfig = {
  __typename?: 'AwsCallbackConfig';
  authentication?: Maybe<AwsCallbackAuthentication>;
  send_email?: Maybe<Scalars['Boolean']>;
  supported_clouds?: Maybe<Array<AwsCallbackConfigSupportedCloudsItem>>;
  url?: Maybe<Scalars['String']>;
};

export type AwsCallbackConfigInput = {
  authentication?: InputMaybe<AwsCallbackAuthenticationInput>;
  send_email?: InputMaybe<Scalars['Boolean']>;
  supported_clouds?: InputMaybe<Array<AwsCallbackConfigSupportedCloudsItem>>;
  url?: InputMaybe<Scalars['String']>;
};

export const AwsCallbackConfigSupportedCloudsItem = {
  Aws: 'aws',
  Azure: 'azure',
  Gcp: 'gcp',
  Redhat: 'redhat'
} as const;

export type AwsCallbackConfigSupportedCloudsItem = typeof AwsCallbackConfigSupportedCloudsItem[keyof typeof AwsCallbackConfigSupportedCloudsItem];
export const AwsCapiChangeStatus = {
  Applying: 'APPLYING',
  Cancelled: 'CANCELLED',
  Failed: 'FAILED',
  Preparing: 'PREPARING',
  Succeeded: 'SUCCEEDED'
} as const;

export type AwsCapiChangeStatus = typeof AwsCapiChangeStatus[keyof typeof AwsCapiChangeStatus];
export type AwsCapiChangeSummary = {
  __typename?: 'AwsCapiChangeSummary';
  ChangeName?: Maybe<Scalars['String']>;
  ChangeType?: Maybe<Scalars['String']>;
  Details?: Maybe<Scalars['String']>;
  DetailsDocument?: Maybe<Scalars['JSON']>;
  Entity?: Maybe<AwsCapiEntity>;
  ErrorDetailList?: Maybe<Array<AwsCapiErrorDetail>>;
};

export type AwsCapiDescribeChangeSetResponse = {
  __typename?: 'AwsCapiDescribeChangeSetResponse';
  ChangeSet?: Maybe<Array<AwsCapiChangeSummary>>;
  ChangeSetArn?: Maybe<Scalars['String']>;
  ChangeSetId?: Maybe<Scalars['String']>;
  ChangeSetName?: Maybe<Scalars['String']>;
  EndTime?: Maybe<Scalars['String']>;
  FailureCode?: Maybe<AwsCapiFailureCode>;
  FailureDescription?: Maybe<Scalars['String']>;
  Intent?: Maybe<AwsCapiIntent>;
  StartTime?: Maybe<Scalars['String']>;
  Status?: Maybe<AwsCapiChangeStatus>;
};

export type AwsCapiEntity = {
  __typename?: 'AwsCapiEntity';
  Identifier?: Maybe<Scalars['String']>;
  Type?: Maybe<Scalars['String']>;
};

export type AwsCapiErrorDetail = {
  __typename?: 'AwsCapiErrorDetail';
  ErrorCode?: Maybe<Scalars['String']>;
  ErrorMessage?: Maybe<Scalars['String']>;
};

export const AwsCapiFailureCode = {
  ClientError: 'CLIENT_ERROR',
  ServerFault: 'SERVER_FAULT'
} as const;

export type AwsCapiFailureCode = typeof AwsCapiFailureCode[keyof typeof AwsCapiFailureCode];
export const AwsCapiIntent = {
  Apply: 'APPLY',
  Validate: 'VALIDATE'
} as const;

export type AwsCapiIntent = typeof AwsCapiIntent[keyof typeof AwsCapiIntent];
export type AwsCapiStartChangeSetResponse = {
  __typename?: 'AwsCapiStartChangeSetResponse';
  ChangeSetArn?: Maybe<Scalars['String']>;
  ChangeSetId?: Maybe<Scalars['String']>;
};

export type AwsCategory = {
  __typename?: 'AwsCategory';
  category?: Maybe<Scalars['String']>;
  subcategory?: Maybe<Scalars['String']>;
};

export type AwsCategoryInput = {
  category?: InputMaybe<Scalars['String']>;
  subcategory?: InputMaybe<Scalars['String']>;
};

export type AwsCustomTemplateIds = {
  __typename?: 'AwsCustomTemplateIds';
  tackle_template_id?: Maybe<Scalars['Float']>;
  vendor_template_id?: Maybe<Scalars['Float']>;
};

export type AwsCustomTemplateIdsInput = {
  tackle_template_id?: InputMaybe<Scalars['Float']>;
  vendor_template_id?: InputMaybe<Scalars['Float']>;
};

export type AwsDemo = {
  __typename?: 'AwsDemo';
  email?: Maybe<Scalars['String']>;
  homepage?: Maybe<Scalars['String']>;
  product_feature?: Maybe<Scalars['String']>;
  registration?: Maybe<Scalars['String']>;
};

export type AwsDemoInput = {
  email?: InputMaybe<Scalars['String']>;
  homepage?: InputMaybe<Scalars['String']>;
  product_feature?: InputMaybe<Scalars['String']>;
  registration?: InputMaybe<Scalars['String']>;
};

export type AwsDimension = {
  __typename?: 'AwsDimension';
  /** while this field is called `name` is is actually associated with the `sku` of a usage fee */
  name: Scalars['String'];
};

export type AwsDimensionInput = {
  /** while this field is called `name` is is actually associated with the `sku` of a usage fee */
  name: Scalars['String'];
};

export type AwsEmailsConfig = {
  __typename?: 'AwsEmailsConfig';
  custom_template_ids?: Maybe<Array<AwsCustomTemplateIds>>;
  default_cc?: Maybe<Scalars['String']>;
  default_from?: Maybe<Scalars['String']>;
};

export type AwsEmailsConfigInput = {
  custom_template_ids?: InputMaybe<Array<AwsCustomTemplateIdsInput>>;
  default_cc?: InputMaybe<Scalars['String']>;
  default_from?: InputMaybe<Scalars['String']>;
};

export type AwsLegal = {
  __typename?: 'AwsLegal';
  contract_type?: Maybe<Scalars['String']>;
  contract_url?: Maybe<Scalars['String']>;
};

export type AwsLegalInput = {
  contract_type?: InputMaybe<Scalars['String']>;
  contract_url?: InputMaybe<Scalars['String']>;
};

export type AwsListing = {
  __typename?: 'AwsListing';
  ami_pricing?: Maybe<AwsAmiPricing>;
  callback?: Maybe<AwsCallbackConfig>;
  capi_change_set_id?: Maybe<Scalars['String']>;
  categories?: Maybe<Array<AwsCategory>>;
  contact_email?: Maybe<Scalars['String']>;
  contact_support_url?: Maybe<Scalars['String']>;
  contract_standard_fields?: Maybe<Array<AwsPrivateOfferMetadataStandardField>>;
  created_at?: Maybe<Scalars['String']>;
  created_by_email?: Maybe<Scalars['String']>;
  demo?: Maybe<AwsDemo>;
  dimension_desc?: Maybe<Scalars['String']>;
  dimensions?: Maybe<Array<AwsDimension>>;
  emails?: Maybe<AwsEmailsConfig>;
  encrypted_productid?: Maybe<Scalars['String']>;
  /**
   * entitlement_dimension_map is an object like
   *
   * ```
   * { [dimension.sku]: dimension.name }
   * ```
   */
  entitlement_dimension_map?: Maybe<Scalars['JSONObject']>;
  experimental_example?: Maybe<Scalars['Boolean']>;
  experimental_salesforce_private_offers_connector?: Maybe<Scalars['Boolean']>;
  full_description?: Maybe<Scalars['String']>;
  highlights?: Maybe<Array<Scalars['String']>>;
  id: Scalars['ID'];
  landing_page_form_button_bg_color?: Maybe<Scalars['String']>;
  landing_page_header_bg_color?: Maybe<Scalars['String']>;
  landing_page_html?: Maybe<Scalars['String']>;
  last_imported_at?: Maybe<Scalars['String']>;
  last_modified_at?: Maybe<Scalars['String']>;
  last_modified_by_email?: Maybe<Scalars['String']>;
  legal?: Maybe<AwsLegal>;
  listing_type?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  managed_by_tkl?: Maybe<Scalars['Boolean']>;
  marketplace_id?: Maybe<Scalars['String']>;
  marketplace_url?: Maybe<Scalars['String']>;
  metering_enabled?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  offers?: Maybe<Array<AwsOffer>>;
  packages?: Maybe<Array<Scalars['String']>>;
  pricing?: Maybe<AwsPricing>;
  product_video_url?: Maybe<Scalars['String']>;
  registration?: Maybe<AwsRegistration>;
  registration_hosting?: Maybe<Scalars['String']>;
  registration_message?: Maybe<Scalars['String']>;
  registration_page_fields?: Maybe<Array<AwsRegistrationField>>;
  registration_redirect?: Maybe<AwsRegistrationRedirect>;
  registration_redirect_configs?: Maybe<Scalars['JSONObject']>;
  registration_submit_html?: Maybe<Scalars['String']>;
  relist_of_listing?: Maybe<AwsListing>;
  relist_of_product_id_internal?: Maybe<Scalars['String']>;
  revision_of_listing?: Maybe<AwsListing>;
  revision_of_product_id_internal?: Maybe<Scalars['String']>;
  search_keywords?: Maybe<Scalars['String']>;
  send_customer_email?: Maybe<Scalars['Boolean']>;
  short_description?: Maybe<Scalars['String']>;
  should_sync_listing_to_salesforce_app?: Maybe<Scalars['Boolean']>;
  sns_configuration?: Maybe<AwsStatus>;
  status?: Maybe<Scalars['String']>;
  style_props?: Maybe<AwsListingStyle>;
  support?: Maybe<AwsSupport>;
  vendor?: Maybe<Vendor>;
  vendorid?: Maybe<Scalars['String']>;
  version_detail?: Maybe<AwsVersionDetail>;
  viewed_advanced_tab?: Maybe<Scalars['Boolean']>;
};

export type AwsListingInput = {
  ami_pricing?: InputMaybe<AwsAmiPricingInput>;
  callback?: InputMaybe<AwsCallbackConfigInput>;
  categories?: InputMaybe<Array<AwsCategoryInput>>;
  contact_email?: InputMaybe<Scalars['String']>;
  contact_support_url?: InputMaybe<Scalars['String']>;
  contract_standard_fields?: InputMaybe<Array<AwsPrivateOfferMetadataStandardFieldInput>>;
  demo?: InputMaybe<AwsDemoInput>;
  dimension_desc?: InputMaybe<Scalars['String']>;
  dimensions?: InputMaybe<Array<AwsDimensionInput>>;
  emails?: InputMaybe<AwsEmailsConfigInput>;
  encrypted_productid?: InputMaybe<Scalars['String']>;
  /**
   * entitlement_dimension_map is an object like
   *
   * ```
   * { [dimension.sku]: dimension.name }
   * ```
   */
  entitlement_dimension_map?: InputMaybe<Scalars['JSONObject']>;
  experimental_example?: InputMaybe<Scalars['Boolean']>;
  experimental_salesforce_private_offers_connector?: InputMaybe<Scalars['Boolean']>;
  full_description?: InputMaybe<Scalars['String']>;
  highlights?: InputMaybe<Array<Scalars['String']>>;
  id: Scalars['ID'];
  landing_page_form_button_bg_color?: InputMaybe<Scalars['String']>;
  landing_page_header_bg_color?: InputMaybe<Scalars['String']>;
  landing_page_html?: InputMaybe<Scalars['String']>;
  legal?: InputMaybe<AwsLegalInput>;
  listing_type?: InputMaybe<Scalars['String']>;
  logo?: InputMaybe<Scalars['String']>;
  managed_by_tkl?: InputMaybe<Scalars['Boolean']>;
  /** super admin only */
  marketplace_id?: InputMaybe<Scalars['String']>;
  marketplace_url?: InputMaybe<Scalars['String']>;
  metering_enabled?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  offers?: InputMaybe<Array<AwsOfferInput>>;
  packages?: InputMaybe<Array<Scalars['String']>>;
  pricing?: InputMaybe<AwsPricingInput>;
  product_video_url?: InputMaybe<Scalars['String']>;
  registration?: InputMaybe<AwsRegistrationInput>;
  registration_hosting?: InputMaybe<Scalars['String']>;
  registration_message?: InputMaybe<Scalars['String']>;
  registration_page_fields?: InputMaybe<Array<AwsRegistrationFieldInput>>;
  registration_redirect?: InputMaybe<AwsRegistrationRedirectInput>;
  registration_redirect_configs?: InputMaybe<Scalars['JSONObject']>;
  registration_submit_html?: InputMaybe<Scalars['String']>;
  relist_of_product_id_internal?: InputMaybe<Scalars['String']>;
  revision_of_product_id_internal?: InputMaybe<Scalars['String']>;
  search_keywords?: InputMaybe<Scalars['String']>;
  send_customer_email?: InputMaybe<Scalars['Boolean']>;
  short_description?: InputMaybe<Scalars['String']>;
  should_sync_listing_to_salesforce_app?: InputMaybe<Scalars['Boolean']>;
  sns_configuration?: InputMaybe<AwsStatusInput>;
  status?: InputMaybe<Scalars['String']>;
  style_props?: InputMaybe<AwsListingStyleInput>;
  support?: InputMaybe<AwsSupportInput>;
  vendorid?: InputMaybe<Scalars['String']>;
  version_detail?: InputMaybe<AwsVersionDetailInput>;
  viewed_advanced_tab?: InputMaybe<Scalars['Boolean']>;
};

export type AwsListingRelistInput = {
  encrypted_productid: Scalars['String'];
  id: Scalars['ID'];
  marketplace_id: Scalars['String'];
  marketplace_url: Scalars['String'];
  name: Scalars['String'];
  should_sync_listing_to_salesforce_app: Scalars['Boolean'];
  status: Scalars['String'];
};

export type AwsListingStyle = {
  __typename?: 'AwsListingStyle';
  bgcolor?: Maybe<Scalars['String']>;
  fgcolor?: Maybe<Scalars['String']>;
};

export type AwsListingStyleInput = {
  bgcolor?: InputMaybe<Scalars['String']>;
  fgcolor?: InputMaybe<Scalars['String']>;
};

export type AwsMarketplaceSaasProduct = {
  __typename?: 'AwsMarketplaceSaasProduct';
  EntityId: Scalars['ID'];
  EntityType?: Maybe<Scalars['String']>;
  LastModifiedDate?: Maybe<Scalars['String']>;
  Name?: Maybe<Scalars['String']>;
  Visibility?: Maybe<Scalars['String']>;
};

export type AwsOffer = {
  __typename?: 'AwsOffer';
  offer_type?: Maybe<AwsOfferOfferType>;
  offerid?: Maybe<Scalars['String']>;
  pricing?: Maybe<Array<AwsOfferPricing>>;
};

export type AwsOfferInput = {
  offer_type?: InputMaybe<AwsOfferOfferType>;
  offerid: Scalars['String'];
  pricing?: InputMaybe<Array<AwsOfferPricingInput>>;
};

export const AwsOfferOfferType = {
  Private: 'private',
  Public: 'public'
} as const;

export type AwsOfferOfferType = typeof AwsOfferOfferType[keyof typeof AwsOfferOfferType];
export type AwsOfferPricing = {
  __typename?: 'AwsOfferPricing';
  dimension: Scalars['String'];
  value: Scalars['Int'];
};

export type AwsOfferPricingInput = {
  dimension: Scalars['String'];
  value: Scalars['Int'];
};

export type AwsPricing = {
  __typename?: 'AwsPricing';
  buyer_contract_type?: Maybe<Scalars['String']>;
  contract_dimensions?: Maybe<Array<AwsPricingContractDimension>>;
  contract_durations?: Maybe<Array<Scalars['String']>>;
  markets?: Maybe<AwsPricingMarkets>;
  product_unit?: Maybe<Scalars['String']>;
  usage_fees?: Maybe<Array<AwsUsageFee>>;
};

export type AwsPricingContractDimension = {
  __typename?: 'AwsPricingContractDimension';
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Float']>;
  prices?: Maybe<AwsPricingContractDimensionPrices>;
  sku?: Maybe<Scalars['String']>;
};

export type AwsPricingContractDimensionInput = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Float']>;
  prices?: InputMaybe<AwsPricingContractDimensionPricesInput>;
  sku?: InputMaybe<Scalars['String']>;
};

export type AwsPricingContractDimensionPrices = {
  __typename?: 'AwsPricingContractDimensionPrices';
  monthly?: Maybe<Scalars['String']>;
  one_year?: Maybe<Scalars['String']>;
  three_year?: Maybe<Scalars['String']>;
  two_year?: Maybe<Scalars['String']>;
};

export type AwsPricingContractDimensionPricesInput = {
  monthly?: InputMaybe<Scalars['String']>;
  one_year?: InputMaybe<Scalars['String']>;
  three_year?: InputMaybe<Scalars['String']>;
  two_year?: InputMaybe<Scalars['String']>;
};

export type AwsPricingInput = {
  buyer_contract_type?: InputMaybe<Scalars['String']>;
  contract_dimensions?: InputMaybe<Array<AwsPricingContractDimensionInput>>;
  contract_durations?: InputMaybe<Array<Scalars['String']>>;
  markets?: InputMaybe<AwsPricingMarketsInput>;
  product_unit?: InputMaybe<Scalars['String']>;
  usage_fees?: InputMaybe<Array<AwsUsageFeeInput>>;
};

export type AwsPricingMarkets = {
  __typename?: 'AwsPricingMarkets';
  countries?: Maybe<Array<Scalars['String']>>;
  target_type?: Maybe<AwsPricingMarketsTargetTypes>;
};

export type AwsPricingMarketsInput = {
  countries?: InputMaybe<Array<Scalars['String']>>;
  target_type?: InputMaybe<AwsPricingMarketsTargetTypes>;
};

export const AwsPricingMarketsTargetTypes = {
  Exclude: 'exclude',
  Include: 'include',
  Worldwide: 'worldwide'
} as const;

export type AwsPricingMarketsTargetTypes = typeof AwsPricingMarketsTargetTypes[keyof typeof AwsPricingMarketsTargetTypes];
export type AwsPrivateOfferMetadataStandardField = {
  __typename?: 'AwsPrivateOfferMetadataStandardField';
  cloud_field?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
};

export type AwsPrivateOfferMetadataStandardFieldInput = {
  cloud_field?: InputMaybe<Scalars['Boolean']>;
  title: Scalars['String'];
};

export type AwsRegistration = {
  __typename?: 'AwsRegistration';
  form?: Maybe<AwsRegistrationForm>;
  hero?: Maybe<AwsRegistrationHero>;
  success?: Maybe<AwsRegistrationSuccess>;
};

export type AwsRegistrationField = {
  __typename?: 'AwsRegistrationField';
  data_type?: Maybe<Scalars['String']>;
  default?: Maybe<Scalars['Boolean']>;
  display_title?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  options?: Maybe<Array<AwsRegistrationFieldOptions>>;
  required?: Maybe<Scalars['Boolean']>;
  tackle_required?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  validation_type?: Maybe<AwsRegistrationFieldValidationType>;
};

export type AwsRegistrationFieldInput = {
  data_type?: InputMaybe<Scalars['String']>;
  default?: InputMaybe<Scalars['Boolean']>;
  display_title: Scalars['String'];
  enabled?: InputMaybe<Scalars['Boolean']>;
  options?: InputMaybe<Array<AwsRegistrationFieldOptionsInput>>;
  required?: InputMaybe<Scalars['Boolean']>;
  tackle_required?: InputMaybe<Scalars['Boolean']>;
  title: Scalars['String'];
  validation_type?: InputMaybe<AwsRegistrationFieldValidationType>;
};

export type AwsRegistrationFieldOptions = {
  __typename?: 'AwsRegistrationFieldOptions';
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type AwsRegistrationFieldOptionsInput = {
  label: Scalars['String'];
  value: Scalars['String'];
};

export const AwsRegistrationFieldValidationType = {
  Email: 'email'
} as const;

export type AwsRegistrationFieldValidationType = typeof AwsRegistrationFieldValidationType[keyof typeof AwsRegistrationFieldValidationType];
export type AwsRegistrationForm = {
  __typename?: 'AwsRegistrationForm';
  button?: Maybe<AwsRegistrationFormButton>;
  logo_url?: Maybe<Scalars['String']>;
};

export type AwsRegistrationFormButton = {
  __typename?: 'AwsRegistrationFormButton';
  background_color?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
};

export type AwsRegistrationFormButtonInput = {
  background_color?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
};

export type AwsRegistrationFormInput = {
  button?: InputMaybe<AwsRegistrationFormButtonInput>;
  logo_url?: InputMaybe<Scalars['String']>;
};

export type AwsRegistrationHero = {
  __typename?: 'AwsRegistrationHero';
  background_color?: Maybe<Scalars['String']>;
  background_image_url?: Maybe<Scalars['String']>;
};

export type AwsRegistrationHeroInput = {
  background_color?: InputMaybe<Scalars['String']>;
  background_image_url?: InputMaybe<Scalars['String']>;
};

export type AwsRegistrationInput = {
  form?: InputMaybe<AwsRegistrationFormInput>;
  hero?: InputMaybe<AwsRegistrationHeroInput>;
  success?: InputMaybe<AwsRegistrationSuccessInput>;
};

export type AwsRegistrationRedirect = {
  __typename?: 'AwsRegistrationRedirect';
  params?: Maybe<Scalars['JSONObject']>;
  url?: Maybe<Scalars['String']>;
};

export type AwsRegistrationRedirectInput = {
  params?: InputMaybe<Scalars['JSONObject']>;
  url: Scalars['String'];
};

export type AwsRegistrationSuccess = {
  __typename?: 'AwsRegistrationSuccess';
  message?: Maybe<Scalars['String']>;
  redirect_url?: Maybe<Scalars['String']>;
};

export type AwsRegistrationSuccessInput = {
  message?: InputMaybe<Scalars['String']>;
  redirect_url?: InputMaybe<Scalars['String']>;
};

export type AwsStatus = {
  __typename?: 'AwsStatus';
  error?: Maybe<Scalars['String']>;
  last_connected_at?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['String']>;
  value?: Maybe<AwsStatusValue>;
};

export type AwsStatusInput = {
  last_connected_at?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<AwsStatusValue>;
};

export const AwsStatusValue = {
  Connected: 'connected',
  Disconnected: 'disconnected',
  Pending: 'pending',
  Unconfigured: 'unconfigured'
} as const;

export type AwsStatusValue = typeof AwsStatusValue[keyof typeof AwsStatusValue];
export type AwsSupport = {
  __typename?: 'AwsSupport';
  details?: Maybe<Scalars['String']>;
  refund_policy?: Maybe<Scalars['String']>;
  support_items?: Maybe<Array<AwsSupportItem>>;
};

export type AwsSupportInput = {
  details?: InputMaybe<Scalars['String']>;
  refund_policy?: InputMaybe<Scalars['String']>;
  support_items?: InputMaybe<Array<AwsSupportItemInput>>;
};

export type AwsSupportItem = {
  __typename?: 'AwsSupportItem';
  display_name?: Maybe<Scalars['String']>;
  support_resource?: Maybe<Scalars['String']>;
};

export type AwsSupportItemInput = {
  display_name?: InputMaybe<Scalars['String']>;
  support_resource?: InputMaybe<Scalars['String']>;
};

export type AwsUsageFee = {
  __typename?: 'AwsUsageFee';
  description?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  sku?: Maybe<Scalars['String']>;
};

export type AwsUsageFeeInput = {
  description?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Float']>;
  price?: InputMaybe<Scalars['Float']>;
  sku?: InputMaybe<Scalars['String']>;
};

export type AwsVersionDetail = {
  __typename?: 'AwsVersionDetail';
  access_instructions?: Maybe<Scalars['String']>;
  access_role_arn?: Maybe<Scalars['String']>;
  ami_id?: Maybe<Scalars['String']>;
  architecture?: Maybe<Scalars['String']>;
  os_type?: Maybe<Scalars['String']>;
  os_version?: Maybe<Scalars['String']>;
  os_version_title?: Maybe<Scalars['String']>;
  release_notes?: Maybe<Scalars['String']>;
  scanning_port?: Maybe<Scalars['String']>;
  security_groups?: Maybe<Array<Scalars['String']>>;
  third_party_software?: Maybe<Scalars['String']>;
  usage_instructions?: Maybe<Scalars['String']>;
  user_name?: Maybe<Scalars['String']>;
};

export type AwsVersionDetailInput = {
  access_instructions?: InputMaybe<Scalars['String']>;
  access_role_arn?: InputMaybe<Scalars['String']>;
  ami_id?: InputMaybe<Scalars['String']>;
  architecture?: InputMaybe<Scalars['String']>;
  os_type?: InputMaybe<Scalars['String']>;
  os_version?: InputMaybe<Scalars['String']>;
  os_version_title?: InputMaybe<Scalars['String']>;
  release_notes?: InputMaybe<Scalars['String']>;
  scanning_port?: InputMaybe<Scalars['String']>;
  security_groups?: InputMaybe<Array<Scalars['String']>>;
  third_party_software?: InputMaybe<Scalars['String']>;
  usage_instructions?: InputMaybe<Scalars['String']>;
  user_name?: InputMaybe<Scalars['String']>;
};

export type AzureAbsolutePrice = {
  __typename?: 'AzureAbsolutePrice';
  billing_term?: Maybe<AzureTermOptionPair>;
  payment_option?: Maybe<AzureTermOptionPair>;
  price_per_payment_in_usd?: Maybe<Scalars['Float']>;
};

export type AzureAllowedTenant = {
  __typename?: 'AzureAllowedTenant';
  description?: Maybe<Scalars['String']>;
  tenant_id?: Maybe<Scalars['String']>;
};

export type AzureAllowedTenantInput = {
  description?: InputMaybe<Scalars['String']>;
  tenant_id?: InputMaybe<Scalars['String']>;
};

export type AzureBaseIncludedQuantity = {
  __typename?: 'AzureBaseIncludedQuantity';
  quantity?: Maybe<Scalars['Float']>;
  type?: Maybe<Scalars['String']>;
  unlimited?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Int']>;
};

export type AzureBaseIncludedQuantityInput = {
  quantity?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<Scalars['String']>;
  unlimited?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Int']>;
};

export type AzureBillingTerm = {
  __typename?: 'AzureBillingTerm';
  payment_option?: Maybe<AzurePaymentOption>;
  price_per_payment_in_usd?: Maybe<Scalars['Float']>;
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Int']>;
};

export type AzureBillingTermInput = {
  payment_option?: InputMaybe<AzurePaymentOptionInput>;
  price_per_payment_in_usd?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Int']>;
};

export type AzureCallbackAuthentication = {
  __typename?: 'AzureCallbackAuthentication';
  api_key?: Maybe<Scalars['String']>;
  auth_header_name?: Maybe<Scalars['String']>;
  auth_type?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

export type AzureCallbackAuthenticationInput = {
  api_key?: InputMaybe<Scalars['String']>;
  auth_header_name?: InputMaybe<Scalars['String']>;
  auth_type?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
};

export type AzureCallbackConfig = {
  __typename?: 'AzureCallbackConfig';
  authentication?: Maybe<AzureCallbackAuthentication>;
  send_email?: Maybe<Scalars['Boolean']>;
  supported_clouds?: Maybe<Array<AzureCallbackConfigSupportedCloudsItem>>;
  url?: Maybe<Scalars['String']>;
};

export type AzureCallbackConfigInput = {
  authentication?: InputMaybe<AzureCallbackAuthenticationInput>;
  send_email?: InputMaybe<Scalars['Boolean']>;
  supported_clouds?: InputMaybe<Array<AzureCallbackConfigSupportedCloudsItem>>;
  url?: InputMaybe<Scalars['String']>;
};

export const AzureCallbackConfigSupportedCloudsItem = {
  Aws: 'aws',
  Azure: 'azure',
  Gcp: 'gcp',
  Redhat: 'redhat'
} as const;

export type AzureCallbackConfigSupportedCloudsItem = typeof AzureCallbackConfigSupportedCloudsItem[keyof typeof AzureCallbackConfigSupportedCloudsItem];
export type AzureCategory = {
  __typename?: 'AzureCategory';
  category?: Maybe<Scalars['String']>;
  subcategory_1?: Maybe<Scalars['String']>;
  subcategory_2?: Maybe<Scalars['String']>;
};

export type AzureCategoryInput = {
  category?: InputMaybe<Scalars['String']>;
  subcategory_1?: InputMaybe<Scalars['String']>;
  subcategory_2?: InputMaybe<Scalars['String']>;
};

export type AzureCustomTemplateIds = {
  __typename?: 'AzureCustomTemplateIds';
  tackle_template_id?: Maybe<Scalars['Float']>;
  vendor_template_id?: Maybe<Scalars['Float']>;
};

export type AzureCustomTemplateIdsInput = {
  tackle_template_id?: InputMaybe<Scalars['Float']>;
  vendor_template_id?: InputMaybe<Scalars['Float']>;
};

export type AzureDimension = {
  __typename?: 'AzureDimension';
  dimension?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
};

export type AzureDimensionInput = {
  dimension: Scalars['String'];
  value: Scalars['Float'];
};

export type AzureEmailsConfig = {
  __typename?: 'AzureEmailsConfig';
  custom_template_ids?: Maybe<Array<AzureCustomTemplateIds>>;
  default_cc?: Maybe<Scalars['String']>;
  default_from?: Maybe<Scalars['String']>;
};

export type AzureEmailsConfigInput = {
  custom_template_ids?: InputMaybe<Array<AzureCustomTemplateIdsInput>>;
  default_cc?: InputMaybe<Scalars['String']>;
  default_from?: InputMaybe<Scalars['String']>;
};

export type AzureIndustry = {
  __typename?: 'AzureIndustry';
  industry?: Maybe<Scalars['String']>;
  vertical_1?: Maybe<Scalars['String']>;
  vertical_2?: Maybe<Scalars['String']>;
};

export type AzureIndustryInput = {
  industry?: InputMaybe<Scalars['String']>;
  vertical_1?: InputMaybe<Scalars['String']>;
  vertical_2?: InputMaybe<Scalars['String']>;
};

export type AzureLicenseAgreement = {
  __typename?: 'AzureLicenseAgreement';
  contract_terms?: Maybe<Scalars['String']>;
  contract_type?: Maybe<Scalars['String']>;
  eula_url?: Maybe<Scalars['String']>;
};

export type AzureLicenseAgreementInput = {
  contract_terms?: InputMaybe<Scalars['String']>;
  contract_type?: InputMaybe<Scalars['String']>;
  eula_url?: InputMaybe<Scalars['String']>;
};

export type AzureListing = {
  __typename?: 'AzureListing';
  callback?: Maybe<AzureCallbackConfig>;
  categories?: Maybe<Array<AzureCategory>>;
  contact_email?: Maybe<Scalars['String']>;
  contact_support_url?: Maybe<Scalars['String']>;
  contract_standard_fields?: Maybe<Array<AzurePrivateOfferMetadataStandardField>>;
  created_at?: Maybe<Scalars['String']>;
  created_by_email?: Maybe<Scalars['String']>;
  emails?: Maybe<AzureEmailsConfig>;
  experimental_example?: Maybe<Scalars['Boolean']>;
  experimental_salesforce_private_offers_connector?: Maybe<Scalars['Boolean']>;
  full_description?: Maybe<Scalars['String']>;
  getting_started_instructions?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  industries?: Maybe<Array<AzureIndustry>>;
  landing_page_form_button_bg_color?: Maybe<Scalars['String']>;
  landing_page_header_bg_color?: Maybe<Scalars['String']>;
  landing_page_html?: Maybe<Scalars['String']>;
  last_imported_at?: Maybe<Scalars['String']>;
  last_modified_at?: Maybe<Scalars['String']>;
  last_modified_by_email?: Maybe<Scalars['String']>;
  license?: Maybe<AzureLicenseAgreement>;
  listing_sku?: Maybe<Scalars['String']>;
  listing_type?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  marketplace_id?: Maybe<Scalars['String']>;
  marketplace_url?: Maybe<Scalars['String']>;
  media_image?: Maybe<Array<AzureMediaImage>>;
  media_video?: Maybe<Array<AzureMediaVideo>>;
  metering_enabled?: Maybe<Scalars['Boolean']>;
  metering_service_dimensions?: Maybe<Array<AzureMeteringServiceDimension>>;
  name?: Maybe<Scalars['String']>;
  offers?: Maybe<Array<AzureOffer>>;
  overview_urls?: Maybe<Array<AzureOverviewUrl>>;
  packages?: Maybe<Array<Scalars['String']>>;
  pricing?: Maybe<AzurePricing>;
  privacy_policy_link?: Maybe<Scalars['String']>;
  registration?: Maybe<AzureRegistration>;
  registration_hosting?: Maybe<Scalars['String']>;
  registration_message?: Maybe<Scalars['String']>;
  registration_page_fields?: Maybe<Array<AzureRegistrationField>>;
  registration_redirect?: Maybe<AzureRegistrationRedirect>;
  registration_redirect_configs?: Maybe<Scalars['JSONObject']>;
  registration_submit_html?: Maybe<Scalars['String']>;
  revision_of_listing?: Maybe<AzureListing>;
  revision_of_product_id_internal?: Maybe<Scalars['String']>;
  search_keywords?: Maybe<Array<Scalars['String']>>;
  send_customer_email?: Maybe<Scalars['Boolean']>;
  short_description?: Maybe<Scalars['String']>;
  should_sync_listing_to_salesforce_app?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['String']>;
  support?: Maybe<AzureSupport>;
  vendor?: Maybe<Vendor>;
  vendorid?: Maybe<Scalars['String']>;
  viewed_advanced_tab?: Maybe<Scalars['Boolean']>;
};

export type AzureListingInput = {
  callback?: InputMaybe<AzureCallbackConfigInput>;
  categories?: InputMaybe<Array<AzureCategoryInput>>;
  contact_email?: InputMaybe<Scalars['String']>;
  contact_support_url?: InputMaybe<Scalars['String']>;
  contract_standard_fields?: InputMaybe<Array<AzurePrivateOfferMetadataStandardFieldInput>>;
  emails?: InputMaybe<AzureEmailsConfigInput>;
  experimental_example?: InputMaybe<Scalars['Boolean']>;
  experimental_salesforce_private_offers_connector?: InputMaybe<Scalars['Boolean']>;
  full_description?: InputMaybe<Scalars['String']>;
  getting_started_instructions?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  industries?: InputMaybe<Array<AzureIndustryInput>>;
  landing_page_form_button_bg_color?: InputMaybe<Scalars['String']>;
  landing_page_header_bg_color?: InputMaybe<Scalars['String']>;
  landing_page_html?: InputMaybe<Scalars['String']>;
  license?: InputMaybe<AzureLicenseAgreementInput>;
  listing_sku?: InputMaybe<Scalars['String']>;
  listing_type?: InputMaybe<Scalars['String']>;
  logo?: InputMaybe<Scalars['String']>;
  /** super admin only */
  marketplace_id?: InputMaybe<Scalars['String']>;
  marketplace_url?: InputMaybe<Scalars['String']>;
  media_image?: InputMaybe<Array<AzureMediaImageInput>>;
  media_video?: InputMaybe<Array<AzureMediaVideoInput>>;
  metering_enabled?: InputMaybe<Scalars['Boolean']>;
  metering_service_dimensions?: InputMaybe<Array<AzureMeteringServiceDimensionInput>>;
  name?: InputMaybe<Scalars['String']>;
  offers?: InputMaybe<Array<AzureOfferInput>>;
  overview_urls?: InputMaybe<Array<AzureOverviewUrlInput>>;
  packages?: InputMaybe<Array<Scalars['String']>>;
  pricing?: InputMaybe<AzurePricingInput>;
  privacy_policy_link?: InputMaybe<Scalars['String']>;
  registration?: InputMaybe<AzureRegistrationInput>;
  registration_hosting?: InputMaybe<Scalars['String']>;
  registration_message?: InputMaybe<Scalars['String']>;
  registration_page_fields?: InputMaybe<Array<AzureRegistrationFieldInput>>;
  registration_redirect?: InputMaybe<AzureRegistrationRedirectInput>;
  registration_redirect_configs?: InputMaybe<Scalars['JSONObject']>;
  registration_submit_html?: InputMaybe<Scalars['String']>;
  search_keywords?: InputMaybe<Array<Scalars['String']>>;
  send_customer_email?: InputMaybe<Scalars['Boolean']>;
  short_description?: InputMaybe<Scalars['String']>;
  should_sync_listing_to_salesforce_app?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Scalars['String']>;
  support?: InputMaybe<AzureSupportInput>;
  vendorid?: InputMaybe<Scalars['String']>;
  viewed_advanced_tab?: InputMaybe<Scalars['Boolean']>;
};

export type AzureListingRelistInput = {
  id: Scalars['ID'];
  marketplace_id: Scalars['String'];
  marketplace_url: Scalars['String'];
  name: Scalars['String'];
  should_sync_listing_to_salesforce_app: Scalars['Boolean'];
  status: Scalars['String'];
};

export type AzureMarketplaceSaasProduct = {
  __typename?: 'AzureMarketplaceSaasProduct';
  alias?: Maybe<Scalars['String']>;
  created_date?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  identity?: Maybe<AzureMarketplaceSaasProductIdentity>;
  status?: Maybe<Scalars['String']>;
  /** @deprecated use status instead */
  target?: Maybe<AzureMarketplaceSaasProductTarget>;
  type?: Maybe<Scalars['String']>;
};

export type AzureMarketplaceSaasProductIdentity = {
  __typename?: 'AzureMarketplaceSaasProductIdentity';
  externalId?: Maybe<Scalars['String']>;
};

export type AzureMarketplaceSaasProductTarget = {
  __typename?: 'AzureMarketplaceSaasProductTarget';
  targetType?: Maybe<Scalars['String']>;
};

export type AzureMediaImage = {
  __typename?: 'AzureMediaImage';
  caption?: Maybe<Scalars['String']>;
  image_url?: Maybe<Scalars['String']>;
};

export type AzureMediaImageInput = {
  caption?: InputMaybe<Scalars['String']>;
  image_url?: InputMaybe<Scalars['String']>;
};

export type AzureMediaVideo = {
  __typename?: 'AzureMediaVideo';
  thumbnail?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  video_url?: Maybe<Scalars['String']>;
};

export type AzureMediaVideoInput = {
  thumbnail?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  video_url?: InputMaybe<Scalars['String']>;
};

export type AzureMeteringServiceDimension = {
  __typename?: 'AzureMeteringServiceDimension';
  identifier?: Maybe<Scalars['String']>;
};

export type AzureMeteringServiceDimensionInput = {
  identifier?: InputMaybe<Scalars['String']>;
};

export type AzureMetric = {
  __typename?: 'AzureMetric';
  display_name?: Maybe<Scalars['String']>;
  plan_pricing?: Maybe<Array<AzurePlanPricing>>;
  product_unit?: Maybe<Scalars['String']>;
  sku?: Maybe<Scalars['String']>;
};

export type AzureMetricInput = {
  display_name?: InputMaybe<Scalars['String']>;
  plan_pricing?: InputMaybe<Array<AzurePlanPricingInput>>;
  product_unit?: InputMaybe<Scalars['String']>;
  sku?: InputMaybe<Scalars['String']>;
};

export type AzureOffer = {
  __typename?: 'AzureOffer';
  offer_type?: Maybe<AzureOfferOfferType>;
  offerid?: Maybe<Scalars['String']>;
  pricing?: Maybe<Array<AzureDimension>>;
};

export type AzureOfferInput = {
  offer_type?: InputMaybe<AzureOfferOfferType>;
  offerid: Scalars['String'];
  pricing?: InputMaybe<Array<AzureDimensionInput>>;
};

export const AzureOfferOfferType = {
  Private: 'private',
  Public: 'public'
} as const;

export type AzureOfferOfferType = typeof AzureOfferOfferType[keyof typeof AzureOfferOfferType];
export type AzureOverviewUrl = {
  __typename?: 'AzureOverviewUrl';
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type AzureOverviewUrlInput = {
  title?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type AzurePaymentOption = {
  __typename?: 'AzurePaymentOption';
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Int']>;
};

export type AzurePaymentOptionInput = {
  type?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Int']>;
};

export type AzurePlan = {
  __typename?: 'AzurePlan';
  billing_terms?: Maybe<Array<AzureBillingTerm>>;
  description?: Maybe<Scalars['String']>;
  free_trial?: Maybe<Scalars['Boolean']>;
  markets?: Maybe<Array<Scalars['String']>>;
  name?: Maybe<Scalars['String']>;
  plan_id?: Maybe<Scalars['String']>;
  plan_uuid?: Maybe<Scalars['String']>;
  user_limits?: Maybe<AzureUserLimit>;
  visibility?: Maybe<AzureVisibility>;
};

export type AzurePlanInput = {
  billing_terms?: InputMaybe<Array<AzureBillingTermInput>>;
  description?: InputMaybe<Scalars['String']>;
  free_trial?: InputMaybe<Scalars['Boolean']>;
  markets?: InputMaybe<Array<Scalars['String']>>;
  name?: InputMaybe<Scalars['String']>;
  plan_id?: InputMaybe<Scalars['String']>;
  plan_uuid?: InputMaybe<Scalars['String']>;
  user_limits?: InputMaybe<AzureUserLimitInput>;
  visibility?: InputMaybe<AzureVisibilityInput>;
};

export type AzurePlanPricing = {
  __typename?: 'AzurePlanPricing';
  base_quantity?: Maybe<Array<AzureBaseIncludedQuantity>>;
  plan_uuid?: Maybe<Scalars['String']>;
  price_per_unit?: Maybe<Scalars['Float']>;
};

export type AzurePlanPricingInput = {
  base_quantity?: InputMaybe<Array<AzureBaseIncludedQuantityInput>>;
  plan_uuid?: InputMaybe<Scalars['String']>;
  price_per_unit?: InputMaybe<Scalars['Float']>;
};

export type AzurePricing = {
  __typename?: 'AzurePricing';
  metrics?: Maybe<Array<AzureMetric>>;
  plans?: Maybe<Array<AzurePlan>>;
  pricing_type?: Maybe<Scalars['String']>;
};

export type AzurePricingInput = {
  metrics?: InputMaybe<Array<AzureMetricInput>>;
  plans?: InputMaybe<Array<AzurePlanInput>>;
  pricing_type?: InputMaybe<Scalars['String']>;
};

export type AzurePrivateOfferMetadataStandardField = {
  __typename?: 'AzurePrivateOfferMetadataStandardField';
  cloud_field?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
};

export type AzurePrivateOfferMetadataStandardFieldInput = {
  cloud_field?: InputMaybe<Scalars['Boolean']>;
  title: Scalars['String'];
};

export type AzureRegistration = {
  __typename?: 'AzureRegistration';
  form?: Maybe<AzureRegistrationForm>;
  hero?: Maybe<AzureRegistrationHero>;
  success?: Maybe<AzureRegistrationSuccess>;
};

export type AzureRegistrationField = {
  __typename?: 'AzureRegistrationField';
  data_type?: Maybe<Scalars['String']>;
  default?: Maybe<Scalars['Boolean']>;
  display_title?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  options?: Maybe<Array<AzureRegistrationFieldOptions>>;
  required?: Maybe<Scalars['Boolean']>;
  tackle_required?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  validation_type?: Maybe<AzureRegistrationFieldValidationType>;
};

export type AzureRegistrationFieldInput = {
  data_type?: InputMaybe<Scalars['String']>;
  default?: InputMaybe<Scalars['Boolean']>;
  display_title: Scalars['String'];
  enabled?: InputMaybe<Scalars['Boolean']>;
  options?: InputMaybe<Array<AzureRegistrationFieldOptionsInput>>;
  required?: InputMaybe<Scalars['Boolean']>;
  tackle_required?: InputMaybe<Scalars['Boolean']>;
  title: Scalars['String'];
  validation_type?: InputMaybe<AzureRegistrationFieldValidationType>;
};

export type AzureRegistrationFieldOptions = {
  __typename?: 'AzureRegistrationFieldOptions';
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type AzureRegistrationFieldOptionsInput = {
  label: Scalars['String'];
  value: Scalars['String'];
};

export const AzureRegistrationFieldValidationType = {
  Email: 'email'
} as const;

export type AzureRegistrationFieldValidationType = typeof AzureRegistrationFieldValidationType[keyof typeof AzureRegistrationFieldValidationType];
export type AzureRegistrationForm = {
  __typename?: 'AzureRegistrationForm';
  button?: Maybe<AzureRegistrationFormButton>;
  logo_url?: Maybe<Scalars['String']>;
};

export type AzureRegistrationFormButton = {
  __typename?: 'AzureRegistrationFormButton';
  background_color?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
};

export type AzureRegistrationFormButtonInput = {
  background_color?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
};

export type AzureRegistrationFormInput = {
  button?: InputMaybe<AzureRegistrationFormButtonInput>;
  logo_url?: InputMaybe<Scalars['String']>;
};

export type AzureRegistrationHero = {
  __typename?: 'AzureRegistrationHero';
  background_color?: Maybe<Scalars['String']>;
  background_image_url?: Maybe<Scalars['String']>;
};

export type AzureRegistrationHeroInput = {
  background_color?: InputMaybe<Scalars['String']>;
  background_image_url?: InputMaybe<Scalars['String']>;
};

export type AzureRegistrationInput = {
  form?: InputMaybe<AzureRegistrationFormInput>;
  hero?: InputMaybe<AzureRegistrationHeroInput>;
  success?: InputMaybe<AzureRegistrationSuccessInput>;
};

export type AzureRegistrationRedirect = {
  __typename?: 'AzureRegistrationRedirect';
  params?: Maybe<Scalars['JSONObject']>;
  url?: Maybe<Scalars['String']>;
};

export type AzureRegistrationRedirectInput = {
  params?: InputMaybe<Scalars['JSONObject']>;
  url: Scalars['String'];
};

export type AzureRegistrationSuccess = {
  __typename?: 'AzureRegistrationSuccess';
  message?: Maybe<Scalars['String']>;
  redirect_url?: Maybe<Scalars['String']>;
};

export type AzureRegistrationSuccessInput = {
  message?: InputMaybe<Scalars['String']>;
  redirect_url?: InputMaybe<Scalars['String']>;
};

export type AzureSupport = {
  __typename?: 'AzureSupport';
  engineering_email?: Maybe<Scalars['String']>;
  engineering_name?: Maybe<Scalars['String']>;
  engineering_phone?: Maybe<Scalars['String']>;
  support_documents?: Maybe<Array<AzureSupportDocument>>;
  support_email?: Maybe<Scalars['String']>;
  support_name?: Maybe<Scalars['String']>;
  support_phone?: Maybe<Scalars['String']>;
  support_url?: Maybe<Scalars['String']>;
};

export type AzureSupportDocument = {
  __typename?: 'AzureSupportDocument';
  document_url?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type AzureSupportDocumentInput = {
  document_url?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type AzureSupportInput = {
  engineering_email?: InputMaybe<Scalars['String']>;
  engineering_name?: InputMaybe<Scalars['String']>;
  engineering_phone?: InputMaybe<Scalars['String']>;
  support_documents?: InputMaybe<Array<AzureSupportDocumentInput>>;
  support_email?: InputMaybe<Scalars['String']>;
  support_name?: InputMaybe<Scalars['String']>;
  support_phone?: InputMaybe<Scalars['String']>;
  support_url?: InputMaybe<Scalars['String']>;
};

export type AzureTermOptionPair = {
  __typename?: 'AzureTermOptionPair';
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Int']>;
};

export type AzureUserLimit = {
  __typename?: 'AzureUserLimit';
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
};

export type AzureUserLimitInput = {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

export type AzureVisibility = {
  __typename?: 'AzureVisibility';
  allowed_tenants?: Maybe<Array<AzureAllowedTenant>>;
  public?: Maybe<Scalars['Boolean']>;
};

export type AzureVisibilityInput = {
  allowed_tenants?: InputMaybe<Array<AzureAllowedTenantInput>>;
  public?: InputMaybe<Scalars['Boolean']>;
};

export type BookedRevenue = {
  __typename?: 'BookedRevenue';
  hasAcceptedOffers?: Maybe<Scalars['Boolean']>;
  hasOffers?: Maybe<Scalars['Boolean']>;
  offersByInterval: Array<Maybe<PrivateOffer>>;
  relativeDifference?: Maybe<Scalars['Float']>;
  tSeriesData: Array<MarketplaceRevenueTimeSeries>;
  totalRevenueByProvider: Array<MarketplaceRevenueByProvider>;
};

/**
 * Boosters allow you to optimize Metric Queries for a subset of commonly used Dimensions. A Metric can have one or many Boosters to optimize for the different Query patterns.
 *
 * Boosters can be understood as an aggregating index. The index is formed from left to right as follows:
 *
 * 1. The Data Pool's Tenant ID column (if present)
 * 2. Metric Filter columns (if present)
 * 3. Query Filter Dimensions (see `dimensions`)
 * 4. The Data Pool's timestamp column
 */
export type Booster = Node & {
  __typename?: 'Booster';
  /** The Booster's Account. */
  account: Account;
  /** The Booster's creation date and time in UTC. */
  createdAt: Scalars['DateTime'];
  /** The Booster's creator. It can be either a User ID, an Application ID, or "system" if it was created by Propel. */
  createdBy: Scalars['String'];
  /** Dimensions included in the Booster. */
  dimensions: Array<Dimension>;
  /** The Booster's Environment. */
  environment: Environment;
  /**
   * If the Booster fails during the optimization process, this field includes a descriptive
   * error message.
   */
  error?: Maybe<Error>;
  /** The Booster's unique identifier. */
  id: Scalars['ID'];
  /** The Metric this Booster is associated to. */
  metric: Metric;
  /** The Booster's last modification date and time in UTC. */
  modifiedAt: Scalars['DateTime'];
  /** The Booster's last modifier. It can be either a User ID, an Application ID, or "system" if it was modified by Propel. */
  modifiedBy: Scalars['String'];
  /**
   * When the Booster is OPTIMIZING, this represents its progress as a number from 0 to 1.
   * In all other states, progress is null.
   */
  progress?: Maybe<Scalars['Float']>;
  /** The number of records in the Booster. */
  recordCount?: Maybe<Scalars['String']>;
  /** The amount of storage in terabytes used by the Booster. */
  sizeInTerabytes?: Maybe<Scalars['Float']>;
  /** The status of the Booster (once LIVE it will be available for speeding up Metric queries). */
  status: BoosterStatus;
};

/**
 * The Booster connection object.
 *
 * Learn more about [pagination in GraphQL](https://www.propeldata.com/docs/api/pagination).
 */
export type BoosterConnection = {
  __typename?: 'BoosterConnection';
  /** The Booster connection's edges. */
  edges: Array<BoosterEdge>;
  /** The Booster connection's nodes. */
  nodes: Array<Booster>;
  /** The Booster connection's page info. */
  pageInfo: PageInfo;
};

/**
 * The Booster edge object.
 *
 * Learn more about [pagination in GraphQL](https://www.propeldata.com/docs/api/pagination).
 */
export type BoosterEdge = {
  __typename?: 'BoosterEdge';
  /** The edge's cursor. */
  cursor: Scalars['String'];
  /** The edge's node. */
  node: Booster;
};

/** The Booster status. */
export const BoosterStatus = {
  /** The Booster has been created. Propel will start optimizing the Data Pool soon. */
  Created: 'CREATED',
  /** Propel is deleting the Booster and all of its associated data. */
  Deleting: 'DELETING',
  /** Propel failed to setup the Booster. Please write to support. Alternatively, you can delete the Booster and try again. */
  Failed: 'FAILED',
  /** The Booster is now live and available to speed up Metric queries. */
  Live: 'LIVE',
  /** Propel is setting up the Booster and optimizing the Data Pool. */
  Optimizing: 'OPTIMIZING'
} as const;

export type BoosterStatus = typeof BoosterStatus[keyof typeof BoosterStatus];
export type CheckEmailResult = {
  __typename?: 'CheckEmailResult';
  valid: Scalars['Boolean'];
};

/** The ClickHouse Data Source connection settings. */
export type ClickHouseConnectionSettings = {
  __typename?: 'ClickHouseConnectionSettings';
  /** Which database to connect to */
  database: Scalars['String'];
  /** The password for the provided user */
  password: Scalars['String'];
  /** Whether the user has readonly permissions or not for querying ClickHouse */
  readonly?: Maybe<Scalars['Boolean']>;
  /** The URL where the ClickHouse host is listening to HTTP[S] connections */
  url: Scalars['String'];
  /** The user for authenticating against the ClickHouse host */
  user: Scalars['String'];
};

export type CloseDateAfter = {
  __typename?: 'CloseDateAfter';
  date: Scalars['String'];
  selector: Scalars['String'];
};

export type CloseDateAfterInput = {
  date: Scalars['String'];
  selector?: Scalars['String'];
};

export type CloseDateBefore = {
  __typename?: 'CloseDateBefore';
  date: Scalars['String'];
  selector: Scalars['String'];
};

export type CloseDateBeforeInput = {
  date: Scalars['String'];
  selector?: Scalars['String'];
};

export type CloseDateFilter = CloseDateAfter | CloseDateBefore | CloseDateWithin;

export type CloseDateFilterInput = {
  after?: InputMaybe<CloseDateAfterInput>;
  before?: InputMaybe<CloseDateBeforeInput>;
  within?: InputMaybe<CloseDateWithinInput>;
};

export type CloseDateRule = {
  __typename?: 'CloseDateRule';
  closeDateFilter: CloseDateFilter;
  pk?: Maybe<Scalars['String']>;
  ruleId?: Maybe<Scalars['String']>;
  ruleSetId?: Maybe<Scalars['String']>;
  ruleType: Scalars['String'];
  sk?: Maybe<Scalars['String']>;
};

export type CloseDateRuleInput = {
  closeDateFilter: CloseDateFilterInput;
  pk?: InputMaybe<Scalars['String']>;
  ruleId?: InputMaybe<Scalars['String']>;
  ruleSetId?: InputMaybe<Scalars['String']>;
  ruleType?: Scalars['String'];
  sk?: InputMaybe<Scalars['String']>;
};

export const CloseDateSelector = {
  After: 'after',
  Before: 'before',
  Within: 'within'
} as const;

export type CloseDateSelector = typeof CloseDateSelector[keyof typeof CloseDateSelector];
export type CloseDateWithin = {
  __typename?: 'CloseDateWithin';
  quantity: Scalars['Int'];
  selector: Scalars['String'];
  unit: Scalars['String'];
};

export type CloseDateWithinInput = {
  quantity: Scalars['Int'];
  selector?: Scalars['String'];
  unit: Scalars['String'];
};

export type CloudOpportunitiesToSalesforceOpportunitiesError = {
  __typename?: 'CloudOpportunitiesToSalesforceOpportunitiesError';
  error?: Maybe<Scalars['String']>;
  row?: Maybe<Scalars['Int']>;
};

export type CloudOpportunitiesToSalesforceOpportunitiesResponse = {
  __typename?: 'CloudOpportunitiesToSalesforceOpportunitiesResponse';
  errors?: Maybe<Array<CloudOpportunitiesToSalesforceOpportunitiesError>>;
  failure?: Maybe<Scalars['Int']>;
  success?: Maybe<Scalars['Int']>;
};

export const CloudOptions = {
  Ace: 'ace',
  Mspc: 'mspc'
} as const;

export type CloudOptions = typeof CloudOptions[keyof typeof CloudOptions];
export const CoSellAceAccessType = {
  Role: 'role',
  User: 'user'
} as const;

export type CoSellAceAccessType = typeof CoSellAceAccessType[keyof typeof CoSellAceAccessType];
export type CoSellAiQueryResponse = {
  __typename?: 'CoSellAiQueryResponse';
  query?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['String']>;
};

export type CoSellCloudSolution = {
  __typename?: 'CoSellCloudSolution';
  archivedAt?: Maybe<Scalars['String']>;
  cloud: CloudOptions;
  externalId: Scalars['ID'];
  id: Scalars['ID'];
  isADefaultSolution?: Maybe<Scalars['Boolean']>;
  solutionName?: Maybe<Scalars['String']>;
};

export type CoSellCloudSolutionCreateInput = {
  cloud: CloudOptions;
  externalId: Scalars['ID'];
  isADefaultSolution?: InputMaybe<Scalars['Boolean']>;
  solutionName?: InputMaybe<Scalars['String']>;
  solutionType?: InputMaybe<Scalars['String']>;
  vendorId: Scalars['ID'];
};

export type CoSellCloudSolutionDeleteInput = {
  id: Scalars['ID'];
  vendorId: Scalars['ID'];
};

export type CoSellCloudSolutionUpdateInput = {
  id: Scalars['ID'];
  isADefaultSolution?: InputMaybe<Scalars['Boolean']>;
  solutionName?: InputMaybe<Scalars['String']>;
  vendorId: Scalars['ID'];
};

export type CoSellMicrosoftSolution = {
  __typename?: 'CoSellMicrosoftSolution';
  archivedAt?: Maybe<Scalars['String']>;
  externalId: Scalars['ID'];
  id: Scalars['ID'];
  solutionName?: Maybe<Scalars['String']>;
};

export type CoSellMicrosoftSolutionCreateInput = {
  externalId: Scalars['ID'];
  solutionName?: InputMaybe<Scalars['String']>;
  vendorId: Scalars['ID'];
};

export type CoSellMicrosoftSolutionDeleteInput = {
  id: Scalars['ID'];
  vendorId: Scalars['ID'];
};

export type CoSellMicrosoftSolutionUpdateInput = {
  id: Scalars['ID'];
  solutionName?: InputMaybe<Scalars['String']>;
  vendorId: Scalars['ID'];
};

export type CoSellVendor = {
  __typename?: 'CoSellVendor';
  ace_access_type?: Maybe<CoSellAceAccessType>;
  ace_auto_submit?: Maybe<Scalars['Boolean']>;
  ace_backfill_needed?: Maybe<Scalars['Boolean']>;
  ace_bucket?: Maybe<Scalars['String']>;
  ace_connected?: Maybe<Scalars['Boolean']>;
  ace_connected_updated_at?: Maybe<Scalars['String']>;
  ace_entitled_status?: Maybe<Scalars['Boolean']>;
  ace_entitled_updated_at?: Maybe<Scalars['String']>;
  ace_kms_key?: Maybe<Scalars['String']>;
  ace_region?: Maybe<Scalars['String']>;
  ace_spms_id?: Maybe<Scalars['String']>;
  ace_version?: Maybe<Scalars['Int']>;
  awsSolutions?: Maybe<Array<CoSellCloudSolution>>;
  backfill_crm_id_as_crm_opp_id?: Maybe<Scalars['Boolean']>;
  custom_workflows?: Maybe<Array<Maybe<Scalars['String']>>>;
  id?: Maybe<Scalars['String']>;
  microsoftPartnerCenterConsentLink?: Maybe<Scalars['String']>;
  microsoftSolutions?: Maybe<Array<CoSellMicrosoftSolution>>;
  mspc_auto_submit?: Maybe<Scalars['Boolean']>;
  mspc_connected?: Maybe<Scalars['Boolean']>;
  mspc_connected_updated_at?: Maybe<Scalars['String']>;
  mspc_entitled_status?: Maybe<Scalars['Boolean']>;
  mspc_entitled_updated_at?: Maybe<Scalars['String']>;
  sandbox_arn?: Maybe<Scalars['String']>;
  vendorId?: Maybe<Scalars['String']>;
  vendor_name?: Maybe<Scalars['String']>;
};

export type CoSellVendorInput = {
  ace_access_type?: InputMaybe<CoSellAceAccessType>;
  ace_auto_submit?: InputMaybe<Scalars['Boolean']>;
  ace_backfill_needed?: InputMaybe<Scalars['Boolean']>;
  ace_bucket?: InputMaybe<Scalars['String']>;
  ace_entitled_status?: InputMaybe<Scalars['Boolean']>;
  ace_kms_key?: InputMaybe<Scalars['String']>;
  ace_region?: InputMaybe<Scalars['String']>;
  ace_spms_id?: InputMaybe<Scalars['String']>;
  backfill_crm_id_as_crm_opp_id?: InputMaybe<Scalars['Boolean']>;
  mspc_auto_submit?: InputMaybe<Scalars['Boolean']>;
  mspc_entitled_status?: InputMaybe<Scalars['Boolean']>;
  sandbox_arn?: InputMaybe<Scalars['String']>;
  vendorId: Scalars['String'];
  vendor_name?: InputMaybe<Scalars['String']>;
};

export type CoSellVertical = ProductVertical & {
  __typename?: 'CoSellVertical';
  data: CoSellVerticalData;
  id: ProductVerticalName;
  stage: VerticalStage;
};

export type CoSellVerticalData = {
  __typename?: 'CoSellVerticalData';
  highScoreCount: Scalars['Int'];
  isAwsConnected: Scalars['Boolean'];
  isAzureConnected: Scalars['Boolean'];
};

/**
 * The column object.
 *
 * Once a table introspection succeeds, it creates a new table object for every table it introspected. Within each table object, it also creates a column object for every column it introspected.
 */
export type Column = {
  __typename?: 'Column';
  /** The time at which the column was cached (i.e., the time at which it was introspected). */
  cachedAt: Scalars['DateTime'];
  /**
   * Information about the column obtained from Snowflake.
   * @deprecated This is Snowflake-specific, and will be removed
   */
  comment?: Maybe<Scalars['String']>;
  /** The time at which the column was created. This is the same as its `cachedAt` time. */
  createdAt: Scalars['DateTime'];
  /** The column's creator. This corresponds to the initiator of the table introspection. It can be either a User ID, an Application ID, or "system" if it was created by Propel. */
  createdBy: Scalars['String'];
  /**
   * Information about the column obtained from Snowflake.
   * @deprecated This is Snowflake-specific, and will be removed
   */
  defaultValue?: Maybe<Scalars['String']>;
  /** Whether the column is nullable, meaning whether it accepts a null value. */
  isNullable?: Maybe<Scalars['Boolean']>;
  /**
   * Information about the column obtained from Snowflake.
   * @deprecated This is Snowflake-specific, and will be removed
   */
  isPrimaryKey?: Maybe<Scalars['Boolean']>;
  /**
   * Information about the column obtained from Snowflake.
   * @deprecated This is Snowflake-specific, and will be removed
   */
  isUniqueKey?: Maybe<Scalars['Boolean']>;
  /**
   * Information about the column obtained from Snowflake.
   * @deprecated This is Snowflake-specific, and will be removed
   */
  kind: Scalars['String'];
  /** The column's name. */
  name: Scalars['String'];
  /**
   * Information about the column obtained from Snowflake.
   * @deprecated This is Snowflake-specific, and will be removed
   */
  policyName?: Maybe<Scalars['String']>;
  /**
   * This is the suggested Data Pool column type to use when converting this Data Source column to a Data Pool column.
   * Propel makes this suggestion based on the Data Source column type. If the Data Source column type is unsupported, this field returns `null`.
   *
   * Sometimes, you know better which Data Pool column type to convert to. In these cases, you can refer
   * to `supportedDataPoolColumnTypes` for the full set of supported conversions.
   */
  suggestedDataPoolColumnType?: Maybe<ColumnType>;
  /**
   * This is the set of supported Data Pool column types you can use when converting this Data Source column to a Data Pool column. If the Data Source column type is unsupported, this field returns an empty array.
   *
   * For example, a numeric Data Source column type could be converted to a narrower or wider numeric Data Pool column type; a string-valued Data Source column type could be mapped to a date or timestamp Data Pool column type.
   *
   * To learn more about the supported conversions, refer to [the docs](https://www.propeldata.com/docs) for your particular Data Source.
   */
  supportedDataPoolColumnTypes: Array<ColumnType>;
  /** The column's type. */
  type: Scalars['String'];
};

/**
 * The column connection object.
 *
 * Learn more about [pagination in GraphQL](https://www.propeldata.com/docs/api/pagination).
 */
export type ColumnConnection = {
  __typename?: 'ColumnConnection';
  /** The time at which the columns were cached (i.e., the time at which they were introspected). */
  cachedAt: Scalars['DateTime'];
  /** The column connection's edges. */
  edges: Array<ColumnEdge>;
  /** The column connection's nodes. */
  nodes: Array<Column>;
  /** The column connection's page info. */
  pageInfo: PageInfo;
};

/**
 * The column edge object.
 *
 * Learn more about [pagination in GraphQL](https://www.propeldata.com/docs/api/pagination).
 */
export type ColumnEdge = {
  __typename?: 'ColumnEdge';
  /** The edge's cursor. */
  cursor: Scalars['String'];
  /** The edge's node. */
  node: Column;
};

/** The Propel data types. */
export const ColumnType = {
  /** True or false. */
  Boolean: 'BOOLEAN',
  /** A ClickHouse-specific type. */
  Clickhouse: 'CLICKHOUSE',
  /** A date without a timestamp. For example, "YYYY-MM-DD". */
  Date: 'DATE',
  /** A 64-bit signed double-precision floating point number. */
  Double: 'DOUBLE',
  /** A 32-bit signed double-precision floating point number. */
  Float: 'FLOAT',
  /** An 8-bit signed integer, with a minimum value of -2⁷ and a maximum value of 2⁷-1. */
  Int8: 'INT8',
  /** A 16-bit signed integer, with a minimum value of -2¹⁵ and a maximum value of 2¹⁵-1. */
  Int16: 'INT16',
  /** A 32-bit signed integer, with a minimum value of -2³¹ and a maximum value of 2³¹-1. */
  Int32: 'INT32',
  /** A 64-bit signed integer, with a minimum value of -2⁶³ and a maximum value of 2⁶³-1. */
  Int64: 'INT64',
  /** A JavaScript Object Notation (JSON) document. */
  Json: 'JSON',
  /** A variable-length string. */
  String: 'STRING',
  /** A date with a timestamp. For example, "yyy-MM-dd HH:mm:ss". */
  Timestamp: 'TIMESTAMP'
} as const;

export type ColumnType = typeof ColumnType[keyof typeof ColumnType];
/**
 * All Propel resources, such as Applications and Metrics, have a set of common properties, such as the Propel Account and Environment that they are associated with. They also have a unique ID, which is specified in the interface `Node`.
 *
 * Environments are independent and isolated Propel workspaces for development, staging (testing), and production workloads.
 */
export type Common = {
  /** The resource's Account. */
  account: Account;
  /** The resource's creation date and time in UTC. */
  createdAt: Scalars['DateTime'];
  /** The resource's creator. It can be either a User ID, an Application ID, or "system" if it was created by Propel. */
  createdBy: Scalars['String'];
  /** The resource's description. */
  description: Scalars['String'];
  /** The resource's Environment. */
  environment: Environment;
  /** The resource's last modification date and time in UTC. */
  modifiedAt: Scalars['DateTime'];
  /** The resource's last modifier. It can be either a User ID, an Application ID, or "system" if it was modified by Propel. */
  modifiedBy: Scalars['String'];
  /** The resource's unique name. */
  uniqueName: Scalars['String'];
};

export type ConnectionDetail = {
  __typename?: 'ConnectionDetail';
  errorCode?: Maybe<Scalars['String']>;
  errorMessage?: Maybe<Scalars['String']>;
  hasOrgDetails?: Maybe<Scalars['Boolean']>;
  instanceUrl?: Maybe<Scalars['String']>;
  organizationDetails?: Maybe<OrganizationDetails>;
  registrationOrgDetails?: Maybe<RegistrationOrgDetails>;
  tackleOrgId?: Maybe<Scalars['String']>;
  userDetails?: Maybe<UserDetails>;
};

export type ConnectionSettings = ClickHouseConnectionSettings | HttpConnectionSettings | InternalConnectionSettings | KafkaConnectionSettings | S3ConnectionSettings | SnowflakeConnectionSettings | WebhookConnectionSettings;

export type Contract = {
  __typename?: 'Contract';
  acceptedDate?: Maybe<Scalars['String']>;
  amendedAgreementExistsInTackle?: Maybe<Scalars['Boolean']>;
  amendedAgreementId?: Maybe<Scalars['String']>;
  autoRenew?: Maybe<Scalars['Boolean']>;
  buyerId?: Maybe<Scalars['String']>;
  cloudContractStatus?: Maybe<Scalars['String']>;
  cloudMarketplace?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  contractDuration?: Maybe<Scalars['String']>;
  contractName?: Maybe<Scalars['String']>;
  contractStart?: Maybe<Scalars['String']>;
  contractStatus?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  endingSoon?: Maybe<Scalars['Boolean']>;
  grossDisbursed?: Maybe<ContractMonetaryValue>;
  id: Scalars['String'];
  listingName?: Maybe<Scalars['String']>;
  listingType?: Maybe<Scalars['String']>;
  marketplaceFeeRate?: Maybe<Scalars['Float']>;
  netDisbursed?: Maybe<ContractMonetaryValue>;
  numberOfPayments?: Maybe<Scalars['Int']>;
  numberOfPaymentsRemaining?: Maybe<Scalars['Int']>;
  offerId?: Maybe<Scalars['String']>;
  offerName?: Maybe<Scalars['String']>;
  offerTargetAccount?: Maybe<Scalars['String']>;
  offerType?: Maybe<Scalars['String']>;
  originalCurrencyGrossDisbursed?: Maybe<ContractMonetaryValue>;
  originalCurrencyNetDisbursed?: Maybe<ContractMonetaryValue>;
  partnerOwnedAgreement?: Maybe<Scalars['Boolean']>;
  paymentModel?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<PaymentScheduleTerm>;
  pricingModel?: Maybe<Scalars['String']>;
  productAndPricing?: Maybe<ContractProductAndPricing>;
  productId?: Maybe<Scalars['String']>;
  registration?: Maybe<ContractRegistrationDetails>;
  startDate?: Maybe<Scalars['String']>;
  tackleOfferId?: Maybe<Scalars['String']>;
  totalContractNetValue?: Maybe<ContractMonetaryValue>;
  totalContractValue?: Maybe<ContractMonetaryValue>;
  totalGrossUninvoicedPayment?: Maybe<ContractMonetaryValue>;
  totalNetUninvoicePayment?: Maybe<ContractMonetaryValue>;
  usageMapping?: Maybe<UsageMapping>;
  vendorId: Scalars['String'];
  vendorId_lowercase?: Maybe<Scalars['String']>;
};

export type ContractAddress = {
  __typename?: 'ContractAddress';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
};

export type ContractAggregation = {
  __typename?: 'ContractAggregation';
  count?: Maybe<Scalars['Int']>;
  sum?: Maybe<Scalars['Float']>;
};

export type ContractAggregationWithNet = {
  __typename?: 'ContractAggregationWithNet';
  count?: Maybe<Scalars['Int']>;
  netDisbursed?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
};

export type ContractFilterValues = {
  __typename?: 'ContractFilterValues';
  cloudMarketplaces?: Maybe<Array<Maybe<Scalars['String']>>>;
  customers?: Maybe<Array<Maybe<Scalars['String']>>>;
  managedByTackle?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  offerTypes?: Maybe<Array<Maybe<Scalars['String']>>>;
  pricingModels?: Maybe<Array<Maybe<Scalars['String']>>>;
  productTypes?: Maybe<Array<Maybe<Scalars['String']>>>;
  products?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ContractHit = {
  __typename?: 'ContractHit';
  _id?: Maybe<Scalars['String']>;
  _index?: Maybe<Scalars['String']>;
  _score?: Maybe<Scalars['Float']>;
  _source?: Maybe<Contract>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ContractHits = {
  __typename?: 'ContractHits';
  hits?: Maybe<Array<Maybe<ContractHit>>>;
  max_score?: Maybe<Scalars['Float']>;
  total?: Maybe<ContractOpenSearchTotal>;
};

export type ContractMonetaryValue = {
  __typename?: 'ContractMonetaryValue';
  amount?: Maybe<Scalars['Float']>;
  currencyCode?: Maybe<Scalars['String']>;
};

export type ContractOpenSearchTotal = {
  __typename?: 'ContractOpenSearchTotal';
  relation?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Int']>;
};

export type ContractProductAndPricing = {
  __typename?: 'ContractProductAndPricing';
  dimensions?: Maybe<Array<Maybe<ContractProductDimension>>>;
  /** @deprecated This field is deprecated and will be removed in future versions. */
  gross?: Maybe<ContractMonetaryValue>;
  isListingManagedByTackle?: Maybe<Scalars['Boolean']>;
  /** @deprecated This field is deprecated and will be removed in future versions. */
  marketplaceFee?: Maybe<Scalars['Float']>;
  /** @deprecated This field is deprecated and will be removed in future versions. */
  net?: Maybe<ContractMonetaryValue>;
  /** @deprecated This field is deprecated and will be removed in future versions. */
  productId?: Maybe<Scalars['String']>;
  /** @deprecated This field is deprecated and will be removed in future versions. */
  productName?: Maybe<Scalars['String']>;
  usageDimensions?: Maybe<Array<Maybe<ContractUsageDimensions>>>;
};

export type ContractProductDimension = {
  __typename?: 'ContractProductDimension';
  api?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  dimension?: Maybe<Scalars['String']>;
  price?: Maybe<ContractMonetaryValue>;
  quantity?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['Float']>;
};

export type ContractRegistrationDetails = {
  __typename?: 'ContractRegistrationDetails';
  address?: Maybe<ContractAddress>;
  companyName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  offerMetadata?: Maybe<Scalars['JSONObject']>;
  phone?: Maybe<Scalars['String']>;
  registrationDate?: Maybe<Scalars['String']>;
  registrationMetadata?: Maybe<Scalars['JSONObject']>;
};

export type ContractSearchResponse = {
  __typename?: 'ContractSearchResponse';
  aggregations?: Maybe<Aggregation>;
  hits?: Maybe<ContractHits>;
};

export type ContractSummaryResponse = {
  __typename?: 'ContractSummaryResponse';
  activeContractsDisbursedRevenue?: Maybe<TackleManagedAndNotManagedContractsWithNet>;
  expiringContractsDisbursedRevenue?: Maybe<TackleManagedAndNotManagedContractsWithNet>;
  pendingPayments?: Maybe<TackleManagedAndNotManagedContracts>;
};

export type ContractUsageDimensions = {
  __typename?: 'ContractUsageDimensions';
  api?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  dimension?: Maybe<Scalars['String']>;
  /** @deprecated This field is deprecated and will be removed in future versions. Replaced by price. */
  feeAmount?: Maybe<ContractMonetaryValue>;
  price?: Maybe<ContractMonetaryValue>;
  /** @deprecated This field is deprecated and will be removed in future versions. Replaced by dimension/api. */
  sku?: Maybe<Scalars['String']>;
};

export type ContractsExportPresignedUrlResponse = {
  __typename?: 'ContractsExportPresignedUrlResponse';
  presignedUrl?: Maybe<Scalars['String']>;
};

export type CountDistinctMetricQueryInput = {
  /** The Data Pool to which this Metric belongs. */
  dataPool: DataPoolInput;
  /** The column to count distinct values from. */
  dimension: DimensionInput;
};

/** Settings for Count Distinct Metrics. */
export type CountDistinctMetricSettings = {
  __typename?: 'CountDistinctMetricSettings';
  /** The Dimension where the count distinct operation is going to be performed. */
  dimension: Dimension;
  /**
   * Metric Filters allow defining a Metric with a subset of records from the given Data Pool. If no Metric Filters are present, all records will be included. To filter at query time, add Dimensions and use the `filters` property on the `timeSeriesInput`, `counterInput`, or `leaderboardInput` objects. There is no need to add `filters` to be able to filter at query time.
   *
   * You can provide the filters in the form of SQL.
   */
  filterSql?: Maybe<Scalars['String']>;
  /**
   * Metric Filters allow defining a Metric with a subset of records from the given Data Pool. If no Metric Filters are present, all records will be included. To filter at query time, add Dimensions and use the `filters` property on the `timeSeriesInput`, `counterInput`, or `leaderboardInput` objects. There is no need to add `filters` to be able to filter at query time.
   * @deprecated Use `filterSql` instead
   */
  filters?: Maybe<Array<Filter>>;
};

export type CountMetricQueryInput = {
  /** The Data Pool to which this Metric belongs. */
  dataPool: DataPoolInput;
};

/** Settings for Count Metrics. */
export type CountMetricSettings = {
  __typename?: 'CountMetricSettings';
  /**
   * Metric Filters allow defining a Metric with a subset of records from the given Data Pool. If no Metric Filters are present, all records will be included. To filter at query time, add Dimensions and use the `filters` property on the `timeSeriesInput`, `counterInput`, or `leaderboardInput` objects. There is no need to add `filters` to be able to filter at query time.
   *
   * You can provide the filters in the form of SQL.
   */
  filterSql?: Maybe<Scalars['String']>;
  /**
   * Metric Filters allow defining a Metric with a subset of records from the given Data Pool. If no Metric Filters are present, all records will be included. To filter at query time, add Dimensions and use the `filters` property on the `timeSeriesInput`, `counterInput`, or `leaderboardInput` objects. There is no need to add `filters` to be able to filter at query time.
   * @deprecated Use `filterSql` instead
   */
  filters?: Maybe<Array<Filter>>;
};

/**
 * The fields for querying a Metric in counter format.
 *
 * A Metric's counter query returns a single value over a given time range.
 */
export type CounterInput = {
  /** The Query Filters to apply before retrieving the counter data, in the form of SQL. If no Query Filters are provided, all data is included. */
  filterSql?: InputMaybe<Scalars['String']>;
  /** The Query Filters to apply before retrieving the counter data. If no Query Filters are provided, all data is included. */
  filters?: InputMaybe<Array<FilterInput>>;
  /** The Metric to query. You can query a pre-configured Metric by ID or name, or you can query an ad hoc Metric that you define inline. */
  metric?: InputMaybe<MetricInput>;
  /**
   * The ID of the Metric to query.
   *
   * Required if `metricName` is not specified.
   */
  metricId?: InputMaybe<Scalars['ID']>;
  /**
   * The name of the Metric to query.
   *
   * Required if `metricId` is not specified.
   */
  metricName?: InputMaybe<Scalars['String']>;
  /** The time range for calculating the counter. */
  timeRange?: InputMaybe<TimeRangeInput>;
  /**
   * The time zone to use. Dates and times are always returned in UTC, but setting the time zone influences relative time ranges and granularities.
   *
   * You can set this to "America/Los_Angeles", "Europe/Berlin", or any other value in the [IANA time zone database](https://en.wikipedia.org/wiki/Tz_database). Defaults to "UTC".
   */
  timeZone?: InputMaybe<Scalars['String']>;
};

/** The counter response object. It contains a single Metric value for the given time range and Query Filters. */
export type CounterResponse = {
  __typename?: 'CounterResponse';
  /** The Query statistics and metadata. */
  query: QueryInfo;
  /** The value of the counter. */
  value?: Maybe<Scalars['String']>;
};

export type CreateOrUpdateListingWithCapiInput = {
  overrideToPennyPricing?: InputMaybe<Scalars['Boolean']>;
};

export type CreateVendorInput = {
  activity?: InputMaybe<Array<VendorActivityInput>>;
  applications?: InputMaybe<Array<VendorApplicationInput>>;
  aws_access_key_id?: InputMaybe<Scalars['String']>;
  aws_secret_access_key?: InputMaybe<Scalars['String']>;
  configuration?: InputMaybe<VendorConfigurationInput>;
  disabled_actions?: InputMaybe<Array<Scalars['String']>>;
  email?: InputMaybe<Scalars['String']>;
  feature_flags?: InputMaybe<VendorFeatureFlagsInput>;
  logo_url?: InputMaybe<Scalars['String']>;
  metering?: InputMaybe<VendorMeteringConfigInput>;
  name?: InputMaybe<Scalars['String']>;
  onboarding?: InputMaybe<VendorOnboardingInput>;
  organization_id?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  production_vendor_id?: InputMaybe<Scalars['String']>;
  tkl_customer_data?: InputMaybe<Array<VendorTackleCustomerDataItemInput>>;
  tkl_customer_type?: InputMaybe<Scalars['String']>;
  vendor_type?: InputMaybe<Scalars['String']>;
};

export type CustomMetricQueryInput = {
  /** The Data Pool to which this Metric belongs. */
  dataPool: DataPoolInput;
  /** Custom expression for defining the Metric. */
  expression: Scalars['String'];
};

/** Settings for Custom Metrics. */
export type CustomMetricSettings = {
  __typename?: 'CustomMetricSettings';
  /** The expression that defines the aggregation function for this Metric. */
  expression: Scalars['String'];
  /**
   * Metric Filters allow defining a Metric with a subset of records from the given Data Pool. If no Metric Filters are present, all records will be included. To filter at query time, add Dimensions and use the `filters` property on the `timeSeriesInput`, `counterInput`, or `leaderboardInput` objects. There is no need to add `filters` to be able to filter at query time.
   *
   * You can provide the filters in the form of SQL.
   */
  filterSql?: Maybe<Scalars['String']>;
  /**
   * Metric Filters allow defining a Metric with a subset of records from the given Data Pool. If no Metric Filters are present, all records will be included. To filter at query time, add Dimensions and use the `filters` property on the `timeSeriesInput`, `counterInput`, or `leaderboardInput` objects. There is no need to add `filters` to be able to filter at query time.
   * @deprecated Use `filterSql` instead
   */
  filters?: Maybe<Array<Filter>>;
};

/**
 * The Data Grid connection.
 *
 * It includes `headers` and `rows` for a single page of a Data Grid table. It also allows paging forward and backward to other
 * pages of the Data Grid table.
 *
 * Learn more about [pagination in GraphQL](https://www.propeldata.com/docs/api/pagination).
 */
export type DataGridConnection = {
  __typename?: 'DataGridConnection';
  /** The Data Grid table's edges. */
  edges: Array<DataGridEdge>;
  /** The Data Grid table's headers. */
  headers: Array<Scalars['String']>;
  /** The Data Grid table's nodes. */
  nodes: Array<DataGridNode>;
  /** The Data Grid table's page info. */
  pageInfo: PageInfo;
  /** The Query statistics and metadata. */
  query: QueryInfo;
  /** An array of arrays containing the values of the Data Grid table's rows. */
  rows: Array<Array<Maybe<Scalars['String']>>>;
};

/**
 * The Data Grid edge object.
 *
 * Learn more about [pagination in GraphQL](https://www.propeldata.com/docs/api/pagination).
 */
export type DataGridEdge = {
  __typename?: 'DataGridEdge';
  /** The edge's cursor. */
  cursor: Scalars['String'];
  /** The edge's node. */
  node: DataGridNode;
};

/** The fields for querying Data Grid records. */
export type DataGridInput = {
  /** The cursor to use when paging forward. */
  after?: InputMaybe<Scalars['String']>;
  /** The cursor to use when paging backward. */
  before?: InputMaybe<Scalars['String']>;
  /** The columns to retrieve. */
  columns: Array<Scalars['String']>;
  /** The Data Pool to be queried. */
  dataPool: DataPoolInput;
  /** The filters to apply to the records, in the form of SQL. You may only filter on columns included in the `columns` array input. */
  filterSql?: InputMaybe<Scalars['String']>;
  /** The filters to apply to the records. You may only filter on columns included in the `columns` array input. */
  filters?: InputMaybe<Array<FilterInput>>;
  /** The number of rows to be returned when paging forward. It can be a number between 1 and 1,000. */
  first?: InputMaybe<Scalars['Int']>;
  /** The number of rows to be returned when paging forward. It can be a number between 1 and 1,000. */
  last?: InputMaybe<Scalars['Int']>;
  /** The index of the column to order the table by. The index is 1-based. If not provided, records will be ordered by their timestamp by default. */
  orderByColumn?: InputMaybe<Scalars['Int']>;
  /** The sort order of the rows. It can be ascending (`ASC`) or descending (`DESC`) order. Defaults to descending (`DESC`) order when not provided. */
  sort?: InputMaybe<Sort>;
  /** The time range for retrieving the records. */
  timeRange?: InputMaybe<TimeRangeInput>;
  /**
   * The time zone to use. Dates and times are always returned in UTC, but setting the time zone influences relative time ranges and granularities.
   *
   * You can set this to "America/Los_Angeles", "Europe/Berlin", or any other value in the [IANA time zone database](https://en.wikipedia.org/wiki/Tz_database). Defaults to "UTC".
   */
  timeZone?: InputMaybe<Scalars['String']>;
};

/**
 * The Data Grid table's node.
 *
 * This type represents a single row of a Data Grid table.
 *
 * Learn more about [pagination in GraphQL](https://www.propeldata.com/docs/api/pagination).
 */
export type DataGridNode = {
  __typename?: 'DataGridNode';
  /** The Data Grid table's headers. */
  headers: Array<Scalars['String']>;
  /** An array of the values for the row. */
  row: Array<Maybe<Scalars['String']>>;
};

/**
 * The Data Pool object. Data Pools are Propel's high-speed data store and cache
 *
 * [Learn more about Data Pools](https://www.propeldata.com/docs/connect-your-data#key-concept-2-data-pools).
 */
export type DataPool = Common & Node & {
  __typename?: 'DataPool';
  /**
   * Whether the Data Pool has access control enabled or not.
   *
   * If the Data Pool has access control enabled, Applications must be assigned Data Pool Access
   * Policies in order to query the Data Pool and its Metrics.
   */
  accessControlEnabled: Scalars['Boolean'];
  /** The Data Pool's Account. */
  account: Account;
  /** The Add Column Jobs that were historically issued to this Data Pool, sorted by creation time, in descending order. */
  addColumnToDataPoolJobs?: Maybe<AddColumnToDataPoolJobConnection>;
  /** The list of measures (numeric columns) in the Data Pool. */
  availableMeasures?: Maybe<DataPoolColumnConnection>;
  /** The Data Pool's columns. */
  columns?: Maybe<DataPoolColumnConnection>;
  /** The Data Pool's creation date and time in UTC. */
  createdAt: Scalars['DateTime'];
  /** The Data Pool's creator. It can be either a User ID, an Application ID, or "system" if it was created by Propel. */
  createdBy: Scalars['String'];
  /** A paginated list of Data Pool Access Policies available on the Data Pool. */
  dataPoolAccessPolicies: DataPoolAccessPolicyConnection;
  /** The Data Pool's data retention in days (not yet supported). */
  dataRetentionInDays: Scalars['Int'];
  /** The Data Pool's Data Source. */
  dataSource: DataSource;
  /** The Deletion Jobs that were historically issued to this Data Pool, sorted by creation time, in descending order. */
  deletionJobs?: Maybe<DeletionJobConnection>;
  /** The Data Pool's description. */
  description: Scalars['String'];
  /** The Data Pool's Environment. */
  environment: Environment;
  /** @deprecated Refer to `setupTasks` instead */
  error?: Maybe<Error>;
  /** The Data Pool's unique identifier. */
  id: Scalars['ID'];
  /** The list of Metrics powered by the Data Pool. */
  metrics?: Maybe<MetricConnection>;
  /** The Data Pool's last modification date and time in UTC. */
  modifiedAt: Scalars['DateTime'];
  /** The Data Pool's last modifier. It can be either a User ID, an Application ID, or "system" if it was modified by Propel. */
  modifiedBy: Scalars['String'];
  /** The Data Pool's columns that participate in its ORDER BY clause. */
  orderByColumns?: Maybe<Array<DataPoolColumn>>;
  /** The Data Pool's columns that participate in its PARTITION BY clause. */
  partitionByColumns?: Maybe<Array<DataPoolColumn>>;
  /** The Data Pool's columns that participate in its PRIMARY KEY clause. */
  primaryKeyColumns?: Maybe<Array<DataPoolColumn>>;
  /** The number of records in the Data Pool. */
  recordCount?: Maybe<Scalars['String']>;
  /** A list of setup tasks performed on the Data Pool during its most recent setup attempt. */
  setupTasks?: Maybe<Array<DataPoolSetupTask>>;
  /** The amount of storage in terabytes used by the Data Pool. */
  sizeInTerabytes?: Maybe<Scalars['Float']>;
  /** The Data Pool's status. */
  status: DataPoolStatus;
  /** Settings related to Data Pool syncing. */
  syncing: DataPoolSyncing;
  /** The list of Syncs of the Data Pool. */
  syncs?: Maybe<SyncConnection>;
  /** The name of the Data Pool's table. */
  table: Scalars['String'];
  /** The Data Pool's table settings. */
  tableSettings: TableSettings;
  /**
   * The Data Pool's tenant ID, if configured.
   * @deprecated Will be removed; use Data Pool Access Policies instead
   */
  tenant?: Maybe<Tenant>;
  /** The Data Pool's primary timestamp column, if any. */
  timestamp?: Maybe<Timestamp>;
  /**
   * The Data Pool's unique ID column. Propel uses the primary timestamp and a unique ID to compose a primary key for determining whether records should be inserted, deleted, or updated within the Data Pool.
   * @deprecated Will be removed; use Table Settings to define the primary key.
   */
  uniqueId?: Maybe<UniqueId>;
  /** The Data Pool's unique name. */
  uniqueName: Scalars['String'];
  /** The UpdateDataPoolRecords Jobs that were historically issued to this Data Pool, sorted by creation time, in descending order. */
  updateDataPoolRecordsJobs?: Maybe<UpdateDataPoolRecordsJobConnection>;
  /** Validates a custom expression against the Data Pool's available columns. If the provided expression is invalid, the ValidateExpressionResult response will contain a reason explaining why. */
  validateExpression: ValidateExpressionResult;
};


/**
 * The Data Pool object. Data Pools are Propel's high-speed data store and cache
 *
 * [Learn more about Data Pools](https://www.propeldata.com/docs/connect-your-data#key-concept-2-data-pools).
 */
export type DataPoolAddColumnToDataPoolJobsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/**
 * The Data Pool object. Data Pools are Propel's high-speed data store and cache
 *
 * [Learn more about Data Pools](https://www.propeldata.com/docs/connect-your-data#key-concept-2-data-pools).
 */
export type DataPoolAvailableMeasuresArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/**
 * The Data Pool object. Data Pools are Propel's high-speed data store and cache
 *
 * [Learn more about Data Pools](https://www.propeldata.com/docs/connect-your-data#key-concept-2-data-pools).
 */
export type DataPoolColumnsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/**
 * The Data Pool object. Data Pools are Propel's high-speed data store and cache
 *
 * [Learn more about Data Pools](https://www.propeldata.com/docs/connect-your-data#key-concept-2-data-pools).
 */
export type DataPoolDataPoolAccessPoliciesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/**
 * The Data Pool object. Data Pools are Propel's high-speed data store and cache
 *
 * [Learn more about Data Pools](https://www.propeldata.com/docs/connect-your-data#key-concept-2-data-pools).
 */
export type DataPoolDeletionJobsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/**
 * The Data Pool object. Data Pools are Propel's high-speed data store and cache
 *
 * [Learn more about Data Pools](https://www.propeldata.com/docs/connect-your-data#key-concept-2-data-pools).
 */
export type DataPoolMetricsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/**
 * The Data Pool object. Data Pools are Propel's high-speed data store and cache
 *
 * [Learn more about Data Pools](https://www.propeldata.com/docs/connect-your-data#key-concept-2-data-pools).
 */
export type DataPoolSyncsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SyncsFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/**
 * The Data Pool object. Data Pools are Propel's high-speed data store and cache
 *
 * [Learn more about Data Pools](https://www.propeldata.com/docs/connect-your-data#key-concept-2-data-pools).
 */
export type DataPoolUpdateDataPoolRecordsJobsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/**
 * The Data Pool object. Data Pools are Propel's high-speed data store and cache
 *
 * [Learn more about Data Pools](https://www.propeldata.com/docs/connect-your-data#key-concept-2-data-pools).
 */
export type DataPoolValidateExpressionArgs = {
  expression: Scalars['String'];
};

export type DataPoolAccessPolicy = Common & Node & {
  __typename?: 'DataPoolAccessPolicy';
  /** The Data Pool Access Policy's Account. */
  account: Account;
  /** Applications that are assigned to this Data Pool Access Policy. */
  applications: ApplicationConnection;
  /** Columns that the Access Policy makes available for querying. */
  columns: Array<Scalars['String']>;
  /** The Data Pool Access Policy's creation date and time in UTC. */
  createdAt: Scalars['DateTime'];
  /** The Data Pool Access Policy's creator. It can be either a User ID, an Application ID, or "system" if it was created by Propel. */
  createdBy: Scalars['String'];
  /** The Data Pool to which the Access Policy belongs. */
  dataPool: DataPool;
  /** The Data Pool Access Policy's description. */
  description: Scalars['String'];
  /** The Data Pool Access Policy's Environment. */
  environment: Environment;
  /** Row-level filters that the Access Policy applies before executing queries, in the form of SQL. */
  filterSql?: Maybe<Scalars['String']>;
  /** The ID of the Data Pool Access Policy. */
  id: Scalars['ID'];
  /** The Data Pool Access Policy's last modification date and time in UTC. */
  modifiedAt: Scalars['DateTime'];
  /** The Data Pool Access Policy's last modifier. It can be either a User ID, an Application ID, or "system" if it was modified by Propel. */
  modifiedBy: Scalars['String'];
  /**
   * Row-level filters that the Access Policy applies before executing queries.
   * @deprecated Use `filtersSql` instead
   */
  rows?: Maybe<Array<Filter>>;
  /** The Data Pool Access Policy's unique name. */
  uniqueName: Scalars['String'];
};


export type DataPoolAccessPolicyApplicationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/**
 * The Data Pool Access Policy connection object.
 *
 * Learn more about [pagination in GraphQL](https://www.propeldata.com/docs/api/pagination).
 */
export type DataPoolAccessPolicyConnection = {
  __typename?: 'DataPoolAccessPolicyConnection';
  /** The Data Pool Access Policy connection's edges. */
  edges: Array<DataPoolAccessPolicyEdge>;
  /** The Data Pool Access Policy connection's nodes. */
  nodes: Array<DataPoolAccessPolicy>;
  /** The Data Pool Access Policy connection's page info. */
  pageInfo: PageInfo;
};

/**
 * The Data Pool Access Policy edge object.
 *
 * Learn more about [pagination in GraphQL](https://www.propeldata.com/docs/api/pagination).
 */
export type DataPoolAccessPolicyEdge = {
  __typename?: 'DataPoolAccessPolicyEdge';
  /** The edge's cursor. */
  cursor: Scalars['String'];
  /** The edge's node. */
  node: DataPoolAccessPolicy;
};

export type DataPoolColumn = {
  __typename?: 'DataPoolColumn';
  /** The ClickHouse type. This is the exact representation of the type in ClickHouse. */
  clickHouseType: Scalars['String'];
  /** The name of the Data Source column that this Data Pool column derives from. */
  columnName: Scalars['String'];
  /** Whether the column is nullable, meaning whether it accepts a null value. */
  isNullable: Scalars['Boolean'];
  /**
   * The name of the Data Source column that this Data Pool column derives from.
   * @deprecated Start using `columnName` instead
   */
  name?: Maybe<Scalars['String']>;
  /** The Data Pool column's type. This may differ from the corresponding Data Source column's type. */
  type: ColumnType;
};

/**
 * The Data Pool column connection object.
 *
 * Learn more about [pagination in GraphQL](https://www.propeldata.com/docs/api/pagination).
 */
export type DataPoolColumnConnection = {
  __typename?: 'DataPoolColumnConnection';
  /** The Data Pool column connection's edges. */
  edges: Array<DataPoolColumnEdge>;
  /** The Data Pool column connection's nodes. */
  nodes: Array<DataPoolColumn>;
  /** The Data Pool column connection's page info. */
  pageInfo: PageInfo;
};

/**
 * The Data Pool column edge object.
 *
 * Learn more about [pagination in GraphQL](https://www.propeldata.com/docs/api/pagination).
 */
export type DataPoolColumnEdge = {
  __typename?: 'DataPoolColumnEdge';
  /** The edge's cursor. */
  cursor: Scalars['String'];
  /** The edge's node. */
  node: DataPoolColumn;
};

/**
 * The Data Pool connection object.
 *
 * Learn more about [pagination in GraphQL](https://www.propeldata.com/docs/api/pagination).
 */
export type DataPoolConnection = {
  __typename?: 'DataPoolConnection';
  /** The Data Pool connection's edges. */
  edges: Array<DataPoolEdge>;
  /** The Data Pool connection's nodes. */
  nodes: Array<DataPool>;
  /** The Data Pool connection's page info. */
  pageInfo: PageInfo;
};

/**
 * The Data Pool edge object.
 *
 * Learn more about [pagination in GraphQL](https://www.propeldata.com/docs/api/pagination).
 */
export type DataPoolEdge = {
  __typename?: 'DataPoolEdge';
  /** The edge's cursor. */
  cursor: Scalars['String'];
  /** The edge's node. */
  node: DataPool;
};

export type DataPoolInput = {
  /** The ID of the Data Pool. */
  id?: InputMaybe<Scalars['ID']>;
  /** The name of the Data Pool. */
  name?: InputMaybe<Scalars['String']>;
};

/**
 * The Data Pool Setup Task object.
 *
 * Data Pool Setup Tasks are executed when setting up your Data Pool. They ensure Propel will be able to sync records from your Data Source to your Data Pool.
 *
 * The exact Setup Tasks to perform vary by Data Source. For example, Data Pools pointing to a Snowflake-backed Data Sources will have their own specific Setup Tasks.
 */
export type DataPoolSetupTask = {
  __typename?: 'DataPoolSetupTask';
  /** The time at which the Data Pool Setup Task was completed. */
  completedAt?: Maybe<Scalars['DateTime']>;
  /** A description of the Data Pool Setup Task to be performed. */
  description?: Maybe<Scalars['String']>;
  /** If the Data Pool Setup Task failed, this field includes a descriptive error message. */
  error?: Maybe<Error>;
  /** The name of the Data Pool Setup Task to be performed. */
  name: Scalars['String'];
  /** The status of the Data Pool Setup Task (all setup tasks begin as NOT_STARTED before transitioning to SUCCEEDED or FAILED). */
  status: DataPoolSetupTaskStatus;
};

/** The status of a Data Pool Setup Task. */
export const DataPoolSetupTaskStatus = {
  /** The Data Pool Setup Task has failed. */
  Failed: 'FAILED',
  /** The Data Pool Setup Task has not been started yet. */
  NotStarted: 'NOT_STARTED',
  /** The Data Pool Setup Task has completed successfully. */
  Succeeded: 'SUCCEEDED'
} as const;

export type DataPoolSetupTaskStatus = typeof DataPoolSetupTaskStatus[keyof typeof DataPoolSetupTaskStatus];
/** The status of a Data Pool. */
export const DataPoolStatus = {
  Broken: 'BROKEN',
  Connected: 'CONNECTED',
  Connecting: 'CONNECTING',
  /** The Data Pool has been created and will be set up soon. */
  Created: 'CREATED',
  /** Propel is deleting the Data Pool and all of its associated data. */
  Deleting: 'DELETING',
  /** The Data Pool is set up and serving data. Check its Syncs to monitor data ingestion. */
  Live: 'LIVE',
  Paused: 'PAUSED',
  Pausing: 'PAUSING',
  /** Propel is attempting to set up the Data Pool. */
  Pending: 'PENDING',
  /** The Data Pool setup failed. Check its Setup Tasks before re-attempting setup. */
  SetupFailed: 'SETUP_FAILED'
} as const;

export type DataPoolStatus = typeof DataPoolStatus[keyof typeof DataPoolStatus];
/**
 * The available Data Pool sync intervals. Specify unit of time between attempts to sync data from your data warehouse.
 *
 * Note that the syncing interval is approximate. For example, setting the syncing interval to `EVERY_1_HOUR` does not mean that syncing will occur exactly on the hour. Instead, the syncing interval starts relative to when the Data Pool goes `LIVE`, and Propel will attempt to sync approximately every hour. Additionally, if you pause or resume syncing, this too can shift the syncing interval around.
 */
export const DataPoolSyncInterval = {
  Every_1Hour: 'EVERY_1_HOUR',
  Every_1Minute: 'EVERY_1_MINUTE',
  Every_4Hours: 'EVERY_4_HOURS',
  Every_5Minutes: 'EVERY_5_MINUTES',
  Every_12Hours: 'EVERY_12_HOURS',
  Every_15Minutes: 'EVERY_15_MINUTES',
  Every_24Hours: 'EVERY_24_HOURS',
  Every_30Minutes: 'EVERY_30_MINUTES'
} as const;

export type DataPoolSyncInterval = typeof DataPoolSyncInterval[keyof typeof DataPoolSyncInterval];
/** The Data Pool Sync Status. It indicates whether a Data Pool is syncing data or not. */
export const DataPoolSyncStatus = {
  /** Syncing is disabled for the Data Pool. */
  Disabled: 'DISABLED',
  /** Propel is disabling syncing for the Data Pool. */
  Disabling: 'DISABLING',
  /** Syncing is enabled for the Data Pool. */
  Enabled: 'ENABLED'
} as const;

export type DataPoolSyncStatus = typeof DataPoolSyncStatus[keyof typeof DataPoolSyncStatus];
/** Settings related to Data Pool syncing. */
export type DataPoolSyncing = {
  __typename?: 'DataPoolSyncing';
  /**
   * The syncing interval.
   *
   * Note that the syncing interval is approximate. For example, setting the syncing interval to `EVERY_1_HOUR`
   * does not mean that syncing will occur exactly on the hour. Instead, the syncing interval starts relative to
   * when the Data Pool goes `LIVE`, and Propel will attempt to sync approximately every hour. Additionally,
   * if you pause or resume syncing, this too can shift the syncing interval around.
   */
  interval?: Maybe<DataPoolSyncInterval>;
  /** The date and time of the most recent Sync in UTC. */
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  /** Indicates whether syncing is enabled or disabled. */
  status: DataPoolSyncStatus;
};

/**
 * The Data Source object.
 *
 * A Data Source is a connection to your data warehouse. It has the necessary connection details for Propel to access Snowflake or any other supported Data Source.
 *
 * [Learn more about Data Sources](https://www.propeldata.com/docs/data-sources).
 */
export type DataSource = Common & Node & {
  __typename?: 'DataSource';
  /** The Data Source's Account. */
  account: Account;
  /** A list of checks performed on the Data Source during its most recent connection attempt. */
  checks?: Maybe<Array<DataSourceCheck>>;
  /** The Data Source's connection settings. */
  connectionSettings: ConnectionSettings;
  /** The Data Source's creation date and time in UTC. */
  createdAt: Scalars['DateTime'];
  /** The Data Source's creator. It can be either a User ID, an Application ID, or "system" if it was created by Propel. */
  createdBy: Scalars['String'];
  /**
   * If you list Data Pools via the `dataPools` field on a Data Source, you will get Data Pools for the Data Source.
   *
   * The `dataPools` field uses [cursor-based pagination](/docs/api/pagination) typical of GraphQL APIs. You can use the pairs of parameters `first` and `after` or `last` and `before` to page forward or backward through the results, respectively.
   *
   * For forward pagination, the `first` parameter defines the number of results to return, and the `after` parameter defines the cursor to continue from. You should pass the cursor for the _last_ result of the current page to `after`.
   *
   * For backward pagination, the `last` parameter defines the number of results to return, and the `before` parameter defines the cursor to continue from. You should pass the cursor for the _first_ result of the current page to `before`.
   */
  dataPools?: Maybe<DataPoolConnection>;
  /** The Data Source's description. */
  description: Scalars['String'];
  /** The Data Source's Environment. */
  environment: Environment;
  /** @deprecated Refer to `checks` instead */
  error?: Maybe<Error>;
  /** The Data Source's unique identifier. */
  id: Scalars['ID'];
  /** The Data Source's last modification date and time in UTC. */
  modifiedAt: Scalars['DateTime'];
  /** The Data Source's last modifier. It can be either a User ID, an Application ID, or "system" if it was modified by Propel. */
  modifiedBy: Scalars['String'];
  /** The Data Source's status. */
  status: DataSourceStatus;
  /** A list of table introspections performed for the Data Source. You can see how tables and columns changed over time by paging through this list. */
  tableIntrospections?: Maybe<TableIntrospectionConnection>;
  /** The tables contained within the Data Source, according to the most recent table introspection. */
  tables?: Maybe<TableConnection>;
  /** The Data Source's type. */
  type: DataSourceType;
  /** The Data Source's unique name. */
  uniqueName: Scalars['String'];
};


/**
 * The Data Source object.
 *
 * A Data Source is a connection to your data warehouse. It has the necessary connection details for Propel to access Snowflake or any other supported Data Source.
 *
 * [Learn more about Data Sources](https://www.propeldata.com/docs/data-sources).
 */
export type DataSourceDataPoolsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/**
 * The Data Source object.
 *
 * A Data Source is a connection to your data warehouse. It has the necessary connection details for Propel to access Snowflake or any other supported Data Source.
 *
 * [Learn more about Data Sources](https://www.propeldata.com/docs/data-sources).
 */
export type DataSourceTableIntrospectionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/**
 * The Data Source object.
 *
 * A Data Source is a connection to your data warehouse. It has the necessary connection details for Propel to access Snowflake or any other supported Data Source.
 *
 * [Learn more about Data Sources](https://www.propeldata.com/docs/data-sources).
 */
export type DataSourceTablesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/**
 * The Data Source Check object.
 *
 * Data Source Checks are executed when setting up your Data Source. They check that Propel will be able to receive data and setup Data Pools.
 *
 * The exact Checks to perform vary by Data Source. For example, Snowflake-backed Data Sources will have their own specific Checks.
 */
export type DataSourceCheck = {
  __typename?: 'DataSourceCheck';
  /** The time at which the Data Source Check was performed. */
  checkedAt?: Maybe<Scalars['DateTime']>;
  /** A description of the Data Source Check to be performed. */
  description?: Maybe<Scalars['String']>;
  /** If the Data Source Check failed, this field includes a descriptive error message. */
  error?: Maybe<Error>;
  /** The name of the Data Source Check to be performed. */
  name: Scalars['String'];
  /** The status of the Data Source Check (all checks begin as NOT_STARTED before transitioning to SUCCEEDED or FAILED). */
  status: DataSourceCheckStatus;
};

/** The status of a Data Source Check. */
export const DataSourceCheckStatus = {
  /** The Check failed. */
  Failed: 'FAILED',
  /** The Check has not started. */
  NotStarted: 'NOT_STARTED',
  /** The Check succeeded. */
  Succeeded: 'SUCCEEDED'
} as const;

export type DataSourceCheckStatus = typeof DataSourceCheckStatus[keyof typeof DataSourceCheckStatus];
/** The status of a Data Source. */
export const DataSourceStatus = {
  /** The Data Source failed to connect. */
  Broken: 'BROKEN',
  /** The Data Source is connected. */
  Connected: 'CONNECTED',
  /** Propel is attempting to connect the Data Source. */
  Connecting: 'CONNECTING',
  /** The Data Source has been created, but it is not connected yet. */
  Created: 'CREATED',
  /** Propel is deleting the Data Source. */
  Deleting: 'DELETING'
} as const;

export type DataSourceStatus = typeof DataSourceStatus[keyof typeof DataSourceStatus];
/** The types of Data Sources. */
export const DataSourceType = {
  /** Indicates a ClickHouse Data Source. */
  Clickhouse: 'CLICKHOUSE',
  /** Indicates an Http Data Source. */
  Http: 'Http',
  /** Indicates an internal Data Source. */
  Internal: 'INTERNAL',
  /** Indicates a Kafka Data Source. */
  Kafka: 'KAFKA',
  /** Indicates a Redshift Data Source. */
  Redshift: 'Redshift',
  /** Indicates an S3 Data Source. */
  S3: 'S3',
  /** Indicates a Snowflake Data Source. */
  Snowflake: 'Snowflake',
  /** Indicates a Webhook Data Source. */
  Webhook: 'WEBHOOK'
} as const;

export type DataSourceType = typeof DataSourceType[keyof typeof DataSourceType];
export const DateDuration = {
  Last_365Days: 'last_365_days',
  Last_730Days: 'last_730_days',
  Today: 'today'
} as const;

export type DateDuration = typeof DateDuration[keyof typeof DateDuration];
/**
 * Deletion Job scheduled for a specific Data Pool.
 *
 * The Deletion Job represents the asynchronous process of deleting data
 * given some filters inside a Data Pool. It tracks the deletion process
 * until it is finished, showing the progress and the outcome when it is finished.
 */
export type DeletionJob = Job & Node & {
  __typename?: 'DeletionJob';
  /** Account to which the Deletion Job belongs. */
  account: Account;
  /** The Deletion Job's creation date and time in UTC. */
  createdAt: Scalars['DateTime'];
  /** Who created the Deletion Job. */
  createdBy: Scalars['String'];
  /** The Data Pool whose records will be deleted by the Deletion Job. */
  dataPool: DataPool;
  /** Environment to which the Deletion Job belongs. */
  environment: Environment;
  /** The error that occurred while deleting data, if any. */
  error?: Maybe<Error>;
  /** The time at which the Deletion Job failed. */
  failedAt?: Maybe<Scalars['DateTime']>;
  /** The filters that will be used for deleting data, in the form of SQL. Data matching the filters will be deleted. */
  filterSql?: Maybe<Scalars['String']>;
  /**
   * The list of filters that will be used for deleting data. Data matching the filters will be deleted.
   * @deprecated Use `filterSql` instead
   */
  filters?: Maybe<Array<Filter>>;
  /** The Deletion Job's ID. */
  id: Scalars['ID'];
  /** The Deletion Job's last modification date and time in UTC. */
  modifiedAt: Scalars['DateTime'];
  /** Who last modified the Deletion Job. */
  modifiedBy: Scalars['String'];
  /** The current progress of the Deletion Job, from 0.0 to 1.0. */
  progress: Scalars['Float'];
  /** The time at which the Deletion Job started. */
  startedAt?: Maybe<Scalars['DateTime']>;
  /** The current Deletion Job's status. */
  status: JobStatus;
  /** The time at which the Deletion Job succeeded. */
  succeededAt?: Maybe<Scalars['DateTime']>;
};

/**
 * The Deletion Job connection object.
 *
 * Learn more about [pagination in GraphQL](https://www.propeldata.com/docs/api/pagination).
 */
export type DeletionJobConnection = {
  __typename?: 'DeletionJobConnection';
  /** The Deletion Job connection's edges. */
  edges: Array<DeletionJobEdge>;
  /** The Deletion Job connection's nodes. */
  nodes: Array<DeletionJob>;
  /** The Deletion Job connection's page info. */
  pageInfo: PageInfo;
};

/**
 * The Deletion Job edge object.
 *
 * Learn more about [pagination in GraphQL](https://www.propeldata.com/docs/api/pagination).
 */
export type DeletionJobEdge = {
  __typename?: 'DeletionJobEdge';
  /** The edge's cursor. */
  cursor: Scalars['String'];
  /** The edge's node. */
  node: DeletionJob;
};

/** The Dimension object that represents a column in a table. */
export type Dimension = {
  __typename?: 'Dimension';
  /** The column name it represents. */
  columnName: Scalars['String'];
  /** Whether the column is nullable. */
  isNullable?: Maybe<Scalars['Boolean']>;
  /**
   * Whether the column is a unique key.
   * @deprecated This is Snowflake-specific, and will be removed
   */
  isUniqueKey?: Maybe<Scalars['Boolean']>;
  /**
   * The statistics for the dimension values. Fetching statistics incurs query costs.
   * @deprecated Issue normal queries for calculating stats
   */
  stats?: Maybe<DimensionStatistics>;
  /** The column data type. */
  type: Scalars['String'];
};

/** The fields for creating or modifying a Dimension. */
export type DimensionInput = {
  /** The name of the column to create the Dimension from. */
  columnName: Scalars['String'];
};

export type DimensionOrPlan = PrivateOfferMetadataPricingAzurePlan | PrivateOfferMetadataPricingDimension;

/** Statistics about a particular Dimension. */
export type DimensionStatistics = {
  __typename?: 'DimensionStatistics';
  /** The average value of the Dimension. Empty for non-numeric Dimensions. */
  average?: Maybe<Scalars['String']>;
  /** The maximum value of the Dimension. */
  max?: Maybe<Scalars['String']>;
  /** The minimum value of the Dimension. */
  min?: Maybe<Scalars['String']>;
  /** The Query statistics and metadata. */
  query: QueryInfo;
  /** An array of unique values for the Dimension, up to 1,000. Empty if the Dimension contains more than 1,000 unique values. Fetching unique values incurs query costs. */
  uniqueValues?: Maybe<Array<Scalars['String']>>;
};


/** Statistics about a particular Dimension. */
export type DimensionStatisticsUniqueValuesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

export type DisbursedRevenue = {
  __typename?: 'DisbursedRevenue';
  disbursementsByInterval: Array<Maybe<Disbursement>>;
  hasNonTackleDisbursements?: Maybe<Scalars['Boolean']>;
  hasTackleDisbursements?: Maybe<Scalars['Boolean']>;
  relativeDifference?: Maybe<Scalars['Float']>;
  tSeriesData: Array<MarketplaceRevenueTimeSeries>;
  totalDisbursementsByProvider: Array<MarketplaceRevenueByProvider>;
};

export type Disbursement = {
  __typename?: 'Disbursement';
  cloud_name: Scalars['String'];
  currency?: Maybe<Scalars['String']>;
  date: Scalars['String'];
  gross_seller_revenue?: Maybe<Scalars['Float']>;
  net_revenue?: Maybe<Scalars['Float']>;
  tackle_managed_disbursements?: Maybe<Scalars['Boolean']>;
  vendor_id: Scalars['String'];
};

export type EmailBrandMessageResponse = {
  __typename?: 'EmailBrandMessageResponse';
  Message: Scalars['String'];
};

export type EmailCustomBrand = {
  __typename?: 'EmailCustomBrand';
  brand_id: Scalars['String'];
  colors: EmailCustomBrandColors;
  created_at: Scalars['String'];
  custom_text: Scalars['JSONObject'];
  id: Scalars['String'];
  logo: EmailCustomBrandLogo;
  name: Scalars['String'];
  status: Scalars['String'];
  updated_at: Scalars['String'];
};

export type EmailCustomBrandColors = {
  __typename?: 'EmailCustomBrandColors';
  primary: Scalars['String'];
  secondary: Scalars['String'];
  tertiary: Scalars['String'];
};

export type EmailCustomBrandColorsInput = {
  primary: Scalars['String'];
  secondary: Scalars['String'];
  tertiary: Scalars['String'];
};

export type EmailCustomBrandInput = {
  colors: EmailCustomBrandColorsInput;
  custom_text: Scalars['JSONObject'];
  logo: EmailCustomBrandLogoInput;
  name: Scalars['String'];
  status: Scalars['String'];
};

export type EmailCustomBrandLogo = {
  __typename?: 'EmailCustomBrandLogo';
  image: Scalars['String'];
};

export type EmailCustomBrandLogoInput = {
  image: Scalars['String'];
};

export type EmailCustomBrandTestInput = {
  cloud: Scalars['String'];
  event_type: Scalars['String'];
  id: Scalars['String'];
  user_email: Scalars['String'];
};

/**
 * The Environments object.
 *
 * Environments are independent and isolated Propel workspaces for development, staging (testing), and production workloads. Environments are hosted in a specific region, initially in us-east-2 only.
 */
export type Environment = {
  __typename?: 'Environment';
  /** The Environment's unique identifier. */
  id: Scalars['ID'];
};

/** The error object. */
export type Error = {
  __typename?: 'Error';
  /** The error code. */
  code?: Maybe<Scalars['Int']>;
  /** The error message. */
  message: Scalars['String'];
};

/**
 * The fields of a filter.
 *
 *
 * You can construct more complex filters using `and` and `or`. For example, to construct a filter equivalent to
 *
 * ```
 * (value > 0 AND value <= 100) OR status = "confirmed"
 * ```
 *
 * you could write
 *
 * ```
 * {
 *   "column": "value",
 *   "operator": "GREATER_THAN",
 *   "value": "0",
 *   "and": [{
 *     "column": "value",
 *     "operator": "LESS_THAN_OR_EQUAL_TO",
 *     "value": "0"
 *   }],
 *   "or": [{
 *     "column": "status",
 *     "operator": "EQUALS",
 *     "value": "confirmed"
 *   }]
 * }
 * ```
 *
 * Note that `and` takes precedence over `or`.
 */
export type Filter = {
  __typename?: 'Filter';
  /** Additional filters to AND with this one. AND takes precedence over OR. */
  and?: Maybe<Array<Filter>>;
  /** The name of the column to filter on. */
  column: Scalars['String'];
  /** The operation to perform when comparing the column and filter values. */
  operator: FilterOperator;
  /** Additional filters to OR with this one. AND takes precedence over OR. */
  or?: Maybe<Array<Filter>>;
  /** The value to compare the column to. */
  value?: Maybe<Scalars['String']>;
};

/**
 * The fields of a filter.
 *
 * You can construct more complex filters using `and` and `or`. For example, to construct a filter equivalent to
 *
 * ```
 * (value > 0 AND value <= 100) OR status = "confirmed"
 * ```
 *
 * you could write
 *
 * ```
 * {
 *   "column": "value",
 *   "operator": "GREATER_THAN",
 *   "value": "0",
 *   "and": [{
 *     "column": "value",
 *     "operator": "LESS_THAN_OR_EQUAL_TO",
 *     "value": "0"
 *   }],
 *   "or": [{
 *     "column": "status",
 *     "operator": "EQUALS",
 *     "value": "confirmed"
 *   }]
 * }
 * ```
 *
 * Note that `and` takes precedence over `or`.
 */
export type FilterInput = {
  /** Additional filters to AND with this one. AND takes precedence over OR. */
  and?: InputMaybe<Array<FilterInput>>;
  /** The name of the column to filter on. */
  column: Scalars['String'];
  /** The operation to perform when comparing the column and filter values. */
  operator: FilterOperator;
  /** Additional filters to OR with this one. AND takes precedence over OR. */
  or?: InputMaybe<Array<FilterInput>>;
  /** The value to compare the column to. */
  value?: InputMaybe<Scalars['String']>;
};

/** The available Filter operators. */
export const FilterOperator = {
  /** Selects values that are equal to the specified value. */
  Equals: 'EQUALS',
  /** Selects values that are greater than the specified value. */
  GreaterThan: 'GREATER_THAN',
  /** Selects values that are greater or equal to the specified value. */
  GreaterThanOrEqualTo: 'GREATER_THAN_OR_EQUAL_TO',
  /** Selects values that are not null. This operator does not accept a value. */
  IsNotNull: 'IS_NOT_NULL',
  /** Selects values that are null. This operator does not accept a value. */
  IsNull: 'IS_NULL',
  /** Selects values that are less than the specified value. */
  LessThan: 'LESS_THAN',
  /** Selects values that are less or equal to the specified value. */
  LessThanOrEqualTo: 'LESS_THAN_OR_EQUAL_TO',
  /** Selects values that match the specified pattern. */
  Like: 'LIKE',
  /** Selects values that are not equal to the specified value. */
  NotEquals: 'NOT_EQUALS',
  /** "Selects values that do not match the specified pattern. */
  NotLike: 'NOT_LIKE'
} as const;

export type FilterOperator = typeof FilterOperator[keyof typeof FilterOperator];
export type FilterProspectAccountsInput = {
  batch_id?: InputMaybe<Scalars['String']>;
  clouds?: InputMaybe<Array<Scalars['String']>>;
  company_name_search_string?: InputMaybe<Scalars['String']>;
  domain_search_string?: InputMaybe<Scalars['String']>;
  domains?: InputMaybe<Array<Scalars['String']>>;
  has_offers?: InputMaybe<Scalars['Boolean']>;
  industries?: InputMaybe<Array<Scalars['String']>>;
  opportunity_cloud?: InputMaybe<Scalars['String']>;
  page_number?: InputMaybe<Scalars['Int']>;
  records_per_page?: InputMaybe<Scalars['Int']>;
  regions?: InputMaybe<Array<Scalars['String']>>;
  revenue_band?: InputMaybe<Array<Scalars['String']>>;
  scores?: InputMaybe<Array<Scalars['String']>>;
  vendor_id: Scalars['String'];
};

export type GcpCallbackAuthentication = {
  __typename?: 'GcpCallbackAuthentication';
  api_key?: Maybe<Scalars['String']>;
  auth_header_name?: Maybe<Scalars['String']>;
  auth_type?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

export type GcpCallbackAuthenticationInput = {
  api_key?: InputMaybe<Scalars['String']>;
  auth_header_name?: InputMaybe<Scalars['String']>;
  auth_type?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
};

export type GcpCallbackConfig = {
  __typename?: 'GcpCallbackConfig';
  authentication?: Maybe<GcpCallbackAuthentication>;
  send_email?: Maybe<Scalars['Boolean']>;
  supported_clouds?: Maybe<Array<GcpCallbackConfigSupportedCloudsItem>>;
  url?: Maybe<Scalars['String']>;
};

export type GcpCallbackConfigInput = {
  authentication?: InputMaybe<GcpCallbackAuthenticationInput>;
  send_email?: InputMaybe<Scalars['Boolean']>;
  supported_clouds?: InputMaybe<Array<GcpCallbackConfigSupportedCloudsItem>>;
  url?: InputMaybe<Scalars['String']>;
};

export const GcpCallbackConfigSupportedCloudsItem = {
  Aws: 'aws',
  Azure: 'azure',
  Gcp: 'gcp',
  Redhat: 'redhat'
} as const;

export type GcpCallbackConfigSupportedCloudsItem = typeof GcpCallbackConfigSupportedCloudsItem[keyof typeof GcpCallbackConfigSupportedCloudsItem];
export type GcpCustomTemplateIds = {
  __typename?: 'GcpCustomTemplateIds';
  tackle_template_id?: Maybe<Scalars['Float']>;
  vendor_template_id?: Maybe<Scalars['Float']>;
};

export type GcpCustomTemplateIdsInput = {
  tackle_template_id?: InputMaybe<Scalars['Float']>;
  vendor_template_id?: InputMaybe<Scalars['Float']>;
};

export type GcpDimension = {
  __typename?: 'GcpDimension';
  display_name?: Maybe<Scalars['String']>;
  external_name?: Maybe<Scalars['String']>;
  meterable?: Maybe<Scalars['Boolean']>;
  metric_name?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  plan_id?: Maybe<Scalars['String']>;
  value_type?: Maybe<Scalars['String']>;
};

export type GcpDimensionInput = {
  display_name?: InputMaybe<Scalars['String']>;
  external_name?: InputMaybe<Scalars['String']>;
  meterable?: InputMaybe<Scalars['Boolean']>;
  metric_name?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  plan_id?: InputMaybe<Scalars['String']>;
  value_type?: InputMaybe<Scalars['String']>;
};

export type GcpDocumentationResource = {
  __typename?: 'GcpDocumentationResource';
  description?: Maybe<Scalars['String']>;
  resource_type?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type GcpDocumentationResourceInput = {
  description?: InputMaybe<Scalars['String']>;
  resource_type?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type GcpEmailsConfig = {
  __typename?: 'GcpEmailsConfig';
  custom_template_ids?: Maybe<Array<GcpCustomTemplateIds>>;
  default_cc?: Maybe<Scalars['String']>;
  default_from?: Maybe<Scalars['String']>;
};

export type GcpEmailsConfigInput = {
  custom_template_ids?: InputMaybe<Array<GcpCustomTemplateIdsInput>>;
  default_cc?: InputMaybe<Scalars['String']>;
  default_from?: InputMaybe<Scalars['String']>;
};

export type GcpFeature = {
  __typename?: 'GcpFeature';
  description?: Maybe<Scalars['String']>;
  feature_id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
};

export type GcpFeatureInput = {
  description?: InputMaybe<Scalars['String']>;
  feature_id?: InputMaybe<Scalars['String']>;
  label?: InputMaybe<Scalars['String']>;
};

export type GcpLicenseAgreement = {
  __typename?: 'GcpLicenseAgreement';
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type GcpLicenseAgreementInput = {
  title?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type GcpListing = {
  __typename?: 'GcpListing';
  callback?: Maybe<GcpCallbackConfig>;
  categories?: Maybe<Array<Scalars['String']>>;
  contact_email?: Maybe<Scalars['String']>;
  contact_support_url?: Maybe<Scalars['String']>;
  contract_standard_fields?: Maybe<Array<GcpPrivateOfferMetadataStandardField>>;
  created_at?: Maybe<Scalars['String']>;
  created_by_email?: Maybe<Scalars['String']>;
  dashboard_url?: Maybe<Scalars['String']>;
  dimensions?: Maybe<Array<GcpDimension>>;
  /**
   * To be perfectly honest, I am not sure what this is or how it is different from
   * the regular dimensions but the best I can tell is that it is a sort of dry run
   * from actually generating new dimensions and if this returns something that means
   * we can generate new dimensions and we can show a button in admin dash to do so
   */
  dimensionsIfWeGeneratedNew?: Maybe<Array<GcpDimension>>;
  documentation?: Maybe<Array<GcpDocumentationResource>>;
  emails?: Maybe<GcpEmailsConfig>;
  eula_url?: Maybe<Scalars['String']>;
  experimental_example?: Maybe<Scalars['Boolean']>;
  experimental_salesforce_private_offers_connector?: Maybe<Scalars['Boolean']>;
  features?: Maybe<Array<GcpFeature>>;
  full_description?: Maybe<Scalars['String']>;
  gcp_service?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  is_automatic_offer_approval_enabled?: Maybe<Scalars['Boolean']>;
  is_enrolled_in_future_dated_offers?: Maybe<Scalars['Boolean']>;
  landing_page_form_button_bg_color?: Maybe<Scalars['String']>;
  landing_page_header_bg_color?: Maybe<Scalars['String']>;
  landing_page_html?: Maybe<Scalars['String']>;
  last_modified_at?: Maybe<Scalars['String']>;
  last_modified_by_email?: Maybe<Scalars['String']>;
  license_agreements?: Maybe<Array<GcpLicenseAgreement>>;
  listing_sku?: Maybe<Scalars['String']>;
  listing_slug?: Maybe<Scalars['String']>;
  listing_type?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  marketplace_id?: Maybe<Scalars['String']>;
  marketplace_url?: Maybe<Scalars['String']>;
  metadata_keywords?: Maybe<Scalars['String']>;
  metering_enabled?: Maybe<Scalars['Boolean']>;
  metrics_pricing?: Maybe<Array<GcpMetric>>;
  name?: Maybe<Scalars['String']>;
  offers?: Maybe<Array<GcpOffer>>;
  overview_url?: Maybe<Scalars['String']>;
  packages?: Maybe<Array<Scalars['String']>>;
  plans?: Maybe<Array<GcpPlan>>;
  registration?: Maybe<GcpRegistration>;
  registration_hosting?: Maybe<Scalars['String']>;
  registration_message?: Maybe<Scalars['String']>;
  registration_page_fields?: Maybe<Array<GcpRegistrationField>>;
  registration_redirect?: Maybe<GcpRegistrationRedirect>;
  registration_redirect_configs?: Maybe<Scalars['JSONObject']>;
  registration_submit_html?: Maybe<Scalars['String']>;
  revision_of_listing?: Maybe<GcpListing>;
  revision_of_product_id_internal?: Maybe<Scalars['String']>;
  search_keywords?: Maybe<Scalars['String']>;
  send_customer_email?: Maybe<Scalars['Boolean']>;
  short_description?: Maybe<Scalars['String']>;
  should_sync_listing_to_salesforce_app?: Maybe<Scalars['Boolean']>;
  solution_id?: Maybe<Scalars['String']>;
  sso_api_keys_url?: Maybe<Scalars['String']>;
  sso_login_url?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  support_description?: Maybe<Scalars['String']>;
  support_email?: Maybe<Scalars['String']>;
  support_url?: Maybe<Scalars['String']>;
  tax_category?: Maybe<Scalars['String']>;
  tax_witholding?: Maybe<Scalars['String']>;
  vendor?: Maybe<Vendor>;
  vendorid?: Maybe<Scalars['String']>;
  viewed_advanced_tab?: Maybe<Scalars['Boolean']>;
};

export type GcpListingInput = {
  callback?: InputMaybe<GcpCallbackConfigInput>;
  categories?: InputMaybe<Array<Scalars['String']>>;
  contact_email?: InputMaybe<Scalars['String']>;
  contact_support_url?: InputMaybe<Scalars['String']>;
  contract_standard_fields?: InputMaybe<Array<GcpPrivateOfferMetadataStandardFieldInput>>;
  dashboard_url?: InputMaybe<Scalars['String']>;
  dimensions?: InputMaybe<Array<GcpDimensionInput>>;
  documentation?: InputMaybe<Array<GcpDocumentationResourceInput>>;
  emails?: InputMaybe<GcpEmailsConfigInput>;
  eula_url?: InputMaybe<Scalars['String']>;
  experimental_example?: InputMaybe<Scalars['Boolean']>;
  experimental_salesforce_private_offers_connector?: InputMaybe<Scalars['Boolean']>;
  features?: InputMaybe<Array<GcpFeatureInput>>;
  full_description?: InputMaybe<Scalars['String']>;
  gcp_service?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  is_automatic_offer_approval_enabled?: InputMaybe<Scalars['Boolean']>;
  is_enrolled_in_future_dated_offers?: InputMaybe<Scalars['Boolean']>;
  landing_page_form_button_bg_color?: InputMaybe<Scalars['String']>;
  landing_page_header_bg_color?: InputMaybe<Scalars['String']>;
  landing_page_html?: InputMaybe<Scalars['String']>;
  license_agreements?: InputMaybe<Array<GcpLicenseAgreementInput>>;
  listing_sku?: InputMaybe<Scalars['String']>;
  listing_slug?: InputMaybe<Scalars['String']>;
  listing_type?: InputMaybe<Scalars['String']>;
  logo?: InputMaybe<Scalars['String']>;
  /** super admin only */
  marketplace_id?: InputMaybe<Scalars['String']>;
  marketplace_url?: InputMaybe<Scalars['String']>;
  metadata_keywords?: InputMaybe<Scalars['String']>;
  metering_enabled?: InputMaybe<Scalars['Boolean']>;
  metrics_pricing?: InputMaybe<Array<GcpMetricInput>>;
  name?: InputMaybe<Scalars['String']>;
  offers?: InputMaybe<Array<GcpOfferInput>>;
  overview_url?: InputMaybe<Scalars['String']>;
  packages?: InputMaybe<Array<Scalars['String']>>;
  plans?: InputMaybe<Array<GcpPlanInput>>;
  registration?: InputMaybe<GcpRegistrationInput>;
  registration_hosting?: InputMaybe<Scalars['String']>;
  registration_message?: InputMaybe<Scalars['String']>;
  registration_page_fields?: InputMaybe<Array<GcpRegistrationFieldInput>>;
  registration_redirect?: InputMaybe<GcpRegistrationRedirectInput>;
  registration_redirect_configs?: InputMaybe<Scalars['JSONObject']>;
  registration_submit_html?: InputMaybe<Scalars['String']>;
  search_keywords?: InputMaybe<Scalars['String']>;
  send_customer_email?: InputMaybe<Scalars['Boolean']>;
  short_description?: InputMaybe<Scalars['String']>;
  should_sync_listing_to_salesforce_app?: InputMaybe<Scalars['Boolean']>;
  solution_id?: InputMaybe<Scalars['String']>;
  sso_api_keys_url?: InputMaybe<Scalars['String']>;
  sso_login_url?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  support_description?: InputMaybe<Scalars['String']>;
  support_email?: InputMaybe<Scalars['String']>;
  support_url?: InputMaybe<Scalars['String']>;
  tax_category?: InputMaybe<Scalars['String']>;
  tax_witholding?: InputMaybe<Scalars['String']>;
  vendorid?: InputMaybe<Scalars['String']>;
  viewed_advanced_tab?: InputMaybe<Scalars['Boolean']>;
};

export type GcpListingRelistInput = {
  dashboard_url?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  marketplace_id: Scalars['String'];
  marketplace_url: Scalars['String'];
  name: Scalars['String'];
  should_sync_listing_to_salesforce_app: Scalars['Boolean'];
  status: Scalars['String'];
};

export type GcpMetric = {
  __typename?: 'GcpMetric';
  name?: Maybe<Scalars['String']>;
  price_per_unit?: Maybe<Array<GcpMetricPricePerUnit>>;
  sku?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
};

export type GcpMetricInput = {
  name?: InputMaybe<Scalars['String']>;
  price_per_unit?: InputMaybe<Array<GcpMetricPricePerUnitInput>>;
  sku?: InputMaybe<Scalars['String']>;
  unit?: InputMaybe<Scalars['String']>;
};

export type GcpMetricPricePerUnit = {
  __typename?: 'GcpMetricPricePerUnit';
  plan_id?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
};

export type GcpMetricPricePerUnitInput = {
  plan_id?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
};

export type GcpOffer = {
  __typename?: 'GcpOffer';
  offer_type?: Maybe<GcpOfferOfferType>;
  offerid?: Maybe<Scalars['String']>;
  pricing?: Maybe<Array<GcpDimension>>;
};

export type GcpOfferInput = {
  offer_type?: InputMaybe<GcpOfferOfferType>;
  offerid: Scalars['String'];
  pricing?: InputMaybe<Array<GcpDimensionInput>>;
};

export const GcpOfferOfferType = {
  Private: 'private',
  Public: 'public'
} as const;

export type GcpOfferOfferType = typeof GcpOfferOfferType[keyof typeof GcpOfferOfferType];
export type GcpPlan = {
  __typename?: 'GcpPlan';
  feature_ids?: Maybe<Array<Scalars['String']>>;
  name?: Maybe<Scalars['String']>;
  plan_id?: Maybe<Scalars['String']>;
  pricing?: Maybe<Scalars['JSONObject']>;
  public?: Maybe<Scalars['Boolean']>;
  sku?: Maybe<Scalars['String']>;
};

export type GcpPlanInput = {
  feature_ids?: InputMaybe<Array<Scalars['String']>>;
  name?: InputMaybe<Scalars['String']>;
  plan_id?: InputMaybe<Scalars['String']>;
  pricing?: InputMaybe<Scalars['JSONObject']>;
  public?: InputMaybe<Scalars['Boolean']>;
  sku?: InputMaybe<Scalars['String']>;
};

export type GcpPrivateOfferMetadataStandardField = {
  __typename?: 'GcpPrivateOfferMetadataStandardField';
  cloud_field?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
};

export type GcpPrivateOfferMetadataStandardFieldInput = {
  cloud_field?: InputMaybe<Scalars['Boolean']>;
  title: Scalars['String'];
};

export type GcpRegistration = {
  __typename?: 'GcpRegistration';
  form?: Maybe<GcpRegistrationForm>;
  hero?: Maybe<GcpRegistrationHero>;
  success?: Maybe<GcpRegistrationSuccess>;
};

export type GcpRegistrationField = {
  __typename?: 'GcpRegistrationField';
  data_type?: Maybe<Scalars['String']>;
  default?: Maybe<Scalars['Boolean']>;
  display_title?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  options?: Maybe<Array<GcpRegistrationFieldOptions>>;
  required?: Maybe<Scalars['Boolean']>;
  tackle_required?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  validation_type?: Maybe<GcpRegistrationFieldValidationType>;
};

export type GcpRegistrationFieldInput = {
  data_type?: InputMaybe<Scalars['String']>;
  default?: InputMaybe<Scalars['Boolean']>;
  display_title: Scalars['String'];
  enabled?: InputMaybe<Scalars['Boolean']>;
  options?: InputMaybe<Array<GcpRegistrationFieldOptionsInput>>;
  required?: InputMaybe<Scalars['Boolean']>;
  tackle_required?: InputMaybe<Scalars['Boolean']>;
  title: Scalars['String'];
  validation_type?: InputMaybe<GcpRegistrationFieldValidationType>;
};

export type GcpRegistrationFieldOptions = {
  __typename?: 'GcpRegistrationFieldOptions';
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type GcpRegistrationFieldOptionsInput = {
  label: Scalars['String'];
  value: Scalars['String'];
};

export const GcpRegistrationFieldValidationType = {
  Email: 'email'
} as const;

export type GcpRegistrationFieldValidationType = typeof GcpRegistrationFieldValidationType[keyof typeof GcpRegistrationFieldValidationType];
export type GcpRegistrationForm = {
  __typename?: 'GcpRegistrationForm';
  button?: Maybe<GcpRegistrationFormButton>;
  logo_url?: Maybe<Scalars['String']>;
};

export type GcpRegistrationFormButton = {
  __typename?: 'GcpRegistrationFormButton';
  background_color?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
};

export type GcpRegistrationFormButtonInput = {
  background_color?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
};

export type GcpRegistrationFormInput = {
  button?: InputMaybe<GcpRegistrationFormButtonInput>;
  logo_url?: InputMaybe<Scalars['String']>;
};

export type GcpRegistrationHero = {
  __typename?: 'GcpRegistrationHero';
  background_color?: Maybe<Scalars['String']>;
  background_image_url?: Maybe<Scalars['String']>;
};

export type GcpRegistrationHeroInput = {
  background_color?: InputMaybe<Scalars['String']>;
  background_image_url?: InputMaybe<Scalars['String']>;
};

export type GcpRegistrationInput = {
  form?: InputMaybe<GcpRegistrationFormInput>;
  hero?: InputMaybe<GcpRegistrationHeroInput>;
  success?: InputMaybe<GcpRegistrationSuccessInput>;
};

export type GcpRegistrationRedirect = {
  __typename?: 'GcpRegistrationRedirect';
  params?: Maybe<Scalars['JSONObject']>;
  url?: Maybe<Scalars['String']>;
};

export type GcpRegistrationRedirectInput = {
  params?: InputMaybe<Scalars['JSONObject']>;
  url: Scalars['String'];
};

export type GcpRegistrationSuccess = {
  __typename?: 'GcpRegistrationSuccess';
  message?: Maybe<Scalars['String']>;
  redirect_url?: Maybe<Scalars['String']>;
};

export type GcpRegistrationSuccessInput = {
  message?: InputMaybe<Scalars['String']>;
  redirect_url?: InputMaybe<Scalars['String']>;
};

/** An interface for accessing a table engine's type. */
export type HasTableEngineType = {
  /** The type of the table engine. */
  type: TableEngineType;
};

/** The HTTP Basic authentication settings. */
export type HttpBasicAuthSettings = {
  __typename?: 'HttpBasicAuthSettings';
  /** Password for HTTP Basic authentication that must be included in the Authorization header when uploading new data. */
  password: Scalars['String'];
  /** Username for HTTP Basic authentication that must be included in the Authorization header when uploading new data. */
  username: Scalars['String'];
};

/** The HTTP Data Source connection settings. */
export type HttpConnectionSettings = {
  __typename?: 'HttpConnectionSettings';
  /**
   * The HTTP Basic authentication settings for uploading new data.
   *
   * If this parameter is not provided, anyone with the URL to your tables will be able to upload data. While it's OK to test without HTTP Basic authentication, we recommend enabling it.
   */
  basicAuth?: Maybe<HttpBasicAuthSettings>;
  /** The HTTP Data Source's tables. */
  tables: Array<HttpDataSourceTable>;
};

/** A column in an HTTP Data Source's table. */
export type HttpDataSourceColumn = {
  __typename?: 'HttpDataSourceColumn';
  /** The ClickHouse type to use when `type` is set to `CLICKHOUSE`. */
  clickHouseType?: Maybe<Scalars['String']>;
  /** The column name. It has to be unique within a Table. */
  name: Scalars['String'];
  /** Whether the column's type is nullable or not. */
  nullable: Scalars['Boolean'];
  /** The column type. */
  type: ColumnType;
};

/** An HTTP Data Source's table. */
export type HttpDataSourceTable = {
  __typename?: 'HttpDataSourceTable';
  /** All the columns present in the table */
  columns: Array<HttpDataSourceColumn>;
  /** The ID of the table */
  id: Scalars['ID'];
  /** The name of the table */
  name: Scalars['String'];
};

export type InternalConnectionSettings = {
  __typename?: 'InternalConnectionSettings';
  _?: Maybe<Scalars['Boolean']>;
};

/** A Job is an asynchronous process that modifies a Data Pool or its records. It keeps track of its progress and outcome. */
export type Job = {
  /** Account to which the Job belongs. */
  account: Account;
  /** The Job's creation date and time in UTC. */
  createdAt: Scalars['DateTime'];
  /** Who created the Job. */
  createdBy: Scalars['String'];
  /** The Data Pool whose records will be modified by the Job. */
  dataPool: DataPool;
  /** Environment to which the Job belongs. */
  environment: Environment;
  /** The error that occurred while executing the Job, if any. */
  error?: Maybe<Error>;
  /** The time at which the Job failed. */
  failedAt?: Maybe<Scalars['DateTime']>;
  /** The Job's last modification date and time in UTC. */
  modifiedAt: Scalars['DateTime'];
  /** Who last modified the Job. */
  modifiedBy: Scalars['String'];
  /** The current progress of the Job, from 0.0 to 1.0. */
  progress: Scalars['Float'];
  /** The time at which the Job started. */
  startedAt?: Maybe<Scalars['DateTime']>;
  /** The current Job's status. */
  status: JobStatus;
  /** The time at which the Job succeeded. */
  succeededAt?: Maybe<Scalars['DateTime']>;
};

export const JobStatus = {
  /** The Job was created, but is not yet being executed. */
  Created: 'CREATED',
  /** The Job failed. Check the error message. */
  Failed: 'FAILED',
  /** The Job is executing. */
  InProgress: 'IN_PROGRESS',
  /** The Job succeeded. */
  Succeeded: 'SUCCEEDED'
} as const;

export type JobStatus = typeof JobStatus[keyof typeof JobStatus];
/** The Kafka Data Source connection settings. */
export type KafkaConnectionSettings = {
  __typename?: 'KafkaConnectionSettings';
  /** The type of authentication to use. Can be SCRAM-SHA-256, SCRAM-SHA-512, PLAIN or NONE */
  auth: Scalars['String'];
  /** The bootstrap server(s) to connect to */
  bootstrapServers: Array<Scalars['String']>;
  /** The password for the provided user */
  password: Scalars['String'];
  /** Whether the the connection to the Kafka servers is encrypted or not */
  tls?: Maybe<Scalars['Boolean']>;
  /** The user for authenticating against the Kafka servers */
  user: Scalars['String'];
};

export type LanguageAggregation = {
  __typename?: 'LanguageAggregation';
  buckets?: Maybe<Array<Maybe<LanguageBucket>>>;
  doc_count_error_upper_bound?: Maybe<Scalars['Int']>;
  sum_other_doc_count?: Maybe<Scalars['Int']>;
};

export type LanguageBucket = {
  __typename?: 'LanguageBucket';
  doc_count?: Maybe<Scalars['Int']>;
  key?: Maybe<Scalars['String']>;
};

/**
 * The fields for querying a Metric in leaderboard format.
 *
 * A Metric's leaderboard query returns an ordered table of Dimension and Metric values over a given time range.
 */
export type LeaderboardInput = {
  /** One or many Dimensions to group the Metric values by. Typically, Dimensions in a leaderboard are what you want to compare and rank. */
  dimensions: Array<DimensionInput>;
  /** The Query Filters to apply before retrieving the leaderboard data, in the form of SQL. If no Query Filters are provided, all data is included. */
  filterSql?: InputMaybe<Scalars['String']>;
  /** The Query Filters to apply before retrieving the leaderboard data. If no Query Filters are provided, all data is included. */
  filters?: InputMaybe<Array<FilterInput>>;
  /** The Metric to query. You can query a pre-configured Metric by ID or name, or you can query an ad hoc Metric that you define inline. */
  metric?: InputMaybe<MetricInput>;
  /**
   * The ID of the Metric to query.
   *
   * Required if `metricName` is not specified.
   */
  metricId?: InputMaybe<Scalars['ID']>;
  /**
   * The name of the Metric to query.
   *
   * Required if `metricId` is not specified.
   */
  metricName?: InputMaybe<Scalars['String']>;
  /** The number of rows to be returned. It can be a number between 1 and 1,000. */
  rowLimit: Scalars['Int'];
  /** The sort order of the rows. It can be ascending (`ASC`) or descending (`DESC`) order. Defaults to descending (`DESC`) order when not provided. */
  sort?: InputMaybe<Sort>;
  /** The time range for calculating the leaderboard. */
  timeRange?: InputMaybe<TimeRangeInput>;
  /**
   * The time zone to use. Dates and times are always returned in UTC, but setting the time zone influences relative time ranges and granularities.
   *
   * You can set this to "America/Los_Angeles", "Europe/Berlin", or any other value in the [IANA time zone database](https://en.wikipedia.org/wiki/Tz_database). Defaults to "UTC".
   */
  timeZone?: InputMaybe<Scalars['String']>;
};

/** The leaderboard response object. It contains an array of headers and a table (array of rows) with the selected Dimensions and corresponding Metric values for the given time range and Query Filters. */
export type LeaderboardResponse = {
  __typename?: 'LeaderboardResponse';
  /** The table headers. It contains the Dimension and Metric names. */
  headers: Array<Scalars['String']>;
  /** The Query statistics and metadata. */
  query: QueryInfo;
  /** An ordered array of rows. Each row contains the Dimension values and the corresponding Metric value. A Dimension value can be empty. A Metric value will never be empty. */
  rows: Array<Array<Maybe<Scalars['String']>>>;
};

export const Marketplace = {
  Aws: 'AWS',
  Azure: 'AZURE',
  Gcp: 'GCP'
} as const;

export type Marketplace = typeof Marketplace[keyof typeof Marketplace];
export const MarketplaceConnectionStage = {
  ConnectedListingsInProgress: 'CONNECTED_LISTINGS_IN_PROGRESS',
  ConnectedListingsPublished: 'CONNECTED_LISTINGS_PUBLISHED',
  ConnectedNoListings: 'CONNECTED_NO_LISTINGS',
  InProgress: 'IN_PROGRESS',
  NotConnected: 'NOT_CONNECTED'
} as const;

export type MarketplaceConnectionStage = typeof MarketplaceConnectionStage[keyof typeof MarketplaceConnectionStage];
export type MarketplaceRevenueByProvider = {
  __typename?: 'MarketplaceRevenueByProvider';
  provider: Scalars['String'];
  value: Scalars['Float'];
};

export type MarketplaceRevenueTimeSeries = {
  __typename?: 'MarketplaceRevenueTimeSeries';
  data: Array<Maybe<MarketplaceRevenueTimeSeriesDataPoint>>;
  id: Scalars['String'];
};

export type MarketplaceRevenueTimeSeriesDataPoint = {
  __typename?: 'MarketplaceRevenueTimeSeriesDataPoint';
  x: Scalars['String'];
  y: Scalars['Float'];
};

export type MarketplaceStage = {
  __typename?: 'MarketplaceStage';
  marketplace: Marketplace;
  stage: MarketplaceConnectionStage;
};

export type MaxMetricQueryInput = {
  /** The Data Pool to which this Metric belongs. */
  dataPool: DataPoolInput;
  /** The column to calculate the maximum from. */
  measure: DimensionInput;
};

/** Settings for Max Metrics. */
export type MaxMetricSettings = {
  __typename?: 'MaxMetricSettings';
  /**
   * Metric Filters allow defining a Metric with a subset of records from the given Data Pool. If no Metric Filters are present, all records will be included. To filter at query time, add Dimensions and use the `filters` property on the `timeSeriesInput`, `counterInput`, or `leaderboardInput` objects. There is no need to add `filters` to be able to filter at query time.
   *
   * You can provide the filters in the form of SQL.
   */
  filterSql?: Maybe<Scalars['String']>;
  /**
   * Metric Filters allow defining a Metric with a subset of records from the given Data Pool. If no Metric Filters are present, all records will be included. To filter at query time, add Dimensions and use the `filters` property on the `timeSeriesInput`, `counterInput`, or `leaderboardInput` objects. There is no need to add `filters` to be able to filter at query time.
   * @deprecated Use `filterSql` instead
   */
  filters?: Maybe<Array<Filter>>;
  /** The Dimension to select the maximum from. */
  measure: Dimension;
};

/** Parameters for the MergeTree table engine. */
export type MergeTreeTableEngine = HasTableEngineType & {
  __typename?: 'MergeTreeTableEngine';
  /** The type is always `MERGE_TREE`. */
  type: TableEngineType;
};

/**
 * The Metric object.
 *
 * A Metric is a business indicator measured over time.
 *
 * [Learn more about Metrics](/docs/key-concepts#metric).
 */
export type Metric = Common & Node & {
  __typename?: 'Metric';
  /**
   * Whether or not access control is enabled for the Metric.
   * @deprecated Use Data Pool Access Policies instead
   */
  accessControlEnabled: Scalars['Boolean'];
  /** The Metric's Account. */
  account: Account;
  /** List the Boosters associated to the Metric. */
  boosters: BoosterConnection;
  /**
   * Query the Metric in counter format. Returns the Metric's value for the given time range and filters.
   * @deprecated Use the top-level `counter` query instead
   */
  counter?: Maybe<CounterResponse>;
  /** The Metric's creation date and time in UTC. */
  createdAt: Scalars['DateTime'];
  /** The Metric's creator. It can be either a User ID, an Application ID, or "system" if it was created by Propel. */
  createdBy: Scalars['String'];
  /** The Data Pool that powers this Metric. */
  dataPool?: Maybe<DataPool>;
  /** The Metric's description. */
  description: Scalars['String'];
  /** The Metric's Dimensions. These Dimensions are available to Query Filters. */
  dimensions: Array<Dimension>;
  /** The Metric's Environment. */
  environment: Environment;
  /** The Metric's unique identifier. */
  id: Scalars['ID'];
  /**
   * Query the Metric in leaderboard format. Returns a table (array of rows) with the selected dimensions and the Metric's corresponding values for the given time range and filters.
   * @deprecated Use the top-level `leaderboard` query instead
   */
  leaderboard?: Maybe<LeaderboardResponse>;
  /**
   * The Metric's measure. Access this from the Metric's `settings` object instead.
   * @deprecated Use the Metric `settings` object instead.
   */
  measure?: Maybe<Dimension>;
  /** The Metric's last modification date and time in UTC. */
  modifiedAt: Scalars['DateTime'];
  /** The Metric's last modifier. It can be either a User ID, an Application ID, or "system" if it was modified by Propel. */
  modifiedBy: Scalars['String'];
  /**
   * List the Policies associated to the Metric.
   * @deprecated Use Data Pool Access Policies instead
   */
  policies: PolicyConnection;
  /** The settings for the Metric. The settings are specific to the Metric's type. */
  settings: MetricSettings;
  /**
   * Query the Metric in time series format. Returns arrays of timestamps and the Metric's values for the given time range and filters.
   * @deprecated Use the top-level `timeSeries` query instead
   */
  timeSeries?: Maybe<TimeSeriesResponse>;
  /** The Metric's timestamp, if any. This is the same as its Data Pool's timestamp, if any. */
  timestamp?: Maybe<Dimension>;
  /** The Metric's type. The different Metric types determine how the values are calculated. */
  type: MetricType;
  /** The Metric's unique name. */
  uniqueName: Scalars['String'];
};


/**
 * The Metric object.
 *
 * A Metric is a business indicator measured over time.
 *
 * [Learn more about Metrics](/docs/key-concepts#metric).
 */
export type MetricBoostersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/**
 * The Metric object.
 *
 * A Metric is a business indicator measured over time.
 *
 * [Learn more about Metrics](/docs/key-concepts#metric).
 */
export type MetricCounterArgs = {
  input: CounterInput;
};


/**
 * The Metric object.
 *
 * A Metric is a business indicator measured over time.
 *
 * [Learn more about Metrics](/docs/key-concepts#metric).
 */
export type MetricLeaderboardArgs = {
  input: LeaderboardInput;
};


/**
 * The Metric object.
 *
 * A Metric is a business indicator measured over time.
 *
 * [Learn more about Metrics](/docs/key-concepts#metric).
 */
export type MetricPoliciesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/**
 * The Metric object.
 *
 * A Metric is a business indicator measured over time.
 *
 * [Learn more about Metrics](/docs/key-concepts#metric).
 */
export type MetricTimeSeriesArgs = {
  input: TimeSeriesInput;
};

/**
 * The Metric connection object.
 *
 * Learn more about [pagination in GraphQL](https://www.propeldata.com/docs/api/pagination).
 */
export type MetricConnection = {
  __typename?: 'MetricConnection';
  /** The Metric connection's edges. */
  edges: Array<MetricEdge>;
  /** The Metric connection's nodes. */
  nodes: Array<Metric>;
  /** The Metric connection's page info. */
  pageInfo: PageInfo;
};

/**
 * The Metric edge object.
 *
 * Learn more about [pagination in GraphQL](https://www.propeldata.com/docs/api/pagination).
 */
export type MetricEdge = {
  __typename?: 'MetricEdge';
  /** The edge's cursor. */
  cursor: Scalars['String'];
  /** The edge's node. */
  node: Metric;
};

export type MetricInput = {
  /** An ad hoc Average Metric. */
  average?: InputMaybe<AverageMetricQueryInput>;
  /** An ad hoc Count Metric. */
  count?: InputMaybe<CountMetricQueryInput>;
  /** An ad hoc Count Distinct Metric. */
  countDistinct?: InputMaybe<CountDistinctMetricQueryInput>;
  /** An ad hoc Custom Metric. */
  custom?: InputMaybe<CustomMetricQueryInput>;
  /** The ID of a pre-configured Metric. */
  id?: InputMaybe<Scalars['ID']>;
  /** An ad hoc Max Metric. */
  max?: InputMaybe<MaxMetricQueryInput>;
  /** An ad hoc Min Metric. */
  min?: InputMaybe<MinMetricQueryInput>;
  /** The name of a pre-configured Metric. */
  name?: InputMaybe<Scalars['String']>;
  /** An ad hoc Sum Metric. */
  sum?: InputMaybe<SumMetricQueryInput>;
};

/**
 * The Metric Report connection object.
 *
 * It includes `headers` and `rows` for a single page of a report. It also allows paging forward and backward to other
 * pages of the report.
 *
 * Learn more about [pagination in GraphQL](https://www.propeldata.com/docs/api/pagination).
 */
export type MetricReportConnection = {
  __typename?: 'MetricReportConnection';
  /** The report connection's edges. */
  edges: Array<MetricReportEdge>;
  /** An ordered array of display names for your dimensions and Metrics, as defined in the report input. Use this to display your table's header. */
  headers: Array<Maybe<Scalars['String']>>;
  /** The report connection's nodes. */
  nodes: Array<MetricReportNode>;
  /** The report connection's page info. */
  pageInfo: PageInfo;
  /** The Query statistics and metadata. */
  query: QueryInfo;
  /** An ordered array of rows. Each row contains dimension and Metric values, as defined in the report input. Use these to display the rows of your table. */
  rows: Array<Array<Maybe<Scalars['String']>>>;
};

/** The fields for specifying a dimension to include in a Metric Report. */
export type MetricReportDimensionInput = {
  /** The column name of the dimension to include in a Metric Report. This must match the name of a Data Pool column. */
  columnName: Scalars['String'];
  /** The name to display in the `headers` array when displaying the report. This defaults to the column name if unspecified. */
  displayName?: InputMaybe<Scalars['String']>;
  /** The sort order for the dimension. It can be ascending (`ASC`) or descending (`DESC`) order. Defaults to ascending (`ASC`) order when not provided. */
  sort?: InputMaybe<Sort>;
};

/**
 * The Metric Report edge object.
 *
 * Learn more about [pagination in GraphQL](https://www.propeldata.com/docs/api/pagination).
 */
export type MetricReportEdge = {
  __typename?: 'MetricReportEdge';
  /** The edge's cursor. */
  cursor: Scalars['String'];
  /** The edge's node. */
  node: MetricReportNode;
};

/**
 * The fields for querying a Metric Report.
 *
 * A Metric Report is a table whose columns include dimensions and Metric values, calculated over a given time range.
 */
export type MetricReportInput = {
  /** The cursor to use when paging forward. */
  after?: InputMaybe<Scalars['String']>;
  /** The cursor to use when paging backward. */
  before?: InputMaybe<Scalars['String']>;
  /** One or many dimensions to group the Metric values by. Typically, dimensions in a report are what you want to compare and rank. */
  dimensions: Array<MetricReportDimensionInput>;
  /** The Query Filters to apply when building the Metric Report, in the form of SQL. These can be used to filter out rows. */
  filterSql?: InputMaybe<Scalars['String']>;
  /** The Query Filters to apply when building the Metric Report. These can be used to filter out rows. */
  filters?: InputMaybe<Array<FilterInput>>;
  /** The number of rows to be returned when paging forward. It can be a number between 1 and 1,000. */
  first?: InputMaybe<Scalars['Int']>;
  /** The number of rows to be returned when paging forward. It can be a number between 1 and 1,000. */
  last?: InputMaybe<Scalars['Int']>;
  /** One or more Metrics to include in the Metric Report. These will be broken down by `dimensions`. */
  metrics: Array<MetricReportMetricInput>;
  /** The index of the column to order the Metric Report by. The index is 1-based and defaults to the first Metric column. In other words, by default, reports are ordered by the first Metric; however, you can order by the second Metric, third Metric, etc., by overriding the `orderByColumn` input. You can also order by dimensions this way. */
  orderByColumn?: InputMaybe<Scalars['Int']>;
  /** The time range for calculating the Metric Report. */
  timeRange?: InputMaybe<TimeRangeInput>;
  /**
   * The time zone to use. Dates and times are always returned in UTC, but setting the time zone influences relative time ranges and granularities.
   *
   * You can set this to "America/Los_Angeles", "Europe/Berlin", or any other value in the [IANA time zone database](https://en.wikipedia.org/wiki/Tz_database). Defaults to "UTC".
   */
  timeZone?: InputMaybe<Scalars['String']>;
};

/** The fields for specifying a Metric to include in a Metric Report. */
export type MetricReportMetricInput = {
  /** The name to display in the `headers` array when displaying the report. This defaults to the Metric's unique name if unspecified. */
  displayName?: InputMaybe<Scalars['String']>;
  /** The Query Filters to apply when calculating the Metric, in the form of SQL. */
  filterSql?: InputMaybe<Scalars['String']>;
  /** The Query Filters to apply when calculating the Metric. */
  filters?: InputMaybe<Array<FilterInput>>;
  /** The Metric's ID. If not specified, Propel will lookup the Metric by unique name. */
  id?: InputMaybe<Scalars['ID']>;
  /** The Metric to query. You can query a pre-configured Metric by ID or name, or you can query an ad hoc Metric that you define inline. */
  metric?: InputMaybe<MetricInput>;
  /** The sort order for the Metric. It can be ascending (`ASC`) or descending (`DESC`) order. Defaults to descending (`DESC`) order when not provided. */
  sort?: InputMaybe<Sort>;
  /** The Metric's unique name. If not specified, Propel will lookup the Metric by ID. */
  uniqueName?: InputMaybe<Scalars['String']>;
};

/**
 * The Metric Report node object.
 *
 * This type represents a single row of a report.
 *
 * Learn more about [pagination in GraphQL](https://www.propeldata.com/docs/api/pagination).
 */
export type MetricReportNode = {
  __typename?: 'MetricReportNode';
  /** An ordered array of display names for your dimensions and Metrics, as defined in the report input. Use this to display your table's header. */
  headers: Array<Maybe<Scalars['String']>>;
  /** An ordered array of columns. Each column contains the dimension and Metric values for a single row, as defined in the report input. Use this to display a single row within your table. */
  row: Array<Maybe<Scalars['String']>>;
};

/** A Metric's settings, depending on its type. */
export type MetricSettings = AverageMetricSettings | CountDistinctMetricSettings | CountMetricSettings | CustomMetricSettings | MaxMetricSettings | MinMetricSettings | SumMetricSettings;

/** The available Metric types. */
export const MetricType = {
  /** Averages the values of the specified column for every record that matches the Metric Filters. For time series, it will average the values for each time granularity. */
  Average: 'AVERAGE',
  /** Counts the number of records that matches the Metric Filters. For time series, it will count the values for each time granularity. */
  Count: 'COUNT',
  /** Counts the number of distinct values in the specified column for every record that matches the Metric Filters. For time series, it will count the distinct values for each time granularity. */
  CountDistinct: 'COUNT_DISTINCT',
  /** Aggregates values based on the provided custom expression. */
  Custom: 'CUSTOM',
  /** Selects the maximum value of the specified column for every record that matches the Metric Filters. For time series, it will select the maximum value for each time granularity. */
  Max: 'MAX',
  /** Selects the minimum value of the specified column for every record that matches the Metric Filters. For time series, it will select the minimum value for each time granularity. */
  Min: 'MIN',
  /** Sums the values of the specified column for every record that matches the Metric Filters. For time series, it will sum the values for each time granularity. */
  Sum: 'SUM'
} as const;

export type MetricType = typeof MetricType[keyof typeof MetricType];
export type MinMetricQueryInput = {
  /** The Data Pool to which this Metric belongs. */
  dataPool: DataPoolInput;
  /** The column to calculate the minimum from. */
  measure: DimensionInput;
};

/** Settings for Min Metrics. */
export type MinMetricSettings = {
  __typename?: 'MinMetricSettings';
  /**
   * Metric Filters allow defining a Metric with a subset of records from the given Data Pool. If no Metric Filters are present, all records will be included. To filter at query time, add Dimensions and use the `filters` property on the `timeSeriesInput`, `counterInput`, or `leaderboardInput` objects. There is no need to add `filters` to be able to filter at query time.
   *
   * You can provide the filters in the form of SQL.
   */
  filterSql?: Maybe<Scalars['String']>;
  /**
   * Metric Filters allow defining a Metric with a subset of records from the given Data Pool. If no Metric Filters are present, all records will be included. To filter at query time, add Dimensions and use the `filters` property on the `timeSeriesInput`, `counterInput`, or `leaderboardInput` objects. There is no need to add `filters` to be able to filter at query time.
   * @deprecated Use `filterSql` instead
   */
  filters?: Maybe<Array<Filter>>;
  /** The Dimension to select the minimum from. */
  measure: Dimension;
};

export type Mutation = {
  __typename?: 'Mutation';
  copyAwsListing?: Maybe<AwsListing>;
  copyAzureListing?: Maybe<AzureListing>;
  copyGcpListing?: Maybe<GcpListing>;
  copyRedHatListing?: Maybe<RedHatListing>;
  createAwsConsoleUrl?: Maybe<Scalars['String']>;
  createAwsListing?: Maybe<AwsListing>;
  createAzureListing?: Maybe<AzureListing>;
  createCoSellCloudSolution?: Maybe<CoSellCloudSolution>;
  /** @deprecated Cloud solution should be used, and pass 'cloud' as mspc */
  createCoSellMicrosoftSolution?: Maybe<CoSellMicrosoftSolution>;
  createEmailCustomBrand?: Maybe<EmailCustomBrand>;
  createGcpListing?: Maybe<GcpListing>;
  createNewAwsProductAndOfferFromTackle: AwsCapiStartChangeSetResponse;
  createProspectPresignedUrl?: Maybe<ProspectSignedUrlResponse>;
  createProspectSelectedExportUrlV2?: Maybe<ProspectAccountSelectedExportUrlResponse>;
  createRedHatListing?: Maybe<RedHatListing>;
  createS3PresignedUrl?: Maybe<S3PresignedUrlResponse>;
  createUser: Auth0UserUserResponse;
  createVendor?: Maybe<Vendor>;
  deleteAwsListing?: Maybe<Scalars['Void']>;
  /** @deprecated Added generic delete of listing. Use deleteAwsListing instead. */
  deleteAwsListingRevision?: Maybe<Scalars['Void']>;
  deleteAzureListing?: Maybe<Scalars['Void']>;
  /** @deprecated Added generic delete of listing. Use deleteAzureListing instead. */
  deleteAzureListingRevision?: Maybe<Scalars['Void']>;
  deleteCoSellCloudSolution?: Maybe<CoSellCloudSolution>;
  /** @deprecated Cloud solution should be used instead */
  deleteCoSellMicrosoftSolution?: Maybe<CoSellMicrosoftSolution>;
  deleteEmailCustomBrand?: Maybe<EmailBrandMessageResponse>;
  deleteGcpListing?: Maybe<Scalars['Void']>;
  /** @deprecated Added generic delete of listing. Use deleteGcpListing instead. */
  deleteGcpListingRevision?: Maybe<Scalars['Void']>;
  deleteRedHatListing?: Maybe<Scalars['Void']>;
  /** @deprecated Added generic delete of listing. */
  deleteRedHatListingRevision?: Maybe<Scalars['Void']>;
  deleteRole: Role;
  deleteUser?: Maybe<Scalars['Void']>;
  generateGcpListingDimensions?: Maybe<GcpListing>;
  importAwsListing?: Maybe<AwsListing>;
  importAzureListing?: Maybe<AzureListing>;
  linkCloudOpportunitiesToSalesforceOpportunities?: Maybe<CloudOpportunitiesToSalesforceOpportunitiesResponse>;
  mergeAwsListingRevision?: Maybe<AwsListing>;
  mergeAzureListingRevision?: Maybe<AzureListing>;
  mergeGcpListingRevision?: Maybe<GcpListing>;
  postProspectAgreeToTerms?: Maybe<ProspectHasAgreedToTermsResponse>;
  prospectAutoScoringDeleteRuleSets: Scalars['String'];
  prospectAutoScoringDeleteRules: Scalars['String'];
  prospectAutoScoringGetOrCreateDefaultRule: ProspectAutoScoringGetOrCreateDefaultRuleResponse;
  prospectAutoScoringPersistRules: Scalars['String'];
  prospectSubmitScoreOrMakeVisible?: Maybe<ProspectScoreCrmAccount>;
  relistAwsListingRevision?: Maybe<AwsListing>;
  relistAzureListingRevision?: Maybe<AzureListing>;
  relistGcpListingRevision?: Maybe<GcpListing>;
  salesforceRegistration: SalesforceRegistrationResponse;
  signUp: SignUpResult;
  submitAwsListingForReview?: Maybe<AwsListing>;
  submitAzureListingForReview?: Maybe<AzureListing>;
  submitGcpListingForReview?: Maybe<GcpListing>;
  submitProspectAccountForScoring?: Maybe<ProspectAccountScoringResponse>;
  submitProspectFileForScoring?: Maybe<ProspectFileScoringResponse>;
  submitRedHatListingForReview?: Maybe<RedHatListing>;
  supportApiGenerateVendorAwsEntitlements?: Maybe<Scalars['String']>;
  /** Utility script ported over from the Support API, It generates a CSV as a String of all Azure Subscriptions by Vendor */
  supportApiGenerateVendorAzureSubscriptions?: Maybe<Scalars['String']>;
  supportApiGenerateVendorGcpInspectListOrders?: Maybe<Scalars['String']>;
  switchVendors: SwithVendorsMutationResponse;
  testCoSellAceConnection: Scalars['Boolean'];
  testEmailCustomBrand?: Maybe<EmailBrandMessageResponse>;
  toggleCompletedSaasDocumentation?: Maybe<CoSellVendor>;
  updateAwsListing?: Maybe<AwsListing>;
  updateAwsProductAndOfferFromTackle: AwsCapiStartChangeSetResponse;
  updateAzureListing?: Maybe<AzureListing>;
  updateCoSellCloudSolution?: Maybe<CoSellCloudSolution>;
  /** @deprecated Cloud solution should be used instead */
  updateCoSellMicrosoftSolution?: Maybe<CoSellMicrosoftSolution>;
  updateCoSellVendor?: Maybe<CoSellVendor>;
  updateCrmAccountScoreVisibility?: Maybe<ProspectScoreCrmAccount>;
  updateEmailCustomBrand?: Maybe<EmailCustomBrand>;
  updateEntitlementToCoSellVendor?: Maybe<CoSellVendor>;
  updateGcpListing?: Maybe<GcpListing>;
  updateOrbVendorConfig?: Maybe<OrbVendorConfig>;
  updateOrganization?: Maybe<Organization>;
  updateRedHatListing?: Maybe<RedHatListing>;
  updateUser: Auth0UserUserResponse;
  updateVendor?: Maybe<Vendor>;
  updateVendorBillingConfiguration?: Maybe<VendorBillingConfiguration>;
  upsertRole: Role;
  validateVendor?: Maybe<Vendor>;
};


export type MutationCopyAwsListingArgs = {
  id: Scalars['ID'];
};


export type MutationCopyAzureListingArgs = {
  id: Scalars['ID'];
};


export type MutationCopyGcpListingArgs = {
  id: Scalars['ID'];
};


export type MutationCopyRedHatListingArgs = {
  id: Scalars['ID'];
};


export type MutationCreateAwsConsoleUrlArgs = {
  targetUrl?: InputMaybe<Scalars['String']>;
  vendorId: Scalars['ID'];
};


export type MutationCreateCoSellCloudSolutionArgs = {
  solution: CoSellCloudSolutionCreateInput;
};


export type MutationCreateCoSellMicrosoftSolutionArgs = {
  solution: CoSellMicrosoftSolutionCreateInput;
};


export type MutationCreateEmailCustomBrandArgs = {
  body: EmailCustomBrandInput;
};


export type MutationCreateNewAwsProductAndOfferFromTackleArgs = {
  id: Scalars['ID'];
  input: CreateOrUpdateListingWithCapiInput;
};


export type MutationCreateProspectPresignedUrlArgs = {
  data: ProspectPresignedUrlInput;
};


export type MutationCreateProspectSelectedExportUrlV2Args = {
  data: FilterProspectAccountsInput;
};


export type MutationCreateS3PresignedUrlArgs = {
  data: S3Input;
};


export type MutationCreateUserArgs = {
  email: Scalars['String'];
  role: Auth0UserCreateInputRole;
};


export type MutationCreateVendorArgs = {
  data: CreateVendorInput;
};


export type MutationDeleteAwsListingArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteAwsListingRevisionArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteAzureListingArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteAzureListingRevisionArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteCoSellCloudSolutionArgs = {
  solution: CoSellCloudSolutionDeleteInput;
};


export type MutationDeleteCoSellMicrosoftSolutionArgs = {
  solution: CoSellMicrosoftSolutionDeleteInput;
};


export type MutationDeleteEmailCustomBrandArgs = {
  id: Scalars['String'];
};


export type MutationDeleteGcpListingArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteGcpListingRevisionArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteRedHatListingArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteRedHatListingRevisionArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteRoleArgs = {
  id: Scalars['String'];
};


export type MutationDeleteUserArgs = {
  userId: Scalars['String'];
};


export type MutationGenerateGcpListingDimensionsArgs = {
  listingId: Scalars['ID'];
};


export type MutationImportAwsListingArgs = {
  id: Scalars['ID'];
};


export type MutationImportAzureListingArgs = {
  id: Scalars['ID'];
};


export type MutationLinkCloudOpportunitiesToSalesforceOpportunitiesArgs = {
  cloud: Scalars['String'];
  data: Scalars['String'];
  id: Scalars['ID'];
};


export type MutationMergeAwsListingRevisionArgs = {
  id: Scalars['ID'];
};


export type MutationMergeAzureListingRevisionArgs = {
  id: Scalars['ID'];
};


export type MutationMergeGcpListingRevisionArgs = {
  id: Scalars['ID'];
};


export type MutationPostProspectAgreeToTermsArgs = {
  data: ProspectAgreeToTermsInput;
};


export type MutationProspectAutoScoringDeleteRuleSetsArgs = {
  ruleSets: Array<RuleSetInput>;
  vendor_id: Scalars['String'];
};


export type MutationProspectAutoScoringDeleteRulesArgs = {
  rules: AllRulesInput;
  vendor_id: Scalars['String'];
};


export type MutationProspectAutoScoringGetOrCreateDefaultRuleArgs = {
  vendor_id: Scalars['String'];
};


export type MutationProspectAutoScoringPersistRulesArgs = {
  ruleSets: Array<RuleSetInput>;
  vendor_id: Scalars['String'];
};


export type MutationProspectSubmitScoreOrMakeVisibleArgs = {
  crmId: Scalars['String'];
  domain?: InputMaybe<Scalars['String']>;
  vendorId: Scalars['String'];
};


export type MutationRelistAwsListingRevisionArgs = {
  updates: AwsListingRelistInput;
};


export type MutationRelistAzureListingRevisionArgs = {
  updates: AzureListingRelistInput;
};


export type MutationRelistGcpListingRevisionArgs = {
  updates: GcpListingRelistInput;
};


export type MutationSalesforceRegistrationArgs = {
  authorizationCode: Scalars['String'];
  loginURL: Scalars['String'];
  namespace: Scalars['String'];
  packageVersion: Scalars['String'];
  redirectURL?: InputMaybe<Scalars['String']>;
  vendorId: Scalars['String'];
};


export type MutationSignUpArgs = {
  input: SignUpInput;
};


export type MutationSubmitAwsListingForReviewArgs = {
  id: Scalars['ID'];
};


export type MutationSubmitAzureListingForReviewArgs = {
  id: Scalars['ID'];
};


export type MutationSubmitGcpListingForReviewArgs = {
  id: Scalars['ID'];
};


export type MutationSubmitProspectAccountForScoringArgs = {
  data: ProspectAccountForScoringInput;
};


export type MutationSubmitProspectFileForScoringArgs = {
  data: ProspectFileForScoringInput;
};


export type MutationSubmitRedHatListingForReviewArgs = {
  id: Scalars['ID'];
};


export type MutationSupportApiGenerateVendorAwsEntitlementsArgs = {
  productId: Scalars['ID'];
  vendorId: Scalars['ID'];
};


export type MutationSupportApiGenerateVendorAzureSubscriptionsArgs = {
  id: Scalars['ID'];
};


export type MutationSupportApiGenerateVendorGcpInspectListOrdersArgs = {
  customerId?: InputMaybe<Scalars['ID']>;
  productId: Scalars['ID'];
  raw?: InputMaybe<Scalars['Boolean']>;
  vendorId: Scalars['ID'];
};


export type MutationSwitchVendorsArgs = {
  case_number?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
  vendorid: Scalars['String'];
};


export type MutationTestCoSellAceConnectionArgs = {
  vendorId: Scalars['String'];
};


export type MutationTestEmailCustomBrandArgs = {
  body: EmailCustomBrandTestInput;
};


export type MutationToggleCompletedSaasDocumentationArgs = {
  status: Scalars['Boolean'];
  vendorId: Scalars['ID'];
};


export type MutationUpdateAwsListingArgs = {
  updates: AwsListingInput;
};


export type MutationUpdateAwsProductAndOfferFromTackleArgs = {
  id: Scalars['ID'];
  input: CreateOrUpdateListingWithCapiInput;
};


export type MutationUpdateAzureListingArgs = {
  updates: AzureListingInput;
};


export type MutationUpdateCoSellCloudSolutionArgs = {
  updates: CoSellCloudSolutionUpdateInput;
};


export type MutationUpdateCoSellMicrosoftSolutionArgs = {
  updates: CoSellMicrosoftSolutionUpdateInput;
};


export type MutationUpdateCoSellVendorArgs = {
  updates: CoSellVendorInput;
};


export type MutationUpdateCrmAccountScoreVisibilityArgs = {
  crm_id: Scalars['String'];
  vendor_id: Scalars['String'];
  visibility: Scalars['String'];
};


export type MutationUpdateEmailCustomBrandArgs = {
  body: EmailCustomBrandInput;
  id: Scalars['String'];
};


export type MutationUpdateEntitlementToCoSellVendorArgs = {
  updates: CoSellVendorInput;
};


export type MutationUpdateGcpListingArgs = {
  updates: GcpListingInput;
};


export type MutationUpdateOrbVendorConfigArgs = {
  updates: OrbVendorConfigInput;
};


export type MutationUpdateOrganizationArgs = {
  data: OrganizationInput;
};


export type MutationUpdateRedHatListingArgs = {
  updates: RedHatListingInput;
};


export type MutationUpdateUserArgs = {
  email: Scalars['String'];
  role: Auth0UserCreateInputRole;
  userId: Scalars['String'];
};


export type MutationUpdateVendorArgs = {
  updates: VendorInput;
};


export type MutationUpdateVendorBillingConfigurationArgs = {
  updates: VendorBillingConfigurationInput;
};


export type MutationUpsertRoleArgs = {
  body: RoleInput;
};


export type MutationValidateVendorArgs = {
  id: Scalars['ID'];
};

export type NewUser = {
  __typename?: 'NewUser';
  email: Scalars['String'];
  id: Scalars['String'];
  vendorid: Scalars['String'];
};

/** All Propel resources, such as Applications and Metrics, have a unique identifier, or ID. Typically, they may also have a unique name, which is specified in the interface `Common`. */
export type Node = {
  id: Scalars['ID'];
};

export type OfferSummaryForProspectDomain = {
  __typename?: 'OfferSummaryForProspectDomain';
  cloud?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  po_id: Scalars['String'];
  stage?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type OffersVertical = ProductVertical & {
  __typename?: 'OffersVertical';
  data: OffersVerticalData;
  id: ProductVerticalName;
  stage: VerticalStage;
};

export type OffersVerticalData = {
  __typename?: 'OffersVerticalData';
  highScoreCount: Scalars['Int'];
  marketplaceStages: Array<MarketplaceStage>;
};

export type OpportunitiesExistRule = {
  __typename?: 'OpportunitiesExistRule';
  opportunitiesExist: Scalars['Boolean'];
  pk?: Maybe<Scalars['String']>;
  ruleId?: Maybe<Scalars['String']>;
  ruleSetId?: Maybe<Scalars['String']>;
  ruleType: Scalars['String'];
  sk?: Maybe<Scalars['String']>;
};

export type OpportunitiesExistRuleInput = {
  opportunitiesExist: Scalars['Boolean'];
  pk?: InputMaybe<Scalars['String']>;
  ruleId?: InputMaybe<Scalars['String']>;
  ruleSetId?: InputMaybe<Scalars['String']>;
  ruleType?: Scalars['String'];
  sk?: InputMaybe<Scalars['String']>;
};

export type OpportunityRule = {
  __typename?: 'OpportunityRule';
  opportunityTypes: Array<Scalars['String']>;
  pk?: Maybe<Scalars['String']>;
  ruleId?: Maybe<Scalars['String']>;
  ruleSetId?: Maybe<Scalars['String']>;
  ruleType: Scalars['String'];
  sk?: Maybe<Scalars['String']>;
};

export type OpportunityRuleInput = {
  opportunityTypes: Array<Scalars['String']>;
  pk?: InputMaybe<Scalars['String']>;
  ruleId?: InputMaybe<Scalars['String']>;
  ruleSetId?: InputMaybe<Scalars['String']>;
  ruleType?: Scalars['String'];
  sk?: InputMaybe<Scalars['String']>;
};

export type OpportunityTypeFilteringValuesResponse = {
  __typename?: 'OpportunityTypeFilteringValuesResponse';
  data: Array<Scalars['String']>;
};

export type OrbVendorConfig = {
  __typename?: 'OrbVendorConfig';
  /**
   * config_by_product_id is an object like
   *
   * ```
   * { [product_id]: {
   *     dimension_name: string,
   *     price_per_unit: number
   *   }
   * }
   * ```
   */
  config_by_product_id?: Maybe<Scalars['JSONObject']>;
  id: Scalars['ID'];
  orb_api_key_prefix?: Maybe<Scalars['String']>;
  orb_webhook_signing_secret_prefix?: Maybe<Scalars['String']>;
  tackle_client_id?: Maybe<Scalars['String']>;
  tackle_client_secret_prefix?: Maybe<Scalars['String']>;
};

export type OrbVendorConfigInput = {
  /**
   * config_by_product_id is an object like
   *
   * ```
   * { [product_id]: {
   *     dimension_name: string,
   *     price_per_unit: number
   *   }
   * }
   * ```
   */
  config_by_product_id?: InputMaybe<Scalars['JSONObject']>;
  id: Scalars['ID'];
  orb_api_key?: InputMaybe<Scalars['String']>;
  orb_webhook_signing_secret?: InputMaybe<Scalars['String']>;
  tackle_client_id?: InputMaybe<Scalars['String']>;
  tackle_client_secret?: InputMaybe<Scalars['String']>;
};

export type Organization = {
  __typename?: 'Organization';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  vendorids?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type OrganizationDetails = {
  __typename?: 'OrganizationDetails';
  id?: Maybe<Scalars['String']>;
  instanceName?: Maybe<Scalars['String']>;
  isSandbox?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  namespacePrefix?: Maybe<Scalars['String']>;
  organizationType?: Maybe<Scalars['String']>;
};

export type OrganizationInput = {
  id: Scalars['String'];
  name: Scalars['String'];
  vendorids: Array<Scalars['String']>;
};

export type OrganizationVendor = {
  __typename?: 'OrganizationVendor';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  vendor_type?: Maybe<Scalars['String']>;
};

export type OrganizationVendors = {
  __typename?: 'OrganizationVendors';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  vendors?: Maybe<Array<Maybe<OrganizationVendor>>>;
};

/** The page info object used for pagination. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** Points to the last item returned in the results. Used when paginating forward. */
  endCursor?: Maybe<Scalars['String']>;
  /** A boolean that indicates whether a next page of results exists. Can be used to display a "next page" button in user interfaces, for example. */
  hasNextPage: Scalars['Boolean'];
  /** A boolean that indicates whether a previous page of results exists. Can be used to display a "previous page" button in user interfaces, for example. */
  hasPreviousPage: Scalars['Boolean'];
  /** Points to the first item returned in the results. Used when paginating backward. */
  startCursor?: Maybe<Scalars['String']>;
};

export type PaginatedVendors = {
  __typename?: 'PaginatedVendors';
  lastPageToken?: Maybe<Scalars['String']>;
  nextPageToken?: Maybe<Scalars['String']>;
  /** as it is now vendors is only a subset of the full model, basically just `id`, `name`, and `logo_url` */
  vendors?: Maybe<Array<Vendor>>;
};

export type PaymentScheduleTerm = {
  __typename?: 'PaymentScheduleTerm';
  currencyCode: Scalars['String'];
  schedule: Array<ScheduleItem>;
  type: Scalars['String'];
};

/** The Policy type. It governs an Application's access to a Metric's data. */
export type Policy = Node & {
  __typename?: 'Policy';
  /** The Policy's Account. */
  account: Account;
  /** The Application that is granted access. */
  application: Application;
  /** The Policy's creation date and time in UTC. */
  createdAt: Scalars['DateTime'];
  /** The Policy's creator. It can be either a User ID, an Application ID, or "system" if it was created by Propel. */
  createdBy: Scalars['String'];
  /** The Policy's Environment. */
  environment: Environment;
  /** The Policy's unique identifier. */
  id: Scalars['ID'];
  /** The Metric that the Application is granted access to. */
  metric: Metric;
  /** The Policy's last modification date and time in UTC. */
  modifiedAt: Scalars['DateTime'];
  /** The Policy's last modifier. It can be either a User ID, an Application ID, or "system" if it was modified by Propel. */
  modifiedBy: Scalars['String'];
  /** The type of Policy. */
  type: PolicyType;
};

/**
 * The Policy connection object.
 *
 * Learn more about [pagination in GraphQL](https://www.propeldata.com/docs/api/pagination).
 */
export type PolicyConnection = {
  __typename?: 'PolicyConnection';
  /** The Policy connection's edges. */
  edges: Array<PolicyEdge>;
  /** The Policy connection's nodes. */
  nodes: Array<Policy>;
  /** The Policy connection's page info. */
  pageInfo: PageInfo;
};

/**
 * The Policy edge object.
 *
 * Learn more about [pagination in GraphQL](https://www.propeldata.com/docs/api/pagination).
 */
export type PolicyEdge = {
  __typename?: 'PolicyEdge';
  /** The edge's cursor. */
  cursor: Scalars['String'];
  /** The edge's node. */
  node: Policy;
};

/** The types of Policies that can be applied to a Metric. */
export const PolicyType = {
  /** Grants access to all Metric data. */
  AllAccess: 'ALL_ACCESS',
  /** Grants access to a specified tenant's Metric data. */
  TenantAccess: 'TENANT_ACCESS'
} as const;

export type PolicyType = typeof PolicyType[keyof typeof PolicyType];
export type PrivateOffer = {
  __typename?: 'PrivateOffer';
  abo_linked_offer_ref?: Maybe<Scalars['String']>;
  accepted_at?: Maybe<Scalars['String']>;
  accepted_source?: Maybe<Scalars['String']>;
  archived_at?: Maybe<Scalars['String']>;
  cancelled_at?: Maybe<Scalars['String']>;
  cloud: Scalars['String'];
  created_at?: Maybe<Scalars['String']>;
  customer_ref?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  last_modified_at?: Maybe<Scalars['String']>;
  last_update_source?: Maybe<Scalars['String']>;
  metadata?: Maybe<PrivateOfferMetadata>;
  offer_ref?: Maybe<Scalars['String']>;
  offer_type?: Maybe<Scalars['String']>;
  opened_instructions_at?: Maybe<Scalars['String']>;
  partner_offer_id?: Maybe<Scalars['String']>;
  po_id: Scalars['ID'];
  po_ref?: Maybe<Scalars['String']>;
  pricing?: Maybe<PrivateOfferPricing>;
  product_ref?: Maybe<Scalars['String']>;
  salesforce_ref?: Maybe<Scalars['String']>;
  sent_at?: Maybe<Scalars['String']>;
  stage?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  users_to_notify?: Maybe<Array<Maybe<PrivateOfferUserToNotify>>>;
  vendor_id: Scalars['String'];
  viewed_offer_at?: Maybe<Scalars['String']>;
};

export type PrivateOfferMetadata = {
  __typename?: 'PrivateOfferMetadata';
  buyers?: Maybe<Array<Maybe<PrivateOfferMetadataBuyer>>>;
  enable_zero_dollar_prices?: Maybe<Scalars['Boolean']>;
  eula?: Maybe<PrivateOfferMetadataEula>;
  marketplace_acceptance_link?: Maybe<Scalars['String']>;
  offer_end_at?: Maybe<Scalars['String']>;
  offer_expiration_at?: Maybe<Scalars['String']>;
  offer_metadata?: Maybe<Scalars['JSONObject']>;
  offer_point_of_contact?: Maybe<Scalars['String']>;
  offer_start_at?: Maybe<Scalars['String']>;
  pre_registration_details?: Maybe<Scalars['JSONObject']>;
  pricing?: Maybe<PrivateOfferMetadataPricing>;
  renewal?: Maybe<Scalars['Boolean']>;
};

export type PrivateOfferMetadataBuyer = {
  __typename?: 'PrivateOfferMetadataBuyer';
  email_address?: Maybe<Scalars['String']>;
  full_name?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type PrivateOfferMetadataEula = {
  __typename?: 'PrivateOfferMetadataEula';
  files?: Maybe<Array<Maybe<Scalars['String']>>>;
  type?: Maybe<Scalars['String']>;
};

export type PrivateOfferMetadataPricing = {
  __typename?: 'PrivateOfferMetadataPricing';
  billing_term?: Maybe<Scalars['String']>;
  dimensions?: Maybe<Array<Maybe<DimensionOrPlan>>>;
  duration?: Maybe<Scalars['String']>;
  duration_type?: Maybe<Scalars['String']>;
  duration_value?: Maybe<Scalars['Int']>;
  marketplace_fee?: Maybe<Scalars['String']>;
  monthly_contract_value?: Maybe<Scalars['String']>;
  net_contract_value?: Maybe<Scalars['String']>;
  offer_sub_type?: Maybe<Scalars['String']>;
  payment_model?: Maybe<Scalars['String']>;
  schedule?: Maybe<Array<Maybe<PrivateOfferMetadataPricingSchedule>>>;
  service_end_at?: Maybe<Scalars['String']>;
  service_start_at?: Maybe<Scalars['String']>;
  show_on_email?: Maybe<Scalars['Boolean']>;
  total_contract_value?: Maybe<Scalars['String']>;
  usage_dimensions?: Maybe<Array<Maybe<PrivateOfferMetadataPricingUsageDimension>>>;
  version?: Maybe<Scalars['String']>;
};

export type PrivateOfferMetadataPricingAzurePlan = {
  __typename?: 'PrivateOfferMetadataPricingAzurePlan';
  absolute_prices?: Maybe<Array<Maybe<AzureAbsolutePrice>>>;
  discount_percentage?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
};

export type PrivateOfferMetadataPricingDimension = {
  __typename?: 'PrivateOfferMetadataPricingDimension';
  dimension_value?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['String']>;
};

export type PrivateOfferMetadataPricingSchedule = {
  __typename?: 'PrivateOfferMetadataPricingSchedule';
  invoice_amount?: Maybe<Scalars['Float']>;
  invoice_date?: Maybe<Scalars['String']>;
};

export type PrivateOfferMetadataPricingUsageDimension = {
  __typename?: 'PrivateOfferMetadataPricingUsageDimension';
  description: Scalars['String'];
  price?: Maybe<Scalars['Float']>;
  sku: Scalars['String'];
};

export type PrivateOfferPricing = {
  __typename?: 'PrivateOfferPricing';
  account_id?: Maybe<Scalars['String']>;
  billing_frequency?: Maybe<Scalars['String']>;
  edition_id?: Maybe<Scalars['String']>;
  marketplace_fee?: Maybe<Scalars['String']>;
  monthly_contract_value?: Maybe<Scalars['String']>;
  net_contract_value?: Maybe<Scalars['String']>;
  pricing_type?: Maybe<Scalars['String']>;
  total_contract_value?: Maybe<Scalars['String']>;
};

export type PrivateOfferUserToNotify = {
  __typename?: 'PrivateOfferUserToNotify';
  contact_type: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type ProductVertical = {
  id: ProductVerticalName;
  stage: VerticalStage;
};

export const ProductVerticalName = {
  Cosell: 'COSELL',
  Offers: 'OFFERS',
  Prospect: 'PROSPECT'
} as const;

export type ProductVerticalName = typeof ProductVerticalName[keyof typeof ProductVerticalName];
/**
 * A Propeller determines your Application's query processing power. The larger the Propeller, the faster the queries and the higher the cost. Every Propel Application (and therefore every set of API credentials) has a Propeller that determines the speed and cost of queries.
 *
 * [Learn more about Data Sources](https://www.propeldata.com/docs/applications#propeller).
 */
export const Propeller = {
  /** Max records per second: 250,000,000 records per second */
  P1Large: 'P1_LARGE',
  /** Max records per second: 100,000,000 records per second */
  P1Medium: 'P1_MEDIUM',
  /** Max records per second: 25,000,000 records per second */
  P1Small: 'P1_SMALL',
  /** Max records per second: 500,000,000 records per second */
  P1XLarge: 'P1_X_LARGE',
  /** Max records per second: 5,000,000 records per second */
  P1XSmall: 'P1_X_SMALL'
} as const;

export type Propeller = typeof Propeller[keyof typeof Propeller];
export type Prospect = {
  domain?: InputMaybe<Scalars['String']>;
  extra: Scalars['JSONObject'];
};

export type ProspectAccountForScoringInput = {
  crmId?: InputMaybe<Scalars['String']>;
  domain: Scalars['String'];
  vendorId: Scalars['String'];
};

export type ProspectAccountResult = {
  __typename?: 'ProspectAccountResult';
  company_name?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  primary_industry?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  revenue_band?: Maybe<Scalars['String']>;
  score_aws?: Maybe<Scalars['String']>;
  score_azure?: Maybe<Scalars['String']>;
  score_gcp?: Maybe<Scalars['String']>;
};

export type ProspectAccountScoringResponse = {
  __typename?: 'ProspectAccountScoringResponse';
  data?: Maybe<ProspectAccountResult>;
  metadata?: Maybe<Scalars['JSONObject']>;
};

export type ProspectAccountSelectedExportInput = {
  batch_id?: InputMaybe<Scalars['String']>;
  clouds?: InputMaybe<Array<Scalars['String']>>;
  company_name_search_string?: InputMaybe<Scalars['String']>;
  domains?: InputMaybe<Array<Scalars['String']>>;
  industries?: InputMaybe<Array<Scalars['String']>>;
  opportunities?: InputMaybe<Scalars['Boolean']>;
  opportunity_cloud?: InputMaybe<Scalars['String']>;
  regions?: InputMaybe<Array<Scalars['String']>>;
  revenue_band?: InputMaybe<Array<Scalars['String']>>;
  scores?: InputMaybe<Array<Scalars['String']>>;
  search_string?: InputMaybe<Scalars['String']>;
  vendor_id: Scalars['String'];
};

export type ProspectAccountSelectedExportUrlResponse = {
  __typename?: 'ProspectAccountSelectedExportUrlResponse';
  data?: Maybe<ProspectSignedUrl>;
};

export type ProspectAgreeToTermsInput = {
  agreement_version: Scalars['String'];
  contract_end_date: Scalars['String'];
  contract_start_date: Scalars['String'];
  domains_entitled: Scalars['Int'];
  vendor_id: Scalars['String'];
};

export type ProspectApiProspectAccountScoresResponse = {
  __typename?: 'ProspectApiProspectAccountScoresResponse';
  data?: Maybe<Array<Maybe<ProspectScoringResult>>>;
  metadata?: Maybe<ProspectPaginationInfo>;
};

export type ProspectAutoScoringGetOrCreateDefaultRuleResponse = {
  __typename?: 'ProspectAutoScoringGetOrCreateDefaultRuleResponse';
  data?: Maybe<RuleSetWithRules>;
};

export type ProspectAutoScoringRulesResponse = {
  __typename?: 'ProspectAutoScoringRulesResponse';
  data?: Maybe<Array<RuleSetWithRules>>;
};

export type ProspectCompanyDetails = {
  __typename?: 'ProspectCompanyDetails';
  company_name?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  new_high_info?: Maybe<ProspectNewHighs>;
  offerCount?: Maybe<Scalars['Int']>;
  offers?: Maybe<Array<Maybe<OfferSummaryForProspectDomain>>>;
  primary_industry?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  revenue_band?: Maybe<Scalars['String']>;
  score_aws?: Maybe<Scalars['String']>;
  score_azure?: Maybe<Scalars['String']>;
  score_gcp?: Maybe<Scalars['String']>;
};

export type ProspectCompanyDetailsResponse = {
  __typename?: 'ProspectCompanyDetailsResponse';
  data?: Maybe<ProspectCompanyDetails>;
};

export type ProspectEntitlementsResponse = {
  __typename?: 'ProspectEntitlementsResponse';
  limit_use?: Maybe<Scalars['Boolean']>;
  precommit?: Maybe<Scalars['Int']>;
  requested?: Maybe<Scalars['Int']>;
  usage?: Maybe<Scalars['Int']>;
};

export type ProspectFeatureImportance = {
  __typename?: 'ProspectFeatureImportance';
  bucket?: Maybe<Scalars['String']>;
  bucket_definition?: Maybe<Scalars['String']>;
  bucket_percentage?: Maybe<Scalars['Float']>;
  bucket_score?: Maybe<Scalars['Float']>;
};

export type ProspectFeatureImportanceResponse = {
  __typename?: 'ProspectFeatureImportanceResponse';
  data?: Maybe<Array<Maybe<ProspectFeatureImportance>>>;
};

export type ProspectFileForScoringInput = {
  batchId: Scalars['String'];
  domainColumnName: Scalars['String'];
  fileS3Key: Scalars['String'];
  fileType: Scalars['String'];
  vendorId: Scalars['String'];
};

export type ProspectFileScoring = {
  __typename?: 'ProspectFileScoring';
  batch_id?: Maybe<Scalars['String']>;
  raw_file_bucket?: Maybe<Scalars['String']>;
  raw_file_key?: Maybe<Scalars['String']>;
  scored_file_bucket?: Maybe<Scalars['String']>;
  scored_file_key?: Maybe<Scalars['String']>;
};

export type ProspectFileScoringMetadata = {
  __typename?: 'ProspectFileScoringMetadata';
  warnings?: Maybe<Array<Maybe<ProspectFileScoringWarnings>>>;
};

export type ProspectFileScoringResponse = {
  __typename?: 'ProspectFileScoringResponse';
  data?: Maybe<ProspectFileScoring>;
  metadata?: Maybe<ProspectFileScoringMetadata>;
};

export type ProspectFileScoringWarnings = {
  __typename?: 'ProspectFileScoringWarnings';
  invalid_domains?: Maybe<Array<Maybe<Scalars['String']>>>;
  message?: Maybe<Scalars['String']>;
};

export type ProspectFilterValues = {
  __typename?: 'ProspectFilterValues';
  primary_industries?: Maybe<Array<Maybe<Scalars['String']>>>;
  regions?: Maybe<Array<Maybe<Scalars['String']>>>;
  revenue_bands?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ProspectFilterValuesResponse = {
  __typename?: 'ProspectFilterValuesResponse';
  data?: Maybe<ProspectFilterValues>;
};

export type ProspectHasAgreedToTermsResponse = {
  __typename?: 'ProspectHasAgreedToTermsResponse';
  has_agreed?: Maybe<Scalars['Boolean']>;
};

export type ProspectMarketplaceCounts = {
  __typename?: 'ProspectMarketplaceCounts';
  aws?: Maybe<Scalars['Int']>;
  azure?: Maybe<Scalars['Int']>;
  gcp?: Maybe<Scalars['Int']>;
  not_listed_on?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ProspectMarketplaceScores = {
  __typename?: 'ProspectMarketplaceScores';
  count_high?: Maybe<Scalars['Int']>;
  count_low?: Maybe<Scalars['Int']>;
  count_medium?: Maybe<Scalars['Int']>;
};

export type ProspectMissingOpportunitiesResponse = {
  __typename?: 'ProspectMissingOpportunitiesResponse';
  data?: Maybe<Scalars['String']>;
};

export type ProspectNewHighs = {
  __typename?: 'ProspectNewHighs';
  clouds?: Maybe<Array<Maybe<Scalars['String']>>>;
  domain?: Maybe<Scalars['String']>;
  new_score?: Maybe<Scalars['String']>;
};

export type ProspectNewHighsResponse = {
  __typename?: 'ProspectNewHighsResponse';
  data?: Maybe<Array<Maybe<ProspectNewHighs>>>;
};

export type ProspectOpportunitiesCountByMarketplaceResponse = {
  __typename?: 'ProspectOpportunitiesCountByMarketplaceResponse';
  data?: Maybe<ProspectMarketplaceCounts>;
};

export type ProspectPaginationInfo = {
  __typename?: 'ProspectPaginationInfo';
  current_page_number?: Maybe<Scalars['Int']>;
  current_page_record_count?: Maybe<Scalars['Int']>;
  next_page?: Maybe<Scalars['String']>;
  previous_page?: Maybe<Scalars['String']>;
  total_record_count?: Maybe<Scalars['Int']>;
};

export type ProspectPresignedUrlInput = {
  file_name: Scalars['String'];
  vendor_id: Scalars['String'];
};

export type ProspectRollupStatistics = {
  __typename?: 'ProspectRollupStatistics';
  aws_rollup?: Maybe<ProspectMarketplaceScores>;
  azure_rollup?: Maybe<ProspectMarketplaceScores>;
  gcp_rollup?: Maybe<ProspectMarketplaceScores>;
  new_highs?: Maybe<Scalars['JSONObject']>;
  total_domains?: Maybe<Scalars['Int']>;
};

export type ProspectRollupStatisticsResponse = {
  __typename?: 'ProspectRollupStatisticsResponse';
  data?: Maybe<ProspectRollupStatistics>;
};

export type ProspectScoreCrmAccount = {
  __typename?: 'ProspectScoreCrmAccount';
  batch_id?: Maybe<Scalars['String']>;
  company_name?: Maybe<Scalars['String']>;
  crm_id?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  extra?: Maybe<Scalars['JSONObject']>;
  extra_columns_order?: Maybe<Array<Maybe<Scalars['String']>>>;
  primary_industry?: Maybe<Scalars['String']>;
  prospect_id?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  revenue_band?: Maybe<Scalars['String']>;
  score_aws?: Maybe<Scalars['String']>;
  score_azure?: Maybe<Scalars['String']>;
  score_gcp?: Maybe<Scalars['String']>;
  user_entered_domain?: Maybe<Scalars['String']>;
  visibility?: Maybe<Scalars['String']>;
};

export type ProspectScoringBatch = {
  __typename?: 'ProspectScoringBatch';
  batch_id?: Maybe<Scalars['String']>;
  batch_name?: Maybe<Scalars['String']>;
  domain_count?: Maybe<Scalars['Int']>;
  relative_link_to_batch_result?: Maybe<Scalars['String']>;
  run_date?: Maybe<Scalars['String']>;
  user?: Maybe<Scalars['String']>;
};

export type ProspectScoringBatchesResponse = {
  __typename?: 'ProspectScoringBatchesResponse';
  data?: Maybe<Array<Maybe<ProspectScoringBatch>>>;
};

export type ProspectScoringJob = {
  __typename?: 'ProspectScoringJob';
  batch_id?: Maybe<Scalars['String']>;
  complete_date?: Maybe<Scalars['String']>;
  create_date?: Maybe<Scalars['String']>;
  document_job_ids?: Maybe<Array<Maybe<Scalars['String']>>>;
  domain_count?: Maybe<Scalars['Int']>;
  job_id?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  vendor_id?: Maybe<Scalars['String']>;
};

export type ProspectScoringJobResponse = {
  __typename?: 'ProspectScoringJobResponse';
  data?: Maybe<Array<Maybe<ProspectScoringJob>>>;
};

export type ProspectScoringResult = {
  __typename?: 'ProspectScoringResult';
  company_name?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  newHighs?: Maybe<NewHighsForAccountScore>;
  offerCount?: Maybe<Scalars['Int']>;
  offers?: Maybe<Array<Maybe<OfferSummaryForProspectDomain>>>;
  primary_industry?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  revenue_band?: Maybe<Scalars['String']>;
  score_aws?: Maybe<Scalars['String']>;
  score_azure?: Maybe<Scalars['String']>;
  score_gcp?: Maybe<Scalars['String']>;
};

export type ProspectScoringResultResponse = {
  __typename?: 'ProspectScoringResultResponse';
  data?: Maybe<Array<Maybe<ProspectScoringResult>>>;
};

export type ProspectSignedUrl = {
  __typename?: 'ProspectSignedUrl';
  batch_metadata?: Maybe<ProspectScoringBatch>;
  expires_in?: Maybe<Scalars['Int']>;
  s3_key?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  use?: Maybe<Scalars['String']>;
};

export type ProspectSignedUrlResponse = {
  __typename?: 'ProspectSignedUrlResponse';
  data?: Maybe<ProspectSignedUrl>;
};

export type ProspectVertical = ProductVertical & {
  __typename?: 'ProspectVertical';
  data: ProspectVerticalData;
  id: ProductVerticalName;
  stage: VerticalStage;
};

export type ProspectVerticalData = {
  __typename?: 'ProspectVerticalData';
  highScoreCount: Scalars['Int'];
};

export type Query = {
  __typename?: 'Query';
  activationDashboard: ActivationDashboard;
  activeContractsSummary?: Maybe<TackleManagedAndNotManagedContractsWithNet>;
  awsListing?: Maybe<AwsListing>;
  awsMarketplaceSaasProducts?: Maybe<Array<AwsMarketplaceSaasProduct>>;
  awsRegistrationToken?: Maybe<Scalars['String']>;
  azureListing?: Maybe<AzureListing>;
  azureMarketplaceSaasProducts?: Maybe<Array<AzureMarketplaceSaasProduct>>;
  bookedRevenue?: Maybe<BookedRevenue>;
  checkEmail: CheckEmailResult;
  coSellAiBusinessProblemDescription?: Maybe<CoSellAiQueryResponse>;
  coSellVendorForAdmin?: Maybe<CoSellVendor>;
  contractFilteringValues?: Maybe<ContractFilterValues>;
  contractSummaries?: Maybe<ContractSummaryResponse>;
  contracts?: Maybe<ContractSearchResponse>;
  contractsExportPresignedUrl?: Maybe<ContractsExportPresignedUrlResponse>;
  currentUser?: Maybe<User>;
  currentVendors?: Maybe<Array<Maybe<Vendor>>>;
  /** This query returns the individual records of a Data Pool with the convenience of built-in pagination, filtering, and sorting. */
  dataGrid: DataGridConnection;
  describeAwsChangeSet?: Maybe<AwsCapiDescribeChangeSetResponse>;
  disbursedRevenue?: Maybe<DisbursedRevenue>;
  disbursements: Array<Maybe<Disbursement>>;
  emailCustomBrands?: Maybe<Array<EmailCustomBrand>>;
  expiringContractsSummary?: Maybe<TackleManagedAndNotManagedContractsWithNet>;
  gcpListing?: Maybe<GcpListing>;
  /**
   * This query returns the Metric specified by the given ID.
   *
   * A Metric is a business indicator measured over time.
   */
  metric?: Maybe<Metric>;
  /**
   * This query returns the Metric specified by the given unique name.
   *
   * A Metric is a business indicator measured over time.
   */
  metricByName?: Maybe<Metric>;
  /**
   * Build a report, or table, consisting of multiple Metrics broken down by one-or-more dimensions.
   *
   * The first few columns of the report are the dimensions you choose to break down by. The subsequent columns are the
   * Metrics you choose to query. By default, the report sorts on the first Metric in descending order, but you can
   * configure this with the `orderByMetric` and `sort` inputs.
   *
   * Finally, reports use [cursor-based pagination](/docs/api/pagination). You can control page size with the `first` and
   * `last` inputs.
   */
  metricReport?: Maybe<MetricReportConnection>;
  orbVendorConfig?: Maybe<OrbVendorConfig>;
  organization?: Maybe<Organization>;
  organizationByVendor?: Maybe<Organization>;
  organizationVendors?: Maybe<OrganizationVendors>;
  organizations?: Maybe<Array<Maybe<Organization>>>;
  pendingPaymentsSummary?: Maybe<TackleManagedAndNotManagedContracts>;
  privateOffers?: Maybe<Array<Maybe<PrivateOffer>>>;
  prospectAutoScoringGetDomainCount: AutoScoringDomainCountResponse;
  prospectAutoScoringGetRules: ProspectAutoScoringRulesResponse;
  prospectAutoScoringOpportunityTypeFilteringValues: OpportunityTypeFilteringValuesResponse;
  prospectAutoScoringSalesStageFilteringValues: SalesStageFilteringValuesResponse;
  prospectCompanyDetails?: Maybe<ProspectCompanyDetailsResponse>;
  prospectDefaultFeatureImportance?: Maybe<ProspectFeatureImportanceResponse>;
  prospectDomainFeatureImportance?: Maybe<ProspectFeatureImportanceResponse>;
  prospectEntitlements: ProspectEntitlementsResponse;
  prospectFilterValues: ProspectFilterValuesResponse;
  prospectHasAgreedToTerms?: Maybe<ProspectHasAgreedToTermsResponse>;
  prospectMissingOpportunities?: Maybe<ProspectMissingOpportunitiesResponse>;
  prospectNewHighsForDomains: ProspectNewHighsResponse;
  prospectOpportunitiesCountByMarketplace?: Maybe<ProspectOpportunitiesCountByMarketplaceResponse>;
  prospectRollupStatistics: ProspectRollupStatisticsResponse;
  prospectRollupStatisticsV2: ProspectRollupStatisticsResponse;
  prospectScoreCrmAccount?: Maybe<ProspectScoreCrmAccount>;
  prospectScoresByVendorIdV2: ProspectApiProspectAccountScoresResponse;
  prospectScoringBatches: ProspectScoringBatchesResponse;
  prospectScoringJob: ProspectScoringJobResponse;
  prospectScoringResult: ProspectScoringResultResponse;
  redHatListing?: Maybe<RedHatListing>;
  role: Role;
  roleDetails: RoleWithDetails;
  roleWithVendorNames?: Maybe<Array<RoleWithVendorNames>>;
  roles?: Maybe<Array<Role>>;
  salesforceConnectionDetails?: Maybe<Array<Maybe<SalesforceConnectionDetailsResponse>>>;
  sfConnectionDetails: SfConnectionDetails;
  /** Query Data Pools using SQL. */
  sqlV1: SqlResponse;
  usageRecords?: Maybe<UsageRecordsResponse>;
  userBillingDetails: UserBillingDetails;
  usersFromOrganization?: Maybe<Array<Maybe<UserFromOrgResult>>>;
  vendor?: Maybe<Vendor>;
  vendorLinkedSandboxes?: Maybe<Array<Maybe<Vendor>>>;
  vendorListingsByChannel?: Maybe<VendorListingsByChannel>;
  vendors?: Maybe<PaginatedVendors>;
};


export type QueryActivationDashboardArgs = {
  hasCoSellAccess?: InputMaybe<Scalars['Boolean']>;
  hasOffersAccess?: InputMaybe<Scalars['Boolean']>;
  hasProspectAccess?: InputMaybe<Scalars['Boolean']>;
  vendorId: Scalars['String'];
};


export type QueryActiveContractsSummaryArgs = {
  query?: InputMaybe<Scalars['JSON']>;
  vendorId: Scalars['String'];
};


export type QueryAwsListingArgs = {
  id: Scalars['ID'];
};


export type QueryAzureListingArgs = {
  id: Scalars['ID'];
};


export type QueryBookedRevenueArgs = {
  endDate: DateDuration;
  periodicInterval: TimeInterval;
  startDate: DateDuration;
};


export type QueryCheckEmailArgs = {
  email: Scalars['String'];
};


export type QueryCoSellAiBusinessProblemDescriptionArgs = {
  buyer_domain: Scalars['String'];
  target_cloud: Scalars['String'];
  vendor_id: Scalars['String'];
};


export type QueryCoSellVendorForAdminArgs = {
  id: Scalars['ID'];
};


export type QueryContractFilteringValuesArgs = {
  vendorId: Scalars['String'];
};


export type QueryContractSummariesArgs = {
  query?: InputMaybe<Scalars['JSON']>;
  vendorId: Scalars['String'];
};


export type QueryContractsArgs = {
  query?: InputMaybe<Scalars['JSON']>;
  searchAfter?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  size?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  vendorId: Scalars['String'];
};


export type QueryContractsExportPresignedUrlArgs = {
  query?: InputMaybe<Scalars['JSON']>;
  vendorId: Scalars['String'];
};


export type QueryDataGridArgs = {
  input: DataGridInput;
};


export type QueryDescribeAwsChangeSetArgs = {
  change_set_id: Scalars['ID'];
  vendor_id: Scalars['ID'];
};


export type QueryDisbursedRevenueArgs = {
  endDate: DateDuration;
  periodicInterval: TimeInterval;
  startDate: DateDuration;
  vendorId: Scalars['String'];
};


export type QueryDisbursementsArgs = {
  endDate: DateDuration;
  startDate: DateDuration;
};


export type QueryExpiringContractsSummaryArgs = {
  query?: InputMaybe<Scalars['JSON']>;
  vendorId: Scalars['String'];
};


export type QueryGcpListingArgs = {
  id: Scalars['ID'];
};


export type QueryMetricArgs = {
  id: Scalars['ID'];
};


export type QueryMetricByNameArgs = {
  uniqueName: Scalars['String'];
};


export type QueryMetricReportArgs = {
  input: MetricReportInput;
};


export type QueryOrbVendorConfigArgs = {
  id: Scalars['ID'];
};


export type QueryOrganizationArgs = {
  organization_id: Scalars['String'];
};


export type QueryOrganizationByVendorArgs = {
  vendor_id: Scalars['String'];
};


export type QueryOrganizationVendorsArgs = {
  organization_id: Scalars['String'];
};


export type QueryPendingPaymentsSummaryArgs = {
  query?: InputMaybe<Scalars['JSON']>;
  vendorId: Scalars['String'];
};


export type QueryProspectAutoScoringGetDomainCountArgs = {
  rules: AllRulesInput;
  vendor_id: Scalars['String'];
};


export type QueryProspectAutoScoringGetRulesArgs = {
  vendor_id: Scalars['String'];
};


export type QueryProspectAutoScoringOpportunityTypeFilteringValuesArgs = {
  vendor_id: Scalars['String'];
};


export type QueryProspectAutoScoringSalesStageFilteringValuesArgs = {
  vendor_id: Scalars['String'];
};


export type QueryProspectCompanyDetailsArgs = {
  domain: Scalars['String'];
  vendor_id: Scalars['String'];
};


export type QueryProspectDefaultFeatureImportanceArgs = {
  cloud: Scalars['String'];
  vendor_id: Scalars['String'];
};


export type QueryProspectDomainFeatureImportanceArgs = {
  cloud: Scalars['String'];
  domain: Scalars['String'];
  vendor_id: Scalars['String'];
};


export type QueryProspectEntitlementsArgs = {
  vendor_id: Scalars['String'];
};


export type QueryProspectFilterValuesArgs = {
  vendor_id: Scalars['String'];
};


export type QueryProspectHasAgreedToTermsArgs = {
  vendor_id: Scalars['String'];
};


export type QueryProspectMissingOpportunitiesArgs = {
  vendor_id: Scalars['String'];
};


export type QueryProspectNewHighsForDomainsArgs = {
  domains?: InputMaybe<Array<Scalars['String']>>;
  vendor_id: Scalars['String'];
};


export type QueryProspectOpportunitiesCountByMarketplaceArgs = {
  vendor_id: Scalars['String'];
};


export type QueryProspectRollupStatisticsArgs = {
  vendor_id: Scalars['String'];
};


export type QueryProspectRollupStatisticsV2Args = {
  data: FilterProspectAccountsInput;
};


export type QueryProspectScoreCrmAccountArgs = {
  crm_id: Scalars['String'];
  vendor_id: Scalars['String'];
};


export type QueryProspectScoresByVendorIdV2Args = {
  data: FilterProspectAccountsInput;
};


export type QueryProspectScoringBatchesArgs = {
  vendor_id: Scalars['String'];
};


export type QueryProspectScoringJobArgs = {
  batch_id?: InputMaybe<Scalars['String']>;
  vendor_id: Scalars['String'];
};


export type QueryProspectScoringResultArgs = {
  batch_id: Scalars['String'];
  vendor_id: Scalars['String'];
};


export type QueryRedHatListingArgs = {
  id: Scalars['ID'];
};


export type QueryRoleArgs = {
  id: Scalars['String'];
};


export type QueryRoleDetailsArgs = {
  id: Scalars['String'];
};


export type QuerySqlV1Args = {
  input: SqlV1Input;
};


export type QueryUsageRecordsArgs = {
  customerId: Scalars['String'];
  page?: InputMaybe<Scalars['Int']>;
  productId: Scalars['String'];
  size?: InputMaybe<Scalars['Int']>;
};


export type QueryUsersFromOrganizationArgs = {
  organizationId: Scalars['String'];
};


export type QueryVendorArgs = {
  id: Scalars['ID'];
};


export type QueryVendorLinkedSandboxesArgs = {
  id: Scalars['ID'];
};


export type QueryVendorListingsByChannelArgs = {
  id: Scalars['ID'];
};


export type QueryVendorsArgs = {
  pageSize?: InputMaybe<Scalars['Int']>;
  pageToken?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};

/** The Query Info object. It contains metadata and statistics about a Query performed. */
export type QueryInfo = {
  __typename?: 'QueryInfo';
  /** If the Query was boosted, the Booster that was used. */
  booster?: Maybe<Booster>;
  /** The bytes processed by the Query. */
  bytesProcessed: Scalars['String'];
  /** The date and time in UTC when the Query was created. */
  createdAt: Scalars['DateTime'];
  /** The unique identifier of the actor that performed the Query. */
  createdBy: Scalars['String'];
  /** The duration of the Query in milliseconds. */
  durationInMilliseconds: Scalars['Int'];
  /** The Query's unique identifier. */
  id: Scalars['ID'];
  /** The date and time in UTC when the Query was last modified. */
  modifiedAt: Scalars['DateTime'];
  /** The unique identifier of the actor that modified the Query. */
  modifiedBy: Scalars['String'];
  /** The Propeller used for this query. */
  propeller?: Maybe<Propeller>;
  /** The number of records processed by the Query. */
  recordsProcessed: Scalars['String'];
  /** The bytes returned by the Query. */
  resultingBytes: Scalars['Int'];
  /** The number of records returned by the Query. */
  resultingRecords: Scalars['Int'];
  /** The Query status. */
  status: QueryStatus;
  /** The Query subtype. */
  subtype?: Maybe<QuerySubtype>;
  /** The Query type. */
  type: QueryType;
};

/** The Query status. */
export const QueryStatus = {
  /** The Query was completed succesfully. */
  Completed: 'COMPLETED',
  /** The Query experienced an error. */
  Error: 'ERROR',
  /** The Query timed out. */
  TimedOut: 'TIMED_OUT'
} as const;

export type QueryStatus = typeof QueryStatus[keyof typeof QueryStatus];
/** The Query subtype. */
export const QuerySubtype = {
  /** Indicates a Metric counter Query. */
  Counter: 'COUNTER',
  /** Indicates a Metric leaderboard Query. */
  Leaderboard: 'LEADERBOARD',
  /** Indicates a Metric time series Query. */
  TimeSeries: 'TIME_SERIES'
} as const;

export type QuerySubtype = typeof QuerySubtype[keyof typeof QuerySubtype];
/** The Query type. */
export const QueryType = {
  /** Indicates a Metric Query. */
  Metric: 'METRIC',
  /** Indicates a Record Table Query. */
  Records: 'RECORDS',
  /** Indicates records queried by unique ID. */
  RecordsByUniqueId: 'RECORDS_BY_UNIQUE_ID',
  /** Indicates a Report Query. */
  Report: 'REPORT',
  /** Indicates a SelectV1 Query. */
  Select: 'SELECT',
  /** Indicates a SQL Query. */
  Sql: 'SQL',
  /** Indicates a Dimension Stats Query. */
  Stats: 'STATS',
  /** Indicates a Top Values Query. */
  TopValues: 'TOP_VALUES'
} as const;

export type QueryType = typeof QueryType[keyof typeof QueryType];
export type RedHatCallbackAuthentication = {
  __typename?: 'RedHatCallbackAuthentication';
  api_key?: Maybe<Scalars['String']>;
  auth_header_name?: Maybe<Scalars['String']>;
  auth_type?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

export type RedHatCallbackAuthenticationInput = {
  api_key?: InputMaybe<Scalars['String']>;
  auth_header_name?: InputMaybe<Scalars['String']>;
  auth_type?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
};

export type RedHatCallbackConfig = {
  __typename?: 'RedHatCallbackConfig';
  authentication?: Maybe<RedHatCallbackAuthentication>;
  send_email?: Maybe<Scalars['Boolean']>;
  supported_clouds?: Maybe<Array<RedHatCallbackConfigSupportedCloudsItem>>;
  url?: Maybe<Scalars['String']>;
};

export type RedHatCallbackConfigInput = {
  authentication?: InputMaybe<RedHatCallbackAuthenticationInput>;
  send_email?: InputMaybe<Scalars['Boolean']>;
  supported_clouds?: InputMaybe<Array<RedHatCallbackConfigSupportedCloudsItem>>;
  url?: InputMaybe<Scalars['String']>;
};

export const RedHatCallbackConfigSupportedCloudsItem = {
  Aws: 'aws',
  Azure: 'azure',
  Gcp: 'gcp',
  Redhat: 'redhat'
} as const;

export type RedHatCallbackConfigSupportedCloudsItem = typeof RedHatCallbackConfigSupportedCloudsItem[keyof typeof RedHatCallbackConfigSupportedCloudsItem];
export type RedHatCompanyDetail = {
  __typename?: 'RedHatCompanyDetail';
  logo?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  website_url?: Maybe<Scalars['String']>;
};

export type RedHatCompanyDetailInput = {
  logo?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  website_url?: InputMaybe<Scalars['String']>;
};

export type RedHatCustomTemplateIds = {
  __typename?: 'RedHatCustomTemplateIds';
  tackle_template_id?: Maybe<Scalars['Float']>;
  vendor_template_id?: Maybe<Scalars['Float']>;
};

export type RedHatCustomTemplateIdsInput = {
  tackle_template_id?: InputMaybe<Scalars['Float']>;
  vendor_template_id?: InputMaybe<Scalars['Float']>;
};

export type RedHatDimension = {
  __typename?: 'RedHatDimension';
  dimension?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
};

export type RedHatDimensionInput = {
  dimension: Scalars['String'];
  value: Scalars['Float'];
};

export type RedHatEmailsConfig = {
  __typename?: 'RedHatEmailsConfig';
  custom_template_ids?: Maybe<Array<RedHatCustomTemplateIds>>;
  default_cc?: Maybe<Scalars['String']>;
  default_from?: Maybe<Scalars['String']>;
};

export type RedHatEmailsConfigInput = {
  custom_template_ids?: InputMaybe<Array<RedHatCustomTemplateIdsInput>>;
  default_cc?: InputMaybe<Scalars['String']>;
  default_from?: InputMaybe<Scalars['String']>;
};

export type RedHatFaqItem = {
  __typename?: 'RedHatFaqItem';
  answer?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  question?: Maybe<Scalars['String']>;
};

export type RedHatFaqItemInput = {
  answer?: InputMaybe<Scalars['String']>;
  link?: InputMaybe<Scalars['String']>;
  question?: InputMaybe<Scalars['String']>;
};

export type RedHatFeatureItem = {
  __typename?: 'RedHatFeatureItem';
  description?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type RedHatFeatureItemInput = {
  description?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type RedHatImage = {
  __typename?: 'RedHatImage';
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type RedHatImageInput = {
  title?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type RedHatListing = {
  __typename?: 'RedHatListing';
  callback?: Maybe<RedHatCallbackConfig>;
  categories?: Maybe<Array<Scalars['String']>>;
  company?: Maybe<RedHatCompanyDetail>;
  configuration_url?: Maybe<Scalars['String']>;
  contact_email?: Maybe<Scalars['String']>;
  contact_support_url?: Maybe<Scalars['String']>;
  contract_standard_fields?: Maybe<Array<RedHatPrivateOfferMetadataStandardField>>;
  created_at?: Maybe<Scalars['String']>;
  created_by_email?: Maybe<Scalars['String']>;
  details?: Maybe<RedHatListingDetails>;
  dimensions?: Maybe<Array<RedHatDimension>>;
  emails?: Maybe<RedHatEmailsConfig>;
  experimental_example?: Maybe<Scalars['Boolean']>;
  experimental_salesforce_private_offers_connector?: Maybe<Scalars['Boolean']>;
  faq_url?: Maybe<Scalars['String']>;
  faqs?: Maybe<Array<RedHatFaqItem>>;
  full_description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  images?: Maybe<Array<RedHatImage>>;
  last_modified_at?: Maybe<Scalars['String']>;
  last_modified_by_email?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  marketplace_id?: Maybe<Scalars['String']>;
  marketplace_url?: Maybe<Scalars['String']>;
  metering_enabled?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  offers?: Maybe<Array<RedHatOffer>>;
  packages?: Maybe<Array<Scalars['String']>>;
  pricing?: Maybe<RedHatPricing>;
  product_readme?: Maybe<Scalars['String']>;
  quickstart_url?: Maybe<Scalars['String']>;
  readme_url?: Maybe<Scalars['String']>;
  /** super admin only */
  red_hat_password?: Maybe<Scalars['String']>;
  /** super admin only */
  red_hat_username?: Maybe<Scalars['String']>;
  registration?: Maybe<RedHatRegistration>;
  registration_message?: Maybe<Scalars['String']>;
  registration_page_fields?: Maybe<Array<RedHatRegistrationField>>;
  registration_redirect?: Maybe<RedHatRegistrationRedirect>;
  revision_of_listing?: Maybe<RedHatListing>;
  revision_of_product_id_internal?: Maybe<Scalars['String']>;
  search_keywords?: Maybe<Scalars['String']>;
  send_customer_email?: Maybe<Scalars['Boolean']>;
  short_description?: Maybe<Scalars['String']>;
  should_sync_listing_to_salesforce_app?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['String']>;
  support?: Maybe<RedHatSupport>;
  troubleshooting_url?: Maybe<Scalars['String']>;
  vendor?: Maybe<Vendor>;
  vendorid?: Maybe<Scalars['String']>;
  videos?: Maybe<Array<RedHatVideo>>;
};

export type RedHatListingDetails = {
  __typename?: 'RedHatListingDetails';
  categories?: Maybe<Array<Scalars['String']>>;
  features?: Maybe<Array<RedHatFeatureItem>>;
  license_agreement_url?: Maybe<Scalars['String']>;
};

export type RedHatListingDetailsInput = {
  categories?: InputMaybe<Array<Scalars['String']>>;
  features?: InputMaybe<Array<RedHatFeatureItemInput>>;
  license_agreement_url?: InputMaybe<Scalars['String']>;
};

export type RedHatListingInput = {
  callback?: InputMaybe<RedHatCallbackConfigInput>;
  categories?: InputMaybe<Array<Scalars['String']>>;
  company?: InputMaybe<RedHatCompanyDetailInput>;
  configuration_url?: InputMaybe<Scalars['String']>;
  contact_email?: InputMaybe<Scalars['String']>;
  contact_support_url?: InputMaybe<Scalars['String']>;
  contract_standard_fields?: InputMaybe<Array<RedHatPrivateOfferMetadataStandardFieldInput>>;
  details?: InputMaybe<RedHatListingDetailsInput>;
  dimensions?: InputMaybe<Array<RedHatDimensionInput>>;
  emails?: InputMaybe<RedHatEmailsConfigInput>;
  experimental_example?: InputMaybe<Scalars['Boolean']>;
  experimental_salesforce_private_offers_connector?: InputMaybe<Scalars['Boolean']>;
  faq_url?: InputMaybe<Scalars['String']>;
  faqs?: InputMaybe<Array<RedHatFaqItemInput>>;
  full_description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  images?: InputMaybe<Array<RedHatImageInput>>;
  logo?: InputMaybe<Scalars['String']>;
  /** super admin only */
  marketplace_id?: InputMaybe<Scalars['String']>;
  marketplace_url?: InputMaybe<Scalars['String']>;
  metering_enabled?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  offers?: InputMaybe<Array<RedHatOfferInput>>;
  packages?: InputMaybe<Array<Scalars['String']>>;
  pricing?: InputMaybe<RedHatPricingInput>;
  product_readme?: InputMaybe<Scalars['String']>;
  quickstart_url?: InputMaybe<Scalars['String']>;
  readme_url?: InputMaybe<Scalars['String']>;
  /** super admin only */
  red_hat_password?: InputMaybe<Scalars['String']>;
  /** super admin only */
  red_hat_username?: InputMaybe<Scalars['String']>;
  registration?: InputMaybe<RedHatRegistrationInput>;
  registration_message?: InputMaybe<Scalars['String']>;
  registration_page_fields?: InputMaybe<Array<RedHatRegistrationFieldInput>>;
  registration_redirect?: InputMaybe<RedHatRegistrationRedirectInput>;
  search_keywords?: InputMaybe<Scalars['String']>;
  send_customer_email?: InputMaybe<Scalars['Boolean']>;
  short_description?: InputMaybe<Scalars['String']>;
  should_sync_listing_to_salesforce_app?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Scalars['String']>;
  support?: InputMaybe<RedHatSupportInput>;
  troubleshooting_url?: InputMaybe<Scalars['String']>;
  vendorid?: InputMaybe<Scalars['String']>;
  videos?: InputMaybe<Array<RedHatVideoInput>>;
};

export type RedHatOffer = {
  __typename?: 'RedHatOffer';
  offer_type?: Maybe<RedHatOfferOfferType>;
  offerid?: Maybe<Scalars['String']>;
  pricing?: Maybe<Array<RedHatDimension>>;
};

export type RedHatOfferInput = {
  offer_type?: InputMaybe<RedHatOfferOfferType>;
  offerid: Scalars['String'];
  pricing?: InputMaybe<Array<RedHatDimensionInput>>;
};

export const RedHatOfferOfferType = {
  Private: 'private',
  Public: 'public'
} as const;

export type RedHatOfferOfferType = typeof RedHatOfferOfferType[keyof typeof RedHatOfferOfferType];
export type RedHatPricing = {
  __typename?: 'RedHatPricing';
  ECCN?: Maybe<Scalars['String']>;
  ECCN2?: Maybe<Scalars['String']>;
  UNSPSC?: Maybe<Scalars['String']>;
  editions?: Maybe<Array<RedHatPricingEdition>>;
  geographies?: Maybe<Array<Scalars['String']>>;
};

export type RedHatPricingEdition = {
  __typename?: 'RedHatPricingEdition';
  allow_auto_renew?: Maybe<Scalars['Boolean']>;
  audience?: Maybe<RedHatPricingEditionAudience>;
  billing_frequency?: Maybe<Array<RedHatPricingEditionBillingFrequencyItem>>;
  commerce_model?: Maybe<Scalars['String']>;
  delivery_method?: Maybe<RedHatPricingEditionDeliveryMethod>;
  description?: Maybe<Scalars['String']>;
  details?: Maybe<Array<Scalars['String']>>;
  edition_charges?: Maybe<Array<RedHatPricingEditionCharge>>;
  grace_period?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['String']>;
  launch_url?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  subscription_terms_in_months?: Maybe<Array<Scalars['String']>>;
  trial_length?: Maybe<Scalars['Float']>;
  vendor_chargeid?: Maybe<Scalars['String']>;
};

export const RedHatPricingEditionAudience = {
  Private: 'Private',
  Public: 'Public'
} as const;

export type RedHatPricingEditionAudience = typeof RedHatPricingEditionAudience[keyof typeof RedHatPricingEditionAudience];
export const RedHatPricingEditionBillingFrequencyItem = {
  Annual: 'annual',
  Monthly: 'monthly',
  Quarterly: 'quarterly'
} as const;

export type RedHatPricingEditionBillingFrequencyItem = typeof RedHatPricingEditionBillingFrequencyItem[keyof typeof RedHatPricingEditionBillingFrequencyItem];
export type RedHatPricingEditionCharge = {
  __typename?: 'RedHatPricingEditionCharge';
  charge_type?: Maybe<RedHatPricingEditionChargeChargeType>;
  include_in_starting_price?: Maybe<Scalars['Boolean']>;
  increment?: Maybe<Scalars['String']>;
  maximum_quantity?: Maybe<Scalars['Int']>;
  minimum_quantity?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  name_description?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  price_frequency?: Maybe<RedHatPricingEditionChargePriceFrequency>;
  price_type?: Maybe<Scalars['String']>;
  required?: Maybe<Scalars['Boolean']>;
  sequence?: Maybe<Scalars['String']>;
  unit_of_measure?: Maybe<Scalars['String']>;
  usage_reportingid?: Maybe<Scalars['String']>;
  vendor_chargeid?: Maybe<Scalars['String']>;
};

export const RedHatPricingEditionChargeChargeType = {
  Recurring: 'recurring',
  Usage: 'usage'
} as const;

export type RedHatPricingEditionChargeChargeType = typeof RedHatPricingEditionChargeChargeType[keyof typeof RedHatPricingEditionChargeChargeType];
export type RedHatPricingEditionChargeInput = {
  charge_type?: InputMaybe<RedHatPricingEditionChargeChargeType>;
  include_in_starting_price?: InputMaybe<Scalars['Boolean']>;
  increment?: InputMaybe<Scalars['String']>;
  maximum_quantity?: InputMaybe<Scalars['Int']>;
  minimum_quantity?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  name_description?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
  price_frequency?: InputMaybe<RedHatPricingEditionChargePriceFrequency>;
  price_type?: InputMaybe<Scalars['String']>;
  required?: InputMaybe<Scalars['Boolean']>;
  sequence?: InputMaybe<Scalars['String']>;
  unit_of_measure?: InputMaybe<Scalars['String']>;
  usage_reportingid?: InputMaybe<Scalars['String']>;
  vendor_chargeid?: InputMaybe<Scalars['String']>;
};

export const RedHatPricingEditionChargePriceFrequency = {
  Annual: 'annual',
  Monthly: 'monthly'
} as const;

export type RedHatPricingEditionChargePriceFrequency = typeof RedHatPricingEditionChargePriceFrequency[keyof typeof RedHatPricingEditionChargePriceFrequency];
export const RedHatPricingEditionDeliveryMethod = {
  SaaS: 'SaaS'
} as const;

export type RedHatPricingEditionDeliveryMethod = typeof RedHatPricingEditionDeliveryMethod[keyof typeof RedHatPricingEditionDeliveryMethod];
export type RedHatPricingEditionInput = {
  allow_auto_renew?: InputMaybe<Scalars['Boolean']>;
  audience?: InputMaybe<RedHatPricingEditionAudience>;
  billing_frequency?: InputMaybe<Array<RedHatPricingEditionBillingFrequencyItem>>;
  commerce_model?: InputMaybe<Scalars['String']>;
  delivery_method?: InputMaybe<RedHatPricingEditionDeliveryMethod>;
  description?: InputMaybe<Scalars['String']>;
  details?: InputMaybe<Array<Scalars['String']>>;
  edition_charges?: InputMaybe<Array<RedHatPricingEditionChargeInput>>;
  grace_period?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['String']>;
  launch_url?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  subscription_terms_in_months?: InputMaybe<Array<Scalars['String']>>;
  trial_length?: InputMaybe<Scalars['Float']>;
  vendor_chargeid?: InputMaybe<Scalars['String']>;
};

export type RedHatPricingInput = {
  ECCN?: InputMaybe<Scalars['String']>;
  ECCN2?: InputMaybe<Scalars['String']>;
  UNSPSC?: InputMaybe<Scalars['String']>;
  editions?: InputMaybe<Array<RedHatPricingEditionInput>>;
  geographies?: InputMaybe<Array<Scalars['String']>>;
};

export type RedHatPrivateOfferMetadataStandardField = {
  __typename?: 'RedHatPrivateOfferMetadataStandardField';
  cloud_field?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
};

export type RedHatPrivateOfferMetadataStandardFieldInput = {
  cloud_field?: InputMaybe<Scalars['Boolean']>;
  title: Scalars['String'];
};

export type RedHatRegistration = {
  __typename?: 'RedHatRegistration';
  form?: Maybe<RedHatRegistrationForm>;
  hero?: Maybe<RedHatRegistrationHero>;
  success?: Maybe<RedHatRegistrationSuccess>;
};

export type RedHatRegistrationField = {
  __typename?: 'RedHatRegistrationField';
  data_type?: Maybe<Scalars['String']>;
  default?: Maybe<Scalars['Boolean']>;
  display_title?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  options?: Maybe<Array<RedHatRegistrationFieldOptions>>;
  required?: Maybe<Scalars['Boolean']>;
  tackle_required?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  validation_type?: Maybe<RedHatRegistrationFieldValidationType>;
};

export type RedHatRegistrationFieldInput = {
  data_type?: InputMaybe<Scalars['String']>;
  default?: InputMaybe<Scalars['Boolean']>;
  display_title: Scalars['String'];
  enabled?: InputMaybe<Scalars['Boolean']>;
  options?: InputMaybe<Array<RedHatRegistrationFieldOptionsInput>>;
  required?: InputMaybe<Scalars['Boolean']>;
  tackle_required?: InputMaybe<Scalars['Boolean']>;
  title: Scalars['String'];
  validation_type?: InputMaybe<RedHatRegistrationFieldValidationType>;
};

export type RedHatRegistrationFieldOptions = {
  __typename?: 'RedHatRegistrationFieldOptions';
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type RedHatRegistrationFieldOptionsInput = {
  label: Scalars['String'];
  value: Scalars['String'];
};

export const RedHatRegistrationFieldValidationType = {
  Email: 'email'
} as const;

export type RedHatRegistrationFieldValidationType = typeof RedHatRegistrationFieldValidationType[keyof typeof RedHatRegistrationFieldValidationType];
export type RedHatRegistrationForm = {
  __typename?: 'RedHatRegistrationForm';
  button?: Maybe<RedHatRegistrationFormButton>;
  logo_url?: Maybe<Scalars['String']>;
};

export type RedHatRegistrationFormButton = {
  __typename?: 'RedHatRegistrationFormButton';
  background_color?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
};

export type RedHatRegistrationFormButtonInput = {
  background_color?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
};

export type RedHatRegistrationFormInput = {
  button?: InputMaybe<RedHatRegistrationFormButtonInput>;
  logo_url?: InputMaybe<Scalars['String']>;
};

export type RedHatRegistrationHero = {
  __typename?: 'RedHatRegistrationHero';
  background_color?: Maybe<Scalars['String']>;
  background_image_url?: Maybe<Scalars['String']>;
};

export type RedHatRegistrationHeroInput = {
  background_color?: InputMaybe<Scalars['String']>;
  background_image_url?: InputMaybe<Scalars['String']>;
};

export type RedHatRegistrationInput = {
  form?: InputMaybe<RedHatRegistrationFormInput>;
  hero?: InputMaybe<RedHatRegistrationHeroInput>;
  success?: InputMaybe<RedHatRegistrationSuccessInput>;
};

export type RedHatRegistrationRedirect = {
  __typename?: 'RedHatRegistrationRedirect';
  url?: Maybe<Scalars['String']>;
};

export type RedHatRegistrationRedirectInput = {
  url: Scalars['String'];
};

export type RedHatRegistrationSuccess = {
  __typename?: 'RedHatRegistrationSuccess';
  message?: Maybe<Scalars['String']>;
  redirect_url?: Maybe<Scalars['String']>;
};

export type RedHatRegistrationSuccessInput = {
  message?: InputMaybe<Scalars['String']>;
  redirect_url?: InputMaybe<Scalars['String']>;
};

export type RedHatSupport = {
  __typename?: 'RedHatSupport';
  contact?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  items?: Maybe<Array<RedHatSupportItem>>;
  privacy_policy_link?: Maybe<Scalars['String']>;
  resources?: Maybe<Scalars['String']>;
  support_url?: Maybe<Scalars['String']>;
};

export type RedHatSupportInput = {
  contact?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  items?: InputMaybe<Array<RedHatSupportItemInput>>;
  privacy_policy_link?: InputMaybe<Scalars['String']>;
  resources?: InputMaybe<Scalars['String']>;
  support_url?: InputMaybe<Scalars['String']>;
};

export type RedHatSupportItem = {
  __typename?: 'RedHatSupportItem';
  description?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type RedHatSupportItemInput = {
  description?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type RedHatVideo = {
  __typename?: 'RedHatVideo';
  thumbnail_url?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type RedHatVideoInput = {
  thumbnail_url?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type RegistrationDetails = {
  __typename?: 'RegistrationDetails';
  createdAt?: Maybe<Scalars['String']>;
  errorCode?: Maybe<Scalars['String']>;
  errorMessage?: Maybe<Scalars['String']>;
  instanceUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationDetails>;
  packageVersion?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  tackleOrgId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  user?: Maybe<UserDetails>;
  vendorId?: Maybe<Scalars['String']>;
};

export type RegistrationOrgDetails = {
  __typename?: 'RegistrationOrgDetails';
  isSandbox?: Maybe<Scalars['Boolean']>;
  organizationId?: Maybe<Scalars['String']>;
};

/**
 * The Relative time ranges are based on the current date and time.
 *
 * `THIS` - The current unit of time. For example, if today is June 8, 2022, and
 * `THIS_MONTH` is selected, then data for June 2022 would be returned.
 *
 * `PREVIOUS` - The previous unit of time. For example, if today is June 8, 2022, and
 * `PREVIOUS_MONTH` is selected, then data for May 2022 would be returned. It excludes
 * the current unit of time.
 *
 * `NEXT` - The next unit of time. For example, if today is June 8, 2022, and
 * `NEXT_MONTH` is selected, then data for July 2022 would be returned. It excludes
 * the current unit of time.
 *
 * `LAST_N` - The last `n` units of time, including the current one. For example, if today
 * is June 8, 2022 and `LAST_N_YEARS` with `n` = 3 is selected, then data for 2020, 2021, and
 * 2022 will be returned. It will include the current time period.
 */
export const RelativeTimeRange = {
  Last_2Years: 'LAST_2_YEARS',
  Last_3Months: 'LAST_3_MONTHS',
  Last_4Hours: 'LAST_4_HOURS',
  Last_5Years: 'LAST_5_YEARS',
  Last_6Months: 'LAST_6_MONTHS',
  Last_7Days: 'LAST_7_DAYS',
  Last_12Hours: 'LAST_12_HOURS',
  Last_15Minutes: 'LAST_15_MINUTES',
  Last_24Hours: 'LAST_24_HOURS',
  Last_30Days: 'LAST_30_DAYS',
  Last_30Minutes: 'LAST_30_MINUTES',
  Last_90Days: 'LAST_90_DAYS',
  LastHour: 'LAST_HOUR',
  /** Starts at 12:00:00 AM, `n` - 1 day(s) before the current day, and continues through the current day. It includes today. */
  LastNDays: 'LAST_N_DAYS',
  /** Starts at the zeroth minute of the `n` - 1 hour(s) before the current hour, and continues through the current hour. It includes this hour. */
  LastNHours: 'LAST_N_HOURS',
  /** Starts at the zeroth second `n` - 1 minute(s) before the current minute and continues through the current minute. It includes this minute. */
  LastNMinutes: 'LAST_N_MINUTES',
  /** Starts at 12:00:00 AM on the first day of the month, `n` - 1 month(s) before the current month, and continues through the current month. It includes this month. */
  LastNMonths: 'LAST_N_MONTHS',
  /** Starts at 12:00:00 AM on the first day of the calendar quarter `n` - 1 quarter(s) before the current quarter and continues through the current quarter. It includes this quarter. */
  LastNQuarters: 'LAST_N_QUARTERS',
  /** Starts on Monday, 12:00:00 AM, `n` - 1 week(s) before the current week, and continues through the current week. It includes this week. */
  LastNWeeks: 'LAST_N_WEEKS',
  /** Starts on January 1st, 12:00:00 AM of the year `n` - 1 year(s) before the current year and continues through the current year. It includes this year. */
  LastNYears: 'LAST_N_YEARS',
  LastYear: 'LAST_YEAR',
  /** Starts at the zeroth minute of the next hour and continues for 60 minutes. */
  NextHour: 'NEXT_HOUR',
  /** Starts at 12:00:00 AM on the first day of the next month and continues for the duration of the month. */
  NextMonth: 'NEXT_MONTH',
  /** Starts at 12:00:00 AM on the first day of the next calendar quarter and continues for the duration of the quarter. */
  NextQuarter: 'NEXT_QUARTER',
  /** Starts on Monday, 12:00:00 AM, the week after the current week, and continues for the duration of the week. */
  NextWeek: 'NEXT_WEEK',
  /** Starts on January 1st, 12:00:00 AM of the next year and continues for the duration of the year. */
  NextYear: 'NEXT_YEAR',
  /** Starts at the zeroth minute of the previous hour and continues for 60 minutes. */
  PreviousHour: 'PREVIOUS_HOUR',
  /** Starts at 12:00:00 AM on the first day of the month before the current month and continues for the duration of the month. */
  PreviousMonth: 'PREVIOUS_MONTH',
  /** Starts at 12:00:00 AM on the first day of the calendar quarter before the current quarter and continues for the duration of the quarter. */
  PreviousQuarter: 'PREVIOUS_QUARTER',
  /** Starts on Monday, 12:00:00 AM, a week before the current week, and continues for seven days. */
  PreviousWeek: 'PREVIOUS_WEEK',
  /** Starts on January 1st, 12:00:00 AM, the year before the current year, and continues for the duration of the year. */
  PreviousYear: 'PREVIOUS_YEAR',
  /** Starts at the zeroth minute of the current hour and continues for 60 minutes. */
  ThisHour: 'THIS_HOUR',
  /** Starts at 12:00:00 AM on the first day of the current month and continues for the duration of the month. */
  ThisMonth: 'THIS_MONTH',
  /** Starts at 12:00:00 AM on the first day of the current calendar quarter and continues for the duration of the quarter. */
  ThisQuarter: 'THIS_QUARTER',
  /** Starts on Monday, 12:00:00 AM of the current week and continues for seven days. */
  ThisWeek: 'THIS_WEEK',
  /** Starts on January 1st, 12:00:00 AM of the current year and continues for the duration of the year. */
  ThisYear: 'THIS_YEAR',
  /** Starts at 12:00:00 AM of the current day and continues for 24 hours. */
  Today: 'TODAY',
  /** " Starts at 12:00:00 AM, the day after the current day, and continues for 24 hours. */
  Tomorrow: 'TOMORROW',
  /** Starts at 12:00:00 AM on the day before the today and continues for 24 hours. */
  Yesterday: 'YESTERDAY'
} as const;

export type RelativeTimeRange = typeof RelativeTimeRange[keyof typeof RelativeTimeRange];
/** Parameters for the ReplacingMergeTree table engine. */
export type ReplacingMergeTreeTableEngine = HasTableEngineType & {
  __typename?: 'ReplacingMergeTreeTableEngine';
  /** The type is always `REPLACING_MERGE_TREE`. */
  type: TableEngineType;
  /** The `ver` parameter to the ReplacingMergeTree engine. */
  ver?: Maybe<Scalars['String']>;
};

export type Role = {
  __typename?: 'Role';
  allowed_vendors?: Maybe<Array<Scalars['String']>>;
  built_in: Scalars['Boolean'];
  created_at: Scalars['String'];
  global: Scalars['Boolean'];
  id: Scalars['String'];
  name: Scalars['String'];
  organization_id: Scalars['String'];
  permissions?: Maybe<Array<Scalars['String']>>;
  updated_at: Scalars['String'];
};

export type RoleInput = {
  allowed_vendors?: InputMaybe<Array<Scalars['String']>>;
  global?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  permissions?: InputMaybe<Array<Scalars['String']>>;
};

export type RoleWithDetails = {
  __typename?: 'RoleWithDetails';
  allowed_vendors?: Maybe<Array<Scalars['String']>>;
  built_in: Scalars['Boolean'];
  created_at: Scalars['String'];
  global: Scalars['Boolean'];
  id: Scalars['String'];
  in_use: Scalars['Boolean'];
  in_use_count: Scalars['Int'];
  name: Scalars['String'];
  organization_id: Scalars['String'];
  permissions?: Maybe<Array<Scalars['String']>>;
  updated_at: Scalars['String'];
};

export type RoleWithVendorNames = {
  __typename?: 'RoleWithVendorNames';
  allowed_vendors?: Maybe<Array<Scalars['String']>>;
  allowed_vendors_names?: Maybe<Array<Scalars['String']>>;
  built_in: Scalars['Boolean'];
  created_at: Scalars['String'];
  global: Scalars['Boolean'];
  id: Scalars['String'];
  name: Scalars['String'];
  organization_id: Scalars['String'];
  permissions?: Maybe<Array<Scalars['String']>>;
  updated_at: Scalars['String'];
};

export type RuleSet = {
  __typename?: 'RuleSet';
  active: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  pk?: Maybe<Scalars['String']>;
  ruleSetId?: Maybe<Scalars['String']>;
  sk?: Maybe<Scalars['String']>;
  vendorId: Scalars['String'];
  visible: Scalars['Boolean'];
};

export type RuleSetInput = {
  active: Scalars['Boolean'];
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  pk?: InputMaybe<Scalars['String']>;
  ruleSetId?: InputMaybe<Scalars['String']>;
  rules: AllRulesInput;
  sk?: InputMaybe<Scalars['String']>;
  visible: Scalars['Boolean'];
};

export type RuleSetWithRules = {
  __typename?: 'RuleSetWithRules';
  active: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  pk?: Maybe<Scalars['String']>;
  ruleSetId?: Maybe<Scalars['String']>;
  rules?: Maybe<Array<AllRules>>;
  sk?: Maybe<Scalars['String']>;
  vendorId: Scalars['String'];
  visible: Scalars['Boolean'];
};

export const RuleType = {
  CloseDate: 'CloseDate',
  OpportunitiesExist: 'OpportunitiesExist',
  Opportunity: 'Opportunity',
  SalesStage: 'SalesStage',
  Tcv: 'TCV'
} as const;

export type RuleType = typeof RuleType[keyof typeof RuleType];
/** The connection settings for an S3 Data Source. These include the S3 bucket name, the AWS access key ID, and the tables (along with their paths). We do not allow fetching the AWS secret access key after it has been set. */
export type S3ConnectionSettings = {
  __typename?: 'S3ConnectionSettings';
  /** The AWS access key ID for an IAM user with sufficient access to the S3 bucket. */
  awsAccessKeyId: Scalars['String'];
  /** The name of the S3 bucket. */
  bucket: Scalars['String'];
  /** The S3 Data Source's tables. */
  tables: Array<S3DataSourceTable>;
};

/** A column in an S3 Data Source's table. */
export type S3DataSourceColumn = {
  __typename?: 'S3DataSourceColumn';
  /** The column name. */
  name: Scalars['String'];
  /** Whether the column's type is nullable or not. */
  nullable: Scalars['Boolean'];
  /** The column type. */
  type: ColumnType;
};

/** An S3 Data Source's table. */
export type S3DataSourceTable = {
  __typename?: 'S3DataSourceTable';
  /** All the columns present in the table */
  columns: Array<S3DataSourceColumn>;
  /** The ID of the table */
  id: Scalars['ID'];
  /** The name of the table */
  name: Scalars['String'];
  /** The path to the table's files in S3. */
  path?: Maybe<Scalars['String']>;
};

export type S3Input = {
  contentType: Scalars['String'];
  fileName: Scalars['String'];
  id: Scalars['ID'];
};

export type S3PresignedUrlResponse = {
  __typename?: 'S3PresignedUrlResponse';
  fields?: Maybe<Scalars['JSONObject']>;
  url?: Maybe<Scalars['String']>;
};

export type SalesStageFilteringValuesResponse = {
  __typename?: 'SalesStageFilteringValuesResponse';
  data: Array<Scalars['String']>;
};

export type SalesStageRule = {
  __typename?: 'SalesStageRule';
  pk?: Maybe<Scalars['String']>;
  ruleId?: Maybe<Scalars['String']>;
  ruleSetId?: Maybe<Scalars['String']>;
  ruleType: Scalars['String'];
  salesStages: Array<Scalars['String']>;
  sk?: Maybe<Scalars['String']>;
};

export type SalesStageRuleInput = {
  pk?: InputMaybe<Scalars['String']>;
  ruleId?: InputMaybe<Scalars['String']>;
  ruleSetId?: InputMaybe<Scalars['String']>;
  ruleType?: Scalars['String'];
  salesStages: Array<Scalars['String']>;
  sk?: InputMaybe<Scalars['String']>;
};

export type SalesforceConnectionDetailsResponse = {
  __typename?: 'SalesforceConnectionDetailsResponse';
  registration?: Maybe<RegistrationDetails>;
  vendorId?: Maybe<Scalars['String']>;
  vendorName?: Maybe<Scalars['String']>;
  vendorType?: Maybe<Scalars['String']>;
};

export type SalesforceRegistrationResponse = {
  __typename?: 'SalesforceRegistrationResponse';
  createdAt: Scalars['String'];
  errorCode: Scalars['String'];
  errorMessage: Scalars['String'];
  instanceUrl: Scalars['String'];
  namespace: Scalars['String'];
  orgId: Scalars['String'];
  organization: OrganizationDetails;
  packageVersion: Scalars['String'];
  status: Scalars['String'];
  tackleOrgId: Scalars['String'];
  updatedAt: Scalars['String'];
  user: UserDetails;
  vendorId: Scalars['String'];
};

export type ScheduleItem = {
  __typename?: 'ScheduleItem';
  chargeAmount: Scalars['String'];
  chargeDate: Scalars['String'];
};

export type SfConnectionDetails = {
  __typename?: 'SfConnectionDetails';
  connectedOrgIndices?: Maybe<Array<Maybe<Scalars['Int']>>>;
  connectionCount?: Maybe<Scalars['Int']>;
  data?: Maybe<Array<Maybe<ConnectionDetail>>>;
  hasError: Scalars['Boolean'];
  hasSandbox?: Maybe<Scalars['Boolean']>;
  isConnected: Scalars['Boolean'];
  sandboxOrgIndices?: Maybe<Array<Maybe<Scalars['Int']>>>;
  success: Scalars['Boolean'];
};

export type SignUpInput = {
  companyName: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  jobTitle: Scalars['String'];
  lastName: Scalars['String'];
  password: Scalars['String'];
};

export type SignUpResult = {
  __typename?: 'SignUpResult';
  success: Scalars['Boolean'];
  user: NewUser;
};

/** The Snowflake Data Source connection settings. */
export type SnowflakeConnectionSettings = {
  __typename?: 'SnowflakeConnectionSettings';
  /** The Snowflake account. This is the part before the "snowflakecomputing.com" part of your Snowflake URL. */
  account: Scalars['String'];
  /** The Snowflake database name. */
  database: Scalars['String'];
  /** The Snowflake role. It should be "PROPELLER" if you used the default name in the setup script. */
  role: Scalars['String'];
  /** The Snowflake schema. */
  schema: Scalars['String'];
  /** The Snowflake username. It should be "PROPEL" if you used the default name in the setup script. */
  username: Scalars['String'];
  /** The Snowflake warehouse name. It should be "PROPELLING" if you used the default name in the setup script. */
  warehouse: Scalars['String'];
};

/** The available sort orders. */
export const Sort = {
  /** Sort in ascending order. */
  Asc: 'ASC',
  /** Sort in descending order. */
  Desc: 'DESC'
} as const;

export type Sort = typeof Sort[keyof typeof Sort];
export type SqlColumnResponse = {
  __typename?: 'SqlColumnResponse';
  /** The name of the returned column. */
  columnName: Scalars['String'];
  /** Whether the column is nullable, meaning whether it accepts a null value. */
  isNullable: Scalars['Boolean'];
  /** The returned column's type. */
  type: ColumnType;
};

/** Response from the SQL API. */
export type SqlResponse = {
  __typename?: 'SqlResponse';
  /** The column names in the same order as present in the `data` field. */
  columns: Array<SqlColumnResponse>;
  /** The Query statistics and metadata. */
  info: QueryInfo;
  /**
   * The data gathered by the SQL query. The data is returned in an N x M matrix format, where the
   * first dimension are the rows retrieved, and the second dimension are the columns. Each cell
   * can be either a string or null, and the string can represent a number, text, date or boolean value.
   */
  rows: Array<Array<Maybe<Scalars['String']>>>;
};

/** Input to the SqlV1 api. */
export type SqlV1Input = {
  /** The SQL query. */
  query: Scalars['String'];
};

export type StatsAggregation = {
  __typename?: 'StatsAggregation';
  avg?: Maybe<Scalars['Float']>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
};

export type SumMetricQueryInput = {
  /** The Data Pool to which this Metric belongs. */
  dataPool: DataPoolInput;
  /** The column to be summed. */
  measure: DimensionInput;
};

/** Settings for Sum Metrics. */
export type SumMetricSettings = {
  __typename?: 'SumMetricSettings';
  /**
   * Metric Filters allow defining a Metric with a subset of records from the given Data Pool. If no Metric Filters are present, all records will be included. To filter at query time, add Dimensions and use the `filters` property on the `timeSeriesInput`, `counterInput`, or `leaderboardInput` objects. There is no need to add `filters` to be able to filter at query time.
   *
   * You can provide the filters in the form of SQL.
   */
  filterSql?: Maybe<Scalars['String']>;
  /**
   * Metric Filters allow defining a Metric with a subset of records from the given Data Pool. If no Metric Filters are present, all records will be included. To filter at query time, add Dimensions and use the `filters` property on the `timeSeriesInput`, `counterInput`, or `leaderboardInput` objects. There is no need to add `filters` to be able to filter at query time.
   * @deprecated Use `filterSql` instead
   */
  filters?: Maybe<Array<Filter>>;
  /** The Dimension to be summed. */
  measure: Dimension;
};

/** Parameters for the SummingMergeTree table engine. */
export type SummingMergeTreeTableEngine = HasTableEngineType & {
  __typename?: 'SummingMergeTreeTableEngine';
  /** The columns argument for the SummingMergeTree table engine */
  columns?: Maybe<Array<Scalars['String']>>;
  /** The type is always `SUMMING_MERGE_TREE`. */
  type: TableEngineType;
};

export type SwithVendorsMutationResponse = {
  __typename?: 'SwithVendorsMutationResponse';
  id?: Maybe<Scalars['String']>;
  vendorId?: Maybe<Scalars['String']>;
};

/**
 * The Sync object.
 *
 * This represents the process of syncing data from your Data Source (for example, a Snowflake data warehouse) to your Data Pool.
 */
export type Sync = Node & {
  __typename?: 'Sync';
  /** The Sync's Account. */
  account?: Maybe<Account>;
  /** The Sync's creation date and time in UTC. */
  createdAt: Scalars['DateTime'];
  /** The Sync's creator. It can be either a User ID, an Application ID, or "system" if it was created by Propel. */
  createdBy: Scalars['String'];
  /** The Sync's Data Pool. */
  dataPool?: Maybe<DataPool>;
  /** The Sync's Data Pool's Data Source. */
  dataSource?: Maybe<DataSource>;
  /**
   * The number of deleted records contained within the Sync, if known. This excludes filtered records.
   * @deprecated All records are considered to be processed; see `processedRecords` instead
   */
  deletedRecords?: Maybe<Scalars['String']>;
  /** The Sync's Environment. */
  environment?: Maybe<Environment>;
  /** If the Sync failed, this represents the reason the Sync failed. */
  error?: Maybe<Error>;
  /** The time at which the Sync failed. */
  failedAt?: Maybe<Scalars['DateTime']>;
  /** The Sync's unique identifier. */
  id: Scalars['ID'];
  /**
   * The number of filtered records contained within the Sync, due to issues such as a missing timestamp Dimension, if any are known to be invalid.
   * @deprecated All records are considered to be processed; see `processedRecords` instead
   */
  invalidRecords?: Maybe<Scalars['String']>;
  /** The Sync's last modification date and time in UTC. */
  modifiedAt: Scalars['DateTime'];
  /** The Sync's last modifier. It can be either a User ID, an Application ID, or "system" if it was modified by Propel. */
  modifiedBy: Scalars['String'];
  /**
   * The number of new records contained within the Sync, if known. This excludes filtered records.
   * @deprecated All records are considered to be processed; see `processedRecords` instead
   */
  newRecords?: Maybe<Scalars['String']>;
  /** The number of new, updated, and deleted records contained within the Sync, if known. This excludes filtered records. */
  processedRecords?: Maybe<Scalars['String']>;
  /** The (compressed) size of the Sync, in bytes, if known. */
  size?: Maybe<Scalars['String']>;
  /** The time at which the Sync started. */
  startedAt?: Maybe<Scalars['DateTime']>;
  /** The status of the Sync (all Syncs begin as SYNCING before transitioning to SUCCEEDED or FAILED). */
  status: SyncStatus;
  /** The time at which the Sync succeeded. */
  succeededAt?: Maybe<Scalars['DateTime']>;
  /**
   * The number of updated records contained within the Sync, if known. This excludes filtered records.
   * @deprecated All records are considered to be processed; see `processedRecords` instead
   */
  updatedRecords?: Maybe<Scalars['String']>;
};

/**
 * The Sync connection object.
 *
 * Learn more about [pagination in GraphQL](https://www.propeldata.com/docs/api/pagination).
 */
export type SyncConnection = {
  __typename?: 'SyncConnection';
  /** The Sync connection's edges. */
  edges: Array<SyncEdge>;
  /** The Sync connection's nodes. */
  nodes: Array<Sync>;
  /** The Sync connection's page info. */
  pageInfo: PageInfo;
};

/**
 * The Sync edge object.
 *
 * Learn more about [pagination in GraphQL](https://www.propeldata.com/docs/api/pagination).
 */
export type SyncEdge = {
  __typename?: 'SyncEdge';
  /** The edge's cursor. */
  cursor: Scalars['String'];
  /** The edge's node. */
  node: Sync;
};

/** The status of a Sync. */
export const SyncStatus = {
  /** Propel is deleting the Sync. */
  Deleting: 'DELETING',
  /** The Sync failed. Propel failed to sync some or all records contained within the Sync. */
  Failed: 'FAILED',
  /** The Sync succeeded. Propel successfully synced all records contained within the Sync. */
  Succeeded: 'SUCCEEDED',
  /** Propel is actively syncing records contained within the Sync. */
  Syncing: 'SYNCING'
} as const;

export type SyncStatus = typeof SyncStatus[keyof typeof SyncStatus];
/** The filter to apply when listing the Syncs for a Data Pool. */
export const SyncsFilter = {
  /** Returns all Syncs, regardless of whether they contain records or not. */
  All: 'ALL',
  /** Returns only Syncs with empty records. */
  Empty: 'EMPTY',
  /** Returns only Syncs that contain one or more records. */
  NotEmpty: 'NOT_EMPTY'
} as const;

export type SyncsFilter = typeof SyncsFilter[keyof typeof SyncsFilter];
export type TcvRule = {
  __typename?: 'TCVRule';
  amount: Scalars['Int'];
  pk?: Maybe<Scalars['String']>;
  ruleId?: Maybe<Scalars['String']>;
  ruleSetId?: Maybe<Scalars['String']>;
  ruleType: Scalars['String'];
  selector: Scalars['String'];
  sk?: Maybe<Scalars['String']>;
};

export type TcvRuleInput = {
  amount: Scalars['Int'];
  pk?: InputMaybe<Scalars['String']>;
  ruleId?: InputMaybe<Scalars['String']>;
  ruleSetId?: InputMaybe<Scalars['String']>;
  ruleType?: Scalars['String'];
  selector: Scalars['String'];
  sk?: InputMaybe<Scalars['String']>;
};

export const TcvSelector = {
  GreaterThan: 'greaterThan',
  LessThan: 'lessThan'
} as const;

export type TcvSelector = typeof TcvSelector[keyof typeof TcvSelector];
/**
 * The table object.
 *
 * Once a table introspection succeeds, it creates a new table object for every table it introspected.
 */
export type Table = {
  __typename?: 'Table';
  /** The table's columns which can be used as a measure for a Metric. */
  availableMeasures?: Maybe<ColumnConnection>;
  /** The table's columns which can be used as a timestamp for a Data Pool. */
  availableTimestamps?: Maybe<ColumnConnection>;
  /** The time at which the table was cached (i.e., the time at which it was introspected). */
  cachedAt: Scalars['DateTime'];
  /**
   * Information about the table obtained from Snowflake.
   * @deprecated This is Snowflake-specific, and will be removed
   */
  clusterBy?: Maybe<Scalars['String']>;
  /** The table's columns. */
  columns?: Maybe<ColumnConnection>;
  /**
   * Information about the table obtained from Snowflake.
   * @deprecated This is Snowflake-specific, and will be removed
   */
  comment: Scalars['String'];
  /** The time at which the table was created. This is the same as its `cachedAt` time. */
  createdAt: Scalars['DateTime'];
  /** The table's creator. This corresponds to the initiator of the table Introspection. It can be either a User ID, an Application ID, or "system" if it was created by Propel. */
  createdBy: Scalars['String'];
  /** The Data Source to which the table belongs. */
  dataSource?: Maybe<DataSource>;
  /** The table's ID. */
  id: Scalars['ID'];
  /**
   * Information about the table obtained from Snowflake.
   * @deprecated This is Snowflake-specific, and will be removed
   */
  isAutomaticClusteringEnabled?: Maybe<Scalars['Boolean']>;
  /**
   * Information about the table obtained from Snowflake.
   * @deprecated This is Snowflake-specific, and will be removed
   */
  isChangeTrackingEnabled?: Maybe<Scalars['Boolean']>;
  /**
   * Information about the table obtained from Snowflake.
   * @deprecated This is Snowflake-specific, and will be removed
   */
  isExternal: Scalars['Boolean'];
  /**
   * Information about the table obtained from Snowflake.
   * @deprecated This is Snowflake-specific, and will be removed
   */
  isSearchOptimizationEnabled?: Maybe<Scalars['Boolean']>;
  /**
   * Information about the table obtained from Snowflake.
   * @deprecated This is Snowflake-specific, and will be removed
   */
  kind: Scalars['String'];
  /** The table's name. */
  name: Scalars['String'];
  /**
   * Information about the table obtained from Snowflake.
   * @deprecated This is Snowflake-specific, and will be removed
   */
  owner: Scalars['String'];
  /** The number of rows contained within the table at the time of introspection. Check the table's `cachedAt` time, since this info can become out of date. */
  rows?: Maybe<Scalars['Int']>;
  /** The size of the table (in bytes) at the time of introspection. Check the table's `cachedAt` time, since this info can become out of date. */
  size?: Maybe<Scalars['Int']>;
  /**
   * Information about the table obtained from Snowflake.
   * @deprecated This is Snowflake-specific, and will be removed
   */
  timeTravelRetentionInDays?: Maybe<Scalars['Int']>;
};


/**
 * The table object.
 *
 * Once a table introspection succeeds, it creates a new table object for every table it introspected.
 */
export type TableAvailableMeasuresArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/**
 * The table object.
 *
 * Once a table introspection succeeds, it creates a new table object for every table it introspected.
 */
export type TableAvailableTimestampsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/**
 * The table object.
 *
 * Once a table introspection succeeds, it creates a new table object for every table it introspected.
 */
export type TableColumnsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/**
 * The table connection object.
 *
 * Learn more about [pagination in GraphQL](https://www.propeldata.com/docs/api/pagination).
 */
export type TableConnection = {
  __typename?: 'TableConnection';
  /** The time at which the tables were cached (i.e., the time at which they were introspected). */
  cachedAt: Scalars['DateTime'];
  /** The table connection's edges. */
  edges: Array<TableEdge>;
  /** The table connection's nodes. */
  nodes: Array<Table>;
  /** The table connection's page info. */
  pageInfo: PageInfo;
};

/**
 * The table edge object.
 *
 * Learn more about [pagination in GraphQL](https://www.propeldata.com/docs/api/pagination).
 */
export type TableEdge = {
  __typename?: 'TableEdge';
  /** The edge's cursor. */
  cursor: Scalars['String'];
  /** The edge's node. */
  node: Table;
};

/** A Data Pool's table engine. */
export type TableEngine = AggregatingMergeTreeTableEngine | MergeTreeTableEngine | ReplacingMergeTreeTableEngine | SummingMergeTreeTableEngine;

/** ClickHouse table engine types. */
export const TableEngineType = {
  /** The AggregatingMergeTree table engine. */
  AggregatingMergeTree: 'AGGREGATING_MERGE_TREE',
  /** The MergeTree table engine. */
  MergeTree: 'MERGE_TREE',
  /** The ReplacingMergeTree table engine. */
  ReplacingMergeTree: 'REPLACING_MERGE_TREE',
  /** The SummingMergeTree table engine. */
  SummingMergeTree: 'SUMMING_MERGE_TREE'
} as const;

export type TableEngineType = typeof TableEngineType[keyof typeof TableEngineType];
/**
 * The table introspection object.
 *
 * When setting up a Data Source, Propel may need to introspect tables in order to determine what tables and columns are available to create Data Pools from. The table introspection represents the lifecycle of this operation (whether it's in-progress, succeeded, or failed) and the resulting tables and columns. These will be captured as table and column objects, respectively.
 */
export type TableIntrospection = {
  __typename?: 'TableIntrospection';
  /** The table introspection's creation date and time in UTC. */
  createdAt: Scalars['DateTime'];
  /** The table introspection's creator. It can be either a User ID, an Application ID, or "system" if it was created by Propel. */
  createdBy: Scalars['String'];
  /** The Data Source the table introspection was performed for. */
  dataSource: DataSource;
  /** The table introspection's last modification date and time in UTC. */
  modifiedAt: Scalars['DateTime'];
  /** The table introspection's last modifier. It can be either a User ID, an Application ID, or "system" if it was modified by Propel. */
  modifiedBy: Scalars['String'];
  /** The number of tables introspected. */
  numTables?: Maybe<Scalars['Int']>;
  /** The status of the table introspection. */
  status: TableIntrospectionStatus;
  /** The tables introspected. */
  tables?: Maybe<TableConnection>;
};


/**
 * The table introspection object.
 *
 * When setting up a Data Source, Propel may need to introspect tables in order to determine what tables and columns are available to create Data Pools from. The table introspection represents the lifecycle of this operation (whether it's in-progress, succeeded, or failed) and the resulting tables and columns. These will be captured as table and column objects, respectively.
 */
export type TableIntrospectionTablesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/**
 * The table introspection connection object.
 *
 * Learn more about [pagination in GraphQL](https://www.propeldata.com/docs/api/pagination).
 */
export type TableIntrospectionConnection = {
  __typename?: 'TableIntrospectionConnection';
  /** The table introspection connection's edges. */
  edges: Array<TableIntrospectionEdge>;
  /** The table introspection connection's nodes. */
  nodes: Array<TableIntrospection>;
  /** The table introspection connection's page info. */
  pageInfo: PageInfo;
};

/**
 * The table introspection edge object.
 *
 * Learn more about [pagination in GraphQL](https://www.propeldata.com/docs/api/pagination).
 */
export type TableIntrospectionEdge = {
  __typename?: 'TableIntrospectionEdge';
  /** The edge's cursor. */
  cursor: Scalars['String'];
  /** The edge's node. */
  node: TableIntrospection;
};

/** The status of a table introspection. */
export const TableIntrospectionStatus = {
  /** The table introspection failed. */
  Failed: 'FAILED',
  /** The table introspection has not started. */
  NotStarted: 'NOT_STARTED',
  /** The table introspection has started. */
  Started: 'STARTED',
  /** The table introspection succeeded. */
  Succeeded: 'SUCCEEDED'
} as const;

export type TableIntrospectionStatus = typeof TableIntrospectionStatus[keyof typeof TableIntrospectionStatus];
/**
 * A Data Pool's table settings.
 *
 * These describe how the Data Pool's table is created in ClickHouse.
 */
export type TableSettings = {
  __typename?: 'TableSettings';
  /** The ClickHouse table engine for the Data Pool's table. */
  engine?: Maybe<TableEngine>;
  /** The ORDER BY clause for the Data Pool's table. */
  orderBy?: Maybe<Array<Scalars['String']>>;
  /** The PARTITION BY clause for the Data Pool's table. */
  partitionBy?: Maybe<Array<Scalars['String']>>;
  /** The PRIMARY KEY clause for the Data Pool's table. */
  primaryKey?: Maybe<Array<Scalars['String']>>;
};

export type TackleManagedAndNotManagedContracts = {
  __typename?: 'TackleManagedAndNotManagedContracts';
  managedByTackle?: Maybe<ContractAggregation>;
  nonManagedByTackle?: Maybe<ContractAggregation>;
};

export type TackleManagedAndNotManagedContractsWithNet = {
  __typename?: 'TackleManagedAndNotManagedContractsWithNet';
  managedByTackle?: Maybe<ContractAggregationWithNet>;
  nonManagedByTackle?: Maybe<ContractAggregationWithNet>;
};

/** A Data Pool's tenant ID column. The tenant ID column is used to control access to your data with access policies. */
export type Tenant = {
  __typename?: 'Tenant';
  /** The name of the column that represents the tenant ID. */
  columnName: Scalars['String'];
  /** The tenant ID column's type. */
  type: Scalars['String'];
};

export const TimeInterval = {
  Annually: 'annually',
  Monthly: 'monthly',
  Quarterly: 'quarterly'
} as const;

export type TimeInterval = typeof TimeInterval[keyof typeof TimeInterval];
/**
 * The fields required to specify the time range for a time series, counter, or leaderboard Metric query.
 *
 * If no relative or absolute time ranges are provided, Propel defaults to an absolute time range beginning with the earliest record in the Metric's Data Pool and ending with the latest record.
 *
 * If both relative and absolute time ranges are provided, the relative time range will take precedence.
 *
 * If a `LAST_N` relative time period is selected, an `n` ≥ 1 must be provided. If no `n` is provided or `n` < 1, a `BAD_REQUEST` error will be returned.
 */
export type TimeRangeInput = {
  /** The number of time units for the `LAST_N` relative periods. */
  n?: InputMaybe<Scalars['Int']>;
  /** The relative time period. */
  relative?: InputMaybe<RelativeTimeRange>;
  /** The optional start timestamp (inclusive). Defaults to the timestamp of the earliest record in the Data Pool. */
  start?: InputMaybe<Scalars['DateTime']>;
  /** The optional end timestamp (exclusive). Defaults to the timestamp of the latest record in the Data Pool. */
  stop?: InputMaybe<Scalars['DateTime']>;
  /**
   * The timestamp field to use when querying. Defaults to the timestamp configured on the Data Pool or Metric, if any.
   * Set this to filter on an alternative timestamp field.
   */
  timestamp?: InputMaybe<Scalars['String']>;
};

/**
 * The available time series granularities. Granularities define the unit of time to aggregate the Metric data for a time series query.
 *
 * For example, if the granularity is set to `DAY`, then the the time series query will return a label and a value for each day.
 *
 * If there are no records for a given time series granularity, Propel will return the label and a value of "0" so that the time series can be properly visualized.
 */
export const TimeSeriesGranularity = {
  /** Aggregates values by daily intervals. */
  Day: 'DAY',
  /** Aggregates values by 15-minute intervals. */
  FifteenMinutes: 'FIFTEEN_MINUTES',
  /** Aggregates values by 5-minute intervals. */
  FiveMinutes: 'FIVE_MINUTES',
  /** Aggregates values by hourly intervals. */
  Hour: 'HOUR',
  /** Aggregates values by minute intervals. */
  Minute: 'MINUTE',
  /** Aggregates values by monthly intervals. */
  Month: 'MONTH',
  /** Aggregates values by 10-minute intervals. */
  TenMinutes: 'TEN_MINUTES',
  /** Aggregates values by weekly intervals. */
  Week: 'WEEK',
  /** Aggregates values by yearly intervals. */
  Year: 'YEAR'
} as const;

export type TimeSeriesGranularity = typeof TimeSeriesGranularity[keyof typeof TimeSeriesGranularity];
/**
 * The fields for querying a Metric in time series format.
 *
 * A Metric's time series query returns the values over a given time range aggregated by a given time granularity; day, month, or year, for example.
 */
export type TimeSeriesInput = {
  /** The Query Filters to apply before retrieving the time series data, in the form of SQL. If no Query Filters are provided, all data is included. */
  filterSql?: InputMaybe<Scalars['String']>;
  /** The Query Filters to apply before retrieving the time series data. If no Query Filters are provided, all data is included. */
  filters?: InputMaybe<Array<FilterInput>>;
  /** The time granularity (hour, day, month, etc.) to aggregate the Metric values by. */
  granularity: TimeSeriesGranularity;
  /** Columns to group by. */
  groupBy?: InputMaybe<Array<Scalars['String']>>;
  /** The Metric to Query. It can be a pre-created one or it can be inlined here. */
  metric?: InputMaybe<MetricInput>;
  /**
   * The ID of the Metric to query.
   *
   * Required if `metricName` is not specified.
   */
  metricId?: InputMaybe<Scalars['ID']>;
  /**
   * The name of the Metric to query.
   *
   * Required if `metricId` is not specified.
   */
  metricName?: InputMaybe<Scalars['String']>;
  /** The time range for calculating the time series. */
  timeRange?: InputMaybe<TimeRangeInput>;
  /**
   * The time zone to use. Dates and times are always returned in UTC, but setting the time zone influences relative time ranges and granularities.
   *
   * You can set this to "America/Los_Angeles", "Europe/Berlin", or any other value in the [IANA time zone database](https://en.wikipedia.org/wiki/Tz_database). Defaults to "UTC".
   */
  timeZone?: InputMaybe<Scalars['String']>;
};

/** The time series response object. It contains an array of time series labels and an array of Metric values for the given time range and Query Filters. */
export type TimeSeriesResponse = {
  __typename?: 'TimeSeriesResponse';
  /** The time series values for each group in `groupBy`, if specified. */
  groups?: Maybe<Array<TimeSeriesResponseGroup>>;
  /** The time series labels. */
  labels: Array<Scalars['String']>;
  /** The Query statistics and metadata. */
  query: QueryInfo;
  /** The time series values. */
  values: Array<Maybe<Scalars['String']>>;
};

/** The time series response object for a group specified in `groupBy`. It contains an array of time series labels and an array of Metric values for a particular group. */
export type TimeSeriesResponseGroup = {
  __typename?: 'TimeSeriesResponseGroup';
  /** The time series group's columns. */
  group: Array<Maybe<Scalars['String']>>;
  /** The time series group's labels. */
  labels: Array<Scalars['String']>;
  /** The time series group's values. */
  values: Array<Maybe<Scalars['String']>>;
};

/** A Data Pool's primary timestamp column. Propel uses the primary timestamp to order and partition your data in Data Pools. It will serve as the time dimension for your Metrics. */
export type Timestamp = {
  __typename?: 'Timestamp';
  /** The name of the column that represents the primary timestamp. */
  columnName: Scalars['String'];
  /** The primary timestamp column's type. */
  type: Scalars['String'];
};

/** A Data Pool's unique ID column. Propel uses the primary timestamp and a unique ID to compose a primary key for determining whether records should be inserted, deleted, or updated within the Data Pool. */
export type UniqueId = {
  __typename?: 'UniqueId';
  /** The name of the column that represents the unique ID. */
  columnName: Scalars['String'];
};

/**
 * UpdateDataPoolRecords Job scheduled for a specific Data Pool.
 * The Update Data Pool Records Job represents the asynchronous process of updating records
 * given some filters, inside a Data Pool. It tracks the process of updating records
 * until it is finished, showing the progress and the outcome when it is finished.
 */
export type UpdateDataPoolRecordsJob = Job & Node & {
  __typename?: 'UpdateDataPoolRecordsJob';
  /** Account to which the UpdateDataPoolRecords Job belongs */
  account: Account;
  /** The UpdateDataPoolRecords Job's creation date and time in UTC */
  createdAt: Scalars['DateTime'];
  /** Who created the UpdateDataPoolRecords Job */
  createdBy: Scalars['String'];
  /** The Data Pool whose records will be updated by the UpdateDataPoolRecords Job */
  dataPool: DataPool;
  /** Environment to which the UpdateDataPoolRecords Job belongs */
  environment: Environment;
  /** The error that occurred while updating data, if any. */
  error?: Maybe<Error>;
  /** The time at which the UpdateDataPoolRecords Job failed. */
  failedAt?: Maybe<Scalars['DateTime']>;
  /** The filters that will be used for updating data, in the form of SQL. Data matching the filters will be updated. */
  filterSql?: Maybe<Scalars['String']>;
  /**
   * The list of filters that will be used for updating data. Data matching the filters will be updated.
   * @deprecated Use `filterSql` instead
   */
  filters?: Maybe<Array<Filter>>;
  /** The UpdateDataPoolRecords Job's ID */
  id: Scalars['ID'];
  /** The UpdateDataPoolRecords Job's last modification date and time in UTC */
  modifiedAt: Scalars['DateTime'];
  /** Who last modified the UpdateDataPoolRecords Job */
  modifiedBy: Scalars['String'];
  /** The current progress of the UpdateDataPoolRecords Job, from 0.0 to 1.0. */
  progress: Scalars['Float'];
  /** Describes how the job will update the records. */
  set: Array<UpdateDataPoolRecordsJobSetColumn>;
  /** The time at which the UpdateDataPoolRecords Job started. */
  startedAt?: Maybe<Scalars['DateTime']>;
  /** The current UpdateDataPoolRecords Job's status */
  status: JobStatus;
  /** The time at which the UpdateDataPoolRecords Job succeeded. */
  succeededAt?: Maybe<Scalars['DateTime']>;
};

/**
 * The Update Data Pool records Job connection object.
 *
 * Learn more about [pagination in GraphQL](https://www.propeldata.com/docs/api/pagination).
 */
export type UpdateDataPoolRecordsJobConnection = {
  __typename?: 'UpdateDataPoolRecordsJobConnection';
  /** The Update Data Pool records Job connection's edges. */
  edges: Array<UpdateDataPoolRecordsJobEdge>;
  /** The Update Data Pool records Job connection's nodes. */
  nodes: Array<UpdateDataPoolRecordsJob>;
  /** The Update Data Pool records Job connection's page info. */
  pageInfo: PageInfo;
};

/**
 * The Update Data Pool records Job edge object.
 *
 * Learn more about [pagination in GraphQL](https://www.propeldata.com/docs/api/pagination).
 */
export type UpdateDataPoolRecordsJobEdge = {
  __typename?: 'UpdateDataPoolRecordsJobEdge';
  /** The edge's cursor. */
  cursor: Scalars['String'];
  /** The edge's node. */
  node: UpdateDataPoolRecordsJob;
};

/**
 * The fields for creating an Update Data Pool Records Job.
 *
 * ```
 * {
 * "column": "status",
 * "expression": "'completed'"
 * }
 *
 * {
 * "column": "counter",
 * "expression": "counter + 1"
 * }
 *
 * {
 * "column": "full_name",
 * "expression": "concat(first_name, ' ', last_name)"
 * }
 * ```
 */
export type UpdateDataPoolRecordsJobSetColumn = {
  __typename?: 'UpdateDataPoolRecordsJobSetColumn';
  /** The name of the column to update. */
  column: Scalars['String'];
  /** The value to which the column will be updated. Once evaluated, it should be of the same data type as the column. */
  expression: Scalars['String'];
};

export type UsageMapping = {
  __typename?: 'UsageMapping';
  customerId?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
};

export type UsageRecord = {
  __typename?: 'UsageRecord';
  cloud: Scalars['String'];
  created_at: Scalars['String'];
  customer_id: Scalars['String'];
  dimension: UsageRecordDimension;
  id: Scalars['String'];
  product_id: Scalars['String'];
  reason?: Maybe<Scalars['String']>;
  scheduled_at?: Maybe<Scalars['String']>;
  start_time: Scalars['String'];
  status: Scalars['String'];
  subscription_id: Scalars['String'];
  updated_at: Scalars['String'];
  vendor_id: Scalars['String'];
};

export type UsageRecordDimension = {
  __typename?: 'UsageRecordDimension';
  name: Scalars['String'];
  quantity: Scalars['Float'];
};

export type UsageRecordsMetadata = {
  __typename?: 'UsageRecordsMetadata';
  next_page_token?: Maybe<Scalars['String']>;
};

export type UsageRecordsResponse = {
  __typename?: 'UsageRecordsResponse';
  data: Array<UsageRecord>;
  metadata: UsageRecordsMetadata;
};

export type User = {
  __typename?: 'User';
  allowedVendors?: Maybe<Array<Scalars['String']>>;
  case_number?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  intercomUserHash?: Maybe<Scalars['String']>;
  isConsoleUser?: Maybe<Scalars['Boolean']>;
  isSuperAdmin?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  picture?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  role_details?: Maybe<Role>;
  vendor?: Maybe<Vendor>;
  vendorId?: Maybe<Scalars['String']>;
};

export type UserBillingDetails = {
  __typename?: 'UserBillingDetails';
  gmvPrecommit?: Maybe<Scalars['Float']>;
  gmvUsage?: Maybe<Scalars['Float']>;
  lastUpdated?: Maybe<Scalars['String']>;
  subscriptionEndTime?: Maybe<Scalars['String']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionStartTime?: Maybe<Scalars['String']>;
};

export type UserDetails = {
  __typename?: 'UserDetails';
  email?: Maybe<Scalars['String']>;
  familyName?: Maybe<Scalars['String']>;
  givenName?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  userType?: Maybe<Scalars['String']>;
};

export type UserFromOrgResult = {
  __typename?: 'UserFromOrgResult';
  allowed_vendors_auth0?: Maybe<Array<Maybe<Scalars['String']>>>;
  allowed_vendors_rbac?: Maybe<Array<Maybe<Scalars['String']>>>;
  created_at?: Maybe<Scalars['String']>;
  deactivated_at?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  global?: Maybe<Scalars['Boolean']>;
  last_login?: Maybe<Scalars['String']>;
  logins_count?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  organization_id?: Maybe<Scalars['String']>;
  picture?: Maybe<Scalars['String']>;
  role_id?: Maybe<Scalars['String']>;
  role_name?: Maybe<Scalars['String']>;
  sso_user?: Maybe<Scalars['Boolean']>;
  superadmin?: Maybe<Scalars['Boolean']>;
  supportapi?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
  vendor_names?: Maybe<Array<Maybe<Scalars['String']>>>;
  vendor_type?: Maybe<Scalars['String']>;
  vendorid?: Maybe<Scalars['String']>;
};

/**
 * Response returned by the validateExpression query for validating expressions in Custom Metrics.
 *
 * Returns whether the expression is valid or not with a reason explaining why.
 */
export type ValidateExpressionResult = {
  __typename?: 'ValidateExpressionResult';
  /** The reason for why the expression is not valid in case it isn't, null otherwise. */
  reason?: Maybe<Scalars['String']>;
  /** True if the expression is valid, false otherwise. */
  valid: Scalars['Boolean'];
};

export type Vendor = {
  __typename?: 'Vendor';
  activity?: Maybe<Array<VendorActivity>>;
  applications?: Maybe<Array<VendorApplication>>;
  aws_access_key_id?: Maybe<Scalars['String']>;
  aws_secret_access_key?: Maybe<Scalars['String']>;
  billing?: Maybe<VendorBillingConfiguration>;
  canAccessAwsConsole?: Maybe<Scalars['Boolean']>;
  coSell?: Maybe<CoSellVendor>;
  configuration?: Maybe<VendorConfiguration>;
  created_at?: Maybe<Scalars['String']>;
  disabled_actions?: Maybe<Array<Scalars['String']>>;
  email?: Maybe<Scalars['String']>;
  external_id?: Maybe<Scalars['String']>;
  feature_flags?: Maybe<VendorFeatureFlags>;
  id: Scalars['ID'];
  linkedSandboxes?: Maybe<Array<Maybe<Vendor>>>;
  listingsByChannel?: Maybe<VendorListingsByChannel>;
  logo_url?: Maybe<Scalars['String']>;
  metering?: Maybe<VendorMeteringConfig>;
  name?: Maybe<Scalars['String']>;
  onboarding?: Maybe<VendorOnboarding>;
  orbVendorConfig?: Maybe<OrbVendorConfig>;
  organization_id?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  production_vendor_id?: Maybe<Scalars['ID']>;
  reporting?: Maybe<VendorReporting>;
  tkl_customer_data?: Maybe<Array<VendorTackleCustomerDataItem>>;
  tkl_customer_type?: Maybe<Scalars['String']>;
  vendor_type?: Maybe<Scalars['String']>;
  vendorid?: Maybe<Scalars['ID']>;
};

export type VendorActivity = {
  __typename?: 'VendorActivity';
  activity_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

export type VendorActivityInput = {
  activity_type: Scalars['String'];
  created_at: Scalars['String'];
  slug: Scalars['String'];
  user_id: Scalars['String'];
};

export type VendorApplication = {
  __typename?: 'VendorApplication';
  client_id?: Maybe<Scalars['String']>;
  client_secret?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Scalars['String']>>;
  roles?: Maybe<Array<Scalars['String']>>;
};

export type VendorApplicationInput = {
  client_id?: InputMaybe<Scalars['String']>;
  client_secret?: InputMaybe<Scalars['String']>;
  label?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<Array<Scalars['String']>>;
  roles?: InputMaybe<Array<Scalars['String']>>;
};

export type VendorAwsAssumeRoleConfig = {
  __typename?: 'VendorAwsAssumeRoleConfig';
  role_arn?: Maybe<Scalars['String']>;
};

export type VendorAwsAssumeRoleConfigInput = {
  role_arn?: InputMaybe<Scalars['String']>;
};

export type VendorAwsConfig = {
  __typename?: 'VendorAwsConfig';
  assume_role?: Maybe<VendorAwsAssumeRoleConfig>;
  data_feed?: Maybe<VendorDataFeedConfig>;
};

export type VendorAwsConfigInput = {
  assume_role?: InputMaybe<VendorAwsAssumeRoleConfigInput>;
  data_feed?: InputMaybe<VendorDataFeedConfigInput>;
};

export type VendorAwsOnboarding = {
  __typename?: 'VendorAwsOnboarding';
  account_setup?: Maybe<Array<Scalars['String']>>;
  admin_contacts?: Maybe<Array<AdminContacts>>;
  stacks?: Maybe<Array<Scalars['String']>>;
};

export type VendorAwsOnboardingInput = {
  account_setup?: InputMaybe<Array<Scalars['String']>>;
  admin_contacts?: InputMaybe<Array<AdminContactsInput>>;
  stacks?: InputMaybe<Array<Scalars['String']>>;
};

export type VendorAzureConfig = {
  __typename?: 'VendorAzureConfig';
  app_id?: Maybe<Scalars['String']>;
  app_secret?: Maybe<Scalars['String']>;
  exp_date?: Maybe<Scalars['String']>;
  tenant_id?: Maybe<Scalars['String']>;
};

export type VendorAzureConfigInput = {
  app_id?: InputMaybe<Scalars['String']>;
  app_secret?: InputMaybe<Scalars['String']>;
  exp_date?: InputMaybe<Scalars['String']>;
  tenant_id?: InputMaybe<Scalars['String']>;
};

export type VendorAzureOnboarding = {
  __typename?: 'VendorAzureOnboarding';
  account_setup?: Maybe<Array<Scalars['String']>>;
  admin_contacts?: Maybe<Array<AdminContacts>>;
  commercial_marketplace?: Maybe<Array<Scalars['String']>>;
};

export type VendorAzureOnboardingInput = {
  account_setup?: InputMaybe<Array<Scalars['String']>>;
  admin_contacts?: InputMaybe<Array<AdminContactsInput>>;
  commercial_marketplace?: InputMaybe<Array<Scalars['String']>>;
};

export type VendorBillingConfiguration = {
  __typename?: 'VendorBillingConfiguration';
  cosell_marketplaces_override?: Maybe<Array<Scalars['String']>>;
  gmv_override?: Maybe<Scalars['Int']>;
  gmv_precommit?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  prospect_override?: Maybe<Scalars['Int']>;
  prospect_precommit?: Maybe<Scalars['Int']>;
  subscription_end_time_override?: Maybe<Scalars['String']>;
  subscription_ids?: Maybe<Array<Scalars['ID']>>;
  subscription_start_time_override?: Maybe<Scalars['String']>;
  vendor_ids?: Maybe<Array<Scalars['ID']>>;
};

export type VendorBillingConfigurationInput = {
  cosell_marketplaces_override?: InputMaybe<Array<Scalars['String']>>;
  gmv_override?: InputMaybe<Scalars['Int']>;
  gmv_precommit?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  prospect_override?: InputMaybe<Scalars['Int']>;
  prospect_precommit?: InputMaybe<Scalars['Int']>;
  subscription_end_time_override?: InputMaybe<Scalars['String']>;
  subscription_ids?: InputMaybe<Array<Scalars['ID']>>;
  subscription_start_time_override?: InputMaybe<Scalars['String']>;
  vendor_ids?: InputMaybe<Array<Scalars['ID']>>;
};

export type VendorCallbackAuthentication = {
  __typename?: 'VendorCallbackAuthentication';
  api_key?: Maybe<Scalars['String']>;
  auth_header_name?: Maybe<Scalars['String']>;
  auth_type?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

export type VendorCallbackAuthenticationInput = {
  api_key?: InputMaybe<Scalars['String']>;
  auth_header_name?: InputMaybe<Scalars['String']>;
  auth_type?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
};

export type VendorCallbackConfig = {
  __typename?: 'VendorCallbackConfig';
  authentication?: Maybe<VendorCallbackAuthentication>;
  supported_clouds?: Maybe<Array<Scalars['String']>>;
  url?: Maybe<Scalars['String']>;
};

export type VendorCallbackConfigInput = {
  authentication?: InputMaybe<VendorCallbackAuthenticationInput>;
  supported_clouds?: InputMaybe<Array<Scalars['String']>>;
  url?: InputMaybe<Scalars['String']>;
};

export type VendorCasConfig = {
  __typename?: 'VendorCasConfig';
  S3_bucket?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  schedule_overrides?: Maybe<Array<VendorCasScheduleRuleSet>>;
  sns?: Maybe<Scalars['String']>;
  sqs?: Maybe<VendorSqsQueueConfig>;
};

export type VendorCasConfigInput = {
  S3_bucket?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
  schedule_overrides?: InputMaybe<Array<VendorCasScheduleRuleSetInput>>;
  sns?: InputMaybe<Scalars['String']>;
  sqs?: InputMaybe<VendorSqsQueueConfigInput>;
};

export type VendorCasScheduleRuleSet = {
  __typename?: 'VendorCasScheduleRuleSet';
  bymonthday?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
  freq?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  report_start?: Maybe<Scalars['String']>;
};

export type VendorCasScheduleRuleSetInput = {
  bymonthday?: InputMaybe<Scalars['Float']>;
  description?: InputMaybe<Scalars['String']>;
  freq: Scalars['String'];
  name: Scalars['String'];
  report_start?: InputMaybe<Scalars['String']>;
};

export type VendorConfiguration = {
  __typename?: 'VendorConfiguration';
  aws?: Maybe<VendorAwsConfig>;
  azure?: Maybe<VendorAzureConfig>;
  callback?: Maybe<VendorCallbackConfig>;
  cas?: Maybe<VendorCasConfig>;
  emails?: Maybe<VendorEmailsConfig>;
  gcp?: Maybe<VendorGcpConfig>;
  id: Scalars['ID'];
  integrations?: Maybe<VendorIntegrationsConfig>;
  permitted_listings?: Maybe<VendorPermittedListings>;
  redhat?: Maybe<VendorRedHatConfig>;
  salesforce?: Maybe<VendorSalesforceConfig>;
  status?: Maybe<VendorConfigurationStatuses>;
  system?: Maybe<VendorSystemConfig>;
  vendor_events?: Maybe<VendorSqsQueueConfig>;
};

export type VendorConfigurationInput = {
  aws?: InputMaybe<VendorAwsConfigInput>;
  azure?: InputMaybe<VendorAzureConfigInput>;
  callback?: InputMaybe<VendorCallbackConfigInput>;
  cas?: InputMaybe<VendorCasConfigInput>;
  emails?: InputMaybe<VendorEmailsConfigInput>;
  gcp?: InputMaybe<VendorGcpConfigInput>;
  integrations?: InputMaybe<VendorIntegrationsConfigInput>;
  permitted_listings?: InputMaybe<VendorPermittedListingsInput>;
  redhat?: InputMaybe<VendorRedHatConfigInput>;
  salesforce?: InputMaybe<VendorSalesforceConfigInput>;
  status?: InputMaybe<VendorConfigurationStatusesInput>;
  system?: InputMaybe<VendorSystemConfigInput>;
  vendor_events?: InputMaybe<VendorSqsQueueConfigInput>;
};

export type VendorConfigurationStatuses = {
  __typename?: 'VendorConfigurationStatuses';
  aws?: Maybe<VendorStatus>;
  cas?: Maybe<VendorStatus>;
  eds?: Maybe<VendorStatus>;
  events_sqs?: Maybe<VendorStatus>;
  sdds?: Maybe<VendorStatus>;
};

export type VendorConfigurationStatusesInput = {
  aws?: InputMaybe<VendorStatusInput>;
  cas?: InputMaybe<VendorStatusInput>;
  eds?: InputMaybe<VendorStatusInput>;
  events_sqs?: InputMaybe<VendorStatusInput>;
  sdds?: InputMaybe<VendorStatusInput>;
};

export type VendorCosellOnboarding = {
  __typename?: 'VendorCosellOnboarding';
  ace_eligible_selection?: Maybe<Scalars['String']>;
  aws_has_launch_stack_button_been_clicked?: Maybe<Scalars['Boolean']>;
  aws_has_pc_events_launch_stack_button_been_clicked?: Maybe<Scalars['Boolean']>;
  aws_is_crm_integrated_with_ace?: Maybe<Scalars['Boolean']>;
  has_completed_partner_central_linking?: Maybe<Scalars['Boolean']>;
  has_identified_alliance_account?: Maybe<Scalars['Boolean']>;
};

export type VendorCosellOnboardingInput = {
  ace_eligible_selection?: InputMaybe<Scalars['String']>;
  aws_has_launch_stack_button_been_clicked?: InputMaybe<Scalars['Boolean']>;
  aws_has_pc_events_launch_stack_button_been_clicked?: InputMaybe<Scalars['Boolean']>;
  aws_is_crm_integrated_with_ace?: InputMaybe<Scalars['Boolean']>;
  has_completed_partner_central_linking?: InputMaybe<Scalars['Boolean']>;
  has_identified_alliance_account?: InputMaybe<Scalars['Boolean']>;
};

export type VendorCustomTemplateIds = {
  __typename?: 'VendorCustomTemplateIds';
  tackle_template_id?: Maybe<Scalars['Float']>;
  vendor_template_id?: Maybe<Scalars['Float']>;
};

export type VendorCustomTemplateIdsInput = {
  tackle_template_id?: InputMaybe<Scalars['Float']>;
  vendor_template_id?: InputMaybe<Scalars['Float']>;
};

export type VendorDataFeedConfig = {
  __typename?: 'VendorDataFeedConfig';
  S3_bucket?: Maybe<Scalars['String']>;
  kms_key_arn?: Maybe<Scalars['String']>;
  sns_topic_arn?: Maybe<Scalars['String']>;
  sqs?: Maybe<VendorDataFeedSqsQueueConfig>;
};

export type VendorDataFeedConfigInput = {
  S3_bucket?: InputMaybe<Scalars['String']>;
  kms_key_arn?: InputMaybe<Scalars['String']>;
  sns_topic_arn?: InputMaybe<Scalars['String']>;
  sqs?: InputMaybe<VendorDataFeedSqsQueueConfigInput>;
};

export type VendorDataFeedSqsQueueConfig = {
  __typename?: 'VendorDataFeedSqsQueueConfig';
  url?: Maybe<Scalars['String']>;
};

export type VendorDataFeedSqsQueueConfigInput = {
  url?: InputMaybe<Scalars['String']>;
};

export type VendorEmailsConfig = {
  __typename?: 'VendorEmailsConfig';
  custom_template_ids?: Maybe<Array<VendorCustomTemplateIds>>;
  default_cc?: Maybe<Scalars['String']>;
  default_from?: Maybe<Scalars['String']>;
};

export type VendorEmailsConfigInput = {
  custom_template_ids?: InputMaybe<Array<VendorCustomTemplateIdsInput>>;
  default_cc?: InputMaybe<Scalars['String']>;
  default_from?: InputMaybe<Scalars['String']>;
};

export type VendorFeatureFlags = {
  __typename?: 'VendorFeatureFlags';
  is_ami_early_access_program_enabled?: Maybe<Scalars['Boolean']>;
  is_co_sell_enabled?: Maybe<Scalars['Boolean']>;
  is_co_sell_enabled_for_microsoft?: Maybe<Scalars['Boolean']>;
  is_listings_enabled?: Maybe<Scalars['Boolean']>;
  is_marketplace_enabled?: Maybe<Scalars['Boolean']>;
  is_prospect_enabled?: Maybe<Scalars['Boolean']>;
  metering_upload?: Maybe<Scalars['Boolean']>;
  opt_out_of_aws_v3_metering?: Maybe<Scalars['Boolean']>;
  opt_out_of_gcp_v3_metering?: Maybe<Scalars['Boolean']>;
  po_callback_enabled?: Maybe<Scalars['Boolean']>;
  stripe?: Maybe<Scalars['Boolean']>;
};

export type VendorFeatureFlagsInput = {
  is_ami_early_access_program_enabled?: InputMaybe<Scalars['Boolean']>;
  is_co_sell_enabled?: InputMaybe<Scalars['Boolean']>;
  is_co_sell_enabled_for_microsoft?: InputMaybe<Scalars['Boolean']>;
  is_listings_enabled?: InputMaybe<Scalars['Boolean']>;
  is_marketplace_enabled?: InputMaybe<Scalars['Boolean']>;
  is_prospect_enabled?: InputMaybe<Scalars['Boolean']>;
  metering_upload?: InputMaybe<Scalars['Boolean']>;
  opt_out_of_aws_v3_metering?: InputMaybe<Scalars['Boolean']>;
  opt_out_of_gcp_v3_metering?: InputMaybe<Scalars['Boolean']>;
  po_callback_enabled?: InputMaybe<Scalars['Boolean']>;
  stripe?: InputMaybe<Scalars['Boolean']>;
};

export type VendorGcpConfig = {
  __typename?: 'VendorGcpConfig';
  partner_id?: Maybe<Scalars['String']>;
  projects?: Maybe<Array<VendorGcpProjectConfig>>;
};

export type VendorGcpConfigInput = {
  partner_id?: InputMaybe<Scalars['String']>;
  projects?: InputMaybe<Array<VendorGcpProjectConfigInput>>;
};

export type VendorGcpOnboarding = {
  __typename?: 'VendorGcpOnboarding';
  admin_contacts?: Maybe<Array<AdminContacts>>;
  gc_marketplace_form_is_submitted?: Maybe<Scalars['Boolean']>;
  gc_payment_is_configured?: Maybe<Scalars['Boolean']>;
  gc_project_access_is_granted?: Maybe<Scalars['Boolean']>;
  gc_tackle_permissions_for_offers_granted?: Maybe<Scalars['Boolean']>;
};

export type VendorGcpOnboardingInput = {
  admin_contacts?: InputMaybe<Array<AdminContactsInput>>;
  gc_marketplace_form_is_submitted?: InputMaybe<Scalars['Boolean']>;
  gc_payment_is_configured?: InputMaybe<Scalars['Boolean']>;
  gc_project_access_is_granted?: InputMaybe<Scalars['Boolean']>;
  gc_tackle_permissions_for_offers_granted?: InputMaybe<Scalars['Boolean']>;
};

export type VendorGcpProjectConfig = {
  __typename?: 'VendorGcpProjectConfig';
  /** `name` matches to Project ID */
  name?: Maybe<Scalars['String']>;
  project_name?: Maybe<Scalars['String']>;
  project_number?: Maybe<Scalars['String']>;
  report_bucket?: Maybe<Scalars['String']>;
  service_account?: Maybe<Scalars['String']>;
  service_account_email_address?: Maybe<Scalars['String']>;
  service_account_name?: Maybe<Scalars['String']>;
};

export type VendorGcpProjectConfigInput = {
  /** `name` matches to Project ID */
  name?: InputMaybe<Scalars['String']>;
  project_name?: InputMaybe<Scalars['String']>;
  project_number?: InputMaybe<Scalars['String']>;
  report_bucket?: InputMaybe<Scalars['String']>;
  service_account?: InputMaybe<Scalars['String']>;
  service_account_email_address?: InputMaybe<Scalars['String']>;
  service_account_name?: InputMaybe<Scalars['String']>;
};

export type VendorInput = {
  activity?: InputMaybe<Array<VendorActivityInput>>;
  applications?: InputMaybe<Array<VendorApplicationInput>>;
  aws_access_key_id?: InputMaybe<Scalars['String']>;
  aws_secret_access_key?: InputMaybe<Scalars['String']>;
  billing?: InputMaybe<VendorBillingConfigurationInput>;
  configuration?: InputMaybe<VendorConfigurationInput>;
  disabled_actions?: InputMaybe<Array<Scalars['String']>>;
  email?: InputMaybe<Scalars['String']>;
  feature_flags?: InputMaybe<VendorFeatureFlagsInput>;
  id: Scalars['ID'];
  logo_url?: InputMaybe<Scalars['String']>;
  metering?: InputMaybe<VendorMeteringConfigInput>;
  name?: InputMaybe<Scalars['String']>;
  onboarding?: InputMaybe<VendorOnboardingInput>;
  password?: InputMaybe<Scalars['String']>;
  production_vendor_id?: InputMaybe<Scalars['ID']>;
  tkl_customer_data?: InputMaybe<Array<VendorTackleCustomerDataItemInput>>;
  tkl_customer_type?: InputMaybe<Scalars['String']>;
  vendor_type?: InputMaybe<Scalars['String']>;
};

export type VendorIntegrationsConfig = {
  __typename?: 'VendorIntegrationsConfig';
  slack?: Maybe<VendorSlackConfig>;
};

export type VendorIntegrationsConfigInput = {
  slack?: InputMaybe<VendorSlackConfigInput>;
};

export type VendorListingsByChannel = {
  __typename?: 'VendorListingsByChannel';
  aws?: Maybe<Array<AwsListing>>;
  azure?: Maybe<Array<AzureListing>>;
  gcp?: Maybe<Array<GcpListing>>;
  id: Scalars['ID'];
  redhat?: Maybe<Array<RedHatListing>>;
};

export type VendorMeteringConfig = {
  __typename?: 'VendorMeteringConfig';
  upload_mapping?: Maybe<VendorMeteringUploadMappingConfig>;
};

export type VendorMeteringConfigInput = {
  upload_mapping?: InputMaybe<VendorMeteringUploadMappingConfigInput>;
};

export type VendorMeteringUploadMappingConfig = {
  __typename?: 'VendorMeteringUploadMappingConfig';
  customerid?: Maybe<Scalars['String']>;
  dimension?: Maybe<Scalars['String']>;
  productid?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['String']>;
};

export type VendorMeteringUploadMappingConfigInput = {
  customerid?: InputMaybe<Scalars['String']>;
  dimension?: InputMaybe<Scalars['String']>;
  productid?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['String']>;
};

export type VendorOnboarding = {
  __typename?: 'VendorOnboarding';
  aws?: Maybe<VendorAwsOnboarding>;
  azure?: Maybe<VendorAzureOnboarding>;
  cosell?: Maybe<VendorCosellOnboarding>;
  gcp?: Maybe<VendorGcpOnboarding>;
  redhat?: Maybe<VendorRedHatOnboarding>;
};

export type VendorOnboardingInput = {
  aws?: InputMaybe<VendorAwsOnboardingInput>;
  azure?: InputMaybe<VendorAzureOnboardingInput>;
  cosell?: InputMaybe<VendorCosellOnboardingInput>;
  gcp?: InputMaybe<VendorGcpOnboardingInput>;
  redhat?: InputMaybe<VendorRedHatOnboardingInput>;
};

export type VendorPermittedListings = {
  __typename?: 'VendorPermittedListings';
  aws?: Maybe<Scalars['Float']>;
  azure?: Maybe<Scalars['Float']>;
  gcp?: Maybe<Scalars['Float']>;
  redhat?: Maybe<Scalars['Float']>;
  update_source?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['String']>;
};

export type VendorPermittedListingsInput = {
  aws?: InputMaybe<Scalars['Float']>;
  azure?: InputMaybe<Scalars['Float']>;
  gcp?: InputMaybe<Scalars['Float']>;
  redhat?: InputMaybe<Scalars['Float']>;
  update_source?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['String']>;
};

export type VendorRedHatConfig = {
  __typename?: 'VendorRedHatConfig';
  /** superadmin only */
  api_key?: Maybe<Scalars['String']>;
  has_api_key?: Maybe<Scalars['Boolean']>;
};

export type VendorRedHatConfigInput = {
  api_key?: InputMaybe<Scalars['String']>;
};

export type VendorRedHatOnboarding = {
  __typename?: 'VendorRedHatOnboarding';
  account_setup?: Maybe<Array<Scalars['String']>>;
  admin_contacts?: Maybe<Array<AdminContacts>>;
};

export type VendorRedHatOnboardingInput = {
  account_setup?: InputMaybe<Array<Scalars['String']>>;
  admin_contacts?: InputMaybe<Array<AdminContactsInput>>;
};

export type VendorReporting = {
  __typename?: 'VendorReporting';
  health?: Maybe<VendorReportingHealth>;
  id: Scalars['ID'];
};

export type VendorReportingConnection = {
  __typename?: 'VendorReportingConnection';
  disconnect_note?: Maybe<Scalars['String']>;
  raw_error?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type VendorReportingHealth = {
  __typename?: 'VendorReportingHealth';
  azure_status?: Maybe<VendorReportingConnection>;
  cas_generation_status?: Maybe<VendorReportingConnection>;
  cas_iam_status?: Maybe<VendorReportingConnection>;
  cas_s3_status?: Maybe<VendorReportingConnection>;
  cas_sqs_status?: Maybe<VendorReportingConnection>;
  gcp_status?: Maybe<VendorReportingConnection>;
  sdds_s3_status?: Maybe<VendorReportingConnection>;
  sdds_sqs_status?: Maybe<VendorReportingConnection>;
  tkl_iam_role_status?: Maybe<VendorReportingConnection>;
};

export type VendorSalesforceConfig = {
  __typename?: 'VendorSalesforceConfig';
  client_id?: Maybe<Scalars['String']>;
  client_secret?: Maybe<Scalars['String']>;
  instance_url?: Maybe<Scalars['String']>;
  issued_at?: Maybe<Scalars['String']>;
  refresh_token?: Maybe<Scalars['String']>;
};

export type VendorSalesforceConfigInput = {
  client_id?: InputMaybe<Scalars['String']>;
  client_secret?: InputMaybe<Scalars['String']>;
  instance_url?: InputMaybe<Scalars['String']>;
  issued_at?: InputMaybe<Scalars['String']>;
  refresh_token?: InputMaybe<Scalars['String']>;
};

export type VendorSlackConfig = {
  __typename?: 'VendorSlackConfig';
  enabled?: Maybe<Scalars['Boolean']>;
  url?: Maybe<Scalars['String']>;
};

export type VendorSlackConfigInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
};

export type VendorSqsQueueConfig = {
  __typename?: 'VendorSqsQueueConfig';
  region?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type VendorSqsQueueConfigInput = {
  region?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type VendorStatus = {
  __typename?: 'VendorStatus';
  error?: Maybe<Scalars['String']>;
  last_connected_at?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type VendorStatusInput = {
  last_connected_at?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type VendorSystemConfig = {
  __typename?: 'VendorSystemConfig';
  email_notifications?: Maybe<Scalars['Boolean']>;
  is_demo?: Maybe<Scalars['Boolean']>;
};

export type VendorSystemConfigInput = {
  email_notifications?: InputMaybe<Scalars['Boolean']>;
  is_demo?: InputMaybe<Scalars['Boolean']>;
};

export type VendorTackleCustomerDataItem = {
  __typename?: 'VendorTackleCustomerDataItem';
  cloud?: Maybe<Scalars['String']>;
  customerid?: Maybe<Scalars['String']>;
  productid?: Maybe<Scalars['String']>;
};

export type VendorTackleCustomerDataItemInput = {
  cloud: Scalars['String'];
  customerid: Scalars['String'];
  productid: Scalars['String'];
};

export const VerticalStage = {
  Connected: 'CONNECTED',
  ConnectedListingsInProgress: 'CONNECTED_LISTINGS_IN_PROGRESS',
  ConnectedNoListings: 'CONNECTED_NO_LISTINGS',
  ConnectedNoUsageNoScores: 'CONNECTED_NO_USAGE_NO_SCORES',
  ConnectedNoUsageWithScores: 'CONNECTED_NO_USAGE_WITH_SCORES',
  InProgress: 'IN_PROGRESS',
  NotConnected: 'NOT_CONNECTED',
  Transacting: 'TRANSACTING'
} as const;

export type VerticalStage = typeof VerticalStage[keyof typeof VerticalStage];
/** The Webhook Data Source connection settings. */
export type WebhookConnectionSettings = {
  __typename?: 'WebhookConnectionSettings';
  /**
   * Enables or disables access control for the Data Pool.
   * If the Data Pool has access control enabled, Applications must be assigned Data Pool Access Policies in order to query the Data Pool and its Metrics.
   */
  accessControlEnabled?: Maybe<Scalars['Boolean']>;
  /** The HTTP basic authentication settings for the Webhook Data Source URL. If this parameter is not provided, anyone with the webhook URL will be able to send events. While it's OK to test without HTTP Basic authentication, we recommend enabling it. */
  basicAuth?: Maybe<HttpBasicAuthSettings>;
  /** The additional columns for the Webhook Data Source table. */
  columns?: Maybe<Array<WebhookDataSourceColumn>>;
  /**
   * Override the Data Pool's table settings. These describe how the Data Pool's table is created in ClickHouse, and a
   * default will be chosen based on the Data Pool's `timestamp` and `uniqueId` values, if any. You can override these
   * defaults in order to specify a custom table engine, custom ORDER BY, etc.
   */
  tableSettings?: Maybe<TableSettings>;
  /**
   * The tenant ID column, if any.
   * @deprecated Will be removed; use Data Pool Access Policies instead.
   */
  tenant?: Maybe<Scalars['String']>;
  /** The primary timestamp column, if any. */
  timestamp?: Maybe<Scalars['String']>;
  /**
   * The unique ID column, if any. Propel uses the primary timestamp and a unique ID to compose a primary key for determining whether records should be inserted, deleted, or updated.
   * @deprecated Will be removed; use Table Settings to define the primary key.
   */
  uniqueId?: Maybe<Scalars['String']>;
  /** The Webhook URL for posting JSON events */
  webhookUrl: Scalars['String'];
};

/** A column in the Webhook Data Source's table. */
export type WebhookDataSourceColumn = {
  __typename?: 'WebhookDataSourceColumn';
  /**
   * The JSON property that the column will be derived from. For example, if you POST a JSON event like this:
   * ```json
   * { "greeting": { "message": "hello, world" } }
   * ```
   * Then you can use the JSON property "greeting.message" to extract "hello, world" to a column.
   */
  jsonProperty: Scalars['String'];
  /** The column name. */
  name: Scalars['String'];
  /** Whether the column's type is nullable or not. */
  nullable: Scalars['Boolean'];
  /** The column type. */
  type: ColumnType;
};

export type NewHighsForAccountScore = {
  __typename?: 'newHighsForAccountScore';
  aws?: Maybe<Scalars['Boolean']>;
  azure?: Maybe<Scalars['Boolean']>;
  gcp?: Maybe<Scalars['Boolean']>;
};

export type CurrentUserVendorQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserVendorQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, vendor?: { __typename?: 'Vendor', id: string, vendor_type?: string | null } | null } | null };

export type GetThirdPartyServicesIdentificationInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetThirdPartyServicesIdentificationInfoQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, role?: string | null, organizationId?: string | null, intercomUserHash?: string | null, vendor?: { __typename?: 'Vendor', id: string, name?: string | null, vendor_type?: string | null } | null } | null };

export type GetVendorsQueryVariables = Exact<{
  token?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetVendorsQuery = { __typename?: 'Query', vendors?: { __typename?: 'PaginatedVendors', nextPageToken?: string | null, vendors?: Array<{ __typename?: 'Vendor', id: string, name?: string | null, logo_url?: string | null, vendor_type?: string | null, production_vendor_id?: string | null }> | null } | null };

export type GetAccountListOrganizationVendorsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAccountListOrganizationVendorsQuery = { __typename?: 'Query', currentVendors?: Array<{ __typename?: 'Vendor', id: string, logo_url?: string | null, name?: string | null, vendor_type?: string | null, production_vendor_id?: string | null } | null> | null };

export type ChangeUsersVendorMutationVariables = Exact<{
  vendorid: Scalars['String'];
}>;


export type ChangeUsersVendorMutation = { __typename?: 'Mutation', switchVendors: { __typename?: 'SwithVendorsMutationResponse', vendorId?: string | null } };

export type ApplicationShellQueryVariables = Exact<{ [key: string]: never; }>;


export type ApplicationShellQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, allowedVendors?: Array<string> | null, vendor?: { __typename?: 'Vendor', id: string, name?: string | null, created_at?: string | null, vendor_type?: string | null, production_vendor_id?: string | null, feature_flags?: { __typename?: 'VendorFeatureFlags', is_co_sell_enabled?: boolean | null, is_co_sell_enabled_for_microsoft?: boolean | null, is_prospect_enabled?: boolean | null, is_marketplace_enabled?: boolean | null, is_listings_enabled?: boolean | null } | null, listingsByChannel?: { __typename?: 'VendorListingsByChannel', id: string, aws?: Array<{ __typename?: 'AwsListing', id: string, status?: string | null, packages?: Array<string> | null, sns_configuration?: { __typename?: 'AwsStatus', value?: AwsStatusValue | null } | null }> | null, azure?: Array<{ __typename?: 'AzureListing', id: string, packages?: Array<string> | null }> | null, gcp?: Array<{ __typename?: 'GcpListing', id: string, packages?: Array<string> | null }> | null, redhat?: Array<{ __typename?: 'RedHatListing', id: string, packages?: Array<string> | null }> | null } | null, configuration?: { __typename?: 'VendorConfiguration', id: string, status?: { __typename?: 'VendorConfigurationStatuses', sdds?: { __typename?: 'VendorStatus', value?: string | null } | null } | null } | null } | null } | null };

export type VendorWithSandboxesQueryVariables = Exact<{
  vendorid: Scalars['ID'];
}>;


export type VendorWithSandboxesQuery = { __typename?: 'Query', vendor?: { __typename?: 'Vendor', id: string, vendor_type?: string | null, name?: string | null, linkedSandboxes?: Array<{ __typename?: 'Vendor', id: string, name?: string | null } | null> | null } | null };

export type GetVendorProfileInformationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetVendorProfileInformationQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, isSuperAdmin?: boolean | null, allowedVendors?: Array<string> | null, vendor?: { __typename?: 'Vendor', id: string, name?: string | null, logo_url?: string | null } | null } | null };

export type GetRolesForUserModalQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRolesForUserModalQuery = { __typename?: 'Query', roleWithVendorNames?: Array<{ __typename?: 'RoleWithVendorNames', id: string, name: string, organization_id: string, allowed_vendors?: Array<string> | null, allowed_vendors_names?: Array<string> | null, global: boolean }> | null };

export type CreateUserMutationVariables = Exact<{
  email: Scalars['String'];
  role: Auth0UserCreateInputRole;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser: { __typename?: 'Auth0UserUserResponse', id?: string | null, email?: string | null, picture?: string | null, name?: string | null, nickname?: string | null, logins_count?: number | null, email_verified?: boolean | null, app_metadata?: { __typename?: 'Auth0UserAppMetadata', role?: string | null, vendorid?: string | null, organization_id?: string | null, vendor_type?: string | null, allowed_vendors?: Array<string | null> | null, password_set?: boolean | null, superadmin?: boolean | null, supportapi?: boolean | null, sso_user?: boolean | null } | null } };

export type UpdateUserMutationVariables = Exact<{
  userId: Scalars['String'];
  email: Scalars['String'];
  role: Auth0UserCreateInputRole;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'Auth0UserUserResponse', id?: string | null, email?: string | null, picture?: string | null, name?: string | null, nickname?: string | null, logins_count?: number | null, email_verified?: boolean | null, app_metadata?: { __typename?: 'Auth0UserAppMetadata', role?: string | null, vendorid?: string | null, organization_id?: string | null, vendor_type?: string | null, allowed_vendors?: Array<string | null> | null, password_set?: boolean | null, superadmin?: boolean | null, supportapi?: boolean | null, sso_user?: boolean | null } | null } };

export type VendorMarketplaceStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type VendorMarketplaceStatusQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, vendor?: { __typename?: 'Vendor', id: string, vendor_type?: string | null, configuration?: { __typename?: 'VendorConfiguration', id: string, status?: { __typename?: 'VendorConfigurationStatuses', aws?: { __typename?: 'VendorStatus', value?: string | null, last_connected_at?: string | null, updated_at?: string | null, error?: string | null } | null, sdds?: { __typename?: 'VendorStatus', value?: string | null, last_connected_at?: string | null, updated_at?: string | null, error?: string | null } | null, events_sqs?: { __typename?: 'VendorStatus', value?: string | null, last_connected_at?: string | null, updated_at?: string | null, error?: string | null } | null } | null } | null, reporting?: { __typename?: 'VendorReporting', id: string, health?: { __typename?: 'VendorReportingHealth', sdds_s3_status?: { __typename?: 'VendorReportingConnection', status?: string | null, raw_error?: string | null } | null, sdds_sqs_status?: { __typename?: 'VendorReportingConnection', status?: string | null, raw_error?: string | null } | null, tkl_iam_role_status?: { __typename?: 'VendorReportingConnection', status?: string | null, raw_error?: string | null } | null, cas_iam_status?: { __typename?: 'VendorReportingConnection', status?: string | null, raw_error?: string | null } | null, cas_s3_status?: { __typename?: 'VendorReportingConnection', status?: string | null, raw_error?: string | null } | null, cas_sqs_status?: { __typename?: 'VendorReportingConnection', status?: string | null, raw_error?: string | null } | null, cas_generation_status?: { __typename?: 'VendorReportingConnection', status?: string | null, raw_error?: string | null } | null, gcp_status?: { __typename?: 'VendorReportingConnection', status?: string | null, raw_error?: string | null } | null, azure_status?: { __typename?: 'VendorReportingConnection', status?: string | null, raw_error?: string | null } | null } | null } | null } | null } | null };

export type CosellAiBusinessProblemDescriptionQueryVariables = Exact<{
  vendorId: Scalars['String'];
  buyerDomain: Scalars['String'];
  targetCloud: Scalars['String'];
}>;


export type CosellAiBusinessProblemDescriptionQuery = { __typename?: 'Query', coSellAiBusinessProblemDescription?: { __typename?: 'CoSellAiQueryResponse', result?: string | null } | null };

export type ProspectScoreCrmAccountQueryVariables = Exact<{
  vendorId: Scalars['String'];
  crmId: Scalars['String'];
}>;


export type ProspectScoreCrmAccountQuery = { __typename?: 'Query', prospectScoreCrmAccount?: { __typename?: 'ProspectScoreCrmAccount', domain?: string | null, score_aws?: string | null, score_azure?: string | null, score_gcp?: string | null, visibility?: string | null, user_entered_domain?: string | null, company_name?: string | null, region?: string | null, revenue_band?: string | null, primary_industry?: string | null } | null };

export type ProspectSubmitScoreOrMakeVisibleMutationVariables = Exact<{
  vendorId: Scalars['String'];
  crmId: Scalars['String'];
  domain?: InputMaybe<Scalars['String']>;
}>;


export type ProspectSubmitScoreOrMakeVisibleMutation = { __typename?: 'Mutation', prospectSubmitScoreOrMakeVisible?: { __typename?: 'ProspectScoreCrmAccount', domain?: string | null, score_aws?: string | null, score_azure?: string | null, score_gcp?: string | null, visibility?: string | null, crm_id?: string | null, user_entered_domain?: string | null, company_name?: string | null, region?: string | null, revenue_band?: string | null, primary_industry?: string | null } | null };

export type ProspectEntitlementsQueryVariables = Exact<{
  vendorId: Scalars['String'];
}>;


export type ProspectEntitlementsQuery = { __typename?: 'Query', prospectEntitlements: { __typename?: 'ProspectEntitlementsResponse', precommit?: number | null, usage?: number | null, requested?: number | null, limit_use?: boolean | null } };

export type SalesforceConnectionDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type SalesforceConnectionDetailsQuery = { __typename?: 'Query', salesforceConnectionDetails?: Array<{ __typename?: 'SalesforceConnectionDetailsResponse', vendorId?: string | null, vendorName?: string | null, vendorType?: string | null, registration?: { __typename?: 'RegistrationDetails', instanceUrl?: string | null, vendorId?: string | null, tackleOrgId?: string | null, errorCode?: string | null, errorMessage?: string | null, status?: string | null, createdAt?: string | null, updatedAt?: string | null, packageVersion?: string | null, organization?: { __typename?: 'OrganizationDetails', id?: string | null, name?: string | null, instanceName?: string | null, isSandbox?: boolean | null, organizationType?: string | null, namespacePrefix?: string | null } | null, user?: { __typename?: 'UserDetails', userId?: string | null, organizationId?: string | null, email?: string | null, givenName?: string | null, familyName?: string | null, userType?: string | null } | null } | null } | null> | null };

export type CreateSalesforceRegistrationMutationVariables = Exact<{
  authorizationCode: Scalars['String'];
  loginURL: Scalars['String'];
  namespace: Scalars['String'];
  packageVersion: Scalars['String'];
  vendorId: Scalars['String'];
  redirectURL?: InputMaybe<Scalars['String']>;
}>;


export type CreateSalesforceRegistrationMutation = { __typename?: 'Mutation', salesforceRegistration: { __typename?: 'SalesforceRegistrationResponse', instanceUrl: string, vendorId: string, tackleOrgId: string, errorCode: string, errorMessage: string, status: string, createdAt: string, updatedAt: string, orgId: string, namespace: string, packageVersion: string, organization: { __typename?: 'OrganizationDetails', id?: string | null, name?: string | null, instanceName?: string | null, isSandbox?: boolean | null, organizationType?: string | null, namespacePrefix?: string | null }, user: { __typename?: 'UserDetails', userId?: string | null, organizationId?: string | null, email?: string | null, givenName?: string | null, familyName?: string | null, userType?: string | null } } };

export type UsageRecordsQueryVariables = Exact<{
  productId: Scalars['String'];
  customerId: Scalars['String'];
}>;


export type UsageRecordsQuery = { __typename?: 'Query', usageRecords?: { __typename?: 'UsageRecordsResponse', data: Array<{ __typename?: 'UsageRecord', created_at: string, status: string, dimension: { __typename?: 'UsageRecordDimension', name: string, quantity: number } }> } | null };

export type ContractsQueryVariables = Exact<{
  vendorId: Scalars['String'];
  size?: InputMaybe<Scalars['Int']>;
  searchAfter?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  query?: InputMaybe<Scalars['JSON']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['JSON']>> | InputMaybe<Scalars['JSON']>>;
}>;


export type ContractsQuery = { __typename?: 'Query', contracts?: { __typename?: 'ContractSearchResponse', hits?: { __typename?: 'ContractHits', hits?: Array<{ __typename?: 'ContractHit', sort?: Array<string | null> | null, _source?: { __typename?: 'Contract', id: string, vendorId: string, buyerId?: string | null, offerId?: string | null, productId?: string | null, contractName?: string | null, companyName?: string | null, cloudMarketplace?: string | null, offerType?: string | null, offerName?: string | null, listingName?: string | null, listingType?: string | null, pricingModel?: string | null, contractStatus?: string | null, cloudContractStatus?: string | null, partnerOwnedAgreement?: boolean | null, startDate?: string | null, acceptedDate?: string | null, endDate?: string | null, contractDuration?: string | null, contractStart?: string | null, numberOfPayments?: number | null, numberOfPaymentsRemaining?: number | null, autoRenew?: boolean | null, offerTargetAccount?: string | null, tackleOfferId?: string | null, marketplaceFeeRate?: number | null, paymentModel?: string | null, endingSoon?: boolean | null, amendedAgreementId?: string | null, amendedAgreementExistsInTackle?: boolean | null, paymentSchedule?: { __typename?: 'PaymentScheduleTerm', type: string, currencyCode: string, schedule: Array<{ __typename?: 'ScheduleItem', chargeAmount: string, chargeDate: string }> } | null, totalContractValue?: { __typename?: 'ContractMonetaryValue', amount?: number | null, currencyCode?: string | null } | null, totalContractNetValue?: { __typename?: 'ContractMonetaryValue', amount?: number | null, currencyCode?: string | null } | null, grossDisbursed?: { __typename?: 'ContractMonetaryValue', amount?: number | null, currencyCode?: string | null } | null, originalCurrencyGrossDisbursed?: { __typename?: 'ContractMonetaryValue', amount?: number | null, currencyCode?: string | null } | null, netDisbursed?: { __typename?: 'ContractMonetaryValue', amount?: number | null, currencyCode?: string | null } | null, originalCurrencyNetDisbursed?: { __typename?: 'ContractMonetaryValue', amount?: number | null, currencyCode?: string | null } | null, productAndPricing?: { __typename?: 'ContractProductAndPricing', isListingManagedByTackle?: boolean | null, dimensions?: Array<{ __typename?: 'ContractProductDimension', dimension?: string | null, description?: string | null, api?: string | null, quantity?: number | null, value?: number | null } | null> | null, usageDimensions?: Array<{ __typename?: 'ContractUsageDimensions', dimension?: string | null, description?: string | null, api?: string | null, price?: { __typename?: 'ContractMonetaryValue', amount?: number | null, currencyCode?: string | null } | null } | null> | null } | null, registration?: { __typename?: 'ContractRegistrationDetails', companyName?: string | null, fullName?: string | null, email?: string | null, phone?: string | null, registrationDate?: string | null, offerMetadata?: any | null, registrationMetadata?: any | null, address?: { __typename?: 'ContractAddress', street?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null } | null } | null, totalGrossUninvoicedPayment?: { __typename?: 'ContractMonetaryValue', amount?: number | null, currencyCode?: string | null } | null, totalNetUninvoicePayment?: { __typename?: 'ContractMonetaryValue', amount?: number | null, currencyCode?: string | null } | null, usageMapping?: { __typename?: 'UsageMapping', productId?: string | null, customerId?: string | null } | null } | null } | null> | null, total?: { __typename?: 'ContractOpenSearchTotal', value?: number | null } | null } | null } | null };

export type ActiveContractsSummaryQueryVariables = Exact<{
  vendorId: Scalars['String'];
  query?: InputMaybe<Scalars['JSON']>;
}>;


export type ActiveContractsSummaryQuery = { __typename?: 'Query', activeContractsSummary?: { __typename?: 'TackleManagedAndNotManagedContractsWithNet', managedByTackle?: { __typename?: 'ContractAggregationWithNet', sum?: number | null, count?: number | null, netDisbursed?: number | null } | null, nonManagedByTackle?: { __typename?: 'ContractAggregationWithNet', sum?: number | null, count?: number | null, netDisbursed?: number | null } | null } | null };

export type PendingPaymentsSummaryQueryVariables = Exact<{
  vendorId: Scalars['String'];
  query?: InputMaybe<Scalars['JSON']>;
}>;


export type PendingPaymentsSummaryQuery = { __typename?: 'Query', pendingPaymentsSummary?: { __typename?: 'TackleManagedAndNotManagedContracts', managedByTackle?: { __typename?: 'ContractAggregation', sum?: number | null, count?: number | null } | null, nonManagedByTackle?: { __typename?: 'ContractAggregation', sum?: number | null, count?: number | null } | null } | null };

export type ExpiringContractsSummaryQueryVariables = Exact<{
  vendorId: Scalars['String'];
  query?: InputMaybe<Scalars['JSON']>;
}>;


export type ExpiringContractsSummaryQuery = { __typename?: 'Query', expiringContractsSummary?: { __typename?: 'TackleManagedAndNotManagedContractsWithNet', managedByTackle?: { __typename?: 'ContractAggregationWithNet', sum?: number | null, count?: number | null, netDisbursed?: number | null } | null, nonManagedByTackle?: { __typename?: 'ContractAggregationWithNet', sum?: number | null, count?: number | null, netDisbursed?: number | null } | null } | null };

export type ContractsExportPresignedUrlQueryVariables = Exact<{
  vendorId: Scalars['String'];
  query?: InputMaybe<Scalars['JSON']>;
}>;


export type ContractsExportPresignedUrlQuery = { __typename?: 'Query', contractsExportPresignedUrl?: { __typename?: 'ContractsExportPresignedUrlResponse', presignedUrl?: string | null } | null };

export type ContractFilteringValuesQueryVariables = Exact<{
  vendorId: Scalars['String'];
}>;


export type ContractFilteringValuesQuery = { __typename?: 'Query', contractFilteringValues?: { __typename?: 'ContractFilterValues', cloudMarketplaces?: Array<string | null> | null, customers?: Array<string | null> | null, offerTypes?: Array<string | null> | null, products?: Array<string | null> | null, productTypes?: Array<string | null> | null, pricingModels?: Array<string | null> | null, managedByTackle?: Array<boolean | null> | null, status?: Array<string | null> | null } | null };

export type AwsIntegrationsVendorOnboardingRequirementsQueryVariables = Exact<{ [key: string]: never; }>;


export type AwsIntegrationsVendorOnboardingRequirementsQuery = { __typename?: 'Query', awsRegistrationToken?: string | null, currentUser?: { __typename?: 'User', id: string, vendor?: { __typename?: 'Vendor', id: string, name?: string | null, external_id?: string | null } | null } | null };

export type SfConnectionDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type SfConnectionDetailsQuery = { __typename?: 'Query', sfConnectionDetails: { __typename?: 'SfConnectionDetails', isConnected: boolean, connectionCount?: number | null, connectedOrgIndices?: Array<number | null> | null, sandboxOrgIndices?: Array<number | null> | null, hasSandbox?: boolean | null, hasError: boolean, success: boolean, data?: Array<{ __typename?: 'ConnectionDetail', instanceUrl?: string | null, hasOrgDetails?: boolean | null, errorCode?: string | null, organizationDetails?: { __typename?: 'OrganizationDetails', id?: string | null, name?: string | null, isSandbox?: boolean | null, instanceName?: string | null, organizationType?: string | null } | null, userDetails?: { __typename?: 'UserDetails', email?: string | null, userType?: string | null } | null, registrationOrgDetails?: { __typename?: 'RegistrationOrgDetails', organizationId?: string | null, isSandbox?: boolean | null } | null } | null> | null } };

export type OrbIntegrationQueryVariables = Exact<{ [key: string]: never; }>;


export type OrbIntegrationQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, vendor?: { __typename?: 'Vendor', id: string, orbVendorConfig?: { __typename?: 'OrbVendorConfig', id: string, orb_api_key_prefix?: string | null, orb_webhook_signing_secret_prefix?: string | null, config_by_product_id?: any | null } | null, listingsByChannel?: { __typename?: 'VendorListingsByChannel', id: string, aws?: Array<{ __typename?: 'AwsListing', id: string, status?: string | null, marketplace_id?: string | null, name?: string | null, pricing?: { __typename?: 'AwsPricing', usage_fees?: Array<{ __typename?: 'AwsUsageFee', price?: number | null, sku?: string | null, description?: string | null }> | null } | null }> | null, azure?: Array<{ __typename?: 'AzureListing', id: string, status?: string | null, marketplace_id?: string | null, name?: string | null, pricing?: { __typename?: 'AzurePricing', plans?: Array<{ __typename?: 'AzurePlan', plan_uuid?: string | null }> | null, metrics?: Array<{ __typename?: 'AzureMetric', sku?: string | null, display_name?: string | null, plan_pricing?: Array<{ __typename?: 'AzurePlanPricing', price_per_unit?: number | null, plan_uuid?: string | null }> | null }> | null } | null }> | null, gcp?: Array<{ __typename?: 'GcpListing', id: string, status?: string | null, marketplace_id?: string | null, name?: string | null, dimensions?: Array<{ __typename?: 'GcpDimension', display_name?: string | null, external_name?: string | null, meterable?: boolean | null, metric_name?: string | null, name?: string | null, plan_id?: string | null }> | null, metrics_pricing?: Array<{ __typename?: 'GcpMetric', name?: string | null, unit?: string | null, price_per_unit?: Array<{ __typename?: 'GcpMetricPricePerUnit', plan_id?: string | null, price?: number | null }> | null }> | null }> | null } | null } | null } | null };

export type UpdateOrbVendorConfigMutationVariables = Exact<{
  updates: OrbVendorConfigInput;
}>;


export type UpdateOrbVendorConfigMutation = { __typename?: 'Mutation', updateOrbVendorConfig?: { __typename?: 'OrbVendorConfig', id: string, orb_api_key_prefix?: string | null, orb_webhook_signing_secret_prefix?: string | null, config_by_product_id?: any | null } | null };

export type ListOfListingsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListOfListingsQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, role?: string | null, vendor?: { __typename?: 'Vendor', id: string, vendor_type?: string | null, feature_flags?: { __typename?: 'VendorFeatureFlags', is_marketplace_enabled?: boolean | null, is_listings_enabled?: boolean | null } | null, configuration?: { __typename?: 'VendorConfiguration', aws?: { __typename?: 'VendorAwsConfig', assume_role?: { __typename?: 'VendorAwsAssumeRoleConfig', role_arn?: string | null } | null, data_feed?: { __typename?: 'VendorDataFeedConfig', S3_bucket?: string | null, sqs?: { __typename?: 'VendorDataFeedSqsQueueConfig', url?: string | null } | null } | null } | null, azure?: { __typename?: 'VendorAzureConfig', exp_date?: string | null } | null } | null, listingsByChannel?: { __typename?: 'VendorListingsByChannel', id: string, aws?: Array<{ __typename?: 'AwsListing', id: string, listing_type?: string | null, name?: string | null, status?: string | null, last_modified_at?: string | null, revision_of_product_id_internal?: string | null, relist_of_product_id_internal?: string | null, viewed_advanced_tab?: boolean | null, registration_hosting?: string | null, sns_configuration?: { __typename?: 'AwsStatus', value?: AwsStatusValue | null } | null }> | null, azure?: Array<{ __typename?: 'AzureListing', id: string, listing_type?: string | null, name?: string | null, status?: string | null, last_modified_at?: string | null, revision_of_product_id_internal?: string | null, viewed_advanced_tab?: boolean | null, registration_hosting?: string | null }> | null, gcp?: Array<{ __typename?: 'GcpListing', id: string, listing_type?: string | null, name?: string | null, status?: string | null, last_modified_at?: string | null, revision_of_product_id_internal?: string | null, viewed_advanced_tab?: boolean | null, registration_hosting?: string | null }> | null } | null } | null } | null };

export type ListOfListingsSplashScreenQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type ListOfListingsSplashScreenQuery = { __typename?: 'Query', awsMarketplaceSaasProducts?: Array<{ __typename?: 'AwsMarketplaceSaasProduct', EntityId: string, LastModifiedDate?: string | null, Name?: string | null, Visibility?: string | null, id: string }> | null, azureMarketplaceSaasProducts?: Array<{ __typename?: 'AzureMarketplaceSaasProduct', id?: string | null, status?: string | null, created_date?: string | null, type?: string | null, alias?: string | null, identity?: { __typename?: 'AzureMarketplaceSaasProductIdentity', externalId?: string | null } | null }> | null, prospectRollupStatistics: { __typename?: 'ProspectRollupStatisticsResponse', data?: { __typename?: 'ProspectRollupStatistics', total_domains?: number | null, aws_rollup?: { __typename?: 'ProspectMarketplaceScores', count_high?: number | null, count_medium?: number | null } | null, gcp_rollup?: { __typename?: 'ProspectMarketplaceScores', count_high?: number | null, count_medium?: number | null } | null, azure_rollup?: { __typename?: 'ProspectMarketplaceScores', count_high?: number | null, count_medium?: number | null } | null } | null } };

export type ListingsCreateAwsListingMutationVariables = Exact<{ [key: string]: never; }>;


export type ListingsCreateAwsListingMutation = { __typename?: 'Mutation', createAwsListing?: { __typename?: 'AwsListing', id: string } | null };

export type ListingsCreateAzureListingMutationVariables = Exact<{ [key: string]: never; }>;


export type ListingsCreateAzureListingMutation = { __typename?: 'Mutation', createAzureListing?: { __typename?: 'AzureListing', id: string } | null };

export type ListingsCreateGcpListingMutationVariables = Exact<{ [key: string]: never; }>;


export type ListingsCreateGcpListingMutation = { __typename?: 'Mutation', createGcpListing?: { __typename?: 'GcpListing', id: string } | null };

export type AwsAmiPricingFormSectionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AwsAmiPricingFormSectionQuery = { __typename?: 'Query', awsListing?: { __typename?: 'AwsListing', id: string, status?: string | null, ami_pricing?: { __typename?: 'AwsAmiPricing', pricing_setting?: AwsAmiPricingSetting | null, pricing_template_url?: string | null } | null } | null };

export type UpdateAwsAmiPricingFormSectionMutationVariables = Exact<{
  updates: AwsListingInput;
}>;


export type UpdateAwsAmiPricingFormSectionMutation = { __typename?: 'Mutation', updateAwsListing?: { __typename?: 'AwsListing', id: string, status?: string | null, ami_pricing?: { __typename?: 'AwsAmiPricing', pricing_setting?: AwsAmiPricingSetting | null, pricing_template_url?: string | null } | null } | null };

export type AwsContractMetadataFormSectionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AwsContractMetadataFormSectionQuery = { __typename?: 'Query', awsListing?: { __typename?: 'AwsListing', id: string, contract_standard_fields?: Array<{ __typename?: 'AwsPrivateOfferMetadataStandardField', cloud_field?: boolean | null, title?: string | null }> | null } | null };

export type UpdateAwsContractMetadataFormSectionMutationVariables = Exact<{
  updates: AwsListingInput;
}>;


export type UpdateAwsContractMetadataFormSectionMutation = { __typename?: 'Mutation', updateAwsListing?: { __typename?: 'AwsListing', id: string, contract_standard_fields?: Array<{ __typename?: 'AwsPrivateOfferMetadataStandardField', cloud_field?: boolean | null, title?: string | null }> | null } | null };

export type AwsGeneralInformationFormSectionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AwsGeneralInformationFormSectionQuery = { __typename?: 'Query', awsListing?: { __typename?: 'AwsListing', id: string, status?: string | null, logo?: string | null, name?: string | null, short_description?: string | null } | null };

export type UpdateAwsGeneralInformationFormSectionMutationVariables = Exact<{
  updates: AwsListingInput;
}>;


export type UpdateAwsGeneralInformationFormSectionMutation = { __typename?: 'Mutation', updateAwsListing?: { __typename?: 'AwsListing', id: string, status?: string | null, logo?: string | null, name?: string | null, short_description?: string | null } | null };

export type AwsKeywordsAndProductCategoriesFormSectionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AwsKeywordsAndProductCategoriesFormSectionQuery = { __typename?: 'Query', awsListing?: { __typename?: 'AwsListing', id: string, status?: string | null, search_keywords?: string | null, categories?: Array<{ __typename?: 'AwsCategory', subcategory?: string | null, category?: string | null }> | null } | null };

export type UpdateAwsKeywordsAndProductCategoriesFormSectionMutationVariables = Exact<{
  updates: AwsListingInput;
}>;


export type UpdateAwsKeywordsAndProductCategoriesFormSectionMutation = { __typename?: 'Mutation', updateAwsListing?: { __typename?: 'AwsListing', id: string, status?: string | null, search_keywords?: string | null, categories?: Array<{ __typename?: 'AwsCategory', subcategory?: string | null, category?: string | null }> | null } | null };

export type AwsLegalFormSectionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AwsLegalFormSectionQuery = { __typename?: 'Query', awsListing?: { __typename?: 'AwsListing', id: string, status?: string | null, legal?: { __typename?: 'AwsLegal', contract_type?: string | null, contract_url?: string | null } | null } | null };

export type UpdateAwsLegalFormSectionMutationVariables = Exact<{
  updates: AwsListingInput;
}>;


export type UpdateAwsLegalFormSectionMutation = { __typename?: 'Mutation', updateAwsListing?: { __typename?: 'AwsListing', id: string, status?: string | null, legal?: { __typename?: 'AwsLegal', contract_type?: string | null, contract_url?: string | null } | null } | null };

export type AwsListingQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AwsListingQuery = { __typename?: 'Query', awsListing?: { __typename?: 'AwsListing', id: string, name?: string | null, vendorid?: string | null, marketplace_id?: string | null, marketplace_url?: string | null, status?: string | null, listing_type?: string | null, last_imported_at?: string | null, registration_hosting?: string | null, viewed_advanced_tab?: boolean | null, vendor?: { __typename?: 'Vendor', vendor_type?: string | null } | null, sns_configuration?: { __typename?: 'AwsStatus', value?: AwsStatusValue | null, updated_at?: string | null, last_connected_at?: string | null, error?: string | null } | null, revision_of_listing?: { __typename?: 'AwsListing', name?: string | null, id: string } | null } | null };

export type SubmitAwsListingForReviewMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SubmitAwsListingForReviewMutation = { __typename?: 'Mutation', submitAwsListingForReview?: { __typename?: 'AwsListing', id: string, status?: string | null } | null };

export type AwsListingAdvancedQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AwsListingAdvancedQuery = { __typename?: 'Query', awsListing?: { __typename?: 'AwsListing', id: string, viewed_advanced_tab?: boolean | null, status?: string | null } | null };

export type UpdateAwsListingAdvancedMutationVariables = Exact<{
  updates: AwsListingInput;
}>;


export type UpdateAwsListingAdvancedMutation = { __typename?: 'Mutation', updateAwsListing?: { __typename?: 'AwsListing', id: string, viewed_advanced_tab?: boolean | null } | null };

export type AwsPreviewQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AwsPreviewQuery = { __typename?: 'Query', awsListing?: { __typename?: 'AwsListing', logo?: string | null, short_description?: string | null, full_description?: string | null, product_video_url?: string | null, highlights?: Array<string> | null, name?: string | null, pricing?: { __typename?: 'AwsPricing', contract_durations?: Array<string> | null, product_unit?: string | null, usage_fees?: Array<{ __typename?: 'AwsUsageFee', description?: string | null, price?: number | null }> | null, contract_dimensions?: Array<{ __typename?: 'AwsPricingContractDimension', name?: string | null, description?: string | null, prices?: { __typename?: 'AwsPricingContractDimensionPrices', monthly?: string | null, one_year?: string | null, two_year?: string | null, three_year?: string | null } | null }> | null } | null, legal?: { __typename?: 'AwsLegal', contract_url?: string | null } | null, support?: { __typename?: 'AwsSupport', details?: string | null, refund_policy?: string | null, support_items?: Array<{ __typename?: 'AwsSupportItem', display_name?: string | null, support_resource?: string | null }> | null } | null, vendor?: { __typename?: 'Vendor', id: string, name?: string | null } | null } | null };

export type AwsListingSideBarQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AwsListingSideBarQuery = { __typename?: 'Query', awsListing?: { __typename?: 'AwsListing', status?: string | null, id: string, revision_of_product_id_internal?: string | null, name?: string | null, marketplace_url?: string | null, vendorid?: string | null, marketplace_id?: string | null, listing_type?: string | null, registration_hosting?: string | null } | null };

export type AwsListingSideBarCopyAwsListingMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AwsListingSideBarCopyAwsListingMutation = { __typename?: 'Mutation', copyAwsListing?: { __typename?: 'AwsListing', id: string } | null };

export type AwsListingSideBarSubmitAwsListingMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AwsListingSideBarSubmitAwsListingMutation = { __typename?: 'Mutation', submitAwsListingForReview?: { __typename?: 'AwsListing', id: string, status?: string | null } | null };

export type AwsListingSideBarDeleteAwsListingMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AwsListingSideBarDeleteAwsListingMutation = { __typename?: 'Mutation', deleteAwsListing?: any | null };

export type AwsProductDemoFormSectionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AwsProductDemoFormSectionQuery = { __typename?: 'Query', awsListing?: { __typename?: 'AwsListing', id: string, status?: string | null, last_imported_at?: string | null, demo?: { __typename?: 'AwsDemo', email?: string | null, registration?: string | null, homepage?: string | null, product_feature?: string | null } | null, revision_of_listing?: { __typename?: 'AwsListing', id: string } | null } | null };

export type UpdateAwsProductDemoFormSectionMutationVariables = Exact<{
  updates: AwsListingInput;
}>;


export type UpdateAwsProductDemoFormSectionMutation = { __typename?: 'Mutation', updateAwsListing?: { __typename?: 'AwsListing', id: string, demo?: { __typename?: 'AwsDemo', email?: string | null, registration?: string | null, homepage?: string | null, product_feature?: string | null } | null } | null };

export type AwsProductOverviewFormSectionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AwsProductOverviewFormSectionQuery = { __typename?: 'Query', awsListing?: { __typename?: 'AwsListing', id: string, status?: string | null, full_description?: string | null, product_video_url?: string | null, highlights?: Array<string> | null } | null };

export type UpdateAwsProductOverviewFormSectionMutationVariables = Exact<{
  updates: AwsListingInput;
}>;


export type UpdateAwsProductOverviewFormSectionMutation = { __typename?: 'Mutation', updateAwsListing?: { __typename?: 'AwsListing', id: string, status?: string | null, full_description?: string | null, product_video_url?: string | null, highlights?: Array<string> | null } | null };

export type AwsSupportFormSectionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AwsSupportFormSectionQuery = { __typename?: 'Query', awsListing?: { __typename?: 'AwsListing', id: string, status?: string | null, contact_email?: string | null, contact_support_url?: string | null, support?: { __typename?: 'AwsSupport', details?: string | null, refund_policy?: string | null, support_items?: Array<{ __typename?: 'AwsSupportItem', display_name?: string | null, support_resource?: string | null }> | null } | null } | null };

export type UpdateAwsSupportFormSectionMutationVariables = Exact<{
  updates: AwsListingInput;
}>;


export type UpdateAwsSupportFormSectionMutation = { __typename?: 'Mutation', updateAwsListing?: { __typename?: 'AwsListing', id: string, status?: string | null, contact_email?: string | null, contact_support_url?: string | null, support?: { __typename?: 'AwsSupport', details?: string | null, refund_policy?: string | null, support_items?: Array<{ __typename?: 'AwsSupportItem', display_name?: string | null, support_resource?: string | null }> | null } | null } | null };

export type AwsSyncWithSalesforceFormSectionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AwsSyncWithSalesforceFormSectionQuery = { __typename?: 'Query', awsListing?: { __typename?: 'AwsListing', id: string, should_sync_listing_to_salesforce_app?: boolean | null } | null };

export type UpdateAwsShouldSyncListingToSalesforceAppMutationVariables = Exact<{
  updates: AwsListingInput;
}>;


export type UpdateAwsShouldSyncListingToSalesforceAppMutation = { __typename?: 'Mutation', updateAwsListing?: { __typename?: 'AwsListing', id: string, should_sync_listing_to_salesforce_app?: boolean | null } | null };

export type AwsVersionDetailsFormSectionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AwsVersionDetailsFormSectionQuery = { __typename?: 'Query', awsListing?: { __typename?: 'AwsListing', id: string, status?: string | null, version_detail?: { __typename?: 'AwsVersionDetail', ami_id?: string | null, architecture?: string | null, access_role_arn?: string | null, os_type?: string | null, os_version?: string | null, os_version_title?: string | null, user_name?: string | null, scanning_port?: string | null, security_groups?: Array<string> | null, release_notes?: string | null, access_instructions?: string | null, usage_instructions?: string | null, third_party_software?: string | null } | null } | null };

export type UpdateAwsVersionDetailsFormSectionMutationVariables = Exact<{
  updates: AwsListingInput;
}>;


export type UpdateAwsVersionDetailsFormSectionMutation = { __typename?: 'Mutation', updateAwsListing?: { __typename?: 'AwsListing', id: string, status?: string | null, version_detail?: { __typename?: 'AwsVersionDetail', ami_id?: string | null, architecture?: string | null, access_role_arn?: string | null, os_type?: string | null, os_version?: string | null, os_version_title?: string | null, user_name?: string | null, scanning_port?: string | null, security_groups?: Array<string> | null, release_notes?: string | null, access_instructions?: string | null, usage_instructions?: string | null, third_party_software?: string | null } | null } | null };

export type AwsOfferAvailabilityAndPricingFormSectionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AwsOfferAvailabilityAndPricingFormSectionQuery = { __typename?: 'Query', awsListing?: { __typename?: 'AwsListing', id: string, vendorid?: string | null, status?: string | null, listing_type?: string | null, revision_of_product_id_internal?: string | null, entitlement_dimension_map?: any | null, dimensions?: Array<{ __typename?: 'AwsDimension', name: string }> | null, pricing?: { __typename?: 'AwsPricing', buyer_contract_type?: string | null, contract_durations?: Array<string> | null, product_unit?: string | null, contract_dimensions?: Array<{ __typename?: 'AwsPricingContractDimension', description?: string | null, name?: string | null, sku?: string | null, position?: number | null, prices?: { __typename?: 'AwsPricingContractDimensionPrices', monthly?: string | null, one_year?: string | null, two_year?: string | null, three_year?: string | null } | null }> | null, usage_fees?: Array<{ __typename?: 'AwsUsageFee', description?: string | null, position?: number | null, price?: number | null, sku?: string | null }> | null, markets?: { __typename?: 'AwsPricingMarkets', countries?: Array<string> | null, target_type?: AwsPricingMarketsTargetTypes | null } | null } | null, revision_of_listing?: { __typename?: 'AwsListing', id: string, listing_type?: string | null, pricing?: { __typename?: 'AwsPricing', buyer_contract_type?: string | null, contract_durations?: Array<string> | null, product_unit?: string | null, contract_dimensions?: Array<{ __typename?: 'AwsPricingContractDimension', description?: string | null, name?: string | null, sku?: string | null, position?: number | null, prices?: { __typename?: 'AwsPricingContractDimensionPrices', monthly?: string | null, one_year?: string | null, two_year?: string | null, three_year?: string | null } | null }> | null, usage_fees?: Array<{ __typename?: 'AwsUsageFee', description?: string | null, position?: number | null, price?: number | null, sku?: string | null }> | null, markets?: { __typename?: 'AwsPricingMarkets', countries?: Array<string> | null, target_type?: AwsPricingMarketsTargetTypes | null } | null } | null } | null } | null };

export type UpdateAwsOfferAvailabilityAndPricingFormSectionMutationVariables = Exact<{
  updates: AwsListingInput;
}>;


export type UpdateAwsOfferAvailabilityAndPricingFormSectionMutation = { __typename?: 'Mutation', updateAwsListing?: { __typename?: 'AwsListing', id: string, status?: string | null, entitlement_dimension_map?: any | null, listing_type?: string | null, revision_of_product_id_internal?: string | null, relist_of_product_id_internal?: string | null, dimensions?: Array<{ __typename?: 'AwsDimension', name: string }> | null, pricing?: { __typename?: 'AwsPricing', buyer_contract_type?: string | null, contract_durations?: Array<string> | null, product_unit?: string | null, contract_dimensions?: Array<{ __typename?: 'AwsPricingContractDimension', description?: string | null, name?: string | null, sku?: string | null, position?: number | null, prices?: { __typename?: 'AwsPricingContractDimensionPrices', monthly?: string | null, one_year?: string | null, two_year?: string | null, three_year?: string | null } | null }> | null, usage_fees?: Array<{ __typename?: 'AwsUsageFee', description?: string | null, position?: number | null, price?: number | null, sku?: string | null }> | null, markets?: { __typename?: 'AwsPricingMarkets', countries?: Array<string> | null, target_type?: AwsPricingMarketsTargetTypes | null } | null } | null, revision_of_listing?: { __typename?: 'AwsListing', id: string, listing_type?: string | null, pricing?: { __typename?: 'AwsPricing', buyer_contract_type?: string | null, contract_durations?: Array<string> | null, product_unit?: string | null, contract_dimensions?: Array<{ __typename?: 'AwsPricingContractDimension', description?: string | null, name?: string | null, sku?: string | null, position?: number | null, prices?: { __typename?: 'AwsPricingContractDimensionPrices', monthly?: string | null, one_year?: string | null, two_year?: string | null, three_year?: string | null } | null }> | null, usage_fees?: Array<{ __typename?: 'AwsUsageFee', description?: string | null, position?: number | null, price?: number | null, sku?: string | null }> | null, markets?: { __typename?: 'AwsPricingMarkets', countries?: Array<string> | null, target_type?: AwsPricingMarketsTargetTypes | null } | null } | null } | null } | null };

export type AwsRegistrationFieldsFormSectionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AwsRegistrationFieldsFormSectionQuery = { __typename?: 'Query', awsListing?: { __typename?: 'AwsListing', id: string, registration_page_fields?: Array<{ __typename?: 'AwsRegistrationField', data_type?: string | null, default?: boolean | null, display_title?: string | null, enabled?: boolean | null, required?: boolean | null, tackle_required?: boolean | null, title?: string | null, validation_type?: AwsRegistrationFieldValidationType | null, options?: Array<{ __typename?: 'AwsRegistrationFieldOptions', label?: string | null, value?: string | null }> | null }> | null } | null };

export type UpdateAwsRegistrationFieldsFormSectionMutationVariables = Exact<{
  updates: AwsListingInput;
}>;


export type UpdateAwsRegistrationFieldsFormSectionMutation = { __typename?: 'Mutation', updateAwsListing?: { __typename?: 'AwsListing', id: string, registration_page_fields?: Array<{ __typename?: 'AwsRegistrationField', data_type?: string | null, default?: boolean | null, display_title?: string | null, enabled?: boolean | null, required?: boolean | null, tackle_required?: boolean | null, title?: string | null, validation_type?: AwsRegistrationFieldValidationType | null, options?: Array<{ __typename?: 'AwsRegistrationFieldOptions', label?: string | null, value?: string | null }> | null }> | null } | null };

export type AwsListingRegistrationQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AwsListingRegistrationQuery = { __typename?: 'Query', awsListing?: { __typename?: 'AwsListing', id: string, registration_hosting?: string | null } | null };

export type AwsRegistrationHostingFormSectionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AwsRegistrationHostingFormSectionQuery = { __typename?: 'Query', awsListing?: { __typename?: 'AwsListing', id: string, registration_hosting?: string | null, registration_redirect?: { __typename?: 'AwsRegistrationRedirect', url?: string | null, params?: any | null } | null } | null };

export type UpdateAwsRegistrationHostingFormSectionMutationVariables = Exact<{
  updates: AwsListingInput;
}>;


export type UpdateAwsRegistrationHostingFormSectionMutation = { __typename?: 'Mutation', updateAwsListing?: { __typename?: 'AwsListing', id: string, registration_hosting?: string | null, registration_redirect?: { __typename?: 'AwsRegistrationRedirect', url?: string | null, params?: any | null } | null } | null };

export type AwsRegistrationSuccessFormSectionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AwsRegistrationSuccessFormSectionQuery = { __typename?: 'Query', awsListing?: { __typename?: 'AwsListing', id: string, registration?: { __typename?: 'AwsRegistration', success?: { __typename?: 'AwsRegistrationSuccess', message?: string | null, redirect_url?: string | null } | null } | null } | null };

export type UpdateAwsRegistrationSuccessFormSectionMutationVariables = Exact<{
  updates: AwsListingInput;
}>;


export type UpdateAwsRegistrationSuccessFormSectionMutation = { __typename?: 'Mutation', updateAwsListing?: { __typename?: 'AwsListing', id: string, registration?: { __typename?: 'AwsRegistration', success?: { __typename?: 'AwsRegistrationSuccess', message?: string | null, redirect_url?: string | null } | null } | null } | null };

export type AwsRegistrationThemeFormSectionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AwsRegistrationThemeFormSectionQuery = { __typename?: 'Query', awsListing?: { __typename?: 'AwsListing', id: string, registration?: { __typename?: 'AwsRegistration', form?: { __typename?: 'AwsRegistrationForm', logo_url?: string | null, button?: { __typename?: 'AwsRegistrationFormButton', background_color?: string | null, color?: string | null } | null } | null, hero?: { __typename?: 'AwsRegistrationHero', background_color?: string | null, background_image_url?: string | null } | null } | null } | null };

export type UpdateAwsRegistrationThemeFormSectionMutationVariables = Exact<{
  updates: AwsListingInput;
}>;


export type UpdateAwsRegistrationThemeFormSectionMutation = { __typename?: 'Mutation', updateAwsListing?: { __typename?: 'AwsListing', id: string, registration?: { __typename?: 'AwsRegistration', form?: { __typename?: 'AwsRegistrationForm', logo_url?: string | null, button?: { __typename?: 'AwsRegistrationFormButton', background_color?: string | null, color?: string | null } | null } | null, hero?: { __typename?: 'AwsRegistrationHero', background_color?: string | null, background_image_url?: string | null } | null } | null } | null };

export type AzureContractMetadataFormSectionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AzureContractMetadataFormSectionQuery = { __typename?: 'Query', azureListing?: { __typename?: 'AzureListing', id: string, contract_standard_fields?: Array<{ __typename?: 'AzurePrivateOfferMetadataStandardField', cloud_field?: boolean | null, title?: string | null }> | null } | null };

export type UpdateAzureContractMetadataFormSectionMutationVariables = Exact<{
  updates: AzureListingInput;
}>;


export type UpdateAzureContractMetadataFormSectionMutation = { __typename?: 'Mutation', updateAzureListing?: { __typename?: 'AzureListing', id: string, contract_standard_fields?: Array<{ __typename?: 'AzurePrivateOfferMetadataStandardField', cloud_field?: boolean | null, title?: string | null }> | null } | null };

export type AzureGeneralInformationFormSectionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AzureGeneralInformationFormSectionQuery = { __typename?: 'Query', azureListing?: { __typename?: 'AzureListing', id: string, status?: string | null, logo?: string | null, name?: string | null, short_description?: string | null } | null };

export type UpdateAzureGeneralInformationFormSectionMutationVariables = Exact<{
  updates: AzureListingInput;
}>;


export type UpdateAzureGeneralInformationFormSectionMutation = { __typename?: 'Mutation', updateAzureListing?: { __typename?: 'AzureListing', id: string, status?: string | null, logo?: string | null, name?: string | null, short_description?: string | null } | null };

export type AzureLegalFormSectionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AzureLegalFormSectionQuery = { __typename?: 'Query', azureListing?: { __typename?: 'AzureListing', id: string, status?: string | null, privacy_policy_link?: string | null, license?: { __typename?: 'AzureLicenseAgreement', contract_terms?: string | null, contract_type?: string | null, eula_url?: string | null } | null } | null };

export type UpdateAzureLegalFormSectionMutationVariables = Exact<{
  updates: AzureListingInput;
}>;


export type UpdateAzureLegalFormSectionMutation = { __typename?: 'Mutation', updateAzureListing?: { __typename?: 'AzureListing', id: string, status?: string | null, privacy_policy_link?: string | null, license?: { __typename?: 'AzureLicenseAgreement', contract_terms?: string | null, contract_type?: string | null, eula_url?: string | null } | null } | null };

export type AzureListingQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AzureListingQuery = { __typename?: 'Query', azureListing?: { __typename?: 'AzureListing', id: string, name?: string | null, vendorid?: string | null, marketplace_id?: string | null, marketplace_url?: string | null, status?: string | null, viewed_advanced_tab?: boolean | null, registration_hosting?: string | null, revision_of_listing?: { __typename?: 'AzureListing', id: string, name?: string | null } | null } | null };

export type SubmitAzureListingForReviewMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SubmitAzureListingForReviewMutation = { __typename?: 'Mutation', submitAzureListingForReview?: { __typename?: 'AzureListing', id: string, status?: string | null } | null };

export type AzureListingAdvancedQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AzureListingAdvancedQuery = { __typename?: 'Query', azureListing?: { __typename?: 'AzureListing', id: string, viewed_advanced_tab?: boolean | null, status?: string | null } | null };

export type UpdateAzureListingAdvancedMutationVariables = Exact<{
  updates: AzureListingInput;
}>;


export type UpdateAzureListingAdvancedMutation = { __typename?: 'Mutation', updateAzureListing?: { __typename?: 'AzureListing', id: string, viewed_advanced_tab?: boolean | null } | null };

export type AzurePreviewQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AzurePreviewQuery = { __typename?: 'Query', azureListing?: { __typename?: 'AzureListing', full_description?: string | null, name?: string | null, logo?: string | null, short_description?: string | null, privacy_policy_link?: string | null, overview_urls?: Array<{ __typename?: 'AzureOverviewUrl', url?: string | null, title?: string | null }> | null, media_image?: Array<{ __typename?: 'AzureMediaImage', caption?: string | null, image_url?: string | null }> | null, media_video?: Array<{ __typename?: 'AzureMediaVideo', thumbnail?: string | null, title?: string | null }> | null, categories?: Array<{ __typename?: 'AzureCategory', category?: string | null }> | null, support?: { __typename?: 'AzureSupport', support_url?: string | null, support_documents?: Array<{ __typename?: 'AzureSupportDocument', name?: string | null, document_url?: string | null }> | null } | null, pricing?: { __typename?: 'AzurePricing', pricing_type?: string | null, plans?: Array<{ __typename?: 'AzurePlan', description?: string | null, name?: string | null, plan_id?: string | null, plan_uuid?: string | null, visibility?: { __typename?: 'AzureVisibility', public?: boolean | null } | null, billing_terms?: Array<{ __typename?: 'AzureBillingTerm', price_per_payment_in_usd?: number | null, type?: string | null, value?: number | null, payment_option?: { __typename?: 'AzurePaymentOption', type?: string | null, value?: number | null } | null }> | null, user_limits?: { __typename?: 'AzureUserLimit', min?: number | null, max?: number | null } | null }> | null, metrics?: Array<{ __typename?: 'AzureMetric', display_name?: string | null, product_unit?: string | null, sku?: string | null, plan_pricing?: Array<{ __typename?: 'AzurePlanPricing', plan_uuid?: string | null, price_per_unit?: number | null, base_quantity?: Array<{ __typename?: 'AzureBaseIncludedQuantity', quantity?: number | null, type?: string | null, value?: number | null }> | null }> | null }> | null } | null, vendor?: { __typename?: 'Vendor', id: string, name?: string | null } | null } | null };

export type AzureListingSideBarQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AzureListingSideBarQuery = { __typename?: 'Query', azureListing?: { __typename?: 'AzureListing', status?: string | null, id: string, revision_of_product_id_internal?: string | null, name?: string | null, marketplace_url?: string | null, vendorid?: string | null, marketplace_id?: string | null, listing_type?: string | null, registration_hosting?: string | null } | null };

export type AzureListingSideBarCopyAzureListingMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AzureListingSideBarCopyAzureListingMutation = { __typename?: 'Mutation', copyAzureListing?: { __typename?: 'AzureListing', id: string } | null };

export type AzureListingSideBarSubmitAzureListingMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AzureListingSideBarSubmitAzureListingMutation = { __typename?: 'Mutation', submitAzureListingForReview?: { __typename?: 'AzureListing', id: string, status?: string | null } | null };

export type AzureListingSideBarDeleteAzureListingMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AzureListingSideBarDeleteAzureListingMutation = { __typename?: 'Mutation', deleteAzureListing?: any | null };

export type AzureMediaFormSectionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AzureMediaFormSectionQuery = { __typename?: 'Query', azureListing?: { __typename?: 'AzureListing', id: string, status?: string | null, media_image?: Array<{ __typename?: 'AzureMediaImage', caption?: string | null, image_url?: string | null }> | null, media_video?: Array<{ __typename?: 'AzureMediaVideo', title?: string | null, thumbnail?: string | null, video_url?: string | null }> | null } | null };

export type UpdateAzureMediaFormSectionMutationVariables = Exact<{
  updates: AzureListingInput;
}>;


export type UpdateAzureMediaFormSectionMutation = { __typename?: 'Mutation', updateAzureListing?: { __typename?: 'AzureListing', id: string, status?: string | null, media_image?: Array<{ __typename?: 'AzureMediaImage', caption?: string | null, image_url?: string | null }> | null, media_video?: Array<{ __typename?: 'AzureMediaVideo', title?: string | null, thumbnail?: string | null, video_url?: string | null }> | null } | null };

export type AzureProductOverviewFormSectionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AzureProductOverviewFormSectionQuery = { __typename?: 'Query', azureListing?: { __typename?: 'AzureListing', id: string, status?: string | null, full_description?: string | null, getting_started_instructions?: string | null, overview_urls?: Array<{ __typename?: 'AzureOverviewUrl', title?: string | null, url?: string | null }> | null } | null };

export type UpdateAzureProductOverviewFormSectionMutationVariables = Exact<{
  updates: AzureListingInput;
}>;


export type UpdateAzureProductOverviewFormSectionMutation = { __typename?: 'Mutation', updateAzureListing?: { __typename?: 'AzureListing', id: string, status?: string | null, full_description?: string | null, getting_started_instructions?: string | null, overview_urls?: Array<{ __typename?: 'AzureOverviewUrl', title?: string | null, url?: string | null }> | null } | null };

export type AzureSearchKeywordsAndProductCategoriesFormSectionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AzureSearchKeywordsAndProductCategoriesFormSectionQuery = { __typename?: 'Query', azureListing?: { __typename?: 'AzureListing', id: string, status?: string | null, search_keywords?: Array<string> | null, categories?: Array<{ __typename?: 'AzureCategory', category?: string | null, subcategory_1?: string | null, subcategory_2?: string | null }> | null, industries?: Array<{ __typename?: 'AzureIndustry', industry?: string | null, vertical_1?: string | null, vertical_2?: string | null }> | null } | null };

export type UpdateAzureSearchKeywordsAndProductCategoriesFormSectionMutationVariables = Exact<{
  updates: AzureListingInput;
}>;


export type UpdateAzureSearchKeywordsAndProductCategoriesFormSectionMutation = { __typename?: 'Mutation', updateAzureListing?: { __typename?: 'AzureListing', id: string, status?: string | null, search_keywords?: Array<string> | null, categories?: Array<{ __typename?: 'AzureCategory', category?: string | null, subcategory_1?: string | null, subcategory_2?: string | null }> | null, industries?: Array<{ __typename?: 'AzureIndustry', industry?: string | null, vertical_1?: string | null, vertical_2?: string | null }> | null } | null };

export type AzureSupportFormSectionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AzureSupportFormSectionQuery = { __typename?: 'Query', azureListing?: { __typename?: 'AzureListing', id: string, status?: string | null, contact_email?: string | null, contact_support_url?: string | null, support?: { __typename?: 'AzureSupport', support_email?: string | null, support_name?: string | null, support_phone?: string | null, support_url?: string | null, engineering_email?: string | null, engineering_name?: string | null, engineering_phone?: string | null, support_documents?: Array<{ __typename?: 'AzureSupportDocument', document_url?: string | null, name?: string | null }> | null } | null } | null };

export type UpdateAzureSupportFormSectionMutationVariables = Exact<{
  updates: AzureListingInput;
}>;


export type UpdateAzureSupportFormSectionMutation = { __typename?: 'Mutation', updateAzureListing?: { __typename?: 'AzureListing', id: string, status?: string | null, contact_email?: string | null, contact_support_url?: string | null, support?: { __typename?: 'AzureSupport', support_email?: string | null, support_name?: string | null, support_phone?: string | null, support_url?: string | null, engineering_email?: string | null, engineering_name?: string | null, engineering_phone?: string | null, support_documents?: Array<{ __typename?: 'AzureSupportDocument', document_url?: string | null, name?: string | null }> | null } | null } | null };

export type AzureSyncWithSalesforceFormSectionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AzureSyncWithSalesforceFormSectionQuery = { __typename?: 'Query', azureListing?: { __typename?: 'AzureListing', id: string, should_sync_listing_to_salesforce_app?: boolean | null } | null };

export type UpdateAzureShouldSyncListingToSalesforceAppMutationVariables = Exact<{
  updates: AzureListingInput;
}>;


export type UpdateAzureShouldSyncListingToSalesforceAppMutation = { __typename?: 'Mutation', updateAzureListing?: { __typename?: 'AzureListing', id: string, should_sync_listing_to_salesforce_app?: boolean | null } | null };

export type AzurePricingAndMetricsFormSectionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AzurePricingAndMetricsFormSectionQuery = { __typename?: 'Query', azureListing?: { __typename?: 'AzureListing', id: string, status?: string | null, pricing?: { __typename?: 'AzurePricing', pricing_type?: string | null, plans?: Array<{ __typename?: 'AzurePlan', plan_id?: string | null, plan_uuid?: string | null, name?: string | null, description?: string | null, markets?: Array<string> | null, free_trial?: boolean | null, user_limits?: { __typename?: 'AzureUserLimit', max?: number | null, min?: number | null } | null, billing_terms?: Array<{ __typename?: 'AzureBillingTerm', type?: string | null, value?: number | null, price_per_payment_in_usd?: number | null, payment_option?: { __typename?: 'AzurePaymentOption', type?: string | null, value?: number | null } | null }> | null, visibility?: { __typename?: 'AzureVisibility', public?: boolean | null, allowed_tenants?: Array<{ __typename?: 'AzureAllowedTenant', description?: string | null, tenant_id?: string | null }> | null } | null }> | null, metrics?: Array<{ __typename?: 'AzureMetric', display_name?: string | null, product_unit?: string | null, sku?: string | null, plan_pricing?: Array<{ __typename?: 'AzurePlanPricing', plan_uuid?: string | null, price_per_unit?: number | null, base_quantity?: Array<{ __typename?: 'AzureBaseIncludedQuantity', quantity?: number | null, type?: string | null, unlimited?: boolean | null, value?: number | null }> | null }> | null }> | null } | null } | null };

export type UpdateAzurePricingAndMetricsFormSectionMutationVariables = Exact<{
  updates: AzureListingInput;
}>;


export type UpdateAzurePricingAndMetricsFormSectionMutation = { __typename?: 'Mutation', updateAzureListing?: { __typename?: 'AzureListing', id: string, status?: string | null, pricing?: { __typename?: 'AzurePricing', pricing_type?: string | null, plans?: Array<{ __typename?: 'AzurePlan', plan_id?: string | null, plan_uuid?: string | null, name?: string | null, description?: string | null, markets?: Array<string> | null, free_trial?: boolean | null, user_limits?: { __typename?: 'AzureUserLimit', max?: number | null, min?: number | null } | null, billing_terms?: Array<{ __typename?: 'AzureBillingTerm', type?: string | null, value?: number | null, price_per_payment_in_usd?: number | null, payment_option?: { __typename?: 'AzurePaymentOption', type?: string | null, value?: number | null } | null }> | null, visibility?: { __typename?: 'AzureVisibility', public?: boolean | null, allowed_tenants?: Array<{ __typename?: 'AzureAllowedTenant', description?: string | null, tenant_id?: string | null }> | null } | null }> | null, metrics?: Array<{ __typename?: 'AzureMetric', display_name?: string | null, product_unit?: string | null, sku?: string | null, plan_pricing?: Array<{ __typename?: 'AzurePlanPricing', plan_uuid?: string | null, price_per_unit?: number | null, base_quantity?: Array<{ __typename?: 'AzureBaseIncludedQuantity', quantity?: number | null, type?: string | null, unlimited?: boolean | null, value?: number | null }> | null }> | null }> | null } | null } | null };

export type AzureRegistrationFieldsFormSectionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AzureRegistrationFieldsFormSectionQuery = { __typename?: 'Query', azureListing?: { __typename?: 'AzureListing', id: string, registration_page_fields?: Array<{ __typename?: 'AzureRegistrationField', data_type?: string | null, default?: boolean | null, display_title?: string | null, enabled?: boolean | null, required?: boolean | null, tackle_required?: boolean | null, title?: string | null, validation_type?: AzureRegistrationFieldValidationType | null, options?: Array<{ __typename?: 'AzureRegistrationFieldOptions', label?: string | null, value?: string | null }> | null }> | null } | null };

export type UpdateAzureRegistrationFieldsFormSectionMutationVariables = Exact<{
  updates: AzureListingInput;
}>;


export type UpdateAzureRegistrationFieldsFormSectionMutation = { __typename?: 'Mutation', updateAzureListing?: { __typename?: 'AzureListing', id: string, registration_page_fields?: Array<{ __typename?: 'AzureRegistrationField', data_type?: string | null, default?: boolean | null, display_title?: string | null, enabled?: boolean | null, required?: boolean | null, tackle_required?: boolean | null, title?: string | null, validation_type?: AzureRegistrationFieldValidationType | null, options?: Array<{ __typename?: 'AzureRegistrationFieldOptions', label?: string | null, value?: string | null }> | null }> | null } | null };

export type AzureListingRegistrationQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AzureListingRegistrationQuery = { __typename?: 'Query', azureListing?: { __typename?: 'AzureListing', id: string, registration_hosting?: string | null } | null };

export type AzureRegistrationHostingFormSectionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AzureRegistrationHostingFormSectionQuery = { __typename?: 'Query', azureListing?: { __typename?: 'AzureListing', id: string, registration_hosting?: string | null, registration_redirect?: { __typename?: 'AzureRegistrationRedirect', url?: string | null, params?: any | null } | null } | null };

export type UpdateAzureRegistrationHostingFormSectionMutationVariables = Exact<{
  updates: AzureListingInput;
}>;


export type UpdateAzureRegistrationHostingFormSectionMutation = { __typename?: 'Mutation', updateAzureListing?: { __typename?: 'AzureListing', id: string, registration_hosting?: string | null, registration_redirect?: { __typename?: 'AzureRegistrationRedirect', url?: string | null, params?: any | null } | null } | null };

export type AzureRegistrationSuccessFormSectionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AzureRegistrationSuccessFormSectionQuery = { __typename?: 'Query', azureListing?: { __typename?: 'AzureListing', id: string, registration?: { __typename?: 'AzureRegistration', success?: { __typename?: 'AzureRegistrationSuccess', message?: string | null, redirect_url?: string | null } | null } | null } | null };

export type UpdateAzureRegistrationSuccessFormSectionMutationVariables = Exact<{
  updates: AzureListingInput;
}>;


export type UpdateAzureRegistrationSuccessFormSectionMutation = { __typename?: 'Mutation', updateAzureListing?: { __typename?: 'AzureListing', id: string, registration?: { __typename?: 'AzureRegistration', success?: { __typename?: 'AzureRegistrationSuccess', message?: string | null, redirect_url?: string | null } | null } | null } | null };

export type AzureRegistrationThemeFormSectionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AzureRegistrationThemeFormSectionQuery = { __typename?: 'Query', azureListing?: { __typename?: 'AzureListing', id: string, registration?: { __typename?: 'AzureRegistration', form?: { __typename?: 'AzureRegistrationForm', logo_url?: string | null, button?: { __typename?: 'AzureRegistrationFormButton', background_color?: string | null, color?: string | null } | null } | null, hero?: { __typename?: 'AzureRegistrationHero', background_color?: string | null, background_image_url?: string | null } | null } | null } | null };

export type UpdateAzureRegistrationThemeFormSectionMutationVariables = Exact<{
  updates: AzureListingInput;
}>;


export type UpdateAzureRegistrationThemeFormSectionMutation = { __typename?: 'Mutation', updateAzureListing?: { __typename?: 'AzureListing', id: string, registration?: { __typename?: 'AzureRegistration', form?: { __typename?: 'AzureRegistrationForm', logo_url?: string | null, button?: { __typename?: 'AzureRegistrationFormButton', background_color?: string | null, color?: string | null } | null } | null, hero?: { __typename?: 'AzureRegistrationHero', background_color?: string | null, background_image_url?: string | null } | null } | null } | null };

export type CreateS3PresignedUrlMutationVariables = Exact<{
  data: S3Input;
}>;


export type CreateS3PresignedUrlMutation = { __typename?: 'Mutation', createS3PresignedUrl?: { __typename?: 'S3PresignedUrlResponse', url?: string | null, fields?: any | null } | null };

export type ImportAwsListingButtonQueryVariables = Exact<{ [key: string]: never; }>;


export type ImportAwsListingButtonQuery = { __typename?: 'Query', awsMarketplaceSaasProducts?: Array<{ __typename?: 'AwsMarketplaceSaasProduct', EntityId: string, LastModifiedDate?: string | null, Name?: string | null, Visibility?: string | null, EntityType?: string | null, id: string }> | null };

export type ImportAzureListingButtonQueryVariables = Exact<{ [key: string]: never; }>;


export type ImportAzureListingButtonQuery = { __typename?: 'Query', azureMarketplaceSaasProducts?: Array<{ __typename?: 'AzureMarketplaceSaasProduct', id?: string | null, status?: string | null, created_date?: string | null, type?: string | null, alias?: string | null, identity?: { __typename?: 'AzureMarketplaceSaasProductIdentity', externalId?: string | null } | null }> | null };

export type ListingsImportAwsListingMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ListingsImportAwsListingMutation = { __typename?: 'Mutation', importAwsListing?: { __typename: 'AwsListing', id: string, name?: string | null, status?: string | null, listing_type?: string | null } | null };

export type ListingsImportAzureListingMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ListingsImportAzureListingMutation = { __typename?: 'Mutation', importAzureListing?: { __typename: 'AzureListing', id: string, status?: string | null, listing_type?: string | null } | null };

export type ImportListingButtonVendorConfigurationQueryVariables = Exact<{ [key: string]: never; }>;


export type ImportListingButtonVendorConfigurationQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, vendor?: { __typename?: 'Vendor', id: string, configuration?: { __typename?: 'VendorConfiguration', id: string, aws?: { __typename?: 'VendorAwsConfig', assume_role?: { __typename?: 'VendorAwsAssumeRoleConfig', role_arn?: string | null } | null } | null, azure?: { __typename?: 'VendorAzureConfig', exp_date?: string | null } | null } | null } | null } | null };

export type ListingHeaderForAwsByListingIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ListingHeaderForAwsByListingIdQuery = { __typename?: 'Query', awsListing?: { __typename?: 'AwsListing', status?: string | null, id: string, revision_of_product_id_internal?: string | null, relist_of_product_id_internal?: string | null, name?: string | null } | null };

export type ListingHeaderForGcpByListingIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ListingHeaderForGcpByListingIdQuery = { __typename?: 'Query', gcpListing?: { __typename?: 'GcpListing', status?: string | null, id: string, revision_of_product_id_internal?: string | null, name?: string | null } | null };

export type ListingHeaderForAzureByListingIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ListingHeaderForAzureByListingIdQuery = { __typename?: 'Query', azureListing?: { __typename?: 'AzureListing', status?: string | null, id: string, revision_of_product_id_internal?: string | null, name?: string | null } | null };

export type ListingHeaderForRedHatByListingIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ListingHeaderForRedHatByListingIdQuery = { __typename?: 'Query', redHatListing?: { __typename?: 'RedHatListing', status?: string | null, id: string, revision_of_product_id_internal?: string | null, name?: string | null } | null };

export type GcpFeaturesAndPlansAndPricingFormSectionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GcpFeaturesAndPlansAndPricingFormSectionQuery = { __typename?: 'Query', gcpListing?: { __typename?: 'GcpListing', id: string, status?: string | null, features?: Array<{ __typename?: 'GcpFeature', description?: string | null, feature_id?: string | null, label?: string | null }> | null, plans?: Array<{ __typename?: 'GcpPlan', name?: string | null, plan_id?: string | null, public?: boolean | null, feature_ids?: Array<string> | null, pricing?: any | null }> | null } | null };

export type UpdateGcpFeaturesAndPlansAndPricingFormSectionMutationVariables = Exact<{
  updates: GcpListingInput;
}>;


export type UpdateGcpFeaturesAndPlansAndPricingFormSectionMutation = { __typename?: 'Mutation', updateGcpListing?: { __typename?: 'GcpListing', id: string, status?: string | null, features?: Array<{ __typename?: 'GcpFeature', description?: string | null, feature_id?: string | null, label?: string | null }> | null, plans?: Array<{ __typename?: 'GcpPlan', name?: string | null, plan_id?: string | null, public?: boolean | null, feature_ids?: Array<string> | null, pricing?: any | null }> | null } | null };

export type GcpContractMetadataFormSectionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GcpContractMetadataFormSectionQuery = { __typename?: 'Query', gcpListing?: { __typename?: 'GcpListing', id: string, contract_standard_fields?: Array<{ __typename?: 'GcpPrivateOfferMetadataStandardField', cloud_field?: boolean | null, title?: string | null }> | null } | null };

export type UpdateGcpContractMetadataFormSectionMutationVariables = Exact<{
  updates: GcpListingInput;
}>;


export type UpdateGcpContractMetadataFormSectionMutation = { __typename?: 'Mutation', updateGcpListing?: { __typename?: 'GcpListing', id: string, contract_standard_fields?: Array<{ __typename?: 'GcpPrivateOfferMetadataStandardField', cloud_field?: boolean | null, title?: string | null }> | null } | null };

export type GcpDocumentationAndSupportFormSectionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GcpDocumentationAndSupportFormSectionQuery = { __typename?: 'Query', gcpListing?: { __typename?: 'GcpListing', id: string, status?: string | null, contact_email?: string | null, contact_support_url?: string | null, support_description?: string | null, support_url?: string | null, documentation?: Array<{ __typename?: 'GcpDocumentationResource', description?: string | null, resource_type?: string | null, url?: string | null }> | null } | null };

export type UpdateGcpDocumentationAndSupportFormSectionMutationVariables = Exact<{
  updates: GcpListingInput;
}>;


export type UpdateGcpDocumentationAndSupportFormSectionMutation = { __typename?: 'Mutation', updateGcpListing?: { __typename?: 'GcpListing', id: string, status?: string | null, contact_email?: string | null, contact_support_url?: string | null, support_description?: string | null, support_url?: string | null, documentation?: Array<{ __typename?: 'GcpDocumentationResource', description?: string | null, resource_type?: string | null, url?: string | null }> | null } | null };

export type GcpGeneralInformationFormSectionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GcpGeneralInformationFormSectionQuery = { __typename?: 'Query', gcpListing?: { __typename?: 'GcpListing', id: string, status?: string | null, logo?: string | null, name?: string | null, short_description?: string | null } | null };

export type UpdateGcpGeneralInformationFormSectionMutationVariables = Exact<{
  updates: GcpListingInput;
}>;


export type UpdateGcpGeneralInformationFormSectionMutation = { __typename?: 'Mutation', updateGcpListing?: { __typename?: 'GcpListing', id: string, status?: string | null, logo?: string | null, name?: string | null, short_description?: string | null } | null };

export type GcpLegalAndTaxFormSectionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GcpLegalAndTaxFormSectionQuery = { __typename?: 'Query', gcpListing?: { __typename?: 'GcpListing', id: string, status?: string | null, eula_url?: string | null, tax_category?: string | null, tax_witholding?: string | null, license_agreements?: Array<{ __typename?: 'GcpLicenseAgreement', title?: string | null, url?: string | null }> | null } | null };

export type UpdateGcpLegalAndTaxFormSectionMutationVariables = Exact<{
  updates: GcpListingInput;
}>;


export type UpdateGcpLegalAndTaxFormSectionMutation = { __typename?: 'Mutation', updateGcpListing?: { __typename?: 'GcpListing', id: string, status?: string | null, eula_url?: string | null, tax_category?: string | null, tax_witholding?: string | null, license_agreements?: Array<{ __typename?: 'GcpLicenseAgreement', title?: string | null, url?: string | null }> | null } | null };

export type GcpListingQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GcpListingQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, isSuperAdmin?: boolean | null } | null, gcpListing?: { __typename?: 'GcpListing', id: string, name?: string | null, vendorid?: string | null, marketplace_id?: string | null, marketplace_url?: string | null, status?: string | null, viewed_advanced_tab?: boolean | null, registration_hosting?: string | null, dimensions?: Array<{ __typename?: 'GcpDimension', meterable?: boolean | null }> | null, revision_of_listing?: { __typename?: 'GcpListing', id: string, name?: string | null } | null } | null };

export type SubmitGcpListingForReviewMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SubmitGcpListingForReviewMutation = { __typename?: 'Mutation', submitGcpListingForReview?: { __typename?: 'GcpListing', id: string, status?: string | null } | null };

export type GcpListingAdvancedQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GcpListingAdvancedQuery = { __typename?: 'Query', gcpListing?: { __typename?: 'GcpListing', id: string, viewed_advanced_tab?: boolean | null, status?: string | null } | null };

export type UpdateGcpListingAdvancedMutationVariables = Exact<{
  updates: GcpListingInput;
}>;


export type UpdateGcpListingAdvancedMutation = { __typename?: 'Mutation', updateGcpListing?: { __typename?: 'GcpListing', id: string, viewed_advanced_tab?: boolean | null } | null };

export type GcpListingPreviewQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GcpListingPreviewQuery = { __typename?: 'Query', gcpListing?: { __typename?: 'GcpListing', support_url?: string | null, support_description?: string | null, name?: string | null, logo?: string | null, short_description?: string | null, eula_url?: string | null, overview_url?: string | null, full_description?: string | null, categories?: Array<string> | null, vendor?: { __typename?: 'Vendor', id: string, name?: string | null } | null, plans?: Array<{ __typename?: 'GcpPlan', plan_id?: string | null, pricing?: any | null, name?: string | null, public?: boolean | null, feature_ids?: Array<string> | null }> | null, metrics_pricing?: Array<{ __typename?: 'GcpMetric', name?: string | null, unit?: string | null, price_per_unit?: Array<{ __typename?: 'GcpMetricPricePerUnit', price?: number | null, plan_id?: string | null }> | null }> | null, documentation?: Array<{ __typename?: 'GcpDocumentationResource', url?: string | null, resource_type?: string | null, description?: string | null }> | null, features?: Array<{ __typename?: 'GcpFeature', label?: string | null, feature_id?: string | null, description?: string | null }> | null } | null };

export type GcpListingSideBarQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GcpListingSideBarQuery = { __typename?: 'Query', gcpListing?: { __typename?: 'GcpListing', status?: string | null, id: string, revision_of_product_id_internal?: string | null, name?: string | null, marketplace_url?: string | null, vendorid?: string | null, marketplace_id?: string | null, listing_type?: string | null, registration_hosting?: string | null } | null };

export type GcpListingSideBarCopyGcpListingMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GcpListingSideBarCopyGcpListingMutation = { __typename?: 'Mutation', copyGcpListing?: { __typename?: 'GcpListing', id: string } | null };

export type GcpListingSideBarSubmitGcpListingMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GcpListingSideBarSubmitGcpListingMutation = { __typename?: 'Mutation', submitGcpListingForReview?: { __typename?: 'GcpListing', id: string, status?: string | null } | null };

export type GcpListingSideBarDeleteGcpListingMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GcpListingSideBarDeleteGcpListingMutation = { __typename?: 'Mutation', deleteGcpListing?: any | null };

export type GcpMetricsFormSectionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GcpMetricsFormSectionQuery = { __typename?: 'Query', gcpListing?: { __typename?: 'GcpListing', id: string, status?: string | null, metrics_pricing?: Array<{ __typename?: 'GcpMetric', name?: string | null, unit?: string | null, price_per_unit?: Array<{ __typename?: 'GcpMetricPricePerUnit', price?: number | null, plan_id?: string | null }> | null }> | null, plans?: Array<{ __typename?: 'GcpPlan', name?: string | null, plan_id?: string | null }> | null } | null };

export type UpdateGcpMetricsFormSectionMutationVariables = Exact<{
  updates: GcpListingInput;
}>;


export type UpdateGcpMetricsFormSectionMutation = { __typename?: 'Mutation', updateGcpListing?: { __typename?: 'GcpListing', id: string, status?: string | null, metrics_pricing?: Array<{ __typename?: 'GcpMetric', name?: string | null, unit?: string | null, price_per_unit?: Array<{ __typename?: 'GcpMetricPricePerUnit', price?: number | null, plan_id?: string | null }> | null }> | null } | null };

export type GcpProductOverviewFormSectionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GcpProductOverviewFormSectionQuery = { __typename?: 'Query', gcpListing?: { __typename?: 'GcpListing', id: string, status?: string | null, categories?: Array<string> | null, full_description?: string | null, overview_url?: string | null } | null };

export type UpdateGcpProductOverviewFormSectionMutationVariables = Exact<{
  updates: GcpListingInput;
}>;


export type UpdateGcpProductOverviewFormSectionMutation = { __typename?: 'Mutation', updateGcpListing?: { __typename?: 'GcpListing', id: string, status?: string | null, categories?: Array<string> | null, full_description?: string | null, overview_url?: string | null } | null };

export type GcpSearchKeywordsFormSectionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GcpSearchKeywordsFormSectionQuery = { __typename?: 'Query', gcpListing?: { __typename?: 'GcpListing', id: string, status?: string | null, metadata_keywords?: string | null, search_keywords?: string | null } | null };

export type UpdateGcpSearchKeywordsFormSectionMutationVariables = Exact<{
  updates: GcpListingInput;
}>;


export type UpdateGcpSearchKeywordsFormSectionMutation = { __typename?: 'Mutation', updateGcpListing?: { __typename?: 'GcpListing', id: string, status?: string | null, metadata_keywords?: string | null, search_keywords?: string | null } | null };

export type GcpSyncWithSalesforceFormSectionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GcpSyncWithSalesforceFormSectionQuery = { __typename?: 'Query', gcpListing?: { __typename?: 'GcpListing', id: string, should_sync_listing_to_salesforce_app?: boolean | null } | null };

export type UpdateGcpShouldSyncListingToSalesforceAppMutationVariables = Exact<{
  updates: GcpListingInput;
}>;


export type UpdateGcpShouldSyncListingToSalesforceAppMutation = { __typename?: 'Mutation', updateGcpListing?: { __typename?: 'GcpListing', id: string, should_sync_listing_to_salesforce_app?: boolean | null } | null };

export type GcpTechnicalSetupFormSectionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GcpTechnicalSetupFormSectionQuery = { __typename?: 'Query', gcpListing?: { __typename?: 'GcpListing', id: string, status?: string | null, solution_id?: string | null, dashboard_url?: string | null } | null };

export type UpdateGcpTechnicalSetupFormSectionMutationVariables = Exact<{
  updates: GcpListingInput;
}>;


export type UpdateGcpTechnicalSetupFormSectionMutation = { __typename?: 'Mutation', updateGcpListing?: { __typename?: 'GcpListing', id: string, status?: string | null, solution_id?: string | null, dashboard_url?: string | null } | null };

export type GcpRegistrationFieldsFormSectionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GcpRegistrationFieldsFormSectionQuery = { __typename?: 'Query', gcpListing?: { __typename?: 'GcpListing', id: string, registration_page_fields?: Array<{ __typename?: 'GcpRegistrationField', data_type?: string | null, default?: boolean | null, display_title?: string | null, enabled?: boolean | null, required?: boolean | null, tackle_required?: boolean | null, title?: string | null, validation_type?: GcpRegistrationFieldValidationType | null, options?: Array<{ __typename?: 'GcpRegistrationFieldOptions', label?: string | null, value?: string | null }> | null }> | null } | null };

export type UpdateGcpRegistrationFieldsFormSectionMutationVariables = Exact<{
  updates: GcpListingInput;
}>;


export type UpdateGcpRegistrationFieldsFormSectionMutation = { __typename?: 'Mutation', updateGcpListing?: { __typename?: 'GcpListing', id: string, registration_page_fields?: Array<{ __typename?: 'GcpRegistrationField', data_type?: string | null, default?: boolean | null, display_title?: string | null, enabled?: boolean | null, required?: boolean | null, tackle_required?: boolean | null, title?: string | null, validation_type?: GcpRegistrationFieldValidationType | null, options?: Array<{ __typename?: 'GcpRegistrationFieldOptions', label?: string | null, value?: string | null }> | null }> | null } | null };

export type GcpListingRegistrationQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GcpListingRegistrationQuery = { __typename?: 'Query', gcpListing?: { __typename?: 'GcpListing', id: string, registration_hosting?: string | null } | null };

export type GcpRegistrationHostingFormSectionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GcpRegistrationHostingFormSectionQuery = { __typename?: 'Query', gcpListing?: { __typename?: 'GcpListing', id: string, registration_hosting?: string | null, registration_redirect?: { __typename?: 'GcpRegistrationRedirect', url?: string | null, params?: any | null } | null } | null };

export type UpdateGcpRegistrationHostingFormSectionMutationVariables = Exact<{
  updates: GcpListingInput;
}>;


export type UpdateGcpRegistrationHostingFormSectionMutation = { __typename?: 'Mutation', updateGcpListing?: { __typename?: 'GcpListing', id: string, registration_hosting?: string | null, registration_redirect?: { __typename?: 'GcpRegistrationRedirect', url?: string | null, params?: any | null } | null } | null };

export type GcpRegistrationSuccessFormSectionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GcpRegistrationSuccessFormSectionQuery = { __typename?: 'Query', gcpListing?: { __typename?: 'GcpListing', id: string, registration?: { __typename?: 'GcpRegistration', success?: { __typename?: 'GcpRegistrationSuccess', message?: string | null, redirect_url?: string | null } | null } | null } | null };

export type UpdateGcpRegistrationSuccessFormSectionMutationVariables = Exact<{
  updates: GcpListingInput;
}>;


export type UpdateGcpRegistrationSuccessFormSectionMutation = { __typename?: 'Mutation', updateGcpListing?: { __typename?: 'GcpListing', id: string, registration?: { __typename?: 'GcpRegistration', success?: { __typename?: 'GcpRegistrationSuccess', message?: string | null, redirect_url?: string | null } | null } | null } | null };

export type GcpRegistrationThemeFormSectionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GcpRegistrationThemeFormSectionQuery = { __typename?: 'Query', gcpListing?: { __typename?: 'GcpListing', id: string, registration?: { __typename?: 'GcpRegistration', form?: { __typename?: 'GcpRegistrationForm', logo_url?: string | null, button?: { __typename?: 'GcpRegistrationFormButton', background_color?: string | null, color?: string | null } | null } | null, hero?: { __typename?: 'GcpRegistrationHero', background_color?: string | null, background_image_url?: string | null } | null } | null } | null };

export type UpdateGcpRegistrationThemeFormSectionMutationVariables = Exact<{
  updates: GcpListingInput;
}>;


export type UpdateGcpRegistrationThemeFormSectionMutation = { __typename?: 'Mutation', updateGcpListing?: { __typename?: 'GcpListing', id: string, registration?: { __typename?: 'GcpRegistration', form?: { __typename?: 'GcpRegistrationForm', logo_url?: string | null, button?: { __typename?: 'GcpRegistrationFormButton', background_color?: string | null, color?: string | null } | null } | null, hero?: { __typename?: 'GcpRegistrationHero', background_color?: string | null, background_image_url?: string | null } | null } | null } | null };

export type PropelCosellOpportunitiesQueryVariables = Exact<{
  metricId: Scalars['ID'];
  granularity: TimeSeriesGranularity;
  timeRange: TimeRangeInput;
  previousPeriodTimeRange: TimeRangeInput;
  showTrend: Scalars['Boolean'];
}>;


export type PropelCosellOpportunitiesQuery = { __typename?: 'Query', previousPeriodTotal?: { __typename?: 'Metric', counter?: { __typename?: 'CounterResponse', value?: string | null } | null } | null, allTimeTotal?: { __typename?: 'Metric', counter?: { __typename?: 'CounterResponse', value?: string | null } | null } | null, total?: { __typename?: 'Metric', counter?: { __typename?: 'CounterResponse', value?: string | null } | null } | null, awsInbound?: { __typename?: 'Metric', timeSeries?: { __typename?: 'TimeSeriesResponse', dates: Array<string>, counts: Array<string | null> } | null } | null, awsOutbound?: { __typename?: 'Metric', timeSeries?: { __typename?: 'TimeSeriesResponse', dates: Array<string>, counts: Array<string | null> } | null } | null, breakdownByCloud?: { __typename?: 'Metric', leaderboard?: { __typename?: 'LeaderboardResponse', headers: Array<string>, rows: Array<Array<string | null>> } | null } | null };

export type PropelCosellPipelineQueryVariables = Exact<{
  metricId: Scalars['ID'];
  timeRange: TimeRangeInput;
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
}>;


export type PropelCosellPipelineQuery = { __typename?: 'Query', total?: { __typename?: 'Metric', counter?: { __typename?: 'CounterResponse', value?: string | null } | null } | null, pipelineData?: { __typename?: 'Metric', leaderboard?: { __typename?: 'LeaderboardResponse', headers: Array<string>, rows: Array<Array<string | null>> } | null } | null };

export type PropelCosellMarketplaceRevenueQueryVariables = Exact<{
  metricId: Scalars['ID'];
  timeRange: TimeRangeInput;
}>;


export type PropelCosellMarketplaceRevenueQuery = { __typename?: 'Query', total?: { __typename?: 'Metric', counter?: { __typename?: 'CounterResponse', value?: string | null } | null } | null, chartData?: { __typename?: 'Metric', leaderboard?: { __typename?: 'LeaderboardResponse', headers: Array<string>, rows: Array<Array<string | null>> } | null } | null };

export type PropelCosellWinRateQueryVariables = Exact<{
  metricId: Scalars['ID'];
  timeRange: TimeRangeInput;
}>;


export type PropelCosellWinRateQuery = { __typename?: 'Query', total?: { __typename?: 'Metric', counter?: { __typename?: 'CounterResponse', value?: string | null } | null } | null, awsInbound?: { __typename?: 'Metric', counter?: { __typename?: 'CounterResponse', value?: string | null } | null } | null, awsInboundWon?: { __typename?: 'Metric', counter?: { __typename?: 'CounterResponse', value?: string | null } | null } | null, awsOutbound?: { __typename?: 'Metric', counter?: { __typename?: 'CounterResponse', value?: string | null } | null } | null, awsOutboundWon?: { __typename?: 'Metric', counter?: { __typename?: 'CounterResponse', value?: string | null } | null } | null };

export type ActivationDashboardQueryVariables = Exact<{
  vendorId: Scalars['String'];
  hasProspectAccess?: InputMaybe<Scalars['Boolean']>;
  hasCoSellAccess?: InputMaybe<Scalars['Boolean']>;
  hasOffersAccess?: InputMaybe<Scalars['Boolean']>;
}>;


export type ActivationDashboardQuery = { __typename?: 'Query', activationDashboard: { __typename?: 'ActivationDashboard', verticals: Array<{ __typename: 'CoSellVertical', id: ProductVerticalName, stage: VerticalStage, data: { __typename?: 'CoSellVerticalData', highScoreCount: number, isAwsConnected: boolean, isAzureConnected: boolean } } | { __typename: 'OffersVertical', id: ProductVerticalName, stage: VerticalStage, data: { __typename?: 'OffersVerticalData', highScoreCount: number, marketplaceStages: Array<{ __typename?: 'MarketplaceStage', marketplace: Marketplace, stage: MarketplaceConnectionStage }> } } | { __typename: 'ProspectVertical', id: ProductVerticalName, stage: VerticalStage, data: { __typename?: 'ProspectVerticalData', highScoreCount: number } }> } };

export type CurrentUserVendorDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserVendorDetailsQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, vendor?: { __typename?: 'Vendor', id: string, vendor_type?: string | null, created_at?: string | null, listingsByChannel?: { __typename?: 'VendorListingsByChannel', id: string, aws?: Array<{ __typename?: 'AwsListing', id: string, status?: string | null }> | null } | null, configuration?: { __typename?: 'VendorConfiguration', id: string, status?: { __typename?: 'VendorConfigurationStatuses', sdds?: { __typename?: 'VendorStatus', value?: string | null } | null } | null } | null } | null } | null };

export type ProspectHighCountsQueryVariables = Exact<{
  vendorId: Scalars['String'];
}>;


export type ProspectHighCountsQuery = { __typename?: 'Query', prospectRollupStatistics: { __typename?: 'ProspectRollupStatisticsResponse', data?: { __typename?: 'ProspectRollupStatistics', total_domains?: number | null, newHighs?: any | null, aws?: { __typename?: 'ProspectMarketplaceScores', count_high?: number | null, count_medium?: number | null, count_low?: number | null } | null, gcp?: { __typename?: 'ProspectMarketplaceScores', count_high?: number | null, count_medium?: number | null, count_low?: number | null } | null, microsoft?: { __typename?: 'ProspectMarketplaceScores', count_high?: number | null, count_medium?: number | null, count_low?: number | null } | null } | null } };

export type ProspectScoringProgressQueryVariables = Exact<{
  vendorId: Scalars['String'];
}>;


export type ProspectScoringProgressQuery = { __typename?: 'Query', prospectScoringJob: { __typename?: 'ProspectScoringJobResponse', data?: Array<{ __typename?: 'ProspectScoringJob', status?: string | null, createDate?: string | null } | null> | null }, prospectScoringBatches: { __typename?: 'ProspectScoringBatchesResponse', data?: Array<{ __typename?: 'ProspectScoringBatch', batch_id?: string | null } | null> | null } };

export type PropelBookedRevenueQueryVariables = Exact<{
  metricName: Scalars['String'];
  granularity: TimeSeriesGranularity;
  timeRange: TimeRangeInput;
  lastPeriodTimeRange: TimeRangeInput;
  cloudFilters: FilterInput;
}>;


export type PropelBookedRevenueQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, vendorId?: string | null } | null, aws?: { __typename?: 'Metric', timeSeries?: { __typename?: 'TimeSeriesResponse', labels: Array<string>, values: Array<string | null> } | null } | null, azure?: { __typename?: 'Metric', timeSeries?: { __typename?: 'TimeSeriesResponse', labels: Array<string>, values: Array<string | null> } | null } | null, gcp?: { __typename?: 'Metric', timeSeries?: { __typename?: 'TimeSeriesResponse', labels: Array<string>, values: Array<string | null> } | null } | null, revenueByCloud?: { __typename?: 'Metric', leaderboard?: { __typename?: 'LeaderboardResponse', headers: Array<string>, rows: Array<Array<string | null>> } | null } | null, thisPeriodRevenue?: { __typename?: 'Metric', counter?: { __typename?: 'CounterResponse', value?: string | null } | null } | null, lastPeriodRevenue?: { __typename?: 'Metric', counter?: { __typename?: 'CounterResponse', value?: string | null } | null } | null };

export type PropelDisbursedRevenueQueryVariables = Exact<{
  metricName: Scalars['String'];
  granularity: TimeSeriesGranularity;
  timeRange: TimeRangeInput;
  lastPeriodTimeRange: TimeRangeInput;
  cloudFilters: FilterInput;
}>;


export type PropelDisbursedRevenueQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, vendorId?: string | null } | null, aws?: { __typename?: 'Metric', timeSeries?: { __typename?: 'TimeSeriesResponse', labels: Array<string>, values: Array<string | null> } | null } | null, azure?: { __typename?: 'Metric', timeSeries?: { __typename?: 'TimeSeriesResponse', labels: Array<string>, values: Array<string | null> } | null } | null, gcp?: { __typename?: 'Metric', timeSeries?: { __typename?: 'TimeSeriesResponse', labels: Array<string>, values: Array<string | null> } | null } | null, revenueByCloud?: { __typename?: 'Metric', leaderboard?: { __typename?: 'LeaderboardResponse', headers: Array<string>, rows: Array<Array<string | null>> } | null } | null, thisPeriodRevenue?: { __typename?: 'Metric', counter?: { __typename?: 'CounterResponse', value?: string | null } | null } | null, lastPeriodRevenue?: { __typename?: 'Metric', counter?: { __typename?: 'CounterResponse', value?: string | null } | null } | null };

export type NewDashboardQueryVariables = Exact<{ [key: string]: never; }>;


export type NewDashboardQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, vendor?: { __typename?: 'Vendor', id: string, feature_flags?: { __typename?: 'VendorFeatureFlags', is_prospect_enabled?: boolean | null, is_listings_enabled?: boolean | null, is_co_sell_enabled?: boolean | null, is_co_sell_enabled_for_microsoft?: boolean | null } | null } | null } | null };

export type ProspectRollupStatisticsCardQueryVariables = Exact<{
  vendorId: Scalars['String'];
}>;


export type ProspectRollupStatisticsCardQuery = { __typename?: 'Query', prospectRollupStatistics: { __typename?: 'ProspectRollupStatisticsResponse', data?: { __typename?: 'ProspectRollupStatistics', total_domains?: number | null, newHighs?: any | null, aws?: { __typename?: 'ProspectMarketplaceScores', count_high?: number | null, count_medium?: number | null, count_low?: number | null } | null, gcp?: { __typename?: 'ProspectMarketplaceScores', count_high?: number | null, count_medium?: number | null, count_low?: number | null } | null, microsoft?: { __typename?: 'ProspectMarketplaceScores', count_high?: number | null, count_medium?: number | null, count_low?: number | null } | null } | null } };

export type LegacyProspectSectionQueryVariables = Exact<{ [key: string]: never; }>;


export type LegacyProspectSectionQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, vendor?: { __typename?: 'Vendor', id: string, feature_flags?: { __typename?: 'VendorFeatureFlags', is_prospect_enabled?: boolean | null } | null } | null } | null };

export type CreateProspectSelectedExportUrlMutationVariables = Exact<{
  data: FilterProspectAccountsInput;
}>;


export type CreateProspectSelectedExportUrlMutation = { __typename?: 'Mutation', createProspectSelectedExportUrlV2?: { __typename?: 'ProspectAccountSelectedExportUrlResponse', data?: { __typename?: 'ProspectSignedUrl', expires_in?: number | null, s3_key?: string | null, url?: string | null, use?: string | null, batch_metadata?: { __typename?: 'ProspectScoringBatch', batch_id?: string | null, batch_name?: string | null } | null } | null } | null };

export type PaymentsExportQueryVariables = Exact<{
  input: DataGridInput;
}>;


export type PaymentsExportQuery = { __typename?: 'Query', payments: { __typename?: 'DataGridConnection', headers: Array<string>, rows: Array<Array<string | null>> } };

export type PropelPaymentsActualDisbursedRevenueQueryVariables = Exact<{
  metricNameTackleManaged: Scalars['String'];
  metricNameNotManaged: Scalars['String'];
  timeRange: TimeRangeInput;
  filterSql: Scalars['String'];
}>;


export type PropelPaymentsActualDisbursedRevenueQuery = { __typename?: 'Query', tackleManaged?: { __typename?: 'Metric', counter?: { __typename?: 'CounterResponse', value?: string | null } | null } | null, notManaged?: { __typename?: 'Metric', counter?: { __typename?: 'CounterResponse', value?: string | null } | null } | null };

export type PropelPaymentsGrosssDisbursedRevenueQueryVariables = Exact<{
  metricNameTackleManaged: Scalars['String'];
  metricNameNotManaged: Scalars['String'];
  timeRange: TimeRangeInput;
  filterSql: Scalars['String'];
}>;


export type PropelPaymentsGrosssDisbursedRevenueQuery = { __typename?: 'Query', tackleManaged?: { __typename?: 'Metric', counter?: { __typename?: 'CounterResponse', value?: string | null } | null } | null, notManaged?: { __typename?: 'Metric', counter?: { __typename?: 'CounterResponse', value?: string | null } | null } | null };

export type GroupedPaymentsQueryVariables = Exact<{
  groupsInput: MetricReportInput;
  countInput: SqlV1Input;
}>;


export type GroupedPaymentsQuery = { __typename?: 'Query', groups?: { __typename?: 'MetricReportConnection', headers: Array<string | null>, rows: Array<Array<string | null>>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } | null, count: { __typename?: 'SqlResponse', rows: Array<Array<string | null>> } };

export type PaymentsGroupQueryVariables = Exact<{
  input: DataGridInput;
}>;


export type PaymentsGroupQuery = { __typename?: 'Query', payments: { __typename?: 'DataGridConnection', headers: Array<string>, rows: Array<Array<string | null>>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: string | null, startCursor?: string | null } } };

export type UngroupedPaymentsQueryVariables = Exact<{
  paymentsInput: DataGridInput;
  countInput: SqlV1Input;
}>;


export type UngroupedPaymentsQuery = { __typename?: 'Query', payments: { __typename?: 'DataGridConnection', headers: Array<string>, rows: Array<Array<string | null>>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: string | null, startCursor?: string | null } }, count: { __typename?: 'SqlResponse', rows: Array<Array<string | null>> } };

export type ListOfListingsIdsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListOfListingsIdsQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, role?: string | null, vendor?: { __typename?: 'Vendor', id: string, listingsByChannel?: { __typename?: 'VendorListingsByChannel', id: string, aws?: Array<{ __typename?: 'AwsListing', id: string }> | null, azure?: Array<{ __typename?: 'AzureListing', id: string }> | null, gcp?: Array<{ __typename?: 'GcpListing', id: string }> | null } | null } | null } | null };

export type DataGridQueryQueryVariables = Exact<{
  input: DataGridInput;
}>;


export type DataGridQueryQuery = { __typename?: 'Query', dataGrid: { __typename?: 'DataGridConnection', headers: Array<string>, rows: Array<Array<string | null>>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: string | null, startCursor?: string | null }, query: { __typename?: 'QueryInfo', resultingRecords: number } } };

export type TotalPaymentsDataQueryVariables = Exact<{
  input: DataGridInput;
}>;


export type TotalPaymentsDataQuery = { __typename?: 'Query', dataGrid: { __typename?: 'DataGridConnection', query: { __typename?: 'QueryInfo', resultingRecords: number } } };

export type TotalPaymentsDetailsDataQueryVariables = Exact<{
  input: DataGridInput;
}>;


export type TotalPaymentsDetailsDataQuery = { __typename?: 'Query', dataGrid: { __typename?: 'DataGridConnection', headers: Array<string>, rows: Array<Array<string | null>>, query: { __typename?: 'QueryInfo', resultingRecords: number } } };

export type UserBillingDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserBillingDetailsQuery = { __typename?: 'Query', userBillingDetails: { __typename?: 'UserBillingDetails', gmvPrecommit?: number | null, gmvUsage?: number | null, subscriptionId?: string | null, subscriptionStartTime?: string | null, subscriptionEndTime?: string | null, lastUpdated?: string | null } };

export type PropelPaymentsGroupByMetricReportQueryVariables = Exact<{
  input: MetricReportInput;
}>;


export type PropelPaymentsGroupByMetricReportQuery = { __typename?: 'Query', metricReport?: { __typename?: 'MetricReportConnection', headers: Array<string | null>, rows: Array<Array<string | null>>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean }, query: { __typename?: 'QueryInfo', resultingRecords: number } } | null };

export type PaymentQueryInputParamsQueryVariables = Exact<{ [key: string]: never; }>;


export type PaymentQueryInputParamsQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, vendor?: { __typename?: 'Vendor', id: string, vendor_type?: string | null } | null } | null };

export type ProspectSingleCompanyDetailsQueryVariables = Exact<{
  vendorId: Scalars['String'];
  domain: Scalars['String'];
}>;


export type ProspectSingleCompanyDetailsQuery = { __typename?: 'Query', prospectCompanyDetails?: { __typename?: 'ProspectCompanyDetailsResponse', data?: { __typename?: 'ProspectCompanyDetails', domain?: string | null, score_aws?: string | null, score_azure?: string | null, score_gcp?: string | null, company_name?: string | null, new_high_info?: { __typename?: 'ProspectNewHighs', clouds?: Array<string | null> | null, domain?: string | null, new_score?: string | null } | null } | null } | null };

export type ProspectHasAgreedToTermsQueryVariables = Exact<{
  vendorId: Scalars['String'];
}>;


export type ProspectHasAgreedToTermsQuery = { __typename?: 'Query', prospectHasAgreedToTerms?: { __typename?: 'ProspectHasAgreedToTermsResponse', has_agreed?: boolean | null } | null };

export type ProspectScoringJobQueryVariables = Exact<{
  vendorId: Scalars['String'];
}>;


export type ProspectScoringJobQuery = { __typename?: 'Query', prospectScoringJob: { __typename?: 'ProspectScoringJobResponse', data?: Array<{ __typename?: 'ProspectScoringJob', job_id?: string | null, batch_id?: string | null, vendor_id?: string | null, status?: string | null, domain_count?: number | null, create_date?: string | null, complete_date?: string | null } | null> | null } };

export type ProspectOpportunitiesCountByMarketplaceQueryVariables = Exact<{
  vendorId: Scalars['String'];
}>;


export type ProspectOpportunitiesCountByMarketplaceQuery = { __typename?: 'Query', prospectOpportunitiesCountByMarketplace?: { __typename?: 'ProspectOpportunitiesCountByMarketplaceResponse', data?: { __typename?: 'ProspectMarketplaceCounts', aws?: number | null, azure?: number | null, gcp?: number | null, not_listed_on?: Array<string | null> | null } | null } | null };

export type ProspectCompanyDetailsQueryVariables = Exact<{
  vendorId: Scalars['String'];
  domain: Scalars['String'];
}>;


export type ProspectCompanyDetailsQuery = { __typename?: 'Query', prospectCompanyDetails?: { __typename?: 'ProspectCompanyDetailsResponse', data?: { __typename?: 'ProspectCompanyDetails', domain?: string | null, score_aws?: string | null, score_azure?: string | null, score_gcp?: string | null, company_name?: string | null, region?: string | null, revenue_band?: string | null, primary_industry?: string | null, offerCount?: number | null, new_high_info?: { __typename?: 'ProspectNewHighs', clouds?: Array<string | null> | null, domain?: string | null } | null, offers?: Array<{ __typename?: 'OfferSummaryForProspectDomain', cloud?: string | null, status?: string | null, id: string, po_id: string } | null> | null } | null } | null };

export type ProspectExplainabilityByCloudQueryVariables = Exact<{
  vendorId: Scalars['String'];
  cloud: Scalars['String'];
}>;


export type ProspectExplainabilityByCloudQuery = { __typename?: 'Query', prospectDefaultFeatureImportance?: { __typename?: 'ProspectFeatureImportanceResponse', data?: Array<{ __typename?: 'ProspectFeatureImportance', bucket_definition?: string | null, bucket?: string | null } | null> | null } | null };

export type SubmitProspectAccountForScoringMutationVariables = Exact<{
  data: ProspectAccountForScoringInput;
}>;


export type SubmitProspectAccountForScoringMutation = { __typename?: 'Mutation', submitProspectAccountForScoring?: { __typename?: 'ProspectAccountScoringResponse', metadata?: any | null, data?: { __typename: 'ProspectAccountResult', domain?: string | null, score_aws?: string | null, score_azure?: string | null, score_gcp?: string | null, region?: string | null, revenue_band?: string | null, primary_industry?: string | null, company_name?: string | null } | null } | null };

export type PostProspectAgreeToTermsMutationVariables = Exact<{
  data: ProspectAgreeToTermsInput;
}>;


export type PostProspectAgreeToTermsMutation = { __typename?: 'Mutation', postProspectAgreeToTerms?: { __typename?: 'ProspectHasAgreedToTermsResponse', has_agreed?: boolean | null } | null };

export type CreateProspectPresignedUrlMutationVariables = Exact<{
  data: ProspectPresignedUrlInput;
}>;


export type CreateProspectPresignedUrlMutation = { __typename?: 'Mutation', createProspectPresignedUrl?: { __typename?: 'ProspectSignedUrlResponse', data?: { __typename?: 'ProspectSignedUrl', expires_in?: number | null, s3_key?: string | null, url?: string | null, use?: string | null, batch_metadata?: { __typename?: 'ProspectScoringBatch', batch_id?: string | null, batch_name?: string | null } | null } | null } | null };

export type SubmitProspectFileForScoringMutationVariables = Exact<{
  data: ProspectFileForScoringInput;
}>;


export type SubmitProspectFileForScoringMutation = { __typename?: 'Mutation', submitProspectFileForScoring?: { __typename?: 'ProspectFileScoringResponse', data?: { __typename?: 'ProspectFileScoring', batch_id?: string | null, raw_file_key?: string | null, raw_file_bucket?: string | null, scored_file_key?: string | null, scored_file_bucket?: string | null } | null, metadata?: { __typename?: 'ProspectFileScoringMetadata', warnings?: Array<{ __typename?: 'ProspectFileScoringWarnings', message?: string | null, invalid_domains?: Array<string | null> | null } | null> | null } | null } | null };

export type ProspectRollupStatisticsQueryVariables = Exact<{
  data: FilterProspectAccountsInput;
}>;


export type ProspectRollupStatisticsQuery = { __typename?: 'Query', prospectRollupStatisticsV2: { __typename?: 'ProspectRollupStatisticsResponse', data?: { __typename?: 'ProspectRollupStatistics', total_domains?: number | null, aws?: { __typename?: 'ProspectMarketplaceScores', count_high?: number | null, count_medium?: number | null, count_low?: number | null } | null, microsoft?: { __typename?: 'ProspectMarketplaceScores', count_high?: number | null, count_medium?: number | null, count_low?: number | null } | null, gcp?: { __typename?: 'ProspectMarketplaceScores', count_high?: number | null, count_medium?: number | null, count_low?: number | null } | null } | null } };

export type ProspectScoringBatchesQueryVariables = Exact<{
  vendorId: Scalars['String'];
}>;


export type ProspectScoringBatchesQuery = { __typename?: 'Query', prospectScoringBatches: { __typename?: 'ProspectScoringBatchesResponse', data?: Array<{ __typename?: 'ProspectScoringBatch', batch_id?: string | null, batch_name?: string | null, domain_count?: number | null, run_date?: string | null } | null> | null } };

export type ProspectAccountScoresQueryVariables = Exact<{
  data: FilterProspectAccountsInput;
}>;


export type ProspectAccountScoresQuery = { __typename?: 'Query', prospectScoresByVendorIdV2: { __typename?: 'ProspectApiProspectAccountScoresResponse', data?: Array<{ __typename?: 'ProspectScoringResult', domain?: string | null, company_name?: string | null, score_aws?: string | null, score_azure?: string | null, score_gcp?: string | null, region?: string | null, revenue_band?: string | null, primary_industry?: string | null, offerCount?: number | null, newHighs?: { __typename?: 'newHighsForAccountScore', aws?: boolean | null, gcp?: boolean | null, azure?: boolean | null } | null, offers?: Array<{ __typename?: 'OfferSummaryForProspectDomain', id: string, po_id: string } | null> | null } | null> | null, metadata?: { __typename?: 'ProspectPaginationInfo', next_page?: string | null, previous_page?: string | null, current_page_number?: number | null, current_page_record_count?: number | null, total_record_count?: number | null } | null } };

export type ProspectRollupStatisticsTotalDomainsQueryVariables = Exact<{
  vendorId: Scalars['String'];
}>;


export type ProspectRollupStatisticsTotalDomainsQuery = { __typename?: 'Query', prospectRollupStatistics: { __typename?: 'ProspectRollupStatisticsResponse', data?: { __typename?: 'ProspectRollupStatistics', total_domains?: number | null, newHighs?: any | null } | null } };

export type ProspectMiissingOpportunitiesQueryVariables = Exact<{
  vendorId: Scalars['String'];
}>;


export type ProspectMiissingOpportunitiesQuery = { __typename?: 'Query', prospectMissingOpportunities?: { __typename?: 'ProspectMissingOpportunitiesResponse', data?: string | null } | null };

export type ProspectFilterValuesQueryVariables = Exact<{
  vendorId: Scalars['String'];
}>;


export type ProspectFilterValuesQuery = { __typename?: 'Query', prospectFilterValues: { __typename?: 'ProspectFilterValuesResponse', data?: { __typename?: 'ProspectFilterValues', primary_industries?: Array<string | null> | null, revenue_bands?: Array<string | null> | null, regions?: Array<string | null> | null } | null } };

export type BillingInfoQueryVariables = Exact<{
  metricNameTackleManaged: Scalars['String'];
  timeRange: TimeRangeInput;
  filterSql: Scalars['String'];
}>;


export type BillingInfoQuery = { __typename?: 'Query', tackleManaged?: { __typename?: 'Metric', id: string, counter?: { __typename?: 'CounterResponse', value?: string | null } | null } | null };

export type BillingInfoContainerQueryVariables = Exact<{ [key: string]: never; }>;


export type BillingInfoContainerQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, vendor?: { __typename?: 'Vendor', id: string, vendor_type?: string | null } | null } | null };

export type CanAccessBillingQueryVariables = Exact<{ [key: string]: never; }>;


export type CanAccessBillingQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, isSuperAdmin?: boolean | null, vendor?: { __typename?: 'Vendor', id: string, feature_flags?: { __typename?: 'VendorFeatureFlags', is_co_sell_enabled?: boolean | null, is_co_sell_enabled_for_microsoft?: boolean | null, is_prospect_enabled?: boolean | null, is_marketplace_enabled?: boolean | null, is_listings_enabled?: boolean | null } | null } | null } | null };

export type CoSellSettingsAwsBackfillMapCoSellsToSalesforceGetVendorQueryVariables = Exact<{ [key: string]: never; }>;


export type CoSellSettingsAwsBackfillMapCoSellsToSalesforceGetVendorQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, vendor?: { __typename?: 'Vendor', id: string, coSell?: { __typename?: 'CoSellVendor', id?: string | null, vendorId?: string | null } | null } | null } | null };

export type CoSellSettingsAwsBackfillMapCoSellsToSalesforceMutationVariables = Exact<{
  vendorId: Scalars['ID'];
  cloud: Scalars['String'];
  data: Scalars['String'];
}>;


export type CoSellSettingsAwsBackfillMapCoSellsToSalesforceMutation = { __typename?: 'Mutation', linkCloudOpportunitiesToSalesforceOpportunities?: { __typename?: 'CloudOpportunitiesToSalesforceOpportunitiesResponse', success?: number | null, failure?: number | null, errors?: Array<{ __typename?: 'CloudOpportunitiesToSalesforceOpportunitiesError', row?: number | null, error?: string | null }> | null } | null };

export type CoSellSettingsAwsAceQueryVariables = Exact<{ [key: string]: never; }>;


export type CoSellSettingsAwsAceQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, vendor?: { __typename?: 'Vendor', id: string, configuration?: { __typename?: 'VendorConfiguration', aws?: { __typename?: 'VendorAwsConfig', assume_role?: { __typename?: 'VendorAwsAssumeRoleConfig', role_arn?: string | null } | null } | null } | null, coSell?: { __typename?: 'CoSellVendor', id?: string | null, ace_bucket?: string | null, ace_spms_id?: string | null, ace_kms_key?: string | null, sandbox_arn?: string | null } | null } | null } | null };

export type UpdateCoSellVendorCoSellSettingsAwsAceMutationVariables = Exact<{
  updates: CoSellVendorInput;
}>;


export type UpdateCoSellVendorCoSellSettingsAwsAceMutation = { __typename?: 'Mutation', updateCoSellVendor?: { __typename?: 'CoSellVendor', id?: string | null, ace_bucket?: string | null, ace_spms_id?: string | null, ace_kms_key?: string | null } | null };

export type UpdateAwsVendorCoSellSettingsAwsAceMutationVariables = Exact<{
  updates: VendorInput;
}>;


export type UpdateAwsVendorCoSellSettingsAwsAceMutation = { __typename?: 'Mutation', updateVendor?: { __typename?: 'Vendor', id: string, onboarding?: { __typename?: 'VendorOnboarding', cosell?: { __typename?: 'VendorCosellOnboarding', aws_has_launch_stack_button_been_clicked?: boolean | null } | null } | null } | null };

export type CoSellSettingsAwsGetStartedQueryVariables = Exact<{ [key: string]: never; }>;


export type CoSellSettingsAwsGetStartedQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, vendor?: { __typename?: 'Vendor', id: string, onboarding?: { __typename?: 'VendorOnboarding', aws?: { __typename?: 'VendorAwsOnboarding', account_setup?: Array<string> | null } | null } | null } | null } | null };

export type UpdateCoSellSettingsAwsGetStartedMutationVariables = Exact<{
  updates: VendorInput;
}>;


export type UpdateCoSellSettingsAwsGetStartedMutation = { __typename?: 'Mutation', updateVendor?: { __typename?: 'Vendor', id: string, onboarding?: { __typename?: 'VendorOnboarding', aws?: { __typename?: 'VendorAwsOnboarding', account_setup?: Array<string> | null } | null } | null } | null };

export type UpdateCoSellSettingsAwsPcEventsMutationVariables = Exact<{
  updates: VendorInput;
}>;


export type UpdateCoSellSettingsAwsPcEventsMutation = { __typename?: 'Mutation', updateVendor?: { __typename?: 'Vendor', id: string, onboarding?: { __typename?: 'VendorOnboarding', cosell?: { __typename?: 'VendorCosellOnboarding', aws_has_pc_events_launch_stack_button_been_clicked?: boolean | null } | null } | null } | null };

export type CoSellSettingsAwsPcEventsQueryVariables = Exact<{ [key: string]: never; }>;


export type CoSellSettingsAwsPcEventsQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, vendor?: { __typename?: 'Vendor', id: string, configuration?: { __typename?: 'VendorConfiguration', aws?: { __typename?: 'VendorAwsConfig', assume_role?: { __typename?: 'VendorAwsAssumeRoleConfig', role_arn?: string | null } | null } | null } | null, onboarding?: { __typename?: 'VendorOnboarding', cosell?: { __typename?: 'VendorCosellOnboarding', aws_has_pc_events_launch_stack_button_been_clicked?: boolean | null } | null } | null } | null } | null };

export type RegistrationTokenCoSellSettingsAwsPcEventsQueryVariables = Exact<{ [key: string]: never; }>;


export type RegistrationTokenCoSellSettingsAwsPcEventsQuery = { __typename?: 'Query', awsRegistrationToken?: string | null };

export type UpdateAwsVendorCoSellSettingsAwsPartnerCentralLinkedMutationVariables = Exact<{
  updates: VendorInput;
}>;


export type UpdateAwsVendorCoSellSettingsAwsPartnerCentralLinkedMutation = { __typename?: 'Mutation', updateVendor?: { __typename?: 'Vendor', id: string, onboarding?: { __typename?: 'VendorOnboarding', cosell?: { __typename?: 'VendorCosellOnboarding', has_completed_partner_central_linking?: boolean | null } | null } | null } | null };

export type CoSellSettingsAwsProductionQueryVariables = Exact<{ [key: string]: never; }>;


export type CoSellSettingsAwsProductionQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, vendor?: { __typename?: 'Vendor', id: string, external_id?: string | null, configuration?: { __typename?: 'VendorConfiguration', aws?: { __typename?: 'VendorAwsConfig', assume_role?: { __typename?: 'VendorAwsAssumeRoleConfig', role_arn?: string | null } | null } | null } | null, reporting?: { __typename?: 'VendorReporting', health?: { __typename?: 'VendorReportingHealth', tkl_iam_role_status?: { __typename?: 'VendorReportingConnection', status?: string | null } | null } | null } | null } | null } | null };

export type UpdateAwsVendorCoSellSettingsAwsProductionMutationVariables = Exact<{
  updates: VendorInput;
}>;


export type UpdateAwsVendorCoSellSettingsAwsProductionMutation = { __typename?: 'Mutation', updateVendor?: { __typename?: 'Vendor', id: string, configuration?: { __typename?: 'VendorConfiguration', aws?: { __typename?: 'VendorAwsConfig', assume_role?: { __typename?: 'VendorAwsAssumeRoleConfig', role_arn?: string | null } | null } | null } | null, onboarding?: { __typename?: 'VendorOnboarding', cosell?: { __typename?: 'VendorCosellOnboarding', aws_has_launch_stack_button_been_clicked?: boolean | null } | null } | null } | null };

export type CoSellSettingsAwsS3QueryVariables = Exact<{ [key: string]: never; }>;


export type CoSellSettingsAwsS3Query = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, vendor?: { __typename?: 'Vendor', id: string, configuration?: { __typename?: 'VendorConfiguration', aws?: { __typename?: 'VendorAwsConfig', assume_role?: { __typename?: 'VendorAwsAssumeRoleConfig', role_arn?: string | null } | null } | null } | null, coSell?: { __typename?: 'CoSellVendor', id?: string | null, ace_bucket?: string | null, ace_kms_key?: string | null, ace_connected?: boolean | null } | null, onboarding?: { __typename?: 'VendorOnboarding', cosell?: { __typename?: 'VendorCosellOnboarding', aws_has_launch_stack_button_been_clicked?: boolean | null } | null } | null } | null } | null };

export type TestAceConnectionMutationVariables = Exact<{
  vendorId: Scalars['String'];
}>;


export type TestAceConnectionMutation = { __typename?: 'Mutation', testCoSellAceConnection: boolean };

export type UpdateAwsVendorCoSellSettingsAwsS3MutationVariables = Exact<{
  updates: VendorInput;
}>;


export type UpdateAwsVendorCoSellSettingsAwsS3Mutation = { __typename?: 'Mutation', updateVendor?: { __typename?: 'Vendor', id: string, onboarding?: { __typename?: 'VendorOnboarding', cosell?: { __typename?: 'VendorCosellOnboarding', aws_has_launch_stack_button_been_clicked?: boolean | null } | null } | null } | null };

export type CoSellSettingsAwsSandboxQueryVariables = Exact<{ [key: string]: never; }>;


export type CoSellSettingsAwsSandboxQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, vendor?: { __typename?: 'Vendor', id: string, coSell?: { __typename?: 'CoSellVendor', id?: string | null, sandbox_arn?: string | null } | null } | null } | null };

export type UpdateCoSellVendorCoSellSettingsAwsSandboxMutationVariables = Exact<{
  updates: CoSellVendorInput;
}>;


export type UpdateCoSellVendorCoSellSettingsAwsSandboxMutation = { __typename?: 'Mutation', updateCoSellVendor?: { __typename?: 'CoSellVendor', id?: string | null, sandbox_arn?: string | null } | null };

export type CoSellSettingsAwsSolutionsQueryVariables = Exact<{ [key: string]: never; }>;


export type CoSellSettingsAwsSolutionsQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, vendor?: { __typename?: 'Vendor', id: string, coSell?: { __typename?: 'CoSellVendor', id?: string | null, custom_workflows?: Array<string | null> | null, awsSolutions?: Array<{ __typename?: 'CoSellCloudSolution', id: string, externalId: string, isADefaultSolution?: boolean | null, name?: string | null }> | null } | null } | null } | null };

export type CreateCoSellCloudSolutionMutationVariables = Exact<{
  solution: CoSellCloudSolutionCreateInput;
}>;


export type CreateCoSellCloudSolutionMutation = { __typename?: 'Mutation', createCoSellCloudSolution?: { __typename?: 'CoSellCloudSolution', id: string, externalId: string, solutionName?: string | null, isADefaultSolution?: boolean | null } | null };

export type UpdateCoSellCloudSolutionMutationVariables = Exact<{
  updates: CoSellCloudSolutionUpdateInput;
}>;


export type UpdateCoSellCloudSolutionMutation = { __typename?: 'Mutation', updateCoSellCloudSolution?: { __typename?: 'CoSellCloudSolution', id: string, externalId: string, solutionName?: string | null, isADefaultSolution?: boolean | null } | null };

export type DeleteCoSellCloudSolutionMutationVariables = Exact<{
  solution: CoSellCloudSolutionDeleteInput;
}>;


export type DeleteCoSellCloudSolutionMutation = { __typename?: 'Mutation', deleteCoSellCloudSolution?: { __typename?: 'CoSellCloudSolution', id: string, externalId: string, solutionName?: string | null, archivedAt?: string | null } | null };

export type ToggleCompletedSaasDocumentationMutationVariables = Exact<{
  vendorId: Scalars['ID'];
  status: Scalars['Boolean'];
}>;


export type ToggleCompletedSaasDocumentationMutation = { __typename?: 'Mutation', toggleCompletedSaasDocumentation?: { __typename?: 'CoSellVendor', id?: string | null, custom_workflows?: Array<string | null> | null } | null };

export type UpdateAwsVendorCoSellSettingsAwsAceEligibleMutationVariables = Exact<{
  updates: VendorInput;
}>;


export type UpdateAwsVendorCoSellSettingsAwsAceEligibleMutation = { __typename?: 'Mutation', updateVendor?: { __typename?: 'Vendor', id: string, onboarding?: { __typename?: 'VendorOnboarding', cosell?: { __typename?: 'VendorCosellOnboarding', ace_eligible_selection?: string | null } | null } | null } | null };

export type CoSellSettingsMicrosoftSolutionsQueryVariables = Exact<{ [key: string]: never; }>;


export type CoSellSettingsMicrosoftSolutionsQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, vendor?: { __typename?: 'Vendor', id: string, coSell?: { __typename?: 'CoSellVendor', id?: string | null, microsoftSolutions?: Array<{ __typename?: 'CoSellMicrosoftSolution', id: string, externalId: string, solutionName?: string | null }> | null } | null } | null } | null };

export type CreateCoSellMicrosoftSolutionMutationVariables = Exact<{
  solution: CoSellMicrosoftSolutionCreateInput;
}>;


export type CreateCoSellMicrosoftSolutionMutation = { __typename?: 'Mutation', createCoSellMicrosoftSolution?: { __typename?: 'CoSellMicrosoftSolution', id: string, externalId: string, solutionName?: string | null } | null };

export type UpdateCoSellMicrosoftSolutionMutationVariables = Exact<{
  updates: CoSellMicrosoftSolutionUpdateInput;
}>;


export type UpdateCoSellMicrosoftSolutionMutation = { __typename?: 'Mutation', updateCoSellMicrosoftSolution?: { __typename?: 'CoSellMicrosoftSolution', id: string, externalId: string, solutionName?: string | null } | null };

export type DeleteCoSellMicrosoftSolutionMutationVariables = Exact<{
  solution: CoSellMicrosoftSolutionDeleteInput;
}>;


export type DeleteCoSellMicrosoftSolutionMutation = { __typename?: 'Mutation', deleteCoSellMicrosoftSolution?: { __typename?: 'CoSellMicrosoftSolution', id: string, externalId: string, solutionName?: string | null, archivedAt?: string | null } | null };

export type CoSellSettingsStartQueryVariables = Exact<{ [key: string]: never; }>;


export type CoSellSettingsStartQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, vendor?: { __typename?: 'Vendor', id: string, feature_flags?: { __typename?: 'VendorFeatureFlags', is_co_sell_enabled?: boolean | null, is_co_sell_enabled_for_microsoft?: boolean | null } | null, coSell?: { __typename?: 'CoSellVendor', id?: string | null, ace_auto_submit?: boolean | null, mspc_auto_submit?: boolean | null } | null } | null } | null };

export type CoSellSettingsStartAutoSubmitToCloudPartnerMutationVariables = Exact<{
  updates: CoSellVendorInput;
}>;


export type CoSellSettingsStartAutoSubmitToCloudPartnerMutation = { __typename?: 'Mutation', updateCoSellVendor?: { __typename?: 'CoSellVendor', id?: string | null, ace_auto_submit?: boolean | null, mspc_auto_submit?: boolean | null } | null };

export type CreateCoSellCloudSolutionBulkMutationVariables = Exact<{
  solution: CoSellCloudSolutionCreateInput;
}>;


export type CreateCoSellCloudSolutionBulkMutation = { __typename?: 'Mutation', createCoSellCloudSolution?: { __typename?: 'CoSellCloudSolution', id: string, externalId: string, solutionName?: string | null } | null };

export type CoSellSettingsAwsHasIdentifiedAllianceAccountQueryVariables = Exact<{ [key: string]: never; }>;


export type CoSellSettingsAwsHasIdentifiedAllianceAccountQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, vendor?: { __typename?: 'Vendor', id: string, onboarding?: { __typename?: 'VendorOnboarding', cosell?: { __typename?: 'VendorCosellOnboarding', has_identified_alliance_account?: boolean | null } | null } | null, coSell?: { __typename?: 'CoSellVendor', ace_connected?: boolean | null } | null } | null } | null };

export type UpdateVendorCoSellSettingsAwsHasIdentifiedAllianceAccountMutationVariables = Exact<{
  updates: VendorInput;
}>;


export type UpdateVendorCoSellSettingsAwsHasIdentifiedAllianceAccountMutation = { __typename?: 'Mutation', updateVendor?: { __typename?: 'Vendor', id: string, onboarding?: { __typename?: 'VendorOnboarding', cosell?: { __typename?: 'VendorCosellOnboarding', has_identified_alliance_account?: boolean | null } | null } | null } | null };

export type CoSellSettingsAwsAceEligibleQueryVariables = Exact<{ [key: string]: never; }>;


export type CoSellSettingsAwsAceEligibleQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, vendor?: { __typename?: 'Vendor', id: string, onboarding?: { __typename?: 'VendorOnboarding', cosell?: { __typename?: 'VendorCosellOnboarding', ace_eligible_selection?: string | null, has_completed_partner_central_linking?: boolean | null } | null } | null, coSell?: { __typename?: 'CoSellVendor', ace_connected?: boolean | null } | null } | null } | null };

export type CreateEmailCustomBrandMutationVariables = Exact<{
  body: EmailCustomBrandInput;
}>;


export type CreateEmailCustomBrandMutation = { __typename?: 'Mutation', createEmailCustomBrand?: { __typename?: 'EmailCustomBrand', id: string, name: string, status: string, custom_text: any, updated_at: string, colors: { __typename?: 'EmailCustomBrandColors', primary: string, secondary: string, tertiary: string }, logo: { __typename?: 'EmailCustomBrandLogo', image: string } } | null };

export type UpdateEmailCustomBrandMutationVariables = Exact<{
  body: EmailCustomBrandInput;
  updateEmailCustomBrandId: Scalars['String'];
}>;


export type UpdateEmailCustomBrandMutation = { __typename?: 'Mutation', updateEmailCustomBrand?: { __typename?: 'EmailCustomBrand', id: string, name: string, status: string, custom_text: any, updated_at: string, colors: { __typename?: 'EmailCustomBrandColors', primary: string, secondary: string, tertiary: string }, logo: { __typename?: 'EmailCustomBrandLogo', image: string } } | null };

export type TestEmailCustomBrandMutationVariables = Exact<{
  body: EmailCustomBrandTestInput;
}>;


export type TestEmailCustomBrandMutation = { __typename?: 'Mutation', testEmailCustomBrand?: { __typename?: 'EmailBrandMessageResponse', Message: string } | null };

export type GetEmailCustomBrandsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEmailCustomBrandsQuery = { __typename?: 'Query', emailCustomBrands?: Array<{ __typename?: 'EmailCustomBrand', id: string, name: string, status: string, custom_text: any, updated_at: string, colors: { __typename?: 'EmailCustomBrandColors', primary: string, secondary: string, tertiary: string }, logo: { __typename?: 'EmailCustomBrandLogo', image: string } }> | null };

export type ProspectAutoScoringGetRulesQueryVariables = Exact<{
  vendorId: Scalars['String'];
}>;


export type ProspectAutoScoringGetRulesQuery = { __typename?: 'Query', prospectAutoScoringGetRules: { __typename?: 'ProspectAutoScoringRulesResponse', data?: Array<{ __typename?: 'RuleSetWithRules', vendorId: string, name: string, description?: string | null, active: boolean, visible: boolean, ruleSetId?: string | null, pk?: string | null, sk?: string | null, rules?: Array<{ __typename?: 'CloseDateRule', ruleType: string, ruleId?: string | null, ruleSetId?: string | null, pk?: string | null, sk?: string | null, closeDateFilter: { __typename?: 'CloseDateAfter', selector: string, date: string } | { __typename?: 'CloseDateBefore', selector: string, date: string } | { __typename?: 'CloseDateWithin', selector: string, quantity: number, unit: string } } | { __typename?: 'OpportunitiesExistRule', ruleType: string, opportunitiesExist: boolean, ruleId?: string | null, ruleSetId?: string | null, pk?: string | null, sk?: string | null } | { __typename?: 'OpportunityRule', ruleType: string, opportunityTypes: Array<string>, ruleId?: string | null, ruleSetId?: string | null, pk?: string | null, sk?: string | null } | { __typename?: 'SalesStageRule', ruleType: string, salesStages: Array<string>, ruleId?: string | null, ruleSetId?: string | null, pk?: string | null, sk?: string | null } | { __typename?: 'TCVRule', ruleType: string, selector: string, amount: number, ruleId?: string | null, ruleSetId?: string | null, pk?: string | null, sk?: string | null }> | null }> | null } };

export type ProspectAutoScoringOpportunityTypeFilteringValuesQueryVariables = Exact<{
  vendorId: Scalars['String'];
}>;


export type ProspectAutoScoringOpportunityTypeFilteringValuesQuery = { __typename?: 'Query', prospectAutoScoringOpportunityTypeFilteringValues: { __typename?: 'OpportunityTypeFilteringValuesResponse', data: Array<string> } };

export type ProspectAutoScoringSalesStageFilteringValuesQueryVariables = Exact<{
  vendorId: Scalars['String'];
}>;


export type ProspectAutoScoringSalesStageFilteringValuesQuery = { __typename?: 'Query', prospectAutoScoringSalesStageFilteringValues: { __typename?: 'SalesStageFilteringValuesResponse', data: Array<string> } };

export type ProspectAutoScoringGetDomainCountQueryVariables = Exact<{
  vendorId: Scalars['String'];
  rules: AllRulesInput;
}>;


export type ProspectAutoScoringGetDomainCountQuery = { __typename?: 'Query', prospectAutoScoringGetDomainCount: { __typename?: 'AutoScoringDomainCountResponse', domainCount: number } };

export type ProspectAutoScoringGetOrCreateDefaultRuleMutationVariables = Exact<{
  vendorId: Scalars['String'];
}>;


export type ProspectAutoScoringGetOrCreateDefaultRuleMutation = { __typename?: 'Mutation', prospectAutoScoringGetOrCreateDefaultRule: { __typename?: 'ProspectAutoScoringGetOrCreateDefaultRuleResponse', data?: { __typename?: 'RuleSetWithRules', vendorId: string, name: string, visible: boolean, description?: string | null, active: boolean, ruleSetId?: string | null, rules?: Array<{ __typename?: 'CloseDateRule', ruleType: string, ruleId?: string | null, ruleSetId?: string | null, closeDateFilter: { __typename?: 'CloseDateAfter', selector: string, date: string } | { __typename?: 'CloseDateBefore', selector: string, date: string } | { __typename?: 'CloseDateWithin', selector: string, quantity: number, unit: string } } | { __typename?: 'OpportunitiesExistRule', ruleType: string, opportunitiesExist: boolean, ruleId?: string | null, ruleSetId?: string | null } | { __typename?: 'OpportunityRule', ruleType: string, opportunityTypes: Array<string>, ruleId?: string | null, ruleSetId?: string | null } | { __typename?: 'SalesStageRule', ruleType: string, salesStages: Array<string>, ruleId?: string | null, ruleSetId?: string | null } | { __typename?: 'TCVRule', ruleType: string, selector: string, amount: number, ruleId?: string | null, ruleSetId?: string | null }> | null } | null } };

export type ProspectAutoScoringPersistRulesMutationVariables = Exact<{
  vendorId: Scalars['String'];
  ruleSets: Array<RuleSetInput> | RuleSetInput;
}>;


export type ProspectAutoScoringPersistRulesMutation = { __typename?: 'Mutation', prospectAutoScoringPersistRules: string };

export type ProspectAutoScoringDeleteRuleSetsMutationVariables = Exact<{
  vendorId: Scalars['String'];
  ruleSets: Array<RuleSetInput> | RuleSetInput;
}>;


export type ProspectAutoScoringDeleteRuleSetsMutation = { __typename?: 'Mutation', prospectAutoScoringDeleteRuleSets: string };

export type ProspectAutoScoringDeleteRulesMutationVariables = Exact<{
  vendorId: Scalars['String'];
  rules: AllRulesInput;
}>;


export type ProspectAutoScoringDeleteRulesMutation = { __typename?: 'Mutation', prospectAutoScoringDeleteRules: string };

export type AccountSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountSettingsQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, vendor?: { __typename?: 'Vendor', id: string, feature_flags?: { __typename?: 'VendorFeatureFlags', is_co_sell_enabled?: boolean | null, is_co_sell_enabled_for_microsoft?: boolean | null } | null } | null } | null };

export type GetMarketplaceSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMarketplaceSettingsQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, vendor?: { __typename?: 'Vendor', id: string, email?: string | null, configuration?: { __typename?: 'VendorConfiguration', id: string, aws?: { __typename?: 'VendorAwsConfig', assume_role?: { __typename?: 'VendorAwsAssumeRoleConfig', role_arn?: string | null } | null, data_feed?: { __typename?: 'VendorDataFeedConfig', S3_bucket?: string | null, sqs?: { __typename?: 'VendorDataFeedSqsQueueConfig', url?: string | null } | null } | null } | null } | null, listingsByChannel?: { __typename?: 'VendorListingsByChannel', id: string, aws?: Array<{ __typename?: 'AwsListing', id: string, marketplace_url?: string | null, status?: string | null }> | null, azure?: Array<{ __typename?: 'AzureListing', id: string, marketplace_url?: string | null, status?: string | null }> | null, gcp?: Array<{ __typename?: 'GcpListing', id: string, marketplace_url?: string | null, status?: string | null }> | null } | null, onboarding?: { __typename?: 'VendorOnboarding', aws?: { __typename?: 'VendorAwsOnboarding', account_setup?: Array<string> | null, stacks?: Array<string> | null } | null } | null } | null } | null };

export type UpdateMarketplaceSettingsMutationVariables = Exact<{
  updates: VendorInput;
}>;


export type UpdateMarketplaceSettingsMutation = { __typename?: 'Mutation', updateVendor?: { __typename?: 'Vendor', email?: string | null, id: string } | null };

export type AwsVendorCasIamPolicyFormSectionQueryVariables = Exact<{ [key: string]: never; }>;


export type AwsVendorCasIamPolicyFormSectionQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, vendor?: { __typename?: 'Vendor', id: string, configuration?: { __typename?: 'VendorConfiguration', aws?: { __typename?: 'VendorAwsConfig', assume_role?: { __typename?: 'VendorAwsAssumeRoleConfig', role_arn?: string | null } | null } | null } | null, onboarding?: { __typename?: 'VendorOnboarding', aws?: { __typename?: 'VendorAwsOnboarding', stacks?: Array<string> | null } | null } | null } | null } | null };

export type UpdateAwsVendorCasIamPolicyFormSectionMutationVariables = Exact<{
  updates: VendorInput;
}>;


export type UpdateAwsVendorCasIamPolicyFormSectionMutation = { __typename?: 'Mutation', updateVendor?: { __typename?: 'Vendor', id: string, onboarding?: { __typename?: 'VendorOnboarding', aws?: { __typename?: 'VendorAwsOnboarding', stacks?: Array<string> | null } | null } | null } | null };

export type AwsVendorEnrollInSddsFormSectionQueryVariables = Exact<{ [key: string]: never; }>;


export type AwsVendorEnrollInSddsFormSectionQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, vendor?: { __typename?: 'Vendor', id: string, configuration?: { __typename?: 'VendorConfiguration', aws?: { __typename?: 'VendorAwsConfig', data_feed?: { __typename?: 'VendorDataFeedConfig', kms_key_arn?: string | null, S3_bucket?: string | null, sns_topic_arn?: string | null } | null } | null } | null, onboarding?: { __typename?: 'VendorOnboarding', aws?: { __typename?: 'VendorAwsOnboarding', stacks?: Array<string> | null } | null } | null } | null } | null };

export type UpdateAwsVendorEnrollInSddsFormSectionMutationVariables = Exact<{
  updates: VendorInput;
}>;


export type UpdateAwsVendorEnrollInSddsFormSectionMutation = { __typename?: 'Mutation', updateVendor?: { __typename?: 'Vendor', id: string, configuration?: { __typename?: 'VendorConfiguration', aws?: { __typename?: 'VendorAwsConfig', data_feed?: { __typename?: 'VendorDataFeedConfig', kms_key_arn?: string | null, S3_bucket?: string | null, sns_topic_arn?: string | null } | null } | null } | null, onboarding?: { __typename?: 'VendorOnboarding', aws?: { __typename?: 'VendorAwsOnboarding', stacks?: Array<string> | null } | null } | null } | null };

export type AwsVendorAccountSetupFormSectionQueryVariables = Exact<{ [key: string]: never; }>;


export type AwsVendorAccountSetupFormSectionQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, vendor?: { __typename?: 'Vendor', id: string, onboarding?: { __typename?: 'VendorOnboarding', aws?: { __typename?: 'VendorAwsOnboarding', account_setup?: Array<string> | null } | null } | null } | null } | null };

export type UpdateAwsVendorAccountSetupFormSectionMutationVariables = Exact<{
  updates: VendorInput;
}>;


export type UpdateAwsVendorAccountSetupFormSectionMutation = { __typename?: 'Mutation', updateVendor?: { __typename?: 'Vendor', id: string, onboarding?: { __typename?: 'VendorOnboarding', aws?: { __typename?: 'VendorAwsOnboarding', account_setup?: Array<string> | null } | null } | null } | null };

export type AwsVendorGrantTackleAccessFormSectionQueryVariables = Exact<{ [key: string]: never; }>;


export type AwsVendorGrantTackleAccessFormSectionQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, vendor?: { __typename?: 'Vendor', id: string, external_id?: string | null, configuration?: { __typename?: 'VendorConfiguration', id: string, aws?: { __typename?: 'VendorAwsConfig', assume_role?: { __typename?: 'VendorAwsAssumeRoleConfig', role_arn?: string | null } | null } | null } | null, onboarding?: { __typename?: 'VendorOnboarding', aws?: { __typename?: 'VendorAwsOnboarding', stacks?: Array<string> | null, admin_contacts?: Array<{ __typename?: 'AdminContacts', name?: string | null, email?: string | null }> | null } | null } | null } | null } | null };

export type UpdateAwsVendorGrantTackleAccessFormSectionMutationVariables = Exact<{
  id: Scalars['ID'];
  updates: VendorInput;
}>;


export type UpdateAwsVendorGrantTackleAccessFormSectionMutation = { __typename?: 'Mutation', updateVendor?: { __typename?: 'Vendor', id: string, configuration?: { __typename?: 'VendorConfiguration', id: string, aws?: { __typename?: 'VendorAwsConfig', assume_role?: { __typename?: 'VendorAwsAssumeRoleConfig', role_arn?: string | null } | null } | null } | null, onboarding?: { __typename?: 'VendorOnboarding', aws?: { __typename?: 'VendorAwsOnboarding', stacks?: Array<string> | null, admin_contacts?: Array<{ __typename?: 'AdminContacts', name?: string | null, email?: string | null }> | null } | null } | null } | null, validateVendor?: { __typename?: 'Vendor', id: string, configuration?: { __typename?: 'VendorConfiguration', id: string, status?: { __typename?: 'VendorConfigurationStatuses', aws?: { __typename?: 'VendorStatus', value?: string | null, last_connected_at?: string | null, updated_at?: string | null, error?: string | null } | null, events_sqs?: { __typename?: 'VendorStatus', value?: string | null, last_connected_at?: string | null, updated_at?: string | null, error?: string | null } | null, sdds?: { __typename?: 'VendorStatus', value?: string | null, last_connected_at?: string | null, updated_at?: string | null, error?: string | null } | null } | null } | null } | null };

export type AwsVendorSetupOrderNotificationsFormSectionQueryVariables = Exact<{ [key: string]: never; }>;


export type AwsVendorSetupOrderNotificationsFormSectionQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, vendor?: { __typename?: 'Vendor', id: string, name?: string | null, configuration?: { __typename?: 'VendorConfiguration', id: string, vendor_events?: { __typename?: 'VendorSqsQueueConfig', url?: string | null } | null, aws?: { __typename?: 'VendorAwsConfig', assume_role?: { __typename?: 'VendorAwsAssumeRoleConfig', role_arn?: string | null } | null } | null } | null, onboarding?: { __typename?: 'VendorOnboarding', aws?: { __typename?: 'VendorAwsOnboarding', stacks?: Array<string> | null } | null } | null } | null } | null };

export type UpdateAwsVendorSetupOrderNotificationsFormSectionMutationVariables = Exact<{
  updates: VendorInput;
}>;


export type UpdateAwsVendorSetupOrderNotificationsFormSectionMutation = { __typename?: 'Mutation', updateVendor?: { __typename?: 'Vendor', id: string, configuration?: { __typename?: 'VendorConfiguration', aws?: { __typename?: 'VendorAwsConfig', assume_role?: { __typename?: 'VendorAwsAssumeRoleConfig', role_arn?: string | null } | null } | null, vendor_events?: { __typename?: 'VendorSqsQueueConfig', url?: string | null } | null } | null, onboarding?: { __typename?: 'VendorOnboarding', aws?: { __typename?: 'VendorAwsOnboarding', stacks?: Array<string> | null } | null } | null } | null };

export type AwsVendorSetupSddsFormSectionQueryVariables = Exact<{ [key: string]: never; }>;


export type AwsVendorSetupSddsFormSectionQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, vendor?: { __typename?: 'Vendor', id: string, name?: string | null, configuration?: { __typename?: 'VendorConfiguration', aws?: { __typename?: 'VendorAwsConfig', assume_role?: { __typename?: 'VendorAwsAssumeRoleConfig', role_arn?: string | null } | null, data_feed?: { __typename?: 'VendorDataFeedConfig', kms_key_arn?: string | null, S3_bucket?: string | null, sns_topic_arn?: string | null, sqs?: { __typename?: 'VendorDataFeedSqsQueueConfig', url?: string | null } | null } | null } | null } | null, onboarding?: { __typename?: 'VendorOnboarding', aws?: { __typename?: 'VendorAwsOnboarding', stacks?: Array<string> | null } | null } | null } | null } | null };

export type UpdateAwsVendorSetupSddsFormSectionMutationVariables = Exact<{
  updates: VendorInput;
}>;


export type UpdateAwsVendorSetupSddsFormSectionMutation = { __typename?: 'Mutation', updateVendor?: { __typename?: 'Vendor', id: string, name?: string | null, configuration?: { __typename?: 'VendorConfiguration', aws?: { __typename?: 'VendorAwsConfig', assume_role?: { __typename?: 'VendorAwsAssumeRoleConfig', role_arn?: string | null } | null, data_feed?: { __typename?: 'VendorDataFeedConfig', kms_key_arn?: string | null, S3_bucket?: string | null, sns_topic_arn?: string | null, sqs?: { __typename?: 'VendorDataFeedSqsQueueConfig', url?: string | null } | null } | null } | null } | null, onboarding?: { __typename?: 'VendorOnboarding', aws?: { __typename?: 'VendorAwsOnboarding', stacks?: Array<string> | null } | null } | null } | null };

export type ValidateVendorConfigurationButtonQueryVariables = Exact<{ [key: string]: never; }>;


export type ValidateVendorConfigurationButtonQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, vendor?: { __typename?: 'Vendor', id: string, configuration?: { __typename?: 'VendorConfiguration', aws?: { __typename?: 'VendorAwsConfig', assume_role?: { __typename?: 'VendorAwsAssumeRoleConfig', role_arn?: string | null } | null } | null } | null } | null } | null };

export type ValidateVendorConfigurationMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ValidateVendorConfigurationMutation = { __typename?: 'Mutation', validateVendor?: { __typename?: 'Vendor', id: string, configuration?: { __typename?: 'VendorConfiguration', id: string, status?: { __typename?: 'VendorConfigurationStatuses', aws?: { __typename?: 'VendorStatus', value?: string | null, last_connected_at?: string | null, updated_at?: string | null, error?: string | null } | null, events_sqs?: { __typename?: 'VendorStatus', value?: string | null, last_connected_at?: string | null, updated_at?: string | null, error?: string | null } | null, sdds?: { __typename?: 'VendorStatus', value?: string | null, last_connected_at?: string | null, updated_at?: string | null, error?: string | null } | null } | null } | null } | null };

export type AzureVendorAdditionalServicesFormSectionQueryVariables = Exact<{ [key: string]: never; }>;


export type AzureVendorAdditionalServicesFormSectionQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, vendor?: { __typename?: 'Vendor', id: string, onboarding?: { __typename?: 'VendorOnboarding', azure?: { __typename?: 'VendorAzureOnboarding', commercial_marketplace?: Array<string> | null } | null } | null } | null } | null };

export type UpdateAzureVendorAdditionalServicesFormSectionMutationVariables = Exact<{
  updates: VendorInput;
}>;


export type UpdateAzureVendorAdditionalServicesFormSectionMutation = { __typename?: 'Mutation', updateVendor?: { __typename?: 'Vendor', id: string, onboarding?: { __typename?: 'VendorOnboarding', azure?: { __typename?: 'VendorAzureOnboarding', commercial_marketplace?: Array<string> | null } | null } | null } | null };

export type AzureVendorMarketplaceAccountFormSectionQueryVariables = Exact<{ [key: string]: never; }>;


export type AzureVendorMarketplaceAccountFormSectionQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, vendor?: { __typename?: 'Vendor', id: string, onboarding?: { __typename?: 'VendorOnboarding', azure?: { __typename?: 'VendorAzureOnboarding', account_setup?: Array<string> | null, commercial_marketplace?: Array<string> | null, admin_contacts?: Array<{ __typename?: 'AdminContacts', name?: string | null, email?: string | null }> | null } | null } | null } | null } | null };

export type UpdateAzureVendorMarketplaceAccountFormSectionMutationVariables = Exact<{
  updates: VendorInput;
}>;


export type UpdateAzureVendorMarketplaceAccountFormSectionMutation = { __typename?: 'Mutation', updateVendor?: { __typename?: 'Vendor', id: string, onboarding?: { __typename?: 'VendorOnboarding', azure?: { __typename?: 'VendorAzureOnboarding', account_setup?: Array<string> | null, commercial_marketplace?: Array<string> | null, admin_contacts?: Array<{ __typename?: 'AdminContacts', name?: string | null, email?: string | null }> | null } | null } | null } | null };

export type AzureVendorTackleAndAzureFormSectionQueryVariables = Exact<{ [key: string]: never; }>;


export type AzureVendorTackleAndAzureFormSectionQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, vendor?: { __typename?: 'Vendor', id: string, configuration?: { __typename?: 'VendorConfiguration', azure?: { __typename?: 'VendorAzureConfig', exp_date?: string | null } | null } | null, onboarding?: { __typename?: 'VendorOnboarding', azure?: { __typename?: 'VendorAzureOnboarding', account_setup?: Array<string> | null, commercial_marketplace?: Array<string> | null } | null } | null, coSell?: { __typename?: 'CoSellVendor', id?: string | null, mspc_connected?: boolean | null, microsoftPartnerCenterConsentLink?: string | null, microsoftSolutions?: Array<{ __typename?: 'CoSellMicrosoftSolution', id: string }> | null } | null } | null } | null };

export type AzureVendorTackleAndAzureFormSectionMspcConnectedQueryVariables = Exact<{ [key: string]: never; }>;


export type AzureVendorTackleAndAzureFormSectionMspcConnectedQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, vendor?: { __typename?: 'Vendor', id: string, coSell?: { __typename?: 'CoSellVendor', id?: string | null, mspc_connected?: boolean | null } | null } | null } | null };

export type UpdateAzureVendorTackleAndAzureFormSectionMutationVariables = Exact<{
  updates: VendorInput;
}>;


export type UpdateAzureVendorTackleAndAzureFormSectionMutation = { __typename?: 'Mutation', updateVendor?: { __typename?: 'Vendor', id: string, configuration?: { __typename?: 'VendorConfiguration', azure?: { __typename?: 'VendorAzureConfig', exp_date?: string | null } | null } | null, onboarding?: { __typename?: 'VendorOnboarding', azure?: { __typename?: 'VendorAzureOnboarding', account_setup?: Array<string> | null, commercial_marketplace?: Array<string> | null } | null } | null, coSell?: { __typename?: 'CoSellVendor', id?: string | null, mspc_connected?: boolean | null, microsoftPartnerCenterConsentLink?: string | null } | null } | null };

export type GcpVendorAdditionalServicesFormSectionQueryVariables = Exact<{ [key: string]: never; }>;


export type GcpVendorAdditionalServicesFormSectionQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, vendor?: { __typename?: 'Vendor', id: string, configuration?: { __typename?: 'VendorConfiguration', gcp?: { __typename?: 'VendorGcpConfig', projects?: Array<{ __typename?: 'VendorGcpProjectConfig', report_bucket?: string | null, id?: string | null }> | null } | null } | null, onboarding?: { __typename?: 'VendorOnboarding', gcp?: { __typename?: 'VendorGcpOnboarding', gc_payment_is_configured?: boolean | null } | null } | null } | null } | null };

export type UpdateGcpVendorAdditionalServicesFormSectionMutationVariables = Exact<{
  updates: VendorInput;
}>;


export type UpdateGcpVendorAdditionalServicesFormSectionMutation = { __typename?: 'Mutation', updateVendor?: { __typename?: 'Vendor', id: string, configuration?: { __typename?: 'VendorConfiguration', gcp?: { __typename?: 'VendorGcpConfig', projects?: Array<{ __typename?: 'VendorGcpProjectConfig', report_bucket?: string | null, id?: string | null }> | null } | null } | null, onboarding?: { __typename?: 'VendorOnboarding', gcp?: { __typename?: 'VendorGcpOnboarding', gc_payment_is_configured?: boolean | null } | null } | null } | null };

export type GcpVendorMarketplaceAccountFormSectionQueryVariables = Exact<{ [key: string]: never; }>;


export type GcpVendorMarketplaceAccountFormSectionQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, vendor?: { __typename?: 'Vendor', id: string, configuration?: { __typename?: 'VendorConfiguration', gcp?: { __typename?: 'VendorGcpConfig', projects?: Array<{ __typename?: 'VendorGcpProjectConfig', name?: string | null, service_account?: string | null, service_account_name?: string | null, service_account_email_address?: string | null, project_name?: string | null, project_number?: string | null, id?: string | null }> | null } | null } | null } | null } | null };

export type UpdateGcpVendorMarketplaceAccountFormSectionMutationVariables = Exact<{
  updates: VendorInput;
}>;


export type UpdateGcpVendorMarketplaceAccountFormSectionMutation = { __typename?: 'Mutation', updateVendor?: { __typename?: 'Vendor', id: string, configuration?: { __typename?: 'VendorConfiguration', gcp?: { __typename?: 'VendorGcpConfig', projects?: Array<{ __typename?: 'VendorGcpProjectConfig', name?: string | null, service_account?: string | null, service_account_name?: string | null, service_account_email_address?: string | null, project_name?: string | null, project_number?: string | null, id?: string | null }> | null } | null } | null } | null };

export type GcpVendorTackleAndGcpFormSectionQueryVariables = Exact<{ [key: string]: never; }>;


export type GcpVendorTackleAndGcpFormSectionQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', vendor?: { __typename?: 'Vendor', id: string, onboarding?: { __typename?: 'VendorOnboarding', gcp?: { __typename?: 'VendorGcpOnboarding', gc_project_access_is_granted?: boolean | null, gc_tackle_permissions_for_offers_granted?: boolean | null, gc_marketplace_form_is_submitted?: boolean | null, admin_contacts?: Array<{ __typename?: 'AdminContacts', name?: string | null, email?: string | null }> | null } | null } | null, reporting?: { __typename?: 'VendorReporting', health?: { __typename?: 'VendorReportingHealth', gcp_status?: { __typename?: 'VendorReportingConnection', status?: string | null } | null } | null } | null } | null } | null };

export type UpdateGcpVendorTackleAndGcpFormSectionMutationVariables = Exact<{
  updates: VendorInput;
}>;


export type UpdateGcpVendorTackleAndGcpFormSectionMutation = { __typename?: 'Mutation', updateVendor?: { __typename?: 'Vendor', id: string, onboarding?: { __typename?: 'VendorOnboarding', gcp?: { __typename?: 'VendorGcpOnboarding', gc_project_access_is_granted?: boolean | null, gc_tackle_permissions_for_offers_granted?: boolean | null, gc_marketplace_form_is_submitted?: boolean | null, admin_contacts?: Array<{ __typename?: 'AdminContacts', name?: string | null, email?: string | null }> | null } | null } | null } | null };

export type GetAccountSettingsUsersQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAccountSettingsUsersQueryQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, role?: string | null, organizationId?: string | null, vendor?: { __typename?: 'Vendor', id: string, name?: string | null, vendor_type?: string | null } | null } | null };

export type UpsertRoleMutationVariables = Exact<{
  body: RoleInput;
}>;


export type UpsertRoleMutation = { __typename?: 'Mutation', upsertRole: { __typename?: 'Role', id: string, name: string, organization_id: string, permissions?: Array<string> | null, global: boolean, built_in: boolean, allowed_vendors?: Array<string> | null, created_at: string, updated_at: string } };

export type CurrentVendorsQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentVendorsQuery = { __typename?: 'Query', currentVendors?: Array<{ __typename?: 'Vendor', vendorid?: string | null, name?: string | null } | null> | null };

export type EditRoleDrawerRoleDetailsQueryVariables = Exact<{
  roleDetailsId: Scalars['String'];
}>;


export type EditRoleDrawerRoleDetailsQuery = { __typename?: 'Query', roleDetails: { __typename?: 'RoleWithDetails', in_use: boolean, in_use_count: number } };

export type EditRoleDrawerDeleteRoleMutationVariables = Exact<{
  roleDeleteId: Scalars['String'];
}>;


export type EditRoleDrawerDeleteRoleMutation = { __typename?: 'Mutation', deleteRole: { __typename?: 'Role', id: string, name: string } };

export type GetRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRolesQuery = { __typename?: 'Query', roles?: Array<{ __typename?: 'Role', id: string, name: string, organization_id: string, permissions?: Array<string> | null, global: boolean, built_in: boolean, allowed_vendors?: Array<string> | null, created_at: string, updated_at: string }> | null };

export type GetUsersFromOrganizationQueryVariables = Exact<{
  organizationId: Scalars['String'];
}>;


export type GetUsersFromOrganizationQuery = { __typename?: 'Query', usersFromOrganization?: Array<{ __typename?: 'UserFromOrgResult', user_id?: string | null, name?: string | null, email?: string | null, picture?: string | null, role_id?: string | null, role_name?: string | null, allowed_vendors_rbac?: Array<string | null> | null, vendor_names?: Array<string | null> | null, sso_user?: boolean | null, superadmin?: boolean | null, supportapi?: boolean | null, vendorid?: string | null, organization_id?: string | null, vendor_type?: string | null, allowed_vendors_auth0?: Array<string | null> | null, logins_count?: number | null, global?: boolean | null, created_at?: string | null, updated_at?: string | null, last_login?: string | null, deactivated_at?: string | null, id?: string | null } | null> | null };

export type GetOrganizationVendorIdsQueryVariables = Exact<{
  organizationId: Scalars['String'];
}>;


export type GetOrganizationVendorIdsQuery = { __typename?: 'Query', organizationVendors?: { __typename?: 'OrganizationVendors', id?: string | null, name?: string | null, vendors?: Array<{ __typename?: 'OrganizationVendor', id?: string | null, name?: string | null, vendor_type?: string | null } | null> | null } | null };

export type DeleteUserMutationVariables = Exact<{
  userId: Scalars['String'];
}>;


export type DeleteUserMutation = { __typename?: 'Mutation', deleteUser?: any | null };

export type SignUpMutationVariables = Exact<{
  input: SignUpInput;
}>;


export type SignUpMutation = { __typename?: 'Mutation', signUp: { __typename?: 'SignUpResult', user: { __typename?: 'NewUser', id: string, vendorid: string, email: string } } };

export type CheckEmailQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type CheckEmailQuery = { __typename?: 'Query', checkEmail: { __typename?: 'CheckEmailResult', valid: boolean } };

export type CosellDashboardQueryVariables = Exact<{ [key: string]: never; }>;


export type CosellDashboardQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, vendor?: { __typename?: 'Vendor', id: string, vendor_type?: string | null, coSell?: { __typename?: 'CoSellVendor', id?: string | null, ace_connected?: boolean | null, ace_entitled_status?: boolean | null, mspc_entitled_status?: boolean | null, mspc_connected?: boolean | null, microsoftSolutions?: Array<{ __typename?: 'CoSellMicrosoftSolution', archivedAt?: string | null, externalId: string, id: string, solutionName?: string | null }> | null } | null } | null } | null };

export type PlatformRbacProviderQueryVariables = Exact<{ [key: string]: never; }>;


export type PlatformRbacProviderQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, role_details?: { __typename?: 'Role', id: string, permissions?: Array<string> | null } | null } | null };


export const CurrentUserVendorDocument = gql`
    query currentUserVendor {
  currentUser {
    id
    vendor {
      id
      vendor_type
    }
  }
}
    `;

/**
 * __useCurrentUserVendorQuery__
 *
 * To run a query within a React component, call `useCurrentUserVendorQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserVendorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserVendorQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserVendorQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserVendorQuery, CurrentUserVendorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserVendorQuery, CurrentUserVendorQueryVariables>(CurrentUserVendorDocument, options);
      }
export function useCurrentUserVendorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserVendorQuery, CurrentUserVendorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserVendorQuery, CurrentUserVendorQueryVariables>(CurrentUserVendorDocument, options);
        }
export type CurrentUserVendorQueryHookResult = ReturnType<typeof useCurrentUserVendorQuery>;
export type CurrentUserVendorLazyQueryHookResult = ReturnType<typeof useCurrentUserVendorLazyQuery>;
export type CurrentUserVendorQueryResult = Apollo.QueryResult<CurrentUserVendorQuery, CurrentUserVendorQueryVariables>;
export const GetThirdPartyServicesIdentificationInfoDocument = gql`
    query getThirdPartyServicesIdentificationInfo {
  currentUser {
    id
    name
    email
    role
    organizationId
    vendor {
      id
      name
      vendor_type
    }
    intercomUserHash
  }
}
    `;

/**
 * __useGetThirdPartyServicesIdentificationInfoQuery__
 *
 * To run a query within a React component, call `useGetThirdPartyServicesIdentificationInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetThirdPartyServicesIdentificationInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetThirdPartyServicesIdentificationInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetThirdPartyServicesIdentificationInfoQuery(baseOptions?: Apollo.QueryHookOptions<GetThirdPartyServicesIdentificationInfoQuery, GetThirdPartyServicesIdentificationInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetThirdPartyServicesIdentificationInfoQuery, GetThirdPartyServicesIdentificationInfoQueryVariables>(GetThirdPartyServicesIdentificationInfoDocument, options);
      }
export function useGetThirdPartyServicesIdentificationInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetThirdPartyServicesIdentificationInfoQuery, GetThirdPartyServicesIdentificationInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetThirdPartyServicesIdentificationInfoQuery, GetThirdPartyServicesIdentificationInfoQueryVariables>(GetThirdPartyServicesIdentificationInfoDocument, options);
        }
export type GetThirdPartyServicesIdentificationInfoQueryHookResult = ReturnType<typeof useGetThirdPartyServicesIdentificationInfoQuery>;
export type GetThirdPartyServicesIdentificationInfoLazyQueryHookResult = ReturnType<typeof useGetThirdPartyServicesIdentificationInfoLazyQuery>;
export type GetThirdPartyServicesIdentificationInfoQueryResult = Apollo.QueryResult<GetThirdPartyServicesIdentificationInfoQuery, GetThirdPartyServicesIdentificationInfoQueryVariables>;
export const GetVendorsDocument = gql`
    query getVendors($token: String, $size: Int, $search: String) {
  vendors(pageToken: $token, pageSize: $size, search: $search) {
    vendors {
      id
      name
      logo_url
      vendor_type
      production_vendor_id
    }
    nextPageToken
  }
}
    `;

/**
 * __useGetVendorsQuery__
 *
 * To run a query within a React component, call `useGetVendorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVendorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVendorsQuery({
 *   variables: {
 *      token: // value for 'token'
 *      size: // value for 'size'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetVendorsQuery(baseOptions?: Apollo.QueryHookOptions<GetVendorsQuery, GetVendorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVendorsQuery, GetVendorsQueryVariables>(GetVendorsDocument, options);
      }
export function useGetVendorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVendorsQuery, GetVendorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVendorsQuery, GetVendorsQueryVariables>(GetVendorsDocument, options);
        }
export type GetVendorsQueryHookResult = ReturnType<typeof useGetVendorsQuery>;
export type GetVendorsLazyQueryHookResult = ReturnType<typeof useGetVendorsLazyQuery>;
export type GetVendorsQueryResult = Apollo.QueryResult<GetVendorsQuery, GetVendorsQueryVariables>;
export const GetAccountListOrganizationVendorsDocument = gql`
    query getAccountListOrganizationVendors {
  currentVendors {
    id
    logo_url
    name
    vendor_type
    production_vendor_id
  }
}
    `;

/**
 * __useGetAccountListOrganizationVendorsQuery__
 *
 * To run a query within a React component, call `useGetAccountListOrganizationVendorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountListOrganizationVendorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountListOrganizationVendorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAccountListOrganizationVendorsQuery(baseOptions?: Apollo.QueryHookOptions<GetAccountListOrganizationVendorsQuery, GetAccountListOrganizationVendorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountListOrganizationVendorsQuery, GetAccountListOrganizationVendorsQueryVariables>(GetAccountListOrganizationVendorsDocument, options);
      }
export function useGetAccountListOrganizationVendorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountListOrganizationVendorsQuery, GetAccountListOrganizationVendorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountListOrganizationVendorsQuery, GetAccountListOrganizationVendorsQueryVariables>(GetAccountListOrganizationVendorsDocument, options);
        }
export type GetAccountListOrganizationVendorsQueryHookResult = ReturnType<typeof useGetAccountListOrganizationVendorsQuery>;
export type GetAccountListOrganizationVendorsLazyQueryHookResult = ReturnType<typeof useGetAccountListOrganizationVendorsLazyQuery>;
export type GetAccountListOrganizationVendorsQueryResult = Apollo.QueryResult<GetAccountListOrganizationVendorsQuery, GetAccountListOrganizationVendorsQueryVariables>;
export const ChangeUsersVendorDocument = gql`
    mutation changeUsersVendor($vendorid: String!) {
  switchVendors(vendorid: $vendorid) {
    vendorId
  }
}
    `;
export type ChangeUsersVendorMutationFn = Apollo.MutationFunction<ChangeUsersVendorMutation, ChangeUsersVendorMutationVariables>;

/**
 * __useChangeUsersVendorMutation__
 *
 * To run a mutation, you first call `useChangeUsersVendorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeUsersVendorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeUsersVendorMutation, { data, loading, error }] = useChangeUsersVendorMutation({
 *   variables: {
 *      vendorid: // value for 'vendorid'
 *   },
 * });
 */
export function useChangeUsersVendorMutation(baseOptions?: Apollo.MutationHookOptions<ChangeUsersVendorMutation, ChangeUsersVendorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeUsersVendorMutation, ChangeUsersVendorMutationVariables>(ChangeUsersVendorDocument, options);
      }
export type ChangeUsersVendorMutationHookResult = ReturnType<typeof useChangeUsersVendorMutation>;
export type ChangeUsersVendorMutationResult = Apollo.MutationResult<ChangeUsersVendorMutation>;
export type ChangeUsersVendorMutationOptions = Apollo.BaseMutationOptions<ChangeUsersVendorMutation, ChangeUsersVendorMutationVariables>;
export const ApplicationShellDocument = gql`
    query applicationShell {
  currentUser {
    id
    vendor {
      id
      name
      created_at
      vendor_type
      production_vendor_id
      feature_flags {
        is_co_sell_enabled
        is_co_sell_enabled_for_microsoft
        is_prospect_enabled
        is_marketplace_enabled
        is_listings_enabled
      }
      listingsByChannel {
        id
        aws {
          id
          status
          packages
          sns_configuration {
            value
          }
        }
        azure {
          id
          packages
        }
        gcp {
          id
          packages
        }
        redhat {
          id
          packages
        }
      }
      configuration {
        id
        status {
          sdds {
            value
          }
        }
      }
    }
    allowedVendors
  }
}
    `;

/**
 * __useApplicationShellQuery__
 *
 * To run a query within a React component, call `useApplicationShellQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplicationShellQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplicationShellQuery({
 *   variables: {
 *   },
 * });
 */
export function useApplicationShellQuery(baseOptions?: Apollo.QueryHookOptions<ApplicationShellQuery, ApplicationShellQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApplicationShellQuery, ApplicationShellQueryVariables>(ApplicationShellDocument, options);
      }
export function useApplicationShellLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApplicationShellQuery, ApplicationShellQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApplicationShellQuery, ApplicationShellQueryVariables>(ApplicationShellDocument, options);
        }
export type ApplicationShellQueryHookResult = ReturnType<typeof useApplicationShellQuery>;
export type ApplicationShellLazyQueryHookResult = ReturnType<typeof useApplicationShellLazyQuery>;
export type ApplicationShellQueryResult = Apollo.QueryResult<ApplicationShellQuery, ApplicationShellQueryVariables>;
export const VendorWithSandboxesDocument = gql`
    query vendorWithSandboxes($vendorid: ID!) {
  vendor(id: $vendorid) {
    id
    vendor_type
    name
    linkedSandboxes {
      id
      name
    }
  }
}
    `;

/**
 * __useVendorWithSandboxesQuery__
 *
 * To run a query within a React component, call `useVendorWithSandboxesQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorWithSandboxesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorWithSandboxesQuery({
 *   variables: {
 *      vendorid: // value for 'vendorid'
 *   },
 * });
 */
export function useVendorWithSandboxesQuery(baseOptions: Apollo.QueryHookOptions<VendorWithSandboxesQuery, VendorWithSandboxesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VendorWithSandboxesQuery, VendorWithSandboxesQueryVariables>(VendorWithSandboxesDocument, options);
      }
export function useVendorWithSandboxesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VendorWithSandboxesQuery, VendorWithSandboxesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VendorWithSandboxesQuery, VendorWithSandboxesQueryVariables>(VendorWithSandboxesDocument, options);
        }
export type VendorWithSandboxesQueryHookResult = ReturnType<typeof useVendorWithSandboxesQuery>;
export type VendorWithSandboxesLazyQueryHookResult = ReturnType<typeof useVendorWithSandboxesLazyQuery>;
export type VendorWithSandboxesQueryResult = Apollo.QueryResult<VendorWithSandboxesQuery, VendorWithSandboxesQueryVariables>;
export const GetVendorProfileInformationDocument = gql`
    query getVendorProfileInformation {
  currentUser {
    id
    isSuperAdmin
    allowedVendors
    vendor {
      id
      name
      logo_url
    }
  }
}
    `;

/**
 * __useGetVendorProfileInformationQuery__
 *
 * To run a query within a React component, call `useGetVendorProfileInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVendorProfileInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVendorProfileInformationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetVendorProfileInformationQuery(baseOptions?: Apollo.QueryHookOptions<GetVendorProfileInformationQuery, GetVendorProfileInformationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVendorProfileInformationQuery, GetVendorProfileInformationQueryVariables>(GetVendorProfileInformationDocument, options);
      }
export function useGetVendorProfileInformationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVendorProfileInformationQuery, GetVendorProfileInformationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVendorProfileInformationQuery, GetVendorProfileInformationQueryVariables>(GetVendorProfileInformationDocument, options);
        }
export type GetVendorProfileInformationQueryHookResult = ReturnType<typeof useGetVendorProfileInformationQuery>;
export type GetVendorProfileInformationLazyQueryHookResult = ReturnType<typeof useGetVendorProfileInformationLazyQuery>;
export type GetVendorProfileInformationQueryResult = Apollo.QueryResult<GetVendorProfileInformationQuery, GetVendorProfileInformationQueryVariables>;
export const GetRolesForUserModalDocument = gql`
    query GetRolesForUserModal {
  roleWithVendorNames {
    id
    name
    organization_id
    allowed_vendors
    allowed_vendors_names
    global
  }
}
    `;

/**
 * __useGetRolesForUserModalQuery__
 *
 * To run a query within a React component, call `useGetRolesForUserModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRolesForUserModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRolesForUserModalQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRolesForUserModalQuery(baseOptions?: Apollo.QueryHookOptions<GetRolesForUserModalQuery, GetRolesForUserModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRolesForUserModalQuery, GetRolesForUserModalQueryVariables>(GetRolesForUserModalDocument, options);
      }
export function useGetRolesForUserModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRolesForUserModalQuery, GetRolesForUserModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRolesForUserModalQuery, GetRolesForUserModalQueryVariables>(GetRolesForUserModalDocument, options);
        }
export type GetRolesForUserModalQueryHookResult = ReturnType<typeof useGetRolesForUserModalQuery>;
export type GetRolesForUserModalLazyQueryHookResult = ReturnType<typeof useGetRolesForUserModalLazyQuery>;
export type GetRolesForUserModalQueryResult = Apollo.QueryResult<GetRolesForUserModalQuery, GetRolesForUserModalQueryVariables>;
export const CreateUserDocument = gql`
    mutation CreateUser($email: String!, $role: Auth0UserCreateInputRole!) {
  createUser(email: $email, role: $role) {
    id
    email
    picture
    name
    nickname
    logins_count
    email_verified
    app_metadata {
      role
      vendorid
      organization_id
      vendor_type
      allowed_vendors
      password_set
      superadmin
      supportapi
      sso_user
    }
  }
}
    `;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      email: // value for 'email'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($userId: String!, $email: String!, $role: Auth0UserCreateInputRole!) {
  updateUser(userId: $userId, email: $email, role: $role) {
    id
    email
    app_metadata {
      role
      vendorid
      organization_id
      vendor_type
      allowed_vendors
      password_set
      superadmin
      supportapi
      sso_user
    }
    picture
    name
    nickname
    logins_count
    email_verified
  }
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      email: // value for 'email'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const VendorMarketplaceStatusDocument = gql`
    query VendorMarketplaceStatus {
  currentUser {
    id
    vendor {
      id
      vendor_type
      configuration {
        id
        status {
          aws {
            value
            last_connected_at
            updated_at
            error
          }
          sdds {
            value
            last_connected_at
            updated_at
            error
          }
          events_sqs {
            value
            last_connected_at
            updated_at
            error
          }
        }
      }
      reporting {
        id
        health {
          sdds_s3_status {
            status
            raw_error
          }
          sdds_sqs_status {
            status
            raw_error
          }
          tkl_iam_role_status {
            status
            raw_error
          }
          cas_iam_status {
            status
            raw_error
          }
          cas_s3_status {
            status
            raw_error
          }
          cas_sqs_status {
            status
            raw_error
          }
          cas_generation_status {
            status
            raw_error
          }
          gcp_status {
            status
            raw_error
          }
          azure_status {
            status
            raw_error
          }
        }
      }
    }
  }
}
    `;

/**
 * __useVendorMarketplaceStatusQuery__
 *
 * To run a query within a React component, call `useVendorMarketplaceStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorMarketplaceStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorMarketplaceStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useVendorMarketplaceStatusQuery(baseOptions?: Apollo.QueryHookOptions<VendorMarketplaceStatusQuery, VendorMarketplaceStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VendorMarketplaceStatusQuery, VendorMarketplaceStatusQueryVariables>(VendorMarketplaceStatusDocument, options);
      }
export function useVendorMarketplaceStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VendorMarketplaceStatusQuery, VendorMarketplaceStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VendorMarketplaceStatusQuery, VendorMarketplaceStatusQueryVariables>(VendorMarketplaceStatusDocument, options);
        }
export type VendorMarketplaceStatusQueryHookResult = ReturnType<typeof useVendorMarketplaceStatusQuery>;
export type VendorMarketplaceStatusLazyQueryHookResult = ReturnType<typeof useVendorMarketplaceStatusLazyQuery>;
export type VendorMarketplaceStatusQueryResult = Apollo.QueryResult<VendorMarketplaceStatusQuery, VendorMarketplaceStatusQueryVariables>;
export const CosellAiBusinessProblemDescriptionDocument = gql`
    query cosellAiBusinessProblemDescription($vendorId: String!, $buyerDomain: String!, $targetCloud: String!) {
  coSellAiBusinessProblemDescription(
    vendor_id: $vendorId
    buyer_domain: $buyerDomain
    target_cloud: $targetCloud
  ) {
    result
  }
}
    `;

/**
 * __useCosellAiBusinessProblemDescriptionQuery__
 *
 * To run a query within a React component, call `useCosellAiBusinessProblemDescriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useCosellAiBusinessProblemDescriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCosellAiBusinessProblemDescriptionQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *      buyerDomain: // value for 'buyerDomain'
 *      targetCloud: // value for 'targetCloud'
 *   },
 * });
 */
export function useCosellAiBusinessProblemDescriptionQuery(baseOptions: Apollo.QueryHookOptions<CosellAiBusinessProblemDescriptionQuery, CosellAiBusinessProblemDescriptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CosellAiBusinessProblemDescriptionQuery, CosellAiBusinessProblemDescriptionQueryVariables>(CosellAiBusinessProblemDescriptionDocument, options);
      }
export function useCosellAiBusinessProblemDescriptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CosellAiBusinessProblemDescriptionQuery, CosellAiBusinessProblemDescriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CosellAiBusinessProblemDescriptionQuery, CosellAiBusinessProblemDescriptionQueryVariables>(CosellAiBusinessProblemDescriptionDocument, options);
        }
export type CosellAiBusinessProblemDescriptionQueryHookResult = ReturnType<typeof useCosellAiBusinessProblemDescriptionQuery>;
export type CosellAiBusinessProblemDescriptionLazyQueryHookResult = ReturnType<typeof useCosellAiBusinessProblemDescriptionLazyQuery>;
export type CosellAiBusinessProblemDescriptionQueryResult = Apollo.QueryResult<CosellAiBusinessProblemDescriptionQuery, CosellAiBusinessProblemDescriptionQueryVariables>;
export const ProspectScoreCrmAccountDocument = gql`
    query ProspectScoreCrmAccount($vendorId: String!, $crmId: String!) {
  prospectScoreCrmAccount(vendor_id: $vendorId, crm_id: $crmId) {
    domain
    score_aws
    score_azure
    score_gcp
    visibility
    user_entered_domain
    company_name
    region
    revenue_band
    primary_industry
  }
}
    `;

/**
 * __useProspectScoreCrmAccountQuery__
 *
 * To run a query within a React component, call `useProspectScoreCrmAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useProspectScoreCrmAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProspectScoreCrmAccountQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *      crmId: // value for 'crmId'
 *   },
 * });
 */
export function useProspectScoreCrmAccountQuery(baseOptions: Apollo.QueryHookOptions<ProspectScoreCrmAccountQuery, ProspectScoreCrmAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProspectScoreCrmAccountQuery, ProspectScoreCrmAccountQueryVariables>(ProspectScoreCrmAccountDocument, options);
      }
export function useProspectScoreCrmAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProspectScoreCrmAccountQuery, ProspectScoreCrmAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProspectScoreCrmAccountQuery, ProspectScoreCrmAccountQueryVariables>(ProspectScoreCrmAccountDocument, options);
        }
export type ProspectScoreCrmAccountQueryHookResult = ReturnType<typeof useProspectScoreCrmAccountQuery>;
export type ProspectScoreCrmAccountLazyQueryHookResult = ReturnType<typeof useProspectScoreCrmAccountLazyQuery>;
export type ProspectScoreCrmAccountQueryResult = Apollo.QueryResult<ProspectScoreCrmAccountQuery, ProspectScoreCrmAccountQueryVariables>;
export const ProspectSubmitScoreOrMakeVisibleDocument = gql`
    mutation ProspectSubmitScoreOrMakeVisible($vendorId: String!, $crmId: String!, $domain: String) {
  prospectSubmitScoreOrMakeVisible(
    vendorId: $vendorId
    crmId: $crmId
    domain: $domain
  ) {
    domain
    score_aws
    score_azure
    score_gcp
    visibility
    crm_id
    user_entered_domain
    company_name
    region
    revenue_band
    primary_industry
  }
}
    `;
export type ProspectSubmitScoreOrMakeVisibleMutationFn = Apollo.MutationFunction<ProspectSubmitScoreOrMakeVisibleMutation, ProspectSubmitScoreOrMakeVisibleMutationVariables>;

/**
 * __useProspectSubmitScoreOrMakeVisibleMutation__
 *
 * To run a mutation, you first call `useProspectSubmitScoreOrMakeVisibleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProspectSubmitScoreOrMakeVisibleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [prospectSubmitScoreOrMakeVisibleMutation, { data, loading, error }] = useProspectSubmitScoreOrMakeVisibleMutation({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *      crmId: // value for 'crmId'
 *      domain: // value for 'domain'
 *   },
 * });
 */
export function useProspectSubmitScoreOrMakeVisibleMutation(baseOptions?: Apollo.MutationHookOptions<ProspectSubmitScoreOrMakeVisibleMutation, ProspectSubmitScoreOrMakeVisibleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProspectSubmitScoreOrMakeVisibleMutation, ProspectSubmitScoreOrMakeVisibleMutationVariables>(ProspectSubmitScoreOrMakeVisibleDocument, options);
      }
export type ProspectSubmitScoreOrMakeVisibleMutationHookResult = ReturnType<typeof useProspectSubmitScoreOrMakeVisibleMutation>;
export type ProspectSubmitScoreOrMakeVisibleMutationResult = Apollo.MutationResult<ProspectSubmitScoreOrMakeVisibleMutation>;
export type ProspectSubmitScoreOrMakeVisibleMutationOptions = Apollo.BaseMutationOptions<ProspectSubmitScoreOrMakeVisibleMutation, ProspectSubmitScoreOrMakeVisibleMutationVariables>;
export const ProspectEntitlementsDocument = gql`
    query ProspectEntitlements($vendorId: String!) {
  prospectEntitlements(vendor_id: $vendorId) {
    precommit
    usage
    requested
    limit_use
  }
}
    `;

/**
 * __useProspectEntitlementsQuery__
 *
 * To run a query within a React component, call `useProspectEntitlementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProspectEntitlementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProspectEntitlementsQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *   },
 * });
 */
export function useProspectEntitlementsQuery(baseOptions: Apollo.QueryHookOptions<ProspectEntitlementsQuery, ProspectEntitlementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProspectEntitlementsQuery, ProspectEntitlementsQueryVariables>(ProspectEntitlementsDocument, options);
      }
export function useProspectEntitlementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProspectEntitlementsQuery, ProspectEntitlementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProspectEntitlementsQuery, ProspectEntitlementsQueryVariables>(ProspectEntitlementsDocument, options);
        }
export type ProspectEntitlementsQueryHookResult = ReturnType<typeof useProspectEntitlementsQuery>;
export type ProspectEntitlementsLazyQueryHookResult = ReturnType<typeof useProspectEntitlementsLazyQuery>;
export type ProspectEntitlementsQueryResult = Apollo.QueryResult<ProspectEntitlementsQuery, ProspectEntitlementsQueryVariables>;
export const SalesforceConnectionDetailsDocument = gql`
    query SalesforceConnectionDetails {
  salesforceConnectionDetails {
    vendorId
    vendorName
    vendorType
    registration {
      organization {
        id
        name
        instanceName
        isSandbox
        organizationType
        namespacePrefix
      }
      user {
        userId
        organizationId
        email
        givenName
        familyName
        userType
      }
      instanceUrl
      vendorId
      tackleOrgId
      errorCode
      errorMessage
      status
      createdAt
      updatedAt
      packageVersion
    }
  }
}
    `;

/**
 * __useSalesforceConnectionDetailsQuery__
 *
 * To run a query within a React component, call `useSalesforceConnectionDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalesforceConnectionDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalesforceConnectionDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSalesforceConnectionDetailsQuery(baseOptions?: Apollo.QueryHookOptions<SalesforceConnectionDetailsQuery, SalesforceConnectionDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SalesforceConnectionDetailsQuery, SalesforceConnectionDetailsQueryVariables>(SalesforceConnectionDetailsDocument, options);
      }
export function useSalesforceConnectionDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SalesforceConnectionDetailsQuery, SalesforceConnectionDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SalesforceConnectionDetailsQuery, SalesforceConnectionDetailsQueryVariables>(SalesforceConnectionDetailsDocument, options);
        }
export type SalesforceConnectionDetailsQueryHookResult = ReturnType<typeof useSalesforceConnectionDetailsQuery>;
export type SalesforceConnectionDetailsLazyQueryHookResult = ReturnType<typeof useSalesforceConnectionDetailsLazyQuery>;
export type SalesforceConnectionDetailsQueryResult = Apollo.QueryResult<SalesforceConnectionDetailsQuery, SalesforceConnectionDetailsQueryVariables>;
export const CreateSalesforceRegistrationDocument = gql`
    mutation CreateSalesforceRegistration($authorizationCode: String!, $loginURL: String!, $namespace: String!, $packageVersion: String!, $vendorId: String!, $redirectURL: String) {
  salesforceRegistration(
    authorizationCode: $authorizationCode
    loginURL: $loginURL
    namespace: $namespace
    packageVersion: $packageVersion
    vendorId: $vendorId
    redirectURL: $redirectURL
  ) {
    organization {
      id
      name
      instanceName
      isSandbox
      organizationType
      namespacePrefix
    }
    user {
      userId
      organizationId
      email
      givenName
      familyName
      userType
    }
    instanceUrl
    vendorId
    tackleOrgId
    errorCode
    errorMessage
    status
    createdAt
    updatedAt
    orgId
    namespace
    packageVersion
  }
}
    `;
export type CreateSalesforceRegistrationMutationFn = Apollo.MutationFunction<CreateSalesforceRegistrationMutation, CreateSalesforceRegistrationMutationVariables>;

/**
 * __useCreateSalesforceRegistrationMutation__
 *
 * To run a mutation, you first call `useCreateSalesforceRegistrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSalesforceRegistrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSalesforceRegistrationMutation, { data, loading, error }] = useCreateSalesforceRegistrationMutation({
 *   variables: {
 *      authorizationCode: // value for 'authorizationCode'
 *      loginURL: // value for 'loginURL'
 *      namespace: // value for 'namespace'
 *      packageVersion: // value for 'packageVersion'
 *      vendorId: // value for 'vendorId'
 *      redirectURL: // value for 'redirectURL'
 *   },
 * });
 */
export function useCreateSalesforceRegistrationMutation(baseOptions?: Apollo.MutationHookOptions<CreateSalesforceRegistrationMutation, CreateSalesforceRegistrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSalesforceRegistrationMutation, CreateSalesforceRegistrationMutationVariables>(CreateSalesforceRegistrationDocument, options);
      }
export type CreateSalesforceRegistrationMutationHookResult = ReturnType<typeof useCreateSalesforceRegistrationMutation>;
export type CreateSalesforceRegistrationMutationResult = Apollo.MutationResult<CreateSalesforceRegistrationMutation>;
export type CreateSalesforceRegistrationMutationOptions = Apollo.BaseMutationOptions<CreateSalesforceRegistrationMutation, CreateSalesforceRegistrationMutationVariables>;
export const UsageRecordsDocument = gql`
    query UsageRecords($productId: String!, $customerId: String!) {
  usageRecords(productId: $productId, customerId: $customerId) {
    data {
      created_at
      status
      dimension {
        name
        quantity
      }
    }
  }
}
    `;

/**
 * __useUsageRecordsQuery__
 *
 * To run a query within a React component, call `useUsageRecordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsageRecordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsageRecordsQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useUsageRecordsQuery(baseOptions: Apollo.QueryHookOptions<UsageRecordsQuery, UsageRecordsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsageRecordsQuery, UsageRecordsQueryVariables>(UsageRecordsDocument, options);
      }
export function useUsageRecordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsageRecordsQuery, UsageRecordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsageRecordsQuery, UsageRecordsQueryVariables>(UsageRecordsDocument, options);
        }
export type UsageRecordsQueryHookResult = ReturnType<typeof useUsageRecordsQuery>;
export type UsageRecordsLazyQueryHookResult = ReturnType<typeof useUsageRecordsLazyQuery>;
export type UsageRecordsQueryResult = Apollo.QueryResult<UsageRecordsQuery, UsageRecordsQueryVariables>;
export const ContractsDocument = gql`
    query Contracts($vendorId: String!, $size: Int, $searchAfter: [String], $query: JSON, $sort: [JSON]) {
  contracts(
    vendorId: $vendorId
    size: $size
    searchAfter: $searchAfter
    query: $query
    sort: $sort
  ) {
    hits {
      hits {
        _source {
          id
          vendorId
          buyerId
          offerId
          productId
          contractName
          companyName
          cloudMarketplace
          offerType
          offerName
          listingName
          listingType
          pricingModel
          contractStatus
          cloudContractStatus
          partnerOwnedAgreement
          paymentSchedule {
            schedule {
              chargeAmount
              chargeDate
            }
            type
            currencyCode
          }
          startDate
          acceptedDate
          endDate
          totalContractValue {
            amount
            currencyCode
          }
          totalContractNetValue {
            amount
            currencyCode
          }
          contractDuration
          contractStart
          numberOfPayments
          numberOfPaymentsRemaining
          autoRenew
          grossDisbursed {
            amount
            currencyCode
          }
          originalCurrencyGrossDisbursed {
            amount
            currencyCode
          }
          netDisbursed {
            amount
            currencyCode
          }
          originalCurrencyNetDisbursed {
            amount
            currencyCode
          }
          productAndPricing {
            dimensions {
              dimension
              description
              api
              quantity
              value
            }
            usageDimensions {
              dimension
              description
              api
              price {
                amount
                currencyCode
              }
            }
            isListingManagedByTackle
          }
          offerTargetAccount
          tackleOfferId
          registration {
            companyName
            fullName
            email
            phone
            address {
              street
              city
              state
              postalCode
              country
            }
            registrationDate
            offerMetadata
            registrationMetadata
          }
          marketplaceFeeRate
          totalGrossUninvoicedPayment {
            amount
            currencyCode
          }
          totalNetUninvoicePayment {
            amount
            currencyCode
          }
          paymentModel
          endingSoon
          usageMapping {
            productId
            customerId
          }
          amendedAgreementId
          amendedAgreementExistsInTackle
        }
        sort
      }
      total {
        value
      }
    }
  }
}
    `;

/**
 * __useContractsQuery__
 *
 * To run a query within a React component, call `useContractsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractsQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *      size: // value for 'size'
 *      searchAfter: // value for 'searchAfter'
 *      query: // value for 'query'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useContractsQuery(baseOptions: Apollo.QueryHookOptions<ContractsQuery, ContractsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContractsQuery, ContractsQueryVariables>(ContractsDocument, options);
      }
export function useContractsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContractsQuery, ContractsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContractsQuery, ContractsQueryVariables>(ContractsDocument, options);
        }
export type ContractsQueryHookResult = ReturnType<typeof useContractsQuery>;
export type ContractsLazyQueryHookResult = ReturnType<typeof useContractsLazyQuery>;
export type ContractsQueryResult = Apollo.QueryResult<ContractsQuery, ContractsQueryVariables>;
export const ActiveContractsSummaryDocument = gql`
    query ActiveContractsSummary($vendorId: String!, $query: JSON) {
  activeContractsSummary(vendorId: $vendorId, query: $query) {
    managedByTackle {
      sum
      count
      netDisbursed
    }
    nonManagedByTackle {
      sum
      count
      netDisbursed
    }
  }
}
    `;

/**
 * __useActiveContractsSummaryQuery__
 *
 * To run a query within a React component, call `useActiveContractsSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveContractsSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveContractsSummaryQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useActiveContractsSummaryQuery(baseOptions: Apollo.QueryHookOptions<ActiveContractsSummaryQuery, ActiveContractsSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActiveContractsSummaryQuery, ActiveContractsSummaryQueryVariables>(ActiveContractsSummaryDocument, options);
      }
export function useActiveContractsSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActiveContractsSummaryQuery, ActiveContractsSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActiveContractsSummaryQuery, ActiveContractsSummaryQueryVariables>(ActiveContractsSummaryDocument, options);
        }
export type ActiveContractsSummaryQueryHookResult = ReturnType<typeof useActiveContractsSummaryQuery>;
export type ActiveContractsSummaryLazyQueryHookResult = ReturnType<typeof useActiveContractsSummaryLazyQuery>;
export type ActiveContractsSummaryQueryResult = Apollo.QueryResult<ActiveContractsSummaryQuery, ActiveContractsSummaryQueryVariables>;
export const PendingPaymentsSummaryDocument = gql`
    query PendingPaymentsSummary($vendorId: String!, $query: JSON) {
  pendingPaymentsSummary(vendorId: $vendorId, query: $query) {
    managedByTackle {
      sum
      count
    }
    nonManagedByTackle {
      sum
      count
    }
  }
}
    `;

/**
 * __usePendingPaymentsSummaryQuery__
 *
 * To run a query within a React component, call `usePendingPaymentsSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePendingPaymentsSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePendingPaymentsSummaryQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *      query: // value for 'query'
 *   },
 * });
 */
export function usePendingPaymentsSummaryQuery(baseOptions: Apollo.QueryHookOptions<PendingPaymentsSummaryQuery, PendingPaymentsSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PendingPaymentsSummaryQuery, PendingPaymentsSummaryQueryVariables>(PendingPaymentsSummaryDocument, options);
      }
export function usePendingPaymentsSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PendingPaymentsSummaryQuery, PendingPaymentsSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PendingPaymentsSummaryQuery, PendingPaymentsSummaryQueryVariables>(PendingPaymentsSummaryDocument, options);
        }
export type PendingPaymentsSummaryQueryHookResult = ReturnType<typeof usePendingPaymentsSummaryQuery>;
export type PendingPaymentsSummaryLazyQueryHookResult = ReturnType<typeof usePendingPaymentsSummaryLazyQuery>;
export type PendingPaymentsSummaryQueryResult = Apollo.QueryResult<PendingPaymentsSummaryQuery, PendingPaymentsSummaryQueryVariables>;
export const ExpiringContractsSummaryDocument = gql`
    query ExpiringContractsSummary($vendorId: String!, $query: JSON) {
  expiringContractsSummary(vendorId: $vendorId, query: $query) {
    managedByTackle {
      sum
      count
      netDisbursed
    }
    nonManagedByTackle {
      sum
      count
      netDisbursed
    }
  }
}
    `;

/**
 * __useExpiringContractsSummaryQuery__
 *
 * To run a query within a React component, call `useExpiringContractsSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpiringContractsSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpiringContractsSummaryQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useExpiringContractsSummaryQuery(baseOptions: Apollo.QueryHookOptions<ExpiringContractsSummaryQuery, ExpiringContractsSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExpiringContractsSummaryQuery, ExpiringContractsSummaryQueryVariables>(ExpiringContractsSummaryDocument, options);
      }
export function useExpiringContractsSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExpiringContractsSummaryQuery, ExpiringContractsSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExpiringContractsSummaryQuery, ExpiringContractsSummaryQueryVariables>(ExpiringContractsSummaryDocument, options);
        }
export type ExpiringContractsSummaryQueryHookResult = ReturnType<typeof useExpiringContractsSummaryQuery>;
export type ExpiringContractsSummaryLazyQueryHookResult = ReturnType<typeof useExpiringContractsSummaryLazyQuery>;
export type ExpiringContractsSummaryQueryResult = Apollo.QueryResult<ExpiringContractsSummaryQuery, ExpiringContractsSummaryQueryVariables>;
export const ContractsExportPresignedUrlDocument = gql`
    query ContractsExportPresignedUrl($vendorId: String!, $query: JSON) {
  contractsExportPresignedUrl(vendorId: $vendorId, query: $query) {
    presignedUrl
  }
}
    `;

/**
 * __useContractsExportPresignedUrlQuery__
 *
 * To run a query within a React component, call `useContractsExportPresignedUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractsExportPresignedUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractsExportPresignedUrlQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useContractsExportPresignedUrlQuery(baseOptions: Apollo.QueryHookOptions<ContractsExportPresignedUrlQuery, ContractsExportPresignedUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContractsExportPresignedUrlQuery, ContractsExportPresignedUrlQueryVariables>(ContractsExportPresignedUrlDocument, options);
      }
export function useContractsExportPresignedUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContractsExportPresignedUrlQuery, ContractsExportPresignedUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContractsExportPresignedUrlQuery, ContractsExportPresignedUrlQueryVariables>(ContractsExportPresignedUrlDocument, options);
        }
export type ContractsExportPresignedUrlQueryHookResult = ReturnType<typeof useContractsExportPresignedUrlQuery>;
export type ContractsExportPresignedUrlLazyQueryHookResult = ReturnType<typeof useContractsExportPresignedUrlLazyQuery>;
export type ContractsExportPresignedUrlQueryResult = Apollo.QueryResult<ContractsExportPresignedUrlQuery, ContractsExportPresignedUrlQueryVariables>;
export const ContractFilteringValuesDocument = gql`
    query ContractFilteringValues($vendorId: String!) {
  contractFilteringValues(vendorId: $vendorId) {
    cloudMarketplaces
    customers
    offerTypes
    products
    productTypes
    pricingModels
    managedByTackle
    status
  }
}
    `;

/**
 * __useContractFilteringValuesQuery__
 *
 * To run a query within a React component, call `useContractFilteringValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractFilteringValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractFilteringValuesQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *   },
 * });
 */
export function useContractFilteringValuesQuery(baseOptions: Apollo.QueryHookOptions<ContractFilteringValuesQuery, ContractFilteringValuesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContractFilteringValuesQuery, ContractFilteringValuesQueryVariables>(ContractFilteringValuesDocument, options);
      }
export function useContractFilteringValuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContractFilteringValuesQuery, ContractFilteringValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContractFilteringValuesQuery, ContractFilteringValuesQueryVariables>(ContractFilteringValuesDocument, options);
        }
export type ContractFilteringValuesQueryHookResult = ReturnType<typeof useContractFilteringValuesQuery>;
export type ContractFilteringValuesLazyQueryHookResult = ReturnType<typeof useContractFilteringValuesLazyQuery>;
export type ContractFilteringValuesQueryResult = Apollo.QueryResult<ContractFilteringValuesQuery, ContractFilteringValuesQueryVariables>;
export const AwsIntegrationsVendorOnboardingRequirementsDocument = gql`
    query AwsIntegrationsVendorOnboardingRequirements {
  currentUser {
    id
    vendor {
      id
      name
      external_id
    }
  }
  awsRegistrationToken
}
    `;

/**
 * __useAwsIntegrationsVendorOnboardingRequirementsQuery__
 *
 * To run a query within a React component, call `useAwsIntegrationsVendorOnboardingRequirementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAwsIntegrationsVendorOnboardingRequirementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAwsIntegrationsVendorOnboardingRequirementsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAwsIntegrationsVendorOnboardingRequirementsQuery(baseOptions?: Apollo.QueryHookOptions<AwsIntegrationsVendorOnboardingRequirementsQuery, AwsIntegrationsVendorOnboardingRequirementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AwsIntegrationsVendorOnboardingRequirementsQuery, AwsIntegrationsVendorOnboardingRequirementsQueryVariables>(AwsIntegrationsVendorOnboardingRequirementsDocument, options);
      }
export function useAwsIntegrationsVendorOnboardingRequirementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AwsIntegrationsVendorOnboardingRequirementsQuery, AwsIntegrationsVendorOnboardingRequirementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AwsIntegrationsVendorOnboardingRequirementsQuery, AwsIntegrationsVendorOnboardingRequirementsQueryVariables>(AwsIntegrationsVendorOnboardingRequirementsDocument, options);
        }
export type AwsIntegrationsVendorOnboardingRequirementsQueryHookResult = ReturnType<typeof useAwsIntegrationsVendorOnboardingRequirementsQuery>;
export type AwsIntegrationsVendorOnboardingRequirementsLazyQueryHookResult = ReturnType<typeof useAwsIntegrationsVendorOnboardingRequirementsLazyQuery>;
export type AwsIntegrationsVendorOnboardingRequirementsQueryResult = Apollo.QueryResult<AwsIntegrationsVendorOnboardingRequirementsQuery, AwsIntegrationsVendorOnboardingRequirementsQueryVariables>;
export const SfConnectionDetailsDocument = gql`
    query sfConnectionDetails {
  sfConnectionDetails {
    isConnected
    connectionCount
    connectedOrgIndices
    sandboxOrgIndices
    data {
      organizationDetails {
        id
        name
        isSandbox
        instanceName
        organizationType
      }
      userDetails {
        email
        userType
      }
      registrationOrgDetails {
        organizationId
        isSandbox
      }
      instanceUrl
      hasOrgDetails
      errorCode
    }
    hasSandbox
    hasError
    success
  }
}
    `;

/**
 * __useSfConnectionDetailsQuery__
 *
 * To run a query within a React component, call `useSfConnectionDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSfConnectionDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSfConnectionDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSfConnectionDetailsQuery(baseOptions?: Apollo.QueryHookOptions<SfConnectionDetailsQuery, SfConnectionDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SfConnectionDetailsQuery, SfConnectionDetailsQueryVariables>(SfConnectionDetailsDocument, options);
      }
export function useSfConnectionDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SfConnectionDetailsQuery, SfConnectionDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SfConnectionDetailsQuery, SfConnectionDetailsQueryVariables>(SfConnectionDetailsDocument, options);
        }
export type SfConnectionDetailsQueryHookResult = ReturnType<typeof useSfConnectionDetailsQuery>;
export type SfConnectionDetailsLazyQueryHookResult = ReturnType<typeof useSfConnectionDetailsLazyQuery>;
export type SfConnectionDetailsQueryResult = Apollo.QueryResult<SfConnectionDetailsQuery, SfConnectionDetailsQueryVariables>;
export const OrbIntegrationDocument = gql`
    query OrbIntegration {
  currentUser {
    id
    vendor {
      id
      orbVendorConfig {
        id
        orb_api_key_prefix
        orb_webhook_signing_secret_prefix
        config_by_product_id
      }
      listingsByChannel {
        id
        aws {
          id
          status
          marketplace_id
          name
          pricing {
            usage_fees {
              price
              sku
              description
            }
          }
        }
        azure {
          id
          status
          marketplace_id
          name
          pricing {
            plans {
              plan_uuid
            }
            metrics {
              sku
              display_name
              plan_pricing {
                price_per_unit
                plan_uuid
              }
            }
          }
        }
        gcp {
          id
          status
          marketplace_id
          name
          dimensions {
            display_name
            external_name
            meterable
            metric_name
            name
            plan_id
          }
          metrics_pricing {
            name
            unit
            price_per_unit {
              plan_id
              price
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useOrbIntegrationQuery__
 *
 * To run a query within a React component, call `useOrbIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrbIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrbIntegrationQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrbIntegrationQuery(baseOptions?: Apollo.QueryHookOptions<OrbIntegrationQuery, OrbIntegrationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrbIntegrationQuery, OrbIntegrationQueryVariables>(OrbIntegrationDocument, options);
      }
export function useOrbIntegrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrbIntegrationQuery, OrbIntegrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrbIntegrationQuery, OrbIntegrationQueryVariables>(OrbIntegrationDocument, options);
        }
export type OrbIntegrationQueryHookResult = ReturnType<typeof useOrbIntegrationQuery>;
export type OrbIntegrationLazyQueryHookResult = ReturnType<typeof useOrbIntegrationLazyQuery>;
export type OrbIntegrationQueryResult = Apollo.QueryResult<OrbIntegrationQuery, OrbIntegrationQueryVariables>;
export const UpdateOrbVendorConfigDocument = gql`
    mutation UpdateOrbVendorConfig($updates: OrbVendorConfigInput!) {
  updateOrbVendorConfig(updates: $updates) {
    id
    orb_api_key_prefix
    orb_webhook_signing_secret_prefix
    config_by_product_id
  }
}
    `;
export type UpdateOrbVendorConfigMutationFn = Apollo.MutationFunction<UpdateOrbVendorConfigMutation, UpdateOrbVendorConfigMutationVariables>;

/**
 * __useUpdateOrbVendorConfigMutation__
 *
 * To run a mutation, you first call `useUpdateOrbVendorConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrbVendorConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrbVendorConfigMutation, { data, loading, error }] = useUpdateOrbVendorConfigMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateOrbVendorConfigMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrbVendorConfigMutation, UpdateOrbVendorConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrbVendorConfigMutation, UpdateOrbVendorConfigMutationVariables>(UpdateOrbVendorConfigDocument, options);
      }
export type UpdateOrbVendorConfigMutationHookResult = ReturnType<typeof useUpdateOrbVendorConfigMutation>;
export type UpdateOrbVendorConfigMutationResult = Apollo.MutationResult<UpdateOrbVendorConfigMutation>;
export type UpdateOrbVendorConfigMutationOptions = Apollo.BaseMutationOptions<UpdateOrbVendorConfigMutation, UpdateOrbVendorConfigMutationVariables>;
export const ListOfListingsDocument = gql`
    query ListOfListings {
  currentUser {
    id
    role
    vendor {
      id
      vendor_type
      feature_flags {
        is_marketplace_enabled
        is_listings_enabled
      }
      configuration {
        aws {
          assume_role {
            role_arn
          }
          data_feed {
            S3_bucket
            sqs {
              url
            }
          }
        }
        azure {
          exp_date
        }
      }
      listingsByChannel {
        id
        aws {
          id
          listing_type
          name
          status
          last_modified_at
          sns_configuration {
            value
          }
          revision_of_product_id_internal
          relist_of_product_id_internal
          viewed_advanced_tab
          registration_hosting
        }
        azure {
          id
          listing_type
          name
          status
          last_modified_at
          revision_of_product_id_internal
          viewed_advanced_tab
          registration_hosting
        }
        gcp {
          id
          listing_type
          name
          status
          last_modified_at
          revision_of_product_id_internal
          viewed_advanced_tab
          registration_hosting
        }
      }
    }
  }
}
    `;

/**
 * __useListOfListingsQuery__
 *
 * To run a query within a React component, call `useListOfListingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListOfListingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListOfListingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListOfListingsQuery(baseOptions?: Apollo.QueryHookOptions<ListOfListingsQuery, ListOfListingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListOfListingsQuery, ListOfListingsQueryVariables>(ListOfListingsDocument, options);
      }
export function useListOfListingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListOfListingsQuery, ListOfListingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListOfListingsQuery, ListOfListingsQueryVariables>(ListOfListingsDocument, options);
        }
export type ListOfListingsQueryHookResult = ReturnType<typeof useListOfListingsQuery>;
export type ListOfListingsLazyQueryHookResult = ReturnType<typeof useListOfListingsLazyQuery>;
export type ListOfListingsQueryResult = Apollo.QueryResult<ListOfListingsQuery, ListOfListingsQueryVariables>;
export const ListOfListingsSplashScreenDocument = gql`
    query ListOfListingsSplashScreen($id: String!) {
  awsMarketplaceSaasProducts {
    id: EntityId
    EntityId
    LastModifiedDate
    Name
    Visibility
  }
  azureMarketplaceSaasProducts {
    id
    identity {
      externalId
    }
    status
    created_date
    type
    alias
  }
  prospectRollupStatistics(vendor_id: $id) {
    data {
      total_domains
      aws_rollup {
        count_high
        count_medium
      }
      gcp_rollup {
        count_high
        count_medium
      }
      azure_rollup {
        count_high
        count_medium
      }
    }
  }
}
    `;

/**
 * __useListOfListingsSplashScreenQuery__
 *
 * To run a query within a React component, call `useListOfListingsSplashScreenQuery` and pass it any options that fit your needs.
 * When your component renders, `useListOfListingsSplashScreenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListOfListingsSplashScreenQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useListOfListingsSplashScreenQuery(baseOptions: Apollo.QueryHookOptions<ListOfListingsSplashScreenQuery, ListOfListingsSplashScreenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListOfListingsSplashScreenQuery, ListOfListingsSplashScreenQueryVariables>(ListOfListingsSplashScreenDocument, options);
      }
export function useListOfListingsSplashScreenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListOfListingsSplashScreenQuery, ListOfListingsSplashScreenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListOfListingsSplashScreenQuery, ListOfListingsSplashScreenQueryVariables>(ListOfListingsSplashScreenDocument, options);
        }
export type ListOfListingsSplashScreenQueryHookResult = ReturnType<typeof useListOfListingsSplashScreenQuery>;
export type ListOfListingsSplashScreenLazyQueryHookResult = ReturnType<typeof useListOfListingsSplashScreenLazyQuery>;
export type ListOfListingsSplashScreenQueryResult = Apollo.QueryResult<ListOfListingsSplashScreenQuery, ListOfListingsSplashScreenQueryVariables>;
export const ListingsCreateAwsListingDocument = gql`
    mutation listingsCreateAwsListing {
  createAwsListing {
    id
  }
}
    `;
export type ListingsCreateAwsListingMutationFn = Apollo.MutationFunction<ListingsCreateAwsListingMutation, ListingsCreateAwsListingMutationVariables>;

/**
 * __useListingsCreateAwsListingMutation__
 *
 * To run a mutation, you first call `useListingsCreateAwsListingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useListingsCreateAwsListingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [listingsCreateAwsListingMutation, { data, loading, error }] = useListingsCreateAwsListingMutation({
 *   variables: {
 *   },
 * });
 */
export function useListingsCreateAwsListingMutation(baseOptions?: Apollo.MutationHookOptions<ListingsCreateAwsListingMutation, ListingsCreateAwsListingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ListingsCreateAwsListingMutation, ListingsCreateAwsListingMutationVariables>(ListingsCreateAwsListingDocument, options);
      }
export type ListingsCreateAwsListingMutationHookResult = ReturnType<typeof useListingsCreateAwsListingMutation>;
export type ListingsCreateAwsListingMutationResult = Apollo.MutationResult<ListingsCreateAwsListingMutation>;
export type ListingsCreateAwsListingMutationOptions = Apollo.BaseMutationOptions<ListingsCreateAwsListingMutation, ListingsCreateAwsListingMutationVariables>;
export const ListingsCreateAzureListingDocument = gql`
    mutation listingsCreateAzureListing {
  createAzureListing {
    id
  }
}
    `;
export type ListingsCreateAzureListingMutationFn = Apollo.MutationFunction<ListingsCreateAzureListingMutation, ListingsCreateAzureListingMutationVariables>;

/**
 * __useListingsCreateAzureListingMutation__
 *
 * To run a mutation, you first call `useListingsCreateAzureListingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useListingsCreateAzureListingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [listingsCreateAzureListingMutation, { data, loading, error }] = useListingsCreateAzureListingMutation({
 *   variables: {
 *   },
 * });
 */
export function useListingsCreateAzureListingMutation(baseOptions?: Apollo.MutationHookOptions<ListingsCreateAzureListingMutation, ListingsCreateAzureListingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ListingsCreateAzureListingMutation, ListingsCreateAzureListingMutationVariables>(ListingsCreateAzureListingDocument, options);
      }
export type ListingsCreateAzureListingMutationHookResult = ReturnType<typeof useListingsCreateAzureListingMutation>;
export type ListingsCreateAzureListingMutationResult = Apollo.MutationResult<ListingsCreateAzureListingMutation>;
export type ListingsCreateAzureListingMutationOptions = Apollo.BaseMutationOptions<ListingsCreateAzureListingMutation, ListingsCreateAzureListingMutationVariables>;
export const ListingsCreateGcpListingDocument = gql`
    mutation listingsCreateGcpListing {
  createGcpListing {
    id
  }
}
    `;
export type ListingsCreateGcpListingMutationFn = Apollo.MutationFunction<ListingsCreateGcpListingMutation, ListingsCreateGcpListingMutationVariables>;

/**
 * __useListingsCreateGcpListingMutation__
 *
 * To run a mutation, you first call `useListingsCreateGcpListingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useListingsCreateGcpListingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [listingsCreateGcpListingMutation, { data, loading, error }] = useListingsCreateGcpListingMutation({
 *   variables: {
 *   },
 * });
 */
export function useListingsCreateGcpListingMutation(baseOptions?: Apollo.MutationHookOptions<ListingsCreateGcpListingMutation, ListingsCreateGcpListingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ListingsCreateGcpListingMutation, ListingsCreateGcpListingMutationVariables>(ListingsCreateGcpListingDocument, options);
      }
export type ListingsCreateGcpListingMutationHookResult = ReturnType<typeof useListingsCreateGcpListingMutation>;
export type ListingsCreateGcpListingMutationResult = Apollo.MutationResult<ListingsCreateGcpListingMutation>;
export type ListingsCreateGcpListingMutationOptions = Apollo.BaseMutationOptions<ListingsCreateGcpListingMutation, ListingsCreateGcpListingMutationVariables>;
export const AwsAmiPricingFormSectionDocument = gql`
    query AwsAmiPricingFormSection($id: ID!) {
  awsListing(id: $id) {
    id
    status
    ami_pricing {
      pricing_setting
      pricing_template_url
    }
  }
}
    `;

/**
 * __useAwsAmiPricingFormSectionQuery__
 *
 * To run a query within a React component, call `useAwsAmiPricingFormSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAwsAmiPricingFormSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAwsAmiPricingFormSectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAwsAmiPricingFormSectionQuery(baseOptions: Apollo.QueryHookOptions<AwsAmiPricingFormSectionQuery, AwsAmiPricingFormSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AwsAmiPricingFormSectionQuery, AwsAmiPricingFormSectionQueryVariables>(AwsAmiPricingFormSectionDocument, options);
      }
export function useAwsAmiPricingFormSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AwsAmiPricingFormSectionQuery, AwsAmiPricingFormSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AwsAmiPricingFormSectionQuery, AwsAmiPricingFormSectionQueryVariables>(AwsAmiPricingFormSectionDocument, options);
        }
export type AwsAmiPricingFormSectionQueryHookResult = ReturnType<typeof useAwsAmiPricingFormSectionQuery>;
export type AwsAmiPricingFormSectionLazyQueryHookResult = ReturnType<typeof useAwsAmiPricingFormSectionLazyQuery>;
export type AwsAmiPricingFormSectionQueryResult = Apollo.QueryResult<AwsAmiPricingFormSectionQuery, AwsAmiPricingFormSectionQueryVariables>;
export const UpdateAwsAmiPricingFormSectionDocument = gql`
    mutation UpdateAwsAmiPricingFormSection($updates: AwsListingInput!) {
  updateAwsListing(updates: $updates) {
    id
    status
    ami_pricing {
      pricing_setting
      pricing_template_url
    }
  }
}
    `;
export type UpdateAwsAmiPricingFormSectionMutationFn = Apollo.MutationFunction<UpdateAwsAmiPricingFormSectionMutation, UpdateAwsAmiPricingFormSectionMutationVariables>;

/**
 * __useUpdateAwsAmiPricingFormSectionMutation__
 *
 * To run a mutation, you first call `useUpdateAwsAmiPricingFormSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAwsAmiPricingFormSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAwsAmiPricingFormSectionMutation, { data, loading, error }] = useUpdateAwsAmiPricingFormSectionMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateAwsAmiPricingFormSectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAwsAmiPricingFormSectionMutation, UpdateAwsAmiPricingFormSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAwsAmiPricingFormSectionMutation, UpdateAwsAmiPricingFormSectionMutationVariables>(UpdateAwsAmiPricingFormSectionDocument, options);
      }
export type UpdateAwsAmiPricingFormSectionMutationHookResult = ReturnType<typeof useUpdateAwsAmiPricingFormSectionMutation>;
export type UpdateAwsAmiPricingFormSectionMutationResult = Apollo.MutationResult<UpdateAwsAmiPricingFormSectionMutation>;
export type UpdateAwsAmiPricingFormSectionMutationOptions = Apollo.BaseMutationOptions<UpdateAwsAmiPricingFormSectionMutation, UpdateAwsAmiPricingFormSectionMutationVariables>;
export const AwsContractMetadataFormSectionDocument = gql`
    query AwsContractMetadataFormSection($id: ID!) {
  awsListing(id: $id) {
    id
    contract_standard_fields {
      cloud_field
      title
    }
  }
}
    `;

/**
 * __useAwsContractMetadataFormSectionQuery__
 *
 * To run a query within a React component, call `useAwsContractMetadataFormSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAwsContractMetadataFormSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAwsContractMetadataFormSectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAwsContractMetadataFormSectionQuery(baseOptions: Apollo.QueryHookOptions<AwsContractMetadataFormSectionQuery, AwsContractMetadataFormSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AwsContractMetadataFormSectionQuery, AwsContractMetadataFormSectionQueryVariables>(AwsContractMetadataFormSectionDocument, options);
      }
export function useAwsContractMetadataFormSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AwsContractMetadataFormSectionQuery, AwsContractMetadataFormSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AwsContractMetadataFormSectionQuery, AwsContractMetadataFormSectionQueryVariables>(AwsContractMetadataFormSectionDocument, options);
        }
export type AwsContractMetadataFormSectionQueryHookResult = ReturnType<typeof useAwsContractMetadataFormSectionQuery>;
export type AwsContractMetadataFormSectionLazyQueryHookResult = ReturnType<typeof useAwsContractMetadataFormSectionLazyQuery>;
export type AwsContractMetadataFormSectionQueryResult = Apollo.QueryResult<AwsContractMetadataFormSectionQuery, AwsContractMetadataFormSectionQueryVariables>;
export const UpdateAwsContractMetadataFormSectionDocument = gql`
    mutation UpdateAwsContractMetadataFormSection($updates: AwsListingInput!) {
  updateAwsListing(updates: $updates) {
    id
    contract_standard_fields {
      cloud_field
      title
    }
  }
}
    `;
export type UpdateAwsContractMetadataFormSectionMutationFn = Apollo.MutationFunction<UpdateAwsContractMetadataFormSectionMutation, UpdateAwsContractMetadataFormSectionMutationVariables>;

/**
 * __useUpdateAwsContractMetadataFormSectionMutation__
 *
 * To run a mutation, you first call `useUpdateAwsContractMetadataFormSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAwsContractMetadataFormSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAwsContractMetadataFormSectionMutation, { data, loading, error }] = useUpdateAwsContractMetadataFormSectionMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateAwsContractMetadataFormSectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAwsContractMetadataFormSectionMutation, UpdateAwsContractMetadataFormSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAwsContractMetadataFormSectionMutation, UpdateAwsContractMetadataFormSectionMutationVariables>(UpdateAwsContractMetadataFormSectionDocument, options);
      }
export type UpdateAwsContractMetadataFormSectionMutationHookResult = ReturnType<typeof useUpdateAwsContractMetadataFormSectionMutation>;
export type UpdateAwsContractMetadataFormSectionMutationResult = Apollo.MutationResult<UpdateAwsContractMetadataFormSectionMutation>;
export type UpdateAwsContractMetadataFormSectionMutationOptions = Apollo.BaseMutationOptions<UpdateAwsContractMetadataFormSectionMutation, UpdateAwsContractMetadataFormSectionMutationVariables>;
export const AwsGeneralInformationFormSectionDocument = gql`
    query AwsGeneralInformationFormSection($id: ID!) {
  awsListing(id: $id) {
    id
    status
    logo
    name
    short_description
  }
}
    `;

/**
 * __useAwsGeneralInformationFormSectionQuery__
 *
 * To run a query within a React component, call `useAwsGeneralInformationFormSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAwsGeneralInformationFormSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAwsGeneralInformationFormSectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAwsGeneralInformationFormSectionQuery(baseOptions: Apollo.QueryHookOptions<AwsGeneralInformationFormSectionQuery, AwsGeneralInformationFormSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AwsGeneralInformationFormSectionQuery, AwsGeneralInformationFormSectionQueryVariables>(AwsGeneralInformationFormSectionDocument, options);
      }
export function useAwsGeneralInformationFormSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AwsGeneralInformationFormSectionQuery, AwsGeneralInformationFormSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AwsGeneralInformationFormSectionQuery, AwsGeneralInformationFormSectionQueryVariables>(AwsGeneralInformationFormSectionDocument, options);
        }
export type AwsGeneralInformationFormSectionQueryHookResult = ReturnType<typeof useAwsGeneralInformationFormSectionQuery>;
export type AwsGeneralInformationFormSectionLazyQueryHookResult = ReturnType<typeof useAwsGeneralInformationFormSectionLazyQuery>;
export type AwsGeneralInformationFormSectionQueryResult = Apollo.QueryResult<AwsGeneralInformationFormSectionQuery, AwsGeneralInformationFormSectionQueryVariables>;
export const UpdateAwsGeneralInformationFormSectionDocument = gql`
    mutation UpdateAwsGeneralInformationFormSection($updates: AwsListingInput!) {
  updateAwsListing(updates: $updates) {
    id
    status
    logo
    name
    short_description
  }
}
    `;
export type UpdateAwsGeneralInformationFormSectionMutationFn = Apollo.MutationFunction<UpdateAwsGeneralInformationFormSectionMutation, UpdateAwsGeneralInformationFormSectionMutationVariables>;

/**
 * __useUpdateAwsGeneralInformationFormSectionMutation__
 *
 * To run a mutation, you first call `useUpdateAwsGeneralInformationFormSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAwsGeneralInformationFormSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAwsGeneralInformationFormSectionMutation, { data, loading, error }] = useUpdateAwsGeneralInformationFormSectionMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateAwsGeneralInformationFormSectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAwsGeneralInformationFormSectionMutation, UpdateAwsGeneralInformationFormSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAwsGeneralInformationFormSectionMutation, UpdateAwsGeneralInformationFormSectionMutationVariables>(UpdateAwsGeneralInformationFormSectionDocument, options);
      }
export type UpdateAwsGeneralInformationFormSectionMutationHookResult = ReturnType<typeof useUpdateAwsGeneralInformationFormSectionMutation>;
export type UpdateAwsGeneralInformationFormSectionMutationResult = Apollo.MutationResult<UpdateAwsGeneralInformationFormSectionMutation>;
export type UpdateAwsGeneralInformationFormSectionMutationOptions = Apollo.BaseMutationOptions<UpdateAwsGeneralInformationFormSectionMutation, UpdateAwsGeneralInformationFormSectionMutationVariables>;
export const AwsKeywordsAndProductCategoriesFormSectionDocument = gql`
    query AwsKeywordsAndProductCategoriesFormSection($id: ID!) {
  awsListing(id: $id) {
    id
    status
    search_keywords
    categories {
      subcategory
      category
    }
  }
}
    `;

/**
 * __useAwsKeywordsAndProductCategoriesFormSectionQuery__
 *
 * To run a query within a React component, call `useAwsKeywordsAndProductCategoriesFormSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAwsKeywordsAndProductCategoriesFormSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAwsKeywordsAndProductCategoriesFormSectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAwsKeywordsAndProductCategoriesFormSectionQuery(baseOptions: Apollo.QueryHookOptions<AwsKeywordsAndProductCategoriesFormSectionQuery, AwsKeywordsAndProductCategoriesFormSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AwsKeywordsAndProductCategoriesFormSectionQuery, AwsKeywordsAndProductCategoriesFormSectionQueryVariables>(AwsKeywordsAndProductCategoriesFormSectionDocument, options);
      }
export function useAwsKeywordsAndProductCategoriesFormSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AwsKeywordsAndProductCategoriesFormSectionQuery, AwsKeywordsAndProductCategoriesFormSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AwsKeywordsAndProductCategoriesFormSectionQuery, AwsKeywordsAndProductCategoriesFormSectionQueryVariables>(AwsKeywordsAndProductCategoriesFormSectionDocument, options);
        }
export type AwsKeywordsAndProductCategoriesFormSectionQueryHookResult = ReturnType<typeof useAwsKeywordsAndProductCategoriesFormSectionQuery>;
export type AwsKeywordsAndProductCategoriesFormSectionLazyQueryHookResult = ReturnType<typeof useAwsKeywordsAndProductCategoriesFormSectionLazyQuery>;
export type AwsKeywordsAndProductCategoriesFormSectionQueryResult = Apollo.QueryResult<AwsKeywordsAndProductCategoriesFormSectionQuery, AwsKeywordsAndProductCategoriesFormSectionQueryVariables>;
export const UpdateAwsKeywordsAndProductCategoriesFormSectionDocument = gql`
    mutation UpdateAwsKeywordsAndProductCategoriesFormSection($updates: AwsListingInput!) {
  updateAwsListing(updates: $updates) {
    id
    status
    search_keywords
    categories {
      subcategory
      category
    }
  }
}
    `;
export type UpdateAwsKeywordsAndProductCategoriesFormSectionMutationFn = Apollo.MutationFunction<UpdateAwsKeywordsAndProductCategoriesFormSectionMutation, UpdateAwsKeywordsAndProductCategoriesFormSectionMutationVariables>;

/**
 * __useUpdateAwsKeywordsAndProductCategoriesFormSectionMutation__
 *
 * To run a mutation, you first call `useUpdateAwsKeywordsAndProductCategoriesFormSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAwsKeywordsAndProductCategoriesFormSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAwsKeywordsAndProductCategoriesFormSectionMutation, { data, loading, error }] = useUpdateAwsKeywordsAndProductCategoriesFormSectionMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateAwsKeywordsAndProductCategoriesFormSectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAwsKeywordsAndProductCategoriesFormSectionMutation, UpdateAwsKeywordsAndProductCategoriesFormSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAwsKeywordsAndProductCategoriesFormSectionMutation, UpdateAwsKeywordsAndProductCategoriesFormSectionMutationVariables>(UpdateAwsKeywordsAndProductCategoriesFormSectionDocument, options);
      }
export type UpdateAwsKeywordsAndProductCategoriesFormSectionMutationHookResult = ReturnType<typeof useUpdateAwsKeywordsAndProductCategoriesFormSectionMutation>;
export type UpdateAwsKeywordsAndProductCategoriesFormSectionMutationResult = Apollo.MutationResult<UpdateAwsKeywordsAndProductCategoriesFormSectionMutation>;
export type UpdateAwsKeywordsAndProductCategoriesFormSectionMutationOptions = Apollo.BaseMutationOptions<UpdateAwsKeywordsAndProductCategoriesFormSectionMutation, UpdateAwsKeywordsAndProductCategoriesFormSectionMutationVariables>;
export const AwsLegalFormSectionDocument = gql`
    query AwsLegalFormSection($id: ID!) {
  awsListing(id: $id) {
    id
    status
    legal {
      contract_type
      contract_url
    }
  }
}
    `;

/**
 * __useAwsLegalFormSectionQuery__
 *
 * To run a query within a React component, call `useAwsLegalFormSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAwsLegalFormSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAwsLegalFormSectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAwsLegalFormSectionQuery(baseOptions: Apollo.QueryHookOptions<AwsLegalFormSectionQuery, AwsLegalFormSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AwsLegalFormSectionQuery, AwsLegalFormSectionQueryVariables>(AwsLegalFormSectionDocument, options);
      }
export function useAwsLegalFormSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AwsLegalFormSectionQuery, AwsLegalFormSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AwsLegalFormSectionQuery, AwsLegalFormSectionQueryVariables>(AwsLegalFormSectionDocument, options);
        }
export type AwsLegalFormSectionQueryHookResult = ReturnType<typeof useAwsLegalFormSectionQuery>;
export type AwsLegalFormSectionLazyQueryHookResult = ReturnType<typeof useAwsLegalFormSectionLazyQuery>;
export type AwsLegalFormSectionQueryResult = Apollo.QueryResult<AwsLegalFormSectionQuery, AwsLegalFormSectionQueryVariables>;
export const UpdateAwsLegalFormSectionDocument = gql`
    mutation UpdateAwsLegalFormSection($updates: AwsListingInput!) {
  updateAwsListing(updates: $updates) {
    id
    status
    legal {
      contract_type
      contract_url
    }
  }
}
    `;
export type UpdateAwsLegalFormSectionMutationFn = Apollo.MutationFunction<UpdateAwsLegalFormSectionMutation, UpdateAwsLegalFormSectionMutationVariables>;

/**
 * __useUpdateAwsLegalFormSectionMutation__
 *
 * To run a mutation, you first call `useUpdateAwsLegalFormSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAwsLegalFormSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAwsLegalFormSectionMutation, { data, loading, error }] = useUpdateAwsLegalFormSectionMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateAwsLegalFormSectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAwsLegalFormSectionMutation, UpdateAwsLegalFormSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAwsLegalFormSectionMutation, UpdateAwsLegalFormSectionMutationVariables>(UpdateAwsLegalFormSectionDocument, options);
      }
export type UpdateAwsLegalFormSectionMutationHookResult = ReturnType<typeof useUpdateAwsLegalFormSectionMutation>;
export type UpdateAwsLegalFormSectionMutationResult = Apollo.MutationResult<UpdateAwsLegalFormSectionMutation>;
export type UpdateAwsLegalFormSectionMutationOptions = Apollo.BaseMutationOptions<UpdateAwsLegalFormSectionMutation, UpdateAwsLegalFormSectionMutationVariables>;
export const AwsListingDocument = gql`
    query AwsListing($id: ID!) {
  awsListing(id: $id) {
    id
    name
    vendorid
    vendor {
      vendor_type
    }
    marketplace_id
    marketplace_url
    status
    listing_type
    last_imported_at
    sns_configuration {
      value
      updated_at
      last_connected_at
      error
    }
    registration_hosting
    viewed_advanced_tab
    revision_of_listing {
      name
      id
    }
  }
}
    `;

/**
 * __useAwsListingQuery__
 *
 * To run a query within a React component, call `useAwsListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useAwsListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAwsListingQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAwsListingQuery(baseOptions: Apollo.QueryHookOptions<AwsListingQuery, AwsListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AwsListingQuery, AwsListingQueryVariables>(AwsListingDocument, options);
      }
export function useAwsListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AwsListingQuery, AwsListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AwsListingQuery, AwsListingQueryVariables>(AwsListingDocument, options);
        }
export type AwsListingQueryHookResult = ReturnType<typeof useAwsListingQuery>;
export type AwsListingLazyQueryHookResult = ReturnType<typeof useAwsListingLazyQuery>;
export type AwsListingQueryResult = Apollo.QueryResult<AwsListingQuery, AwsListingQueryVariables>;
export const SubmitAwsListingForReviewDocument = gql`
    mutation submitAwsListingForReview($id: ID!) {
  submitAwsListingForReview(id: $id) {
    id
    status
  }
}
    `;
export type SubmitAwsListingForReviewMutationFn = Apollo.MutationFunction<SubmitAwsListingForReviewMutation, SubmitAwsListingForReviewMutationVariables>;

/**
 * __useSubmitAwsListingForReviewMutation__
 *
 * To run a mutation, you first call `useSubmitAwsListingForReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitAwsListingForReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitAwsListingForReviewMutation, { data, loading, error }] = useSubmitAwsListingForReviewMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSubmitAwsListingForReviewMutation(baseOptions?: Apollo.MutationHookOptions<SubmitAwsListingForReviewMutation, SubmitAwsListingForReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitAwsListingForReviewMutation, SubmitAwsListingForReviewMutationVariables>(SubmitAwsListingForReviewDocument, options);
      }
export type SubmitAwsListingForReviewMutationHookResult = ReturnType<typeof useSubmitAwsListingForReviewMutation>;
export type SubmitAwsListingForReviewMutationResult = Apollo.MutationResult<SubmitAwsListingForReviewMutation>;
export type SubmitAwsListingForReviewMutationOptions = Apollo.BaseMutationOptions<SubmitAwsListingForReviewMutation, SubmitAwsListingForReviewMutationVariables>;
export const AwsListingAdvancedDocument = gql`
    query AwsListingAdvanced($id: ID!) {
  awsListing(id: $id) {
    id
    viewed_advanced_tab
    status
  }
}
    `;

/**
 * __useAwsListingAdvancedQuery__
 *
 * To run a query within a React component, call `useAwsListingAdvancedQuery` and pass it any options that fit your needs.
 * When your component renders, `useAwsListingAdvancedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAwsListingAdvancedQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAwsListingAdvancedQuery(baseOptions: Apollo.QueryHookOptions<AwsListingAdvancedQuery, AwsListingAdvancedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AwsListingAdvancedQuery, AwsListingAdvancedQueryVariables>(AwsListingAdvancedDocument, options);
      }
export function useAwsListingAdvancedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AwsListingAdvancedQuery, AwsListingAdvancedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AwsListingAdvancedQuery, AwsListingAdvancedQueryVariables>(AwsListingAdvancedDocument, options);
        }
export type AwsListingAdvancedQueryHookResult = ReturnType<typeof useAwsListingAdvancedQuery>;
export type AwsListingAdvancedLazyQueryHookResult = ReturnType<typeof useAwsListingAdvancedLazyQuery>;
export type AwsListingAdvancedQueryResult = Apollo.QueryResult<AwsListingAdvancedQuery, AwsListingAdvancedQueryVariables>;
export const UpdateAwsListingAdvancedDocument = gql`
    mutation updateAwsListingAdvanced($updates: AwsListingInput!) {
  updateAwsListing(updates: $updates) {
    id
    viewed_advanced_tab
  }
}
    `;
export type UpdateAwsListingAdvancedMutationFn = Apollo.MutationFunction<UpdateAwsListingAdvancedMutation, UpdateAwsListingAdvancedMutationVariables>;

/**
 * __useUpdateAwsListingAdvancedMutation__
 *
 * To run a mutation, you first call `useUpdateAwsListingAdvancedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAwsListingAdvancedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAwsListingAdvancedMutation, { data, loading, error }] = useUpdateAwsListingAdvancedMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateAwsListingAdvancedMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAwsListingAdvancedMutation, UpdateAwsListingAdvancedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAwsListingAdvancedMutation, UpdateAwsListingAdvancedMutationVariables>(UpdateAwsListingAdvancedDocument, options);
      }
export type UpdateAwsListingAdvancedMutationHookResult = ReturnType<typeof useUpdateAwsListingAdvancedMutation>;
export type UpdateAwsListingAdvancedMutationResult = Apollo.MutationResult<UpdateAwsListingAdvancedMutation>;
export type UpdateAwsListingAdvancedMutationOptions = Apollo.BaseMutationOptions<UpdateAwsListingAdvancedMutation, UpdateAwsListingAdvancedMutationVariables>;
export const AwsPreviewDocument = gql`
    query AwsPreview($id: ID!) {
  awsListing(id: $id) {
    logo
    short_description
    full_description
    product_video_url
    highlights
    pricing {
      contract_durations
      product_unit
      usage_fees {
        description
        price
      }
      contract_dimensions {
        name
        description
        prices {
          monthly
          one_year
          two_year
          three_year
        }
      }
    }
    legal {
      contract_url
    }
    name
    support {
      details
      refund_policy
      support_items {
        display_name
        support_resource
      }
    }
    vendor {
      id
      name
    }
  }
}
    `;

/**
 * __useAwsPreviewQuery__
 *
 * To run a query within a React component, call `useAwsPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useAwsPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAwsPreviewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAwsPreviewQuery(baseOptions: Apollo.QueryHookOptions<AwsPreviewQuery, AwsPreviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AwsPreviewQuery, AwsPreviewQueryVariables>(AwsPreviewDocument, options);
      }
export function useAwsPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AwsPreviewQuery, AwsPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AwsPreviewQuery, AwsPreviewQueryVariables>(AwsPreviewDocument, options);
        }
export type AwsPreviewQueryHookResult = ReturnType<typeof useAwsPreviewQuery>;
export type AwsPreviewLazyQueryHookResult = ReturnType<typeof useAwsPreviewLazyQuery>;
export type AwsPreviewQueryResult = Apollo.QueryResult<AwsPreviewQuery, AwsPreviewQueryVariables>;
export const AwsListingSideBarDocument = gql`
    query AwsListingSideBar($id: ID!) {
  awsListing(id: $id) {
    status
    id
    revision_of_product_id_internal
    name
    marketplace_url
    vendorid
    marketplace_id
    listing_type
    registration_hosting
  }
}
    `;

/**
 * __useAwsListingSideBarQuery__
 *
 * To run a query within a React component, call `useAwsListingSideBarQuery` and pass it any options that fit your needs.
 * When your component renders, `useAwsListingSideBarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAwsListingSideBarQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAwsListingSideBarQuery(baseOptions: Apollo.QueryHookOptions<AwsListingSideBarQuery, AwsListingSideBarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AwsListingSideBarQuery, AwsListingSideBarQueryVariables>(AwsListingSideBarDocument, options);
      }
export function useAwsListingSideBarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AwsListingSideBarQuery, AwsListingSideBarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AwsListingSideBarQuery, AwsListingSideBarQueryVariables>(AwsListingSideBarDocument, options);
        }
export type AwsListingSideBarQueryHookResult = ReturnType<typeof useAwsListingSideBarQuery>;
export type AwsListingSideBarLazyQueryHookResult = ReturnType<typeof useAwsListingSideBarLazyQuery>;
export type AwsListingSideBarQueryResult = Apollo.QueryResult<AwsListingSideBarQuery, AwsListingSideBarQueryVariables>;
export const AwsListingSideBarCopyAwsListingDocument = gql`
    mutation AwsListingSideBarCopyAwsListing($id: ID!) {
  copyAwsListing(id: $id) {
    id
  }
}
    `;
export type AwsListingSideBarCopyAwsListingMutationFn = Apollo.MutationFunction<AwsListingSideBarCopyAwsListingMutation, AwsListingSideBarCopyAwsListingMutationVariables>;

/**
 * __useAwsListingSideBarCopyAwsListingMutation__
 *
 * To run a mutation, you first call `useAwsListingSideBarCopyAwsListingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAwsListingSideBarCopyAwsListingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [awsListingSideBarCopyAwsListingMutation, { data, loading, error }] = useAwsListingSideBarCopyAwsListingMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAwsListingSideBarCopyAwsListingMutation(baseOptions?: Apollo.MutationHookOptions<AwsListingSideBarCopyAwsListingMutation, AwsListingSideBarCopyAwsListingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AwsListingSideBarCopyAwsListingMutation, AwsListingSideBarCopyAwsListingMutationVariables>(AwsListingSideBarCopyAwsListingDocument, options);
      }
export type AwsListingSideBarCopyAwsListingMutationHookResult = ReturnType<typeof useAwsListingSideBarCopyAwsListingMutation>;
export type AwsListingSideBarCopyAwsListingMutationResult = Apollo.MutationResult<AwsListingSideBarCopyAwsListingMutation>;
export type AwsListingSideBarCopyAwsListingMutationOptions = Apollo.BaseMutationOptions<AwsListingSideBarCopyAwsListingMutation, AwsListingSideBarCopyAwsListingMutationVariables>;
export const AwsListingSideBarSubmitAwsListingDocument = gql`
    mutation AwsListingSideBarSubmitAwsListing($id: ID!) {
  submitAwsListingForReview(id: $id) {
    id
    status
  }
}
    `;
export type AwsListingSideBarSubmitAwsListingMutationFn = Apollo.MutationFunction<AwsListingSideBarSubmitAwsListingMutation, AwsListingSideBarSubmitAwsListingMutationVariables>;

/**
 * __useAwsListingSideBarSubmitAwsListingMutation__
 *
 * To run a mutation, you first call `useAwsListingSideBarSubmitAwsListingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAwsListingSideBarSubmitAwsListingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [awsListingSideBarSubmitAwsListingMutation, { data, loading, error }] = useAwsListingSideBarSubmitAwsListingMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAwsListingSideBarSubmitAwsListingMutation(baseOptions?: Apollo.MutationHookOptions<AwsListingSideBarSubmitAwsListingMutation, AwsListingSideBarSubmitAwsListingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AwsListingSideBarSubmitAwsListingMutation, AwsListingSideBarSubmitAwsListingMutationVariables>(AwsListingSideBarSubmitAwsListingDocument, options);
      }
export type AwsListingSideBarSubmitAwsListingMutationHookResult = ReturnType<typeof useAwsListingSideBarSubmitAwsListingMutation>;
export type AwsListingSideBarSubmitAwsListingMutationResult = Apollo.MutationResult<AwsListingSideBarSubmitAwsListingMutation>;
export type AwsListingSideBarSubmitAwsListingMutationOptions = Apollo.BaseMutationOptions<AwsListingSideBarSubmitAwsListingMutation, AwsListingSideBarSubmitAwsListingMutationVariables>;
export const AwsListingSideBarDeleteAwsListingDocument = gql`
    mutation AwsListingSideBarDeleteAwsListing($id: ID!) {
  deleteAwsListing(id: $id)
}
    `;
export type AwsListingSideBarDeleteAwsListingMutationFn = Apollo.MutationFunction<AwsListingSideBarDeleteAwsListingMutation, AwsListingSideBarDeleteAwsListingMutationVariables>;

/**
 * __useAwsListingSideBarDeleteAwsListingMutation__
 *
 * To run a mutation, you first call `useAwsListingSideBarDeleteAwsListingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAwsListingSideBarDeleteAwsListingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [awsListingSideBarDeleteAwsListingMutation, { data, loading, error }] = useAwsListingSideBarDeleteAwsListingMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAwsListingSideBarDeleteAwsListingMutation(baseOptions?: Apollo.MutationHookOptions<AwsListingSideBarDeleteAwsListingMutation, AwsListingSideBarDeleteAwsListingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AwsListingSideBarDeleteAwsListingMutation, AwsListingSideBarDeleteAwsListingMutationVariables>(AwsListingSideBarDeleteAwsListingDocument, options);
      }
export type AwsListingSideBarDeleteAwsListingMutationHookResult = ReturnType<typeof useAwsListingSideBarDeleteAwsListingMutation>;
export type AwsListingSideBarDeleteAwsListingMutationResult = Apollo.MutationResult<AwsListingSideBarDeleteAwsListingMutation>;
export type AwsListingSideBarDeleteAwsListingMutationOptions = Apollo.BaseMutationOptions<AwsListingSideBarDeleteAwsListingMutation, AwsListingSideBarDeleteAwsListingMutationVariables>;
export const AwsProductDemoFormSectionDocument = gql`
    query AwsProductDemoFormSection($id: ID!) {
  awsListing(id: $id) {
    id
    status
    demo {
      email
      registration
      homepage
      product_feature
    }
    last_imported_at
    revision_of_listing {
      id
    }
  }
}
    `;

/**
 * __useAwsProductDemoFormSectionQuery__
 *
 * To run a query within a React component, call `useAwsProductDemoFormSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAwsProductDemoFormSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAwsProductDemoFormSectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAwsProductDemoFormSectionQuery(baseOptions: Apollo.QueryHookOptions<AwsProductDemoFormSectionQuery, AwsProductDemoFormSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AwsProductDemoFormSectionQuery, AwsProductDemoFormSectionQueryVariables>(AwsProductDemoFormSectionDocument, options);
      }
export function useAwsProductDemoFormSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AwsProductDemoFormSectionQuery, AwsProductDemoFormSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AwsProductDemoFormSectionQuery, AwsProductDemoFormSectionQueryVariables>(AwsProductDemoFormSectionDocument, options);
        }
export type AwsProductDemoFormSectionQueryHookResult = ReturnType<typeof useAwsProductDemoFormSectionQuery>;
export type AwsProductDemoFormSectionLazyQueryHookResult = ReturnType<typeof useAwsProductDemoFormSectionLazyQuery>;
export type AwsProductDemoFormSectionQueryResult = Apollo.QueryResult<AwsProductDemoFormSectionQuery, AwsProductDemoFormSectionQueryVariables>;
export const UpdateAwsProductDemoFormSectionDocument = gql`
    mutation UpdateAwsProductDemoFormSection($updates: AwsListingInput!) {
  updateAwsListing(updates: $updates) {
    id
    demo {
      email
      registration
      homepage
      product_feature
    }
  }
}
    `;
export type UpdateAwsProductDemoFormSectionMutationFn = Apollo.MutationFunction<UpdateAwsProductDemoFormSectionMutation, UpdateAwsProductDemoFormSectionMutationVariables>;

/**
 * __useUpdateAwsProductDemoFormSectionMutation__
 *
 * To run a mutation, you first call `useUpdateAwsProductDemoFormSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAwsProductDemoFormSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAwsProductDemoFormSectionMutation, { data, loading, error }] = useUpdateAwsProductDemoFormSectionMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateAwsProductDemoFormSectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAwsProductDemoFormSectionMutation, UpdateAwsProductDemoFormSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAwsProductDemoFormSectionMutation, UpdateAwsProductDemoFormSectionMutationVariables>(UpdateAwsProductDemoFormSectionDocument, options);
      }
export type UpdateAwsProductDemoFormSectionMutationHookResult = ReturnType<typeof useUpdateAwsProductDemoFormSectionMutation>;
export type UpdateAwsProductDemoFormSectionMutationResult = Apollo.MutationResult<UpdateAwsProductDemoFormSectionMutation>;
export type UpdateAwsProductDemoFormSectionMutationOptions = Apollo.BaseMutationOptions<UpdateAwsProductDemoFormSectionMutation, UpdateAwsProductDemoFormSectionMutationVariables>;
export const AwsProductOverviewFormSectionDocument = gql`
    query AwsProductOverviewFormSection($id: ID!) {
  awsListing(id: $id) {
    id
    status
    full_description
    product_video_url
    highlights
  }
}
    `;

/**
 * __useAwsProductOverviewFormSectionQuery__
 *
 * To run a query within a React component, call `useAwsProductOverviewFormSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAwsProductOverviewFormSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAwsProductOverviewFormSectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAwsProductOverviewFormSectionQuery(baseOptions: Apollo.QueryHookOptions<AwsProductOverviewFormSectionQuery, AwsProductOverviewFormSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AwsProductOverviewFormSectionQuery, AwsProductOverviewFormSectionQueryVariables>(AwsProductOverviewFormSectionDocument, options);
      }
export function useAwsProductOverviewFormSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AwsProductOverviewFormSectionQuery, AwsProductOverviewFormSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AwsProductOverviewFormSectionQuery, AwsProductOverviewFormSectionQueryVariables>(AwsProductOverviewFormSectionDocument, options);
        }
export type AwsProductOverviewFormSectionQueryHookResult = ReturnType<typeof useAwsProductOverviewFormSectionQuery>;
export type AwsProductOverviewFormSectionLazyQueryHookResult = ReturnType<typeof useAwsProductOverviewFormSectionLazyQuery>;
export type AwsProductOverviewFormSectionQueryResult = Apollo.QueryResult<AwsProductOverviewFormSectionQuery, AwsProductOverviewFormSectionQueryVariables>;
export const UpdateAwsProductOverviewFormSectionDocument = gql`
    mutation UpdateAwsProductOverviewFormSection($updates: AwsListingInput!) {
  updateAwsListing(updates: $updates) {
    id
    status
    full_description
    product_video_url
    highlights
  }
}
    `;
export type UpdateAwsProductOverviewFormSectionMutationFn = Apollo.MutationFunction<UpdateAwsProductOverviewFormSectionMutation, UpdateAwsProductOverviewFormSectionMutationVariables>;

/**
 * __useUpdateAwsProductOverviewFormSectionMutation__
 *
 * To run a mutation, you first call `useUpdateAwsProductOverviewFormSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAwsProductOverviewFormSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAwsProductOverviewFormSectionMutation, { data, loading, error }] = useUpdateAwsProductOverviewFormSectionMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateAwsProductOverviewFormSectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAwsProductOverviewFormSectionMutation, UpdateAwsProductOverviewFormSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAwsProductOverviewFormSectionMutation, UpdateAwsProductOverviewFormSectionMutationVariables>(UpdateAwsProductOverviewFormSectionDocument, options);
      }
export type UpdateAwsProductOverviewFormSectionMutationHookResult = ReturnType<typeof useUpdateAwsProductOverviewFormSectionMutation>;
export type UpdateAwsProductOverviewFormSectionMutationResult = Apollo.MutationResult<UpdateAwsProductOverviewFormSectionMutation>;
export type UpdateAwsProductOverviewFormSectionMutationOptions = Apollo.BaseMutationOptions<UpdateAwsProductOverviewFormSectionMutation, UpdateAwsProductOverviewFormSectionMutationVariables>;
export const AwsSupportFormSectionDocument = gql`
    query AwsSupportFormSection($id: ID!) {
  awsListing(id: $id) {
    id
    status
    contact_email
    contact_support_url
    support {
      details
      refund_policy
      support_items {
        display_name
        support_resource
      }
    }
  }
}
    `;

/**
 * __useAwsSupportFormSectionQuery__
 *
 * To run a query within a React component, call `useAwsSupportFormSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAwsSupportFormSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAwsSupportFormSectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAwsSupportFormSectionQuery(baseOptions: Apollo.QueryHookOptions<AwsSupportFormSectionQuery, AwsSupportFormSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AwsSupportFormSectionQuery, AwsSupportFormSectionQueryVariables>(AwsSupportFormSectionDocument, options);
      }
export function useAwsSupportFormSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AwsSupportFormSectionQuery, AwsSupportFormSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AwsSupportFormSectionQuery, AwsSupportFormSectionQueryVariables>(AwsSupportFormSectionDocument, options);
        }
export type AwsSupportFormSectionQueryHookResult = ReturnType<typeof useAwsSupportFormSectionQuery>;
export type AwsSupportFormSectionLazyQueryHookResult = ReturnType<typeof useAwsSupportFormSectionLazyQuery>;
export type AwsSupportFormSectionQueryResult = Apollo.QueryResult<AwsSupportFormSectionQuery, AwsSupportFormSectionQueryVariables>;
export const UpdateAwsSupportFormSectionDocument = gql`
    mutation UpdateAwsSupportFormSection($updates: AwsListingInput!) {
  updateAwsListing(updates: $updates) {
    id
    status
    contact_email
    contact_support_url
    support {
      details
      refund_policy
      support_items {
        display_name
        support_resource
      }
    }
  }
}
    `;
export type UpdateAwsSupportFormSectionMutationFn = Apollo.MutationFunction<UpdateAwsSupportFormSectionMutation, UpdateAwsSupportFormSectionMutationVariables>;

/**
 * __useUpdateAwsSupportFormSectionMutation__
 *
 * To run a mutation, you first call `useUpdateAwsSupportFormSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAwsSupportFormSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAwsSupportFormSectionMutation, { data, loading, error }] = useUpdateAwsSupportFormSectionMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateAwsSupportFormSectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAwsSupportFormSectionMutation, UpdateAwsSupportFormSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAwsSupportFormSectionMutation, UpdateAwsSupportFormSectionMutationVariables>(UpdateAwsSupportFormSectionDocument, options);
      }
export type UpdateAwsSupportFormSectionMutationHookResult = ReturnType<typeof useUpdateAwsSupportFormSectionMutation>;
export type UpdateAwsSupportFormSectionMutationResult = Apollo.MutationResult<UpdateAwsSupportFormSectionMutation>;
export type UpdateAwsSupportFormSectionMutationOptions = Apollo.BaseMutationOptions<UpdateAwsSupportFormSectionMutation, UpdateAwsSupportFormSectionMutationVariables>;
export const AwsSyncWithSalesforceFormSectionDocument = gql`
    query AwsSyncWithSalesforceFormSection($id: ID!) {
  awsListing(id: $id) {
    id
    should_sync_listing_to_salesforce_app
  }
}
    `;

/**
 * __useAwsSyncWithSalesforceFormSectionQuery__
 *
 * To run a query within a React component, call `useAwsSyncWithSalesforceFormSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAwsSyncWithSalesforceFormSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAwsSyncWithSalesforceFormSectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAwsSyncWithSalesforceFormSectionQuery(baseOptions: Apollo.QueryHookOptions<AwsSyncWithSalesforceFormSectionQuery, AwsSyncWithSalesforceFormSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AwsSyncWithSalesforceFormSectionQuery, AwsSyncWithSalesforceFormSectionQueryVariables>(AwsSyncWithSalesforceFormSectionDocument, options);
      }
export function useAwsSyncWithSalesforceFormSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AwsSyncWithSalesforceFormSectionQuery, AwsSyncWithSalesforceFormSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AwsSyncWithSalesforceFormSectionQuery, AwsSyncWithSalesforceFormSectionQueryVariables>(AwsSyncWithSalesforceFormSectionDocument, options);
        }
export type AwsSyncWithSalesforceFormSectionQueryHookResult = ReturnType<typeof useAwsSyncWithSalesforceFormSectionQuery>;
export type AwsSyncWithSalesforceFormSectionLazyQueryHookResult = ReturnType<typeof useAwsSyncWithSalesforceFormSectionLazyQuery>;
export type AwsSyncWithSalesforceFormSectionQueryResult = Apollo.QueryResult<AwsSyncWithSalesforceFormSectionQuery, AwsSyncWithSalesforceFormSectionQueryVariables>;
export const UpdateAwsShouldSyncListingToSalesforceAppDocument = gql`
    mutation UpdateAwsShouldSyncListingToSalesforceApp($updates: AwsListingInput!) {
  updateAwsListing(updates: $updates) {
    id
    should_sync_listing_to_salesforce_app
  }
}
    `;
export type UpdateAwsShouldSyncListingToSalesforceAppMutationFn = Apollo.MutationFunction<UpdateAwsShouldSyncListingToSalesforceAppMutation, UpdateAwsShouldSyncListingToSalesforceAppMutationVariables>;

/**
 * __useUpdateAwsShouldSyncListingToSalesforceAppMutation__
 *
 * To run a mutation, you first call `useUpdateAwsShouldSyncListingToSalesforceAppMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAwsShouldSyncListingToSalesforceAppMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAwsShouldSyncListingToSalesforceAppMutation, { data, loading, error }] = useUpdateAwsShouldSyncListingToSalesforceAppMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateAwsShouldSyncListingToSalesforceAppMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAwsShouldSyncListingToSalesforceAppMutation, UpdateAwsShouldSyncListingToSalesforceAppMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAwsShouldSyncListingToSalesforceAppMutation, UpdateAwsShouldSyncListingToSalesforceAppMutationVariables>(UpdateAwsShouldSyncListingToSalesforceAppDocument, options);
      }
export type UpdateAwsShouldSyncListingToSalesforceAppMutationHookResult = ReturnType<typeof useUpdateAwsShouldSyncListingToSalesforceAppMutation>;
export type UpdateAwsShouldSyncListingToSalesforceAppMutationResult = Apollo.MutationResult<UpdateAwsShouldSyncListingToSalesforceAppMutation>;
export type UpdateAwsShouldSyncListingToSalesforceAppMutationOptions = Apollo.BaseMutationOptions<UpdateAwsShouldSyncListingToSalesforceAppMutation, UpdateAwsShouldSyncListingToSalesforceAppMutationVariables>;
export const AwsVersionDetailsFormSectionDocument = gql`
    query AwsVersionDetailsFormSection($id: ID!) {
  awsListing(id: $id) {
    id
    status
    version_detail {
      ami_id
      architecture
      access_role_arn
      os_type
      os_version
      os_version_title
      user_name
      scanning_port
      security_groups
      release_notes
      access_instructions
      usage_instructions
      third_party_software
    }
  }
}
    `;

/**
 * __useAwsVersionDetailsFormSectionQuery__
 *
 * To run a query within a React component, call `useAwsVersionDetailsFormSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAwsVersionDetailsFormSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAwsVersionDetailsFormSectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAwsVersionDetailsFormSectionQuery(baseOptions: Apollo.QueryHookOptions<AwsVersionDetailsFormSectionQuery, AwsVersionDetailsFormSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AwsVersionDetailsFormSectionQuery, AwsVersionDetailsFormSectionQueryVariables>(AwsVersionDetailsFormSectionDocument, options);
      }
export function useAwsVersionDetailsFormSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AwsVersionDetailsFormSectionQuery, AwsVersionDetailsFormSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AwsVersionDetailsFormSectionQuery, AwsVersionDetailsFormSectionQueryVariables>(AwsVersionDetailsFormSectionDocument, options);
        }
export type AwsVersionDetailsFormSectionQueryHookResult = ReturnType<typeof useAwsVersionDetailsFormSectionQuery>;
export type AwsVersionDetailsFormSectionLazyQueryHookResult = ReturnType<typeof useAwsVersionDetailsFormSectionLazyQuery>;
export type AwsVersionDetailsFormSectionQueryResult = Apollo.QueryResult<AwsVersionDetailsFormSectionQuery, AwsVersionDetailsFormSectionQueryVariables>;
export const UpdateAwsVersionDetailsFormSectionDocument = gql`
    mutation UpdateAwsVersionDetailsFormSection($updates: AwsListingInput!) {
  updateAwsListing(updates: $updates) {
    id
    status
    version_detail {
      ami_id
      architecture
      access_role_arn
      os_type
      os_version
      os_version_title
      user_name
      scanning_port
      security_groups
      release_notes
      access_instructions
      usage_instructions
      third_party_software
    }
  }
}
    `;
export type UpdateAwsVersionDetailsFormSectionMutationFn = Apollo.MutationFunction<UpdateAwsVersionDetailsFormSectionMutation, UpdateAwsVersionDetailsFormSectionMutationVariables>;

/**
 * __useUpdateAwsVersionDetailsFormSectionMutation__
 *
 * To run a mutation, you first call `useUpdateAwsVersionDetailsFormSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAwsVersionDetailsFormSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAwsVersionDetailsFormSectionMutation, { data, loading, error }] = useUpdateAwsVersionDetailsFormSectionMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateAwsVersionDetailsFormSectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAwsVersionDetailsFormSectionMutation, UpdateAwsVersionDetailsFormSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAwsVersionDetailsFormSectionMutation, UpdateAwsVersionDetailsFormSectionMutationVariables>(UpdateAwsVersionDetailsFormSectionDocument, options);
      }
export type UpdateAwsVersionDetailsFormSectionMutationHookResult = ReturnType<typeof useUpdateAwsVersionDetailsFormSectionMutation>;
export type UpdateAwsVersionDetailsFormSectionMutationResult = Apollo.MutationResult<UpdateAwsVersionDetailsFormSectionMutation>;
export type UpdateAwsVersionDetailsFormSectionMutationOptions = Apollo.BaseMutationOptions<UpdateAwsVersionDetailsFormSectionMutation, UpdateAwsVersionDetailsFormSectionMutationVariables>;
export const AwsOfferAvailabilityAndPricingFormSectionDocument = gql`
    query AwsOfferAvailabilityAndPricingFormSection($id: ID!) {
  awsListing(id: $id) {
    id
    vendorid
    status
    listing_type
    revision_of_product_id_internal
    dimensions {
      name
    }
    entitlement_dimension_map
    pricing {
      buyer_contract_type
      contract_dimensions {
        description
        name
        sku
        position
        prices {
          monthly
          one_year
          two_year
          three_year
        }
      }
      contract_durations
      product_unit
      usage_fees {
        description
        position
        price
        sku
      }
      markets {
        countries
        target_type
      }
    }
    revision_of_listing {
      id
      listing_type
      pricing {
        buyer_contract_type
        contract_dimensions {
          description
          name
          sku
          position
          prices {
            monthly
            one_year
            two_year
            three_year
          }
        }
        contract_durations
        product_unit
        usage_fees {
          description
          position
          price
          sku
        }
        markets {
          countries
          target_type
        }
      }
    }
  }
}
    `;

/**
 * __useAwsOfferAvailabilityAndPricingFormSectionQuery__
 *
 * To run a query within a React component, call `useAwsOfferAvailabilityAndPricingFormSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAwsOfferAvailabilityAndPricingFormSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAwsOfferAvailabilityAndPricingFormSectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAwsOfferAvailabilityAndPricingFormSectionQuery(baseOptions: Apollo.QueryHookOptions<AwsOfferAvailabilityAndPricingFormSectionQuery, AwsOfferAvailabilityAndPricingFormSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AwsOfferAvailabilityAndPricingFormSectionQuery, AwsOfferAvailabilityAndPricingFormSectionQueryVariables>(AwsOfferAvailabilityAndPricingFormSectionDocument, options);
      }
export function useAwsOfferAvailabilityAndPricingFormSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AwsOfferAvailabilityAndPricingFormSectionQuery, AwsOfferAvailabilityAndPricingFormSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AwsOfferAvailabilityAndPricingFormSectionQuery, AwsOfferAvailabilityAndPricingFormSectionQueryVariables>(AwsOfferAvailabilityAndPricingFormSectionDocument, options);
        }
export type AwsOfferAvailabilityAndPricingFormSectionQueryHookResult = ReturnType<typeof useAwsOfferAvailabilityAndPricingFormSectionQuery>;
export type AwsOfferAvailabilityAndPricingFormSectionLazyQueryHookResult = ReturnType<typeof useAwsOfferAvailabilityAndPricingFormSectionLazyQuery>;
export type AwsOfferAvailabilityAndPricingFormSectionQueryResult = Apollo.QueryResult<AwsOfferAvailabilityAndPricingFormSectionQuery, AwsOfferAvailabilityAndPricingFormSectionQueryVariables>;
export const UpdateAwsOfferAvailabilityAndPricingFormSectionDocument = gql`
    mutation UpdateAwsOfferAvailabilityAndPricingFormSection($updates: AwsListingInput!) {
  updateAwsListing(updates: $updates) {
    id
    status
    dimensions {
      name
    }
    entitlement_dimension_map
    listing_type
    pricing {
      buyer_contract_type
      contract_dimensions {
        description
        name
        sku
        position
        prices {
          monthly
          one_year
          two_year
          three_year
        }
      }
      contract_durations
      product_unit
      usage_fees {
        description
        position
        price
        sku
      }
      markets {
        countries
        target_type
      }
    }
    revision_of_product_id_internal
    relist_of_product_id_internal
    revision_of_listing {
      id
      listing_type
      pricing {
        buyer_contract_type
        contract_dimensions {
          description
          name
          sku
          position
          prices {
            monthly
            one_year
            two_year
            three_year
          }
        }
        contract_durations
        product_unit
        usage_fees {
          description
          position
          price
          sku
        }
        markets {
          countries
          target_type
        }
      }
    }
  }
}
    `;
export type UpdateAwsOfferAvailabilityAndPricingFormSectionMutationFn = Apollo.MutationFunction<UpdateAwsOfferAvailabilityAndPricingFormSectionMutation, UpdateAwsOfferAvailabilityAndPricingFormSectionMutationVariables>;

/**
 * __useUpdateAwsOfferAvailabilityAndPricingFormSectionMutation__
 *
 * To run a mutation, you first call `useUpdateAwsOfferAvailabilityAndPricingFormSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAwsOfferAvailabilityAndPricingFormSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAwsOfferAvailabilityAndPricingFormSectionMutation, { data, loading, error }] = useUpdateAwsOfferAvailabilityAndPricingFormSectionMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateAwsOfferAvailabilityAndPricingFormSectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAwsOfferAvailabilityAndPricingFormSectionMutation, UpdateAwsOfferAvailabilityAndPricingFormSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAwsOfferAvailabilityAndPricingFormSectionMutation, UpdateAwsOfferAvailabilityAndPricingFormSectionMutationVariables>(UpdateAwsOfferAvailabilityAndPricingFormSectionDocument, options);
      }
export type UpdateAwsOfferAvailabilityAndPricingFormSectionMutationHookResult = ReturnType<typeof useUpdateAwsOfferAvailabilityAndPricingFormSectionMutation>;
export type UpdateAwsOfferAvailabilityAndPricingFormSectionMutationResult = Apollo.MutationResult<UpdateAwsOfferAvailabilityAndPricingFormSectionMutation>;
export type UpdateAwsOfferAvailabilityAndPricingFormSectionMutationOptions = Apollo.BaseMutationOptions<UpdateAwsOfferAvailabilityAndPricingFormSectionMutation, UpdateAwsOfferAvailabilityAndPricingFormSectionMutationVariables>;
export const AwsRegistrationFieldsFormSectionDocument = gql`
    query AwsRegistrationFieldsFormSection($id: ID!) {
  awsListing(id: $id) {
    id
    registration_page_fields {
      data_type
      default
      display_title
      enabled
      options {
        label
        value
      }
      required
      tackle_required
      title
      validation_type
    }
  }
}
    `;

/**
 * __useAwsRegistrationFieldsFormSectionQuery__
 *
 * To run a query within a React component, call `useAwsRegistrationFieldsFormSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAwsRegistrationFieldsFormSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAwsRegistrationFieldsFormSectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAwsRegistrationFieldsFormSectionQuery(baseOptions: Apollo.QueryHookOptions<AwsRegistrationFieldsFormSectionQuery, AwsRegistrationFieldsFormSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AwsRegistrationFieldsFormSectionQuery, AwsRegistrationFieldsFormSectionQueryVariables>(AwsRegistrationFieldsFormSectionDocument, options);
      }
export function useAwsRegistrationFieldsFormSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AwsRegistrationFieldsFormSectionQuery, AwsRegistrationFieldsFormSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AwsRegistrationFieldsFormSectionQuery, AwsRegistrationFieldsFormSectionQueryVariables>(AwsRegistrationFieldsFormSectionDocument, options);
        }
export type AwsRegistrationFieldsFormSectionQueryHookResult = ReturnType<typeof useAwsRegistrationFieldsFormSectionQuery>;
export type AwsRegistrationFieldsFormSectionLazyQueryHookResult = ReturnType<typeof useAwsRegistrationFieldsFormSectionLazyQuery>;
export type AwsRegistrationFieldsFormSectionQueryResult = Apollo.QueryResult<AwsRegistrationFieldsFormSectionQuery, AwsRegistrationFieldsFormSectionQueryVariables>;
export const UpdateAwsRegistrationFieldsFormSectionDocument = gql`
    mutation UpdateAwsRegistrationFieldsFormSection($updates: AwsListingInput!) {
  updateAwsListing(updates: $updates) {
    id
    registration_page_fields {
      data_type
      default
      display_title
      enabled
      options {
        label
        value
      }
      required
      tackle_required
      title
      validation_type
    }
  }
}
    `;
export type UpdateAwsRegistrationFieldsFormSectionMutationFn = Apollo.MutationFunction<UpdateAwsRegistrationFieldsFormSectionMutation, UpdateAwsRegistrationFieldsFormSectionMutationVariables>;

/**
 * __useUpdateAwsRegistrationFieldsFormSectionMutation__
 *
 * To run a mutation, you first call `useUpdateAwsRegistrationFieldsFormSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAwsRegistrationFieldsFormSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAwsRegistrationFieldsFormSectionMutation, { data, loading, error }] = useUpdateAwsRegistrationFieldsFormSectionMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateAwsRegistrationFieldsFormSectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAwsRegistrationFieldsFormSectionMutation, UpdateAwsRegistrationFieldsFormSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAwsRegistrationFieldsFormSectionMutation, UpdateAwsRegistrationFieldsFormSectionMutationVariables>(UpdateAwsRegistrationFieldsFormSectionDocument, options);
      }
export type UpdateAwsRegistrationFieldsFormSectionMutationHookResult = ReturnType<typeof useUpdateAwsRegistrationFieldsFormSectionMutation>;
export type UpdateAwsRegistrationFieldsFormSectionMutationResult = Apollo.MutationResult<UpdateAwsRegistrationFieldsFormSectionMutation>;
export type UpdateAwsRegistrationFieldsFormSectionMutationOptions = Apollo.BaseMutationOptions<UpdateAwsRegistrationFieldsFormSectionMutation, UpdateAwsRegistrationFieldsFormSectionMutationVariables>;
export const AwsListingRegistrationDocument = gql`
    query AwsListingRegistration($id: ID!) {
  awsListing(id: $id) {
    id
    registration_hosting
  }
}
    `;

/**
 * __useAwsListingRegistrationQuery__
 *
 * To run a query within a React component, call `useAwsListingRegistrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useAwsListingRegistrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAwsListingRegistrationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAwsListingRegistrationQuery(baseOptions: Apollo.QueryHookOptions<AwsListingRegistrationQuery, AwsListingRegistrationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AwsListingRegistrationQuery, AwsListingRegistrationQueryVariables>(AwsListingRegistrationDocument, options);
      }
export function useAwsListingRegistrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AwsListingRegistrationQuery, AwsListingRegistrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AwsListingRegistrationQuery, AwsListingRegistrationQueryVariables>(AwsListingRegistrationDocument, options);
        }
export type AwsListingRegistrationQueryHookResult = ReturnType<typeof useAwsListingRegistrationQuery>;
export type AwsListingRegistrationLazyQueryHookResult = ReturnType<typeof useAwsListingRegistrationLazyQuery>;
export type AwsListingRegistrationQueryResult = Apollo.QueryResult<AwsListingRegistrationQuery, AwsListingRegistrationQueryVariables>;
export const AwsRegistrationHostingFormSectionDocument = gql`
    query AwsRegistrationHostingFormSection($id: ID!) {
  awsListing(id: $id) {
    id
    registration_hosting
    registration_redirect {
      url
      params
    }
  }
}
    `;

/**
 * __useAwsRegistrationHostingFormSectionQuery__
 *
 * To run a query within a React component, call `useAwsRegistrationHostingFormSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAwsRegistrationHostingFormSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAwsRegistrationHostingFormSectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAwsRegistrationHostingFormSectionQuery(baseOptions: Apollo.QueryHookOptions<AwsRegistrationHostingFormSectionQuery, AwsRegistrationHostingFormSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AwsRegistrationHostingFormSectionQuery, AwsRegistrationHostingFormSectionQueryVariables>(AwsRegistrationHostingFormSectionDocument, options);
      }
export function useAwsRegistrationHostingFormSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AwsRegistrationHostingFormSectionQuery, AwsRegistrationHostingFormSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AwsRegistrationHostingFormSectionQuery, AwsRegistrationHostingFormSectionQueryVariables>(AwsRegistrationHostingFormSectionDocument, options);
        }
export type AwsRegistrationHostingFormSectionQueryHookResult = ReturnType<typeof useAwsRegistrationHostingFormSectionQuery>;
export type AwsRegistrationHostingFormSectionLazyQueryHookResult = ReturnType<typeof useAwsRegistrationHostingFormSectionLazyQuery>;
export type AwsRegistrationHostingFormSectionQueryResult = Apollo.QueryResult<AwsRegistrationHostingFormSectionQuery, AwsRegistrationHostingFormSectionQueryVariables>;
export const UpdateAwsRegistrationHostingFormSectionDocument = gql`
    mutation UpdateAwsRegistrationHostingFormSection($updates: AwsListingInput!) {
  updateAwsListing(updates: $updates) {
    id
    registration_hosting
    registration_redirect {
      url
      params
    }
  }
}
    `;
export type UpdateAwsRegistrationHostingFormSectionMutationFn = Apollo.MutationFunction<UpdateAwsRegistrationHostingFormSectionMutation, UpdateAwsRegistrationHostingFormSectionMutationVariables>;

/**
 * __useUpdateAwsRegistrationHostingFormSectionMutation__
 *
 * To run a mutation, you first call `useUpdateAwsRegistrationHostingFormSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAwsRegistrationHostingFormSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAwsRegistrationHostingFormSectionMutation, { data, loading, error }] = useUpdateAwsRegistrationHostingFormSectionMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateAwsRegistrationHostingFormSectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAwsRegistrationHostingFormSectionMutation, UpdateAwsRegistrationHostingFormSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAwsRegistrationHostingFormSectionMutation, UpdateAwsRegistrationHostingFormSectionMutationVariables>(UpdateAwsRegistrationHostingFormSectionDocument, options);
      }
export type UpdateAwsRegistrationHostingFormSectionMutationHookResult = ReturnType<typeof useUpdateAwsRegistrationHostingFormSectionMutation>;
export type UpdateAwsRegistrationHostingFormSectionMutationResult = Apollo.MutationResult<UpdateAwsRegistrationHostingFormSectionMutation>;
export type UpdateAwsRegistrationHostingFormSectionMutationOptions = Apollo.BaseMutationOptions<UpdateAwsRegistrationHostingFormSectionMutation, UpdateAwsRegistrationHostingFormSectionMutationVariables>;
export const AwsRegistrationSuccessFormSectionDocument = gql`
    query AwsRegistrationSuccessFormSection($id: ID!) {
  awsListing(id: $id) {
    id
    registration {
      success {
        message
        redirect_url
      }
    }
  }
}
    `;

/**
 * __useAwsRegistrationSuccessFormSectionQuery__
 *
 * To run a query within a React component, call `useAwsRegistrationSuccessFormSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAwsRegistrationSuccessFormSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAwsRegistrationSuccessFormSectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAwsRegistrationSuccessFormSectionQuery(baseOptions: Apollo.QueryHookOptions<AwsRegistrationSuccessFormSectionQuery, AwsRegistrationSuccessFormSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AwsRegistrationSuccessFormSectionQuery, AwsRegistrationSuccessFormSectionQueryVariables>(AwsRegistrationSuccessFormSectionDocument, options);
      }
export function useAwsRegistrationSuccessFormSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AwsRegistrationSuccessFormSectionQuery, AwsRegistrationSuccessFormSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AwsRegistrationSuccessFormSectionQuery, AwsRegistrationSuccessFormSectionQueryVariables>(AwsRegistrationSuccessFormSectionDocument, options);
        }
export type AwsRegistrationSuccessFormSectionQueryHookResult = ReturnType<typeof useAwsRegistrationSuccessFormSectionQuery>;
export type AwsRegistrationSuccessFormSectionLazyQueryHookResult = ReturnType<typeof useAwsRegistrationSuccessFormSectionLazyQuery>;
export type AwsRegistrationSuccessFormSectionQueryResult = Apollo.QueryResult<AwsRegistrationSuccessFormSectionQuery, AwsRegistrationSuccessFormSectionQueryVariables>;
export const UpdateAwsRegistrationSuccessFormSectionDocument = gql`
    mutation UpdateAwsRegistrationSuccessFormSection($updates: AwsListingInput!) {
  updateAwsListing(updates: $updates) {
    id
    registration {
      success {
        message
        redirect_url
      }
    }
  }
}
    `;
export type UpdateAwsRegistrationSuccessFormSectionMutationFn = Apollo.MutationFunction<UpdateAwsRegistrationSuccessFormSectionMutation, UpdateAwsRegistrationSuccessFormSectionMutationVariables>;

/**
 * __useUpdateAwsRegistrationSuccessFormSectionMutation__
 *
 * To run a mutation, you first call `useUpdateAwsRegistrationSuccessFormSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAwsRegistrationSuccessFormSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAwsRegistrationSuccessFormSectionMutation, { data, loading, error }] = useUpdateAwsRegistrationSuccessFormSectionMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateAwsRegistrationSuccessFormSectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAwsRegistrationSuccessFormSectionMutation, UpdateAwsRegistrationSuccessFormSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAwsRegistrationSuccessFormSectionMutation, UpdateAwsRegistrationSuccessFormSectionMutationVariables>(UpdateAwsRegistrationSuccessFormSectionDocument, options);
      }
export type UpdateAwsRegistrationSuccessFormSectionMutationHookResult = ReturnType<typeof useUpdateAwsRegistrationSuccessFormSectionMutation>;
export type UpdateAwsRegistrationSuccessFormSectionMutationResult = Apollo.MutationResult<UpdateAwsRegistrationSuccessFormSectionMutation>;
export type UpdateAwsRegistrationSuccessFormSectionMutationOptions = Apollo.BaseMutationOptions<UpdateAwsRegistrationSuccessFormSectionMutation, UpdateAwsRegistrationSuccessFormSectionMutationVariables>;
export const AwsRegistrationThemeFormSectionDocument = gql`
    query AwsRegistrationThemeFormSection($id: ID!) {
  awsListing(id: $id) {
    id
    registration {
      form {
        button {
          background_color
          color
        }
        logo_url
      }
      hero {
        background_color
        background_image_url
      }
    }
  }
}
    `;

/**
 * __useAwsRegistrationThemeFormSectionQuery__
 *
 * To run a query within a React component, call `useAwsRegistrationThemeFormSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAwsRegistrationThemeFormSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAwsRegistrationThemeFormSectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAwsRegistrationThemeFormSectionQuery(baseOptions: Apollo.QueryHookOptions<AwsRegistrationThemeFormSectionQuery, AwsRegistrationThemeFormSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AwsRegistrationThemeFormSectionQuery, AwsRegistrationThemeFormSectionQueryVariables>(AwsRegistrationThemeFormSectionDocument, options);
      }
export function useAwsRegistrationThemeFormSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AwsRegistrationThemeFormSectionQuery, AwsRegistrationThemeFormSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AwsRegistrationThemeFormSectionQuery, AwsRegistrationThemeFormSectionQueryVariables>(AwsRegistrationThemeFormSectionDocument, options);
        }
export type AwsRegistrationThemeFormSectionQueryHookResult = ReturnType<typeof useAwsRegistrationThemeFormSectionQuery>;
export type AwsRegistrationThemeFormSectionLazyQueryHookResult = ReturnType<typeof useAwsRegistrationThemeFormSectionLazyQuery>;
export type AwsRegistrationThemeFormSectionQueryResult = Apollo.QueryResult<AwsRegistrationThemeFormSectionQuery, AwsRegistrationThemeFormSectionQueryVariables>;
export const UpdateAwsRegistrationThemeFormSectionDocument = gql`
    mutation UpdateAwsRegistrationThemeFormSection($updates: AwsListingInput!) {
  updateAwsListing(updates: $updates) {
    id
    registration {
      form {
        button {
          background_color
          color
        }
        logo_url
      }
      hero {
        background_color
        background_image_url
      }
    }
  }
}
    `;
export type UpdateAwsRegistrationThemeFormSectionMutationFn = Apollo.MutationFunction<UpdateAwsRegistrationThemeFormSectionMutation, UpdateAwsRegistrationThemeFormSectionMutationVariables>;

/**
 * __useUpdateAwsRegistrationThemeFormSectionMutation__
 *
 * To run a mutation, you first call `useUpdateAwsRegistrationThemeFormSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAwsRegistrationThemeFormSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAwsRegistrationThemeFormSectionMutation, { data, loading, error }] = useUpdateAwsRegistrationThemeFormSectionMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateAwsRegistrationThemeFormSectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAwsRegistrationThemeFormSectionMutation, UpdateAwsRegistrationThemeFormSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAwsRegistrationThemeFormSectionMutation, UpdateAwsRegistrationThemeFormSectionMutationVariables>(UpdateAwsRegistrationThemeFormSectionDocument, options);
      }
export type UpdateAwsRegistrationThemeFormSectionMutationHookResult = ReturnType<typeof useUpdateAwsRegistrationThemeFormSectionMutation>;
export type UpdateAwsRegistrationThemeFormSectionMutationResult = Apollo.MutationResult<UpdateAwsRegistrationThemeFormSectionMutation>;
export type UpdateAwsRegistrationThemeFormSectionMutationOptions = Apollo.BaseMutationOptions<UpdateAwsRegistrationThemeFormSectionMutation, UpdateAwsRegistrationThemeFormSectionMutationVariables>;
export const AzureContractMetadataFormSectionDocument = gql`
    query AzureContractMetadataFormSection($id: ID!) {
  azureListing(id: $id) {
    id
    contract_standard_fields {
      cloud_field
      title
    }
  }
}
    `;

/**
 * __useAzureContractMetadataFormSectionQuery__
 *
 * To run a query within a React component, call `useAzureContractMetadataFormSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAzureContractMetadataFormSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAzureContractMetadataFormSectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAzureContractMetadataFormSectionQuery(baseOptions: Apollo.QueryHookOptions<AzureContractMetadataFormSectionQuery, AzureContractMetadataFormSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AzureContractMetadataFormSectionQuery, AzureContractMetadataFormSectionQueryVariables>(AzureContractMetadataFormSectionDocument, options);
      }
export function useAzureContractMetadataFormSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AzureContractMetadataFormSectionQuery, AzureContractMetadataFormSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AzureContractMetadataFormSectionQuery, AzureContractMetadataFormSectionQueryVariables>(AzureContractMetadataFormSectionDocument, options);
        }
export type AzureContractMetadataFormSectionQueryHookResult = ReturnType<typeof useAzureContractMetadataFormSectionQuery>;
export type AzureContractMetadataFormSectionLazyQueryHookResult = ReturnType<typeof useAzureContractMetadataFormSectionLazyQuery>;
export type AzureContractMetadataFormSectionQueryResult = Apollo.QueryResult<AzureContractMetadataFormSectionQuery, AzureContractMetadataFormSectionQueryVariables>;
export const UpdateAzureContractMetadataFormSectionDocument = gql`
    mutation UpdateAzureContractMetadataFormSection($updates: AzureListingInput!) {
  updateAzureListing(updates: $updates) {
    id
    contract_standard_fields {
      cloud_field
      title
    }
  }
}
    `;
export type UpdateAzureContractMetadataFormSectionMutationFn = Apollo.MutationFunction<UpdateAzureContractMetadataFormSectionMutation, UpdateAzureContractMetadataFormSectionMutationVariables>;

/**
 * __useUpdateAzureContractMetadataFormSectionMutation__
 *
 * To run a mutation, you first call `useUpdateAzureContractMetadataFormSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAzureContractMetadataFormSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAzureContractMetadataFormSectionMutation, { data, loading, error }] = useUpdateAzureContractMetadataFormSectionMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateAzureContractMetadataFormSectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAzureContractMetadataFormSectionMutation, UpdateAzureContractMetadataFormSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAzureContractMetadataFormSectionMutation, UpdateAzureContractMetadataFormSectionMutationVariables>(UpdateAzureContractMetadataFormSectionDocument, options);
      }
export type UpdateAzureContractMetadataFormSectionMutationHookResult = ReturnType<typeof useUpdateAzureContractMetadataFormSectionMutation>;
export type UpdateAzureContractMetadataFormSectionMutationResult = Apollo.MutationResult<UpdateAzureContractMetadataFormSectionMutation>;
export type UpdateAzureContractMetadataFormSectionMutationOptions = Apollo.BaseMutationOptions<UpdateAzureContractMetadataFormSectionMutation, UpdateAzureContractMetadataFormSectionMutationVariables>;
export const AzureGeneralInformationFormSectionDocument = gql`
    query AzureGeneralInformationFormSection($id: ID!) {
  azureListing(id: $id) {
    id
    status
    logo
    name
    short_description
  }
}
    `;

/**
 * __useAzureGeneralInformationFormSectionQuery__
 *
 * To run a query within a React component, call `useAzureGeneralInformationFormSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAzureGeneralInformationFormSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAzureGeneralInformationFormSectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAzureGeneralInformationFormSectionQuery(baseOptions: Apollo.QueryHookOptions<AzureGeneralInformationFormSectionQuery, AzureGeneralInformationFormSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AzureGeneralInformationFormSectionQuery, AzureGeneralInformationFormSectionQueryVariables>(AzureGeneralInformationFormSectionDocument, options);
      }
export function useAzureGeneralInformationFormSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AzureGeneralInformationFormSectionQuery, AzureGeneralInformationFormSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AzureGeneralInformationFormSectionQuery, AzureGeneralInformationFormSectionQueryVariables>(AzureGeneralInformationFormSectionDocument, options);
        }
export type AzureGeneralInformationFormSectionQueryHookResult = ReturnType<typeof useAzureGeneralInformationFormSectionQuery>;
export type AzureGeneralInformationFormSectionLazyQueryHookResult = ReturnType<typeof useAzureGeneralInformationFormSectionLazyQuery>;
export type AzureGeneralInformationFormSectionQueryResult = Apollo.QueryResult<AzureGeneralInformationFormSectionQuery, AzureGeneralInformationFormSectionQueryVariables>;
export const UpdateAzureGeneralInformationFormSectionDocument = gql`
    mutation UpdateAzureGeneralInformationFormSection($updates: AzureListingInput!) {
  updateAzureListing(updates: $updates) {
    id
    status
    logo
    name
    short_description
  }
}
    `;
export type UpdateAzureGeneralInformationFormSectionMutationFn = Apollo.MutationFunction<UpdateAzureGeneralInformationFormSectionMutation, UpdateAzureGeneralInformationFormSectionMutationVariables>;

/**
 * __useUpdateAzureGeneralInformationFormSectionMutation__
 *
 * To run a mutation, you first call `useUpdateAzureGeneralInformationFormSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAzureGeneralInformationFormSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAzureGeneralInformationFormSectionMutation, { data, loading, error }] = useUpdateAzureGeneralInformationFormSectionMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateAzureGeneralInformationFormSectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAzureGeneralInformationFormSectionMutation, UpdateAzureGeneralInformationFormSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAzureGeneralInformationFormSectionMutation, UpdateAzureGeneralInformationFormSectionMutationVariables>(UpdateAzureGeneralInformationFormSectionDocument, options);
      }
export type UpdateAzureGeneralInformationFormSectionMutationHookResult = ReturnType<typeof useUpdateAzureGeneralInformationFormSectionMutation>;
export type UpdateAzureGeneralInformationFormSectionMutationResult = Apollo.MutationResult<UpdateAzureGeneralInformationFormSectionMutation>;
export type UpdateAzureGeneralInformationFormSectionMutationOptions = Apollo.BaseMutationOptions<UpdateAzureGeneralInformationFormSectionMutation, UpdateAzureGeneralInformationFormSectionMutationVariables>;
export const AzureLegalFormSectionDocument = gql`
    query AzureLegalFormSection($id: ID!) {
  azureListing(id: $id) {
    id
    status
    privacy_policy_link
    license {
      contract_terms
      contract_type
      eula_url
    }
  }
}
    `;

/**
 * __useAzureLegalFormSectionQuery__
 *
 * To run a query within a React component, call `useAzureLegalFormSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAzureLegalFormSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAzureLegalFormSectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAzureLegalFormSectionQuery(baseOptions: Apollo.QueryHookOptions<AzureLegalFormSectionQuery, AzureLegalFormSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AzureLegalFormSectionQuery, AzureLegalFormSectionQueryVariables>(AzureLegalFormSectionDocument, options);
      }
export function useAzureLegalFormSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AzureLegalFormSectionQuery, AzureLegalFormSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AzureLegalFormSectionQuery, AzureLegalFormSectionQueryVariables>(AzureLegalFormSectionDocument, options);
        }
export type AzureLegalFormSectionQueryHookResult = ReturnType<typeof useAzureLegalFormSectionQuery>;
export type AzureLegalFormSectionLazyQueryHookResult = ReturnType<typeof useAzureLegalFormSectionLazyQuery>;
export type AzureLegalFormSectionQueryResult = Apollo.QueryResult<AzureLegalFormSectionQuery, AzureLegalFormSectionQueryVariables>;
export const UpdateAzureLegalFormSectionDocument = gql`
    mutation UpdateAzureLegalFormSection($updates: AzureListingInput!) {
  updateAzureListing(updates: $updates) {
    id
    status
    privacy_policy_link
    license {
      contract_terms
      contract_type
      eula_url
    }
  }
}
    `;
export type UpdateAzureLegalFormSectionMutationFn = Apollo.MutationFunction<UpdateAzureLegalFormSectionMutation, UpdateAzureLegalFormSectionMutationVariables>;

/**
 * __useUpdateAzureLegalFormSectionMutation__
 *
 * To run a mutation, you first call `useUpdateAzureLegalFormSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAzureLegalFormSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAzureLegalFormSectionMutation, { data, loading, error }] = useUpdateAzureLegalFormSectionMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateAzureLegalFormSectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAzureLegalFormSectionMutation, UpdateAzureLegalFormSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAzureLegalFormSectionMutation, UpdateAzureLegalFormSectionMutationVariables>(UpdateAzureLegalFormSectionDocument, options);
      }
export type UpdateAzureLegalFormSectionMutationHookResult = ReturnType<typeof useUpdateAzureLegalFormSectionMutation>;
export type UpdateAzureLegalFormSectionMutationResult = Apollo.MutationResult<UpdateAzureLegalFormSectionMutation>;
export type UpdateAzureLegalFormSectionMutationOptions = Apollo.BaseMutationOptions<UpdateAzureLegalFormSectionMutation, UpdateAzureLegalFormSectionMutationVariables>;
export const AzureListingDocument = gql`
    query AzureListing($id: ID!) {
  azureListing(id: $id) {
    id
    name
    vendorid
    marketplace_id
    marketplace_url
    status
    viewed_advanced_tab
    registration_hosting
    revision_of_listing {
      id
      name
    }
  }
}
    `;

/**
 * __useAzureListingQuery__
 *
 * To run a query within a React component, call `useAzureListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useAzureListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAzureListingQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAzureListingQuery(baseOptions: Apollo.QueryHookOptions<AzureListingQuery, AzureListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AzureListingQuery, AzureListingQueryVariables>(AzureListingDocument, options);
      }
export function useAzureListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AzureListingQuery, AzureListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AzureListingQuery, AzureListingQueryVariables>(AzureListingDocument, options);
        }
export type AzureListingQueryHookResult = ReturnType<typeof useAzureListingQuery>;
export type AzureListingLazyQueryHookResult = ReturnType<typeof useAzureListingLazyQuery>;
export type AzureListingQueryResult = Apollo.QueryResult<AzureListingQuery, AzureListingQueryVariables>;
export const SubmitAzureListingForReviewDocument = gql`
    mutation submitAzureListingForReview($id: ID!) {
  submitAzureListingForReview(id: $id) {
    id
    status
  }
}
    `;
export type SubmitAzureListingForReviewMutationFn = Apollo.MutationFunction<SubmitAzureListingForReviewMutation, SubmitAzureListingForReviewMutationVariables>;

/**
 * __useSubmitAzureListingForReviewMutation__
 *
 * To run a mutation, you first call `useSubmitAzureListingForReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitAzureListingForReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitAzureListingForReviewMutation, { data, loading, error }] = useSubmitAzureListingForReviewMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSubmitAzureListingForReviewMutation(baseOptions?: Apollo.MutationHookOptions<SubmitAzureListingForReviewMutation, SubmitAzureListingForReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitAzureListingForReviewMutation, SubmitAzureListingForReviewMutationVariables>(SubmitAzureListingForReviewDocument, options);
      }
export type SubmitAzureListingForReviewMutationHookResult = ReturnType<typeof useSubmitAzureListingForReviewMutation>;
export type SubmitAzureListingForReviewMutationResult = Apollo.MutationResult<SubmitAzureListingForReviewMutation>;
export type SubmitAzureListingForReviewMutationOptions = Apollo.BaseMutationOptions<SubmitAzureListingForReviewMutation, SubmitAzureListingForReviewMutationVariables>;
export const AzureListingAdvancedDocument = gql`
    query AzureListingAdvanced($id: ID!) {
  azureListing(id: $id) {
    id
    viewed_advanced_tab
    status
  }
}
    `;

/**
 * __useAzureListingAdvancedQuery__
 *
 * To run a query within a React component, call `useAzureListingAdvancedQuery` and pass it any options that fit your needs.
 * When your component renders, `useAzureListingAdvancedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAzureListingAdvancedQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAzureListingAdvancedQuery(baseOptions: Apollo.QueryHookOptions<AzureListingAdvancedQuery, AzureListingAdvancedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AzureListingAdvancedQuery, AzureListingAdvancedQueryVariables>(AzureListingAdvancedDocument, options);
      }
export function useAzureListingAdvancedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AzureListingAdvancedQuery, AzureListingAdvancedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AzureListingAdvancedQuery, AzureListingAdvancedQueryVariables>(AzureListingAdvancedDocument, options);
        }
export type AzureListingAdvancedQueryHookResult = ReturnType<typeof useAzureListingAdvancedQuery>;
export type AzureListingAdvancedLazyQueryHookResult = ReturnType<typeof useAzureListingAdvancedLazyQuery>;
export type AzureListingAdvancedQueryResult = Apollo.QueryResult<AzureListingAdvancedQuery, AzureListingAdvancedQueryVariables>;
export const UpdateAzureListingAdvancedDocument = gql`
    mutation updateAzureListingAdvanced($updates: AzureListingInput!) {
  updateAzureListing(updates: $updates) {
    id
    viewed_advanced_tab
  }
}
    `;
export type UpdateAzureListingAdvancedMutationFn = Apollo.MutationFunction<UpdateAzureListingAdvancedMutation, UpdateAzureListingAdvancedMutationVariables>;

/**
 * __useUpdateAzureListingAdvancedMutation__
 *
 * To run a mutation, you first call `useUpdateAzureListingAdvancedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAzureListingAdvancedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAzureListingAdvancedMutation, { data, loading, error }] = useUpdateAzureListingAdvancedMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateAzureListingAdvancedMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAzureListingAdvancedMutation, UpdateAzureListingAdvancedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAzureListingAdvancedMutation, UpdateAzureListingAdvancedMutationVariables>(UpdateAzureListingAdvancedDocument, options);
      }
export type UpdateAzureListingAdvancedMutationHookResult = ReturnType<typeof useUpdateAzureListingAdvancedMutation>;
export type UpdateAzureListingAdvancedMutationResult = Apollo.MutationResult<UpdateAzureListingAdvancedMutation>;
export type UpdateAzureListingAdvancedMutationOptions = Apollo.BaseMutationOptions<UpdateAzureListingAdvancedMutation, UpdateAzureListingAdvancedMutationVariables>;
export const AzurePreviewDocument = gql`
    query AzurePreview($id: ID!) {
  azureListing(id: $id) {
    full_description
    overview_urls {
      url
      title
    }
    media_image {
      caption
      image_url
    }
    media_video {
      thumbnail
      title
    }
    name
    logo
    categories {
      category
    }
    short_description
    support {
      support_url
      support_documents {
        name
        document_url
      }
    }
    privacy_policy_link
    pricing {
      pricing_type
      plans {
        visibility {
          public
        }
        billing_terms {
          payment_option {
            type
            value
          }
          price_per_payment_in_usd
          type
          value
        }
        description
        name
        plan_id
        plan_uuid
        user_limits {
          min
          max
        }
      }
      metrics {
        display_name
        product_unit
        sku
        plan_pricing {
          base_quantity {
            quantity
            type
            value
          }
          plan_uuid
          price_per_unit
        }
      }
    }
    vendor {
      id
      name
    }
  }
}
    `;

/**
 * __useAzurePreviewQuery__
 *
 * To run a query within a React component, call `useAzurePreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useAzurePreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAzurePreviewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAzurePreviewQuery(baseOptions: Apollo.QueryHookOptions<AzurePreviewQuery, AzurePreviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AzurePreviewQuery, AzurePreviewQueryVariables>(AzurePreviewDocument, options);
      }
export function useAzurePreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AzurePreviewQuery, AzurePreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AzurePreviewQuery, AzurePreviewQueryVariables>(AzurePreviewDocument, options);
        }
export type AzurePreviewQueryHookResult = ReturnType<typeof useAzurePreviewQuery>;
export type AzurePreviewLazyQueryHookResult = ReturnType<typeof useAzurePreviewLazyQuery>;
export type AzurePreviewQueryResult = Apollo.QueryResult<AzurePreviewQuery, AzurePreviewQueryVariables>;
export const AzureListingSideBarDocument = gql`
    query AzureListingSideBar($id: ID!) {
  azureListing(id: $id) {
    status
    id
    revision_of_product_id_internal
    name
    marketplace_url
    vendorid
    marketplace_id
    listing_type
    registration_hosting
  }
}
    `;

/**
 * __useAzureListingSideBarQuery__
 *
 * To run a query within a React component, call `useAzureListingSideBarQuery` and pass it any options that fit your needs.
 * When your component renders, `useAzureListingSideBarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAzureListingSideBarQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAzureListingSideBarQuery(baseOptions: Apollo.QueryHookOptions<AzureListingSideBarQuery, AzureListingSideBarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AzureListingSideBarQuery, AzureListingSideBarQueryVariables>(AzureListingSideBarDocument, options);
      }
export function useAzureListingSideBarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AzureListingSideBarQuery, AzureListingSideBarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AzureListingSideBarQuery, AzureListingSideBarQueryVariables>(AzureListingSideBarDocument, options);
        }
export type AzureListingSideBarQueryHookResult = ReturnType<typeof useAzureListingSideBarQuery>;
export type AzureListingSideBarLazyQueryHookResult = ReturnType<typeof useAzureListingSideBarLazyQuery>;
export type AzureListingSideBarQueryResult = Apollo.QueryResult<AzureListingSideBarQuery, AzureListingSideBarQueryVariables>;
export const AzureListingSideBarCopyAzureListingDocument = gql`
    mutation AzureListingSideBarCopyAzureListing($id: ID!) {
  copyAzureListing(id: $id) {
    id
  }
}
    `;
export type AzureListingSideBarCopyAzureListingMutationFn = Apollo.MutationFunction<AzureListingSideBarCopyAzureListingMutation, AzureListingSideBarCopyAzureListingMutationVariables>;

/**
 * __useAzureListingSideBarCopyAzureListingMutation__
 *
 * To run a mutation, you first call `useAzureListingSideBarCopyAzureListingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAzureListingSideBarCopyAzureListingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [azureListingSideBarCopyAzureListingMutation, { data, loading, error }] = useAzureListingSideBarCopyAzureListingMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAzureListingSideBarCopyAzureListingMutation(baseOptions?: Apollo.MutationHookOptions<AzureListingSideBarCopyAzureListingMutation, AzureListingSideBarCopyAzureListingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AzureListingSideBarCopyAzureListingMutation, AzureListingSideBarCopyAzureListingMutationVariables>(AzureListingSideBarCopyAzureListingDocument, options);
      }
export type AzureListingSideBarCopyAzureListingMutationHookResult = ReturnType<typeof useAzureListingSideBarCopyAzureListingMutation>;
export type AzureListingSideBarCopyAzureListingMutationResult = Apollo.MutationResult<AzureListingSideBarCopyAzureListingMutation>;
export type AzureListingSideBarCopyAzureListingMutationOptions = Apollo.BaseMutationOptions<AzureListingSideBarCopyAzureListingMutation, AzureListingSideBarCopyAzureListingMutationVariables>;
export const AzureListingSideBarSubmitAzureListingDocument = gql`
    mutation AzureListingSideBarSubmitAzureListing($id: ID!) {
  submitAzureListingForReview(id: $id) {
    id
    status
  }
}
    `;
export type AzureListingSideBarSubmitAzureListingMutationFn = Apollo.MutationFunction<AzureListingSideBarSubmitAzureListingMutation, AzureListingSideBarSubmitAzureListingMutationVariables>;

/**
 * __useAzureListingSideBarSubmitAzureListingMutation__
 *
 * To run a mutation, you first call `useAzureListingSideBarSubmitAzureListingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAzureListingSideBarSubmitAzureListingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [azureListingSideBarSubmitAzureListingMutation, { data, loading, error }] = useAzureListingSideBarSubmitAzureListingMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAzureListingSideBarSubmitAzureListingMutation(baseOptions?: Apollo.MutationHookOptions<AzureListingSideBarSubmitAzureListingMutation, AzureListingSideBarSubmitAzureListingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AzureListingSideBarSubmitAzureListingMutation, AzureListingSideBarSubmitAzureListingMutationVariables>(AzureListingSideBarSubmitAzureListingDocument, options);
      }
export type AzureListingSideBarSubmitAzureListingMutationHookResult = ReturnType<typeof useAzureListingSideBarSubmitAzureListingMutation>;
export type AzureListingSideBarSubmitAzureListingMutationResult = Apollo.MutationResult<AzureListingSideBarSubmitAzureListingMutation>;
export type AzureListingSideBarSubmitAzureListingMutationOptions = Apollo.BaseMutationOptions<AzureListingSideBarSubmitAzureListingMutation, AzureListingSideBarSubmitAzureListingMutationVariables>;
export const AzureListingSideBarDeleteAzureListingDocument = gql`
    mutation AzureListingSideBarDeleteAzureListing($id: ID!) {
  deleteAzureListing(id: $id)
}
    `;
export type AzureListingSideBarDeleteAzureListingMutationFn = Apollo.MutationFunction<AzureListingSideBarDeleteAzureListingMutation, AzureListingSideBarDeleteAzureListingMutationVariables>;

/**
 * __useAzureListingSideBarDeleteAzureListingMutation__
 *
 * To run a mutation, you first call `useAzureListingSideBarDeleteAzureListingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAzureListingSideBarDeleteAzureListingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [azureListingSideBarDeleteAzureListingMutation, { data, loading, error }] = useAzureListingSideBarDeleteAzureListingMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAzureListingSideBarDeleteAzureListingMutation(baseOptions?: Apollo.MutationHookOptions<AzureListingSideBarDeleteAzureListingMutation, AzureListingSideBarDeleteAzureListingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AzureListingSideBarDeleteAzureListingMutation, AzureListingSideBarDeleteAzureListingMutationVariables>(AzureListingSideBarDeleteAzureListingDocument, options);
      }
export type AzureListingSideBarDeleteAzureListingMutationHookResult = ReturnType<typeof useAzureListingSideBarDeleteAzureListingMutation>;
export type AzureListingSideBarDeleteAzureListingMutationResult = Apollo.MutationResult<AzureListingSideBarDeleteAzureListingMutation>;
export type AzureListingSideBarDeleteAzureListingMutationOptions = Apollo.BaseMutationOptions<AzureListingSideBarDeleteAzureListingMutation, AzureListingSideBarDeleteAzureListingMutationVariables>;
export const AzureMediaFormSectionDocument = gql`
    query AzureMediaFormSection($id: ID!) {
  azureListing(id: $id) {
    id
    status
    media_image {
      caption
      image_url
    }
    media_video {
      title
      thumbnail
      video_url
    }
  }
}
    `;

/**
 * __useAzureMediaFormSectionQuery__
 *
 * To run a query within a React component, call `useAzureMediaFormSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAzureMediaFormSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAzureMediaFormSectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAzureMediaFormSectionQuery(baseOptions: Apollo.QueryHookOptions<AzureMediaFormSectionQuery, AzureMediaFormSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AzureMediaFormSectionQuery, AzureMediaFormSectionQueryVariables>(AzureMediaFormSectionDocument, options);
      }
export function useAzureMediaFormSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AzureMediaFormSectionQuery, AzureMediaFormSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AzureMediaFormSectionQuery, AzureMediaFormSectionQueryVariables>(AzureMediaFormSectionDocument, options);
        }
export type AzureMediaFormSectionQueryHookResult = ReturnType<typeof useAzureMediaFormSectionQuery>;
export type AzureMediaFormSectionLazyQueryHookResult = ReturnType<typeof useAzureMediaFormSectionLazyQuery>;
export type AzureMediaFormSectionQueryResult = Apollo.QueryResult<AzureMediaFormSectionQuery, AzureMediaFormSectionQueryVariables>;
export const UpdateAzureMediaFormSectionDocument = gql`
    mutation UpdateAzureMediaFormSection($updates: AzureListingInput!) {
  updateAzureListing(updates: $updates) {
    id
    status
    media_image {
      caption
      image_url
    }
    media_video {
      title
      thumbnail
      video_url
    }
  }
}
    `;
export type UpdateAzureMediaFormSectionMutationFn = Apollo.MutationFunction<UpdateAzureMediaFormSectionMutation, UpdateAzureMediaFormSectionMutationVariables>;

/**
 * __useUpdateAzureMediaFormSectionMutation__
 *
 * To run a mutation, you first call `useUpdateAzureMediaFormSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAzureMediaFormSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAzureMediaFormSectionMutation, { data, loading, error }] = useUpdateAzureMediaFormSectionMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateAzureMediaFormSectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAzureMediaFormSectionMutation, UpdateAzureMediaFormSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAzureMediaFormSectionMutation, UpdateAzureMediaFormSectionMutationVariables>(UpdateAzureMediaFormSectionDocument, options);
      }
export type UpdateAzureMediaFormSectionMutationHookResult = ReturnType<typeof useUpdateAzureMediaFormSectionMutation>;
export type UpdateAzureMediaFormSectionMutationResult = Apollo.MutationResult<UpdateAzureMediaFormSectionMutation>;
export type UpdateAzureMediaFormSectionMutationOptions = Apollo.BaseMutationOptions<UpdateAzureMediaFormSectionMutation, UpdateAzureMediaFormSectionMutationVariables>;
export const AzureProductOverviewFormSectionDocument = gql`
    query AzureProductOverviewFormSection($id: ID!) {
  azureListing(id: $id) {
    id
    status
    full_description
    getting_started_instructions
    overview_urls {
      title
      url
    }
  }
}
    `;

/**
 * __useAzureProductOverviewFormSectionQuery__
 *
 * To run a query within a React component, call `useAzureProductOverviewFormSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAzureProductOverviewFormSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAzureProductOverviewFormSectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAzureProductOverviewFormSectionQuery(baseOptions: Apollo.QueryHookOptions<AzureProductOverviewFormSectionQuery, AzureProductOverviewFormSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AzureProductOverviewFormSectionQuery, AzureProductOverviewFormSectionQueryVariables>(AzureProductOverviewFormSectionDocument, options);
      }
export function useAzureProductOverviewFormSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AzureProductOverviewFormSectionQuery, AzureProductOverviewFormSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AzureProductOverviewFormSectionQuery, AzureProductOverviewFormSectionQueryVariables>(AzureProductOverviewFormSectionDocument, options);
        }
export type AzureProductOverviewFormSectionQueryHookResult = ReturnType<typeof useAzureProductOverviewFormSectionQuery>;
export type AzureProductOverviewFormSectionLazyQueryHookResult = ReturnType<typeof useAzureProductOverviewFormSectionLazyQuery>;
export type AzureProductOverviewFormSectionQueryResult = Apollo.QueryResult<AzureProductOverviewFormSectionQuery, AzureProductOverviewFormSectionQueryVariables>;
export const UpdateAzureProductOverviewFormSectionDocument = gql`
    mutation UpdateAzureProductOverviewFormSection($updates: AzureListingInput!) {
  updateAzureListing(updates: $updates) {
    id
    status
    full_description
    getting_started_instructions
    overview_urls {
      title
      url
    }
  }
}
    `;
export type UpdateAzureProductOverviewFormSectionMutationFn = Apollo.MutationFunction<UpdateAzureProductOverviewFormSectionMutation, UpdateAzureProductOverviewFormSectionMutationVariables>;

/**
 * __useUpdateAzureProductOverviewFormSectionMutation__
 *
 * To run a mutation, you first call `useUpdateAzureProductOverviewFormSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAzureProductOverviewFormSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAzureProductOverviewFormSectionMutation, { data, loading, error }] = useUpdateAzureProductOverviewFormSectionMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateAzureProductOverviewFormSectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAzureProductOverviewFormSectionMutation, UpdateAzureProductOverviewFormSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAzureProductOverviewFormSectionMutation, UpdateAzureProductOverviewFormSectionMutationVariables>(UpdateAzureProductOverviewFormSectionDocument, options);
      }
export type UpdateAzureProductOverviewFormSectionMutationHookResult = ReturnType<typeof useUpdateAzureProductOverviewFormSectionMutation>;
export type UpdateAzureProductOverviewFormSectionMutationResult = Apollo.MutationResult<UpdateAzureProductOverviewFormSectionMutation>;
export type UpdateAzureProductOverviewFormSectionMutationOptions = Apollo.BaseMutationOptions<UpdateAzureProductOverviewFormSectionMutation, UpdateAzureProductOverviewFormSectionMutationVariables>;
export const AzureSearchKeywordsAndProductCategoriesFormSectionDocument = gql`
    query AzureSearchKeywordsAndProductCategoriesFormSection($id: ID!) {
  azureListing(id: $id) {
    id
    status
    categories {
      category
      subcategory_1
      subcategory_2
    }
    industries {
      industry
      vertical_1
      vertical_2
    }
    search_keywords
  }
}
    `;

/**
 * __useAzureSearchKeywordsAndProductCategoriesFormSectionQuery__
 *
 * To run a query within a React component, call `useAzureSearchKeywordsAndProductCategoriesFormSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAzureSearchKeywordsAndProductCategoriesFormSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAzureSearchKeywordsAndProductCategoriesFormSectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAzureSearchKeywordsAndProductCategoriesFormSectionQuery(baseOptions: Apollo.QueryHookOptions<AzureSearchKeywordsAndProductCategoriesFormSectionQuery, AzureSearchKeywordsAndProductCategoriesFormSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AzureSearchKeywordsAndProductCategoriesFormSectionQuery, AzureSearchKeywordsAndProductCategoriesFormSectionQueryVariables>(AzureSearchKeywordsAndProductCategoriesFormSectionDocument, options);
      }
export function useAzureSearchKeywordsAndProductCategoriesFormSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AzureSearchKeywordsAndProductCategoriesFormSectionQuery, AzureSearchKeywordsAndProductCategoriesFormSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AzureSearchKeywordsAndProductCategoriesFormSectionQuery, AzureSearchKeywordsAndProductCategoriesFormSectionQueryVariables>(AzureSearchKeywordsAndProductCategoriesFormSectionDocument, options);
        }
export type AzureSearchKeywordsAndProductCategoriesFormSectionQueryHookResult = ReturnType<typeof useAzureSearchKeywordsAndProductCategoriesFormSectionQuery>;
export type AzureSearchKeywordsAndProductCategoriesFormSectionLazyQueryHookResult = ReturnType<typeof useAzureSearchKeywordsAndProductCategoriesFormSectionLazyQuery>;
export type AzureSearchKeywordsAndProductCategoriesFormSectionQueryResult = Apollo.QueryResult<AzureSearchKeywordsAndProductCategoriesFormSectionQuery, AzureSearchKeywordsAndProductCategoriesFormSectionQueryVariables>;
export const UpdateAzureSearchKeywordsAndProductCategoriesFormSectionDocument = gql`
    mutation UpdateAzureSearchKeywordsAndProductCategoriesFormSection($updates: AzureListingInput!) {
  updateAzureListing(updates: $updates) {
    id
    status
    categories {
      category
      subcategory_1
      subcategory_2
    }
    industries {
      industry
      vertical_1
      vertical_2
    }
    search_keywords
  }
}
    `;
export type UpdateAzureSearchKeywordsAndProductCategoriesFormSectionMutationFn = Apollo.MutationFunction<UpdateAzureSearchKeywordsAndProductCategoriesFormSectionMutation, UpdateAzureSearchKeywordsAndProductCategoriesFormSectionMutationVariables>;

/**
 * __useUpdateAzureSearchKeywordsAndProductCategoriesFormSectionMutation__
 *
 * To run a mutation, you first call `useUpdateAzureSearchKeywordsAndProductCategoriesFormSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAzureSearchKeywordsAndProductCategoriesFormSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAzureSearchKeywordsAndProductCategoriesFormSectionMutation, { data, loading, error }] = useUpdateAzureSearchKeywordsAndProductCategoriesFormSectionMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateAzureSearchKeywordsAndProductCategoriesFormSectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAzureSearchKeywordsAndProductCategoriesFormSectionMutation, UpdateAzureSearchKeywordsAndProductCategoriesFormSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAzureSearchKeywordsAndProductCategoriesFormSectionMutation, UpdateAzureSearchKeywordsAndProductCategoriesFormSectionMutationVariables>(UpdateAzureSearchKeywordsAndProductCategoriesFormSectionDocument, options);
      }
export type UpdateAzureSearchKeywordsAndProductCategoriesFormSectionMutationHookResult = ReturnType<typeof useUpdateAzureSearchKeywordsAndProductCategoriesFormSectionMutation>;
export type UpdateAzureSearchKeywordsAndProductCategoriesFormSectionMutationResult = Apollo.MutationResult<UpdateAzureSearchKeywordsAndProductCategoriesFormSectionMutation>;
export type UpdateAzureSearchKeywordsAndProductCategoriesFormSectionMutationOptions = Apollo.BaseMutationOptions<UpdateAzureSearchKeywordsAndProductCategoriesFormSectionMutation, UpdateAzureSearchKeywordsAndProductCategoriesFormSectionMutationVariables>;
export const AzureSupportFormSectionDocument = gql`
    query AzureSupportFormSection($id: ID!) {
  azureListing(id: $id) {
    id
    status
    contact_email
    contact_support_url
    support {
      support_email
      support_name
      support_phone
      support_url
      engineering_email
      engineering_name
      engineering_phone
      support_documents {
        document_url
        name
      }
    }
  }
}
    `;

/**
 * __useAzureSupportFormSectionQuery__
 *
 * To run a query within a React component, call `useAzureSupportFormSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAzureSupportFormSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAzureSupportFormSectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAzureSupportFormSectionQuery(baseOptions: Apollo.QueryHookOptions<AzureSupportFormSectionQuery, AzureSupportFormSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AzureSupportFormSectionQuery, AzureSupportFormSectionQueryVariables>(AzureSupportFormSectionDocument, options);
      }
export function useAzureSupportFormSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AzureSupportFormSectionQuery, AzureSupportFormSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AzureSupportFormSectionQuery, AzureSupportFormSectionQueryVariables>(AzureSupportFormSectionDocument, options);
        }
export type AzureSupportFormSectionQueryHookResult = ReturnType<typeof useAzureSupportFormSectionQuery>;
export type AzureSupportFormSectionLazyQueryHookResult = ReturnType<typeof useAzureSupportFormSectionLazyQuery>;
export type AzureSupportFormSectionQueryResult = Apollo.QueryResult<AzureSupportFormSectionQuery, AzureSupportFormSectionQueryVariables>;
export const UpdateAzureSupportFormSectionDocument = gql`
    mutation UpdateAzureSupportFormSection($updates: AzureListingInput!) {
  updateAzureListing(updates: $updates) {
    id
    status
    contact_email
    contact_support_url
    support {
      support_email
      support_name
      support_phone
      support_url
      engineering_email
      engineering_name
      engineering_phone
      support_documents {
        document_url
        name
      }
    }
  }
}
    `;
export type UpdateAzureSupportFormSectionMutationFn = Apollo.MutationFunction<UpdateAzureSupportFormSectionMutation, UpdateAzureSupportFormSectionMutationVariables>;

/**
 * __useUpdateAzureSupportFormSectionMutation__
 *
 * To run a mutation, you first call `useUpdateAzureSupportFormSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAzureSupportFormSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAzureSupportFormSectionMutation, { data, loading, error }] = useUpdateAzureSupportFormSectionMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateAzureSupportFormSectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAzureSupportFormSectionMutation, UpdateAzureSupportFormSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAzureSupportFormSectionMutation, UpdateAzureSupportFormSectionMutationVariables>(UpdateAzureSupportFormSectionDocument, options);
      }
export type UpdateAzureSupportFormSectionMutationHookResult = ReturnType<typeof useUpdateAzureSupportFormSectionMutation>;
export type UpdateAzureSupportFormSectionMutationResult = Apollo.MutationResult<UpdateAzureSupportFormSectionMutation>;
export type UpdateAzureSupportFormSectionMutationOptions = Apollo.BaseMutationOptions<UpdateAzureSupportFormSectionMutation, UpdateAzureSupportFormSectionMutationVariables>;
export const AzureSyncWithSalesforceFormSectionDocument = gql`
    query AzureSyncWithSalesforceFormSection($id: ID!) {
  azureListing(id: $id) {
    id
    should_sync_listing_to_salesforce_app
  }
}
    `;

/**
 * __useAzureSyncWithSalesforceFormSectionQuery__
 *
 * To run a query within a React component, call `useAzureSyncWithSalesforceFormSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAzureSyncWithSalesforceFormSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAzureSyncWithSalesforceFormSectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAzureSyncWithSalesforceFormSectionQuery(baseOptions: Apollo.QueryHookOptions<AzureSyncWithSalesforceFormSectionQuery, AzureSyncWithSalesforceFormSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AzureSyncWithSalesforceFormSectionQuery, AzureSyncWithSalesforceFormSectionQueryVariables>(AzureSyncWithSalesforceFormSectionDocument, options);
      }
export function useAzureSyncWithSalesforceFormSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AzureSyncWithSalesforceFormSectionQuery, AzureSyncWithSalesforceFormSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AzureSyncWithSalesforceFormSectionQuery, AzureSyncWithSalesforceFormSectionQueryVariables>(AzureSyncWithSalesforceFormSectionDocument, options);
        }
export type AzureSyncWithSalesforceFormSectionQueryHookResult = ReturnType<typeof useAzureSyncWithSalesforceFormSectionQuery>;
export type AzureSyncWithSalesforceFormSectionLazyQueryHookResult = ReturnType<typeof useAzureSyncWithSalesforceFormSectionLazyQuery>;
export type AzureSyncWithSalesforceFormSectionQueryResult = Apollo.QueryResult<AzureSyncWithSalesforceFormSectionQuery, AzureSyncWithSalesforceFormSectionQueryVariables>;
export const UpdateAzureShouldSyncListingToSalesforceAppDocument = gql`
    mutation UpdateAzureShouldSyncListingToSalesforceApp($updates: AzureListingInput!) {
  updateAzureListing(updates: $updates) {
    id
    should_sync_listing_to_salesforce_app
  }
}
    `;
export type UpdateAzureShouldSyncListingToSalesforceAppMutationFn = Apollo.MutationFunction<UpdateAzureShouldSyncListingToSalesforceAppMutation, UpdateAzureShouldSyncListingToSalesforceAppMutationVariables>;

/**
 * __useUpdateAzureShouldSyncListingToSalesforceAppMutation__
 *
 * To run a mutation, you first call `useUpdateAzureShouldSyncListingToSalesforceAppMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAzureShouldSyncListingToSalesforceAppMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAzureShouldSyncListingToSalesforceAppMutation, { data, loading, error }] = useUpdateAzureShouldSyncListingToSalesforceAppMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateAzureShouldSyncListingToSalesforceAppMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAzureShouldSyncListingToSalesforceAppMutation, UpdateAzureShouldSyncListingToSalesforceAppMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAzureShouldSyncListingToSalesforceAppMutation, UpdateAzureShouldSyncListingToSalesforceAppMutationVariables>(UpdateAzureShouldSyncListingToSalesforceAppDocument, options);
      }
export type UpdateAzureShouldSyncListingToSalesforceAppMutationHookResult = ReturnType<typeof useUpdateAzureShouldSyncListingToSalesforceAppMutation>;
export type UpdateAzureShouldSyncListingToSalesforceAppMutationResult = Apollo.MutationResult<UpdateAzureShouldSyncListingToSalesforceAppMutation>;
export type UpdateAzureShouldSyncListingToSalesforceAppMutationOptions = Apollo.BaseMutationOptions<UpdateAzureShouldSyncListingToSalesforceAppMutation, UpdateAzureShouldSyncListingToSalesforceAppMutationVariables>;
export const AzurePricingAndMetricsFormSectionDocument = gql`
    query AzurePricingAndMetricsFormSection($id: ID!) {
  azureListing(id: $id) {
    id
    status
    pricing {
      pricing_type
      plans {
        plan_id
        plan_uuid
        name
        description
        markets
        user_limits {
          max
          min
        }
        billing_terms {
          type
          value
          price_per_payment_in_usd
          payment_option {
            type
            value
          }
        }
        free_trial
        visibility {
          public
          allowed_tenants {
            description
            tenant_id
          }
        }
      }
      metrics {
        display_name
        product_unit
        sku
        plan_pricing {
          plan_uuid
          price_per_unit
          base_quantity {
            quantity
            type
            unlimited
            value
          }
        }
      }
    }
  }
}
    `;

/**
 * __useAzurePricingAndMetricsFormSectionQuery__
 *
 * To run a query within a React component, call `useAzurePricingAndMetricsFormSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAzurePricingAndMetricsFormSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAzurePricingAndMetricsFormSectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAzurePricingAndMetricsFormSectionQuery(baseOptions: Apollo.QueryHookOptions<AzurePricingAndMetricsFormSectionQuery, AzurePricingAndMetricsFormSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AzurePricingAndMetricsFormSectionQuery, AzurePricingAndMetricsFormSectionQueryVariables>(AzurePricingAndMetricsFormSectionDocument, options);
      }
export function useAzurePricingAndMetricsFormSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AzurePricingAndMetricsFormSectionQuery, AzurePricingAndMetricsFormSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AzurePricingAndMetricsFormSectionQuery, AzurePricingAndMetricsFormSectionQueryVariables>(AzurePricingAndMetricsFormSectionDocument, options);
        }
export type AzurePricingAndMetricsFormSectionQueryHookResult = ReturnType<typeof useAzurePricingAndMetricsFormSectionQuery>;
export type AzurePricingAndMetricsFormSectionLazyQueryHookResult = ReturnType<typeof useAzurePricingAndMetricsFormSectionLazyQuery>;
export type AzurePricingAndMetricsFormSectionQueryResult = Apollo.QueryResult<AzurePricingAndMetricsFormSectionQuery, AzurePricingAndMetricsFormSectionQueryVariables>;
export const UpdateAzurePricingAndMetricsFormSectionDocument = gql`
    mutation UpdateAzurePricingAndMetricsFormSection($updates: AzureListingInput!) {
  updateAzureListing(updates: $updates) {
    id
    status
    pricing {
      pricing_type
      plans {
        plan_id
        plan_uuid
        name
        description
        markets
        user_limits {
          max
          min
        }
        billing_terms {
          type
          value
          price_per_payment_in_usd
          payment_option {
            type
            value
          }
        }
        free_trial
        visibility {
          public
          allowed_tenants {
            description
            tenant_id
          }
        }
      }
      metrics {
        display_name
        product_unit
        sku
        plan_pricing {
          plan_uuid
          price_per_unit
          base_quantity {
            quantity
            type
            unlimited
            value
          }
        }
      }
    }
  }
}
    `;
export type UpdateAzurePricingAndMetricsFormSectionMutationFn = Apollo.MutationFunction<UpdateAzurePricingAndMetricsFormSectionMutation, UpdateAzurePricingAndMetricsFormSectionMutationVariables>;

/**
 * __useUpdateAzurePricingAndMetricsFormSectionMutation__
 *
 * To run a mutation, you first call `useUpdateAzurePricingAndMetricsFormSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAzurePricingAndMetricsFormSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAzurePricingAndMetricsFormSectionMutation, { data, loading, error }] = useUpdateAzurePricingAndMetricsFormSectionMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateAzurePricingAndMetricsFormSectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAzurePricingAndMetricsFormSectionMutation, UpdateAzurePricingAndMetricsFormSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAzurePricingAndMetricsFormSectionMutation, UpdateAzurePricingAndMetricsFormSectionMutationVariables>(UpdateAzurePricingAndMetricsFormSectionDocument, options);
      }
export type UpdateAzurePricingAndMetricsFormSectionMutationHookResult = ReturnType<typeof useUpdateAzurePricingAndMetricsFormSectionMutation>;
export type UpdateAzurePricingAndMetricsFormSectionMutationResult = Apollo.MutationResult<UpdateAzurePricingAndMetricsFormSectionMutation>;
export type UpdateAzurePricingAndMetricsFormSectionMutationOptions = Apollo.BaseMutationOptions<UpdateAzurePricingAndMetricsFormSectionMutation, UpdateAzurePricingAndMetricsFormSectionMutationVariables>;
export const AzureRegistrationFieldsFormSectionDocument = gql`
    query AzureRegistrationFieldsFormSection($id: ID!) {
  azureListing(id: $id) {
    id
    registration_page_fields {
      data_type
      default
      display_title
      enabled
      options {
        label
        value
      }
      required
      tackle_required
      title
      validation_type
    }
  }
}
    `;

/**
 * __useAzureRegistrationFieldsFormSectionQuery__
 *
 * To run a query within a React component, call `useAzureRegistrationFieldsFormSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAzureRegistrationFieldsFormSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAzureRegistrationFieldsFormSectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAzureRegistrationFieldsFormSectionQuery(baseOptions: Apollo.QueryHookOptions<AzureRegistrationFieldsFormSectionQuery, AzureRegistrationFieldsFormSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AzureRegistrationFieldsFormSectionQuery, AzureRegistrationFieldsFormSectionQueryVariables>(AzureRegistrationFieldsFormSectionDocument, options);
      }
export function useAzureRegistrationFieldsFormSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AzureRegistrationFieldsFormSectionQuery, AzureRegistrationFieldsFormSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AzureRegistrationFieldsFormSectionQuery, AzureRegistrationFieldsFormSectionQueryVariables>(AzureRegistrationFieldsFormSectionDocument, options);
        }
export type AzureRegistrationFieldsFormSectionQueryHookResult = ReturnType<typeof useAzureRegistrationFieldsFormSectionQuery>;
export type AzureRegistrationFieldsFormSectionLazyQueryHookResult = ReturnType<typeof useAzureRegistrationFieldsFormSectionLazyQuery>;
export type AzureRegistrationFieldsFormSectionQueryResult = Apollo.QueryResult<AzureRegistrationFieldsFormSectionQuery, AzureRegistrationFieldsFormSectionQueryVariables>;
export const UpdateAzureRegistrationFieldsFormSectionDocument = gql`
    mutation UpdateAzureRegistrationFieldsFormSection($updates: AzureListingInput!) {
  updateAzureListing(updates: $updates) {
    id
    registration_page_fields {
      data_type
      default
      display_title
      enabled
      options {
        label
        value
      }
      required
      tackle_required
      title
      validation_type
    }
  }
}
    `;
export type UpdateAzureRegistrationFieldsFormSectionMutationFn = Apollo.MutationFunction<UpdateAzureRegistrationFieldsFormSectionMutation, UpdateAzureRegistrationFieldsFormSectionMutationVariables>;

/**
 * __useUpdateAzureRegistrationFieldsFormSectionMutation__
 *
 * To run a mutation, you first call `useUpdateAzureRegistrationFieldsFormSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAzureRegistrationFieldsFormSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAzureRegistrationFieldsFormSectionMutation, { data, loading, error }] = useUpdateAzureRegistrationFieldsFormSectionMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateAzureRegistrationFieldsFormSectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAzureRegistrationFieldsFormSectionMutation, UpdateAzureRegistrationFieldsFormSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAzureRegistrationFieldsFormSectionMutation, UpdateAzureRegistrationFieldsFormSectionMutationVariables>(UpdateAzureRegistrationFieldsFormSectionDocument, options);
      }
export type UpdateAzureRegistrationFieldsFormSectionMutationHookResult = ReturnType<typeof useUpdateAzureRegistrationFieldsFormSectionMutation>;
export type UpdateAzureRegistrationFieldsFormSectionMutationResult = Apollo.MutationResult<UpdateAzureRegistrationFieldsFormSectionMutation>;
export type UpdateAzureRegistrationFieldsFormSectionMutationOptions = Apollo.BaseMutationOptions<UpdateAzureRegistrationFieldsFormSectionMutation, UpdateAzureRegistrationFieldsFormSectionMutationVariables>;
export const AzureListingRegistrationDocument = gql`
    query AzureListingRegistration($id: ID!) {
  azureListing(id: $id) {
    id
    registration_hosting
  }
}
    `;

/**
 * __useAzureListingRegistrationQuery__
 *
 * To run a query within a React component, call `useAzureListingRegistrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useAzureListingRegistrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAzureListingRegistrationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAzureListingRegistrationQuery(baseOptions: Apollo.QueryHookOptions<AzureListingRegistrationQuery, AzureListingRegistrationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AzureListingRegistrationQuery, AzureListingRegistrationQueryVariables>(AzureListingRegistrationDocument, options);
      }
export function useAzureListingRegistrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AzureListingRegistrationQuery, AzureListingRegistrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AzureListingRegistrationQuery, AzureListingRegistrationQueryVariables>(AzureListingRegistrationDocument, options);
        }
export type AzureListingRegistrationQueryHookResult = ReturnType<typeof useAzureListingRegistrationQuery>;
export type AzureListingRegistrationLazyQueryHookResult = ReturnType<typeof useAzureListingRegistrationLazyQuery>;
export type AzureListingRegistrationQueryResult = Apollo.QueryResult<AzureListingRegistrationQuery, AzureListingRegistrationQueryVariables>;
export const AzureRegistrationHostingFormSectionDocument = gql`
    query AzureRegistrationHostingFormSection($id: ID!) {
  azureListing(id: $id) {
    id
    registration_hosting
    registration_redirect {
      url
      params
    }
  }
}
    `;

/**
 * __useAzureRegistrationHostingFormSectionQuery__
 *
 * To run a query within a React component, call `useAzureRegistrationHostingFormSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAzureRegistrationHostingFormSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAzureRegistrationHostingFormSectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAzureRegistrationHostingFormSectionQuery(baseOptions: Apollo.QueryHookOptions<AzureRegistrationHostingFormSectionQuery, AzureRegistrationHostingFormSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AzureRegistrationHostingFormSectionQuery, AzureRegistrationHostingFormSectionQueryVariables>(AzureRegistrationHostingFormSectionDocument, options);
      }
export function useAzureRegistrationHostingFormSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AzureRegistrationHostingFormSectionQuery, AzureRegistrationHostingFormSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AzureRegistrationHostingFormSectionQuery, AzureRegistrationHostingFormSectionQueryVariables>(AzureRegistrationHostingFormSectionDocument, options);
        }
export type AzureRegistrationHostingFormSectionQueryHookResult = ReturnType<typeof useAzureRegistrationHostingFormSectionQuery>;
export type AzureRegistrationHostingFormSectionLazyQueryHookResult = ReturnType<typeof useAzureRegistrationHostingFormSectionLazyQuery>;
export type AzureRegistrationHostingFormSectionQueryResult = Apollo.QueryResult<AzureRegistrationHostingFormSectionQuery, AzureRegistrationHostingFormSectionQueryVariables>;
export const UpdateAzureRegistrationHostingFormSectionDocument = gql`
    mutation UpdateAzureRegistrationHostingFormSection($updates: AzureListingInput!) {
  updateAzureListing(updates: $updates) {
    id
    registration_hosting
    registration_redirect {
      url
      params
    }
  }
}
    `;
export type UpdateAzureRegistrationHostingFormSectionMutationFn = Apollo.MutationFunction<UpdateAzureRegistrationHostingFormSectionMutation, UpdateAzureRegistrationHostingFormSectionMutationVariables>;

/**
 * __useUpdateAzureRegistrationHostingFormSectionMutation__
 *
 * To run a mutation, you first call `useUpdateAzureRegistrationHostingFormSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAzureRegistrationHostingFormSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAzureRegistrationHostingFormSectionMutation, { data, loading, error }] = useUpdateAzureRegistrationHostingFormSectionMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateAzureRegistrationHostingFormSectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAzureRegistrationHostingFormSectionMutation, UpdateAzureRegistrationHostingFormSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAzureRegistrationHostingFormSectionMutation, UpdateAzureRegistrationHostingFormSectionMutationVariables>(UpdateAzureRegistrationHostingFormSectionDocument, options);
      }
export type UpdateAzureRegistrationHostingFormSectionMutationHookResult = ReturnType<typeof useUpdateAzureRegistrationHostingFormSectionMutation>;
export type UpdateAzureRegistrationHostingFormSectionMutationResult = Apollo.MutationResult<UpdateAzureRegistrationHostingFormSectionMutation>;
export type UpdateAzureRegistrationHostingFormSectionMutationOptions = Apollo.BaseMutationOptions<UpdateAzureRegistrationHostingFormSectionMutation, UpdateAzureRegistrationHostingFormSectionMutationVariables>;
export const AzureRegistrationSuccessFormSectionDocument = gql`
    query AzureRegistrationSuccessFormSection($id: ID!) {
  azureListing(id: $id) {
    id
    registration {
      success {
        message
        redirect_url
      }
    }
  }
}
    `;

/**
 * __useAzureRegistrationSuccessFormSectionQuery__
 *
 * To run a query within a React component, call `useAzureRegistrationSuccessFormSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAzureRegistrationSuccessFormSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAzureRegistrationSuccessFormSectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAzureRegistrationSuccessFormSectionQuery(baseOptions: Apollo.QueryHookOptions<AzureRegistrationSuccessFormSectionQuery, AzureRegistrationSuccessFormSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AzureRegistrationSuccessFormSectionQuery, AzureRegistrationSuccessFormSectionQueryVariables>(AzureRegistrationSuccessFormSectionDocument, options);
      }
export function useAzureRegistrationSuccessFormSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AzureRegistrationSuccessFormSectionQuery, AzureRegistrationSuccessFormSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AzureRegistrationSuccessFormSectionQuery, AzureRegistrationSuccessFormSectionQueryVariables>(AzureRegistrationSuccessFormSectionDocument, options);
        }
export type AzureRegistrationSuccessFormSectionQueryHookResult = ReturnType<typeof useAzureRegistrationSuccessFormSectionQuery>;
export type AzureRegistrationSuccessFormSectionLazyQueryHookResult = ReturnType<typeof useAzureRegistrationSuccessFormSectionLazyQuery>;
export type AzureRegistrationSuccessFormSectionQueryResult = Apollo.QueryResult<AzureRegistrationSuccessFormSectionQuery, AzureRegistrationSuccessFormSectionQueryVariables>;
export const UpdateAzureRegistrationSuccessFormSectionDocument = gql`
    mutation UpdateAzureRegistrationSuccessFormSection($updates: AzureListingInput!) {
  updateAzureListing(updates: $updates) {
    id
    registration {
      success {
        message
        redirect_url
      }
    }
  }
}
    `;
export type UpdateAzureRegistrationSuccessFormSectionMutationFn = Apollo.MutationFunction<UpdateAzureRegistrationSuccessFormSectionMutation, UpdateAzureRegistrationSuccessFormSectionMutationVariables>;

/**
 * __useUpdateAzureRegistrationSuccessFormSectionMutation__
 *
 * To run a mutation, you first call `useUpdateAzureRegistrationSuccessFormSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAzureRegistrationSuccessFormSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAzureRegistrationSuccessFormSectionMutation, { data, loading, error }] = useUpdateAzureRegistrationSuccessFormSectionMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateAzureRegistrationSuccessFormSectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAzureRegistrationSuccessFormSectionMutation, UpdateAzureRegistrationSuccessFormSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAzureRegistrationSuccessFormSectionMutation, UpdateAzureRegistrationSuccessFormSectionMutationVariables>(UpdateAzureRegistrationSuccessFormSectionDocument, options);
      }
export type UpdateAzureRegistrationSuccessFormSectionMutationHookResult = ReturnType<typeof useUpdateAzureRegistrationSuccessFormSectionMutation>;
export type UpdateAzureRegistrationSuccessFormSectionMutationResult = Apollo.MutationResult<UpdateAzureRegistrationSuccessFormSectionMutation>;
export type UpdateAzureRegistrationSuccessFormSectionMutationOptions = Apollo.BaseMutationOptions<UpdateAzureRegistrationSuccessFormSectionMutation, UpdateAzureRegistrationSuccessFormSectionMutationVariables>;
export const AzureRegistrationThemeFormSectionDocument = gql`
    query AzureRegistrationThemeFormSection($id: ID!) {
  azureListing(id: $id) {
    id
    registration {
      form {
        button {
          background_color
          color
        }
        logo_url
      }
      hero {
        background_color
        background_image_url
      }
    }
  }
}
    `;

/**
 * __useAzureRegistrationThemeFormSectionQuery__
 *
 * To run a query within a React component, call `useAzureRegistrationThemeFormSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAzureRegistrationThemeFormSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAzureRegistrationThemeFormSectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAzureRegistrationThemeFormSectionQuery(baseOptions: Apollo.QueryHookOptions<AzureRegistrationThemeFormSectionQuery, AzureRegistrationThemeFormSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AzureRegistrationThemeFormSectionQuery, AzureRegistrationThemeFormSectionQueryVariables>(AzureRegistrationThemeFormSectionDocument, options);
      }
export function useAzureRegistrationThemeFormSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AzureRegistrationThemeFormSectionQuery, AzureRegistrationThemeFormSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AzureRegistrationThemeFormSectionQuery, AzureRegistrationThemeFormSectionQueryVariables>(AzureRegistrationThemeFormSectionDocument, options);
        }
export type AzureRegistrationThemeFormSectionQueryHookResult = ReturnType<typeof useAzureRegistrationThemeFormSectionQuery>;
export type AzureRegistrationThemeFormSectionLazyQueryHookResult = ReturnType<typeof useAzureRegistrationThemeFormSectionLazyQuery>;
export type AzureRegistrationThemeFormSectionQueryResult = Apollo.QueryResult<AzureRegistrationThemeFormSectionQuery, AzureRegistrationThemeFormSectionQueryVariables>;
export const UpdateAzureRegistrationThemeFormSectionDocument = gql`
    mutation UpdateAzureRegistrationThemeFormSection($updates: AzureListingInput!) {
  updateAzureListing(updates: $updates) {
    id
    registration {
      form {
        button {
          background_color
          color
        }
        logo_url
      }
      hero {
        background_color
        background_image_url
      }
    }
  }
}
    `;
export type UpdateAzureRegistrationThemeFormSectionMutationFn = Apollo.MutationFunction<UpdateAzureRegistrationThemeFormSectionMutation, UpdateAzureRegistrationThemeFormSectionMutationVariables>;

/**
 * __useUpdateAzureRegistrationThemeFormSectionMutation__
 *
 * To run a mutation, you first call `useUpdateAzureRegistrationThemeFormSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAzureRegistrationThemeFormSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAzureRegistrationThemeFormSectionMutation, { data, loading, error }] = useUpdateAzureRegistrationThemeFormSectionMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateAzureRegistrationThemeFormSectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAzureRegistrationThemeFormSectionMutation, UpdateAzureRegistrationThemeFormSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAzureRegistrationThemeFormSectionMutation, UpdateAzureRegistrationThemeFormSectionMutationVariables>(UpdateAzureRegistrationThemeFormSectionDocument, options);
      }
export type UpdateAzureRegistrationThemeFormSectionMutationHookResult = ReturnType<typeof useUpdateAzureRegistrationThemeFormSectionMutation>;
export type UpdateAzureRegistrationThemeFormSectionMutationResult = Apollo.MutationResult<UpdateAzureRegistrationThemeFormSectionMutation>;
export type UpdateAzureRegistrationThemeFormSectionMutationOptions = Apollo.BaseMutationOptions<UpdateAzureRegistrationThemeFormSectionMutation, UpdateAzureRegistrationThemeFormSectionMutationVariables>;
export const CreateS3PresignedUrlDocument = gql`
    mutation createS3PresignedUrl($data: S3Input!) {
  createS3PresignedUrl(data: $data) {
    url
    fields
  }
}
    `;
export type CreateS3PresignedUrlMutationFn = Apollo.MutationFunction<CreateS3PresignedUrlMutation, CreateS3PresignedUrlMutationVariables>;

/**
 * __useCreateS3PresignedUrlMutation__
 *
 * To run a mutation, you first call `useCreateS3PresignedUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateS3PresignedUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createS3PresignedUrlMutation, { data, loading, error }] = useCreateS3PresignedUrlMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateS3PresignedUrlMutation(baseOptions?: Apollo.MutationHookOptions<CreateS3PresignedUrlMutation, CreateS3PresignedUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateS3PresignedUrlMutation, CreateS3PresignedUrlMutationVariables>(CreateS3PresignedUrlDocument, options);
      }
export type CreateS3PresignedUrlMutationHookResult = ReturnType<typeof useCreateS3PresignedUrlMutation>;
export type CreateS3PresignedUrlMutationResult = Apollo.MutationResult<CreateS3PresignedUrlMutation>;
export type CreateS3PresignedUrlMutationOptions = Apollo.BaseMutationOptions<CreateS3PresignedUrlMutation, CreateS3PresignedUrlMutationVariables>;
export const ImportAwsListingButtonDocument = gql`
    query ImportAwsListingButton {
  awsMarketplaceSaasProducts {
    id: EntityId
    EntityId
    LastModifiedDate
    Name
    Visibility
    EntityType
  }
}
    `;

/**
 * __useImportAwsListingButtonQuery__
 *
 * To run a query within a React component, call `useImportAwsListingButtonQuery` and pass it any options that fit your needs.
 * When your component renders, `useImportAwsListingButtonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImportAwsListingButtonQuery({
 *   variables: {
 *   },
 * });
 */
export function useImportAwsListingButtonQuery(baseOptions?: Apollo.QueryHookOptions<ImportAwsListingButtonQuery, ImportAwsListingButtonQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImportAwsListingButtonQuery, ImportAwsListingButtonQueryVariables>(ImportAwsListingButtonDocument, options);
      }
export function useImportAwsListingButtonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImportAwsListingButtonQuery, ImportAwsListingButtonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImportAwsListingButtonQuery, ImportAwsListingButtonQueryVariables>(ImportAwsListingButtonDocument, options);
        }
export type ImportAwsListingButtonQueryHookResult = ReturnType<typeof useImportAwsListingButtonQuery>;
export type ImportAwsListingButtonLazyQueryHookResult = ReturnType<typeof useImportAwsListingButtonLazyQuery>;
export type ImportAwsListingButtonQueryResult = Apollo.QueryResult<ImportAwsListingButtonQuery, ImportAwsListingButtonQueryVariables>;
export const ImportAzureListingButtonDocument = gql`
    query ImportAzureListingButton {
  azureMarketplaceSaasProducts {
    id
    identity {
      externalId
    }
    status
    created_date
    type
    alias
  }
}
    `;

/**
 * __useImportAzureListingButtonQuery__
 *
 * To run a query within a React component, call `useImportAzureListingButtonQuery` and pass it any options that fit your needs.
 * When your component renders, `useImportAzureListingButtonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImportAzureListingButtonQuery({
 *   variables: {
 *   },
 * });
 */
export function useImportAzureListingButtonQuery(baseOptions?: Apollo.QueryHookOptions<ImportAzureListingButtonQuery, ImportAzureListingButtonQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImportAzureListingButtonQuery, ImportAzureListingButtonQueryVariables>(ImportAzureListingButtonDocument, options);
      }
export function useImportAzureListingButtonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImportAzureListingButtonQuery, ImportAzureListingButtonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImportAzureListingButtonQuery, ImportAzureListingButtonQueryVariables>(ImportAzureListingButtonDocument, options);
        }
export type ImportAzureListingButtonQueryHookResult = ReturnType<typeof useImportAzureListingButtonQuery>;
export type ImportAzureListingButtonLazyQueryHookResult = ReturnType<typeof useImportAzureListingButtonLazyQuery>;
export type ImportAzureListingButtonQueryResult = Apollo.QueryResult<ImportAzureListingButtonQuery, ImportAzureListingButtonQueryVariables>;
export const ListingsImportAwsListingDocument = gql`
    mutation ListingsImportAwsListing($id: ID!) {
  importAwsListing(id: $id) {
    __typename
    id
    name
    status
    listing_type
  }
}
    `;
export type ListingsImportAwsListingMutationFn = Apollo.MutationFunction<ListingsImportAwsListingMutation, ListingsImportAwsListingMutationVariables>;

/**
 * __useListingsImportAwsListingMutation__
 *
 * To run a mutation, you first call `useListingsImportAwsListingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useListingsImportAwsListingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [listingsImportAwsListingMutation, { data, loading, error }] = useListingsImportAwsListingMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useListingsImportAwsListingMutation(baseOptions?: Apollo.MutationHookOptions<ListingsImportAwsListingMutation, ListingsImportAwsListingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ListingsImportAwsListingMutation, ListingsImportAwsListingMutationVariables>(ListingsImportAwsListingDocument, options);
      }
export type ListingsImportAwsListingMutationHookResult = ReturnType<typeof useListingsImportAwsListingMutation>;
export type ListingsImportAwsListingMutationResult = Apollo.MutationResult<ListingsImportAwsListingMutation>;
export type ListingsImportAwsListingMutationOptions = Apollo.BaseMutationOptions<ListingsImportAwsListingMutation, ListingsImportAwsListingMutationVariables>;
export const ListingsImportAzureListingDocument = gql`
    mutation ListingsImportAzureListing($id: ID!) {
  importAzureListing(id: $id) {
    __typename
    id
    status
    listing_type
  }
}
    `;
export type ListingsImportAzureListingMutationFn = Apollo.MutationFunction<ListingsImportAzureListingMutation, ListingsImportAzureListingMutationVariables>;

/**
 * __useListingsImportAzureListingMutation__
 *
 * To run a mutation, you first call `useListingsImportAzureListingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useListingsImportAzureListingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [listingsImportAzureListingMutation, { data, loading, error }] = useListingsImportAzureListingMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useListingsImportAzureListingMutation(baseOptions?: Apollo.MutationHookOptions<ListingsImportAzureListingMutation, ListingsImportAzureListingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ListingsImportAzureListingMutation, ListingsImportAzureListingMutationVariables>(ListingsImportAzureListingDocument, options);
      }
export type ListingsImportAzureListingMutationHookResult = ReturnType<typeof useListingsImportAzureListingMutation>;
export type ListingsImportAzureListingMutationResult = Apollo.MutationResult<ListingsImportAzureListingMutation>;
export type ListingsImportAzureListingMutationOptions = Apollo.BaseMutationOptions<ListingsImportAzureListingMutation, ListingsImportAzureListingMutationVariables>;
export const ImportListingButtonVendorConfigurationDocument = gql`
    query ImportListingButtonVendorConfiguration {
  currentUser {
    id
    vendor {
      id
      configuration {
        id
        aws {
          assume_role {
            role_arn
          }
        }
        azure {
          exp_date
        }
      }
    }
  }
}
    `;

/**
 * __useImportListingButtonVendorConfigurationQuery__
 *
 * To run a query within a React component, call `useImportListingButtonVendorConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useImportListingButtonVendorConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImportListingButtonVendorConfigurationQuery({
 *   variables: {
 *   },
 * });
 */
export function useImportListingButtonVendorConfigurationQuery(baseOptions?: Apollo.QueryHookOptions<ImportListingButtonVendorConfigurationQuery, ImportListingButtonVendorConfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImportListingButtonVendorConfigurationQuery, ImportListingButtonVendorConfigurationQueryVariables>(ImportListingButtonVendorConfigurationDocument, options);
      }
export function useImportListingButtonVendorConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImportListingButtonVendorConfigurationQuery, ImportListingButtonVendorConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImportListingButtonVendorConfigurationQuery, ImportListingButtonVendorConfigurationQueryVariables>(ImportListingButtonVendorConfigurationDocument, options);
        }
export type ImportListingButtonVendorConfigurationQueryHookResult = ReturnType<typeof useImportListingButtonVendorConfigurationQuery>;
export type ImportListingButtonVendorConfigurationLazyQueryHookResult = ReturnType<typeof useImportListingButtonVendorConfigurationLazyQuery>;
export type ImportListingButtonVendorConfigurationQueryResult = Apollo.QueryResult<ImportListingButtonVendorConfigurationQuery, ImportListingButtonVendorConfigurationQueryVariables>;
export const ListingHeaderForAwsByListingIdDocument = gql`
    query ListingHeaderForAwsByListingId($id: ID!) {
  awsListing(id: $id) {
    status
    id
    revision_of_product_id_internal
    relist_of_product_id_internal
    name
  }
}
    `;

/**
 * __useListingHeaderForAwsByListingIdQuery__
 *
 * To run a query within a React component, call `useListingHeaderForAwsByListingIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingHeaderForAwsByListingIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingHeaderForAwsByListingIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useListingHeaderForAwsByListingIdQuery(baseOptions: Apollo.QueryHookOptions<ListingHeaderForAwsByListingIdQuery, ListingHeaderForAwsByListingIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListingHeaderForAwsByListingIdQuery, ListingHeaderForAwsByListingIdQueryVariables>(ListingHeaderForAwsByListingIdDocument, options);
      }
export function useListingHeaderForAwsByListingIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListingHeaderForAwsByListingIdQuery, ListingHeaderForAwsByListingIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListingHeaderForAwsByListingIdQuery, ListingHeaderForAwsByListingIdQueryVariables>(ListingHeaderForAwsByListingIdDocument, options);
        }
export type ListingHeaderForAwsByListingIdQueryHookResult = ReturnType<typeof useListingHeaderForAwsByListingIdQuery>;
export type ListingHeaderForAwsByListingIdLazyQueryHookResult = ReturnType<typeof useListingHeaderForAwsByListingIdLazyQuery>;
export type ListingHeaderForAwsByListingIdQueryResult = Apollo.QueryResult<ListingHeaderForAwsByListingIdQuery, ListingHeaderForAwsByListingIdQueryVariables>;
export const ListingHeaderForGcpByListingIdDocument = gql`
    query ListingHeaderForGcpByListingId($id: ID!) {
  gcpListing(id: $id) {
    status
    id
    revision_of_product_id_internal
    name
  }
}
    `;

/**
 * __useListingHeaderForGcpByListingIdQuery__
 *
 * To run a query within a React component, call `useListingHeaderForGcpByListingIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingHeaderForGcpByListingIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingHeaderForGcpByListingIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useListingHeaderForGcpByListingIdQuery(baseOptions: Apollo.QueryHookOptions<ListingHeaderForGcpByListingIdQuery, ListingHeaderForGcpByListingIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListingHeaderForGcpByListingIdQuery, ListingHeaderForGcpByListingIdQueryVariables>(ListingHeaderForGcpByListingIdDocument, options);
      }
export function useListingHeaderForGcpByListingIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListingHeaderForGcpByListingIdQuery, ListingHeaderForGcpByListingIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListingHeaderForGcpByListingIdQuery, ListingHeaderForGcpByListingIdQueryVariables>(ListingHeaderForGcpByListingIdDocument, options);
        }
export type ListingHeaderForGcpByListingIdQueryHookResult = ReturnType<typeof useListingHeaderForGcpByListingIdQuery>;
export type ListingHeaderForGcpByListingIdLazyQueryHookResult = ReturnType<typeof useListingHeaderForGcpByListingIdLazyQuery>;
export type ListingHeaderForGcpByListingIdQueryResult = Apollo.QueryResult<ListingHeaderForGcpByListingIdQuery, ListingHeaderForGcpByListingIdQueryVariables>;
export const ListingHeaderForAzureByListingIdDocument = gql`
    query ListingHeaderForAzureByListingId($id: ID!) {
  azureListing(id: $id) {
    status
    id
    revision_of_product_id_internal
    name
  }
}
    `;

/**
 * __useListingHeaderForAzureByListingIdQuery__
 *
 * To run a query within a React component, call `useListingHeaderForAzureByListingIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingHeaderForAzureByListingIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingHeaderForAzureByListingIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useListingHeaderForAzureByListingIdQuery(baseOptions: Apollo.QueryHookOptions<ListingHeaderForAzureByListingIdQuery, ListingHeaderForAzureByListingIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListingHeaderForAzureByListingIdQuery, ListingHeaderForAzureByListingIdQueryVariables>(ListingHeaderForAzureByListingIdDocument, options);
      }
export function useListingHeaderForAzureByListingIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListingHeaderForAzureByListingIdQuery, ListingHeaderForAzureByListingIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListingHeaderForAzureByListingIdQuery, ListingHeaderForAzureByListingIdQueryVariables>(ListingHeaderForAzureByListingIdDocument, options);
        }
export type ListingHeaderForAzureByListingIdQueryHookResult = ReturnType<typeof useListingHeaderForAzureByListingIdQuery>;
export type ListingHeaderForAzureByListingIdLazyQueryHookResult = ReturnType<typeof useListingHeaderForAzureByListingIdLazyQuery>;
export type ListingHeaderForAzureByListingIdQueryResult = Apollo.QueryResult<ListingHeaderForAzureByListingIdQuery, ListingHeaderForAzureByListingIdQueryVariables>;
export const ListingHeaderForRedHatByListingIdDocument = gql`
    query ListingHeaderForRedHatByListingId($id: ID!) {
  redHatListing(id: $id) {
    status
    id
    revision_of_product_id_internal
    name
  }
}
    `;

/**
 * __useListingHeaderForRedHatByListingIdQuery__
 *
 * To run a query within a React component, call `useListingHeaderForRedHatByListingIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingHeaderForRedHatByListingIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingHeaderForRedHatByListingIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useListingHeaderForRedHatByListingIdQuery(baseOptions: Apollo.QueryHookOptions<ListingHeaderForRedHatByListingIdQuery, ListingHeaderForRedHatByListingIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListingHeaderForRedHatByListingIdQuery, ListingHeaderForRedHatByListingIdQueryVariables>(ListingHeaderForRedHatByListingIdDocument, options);
      }
export function useListingHeaderForRedHatByListingIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListingHeaderForRedHatByListingIdQuery, ListingHeaderForRedHatByListingIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListingHeaderForRedHatByListingIdQuery, ListingHeaderForRedHatByListingIdQueryVariables>(ListingHeaderForRedHatByListingIdDocument, options);
        }
export type ListingHeaderForRedHatByListingIdQueryHookResult = ReturnType<typeof useListingHeaderForRedHatByListingIdQuery>;
export type ListingHeaderForRedHatByListingIdLazyQueryHookResult = ReturnType<typeof useListingHeaderForRedHatByListingIdLazyQuery>;
export type ListingHeaderForRedHatByListingIdQueryResult = Apollo.QueryResult<ListingHeaderForRedHatByListingIdQuery, ListingHeaderForRedHatByListingIdQueryVariables>;
export const GcpFeaturesAndPlansAndPricingFormSectionDocument = gql`
    query GcpFeaturesAndPlansAndPricingFormSection($id: ID!) {
  gcpListing(id: $id) {
    id
    status
    features {
      description
      feature_id
      label
    }
    plans {
      name
      plan_id
      public
      feature_ids
      pricing
    }
  }
}
    `;

/**
 * __useGcpFeaturesAndPlansAndPricingFormSectionQuery__
 *
 * To run a query within a React component, call `useGcpFeaturesAndPlansAndPricingFormSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGcpFeaturesAndPlansAndPricingFormSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGcpFeaturesAndPlansAndPricingFormSectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGcpFeaturesAndPlansAndPricingFormSectionQuery(baseOptions: Apollo.QueryHookOptions<GcpFeaturesAndPlansAndPricingFormSectionQuery, GcpFeaturesAndPlansAndPricingFormSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GcpFeaturesAndPlansAndPricingFormSectionQuery, GcpFeaturesAndPlansAndPricingFormSectionQueryVariables>(GcpFeaturesAndPlansAndPricingFormSectionDocument, options);
      }
export function useGcpFeaturesAndPlansAndPricingFormSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GcpFeaturesAndPlansAndPricingFormSectionQuery, GcpFeaturesAndPlansAndPricingFormSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GcpFeaturesAndPlansAndPricingFormSectionQuery, GcpFeaturesAndPlansAndPricingFormSectionQueryVariables>(GcpFeaturesAndPlansAndPricingFormSectionDocument, options);
        }
export type GcpFeaturesAndPlansAndPricingFormSectionQueryHookResult = ReturnType<typeof useGcpFeaturesAndPlansAndPricingFormSectionQuery>;
export type GcpFeaturesAndPlansAndPricingFormSectionLazyQueryHookResult = ReturnType<typeof useGcpFeaturesAndPlansAndPricingFormSectionLazyQuery>;
export type GcpFeaturesAndPlansAndPricingFormSectionQueryResult = Apollo.QueryResult<GcpFeaturesAndPlansAndPricingFormSectionQuery, GcpFeaturesAndPlansAndPricingFormSectionQueryVariables>;
export const UpdateGcpFeaturesAndPlansAndPricingFormSectionDocument = gql`
    mutation UpdateGcpFeaturesAndPlansAndPricingFormSection($updates: GcpListingInput!) {
  updateGcpListing(updates: $updates) {
    id
    status
    features {
      description
      feature_id
      label
    }
    plans {
      name
      plan_id
      public
      feature_ids
      pricing
    }
  }
}
    `;
export type UpdateGcpFeaturesAndPlansAndPricingFormSectionMutationFn = Apollo.MutationFunction<UpdateGcpFeaturesAndPlansAndPricingFormSectionMutation, UpdateGcpFeaturesAndPlansAndPricingFormSectionMutationVariables>;

/**
 * __useUpdateGcpFeaturesAndPlansAndPricingFormSectionMutation__
 *
 * To run a mutation, you first call `useUpdateGcpFeaturesAndPlansAndPricingFormSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGcpFeaturesAndPlansAndPricingFormSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGcpFeaturesAndPlansAndPricingFormSectionMutation, { data, loading, error }] = useUpdateGcpFeaturesAndPlansAndPricingFormSectionMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateGcpFeaturesAndPlansAndPricingFormSectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGcpFeaturesAndPlansAndPricingFormSectionMutation, UpdateGcpFeaturesAndPlansAndPricingFormSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGcpFeaturesAndPlansAndPricingFormSectionMutation, UpdateGcpFeaturesAndPlansAndPricingFormSectionMutationVariables>(UpdateGcpFeaturesAndPlansAndPricingFormSectionDocument, options);
      }
export type UpdateGcpFeaturesAndPlansAndPricingFormSectionMutationHookResult = ReturnType<typeof useUpdateGcpFeaturesAndPlansAndPricingFormSectionMutation>;
export type UpdateGcpFeaturesAndPlansAndPricingFormSectionMutationResult = Apollo.MutationResult<UpdateGcpFeaturesAndPlansAndPricingFormSectionMutation>;
export type UpdateGcpFeaturesAndPlansAndPricingFormSectionMutationOptions = Apollo.BaseMutationOptions<UpdateGcpFeaturesAndPlansAndPricingFormSectionMutation, UpdateGcpFeaturesAndPlansAndPricingFormSectionMutationVariables>;
export const GcpContractMetadataFormSectionDocument = gql`
    query GcpContractMetadataFormSection($id: ID!) {
  gcpListing(id: $id) {
    id
    contract_standard_fields {
      cloud_field
      title
    }
  }
}
    `;

/**
 * __useGcpContractMetadataFormSectionQuery__
 *
 * To run a query within a React component, call `useGcpContractMetadataFormSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGcpContractMetadataFormSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGcpContractMetadataFormSectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGcpContractMetadataFormSectionQuery(baseOptions: Apollo.QueryHookOptions<GcpContractMetadataFormSectionQuery, GcpContractMetadataFormSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GcpContractMetadataFormSectionQuery, GcpContractMetadataFormSectionQueryVariables>(GcpContractMetadataFormSectionDocument, options);
      }
export function useGcpContractMetadataFormSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GcpContractMetadataFormSectionQuery, GcpContractMetadataFormSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GcpContractMetadataFormSectionQuery, GcpContractMetadataFormSectionQueryVariables>(GcpContractMetadataFormSectionDocument, options);
        }
export type GcpContractMetadataFormSectionQueryHookResult = ReturnType<typeof useGcpContractMetadataFormSectionQuery>;
export type GcpContractMetadataFormSectionLazyQueryHookResult = ReturnType<typeof useGcpContractMetadataFormSectionLazyQuery>;
export type GcpContractMetadataFormSectionQueryResult = Apollo.QueryResult<GcpContractMetadataFormSectionQuery, GcpContractMetadataFormSectionQueryVariables>;
export const UpdateGcpContractMetadataFormSectionDocument = gql`
    mutation UpdateGcpContractMetadataFormSection($updates: GcpListingInput!) {
  updateGcpListing(updates: $updates) {
    id
    contract_standard_fields {
      cloud_field
      title
    }
  }
}
    `;
export type UpdateGcpContractMetadataFormSectionMutationFn = Apollo.MutationFunction<UpdateGcpContractMetadataFormSectionMutation, UpdateGcpContractMetadataFormSectionMutationVariables>;

/**
 * __useUpdateGcpContractMetadataFormSectionMutation__
 *
 * To run a mutation, you first call `useUpdateGcpContractMetadataFormSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGcpContractMetadataFormSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGcpContractMetadataFormSectionMutation, { data, loading, error }] = useUpdateGcpContractMetadataFormSectionMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateGcpContractMetadataFormSectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGcpContractMetadataFormSectionMutation, UpdateGcpContractMetadataFormSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGcpContractMetadataFormSectionMutation, UpdateGcpContractMetadataFormSectionMutationVariables>(UpdateGcpContractMetadataFormSectionDocument, options);
      }
export type UpdateGcpContractMetadataFormSectionMutationHookResult = ReturnType<typeof useUpdateGcpContractMetadataFormSectionMutation>;
export type UpdateGcpContractMetadataFormSectionMutationResult = Apollo.MutationResult<UpdateGcpContractMetadataFormSectionMutation>;
export type UpdateGcpContractMetadataFormSectionMutationOptions = Apollo.BaseMutationOptions<UpdateGcpContractMetadataFormSectionMutation, UpdateGcpContractMetadataFormSectionMutationVariables>;
export const GcpDocumentationAndSupportFormSectionDocument = gql`
    query GcpDocumentationAndSupportFormSection($id: ID!) {
  gcpListing(id: $id) {
    id
    status
    contact_email
    contact_support_url
    support_description
    support_url
    documentation {
      description
      resource_type
      url
    }
  }
}
    `;

/**
 * __useGcpDocumentationAndSupportFormSectionQuery__
 *
 * To run a query within a React component, call `useGcpDocumentationAndSupportFormSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGcpDocumentationAndSupportFormSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGcpDocumentationAndSupportFormSectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGcpDocumentationAndSupportFormSectionQuery(baseOptions: Apollo.QueryHookOptions<GcpDocumentationAndSupportFormSectionQuery, GcpDocumentationAndSupportFormSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GcpDocumentationAndSupportFormSectionQuery, GcpDocumentationAndSupportFormSectionQueryVariables>(GcpDocumentationAndSupportFormSectionDocument, options);
      }
export function useGcpDocumentationAndSupportFormSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GcpDocumentationAndSupportFormSectionQuery, GcpDocumentationAndSupportFormSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GcpDocumentationAndSupportFormSectionQuery, GcpDocumentationAndSupportFormSectionQueryVariables>(GcpDocumentationAndSupportFormSectionDocument, options);
        }
export type GcpDocumentationAndSupportFormSectionQueryHookResult = ReturnType<typeof useGcpDocumentationAndSupportFormSectionQuery>;
export type GcpDocumentationAndSupportFormSectionLazyQueryHookResult = ReturnType<typeof useGcpDocumentationAndSupportFormSectionLazyQuery>;
export type GcpDocumentationAndSupportFormSectionQueryResult = Apollo.QueryResult<GcpDocumentationAndSupportFormSectionQuery, GcpDocumentationAndSupportFormSectionQueryVariables>;
export const UpdateGcpDocumentationAndSupportFormSectionDocument = gql`
    mutation UpdateGcpDocumentationAndSupportFormSection($updates: GcpListingInput!) {
  updateGcpListing(updates: $updates) {
    id
    status
    contact_email
    contact_support_url
    support_description
    support_url
    documentation {
      description
      resource_type
      url
    }
  }
}
    `;
export type UpdateGcpDocumentationAndSupportFormSectionMutationFn = Apollo.MutationFunction<UpdateGcpDocumentationAndSupportFormSectionMutation, UpdateGcpDocumentationAndSupportFormSectionMutationVariables>;

/**
 * __useUpdateGcpDocumentationAndSupportFormSectionMutation__
 *
 * To run a mutation, you first call `useUpdateGcpDocumentationAndSupportFormSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGcpDocumentationAndSupportFormSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGcpDocumentationAndSupportFormSectionMutation, { data, loading, error }] = useUpdateGcpDocumentationAndSupportFormSectionMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateGcpDocumentationAndSupportFormSectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGcpDocumentationAndSupportFormSectionMutation, UpdateGcpDocumentationAndSupportFormSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGcpDocumentationAndSupportFormSectionMutation, UpdateGcpDocumentationAndSupportFormSectionMutationVariables>(UpdateGcpDocumentationAndSupportFormSectionDocument, options);
      }
export type UpdateGcpDocumentationAndSupportFormSectionMutationHookResult = ReturnType<typeof useUpdateGcpDocumentationAndSupportFormSectionMutation>;
export type UpdateGcpDocumentationAndSupportFormSectionMutationResult = Apollo.MutationResult<UpdateGcpDocumentationAndSupportFormSectionMutation>;
export type UpdateGcpDocumentationAndSupportFormSectionMutationOptions = Apollo.BaseMutationOptions<UpdateGcpDocumentationAndSupportFormSectionMutation, UpdateGcpDocumentationAndSupportFormSectionMutationVariables>;
export const GcpGeneralInformationFormSectionDocument = gql`
    query GcpGeneralInformationFormSection($id: ID!) {
  gcpListing(id: $id) {
    id
    status
    logo
    name
    short_description
  }
}
    `;

/**
 * __useGcpGeneralInformationFormSectionQuery__
 *
 * To run a query within a React component, call `useGcpGeneralInformationFormSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGcpGeneralInformationFormSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGcpGeneralInformationFormSectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGcpGeneralInformationFormSectionQuery(baseOptions: Apollo.QueryHookOptions<GcpGeneralInformationFormSectionQuery, GcpGeneralInformationFormSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GcpGeneralInformationFormSectionQuery, GcpGeneralInformationFormSectionQueryVariables>(GcpGeneralInformationFormSectionDocument, options);
      }
export function useGcpGeneralInformationFormSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GcpGeneralInformationFormSectionQuery, GcpGeneralInformationFormSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GcpGeneralInformationFormSectionQuery, GcpGeneralInformationFormSectionQueryVariables>(GcpGeneralInformationFormSectionDocument, options);
        }
export type GcpGeneralInformationFormSectionQueryHookResult = ReturnType<typeof useGcpGeneralInformationFormSectionQuery>;
export type GcpGeneralInformationFormSectionLazyQueryHookResult = ReturnType<typeof useGcpGeneralInformationFormSectionLazyQuery>;
export type GcpGeneralInformationFormSectionQueryResult = Apollo.QueryResult<GcpGeneralInformationFormSectionQuery, GcpGeneralInformationFormSectionQueryVariables>;
export const UpdateGcpGeneralInformationFormSectionDocument = gql`
    mutation UpdateGcpGeneralInformationFormSection($updates: GcpListingInput!) {
  updateGcpListing(updates: $updates) {
    id
    status
    logo
    name
    short_description
  }
}
    `;
export type UpdateGcpGeneralInformationFormSectionMutationFn = Apollo.MutationFunction<UpdateGcpGeneralInformationFormSectionMutation, UpdateGcpGeneralInformationFormSectionMutationVariables>;

/**
 * __useUpdateGcpGeneralInformationFormSectionMutation__
 *
 * To run a mutation, you first call `useUpdateGcpGeneralInformationFormSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGcpGeneralInformationFormSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGcpGeneralInformationFormSectionMutation, { data, loading, error }] = useUpdateGcpGeneralInformationFormSectionMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateGcpGeneralInformationFormSectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGcpGeneralInformationFormSectionMutation, UpdateGcpGeneralInformationFormSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGcpGeneralInformationFormSectionMutation, UpdateGcpGeneralInformationFormSectionMutationVariables>(UpdateGcpGeneralInformationFormSectionDocument, options);
      }
export type UpdateGcpGeneralInformationFormSectionMutationHookResult = ReturnType<typeof useUpdateGcpGeneralInformationFormSectionMutation>;
export type UpdateGcpGeneralInformationFormSectionMutationResult = Apollo.MutationResult<UpdateGcpGeneralInformationFormSectionMutation>;
export type UpdateGcpGeneralInformationFormSectionMutationOptions = Apollo.BaseMutationOptions<UpdateGcpGeneralInformationFormSectionMutation, UpdateGcpGeneralInformationFormSectionMutationVariables>;
export const GcpLegalAndTaxFormSectionDocument = gql`
    query GcpLegalAndTaxFormSection($id: ID!) {
  gcpListing(id: $id) {
    id
    status
    eula_url
    license_agreements {
      title
      url
    }
    tax_category
    tax_witholding
  }
}
    `;

/**
 * __useGcpLegalAndTaxFormSectionQuery__
 *
 * To run a query within a React component, call `useGcpLegalAndTaxFormSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGcpLegalAndTaxFormSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGcpLegalAndTaxFormSectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGcpLegalAndTaxFormSectionQuery(baseOptions: Apollo.QueryHookOptions<GcpLegalAndTaxFormSectionQuery, GcpLegalAndTaxFormSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GcpLegalAndTaxFormSectionQuery, GcpLegalAndTaxFormSectionQueryVariables>(GcpLegalAndTaxFormSectionDocument, options);
      }
export function useGcpLegalAndTaxFormSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GcpLegalAndTaxFormSectionQuery, GcpLegalAndTaxFormSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GcpLegalAndTaxFormSectionQuery, GcpLegalAndTaxFormSectionQueryVariables>(GcpLegalAndTaxFormSectionDocument, options);
        }
export type GcpLegalAndTaxFormSectionQueryHookResult = ReturnType<typeof useGcpLegalAndTaxFormSectionQuery>;
export type GcpLegalAndTaxFormSectionLazyQueryHookResult = ReturnType<typeof useGcpLegalAndTaxFormSectionLazyQuery>;
export type GcpLegalAndTaxFormSectionQueryResult = Apollo.QueryResult<GcpLegalAndTaxFormSectionQuery, GcpLegalAndTaxFormSectionQueryVariables>;
export const UpdateGcpLegalAndTaxFormSectionDocument = gql`
    mutation UpdateGcpLegalAndTaxFormSection($updates: GcpListingInput!) {
  updateGcpListing(updates: $updates) {
    id
    status
    eula_url
    license_agreements {
      title
      url
    }
    tax_category
    tax_witholding
  }
}
    `;
export type UpdateGcpLegalAndTaxFormSectionMutationFn = Apollo.MutationFunction<UpdateGcpLegalAndTaxFormSectionMutation, UpdateGcpLegalAndTaxFormSectionMutationVariables>;

/**
 * __useUpdateGcpLegalAndTaxFormSectionMutation__
 *
 * To run a mutation, you first call `useUpdateGcpLegalAndTaxFormSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGcpLegalAndTaxFormSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGcpLegalAndTaxFormSectionMutation, { data, loading, error }] = useUpdateGcpLegalAndTaxFormSectionMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateGcpLegalAndTaxFormSectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGcpLegalAndTaxFormSectionMutation, UpdateGcpLegalAndTaxFormSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGcpLegalAndTaxFormSectionMutation, UpdateGcpLegalAndTaxFormSectionMutationVariables>(UpdateGcpLegalAndTaxFormSectionDocument, options);
      }
export type UpdateGcpLegalAndTaxFormSectionMutationHookResult = ReturnType<typeof useUpdateGcpLegalAndTaxFormSectionMutation>;
export type UpdateGcpLegalAndTaxFormSectionMutationResult = Apollo.MutationResult<UpdateGcpLegalAndTaxFormSectionMutation>;
export type UpdateGcpLegalAndTaxFormSectionMutationOptions = Apollo.BaseMutationOptions<UpdateGcpLegalAndTaxFormSectionMutation, UpdateGcpLegalAndTaxFormSectionMutationVariables>;
export const GcpListingDocument = gql`
    query GcpListing($id: ID!) {
  currentUser {
    id
    isSuperAdmin
  }
  gcpListing(id: $id) {
    id
    name
    vendorid
    marketplace_id
    marketplace_url
    status
    dimensions {
      meterable
    }
    viewed_advanced_tab
    registration_hosting
    revision_of_listing {
      id
      name
    }
  }
}
    `;

/**
 * __useGcpListingQuery__
 *
 * To run a query within a React component, call `useGcpListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGcpListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGcpListingQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGcpListingQuery(baseOptions: Apollo.QueryHookOptions<GcpListingQuery, GcpListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GcpListingQuery, GcpListingQueryVariables>(GcpListingDocument, options);
      }
export function useGcpListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GcpListingQuery, GcpListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GcpListingQuery, GcpListingQueryVariables>(GcpListingDocument, options);
        }
export type GcpListingQueryHookResult = ReturnType<typeof useGcpListingQuery>;
export type GcpListingLazyQueryHookResult = ReturnType<typeof useGcpListingLazyQuery>;
export type GcpListingQueryResult = Apollo.QueryResult<GcpListingQuery, GcpListingQueryVariables>;
export const SubmitGcpListingForReviewDocument = gql`
    mutation submitGcpListingForReview($id: ID!) {
  submitGcpListingForReview(id: $id) {
    id
    status
  }
}
    `;
export type SubmitGcpListingForReviewMutationFn = Apollo.MutationFunction<SubmitGcpListingForReviewMutation, SubmitGcpListingForReviewMutationVariables>;

/**
 * __useSubmitGcpListingForReviewMutation__
 *
 * To run a mutation, you first call `useSubmitGcpListingForReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitGcpListingForReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitGcpListingForReviewMutation, { data, loading, error }] = useSubmitGcpListingForReviewMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSubmitGcpListingForReviewMutation(baseOptions?: Apollo.MutationHookOptions<SubmitGcpListingForReviewMutation, SubmitGcpListingForReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitGcpListingForReviewMutation, SubmitGcpListingForReviewMutationVariables>(SubmitGcpListingForReviewDocument, options);
      }
export type SubmitGcpListingForReviewMutationHookResult = ReturnType<typeof useSubmitGcpListingForReviewMutation>;
export type SubmitGcpListingForReviewMutationResult = Apollo.MutationResult<SubmitGcpListingForReviewMutation>;
export type SubmitGcpListingForReviewMutationOptions = Apollo.BaseMutationOptions<SubmitGcpListingForReviewMutation, SubmitGcpListingForReviewMutationVariables>;
export const GcpListingAdvancedDocument = gql`
    query GcpListingAdvanced($id: ID!) {
  gcpListing(id: $id) {
    id
    viewed_advanced_tab
    status
  }
}
    `;

/**
 * __useGcpListingAdvancedQuery__
 *
 * To run a query within a React component, call `useGcpListingAdvancedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGcpListingAdvancedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGcpListingAdvancedQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGcpListingAdvancedQuery(baseOptions: Apollo.QueryHookOptions<GcpListingAdvancedQuery, GcpListingAdvancedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GcpListingAdvancedQuery, GcpListingAdvancedQueryVariables>(GcpListingAdvancedDocument, options);
      }
export function useGcpListingAdvancedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GcpListingAdvancedQuery, GcpListingAdvancedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GcpListingAdvancedQuery, GcpListingAdvancedQueryVariables>(GcpListingAdvancedDocument, options);
        }
export type GcpListingAdvancedQueryHookResult = ReturnType<typeof useGcpListingAdvancedQuery>;
export type GcpListingAdvancedLazyQueryHookResult = ReturnType<typeof useGcpListingAdvancedLazyQuery>;
export type GcpListingAdvancedQueryResult = Apollo.QueryResult<GcpListingAdvancedQuery, GcpListingAdvancedQueryVariables>;
export const UpdateGcpListingAdvancedDocument = gql`
    mutation updateGcpListingAdvanced($updates: GcpListingInput!) {
  updateGcpListing(updates: $updates) {
    id
    viewed_advanced_tab
  }
}
    `;
export type UpdateGcpListingAdvancedMutationFn = Apollo.MutationFunction<UpdateGcpListingAdvancedMutation, UpdateGcpListingAdvancedMutationVariables>;

/**
 * __useUpdateGcpListingAdvancedMutation__
 *
 * To run a mutation, you first call `useUpdateGcpListingAdvancedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGcpListingAdvancedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGcpListingAdvancedMutation, { data, loading, error }] = useUpdateGcpListingAdvancedMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateGcpListingAdvancedMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGcpListingAdvancedMutation, UpdateGcpListingAdvancedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGcpListingAdvancedMutation, UpdateGcpListingAdvancedMutationVariables>(UpdateGcpListingAdvancedDocument, options);
      }
export type UpdateGcpListingAdvancedMutationHookResult = ReturnType<typeof useUpdateGcpListingAdvancedMutation>;
export type UpdateGcpListingAdvancedMutationResult = Apollo.MutationResult<UpdateGcpListingAdvancedMutation>;
export type UpdateGcpListingAdvancedMutationOptions = Apollo.BaseMutationOptions<UpdateGcpListingAdvancedMutation, UpdateGcpListingAdvancedMutationVariables>;
export const GcpListingPreviewDocument = gql`
    query GcpListingPreview($id: ID!) {
  gcpListing(id: $id) {
    support_url
    support_description
    name
    logo
    short_description
    vendor {
      id
      name
    }
    plans {
      plan_id
      pricing
      name
      public
      feature_ids
    }
    metrics_pricing {
      name
      unit
      price_per_unit {
        price
        plan_id
      }
    }
    eula_url
    overview_url
    full_description
    categories
    documentation {
      url
      resource_type
      description
    }
    features {
      label
      feature_id
      description
    }
  }
}
    `;

/**
 * __useGcpListingPreviewQuery__
 *
 * To run a query within a React component, call `useGcpListingPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGcpListingPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGcpListingPreviewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGcpListingPreviewQuery(baseOptions: Apollo.QueryHookOptions<GcpListingPreviewQuery, GcpListingPreviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GcpListingPreviewQuery, GcpListingPreviewQueryVariables>(GcpListingPreviewDocument, options);
      }
export function useGcpListingPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GcpListingPreviewQuery, GcpListingPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GcpListingPreviewQuery, GcpListingPreviewQueryVariables>(GcpListingPreviewDocument, options);
        }
export type GcpListingPreviewQueryHookResult = ReturnType<typeof useGcpListingPreviewQuery>;
export type GcpListingPreviewLazyQueryHookResult = ReturnType<typeof useGcpListingPreviewLazyQuery>;
export type GcpListingPreviewQueryResult = Apollo.QueryResult<GcpListingPreviewQuery, GcpListingPreviewQueryVariables>;
export const GcpListingSideBarDocument = gql`
    query GcpListingSideBar($id: ID!) {
  gcpListing(id: $id) {
    status
    id
    revision_of_product_id_internal
    name
    marketplace_url
    vendorid
    marketplace_id
    listing_type
    registration_hosting
  }
}
    `;

/**
 * __useGcpListingSideBarQuery__
 *
 * To run a query within a React component, call `useGcpListingSideBarQuery` and pass it any options that fit your needs.
 * When your component renders, `useGcpListingSideBarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGcpListingSideBarQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGcpListingSideBarQuery(baseOptions: Apollo.QueryHookOptions<GcpListingSideBarQuery, GcpListingSideBarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GcpListingSideBarQuery, GcpListingSideBarQueryVariables>(GcpListingSideBarDocument, options);
      }
export function useGcpListingSideBarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GcpListingSideBarQuery, GcpListingSideBarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GcpListingSideBarQuery, GcpListingSideBarQueryVariables>(GcpListingSideBarDocument, options);
        }
export type GcpListingSideBarQueryHookResult = ReturnType<typeof useGcpListingSideBarQuery>;
export type GcpListingSideBarLazyQueryHookResult = ReturnType<typeof useGcpListingSideBarLazyQuery>;
export type GcpListingSideBarQueryResult = Apollo.QueryResult<GcpListingSideBarQuery, GcpListingSideBarQueryVariables>;
export const GcpListingSideBarCopyGcpListingDocument = gql`
    mutation GcpListingSideBarCopyGcpListing($id: ID!) {
  copyGcpListing(id: $id) {
    id
  }
}
    `;
export type GcpListingSideBarCopyGcpListingMutationFn = Apollo.MutationFunction<GcpListingSideBarCopyGcpListingMutation, GcpListingSideBarCopyGcpListingMutationVariables>;

/**
 * __useGcpListingSideBarCopyGcpListingMutation__
 *
 * To run a mutation, you first call `useGcpListingSideBarCopyGcpListingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGcpListingSideBarCopyGcpListingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [gcpListingSideBarCopyGcpListingMutation, { data, loading, error }] = useGcpListingSideBarCopyGcpListingMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGcpListingSideBarCopyGcpListingMutation(baseOptions?: Apollo.MutationHookOptions<GcpListingSideBarCopyGcpListingMutation, GcpListingSideBarCopyGcpListingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GcpListingSideBarCopyGcpListingMutation, GcpListingSideBarCopyGcpListingMutationVariables>(GcpListingSideBarCopyGcpListingDocument, options);
      }
export type GcpListingSideBarCopyGcpListingMutationHookResult = ReturnType<typeof useGcpListingSideBarCopyGcpListingMutation>;
export type GcpListingSideBarCopyGcpListingMutationResult = Apollo.MutationResult<GcpListingSideBarCopyGcpListingMutation>;
export type GcpListingSideBarCopyGcpListingMutationOptions = Apollo.BaseMutationOptions<GcpListingSideBarCopyGcpListingMutation, GcpListingSideBarCopyGcpListingMutationVariables>;
export const GcpListingSideBarSubmitGcpListingDocument = gql`
    mutation GcpListingSideBarSubmitGcpListing($id: ID!) {
  submitGcpListingForReview(id: $id) {
    id
    status
  }
}
    `;
export type GcpListingSideBarSubmitGcpListingMutationFn = Apollo.MutationFunction<GcpListingSideBarSubmitGcpListingMutation, GcpListingSideBarSubmitGcpListingMutationVariables>;

/**
 * __useGcpListingSideBarSubmitGcpListingMutation__
 *
 * To run a mutation, you first call `useGcpListingSideBarSubmitGcpListingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGcpListingSideBarSubmitGcpListingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [gcpListingSideBarSubmitGcpListingMutation, { data, loading, error }] = useGcpListingSideBarSubmitGcpListingMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGcpListingSideBarSubmitGcpListingMutation(baseOptions?: Apollo.MutationHookOptions<GcpListingSideBarSubmitGcpListingMutation, GcpListingSideBarSubmitGcpListingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GcpListingSideBarSubmitGcpListingMutation, GcpListingSideBarSubmitGcpListingMutationVariables>(GcpListingSideBarSubmitGcpListingDocument, options);
      }
export type GcpListingSideBarSubmitGcpListingMutationHookResult = ReturnType<typeof useGcpListingSideBarSubmitGcpListingMutation>;
export type GcpListingSideBarSubmitGcpListingMutationResult = Apollo.MutationResult<GcpListingSideBarSubmitGcpListingMutation>;
export type GcpListingSideBarSubmitGcpListingMutationOptions = Apollo.BaseMutationOptions<GcpListingSideBarSubmitGcpListingMutation, GcpListingSideBarSubmitGcpListingMutationVariables>;
export const GcpListingSideBarDeleteGcpListingDocument = gql`
    mutation GcpListingSideBarDeleteGcpListing($id: ID!) {
  deleteGcpListing(id: $id)
}
    `;
export type GcpListingSideBarDeleteGcpListingMutationFn = Apollo.MutationFunction<GcpListingSideBarDeleteGcpListingMutation, GcpListingSideBarDeleteGcpListingMutationVariables>;

/**
 * __useGcpListingSideBarDeleteGcpListingMutation__
 *
 * To run a mutation, you first call `useGcpListingSideBarDeleteGcpListingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGcpListingSideBarDeleteGcpListingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [gcpListingSideBarDeleteGcpListingMutation, { data, loading, error }] = useGcpListingSideBarDeleteGcpListingMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGcpListingSideBarDeleteGcpListingMutation(baseOptions?: Apollo.MutationHookOptions<GcpListingSideBarDeleteGcpListingMutation, GcpListingSideBarDeleteGcpListingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GcpListingSideBarDeleteGcpListingMutation, GcpListingSideBarDeleteGcpListingMutationVariables>(GcpListingSideBarDeleteGcpListingDocument, options);
      }
export type GcpListingSideBarDeleteGcpListingMutationHookResult = ReturnType<typeof useGcpListingSideBarDeleteGcpListingMutation>;
export type GcpListingSideBarDeleteGcpListingMutationResult = Apollo.MutationResult<GcpListingSideBarDeleteGcpListingMutation>;
export type GcpListingSideBarDeleteGcpListingMutationOptions = Apollo.BaseMutationOptions<GcpListingSideBarDeleteGcpListingMutation, GcpListingSideBarDeleteGcpListingMutationVariables>;
export const GcpMetricsFormSectionDocument = gql`
    query GcpMetricsFormSection($id: ID!) {
  gcpListing(id: $id) {
    id
    status
    metrics_pricing {
      name
      unit
      price_per_unit {
        price
        plan_id
      }
    }
    plans {
      name
      plan_id
    }
  }
}
    `;

/**
 * __useGcpMetricsFormSectionQuery__
 *
 * To run a query within a React component, call `useGcpMetricsFormSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGcpMetricsFormSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGcpMetricsFormSectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGcpMetricsFormSectionQuery(baseOptions: Apollo.QueryHookOptions<GcpMetricsFormSectionQuery, GcpMetricsFormSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GcpMetricsFormSectionQuery, GcpMetricsFormSectionQueryVariables>(GcpMetricsFormSectionDocument, options);
      }
export function useGcpMetricsFormSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GcpMetricsFormSectionQuery, GcpMetricsFormSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GcpMetricsFormSectionQuery, GcpMetricsFormSectionQueryVariables>(GcpMetricsFormSectionDocument, options);
        }
export type GcpMetricsFormSectionQueryHookResult = ReturnType<typeof useGcpMetricsFormSectionQuery>;
export type GcpMetricsFormSectionLazyQueryHookResult = ReturnType<typeof useGcpMetricsFormSectionLazyQuery>;
export type GcpMetricsFormSectionQueryResult = Apollo.QueryResult<GcpMetricsFormSectionQuery, GcpMetricsFormSectionQueryVariables>;
export const UpdateGcpMetricsFormSectionDocument = gql`
    mutation UpdateGcpMetricsFormSection($updates: GcpListingInput!) {
  updateGcpListing(updates: $updates) {
    id
    status
    metrics_pricing {
      name
      unit
      price_per_unit {
        price
        plan_id
      }
    }
  }
}
    `;
export type UpdateGcpMetricsFormSectionMutationFn = Apollo.MutationFunction<UpdateGcpMetricsFormSectionMutation, UpdateGcpMetricsFormSectionMutationVariables>;

/**
 * __useUpdateGcpMetricsFormSectionMutation__
 *
 * To run a mutation, you first call `useUpdateGcpMetricsFormSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGcpMetricsFormSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGcpMetricsFormSectionMutation, { data, loading, error }] = useUpdateGcpMetricsFormSectionMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateGcpMetricsFormSectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGcpMetricsFormSectionMutation, UpdateGcpMetricsFormSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGcpMetricsFormSectionMutation, UpdateGcpMetricsFormSectionMutationVariables>(UpdateGcpMetricsFormSectionDocument, options);
      }
export type UpdateGcpMetricsFormSectionMutationHookResult = ReturnType<typeof useUpdateGcpMetricsFormSectionMutation>;
export type UpdateGcpMetricsFormSectionMutationResult = Apollo.MutationResult<UpdateGcpMetricsFormSectionMutation>;
export type UpdateGcpMetricsFormSectionMutationOptions = Apollo.BaseMutationOptions<UpdateGcpMetricsFormSectionMutation, UpdateGcpMetricsFormSectionMutationVariables>;
export const GcpProductOverviewFormSectionDocument = gql`
    query GcpProductOverviewFormSection($id: ID!) {
  gcpListing(id: $id) {
    id
    status
    categories
    full_description
    overview_url
  }
}
    `;

/**
 * __useGcpProductOverviewFormSectionQuery__
 *
 * To run a query within a React component, call `useGcpProductOverviewFormSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGcpProductOverviewFormSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGcpProductOverviewFormSectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGcpProductOverviewFormSectionQuery(baseOptions: Apollo.QueryHookOptions<GcpProductOverviewFormSectionQuery, GcpProductOverviewFormSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GcpProductOverviewFormSectionQuery, GcpProductOverviewFormSectionQueryVariables>(GcpProductOverviewFormSectionDocument, options);
      }
export function useGcpProductOverviewFormSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GcpProductOverviewFormSectionQuery, GcpProductOverviewFormSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GcpProductOverviewFormSectionQuery, GcpProductOverviewFormSectionQueryVariables>(GcpProductOverviewFormSectionDocument, options);
        }
export type GcpProductOverviewFormSectionQueryHookResult = ReturnType<typeof useGcpProductOverviewFormSectionQuery>;
export type GcpProductOverviewFormSectionLazyQueryHookResult = ReturnType<typeof useGcpProductOverviewFormSectionLazyQuery>;
export type GcpProductOverviewFormSectionQueryResult = Apollo.QueryResult<GcpProductOverviewFormSectionQuery, GcpProductOverviewFormSectionQueryVariables>;
export const UpdateGcpProductOverviewFormSectionDocument = gql`
    mutation UpdateGcpProductOverviewFormSection($updates: GcpListingInput!) {
  updateGcpListing(updates: $updates) {
    id
    status
    categories
    full_description
    overview_url
  }
}
    `;
export type UpdateGcpProductOverviewFormSectionMutationFn = Apollo.MutationFunction<UpdateGcpProductOverviewFormSectionMutation, UpdateGcpProductOverviewFormSectionMutationVariables>;

/**
 * __useUpdateGcpProductOverviewFormSectionMutation__
 *
 * To run a mutation, you first call `useUpdateGcpProductOverviewFormSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGcpProductOverviewFormSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGcpProductOverviewFormSectionMutation, { data, loading, error }] = useUpdateGcpProductOverviewFormSectionMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateGcpProductOverviewFormSectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGcpProductOverviewFormSectionMutation, UpdateGcpProductOverviewFormSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGcpProductOverviewFormSectionMutation, UpdateGcpProductOverviewFormSectionMutationVariables>(UpdateGcpProductOverviewFormSectionDocument, options);
      }
export type UpdateGcpProductOverviewFormSectionMutationHookResult = ReturnType<typeof useUpdateGcpProductOverviewFormSectionMutation>;
export type UpdateGcpProductOverviewFormSectionMutationResult = Apollo.MutationResult<UpdateGcpProductOverviewFormSectionMutation>;
export type UpdateGcpProductOverviewFormSectionMutationOptions = Apollo.BaseMutationOptions<UpdateGcpProductOverviewFormSectionMutation, UpdateGcpProductOverviewFormSectionMutationVariables>;
export const GcpSearchKeywordsFormSectionDocument = gql`
    query GcpSearchKeywordsFormSection($id: ID!) {
  gcpListing(id: $id) {
    id
    status
    metadata_keywords
    search_keywords
  }
}
    `;

/**
 * __useGcpSearchKeywordsFormSectionQuery__
 *
 * To run a query within a React component, call `useGcpSearchKeywordsFormSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGcpSearchKeywordsFormSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGcpSearchKeywordsFormSectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGcpSearchKeywordsFormSectionQuery(baseOptions: Apollo.QueryHookOptions<GcpSearchKeywordsFormSectionQuery, GcpSearchKeywordsFormSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GcpSearchKeywordsFormSectionQuery, GcpSearchKeywordsFormSectionQueryVariables>(GcpSearchKeywordsFormSectionDocument, options);
      }
export function useGcpSearchKeywordsFormSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GcpSearchKeywordsFormSectionQuery, GcpSearchKeywordsFormSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GcpSearchKeywordsFormSectionQuery, GcpSearchKeywordsFormSectionQueryVariables>(GcpSearchKeywordsFormSectionDocument, options);
        }
export type GcpSearchKeywordsFormSectionQueryHookResult = ReturnType<typeof useGcpSearchKeywordsFormSectionQuery>;
export type GcpSearchKeywordsFormSectionLazyQueryHookResult = ReturnType<typeof useGcpSearchKeywordsFormSectionLazyQuery>;
export type GcpSearchKeywordsFormSectionQueryResult = Apollo.QueryResult<GcpSearchKeywordsFormSectionQuery, GcpSearchKeywordsFormSectionQueryVariables>;
export const UpdateGcpSearchKeywordsFormSectionDocument = gql`
    mutation UpdateGcpSearchKeywordsFormSection($updates: GcpListingInput!) {
  updateGcpListing(updates: $updates) {
    id
    status
    metadata_keywords
    search_keywords
  }
}
    `;
export type UpdateGcpSearchKeywordsFormSectionMutationFn = Apollo.MutationFunction<UpdateGcpSearchKeywordsFormSectionMutation, UpdateGcpSearchKeywordsFormSectionMutationVariables>;

/**
 * __useUpdateGcpSearchKeywordsFormSectionMutation__
 *
 * To run a mutation, you first call `useUpdateGcpSearchKeywordsFormSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGcpSearchKeywordsFormSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGcpSearchKeywordsFormSectionMutation, { data, loading, error }] = useUpdateGcpSearchKeywordsFormSectionMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateGcpSearchKeywordsFormSectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGcpSearchKeywordsFormSectionMutation, UpdateGcpSearchKeywordsFormSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGcpSearchKeywordsFormSectionMutation, UpdateGcpSearchKeywordsFormSectionMutationVariables>(UpdateGcpSearchKeywordsFormSectionDocument, options);
      }
export type UpdateGcpSearchKeywordsFormSectionMutationHookResult = ReturnType<typeof useUpdateGcpSearchKeywordsFormSectionMutation>;
export type UpdateGcpSearchKeywordsFormSectionMutationResult = Apollo.MutationResult<UpdateGcpSearchKeywordsFormSectionMutation>;
export type UpdateGcpSearchKeywordsFormSectionMutationOptions = Apollo.BaseMutationOptions<UpdateGcpSearchKeywordsFormSectionMutation, UpdateGcpSearchKeywordsFormSectionMutationVariables>;
export const GcpSyncWithSalesforceFormSectionDocument = gql`
    query GcpSyncWithSalesforceFormSection($id: ID!) {
  gcpListing(id: $id) {
    id
    should_sync_listing_to_salesforce_app
  }
}
    `;

/**
 * __useGcpSyncWithSalesforceFormSectionQuery__
 *
 * To run a query within a React component, call `useGcpSyncWithSalesforceFormSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGcpSyncWithSalesforceFormSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGcpSyncWithSalesforceFormSectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGcpSyncWithSalesforceFormSectionQuery(baseOptions: Apollo.QueryHookOptions<GcpSyncWithSalesforceFormSectionQuery, GcpSyncWithSalesforceFormSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GcpSyncWithSalesforceFormSectionQuery, GcpSyncWithSalesforceFormSectionQueryVariables>(GcpSyncWithSalesforceFormSectionDocument, options);
      }
export function useGcpSyncWithSalesforceFormSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GcpSyncWithSalesforceFormSectionQuery, GcpSyncWithSalesforceFormSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GcpSyncWithSalesforceFormSectionQuery, GcpSyncWithSalesforceFormSectionQueryVariables>(GcpSyncWithSalesforceFormSectionDocument, options);
        }
export type GcpSyncWithSalesforceFormSectionQueryHookResult = ReturnType<typeof useGcpSyncWithSalesforceFormSectionQuery>;
export type GcpSyncWithSalesforceFormSectionLazyQueryHookResult = ReturnType<typeof useGcpSyncWithSalesforceFormSectionLazyQuery>;
export type GcpSyncWithSalesforceFormSectionQueryResult = Apollo.QueryResult<GcpSyncWithSalesforceFormSectionQuery, GcpSyncWithSalesforceFormSectionQueryVariables>;
export const UpdateGcpShouldSyncListingToSalesforceAppDocument = gql`
    mutation UpdateGcpShouldSyncListingToSalesforceApp($updates: GcpListingInput!) {
  updateGcpListing(updates: $updates) {
    id
    should_sync_listing_to_salesforce_app
  }
}
    `;
export type UpdateGcpShouldSyncListingToSalesforceAppMutationFn = Apollo.MutationFunction<UpdateGcpShouldSyncListingToSalesforceAppMutation, UpdateGcpShouldSyncListingToSalesforceAppMutationVariables>;

/**
 * __useUpdateGcpShouldSyncListingToSalesforceAppMutation__
 *
 * To run a mutation, you first call `useUpdateGcpShouldSyncListingToSalesforceAppMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGcpShouldSyncListingToSalesforceAppMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGcpShouldSyncListingToSalesforceAppMutation, { data, loading, error }] = useUpdateGcpShouldSyncListingToSalesforceAppMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateGcpShouldSyncListingToSalesforceAppMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGcpShouldSyncListingToSalesforceAppMutation, UpdateGcpShouldSyncListingToSalesforceAppMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGcpShouldSyncListingToSalesforceAppMutation, UpdateGcpShouldSyncListingToSalesforceAppMutationVariables>(UpdateGcpShouldSyncListingToSalesforceAppDocument, options);
      }
export type UpdateGcpShouldSyncListingToSalesforceAppMutationHookResult = ReturnType<typeof useUpdateGcpShouldSyncListingToSalesforceAppMutation>;
export type UpdateGcpShouldSyncListingToSalesforceAppMutationResult = Apollo.MutationResult<UpdateGcpShouldSyncListingToSalesforceAppMutation>;
export type UpdateGcpShouldSyncListingToSalesforceAppMutationOptions = Apollo.BaseMutationOptions<UpdateGcpShouldSyncListingToSalesforceAppMutation, UpdateGcpShouldSyncListingToSalesforceAppMutationVariables>;
export const GcpTechnicalSetupFormSectionDocument = gql`
    query GcpTechnicalSetupFormSection($id: ID!) {
  gcpListing(id: $id) {
    id
    status
    solution_id
    dashboard_url
  }
}
    `;

/**
 * __useGcpTechnicalSetupFormSectionQuery__
 *
 * To run a query within a React component, call `useGcpTechnicalSetupFormSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGcpTechnicalSetupFormSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGcpTechnicalSetupFormSectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGcpTechnicalSetupFormSectionQuery(baseOptions: Apollo.QueryHookOptions<GcpTechnicalSetupFormSectionQuery, GcpTechnicalSetupFormSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GcpTechnicalSetupFormSectionQuery, GcpTechnicalSetupFormSectionQueryVariables>(GcpTechnicalSetupFormSectionDocument, options);
      }
export function useGcpTechnicalSetupFormSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GcpTechnicalSetupFormSectionQuery, GcpTechnicalSetupFormSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GcpTechnicalSetupFormSectionQuery, GcpTechnicalSetupFormSectionQueryVariables>(GcpTechnicalSetupFormSectionDocument, options);
        }
export type GcpTechnicalSetupFormSectionQueryHookResult = ReturnType<typeof useGcpTechnicalSetupFormSectionQuery>;
export type GcpTechnicalSetupFormSectionLazyQueryHookResult = ReturnType<typeof useGcpTechnicalSetupFormSectionLazyQuery>;
export type GcpTechnicalSetupFormSectionQueryResult = Apollo.QueryResult<GcpTechnicalSetupFormSectionQuery, GcpTechnicalSetupFormSectionQueryVariables>;
export const UpdateGcpTechnicalSetupFormSectionDocument = gql`
    mutation UpdateGcpTechnicalSetupFormSection($updates: GcpListingInput!) {
  updateGcpListing(updates: $updates) {
    id
    status
    solution_id
    dashboard_url
  }
}
    `;
export type UpdateGcpTechnicalSetupFormSectionMutationFn = Apollo.MutationFunction<UpdateGcpTechnicalSetupFormSectionMutation, UpdateGcpTechnicalSetupFormSectionMutationVariables>;

/**
 * __useUpdateGcpTechnicalSetupFormSectionMutation__
 *
 * To run a mutation, you first call `useUpdateGcpTechnicalSetupFormSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGcpTechnicalSetupFormSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGcpTechnicalSetupFormSectionMutation, { data, loading, error }] = useUpdateGcpTechnicalSetupFormSectionMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateGcpTechnicalSetupFormSectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGcpTechnicalSetupFormSectionMutation, UpdateGcpTechnicalSetupFormSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGcpTechnicalSetupFormSectionMutation, UpdateGcpTechnicalSetupFormSectionMutationVariables>(UpdateGcpTechnicalSetupFormSectionDocument, options);
      }
export type UpdateGcpTechnicalSetupFormSectionMutationHookResult = ReturnType<typeof useUpdateGcpTechnicalSetupFormSectionMutation>;
export type UpdateGcpTechnicalSetupFormSectionMutationResult = Apollo.MutationResult<UpdateGcpTechnicalSetupFormSectionMutation>;
export type UpdateGcpTechnicalSetupFormSectionMutationOptions = Apollo.BaseMutationOptions<UpdateGcpTechnicalSetupFormSectionMutation, UpdateGcpTechnicalSetupFormSectionMutationVariables>;
export const GcpRegistrationFieldsFormSectionDocument = gql`
    query GcpRegistrationFieldsFormSection($id: ID!) {
  gcpListing(id: $id) {
    id
    registration_page_fields {
      data_type
      default
      display_title
      enabled
      options {
        label
        value
      }
      required
      tackle_required
      title
      validation_type
    }
  }
}
    `;

/**
 * __useGcpRegistrationFieldsFormSectionQuery__
 *
 * To run a query within a React component, call `useGcpRegistrationFieldsFormSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGcpRegistrationFieldsFormSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGcpRegistrationFieldsFormSectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGcpRegistrationFieldsFormSectionQuery(baseOptions: Apollo.QueryHookOptions<GcpRegistrationFieldsFormSectionQuery, GcpRegistrationFieldsFormSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GcpRegistrationFieldsFormSectionQuery, GcpRegistrationFieldsFormSectionQueryVariables>(GcpRegistrationFieldsFormSectionDocument, options);
      }
export function useGcpRegistrationFieldsFormSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GcpRegistrationFieldsFormSectionQuery, GcpRegistrationFieldsFormSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GcpRegistrationFieldsFormSectionQuery, GcpRegistrationFieldsFormSectionQueryVariables>(GcpRegistrationFieldsFormSectionDocument, options);
        }
export type GcpRegistrationFieldsFormSectionQueryHookResult = ReturnType<typeof useGcpRegistrationFieldsFormSectionQuery>;
export type GcpRegistrationFieldsFormSectionLazyQueryHookResult = ReturnType<typeof useGcpRegistrationFieldsFormSectionLazyQuery>;
export type GcpRegistrationFieldsFormSectionQueryResult = Apollo.QueryResult<GcpRegistrationFieldsFormSectionQuery, GcpRegistrationFieldsFormSectionQueryVariables>;
export const UpdateGcpRegistrationFieldsFormSectionDocument = gql`
    mutation UpdateGcpRegistrationFieldsFormSection($updates: GcpListingInput!) {
  updateGcpListing(updates: $updates) {
    id
    registration_page_fields {
      data_type
      default
      display_title
      enabled
      options {
        label
        value
      }
      required
      tackle_required
      title
      validation_type
    }
  }
}
    `;
export type UpdateGcpRegistrationFieldsFormSectionMutationFn = Apollo.MutationFunction<UpdateGcpRegistrationFieldsFormSectionMutation, UpdateGcpRegistrationFieldsFormSectionMutationVariables>;

/**
 * __useUpdateGcpRegistrationFieldsFormSectionMutation__
 *
 * To run a mutation, you first call `useUpdateGcpRegistrationFieldsFormSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGcpRegistrationFieldsFormSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGcpRegistrationFieldsFormSectionMutation, { data, loading, error }] = useUpdateGcpRegistrationFieldsFormSectionMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateGcpRegistrationFieldsFormSectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGcpRegistrationFieldsFormSectionMutation, UpdateGcpRegistrationFieldsFormSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGcpRegistrationFieldsFormSectionMutation, UpdateGcpRegistrationFieldsFormSectionMutationVariables>(UpdateGcpRegistrationFieldsFormSectionDocument, options);
      }
export type UpdateGcpRegistrationFieldsFormSectionMutationHookResult = ReturnType<typeof useUpdateGcpRegistrationFieldsFormSectionMutation>;
export type UpdateGcpRegistrationFieldsFormSectionMutationResult = Apollo.MutationResult<UpdateGcpRegistrationFieldsFormSectionMutation>;
export type UpdateGcpRegistrationFieldsFormSectionMutationOptions = Apollo.BaseMutationOptions<UpdateGcpRegistrationFieldsFormSectionMutation, UpdateGcpRegistrationFieldsFormSectionMutationVariables>;
export const GcpListingRegistrationDocument = gql`
    query GcpListingRegistration($id: ID!) {
  gcpListing(id: $id) {
    id
    registration_hosting
  }
}
    `;

/**
 * __useGcpListingRegistrationQuery__
 *
 * To run a query within a React component, call `useGcpListingRegistrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGcpListingRegistrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGcpListingRegistrationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGcpListingRegistrationQuery(baseOptions: Apollo.QueryHookOptions<GcpListingRegistrationQuery, GcpListingRegistrationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GcpListingRegistrationQuery, GcpListingRegistrationQueryVariables>(GcpListingRegistrationDocument, options);
      }
export function useGcpListingRegistrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GcpListingRegistrationQuery, GcpListingRegistrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GcpListingRegistrationQuery, GcpListingRegistrationQueryVariables>(GcpListingRegistrationDocument, options);
        }
export type GcpListingRegistrationQueryHookResult = ReturnType<typeof useGcpListingRegistrationQuery>;
export type GcpListingRegistrationLazyQueryHookResult = ReturnType<typeof useGcpListingRegistrationLazyQuery>;
export type GcpListingRegistrationQueryResult = Apollo.QueryResult<GcpListingRegistrationQuery, GcpListingRegistrationQueryVariables>;
export const GcpRegistrationHostingFormSectionDocument = gql`
    query GcpRegistrationHostingFormSection($id: ID!) {
  gcpListing(id: $id) {
    id
    registration_hosting
    registration_redirect {
      url
      params
    }
  }
}
    `;

/**
 * __useGcpRegistrationHostingFormSectionQuery__
 *
 * To run a query within a React component, call `useGcpRegistrationHostingFormSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGcpRegistrationHostingFormSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGcpRegistrationHostingFormSectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGcpRegistrationHostingFormSectionQuery(baseOptions: Apollo.QueryHookOptions<GcpRegistrationHostingFormSectionQuery, GcpRegistrationHostingFormSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GcpRegistrationHostingFormSectionQuery, GcpRegistrationHostingFormSectionQueryVariables>(GcpRegistrationHostingFormSectionDocument, options);
      }
export function useGcpRegistrationHostingFormSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GcpRegistrationHostingFormSectionQuery, GcpRegistrationHostingFormSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GcpRegistrationHostingFormSectionQuery, GcpRegistrationHostingFormSectionQueryVariables>(GcpRegistrationHostingFormSectionDocument, options);
        }
export type GcpRegistrationHostingFormSectionQueryHookResult = ReturnType<typeof useGcpRegistrationHostingFormSectionQuery>;
export type GcpRegistrationHostingFormSectionLazyQueryHookResult = ReturnType<typeof useGcpRegistrationHostingFormSectionLazyQuery>;
export type GcpRegistrationHostingFormSectionQueryResult = Apollo.QueryResult<GcpRegistrationHostingFormSectionQuery, GcpRegistrationHostingFormSectionQueryVariables>;
export const UpdateGcpRegistrationHostingFormSectionDocument = gql`
    mutation UpdateGcpRegistrationHostingFormSection($updates: GcpListingInput!) {
  updateGcpListing(updates: $updates) {
    id
    registration_hosting
    registration_redirect {
      url
      params
    }
  }
}
    `;
export type UpdateGcpRegistrationHostingFormSectionMutationFn = Apollo.MutationFunction<UpdateGcpRegistrationHostingFormSectionMutation, UpdateGcpRegistrationHostingFormSectionMutationVariables>;

/**
 * __useUpdateGcpRegistrationHostingFormSectionMutation__
 *
 * To run a mutation, you first call `useUpdateGcpRegistrationHostingFormSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGcpRegistrationHostingFormSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGcpRegistrationHostingFormSectionMutation, { data, loading, error }] = useUpdateGcpRegistrationHostingFormSectionMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateGcpRegistrationHostingFormSectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGcpRegistrationHostingFormSectionMutation, UpdateGcpRegistrationHostingFormSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGcpRegistrationHostingFormSectionMutation, UpdateGcpRegistrationHostingFormSectionMutationVariables>(UpdateGcpRegistrationHostingFormSectionDocument, options);
      }
export type UpdateGcpRegistrationHostingFormSectionMutationHookResult = ReturnType<typeof useUpdateGcpRegistrationHostingFormSectionMutation>;
export type UpdateGcpRegistrationHostingFormSectionMutationResult = Apollo.MutationResult<UpdateGcpRegistrationHostingFormSectionMutation>;
export type UpdateGcpRegistrationHostingFormSectionMutationOptions = Apollo.BaseMutationOptions<UpdateGcpRegistrationHostingFormSectionMutation, UpdateGcpRegistrationHostingFormSectionMutationVariables>;
export const GcpRegistrationSuccessFormSectionDocument = gql`
    query GcpRegistrationSuccessFormSection($id: ID!) {
  gcpListing(id: $id) {
    id
    registration {
      success {
        message
        redirect_url
      }
    }
  }
}
    `;

/**
 * __useGcpRegistrationSuccessFormSectionQuery__
 *
 * To run a query within a React component, call `useGcpRegistrationSuccessFormSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGcpRegistrationSuccessFormSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGcpRegistrationSuccessFormSectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGcpRegistrationSuccessFormSectionQuery(baseOptions: Apollo.QueryHookOptions<GcpRegistrationSuccessFormSectionQuery, GcpRegistrationSuccessFormSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GcpRegistrationSuccessFormSectionQuery, GcpRegistrationSuccessFormSectionQueryVariables>(GcpRegistrationSuccessFormSectionDocument, options);
      }
export function useGcpRegistrationSuccessFormSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GcpRegistrationSuccessFormSectionQuery, GcpRegistrationSuccessFormSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GcpRegistrationSuccessFormSectionQuery, GcpRegistrationSuccessFormSectionQueryVariables>(GcpRegistrationSuccessFormSectionDocument, options);
        }
export type GcpRegistrationSuccessFormSectionQueryHookResult = ReturnType<typeof useGcpRegistrationSuccessFormSectionQuery>;
export type GcpRegistrationSuccessFormSectionLazyQueryHookResult = ReturnType<typeof useGcpRegistrationSuccessFormSectionLazyQuery>;
export type GcpRegistrationSuccessFormSectionQueryResult = Apollo.QueryResult<GcpRegistrationSuccessFormSectionQuery, GcpRegistrationSuccessFormSectionQueryVariables>;
export const UpdateGcpRegistrationSuccessFormSectionDocument = gql`
    mutation UpdateGcpRegistrationSuccessFormSection($updates: GcpListingInput!) {
  updateGcpListing(updates: $updates) {
    id
    registration {
      success {
        message
        redirect_url
      }
    }
  }
}
    `;
export type UpdateGcpRegistrationSuccessFormSectionMutationFn = Apollo.MutationFunction<UpdateGcpRegistrationSuccessFormSectionMutation, UpdateGcpRegistrationSuccessFormSectionMutationVariables>;

/**
 * __useUpdateGcpRegistrationSuccessFormSectionMutation__
 *
 * To run a mutation, you first call `useUpdateGcpRegistrationSuccessFormSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGcpRegistrationSuccessFormSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGcpRegistrationSuccessFormSectionMutation, { data, loading, error }] = useUpdateGcpRegistrationSuccessFormSectionMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateGcpRegistrationSuccessFormSectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGcpRegistrationSuccessFormSectionMutation, UpdateGcpRegistrationSuccessFormSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGcpRegistrationSuccessFormSectionMutation, UpdateGcpRegistrationSuccessFormSectionMutationVariables>(UpdateGcpRegistrationSuccessFormSectionDocument, options);
      }
export type UpdateGcpRegistrationSuccessFormSectionMutationHookResult = ReturnType<typeof useUpdateGcpRegistrationSuccessFormSectionMutation>;
export type UpdateGcpRegistrationSuccessFormSectionMutationResult = Apollo.MutationResult<UpdateGcpRegistrationSuccessFormSectionMutation>;
export type UpdateGcpRegistrationSuccessFormSectionMutationOptions = Apollo.BaseMutationOptions<UpdateGcpRegistrationSuccessFormSectionMutation, UpdateGcpRegistrationSuccessFormSectionMutationVariables>;
export const GcpRegistrationThemeFormSectionDocument = gql`
    query GcpRegistrationThemeFormSection($id: ID!) {
  gcpListing(id: $id) {
    id
    registration {
      form {
        button {
          background_color
          color
        }
        logo_url
      }
      hero {
        background_color
        background_image_url
      }
    }
  }
}
    `;

/**
 * __useGcpRegistrationThemeFormSectionQuery__
 *
 * To run a query within a React component, call `useGcpRegistrationThemeFormSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGcpRegistrationThemeFormSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGcpRegistrationThemeFormSectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGcpRegistrationThemeFormSectionQuery(baseOptions: Apollo.QueryHookOptions<GcpRegistrationThemeFormSectionQuery, GcpRegistrationThemeFormSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GcpRegistrationThemeFormSectionQuery, GcpRegistrationThemeFormSectionQueryVariables>(GcpRegistrationThemeFormSectionDocument, options);
      }
export function useGcpRegistrationThemeFormSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GcpRegistrationThemeFormSectionQuery, GcpRegistrationThemeFormSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GcpRegistrationThemeFormSectionQuery, GcpRegistrationThemeFormSectionQueryVariables>(GcpRegistrationThemeFormSectionDocument, options);
        }
export type GcpRegistrationThemeFormSectionQueryHookResult = ReturnType<typeof useGcpRegistrationThemeFormSectionQuery>;
export type GcpRegistrationThemeFormSectionLazyQueryHookResult = ReturnType<typeof useGcpRegistrationThemeFormSectionLazyQuery>;
export type GcpRegistrationThemeFormSectionQueryResult = Apollo.QueryResult<GcpRegistrationThemeFormSectionQuery, GcpRegistrationThemeFormSectionQueryVariables>;
export const UpdateGcpRegistrationThemeFormSectionDocument = gql`
    mutation UpdateGcpRegistrationThemeFormSection($updates: GcpListingInput!) {
  updateGcpListing(updates: $updates) {
    id
    registration {
      form {
        button {
          background_color
          color
        }
        logo_url
      }
      hero {
        background_color
        background_image_url
      }
    }
  }
}
    `;
export type UpdateGcpRegistrationThemeFormSectionMutationFn = Apollo.MutationFunction<UpdateGcpRegistrationThemeFormSectionMutation, UpdateGcpRegistrationThemeFormSectionMutationVariables>;

/**
 * __useUpdateGcpRegistrationThemeFormSectionMutation__
 *
 * To run a mutation, you first call `useUpdateGcpRegistrationThemeFormSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGcpRegistrationThemeFormSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGcpRegistrationThemeFormSectionMutation, { data, loading, error }] = useUpdateGcpRegistrationThemeFormSectionMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateGcpRegistrationThemeFormSectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGcpRegistrationThemeFormSectionMutation, UpdateGcpRegistrationThemeFormSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGcpRegistrationThemeFormSectionMutation, UpdateGcpRegistrationThemeFormSectionMutationVariables>(UpdateGcpRegistrationThemeFormSectionDocument, options);
      }
export type UpdateGcpRegistrationThemeFormSectionMutationHookResult = ReturnType<typeof useUpdateGcpRegistrationThemeFormSectionMutation>;
export type UpdateGcpRegistrationThemeFormSectionMutationResult = Apollo.MutationResult<UpdateGcpRegistrationThemeFormSectionMutation>;
export type UpdateGcpRegistrationThemeFormSectionMutationOptions = Apollo.BaseMutationOptions<UpdateGcpRegistrationThemeFormSectionMutation, UpdateGcpRegistrationThemeFormSectionMutationVariables>;
export const PropelCosellOpportunitiesDocument = gql`
    query PropelCosellOpportunities($metricId: ID!, $granularity: TimeSeriesGranularity!, $timeRange: TimeRangeInput!, $previousPeriodTimeRange: TimeRangeInput!, $showTrend: Boolean!) {
  previousPeriodTotal: metric(id: $metricId) @include(if: $showTrend) {
    counter(input: {timeRange: $previousPeriodTimeRange}) {
      value
    }
  }
  allTimeTotal: metric(id: $metricId) {
    counter(input: {timeRange: {relative: LAST_N_YEARS, n: 10}}) {
      value
    }
  }
  total: metric(id: $metricId) {
    counter(input: {timeRange: $timeRange}) {
      value
    }
  }
  awsInbound: metric(id: $metricId) {
    timeSeries(
      input: {timeRange: $timeRange, granularity: $granularity, filters: [{column: "CLOUDPARTNER", operator: EQUALS, value: "AWS"}, {column: "ORIGINATION", operator: EQUALS, value: "inbound"}]}
    ) {
      dates: labels
      counts: values
    }
  }
  awsOutbound: metric(id: $metricId) {
    timeSeries(
      input: {timeRange: $timeRange, granularity: $granularity, filters: [{column: "CLOUDPARTNER", operator: EQUALS, value: "AWS"}, {column: "ORIGINATION", operator: EQUALS, value: "outbound"}]}
    ) {
      dates: labels
      counts: values
    }
  }
  breakdownByCloud: metric(id: $metricId) {
    leaderboard(
      input: {rowLimit: 10, timeRange: $timeRange, dimensions: [{columnName: "CLOUDPARTNER"}, {columnName: "ORIGINATION"}]}
    ) {
      headers
      rows
    }
  }
}
    `;

/**
 * __usePropelCosellOpportunitiesQuery__
 *
 * To run a query within a React component, call `usePropelCosellOpportunitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePropelCosellOpportunitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePropelCosellOpportunitiesQuery({
 *   variables: {
 *      metricId: // value for 'metricId'
 *      granularity: // value for 'granularity'
 *      timeRange: // value for 'timeRange'
 *      previousPeriodTimeRange: // value for 'previousPeriodTimeRange'
 *      showTrend: // value for 'showTrend'
 *   },
 * });
 */
export function usePropelCosellOpportunitiesQuery(baseOptions: Apollo.QueryHookOptions<PropelCosellOpportunitiesQuery, PropelCosellOpportunitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PropelCosellOpportunitiesQuery, PropelCosellOpportunitiesQueryVariables>(PropelCosellOpportunitiesDocument, options);
      }
export function usePropelCosellOpportunitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PropelCosellOpportunitiesQuery, PropelCosellOpportunitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PropelCosellOpportunitiesQuery, PropelCosellOpportunitiesQueryVariables>(PropelCosellOpportunitiesDocument, options);
        }
export type PropelCosellOpportunitiesQueryHookResult = ReturnType<typeof usePropelCosellOpportunitiesQuery>;
export type PropelCosellOpportunitiesLazyQueryHookResult = ReturnType<typeof usePropelCosellOpportunitiesLazyQuery>;
export type PropelCosellOpportunitiesQueryResult = Apollo.QueryResult<PropelCosellOpportunitiesQuery, PropelCosellOpportunitiesQueryVariables>;
export const PropelCosellPipelineDocument = gql`
    query PropelCosellPipeline($metricId: ID!, $timeRange: TimeRangeInput!, $filters: [FilterInput!]) {
  total: metric(id: $metricId) {
    counter(input: {timeRange: $timeRange, filters: $filters}) {
      value
    }
  }
  pipelineData: metric(id: $metricId) {
    leaderboard(
      input: {rowLimit: 1000, sort: DESC, timeRange: $timeRange, filters: $filters, dimensions: [{columnName: "SUBMISSIONSTAGE"}, {columnName: "ORIGINATION"}]}
    ) {
      headers
      rows
    }
  }
}
    `;

/**
 * __usePropelCosellPipelineQuery__
 *
 * To run a query within a React component, call `usePropelCosellPipelineQuery` and pass it any options that fit your needs.
 * When your component renders, `usePropelCosellPipelineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePropelCosellPipelineQuery({
 *   variables: {
 *      metricId: // value for 'metricId'
 *      timeRange: // value for 'timeRange'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function usePropelCosellPipelineQuery(baseOptions: Apollo.QueryHookOptions<PropelCosellPipelineQuery, PropelCosellPipelineQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PropelCosellPipelineQuery, PropelCosellPipelineQueryVariables>(PropelCosellPipelineDocument, options);
      }
export function usePropelCosellPipelineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PropelCosellPipelineQuery, PropelCosellPipelineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PropelCosellPipelineQuery, PropelCosellPipelineQueryVariables>(PropelCosellPipelineDocument, options);
        }
export type PropelCosellPipelineQueryHookResult = ReturnType<typeof usePropelCosellPipelineQuery>;
export type PropelCosellPipelineLazyQueryHookResult = ReturnType<typeof usePropelCosellPipelineLazyQuery>;
export type PropelCosellPipelineQueryResult = Apollo.QueryResult<PropelCosellPipelineQuery, PropelCosellPipelineQueryVariables>;
export const PropelCosellMarketplaceRevenueDocument = gql`
    query PropelCosellMarketplaceRevenue($metricId: ID!, $timeRange: TimeRangeInput!) {
  total: metric(id: $metricId) {
    counter(input: {timeRange: $timeRange}) {
      value
    }
  }
  chartData: metric(id: $metricId) {
    leaderboard(
      input: {rowLimit: 1000, sort: DESC, timeRange: $timeRange, dimensions: [{columnName: "CLOUDPARTNER"}, {columnName: "SUBMISSIONSTAGE"}, {columnName: "ISTHISFORMARKETPLACE"}, {columnName: "ORIGINATION"}]}
    ) {
      headers
      rows
    }
  }
}
    `;

/**
 * __usePropelCosellMarketplaceRevenueQuery__
 *
 * To run a query within a React component, call `usePropelCosellMarketplaceRevenueQuery` and pass it any options that fit your needs.
 * When your component renders, `usePropelCosellMarketplaceRevenueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePropelCosellMarketplaceRevenueQuery({
 *   variables: {
 *      metricId: // value for 'metricId'
 *      timeRange: // value for 'timeRange'
 *   },
 * });
 */
export function usePropelCosellMarketplaceRevenueQuery(baseOptions: Apollo.QueryHookOptions<PropelCosellMarketplaceRevenueQuery, PropelCosellMarketplaceRevenueQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PropelCosellMarketplaceRevenueQuery, PropelCosellMarketplaceRevenueQueryVariables>(PropelCosellMarketplaceRevenueDocument, options);
      }
export function usePropelCosellMarketplaceRevenueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PropelCosellMarketplaceRevenueQuery, PropelCosellMarketplaceRevenueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PropelCosellMarketplaceRevenueQuery, PropelCosellMarketplaceRevenueQueryVariables>(PropelCosellMarketplaceRevenueDocument, options);
        }
export type PropelCosellMarketplaceRevenueQueryHookResult = ReturnType<typeof usePropelCosellMarketplaceRevenueQuery>;
export type PropelCosellMarketplaceRevenueLazyQueryHookResult = ReturnType<typeof usePropelCosellMarketplaceRevenueLazyQuery>;
export type PropelCosellMarketplaceRevenueQueryResult = Apollo.QueryResult<PropelCosellMarketplaceRevenueQuery, PropelCosellMarketplaceRevenueQueryVariables>;
export const PropelCosellWinRateDocument = gql`
    query PropelCosellWinRate($metricId: ID!, $timeRange: TimeRangeInput!) {
  total: metric(id: $metricId) {
    counter(input: {timeRange: $timeRange}) {
      value
    }
  }
  awsInbound: metric(id: $metricId) {
    counter(
      input: {timeRange: $timeRange, filters: [{column: "CLOUDPARTNER", operator: EQUALS, value: "AWS"}, {column: "ORIGINATION", operator: EQUALS, value: "inbound"}]}
    ) {
      value
    }
  }
  awsInboundWon: metric(id: $metricId) {
    counter(
      input: {timeRange: $timeRange, filters: [{column: "CLOUDPARTNER", operator: EQUALS, value: "AWS"}, {column: "ORIGINATION", operator: EQUALS, value: "inbound"}, {column: "SUBMISSIONSTAGE", operator: EQUALS, value: "Closed Won"}]}
    ) {
      value
    }
  }
  awsOutbound: metric(id: $metricId) {
    counter(
      input: {timeRange: $timeRange, filters: [{column: "CLOUDPARTNER", operator: EQUALS, value: "AWS"}, {column: "ORIGINATION", operator: EQUALS, value: "outbound"}]}
    ) {
      value
    }
  }
  awsOutboundWon: metric(id: $metricId) {
    counter(
      input: {timeRange: $timeRange, filters: [{column: "CLOUDPARTNER", operator: EQUALS, value: "AWS"}, {column: "ORIGINATION", operator: EQUALS, value: "outbound"}, {column: "SUBMISSIONSTAGE", operator: EQUALS, value: "Closed Won"}]}
    ) {
      value
    }
  }
}
    `;

/**
 * __usePropelCosellWinRateQuery__
 *
 * To run a query within a React component, call `usePropelCosellWinRateQuery` and pass it any options that fit your needs.
 * When your component renders, `usePropelCosellWinRateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePropelCosellWinRateQuery({
 *   variables: {
 *      metricId: // value for 'metricId'
 *      timeRange: // value for 'timeRange'
 *   },
 * });
 */
export function usePropelCosellWinRateQuery(baseOptions: Apollo.QueryHookOptions<PropelCosellWinRateQuery, PropelCosellWinRateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PropelCosellWinRateQuery, PropelCosellWinRateQueryVariables>(PropelCosellWinRateDocument, options);
      }
export function usePropelCosellWinRateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PropelCosellWinRateQuery, PropelCosellWinRateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PropelCosellWinRateQuery, PropelCosellWinRateQueryVariables>(PropelCosellWinRateDocument, options);
        }
export type PropelCosellWinRateQueryHookResult = ReturnType<typeof usePropelCosellWinRateQuery>;
export type PropelCosellWinRateLazyQueryHookResult = ReturnType<typeof usePropelCosellWinRateLazyQuery>;
export type PropelCosellWinRateQueryResult = Apollo.QueryResult<PropelCosellWinRateQuery, PropelCosellWinRateQueryVariables>;
export const ActivationDashboardDocument = gql`
    query ActivationDashboard($vendorId: String!, $hasProspectAccess: Boolean, $hasCoSellAccess: Boolean, $hasOffersAccess: Boolean) {
  activationDashboard(
    vendorId: $vendorId
    hasProspectAccess: $hasProspectAccess
    hasCoSellAccess: $hasCoSellAccess
    hasOffersAccess: $hasOffersAccess
  ) {
    verticals {
      __typename
      id
      stage
      ... on ProspectVertical {
        data {
          highScoreCount
        }
      }
      ... on CoSellVertical {
        data {
          highScoreCount
          isAwsConnected
          isAzureConnected
        }
      }
      ... on OffersVertical {
        data {
          highScoreCount
          marketplaceStages {
            marketplace
            stage
          }
        }
      }
    }
  }
}
    `;

/**
 * __useActivationDashboardQuery__
 *
 * To run a query within a React component, call `useActivationDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivationDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivationDashboardQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *      hasProspectAccess: // value for 'hasProspectAccess'
 *      hasCoSellAccess: // value for 'hasCoSellAccess'
 *      hasOffersAccess: // value for 'hasOffersAccess'
 *   },
 * });
 */
export function useActivationDashboardQuery(baseOptions: Apollo.QueryHookOptions<ActivationDashboardQuery, ActivationDashboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivationDashboardQuery, ActivationDashboardQueryVariables>(ActivationDashboardDocument, options);
      }
export function useActivationDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivationDashboardQuery, ActivationDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivationDashboardQuery, ActivationDashboardQueryVariables>(ActivationDashboardDocument, options);
        }
export type ActivationDashboardQueryHookResult = ReturnType<typeof useActivationDashboardQuery>;
export type ActivationDashboardLazyQueryHookResult = ReturnType<typeof useActivationDashboardLazyQuery>;
export type ActivationDashboardQueryResult = Apollo.QueryResult<ActivationDashboardQuery, ActivationDashboardQueryVariables>;
export const CurrentUserVendorDetailsDocument = gql`
    query currentUserVendorDetails {
  currentUser {
    id
    vendor {
      id
      vendor_type
      created_at
      listingsByChannel {
        id
        aws {
          id
          status
        }
      }
      configuration {
        id
        status {
          sdds {
            value
          }
        }
      }
    }
  }
}
    `;

/**
 * __useCurrentUserVendorDetailsQuery__
 *
 * To run a query within a React component, call `useCurrentUserVendorDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserVendorDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserVendorDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserVendorDetailsQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserVendorDetailsQuery, CurrentUserVendorDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserVendorDetailsQuery, CurrentUserVendorDetailsQueryVariables>(CurrentUserVendorDetailsDocument, options);
      }
export function useCurrentUserVendorDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserVendorDetailsQuery, CurrentUserVendorDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserVendorDetailsQuery, CurrentUserVendorDetailsQueryVariables>(CurrentUserVendorDetailsDocument, options);
        }
export type CurrentUserVendorDetailsQueryHookResult = ReturnType<typeof useCurrentUserVendorDetailsQuery>;
export type CurrentUserVendorDetailsLazyQueryHookResult = ReturnType<typeof useCurrentUserVendorDetailsLazyQuery>;
export type CurrentUserVendorDetailsQueryResult = Apollo.QueryResult<CurrentUserVendorDetailsQuery, CurrentUserVendorDetailsQueryVariables>;
export const ProspectHighCountsDocument = gql`
    query ProspectHighCounts($vendorId: String!) {
  prospectRollupStatistics(vendor_id: $vendorId) {
    data {
      total_domains
      aws: aws_rollup {
        count_high
        count_medium
        count_low
      }
      gcp: gcp_rollup {
        count_high
        count_medium
        count_low
      }
      microsoft: azure_rollup {
        count_high
        count_medium
        count_low
      }
      newHighs: new_highs
    }
  }
}
    `;

/**
 * __useProspectHighCountsQuery__
 *
 * To run a query within a React component, call `useProspectHighCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProspectHighCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProspectHighCountsQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *   },
 * });
 */
export function useProspectHighCountsQuery(baseOptions: Apollo.QueryHookOptions<ProspectHighCountsQuery, ProspectHighCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProspectHighCountsQuery, ProspectHighCountsQueryVariables>(ProspectHighCountsDocument, options);
      }
export function useProspectHighCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProspectHighCountsQuery, ProspectHighCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProspectHighCountsQuery, ProspectHighCountsQueryVariables>(ProspectHighCountsDocument, options);
        }
export type ProspectHighCountsQueryHookResult = ReturnType<typeof useProspectHighCountsQuery>;
export type ProspectHighCountsLazyQueryHookResult = ReturnType<typeof useProspectHighCountsLazyQuery>;
export type ProspectHighCountsQueryResult = Apollo.QueryResult<ProspectHighCountsQuery, ProspectHighCountsQueryVariables>;
export const ProspectScoringProgressDocument = gql`
    query ProspectScoringProgress($vendorId: String!) {
  prospectScoringJob(vendor_id: $vendorId) {
    data {
      status
      createDate: create_date
    }
  }
  prospectScoringBatches(vendor_id: $vendorId) {
    data {
      batch_id
    }
  }
}
    `;

/**
 * __useProspectScoringProgressQuery__
 *
 * To run a query within a React component, call `useProspectScoringProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useProspectScoringProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProspectScoringProgressQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *   },
 * });
 */
export function useProspectScoringProgressQuery(baseOptions: Apollo.QueryHookOptions<ProspectScoringProgressQuery, ProspectScoringProgressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProspectScoringProgressQuery, ProspectScoringProgressQueryVariables>(ProspectScoringProgressDocument, options);
      }
export function useProspectScoringProgressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProspectScoringProgressQuery, ProspectScoringProgressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProspectScoringProgressQuery, ProspectScoringProgressQueryVariables>(ProspectScoringProgressDocument, options);
        }
export type ProspectScoringProgressQueryHookResult = ReturnType<typeof useProspectScoringProgressQuery>;
export type ProspectScoringProgressLazyQueryHookResult = ReturnType<typeof useProspectScoringProgressLazyQuery>;
export type ProspectScoringProgressQueryResult = Apollo.QueryResult<ProspectScoringProgressQuery, ProspectScoringProgressQueryVariables>;
export const PropelBookedRevenueDocument = gql`
    query PropelBookedRevenue($metricName: String!, $granularity: TimeSeriesGranularity!, $timeRange: TimeRangeInput!, $lastPeriodTimeRange: TimeRangeInput!, $cloudFilters: FilterInput!) {
  currentUser {
    id
    vendorId
  }
  aws: metricByName(uniqueName: $metricName) {
    timeSeries(
      input: {timeRange: $timeRange, granularity: $granularity, filters: [{column: "CLOUD_NAME", operator: EQUALS, value: "AWS"}]}
    ) {
      labels
      values
    }
  }
  azure: metricByName(uniqueName: $metricName) {
    timeSeries(
      input: {timeRange: $timeRange, granularity: $granularity, filters: [{column: "CLOUD_NAME", operator: EQUALS, value: "AZURE"}]}
    ) {
      labels
      values
    }
  }
  gcp: metricByName(uniqueName: $metricName) {
    timeSeries(
      input: {timeRange: $timeRange, granularity: $granularity, filters: [{column: "CLOUD_NAME", operator: EQUALS, value: "GCP"}]}
    ) {
      labels
      values
    }
  }
  revenueByCloud: metricByName(uniqueName: $metricName) {
    leaderboard(
      input: {rowLimit: 10, timeRange: $timeRange, dimensions: [{columnName: "CLOUD_NAME"}], filters: [$cloudFilters]}
    ) {
      headers
      rows
    }
  }
  thisPeriodRevenue: metricByName(uniqueName: $metricName) {
    counter(input: {timeRange: $timeRange, filters: [$cloudFilters]}) {
      value
    }
  }
  lastPeriodRevenue: metricByName(uniqueName: $metricName) {
    counter(input: {timeRange: $lastPeriodTimeRange, filters: [$cloudFilters]}) {
      value
    }
  }
}
    `;

/**
 * __usePropelBookedRevenueQuery__
 *
 * To run a query within a React component, call `usePropelBookedRevenueQuery` and pass it any options that fit your needs.
 * When your component renders, `usePropelBookedRevenueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePropelBookedRevenueQuery({
 *   variables: {
 *      metricName: // value for 'metricName'
 *      granularity: // value for 'granularity'
 *      timeRange: // value for 'timeRange'
 *      lastPeriodTimeRange: // value for 'lastPeriodTimeRange'
 *      cloudFilters: // value for 'cloudFilters'
 *   },
 * });
 */
export function usePropelBookedRevenueQuery(baseOptions: Apollo.QueryHookOptions<PropelBookedRevenueQuery, PropelBookedRevenueQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PropelBookedRevenueQuery, PropelBookedRevenueQueryVariables>(PropelBookedRevenueDocument, options);
      }
export function usePropelBookedRevenueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PropelBookedRevenueQuery, PropelBookedRevenueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PropelBookedRevenueQuery, PropelBookedRevenueQueryVariables>(PropelBookedRevenueDocument, options);
        }
export type PropelBookedRevenueQueryHookResult = ReturnType<typeof usePropelBookedRevenueQuery>;
export type PropelBookedRevenueLazyQueryHookResult = ReturnType<typeof usePropelBookedRevenueLazyQuery>;
export type PropelBookedRevenueQueryResult = Apollo.QueryResult<PropelBookedRevenueQuery, PropelBookedRevenueQueryVariables>;
export const PropelDisbursedRevenueDocument = gql`
    query PropelDisbursedRevenue($metricName: String!, $granularity: TimeSeriesGranularity!, $timeRange: TimeRangeInput!, $lastPeriodTimeRange: TimeRangeInput!, $cloudFilters: FilterInput!) {
  currentUser {
    id
    vendorId
  }
  aws: metricByName(uniqueName: $metricName) {
    timeSeries(
      input: {timeRange: $timeRange, granularity: $granularity, filters: [{column: "CLOUD_MARKETPLACE", operator: EQUALS, value: "AWS"}]}
    ) {
      labels
      values
    }
  }
  azure: metricByName(uniqueName: $metricName) {
    timeSeries(
      input: {timeRange: $timeRange, granularity: $granularity, filters: [{column: "CLOUD_MARKETPLACE", operator: EQUALS, value: "AZURE"}]}
    ) {
      labels
      values
    }
  }
  gcp: metricByName(uniqueName: $metricName) {
    timeSeries(
      input: {timeRange: $timeRange, granularity: $granularity, filters: [{column: "CLOUD_MARKETPLACE", operator: EQUALS, value: "GCP"}]}
    ) {
      labels
      values
    }
  }
  revenueByCloud: metricByName(uniqueName: $metricName) {
    leaderboard(
      input: {rowLimit: 10, timeRange: $timeRange, dimensions: [{columnName: "CLOUD_MARKETPLACE"}], filters: [$cloudFilters]}
    ) {
      headers
      rows
    }
  }
  thisPeriodRevenue: metricByName(uniqueName: $metricName) {
    counter(input: {timeRange: $timeRange, filters: [$cloudFilters]}) {
      value
    }
  }
  lastPeriodRevenue: metricByName(uniqueName: $metricName) {
    counter(input: {timeRange: $lastPeriodTimeRange, filters: [$cloudFilters]}) {
      value
    }
  }
}
    `;

/**
 * __usePropelDisbursedRevenueQuery__
 *
 * To run a query within a React component, call `usePropelDisbursedRevenueQuery` and pass it any options that fit your needs.
 * When your component renders, `usePropelDisbursedRevenueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePropelDisbursedRevenueQuery({
 *   variables: {
 *      metricName: // value for 'metricName'
 *      granularity: // value for 'granularity'
 *      timeRange: // value for 'timeRange'
 *      lastPeriodTimeRange: // value for 'lastPeriodTimeRange'
 *      cloudFilters: // value for 'cloudFilters'
 *   },
 * });
 */
export function usePropelDisbursedRevenueQuery(baseOptions: Apollo.QueryHookOptions<PropelDisbursedRevenueQuery, PropelDisbursedRevenueQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PropelDisbursedRevenueQuery, PropelDisbursedRevenueQueryVariables>(PropelDisbursedRevenueDocument, options);
      }
export function usePropelDisbursedRevenueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PropelDisbursedRevenueQuery, PropelDisbursedRevenueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PropelDisbursedRevenueQuery, PropelDisbursedRevenueQueryVariables>(PropelDisbursedRevenueDocument, options);
        }
export type PropelDisbursedRevenueQueryHookResult = ReturnType<typeof usePropelDisbursedRevenueQuery>;
export type PropelDisbursedRevenueLazyQueryHookResult = ReturnType<typeof usePropelDisbursedRevenueLazyQuery>;
export type PropelDisbursedRevenueQueryResult = Apollo.QueryResult<PropelDisbursedRevenueQuery, PropelDisbursedRevenueQueryVariables>;
export const NewDashboardDocument = gql`
    query NewDashboard {
  currentUser {
    id
    vendor {
      id
      feature_flags {
        is_prospect_enabled
        is_listings_enabled
        is_co_sell_enabled
        is_co_sell_enabled_for_microsoft
      }
    }
  }
}
    `;

/**
 * __useNewDashboardQuery__
 *
 * To run a query within a React component, call `useNewDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewDashboardQuery({
 *   variables: {
 *   },
 * });
 */
export function useNewDashboardQuery(baseOptions?: Apollo.QueryHookOptions<NewDashboardQuery, NewDashboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NewDashboardQuery, NewDashboardQueryVariables>(NewDashboardDocument, options);
      }
export function useNewDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NewDashboardQuery, NewDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NewDashboardQuery, NewDashboardQueryVariables>(NewDashboardDocument, options);
        }
export type NewDashboardQueryHookResult = ReturnType<typeof useNewDashboardQuery>;
export type NewDashboardLazyQueryHookResult = ReturnType<typeof useNewDashboardLazyQuery>;
export type NewDashboardQueryResult = Apollo.QueryResult<NewDashboardQuery, NewDashboardQueryVariables>;
export const ProspectRollupStatisticsCardDocument = gql`
    query ProspectRollupStatisticsCard($vendorId: String!) {
  prospectRollupStatistics(vendor_id: $vendorId) {
    data {
      total_domains
      aws: aws_rollup {
        count_high
        count_medium
        count_low
      }
      gcp: gcp_rollup {
        count_high
        count_medium
        count_low
      }
      microsoft: azure_rollup {
        count_high
        count_medium
        count_low
      }
      newHighs: new_highs
    }
  }
}
    `;

/**
 * __useProspectRollupStatisticsCardQuery__
 *
 * To run a query within a React component, call `useProspectRollupStatisticsCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useProspectRollupStatisticsCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProspectRollupStatisticsCardQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *   },
 * });
 */
export function useProspectRollupStatisticsCardQuery(baseOptions: Apollo.QueryHookOptions<ProspectRollupStatisticsCardQuery, ProspectRollupStatisticsCardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProspectRollupStatisticsCardQuery, ProspectRollupStatisticsCardQueryVariables>(ProspectRollupStatisticsCardDocument, options);
      }
export function useProspectRollupStatisticsCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProspectRollupStatisticsCardQuery, ProspectRollupStatisticsCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProspectRollupStatisticsCardQuery, ProspectRollupStatisticsCardQueryVariables>(ProspectRollupStatisticsCardDocument, options);
        }
export type ProspectRollupStatisticsCardQueryHookResult = ReturnType<typeof useProspectRollupStatisticsCardQuery>;
export type ProspectRollupStatisticsCardLazyQueryHookResult = ReturnType<typeof useProspectRollupStatisticsCardLazyQuery>;
export type ProspectRollupStatisticsCardQueryResult = Apollo.QueryResult<ProspectRollupStatisticsCardQuery, ProspectRollupStatisticsCardQueryVariables>;
export const LegacyProspectSectionDocument = gql`
    query legacyProspectSection {
  currentUser {
    id
    vendor {
      id
      feature_flags {
        is_prospect_enabled
      }
    }
  }
}
    `;

/**
 * __useLegacyProspectSectionQuery__
 *
 * To run a query within a React component, call `useLegacyProspectSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useLegacyProspectSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLegacyProspectSectionQuery({
 *   variables: {
 *   },
 * });
 */
export function useLegacyProspectSectionQuery(baseOptions?: Apollo.QueryHookOptions<LegacyProspectSectionQuery, LegacyProspectSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LegacyProspectSectionQuery, LegacyProspectSectionQueryVariables>(LegacyProspectSectionDocument, options);
      }
export function useLegacyProspectSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LegacyProspectSectionQuery, LegacyProspectSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LegacyProspectSectionQuery, LegacyProspectSectionQueryVariables>(LegacyProspectSectionDocument, options);
        }
export type LegacyProspectSectionQueryHookResult = ReturnType<typeof useLegacyProspectSectionQuery>;
export type LegacyProspectSectionLazyQueryHookResult = ReturnType<typeof useLegacyProspectSectionLazyQuery>;
export type LegacyProspectSectionQueryResult = Apollo.QueryResult<LegacyProspectSectionQuery, LegacyProspectSectionQueryVariables>;
export const CreateProspectSelectedExportUrlDocument = gql`
    mutation CreateProspectSelectedExportUrl($data: FilterProspectAccountsInput!) {
  createProspectSelectedExportUrlV2(data: $data) {
    data {
      expires_in
      s3_key
      url
      use
      batch_metadata {
        batch_id
        batch_name
      }
    }
  }
}
    `;
export type CreateProspectSelectedExportUrlMutationFn = Apollo.MutationFunction<CreateProspectSelectedExportUrlMutation, CreateProspectSelectedExportUrlMutationVariables>;

/**
 * __useCreateProspectSelectedExportUrlMutation__
 *
 * To run a mutation, you first call `useCreateProspectSelectedExportUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProspectSelectedExportUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProspectSelectedExportUrlMutation, { data, loading, error }] = useCreateProspectSelectedExportUrlMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateProspectSelectedExportUrlMutation(baseOptions?: Apollo.MutationHookOptions<CreateProspectSelectedExportUrlMutation, CreateProspectSelectedExportUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProspectSelectedExportUrlMutation, CreateProspectSelectedExportUrlMutationVariables>(CreateProspectSelectedExportUrlDocument, options);
      }
export type CreateProspectSelectedExportUrlMutationHookResult = ReturnType<typeof useCreateProspectSelectedExportUrlMutation>;
export type CreateProspectSelectedExportUrlMutationResult = Apollo.MutationResult<CreateProspectSelectedExportUrlMutation>;
export type CreateProspectSelectedExportUrlMutationOptions = Apollo.BaseMutationOptions<CreateProspectSelectedExportUrlMutation, CreateProspectSelectedExportUrlMutationVariables>;
export const PaymentsExportDocument = gql`
    query PaymentsExport($input: DataGridInput!) {
  payments: dataGrid(input: $input) {
    headers
    rows
  }
}
    `;

/**
 * __usePaymentsExportQuery__
 *
 * To run a query within a React component, call `usePaymentsExportQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentsExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentsExportQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePaymentsExportQuery(baseOptions: Apollo.QueryHookOptions<PaymentsExportQuery, PaymentsExportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentsExportQuery, PaymentsExportQueryVariables>(PaymentsExportDocument, options);
      }
export function usePaymentsExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentsExportQuery, PaymentsExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentsExportQuery, PaymentsExportQueryVariables>(PaymentsExportDocument, options);
        }
export type PaymentsExportQueryHookResult = ReturnType<typeof usePaymentsExportQuery>;
export type PaymentsExportLazyQueryHookResult = ReturnType<typeof usePaymentsExportLazyQuery>;
export type PaymentsExportQueryResult = Apollo.QueryResult<PaymentsExportQuery, PaymentsExportQueryVariables>;
export const PropelPaymentsActualDisbursedRevenueDocument = gql`
    query PropelPaymentsActualDisbursedRevenue($metricNameTackleManaged: String!, $metricNameNotManaged: String!, $timeRange: TimeRangeInput!, $filterSql: String!) {
  tackleManaged: metricByName(uniqueName: $metricNameTackleManaged) {
    counter(input: {timeRange: $timeRange, filterSql: $filterSql}) {
      value
    }
  }
  notManaged: metricByName(uniqueName: $metricNameNotManaged) {
    counter(input: {timeRange: $timeRange, filterSql: $filterSql}) {
      value
    }
  }
}
    `;

/**
 * __usePropelPaymentsActualDisbursedRevenueQuery__
 *
 * To run a query within a React component, call `usePropelPaymentsActualDisbursedRevenueQuery` and pass it any options that fit your needs.
 * When your component renders, `usePropelPaymentsActualDisbursedRevenueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePropelPaymentsActualDisbursedRevenueQuery({
 *   variables: {
 *      metricNameTackleManaged: // value for 'metricNameTackleManaged'
 *      metricNameNotManaged: // value for 'metricNameNotManaged'
 *      timeRange: // value for 'timeRange'
 *      filterSql: // value for 'filterSql'
 *   },
 * });
 */
export function usePropelPaymentsActualDisbursedRevenueQuery(baseOptions: Apollo.QueryHookOptions<PropelPaymentsActualDisbursedRevenueQuery, PropelPaymentsActualDisbursedRevenueQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PropelPaymentsActualDisbursedRevenueQuery, PropelPaymentsActualDisbursedRevenueQueryVariables>(PropelPaymentsActualDisbursedRevenueDocument, options);
      }
export function usePropelPaymentsActualDisbursedRevenueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PropelPaymentsActualDisbursedRevenueQuery, PropelPaymentsActualDisbursedRevenueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PropelPaymentsActualDisbursedRevenueQuery, PropelPaymentsActualDisbursedRevenueQueryVariables>(PropelPaymentsActualDisbursedRevenueDocument, options);
        }
export type PropelPaymentsActualDisbursedRevenueQueryHookResult = ReturnType<typeof usePropelPaymentsActualDisbursedRevenueQuery>;
export type PropelPaymentsActualDisbursedRevenueLazyQueryHookResult = ReturnType<typeof usePropelPaymentsActualDisbursedRevenueLazyQuery>;
export type PropelPaymentsActualDisbursedRevenueQueryResult = Apollo.QueryResult<PropelPaymentsActualDisbursedRevenueQuery, PropelPaymentsActualDisbursedRevenueQueryVariables>;
export const PropelPaymentsGrosssDisbursedRevenueDocument = gql`
    query PropelPaymentsGrosssDisbursedRevenue($metricNameTackleManaged: String!, $metricNameNotManaged: String!, $timeRange: TimeRangeInput!, $filterSql: String!) {
  tackleManaged: metricByName(uniqueName: $metricNameTackleManaged) {
    counter(input: {timeRange: $timeRange, filterSql: $filterSql}) {
      value
    }
  }
  notManaged: metricByName(uniqueName: $metricNameNotManaged) {
    counter(input: {timeRange: $timeRange, filterSql: $filterSql}) {
      value
    }
  }
}
    `;

/**
 * __usePropelPaymentsGrosssDisbursedRevenueQuery__
 *
 * To run a query within a React component, call `usePropelPaymentsGrosssDisbursedRevenueQuery` and pass it any options that fit your needs.
 * When your component renders, `usePropelPaymentsGrosssDisbursedRevenueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePropelPaymentsGrosssDisbursedRevenueQuery({
 *   variables: {
 *      metricNameTackleManaged: // value for 'metricNameTackleManaged'
 *      metricNameNotManaged: // value for 'metricNameNotManaged'
 *      timeRange: // value for 'timeRange'
 *      filterSql: // value for 'filterSql'
 *   },
 * });
 */
export function usePropelPaymentsGrosssDisbursedRevenueQuery(baseOptions: Apollo.QueryHookOptions<PropelPaymentsGrosssDisbursedRevenueQuery, PropelPaymentsGrosssDisbursedRevenueQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PropelPaymentsGrosssDisbursedRevenueQuery, PropelPaymentsGrosssDisbursedRevenueQueryVariables>(PropelPaymentsGrosssDisbursedRevenueDocument, options);
      }
export function usePropelPaymentsGrosssDisbursedRevenueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PropelPaymentsGrosssDisbursedRevenueQuery, PropelPaymentsGrosssDisbursedRevenueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PropelPaymentsGrosssDisbursedRevenueQuery, PropelPaymentsGrosssDisbursedRevenueQueryVariables>(PropelPaymentsGrosssDisbursedRevenueDocument, options);
        }
export type PropelPaymentsGrosssDisbursedRevenueQueryHookResult = ReturnType<typeof usePropelPaymentsGrosssDisbursedRevenueQuery>;
export type PropelPaymentsGrosssDisbursedRevenueLazyQueryHookResult = ReturnType<typeof usePropelPaymentsGrosssDisbursedRevenueLazyQuery>;
export type PropelPaymentsGrosssDisbursedRevenueQueryResult = Apollo.QueryResult<PropelPaymentsGrosssDisbursedRevenueQuery, PropelPaymentsGrosssDisbursedRevenueQueryVariables>;
export const GroupedPaymentsDocument = gql`
    query GroupedPayments($groupsInput: MetricReportInput!, $countInput: SqlV1Input!) {
  groups: metricReport(input: $groupsInput) {
    headers
    rows
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
  count: sqlV1(input: $countInput) {
    rows
  }
}
    `;

/**
 * __useGroupedPaymentsQuery__
 *
 * To run a query within a React component, call `useGroupedPaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupedPaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupedPaymentsQuery({
 *   variables: {
 *      groupsInput: // value for 'groupsInput'
 *      countInput: // value for 'countInput'
 *   },
 * });
 */
export function useGroupedPaymentsQuery(baseOptions: Apollo.QueryHookOptions<GroupedPaymentsQuery, GroupedPaymentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupedPaymentsQuery, GroupedPaymentsQueryVariables>(GroupedPaymentsDocument, options);
      }
export function useGroupedPaymentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupedPaymentsQuery, GroupedPaymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupedPaymentsQuery, GroupedPaymentsQueryVariables>(GroupedPaymentsDocument, options);
        }
export type GroupedPaymentsQueryHookResult = ReturnType<typeof useGroupedPaymentsQuery>;
export type GroupedPaymentsLazyQueryHookResult = ReturnType<typeof useGroupedPaymentsLazyQuery>;
export type GroupedPaymentsQueryResult = Apollo.QueryResult<GroupedPaymentsQuery, GroupedPaymentsQueryVariables>;
export const PaymentsGroupDocument = gql`
    query PaymentsGroup($input: DataGridInput!) {
  payments: dataGrid(input: $input) {
    headers
    rows
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
      startCursor
    }
  }
}
    `;

/**
 * __usePaymentsGroupQuery__
 *
 * To run a query within a React component, call `usePaymentsGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentsGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentsGroupQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePaymentsGroupQuery(baseOptions: Apollo.QueryHookOptions<PaymentsGroupQuery, PaymentsGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentsGroupQuery, PaymentsGroupQueryVariables>(PaymentsGroupDocument, options);
      }
export function usePaymentsGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentsGroupQuery, PaymentsGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentsGroupQuery, PaymentsGroupQueryVariables>(PaymentsGroupDocument, options);
        }
export type PaymentsGroupQueryHookResult = ReturnType<typeof usePaymentsGroupQuery>;
export type PaymentsGroupLazyQueryHookResult = ReturnType<typeof usePaymentsGroupLazyQuery>;
export type PaymentsGroupQueryResult = Apollo.QueryResult<PaymentsGroupQuery, PaymentsGroupQueryVariables>;
export const UngroupedPaymentsDocument = gql`
    query UngroupedPayments($paymentsInput: DataGridInput!, $countInput: SqlV1Input!) {
  payments: dataGrid(input: $paymentsInput) {
    headers
    rows
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
      startCursor
    }
  }
  count: sqlV1(input: $countInput) {
    rows
  }
}
    `;

/**
 * __useUngroupedPaymentsQuery__
 *
 * To run a query within a React component, call `useUngroupedPaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUngroupedPaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUngroupedPaymentsQuery({
 *   variables: {
 *      paymentsInput: // value for 'paymentsInput'
 *      countInput: // value for 'countInput'
 *   },
 * });
 */
export function useUngroupedPaymentsQuery(baseOptions: Apollo.QueryHookOptions<UngroupedPaymentsQuery, UngroupedPaymentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UngroupedPaymentsQuery, UngroupedPaymentsQueryVariables>(UngroupedPaymentsDocument, options);
      }
export function useUngroupedPaymentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UngroupedPaymentsQuery, UngroupedPaymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UngroupedPaymentsQuery, UngroupedPaymentsQueryVariables>(UngroupedPaymentsDocument, options);
        }
export type UngroupedPaymentsQueryHookResult = ReturnType<typeof useUngroupedPaymentsQuery>;
export type UngroupedPaymentsLazyQueryHookResult = ReturnType<typeof useUngroupedPaymentsLazyQuery>;
export type UngroupedPaymentsQueryResult = Apollo.QueryResult<UngroupedPaymentsQuery, UngroupedPaymentsQueryVariables>;
export const ListOfListingsIdsDocument = gql`
    query ListOfListingsIds {
  currentUser {
    id
    role
    vendor {
      id
      listingsByChannel {
        id
        aws {
          id
        }
        azure {
          id
        }
        gcp {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useListOfListingsIdsQuery__
 *
 * To run a query within a React component, call `useListOfListingsIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListOfListingsIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListOfListingsIdsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListOfListingsIdsQuery(baseOptions?: Apollo.QueryHookOptions<ListOfListingsIdsQuery, ListOfListingsIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListOfListingsIdsQuery, ListOfListingsIdsQueryVariables>(ListOfListingsIdsDocument, options);
      }
export function useListOfListingsIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListOfListingsIdsQuery, ListOfListingsIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListOfListingsIdsQuery, ListOfListingsIdsQueryVariables>(ListOfListingsIdsDocument, options);
        }
export type ListOfListingsIdsQueryHookResult = ReturnType<typeof useListOfListingsIdsQuery>;
export type ListOfListingsIdsLazyQueryHookResult = ReturnType<typeof useListOfListingsIdsLazyQuery>;
export type ListOfListingsIdsQueryResult = Apollo.QueryResult<ListOfListingsIdsQuery, ListOfListingsIdsQueryVariables>;
export const DataGridQueryDocument = gql`
    query DataGridQuery($input: DataGridInput!) {
  dataGrid(input: $input) {
    headers
    rows
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
      startCursor
    }
    query {
      resultingRecords
    }
  }
}
    `;

/**
 * __useDataGridQueryQuery__
 *
 * To run a query within a React component, call `useDataGridQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataGridQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataGridQueryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDataGridQueryQuery(baseOptions: Apollo.QueryHookOptions<DataGridQueryQuery, DataGridQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataGridQueryQuery, DataGridQueryQueryVariables>(DataGridQueryDocument, options);
      }
export function useDataGridQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataGridQueryQuery, DataGridQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataGridQueryQuery, DataGridQueryQueryVariables>(DataGridQueryDocument, options);
        }
export type DataGridQueryQueryHookResult = ReturnType<typeof useDataGridQueryQuery>;
export type DataGridQueryLazyQueryHookResult = ReturnType<typeof useDataGridQueryLazyQuery>;
export type DataGridQueryQueryResult = Apollo.QueryResult<DataGridQueryQuery, DataGridQueryQueryVariables>;
export const TotalPaymentsDataDocument = gql`
    query totalPaymentsData($input: DataGridInput!) {
  dataGrid(input: $input) {
    query {
      resultingRecords
    }
  }
}
    `;

/**
 * __useTotalPaymentsDataQuery__
 *
 * To run a query within a React component, call `useTotalPaymentsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useTotalPaymentsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTotalPaymentsDataQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTotalPaymentsDataQuery(baseOptions: Apollo.QueryHookOptions<TotalPaymentsDataQuery, TotalPaymentsDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TotalPaymentsDataQuery, TotalPaymentsDataQueryVariables>(TotalPaymentsDataDocument, options);
      }
export function useTotalPaymentsDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TotalPaymentsDataQuery, TotalPaymentsDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TotalPaymentsDataQuery, TotalPaymentsDataQueryVariables>(TotalPaymentsDataDocument, options);
        }
export type TotalPaymentsDataQueryHookResult = ReturnType<typeof useTotalPaymentsDataQuery>;
export type TotalPaymentsDataLazyQueryHookResult = ReturnType<typeof useTotalPaymentsDataLazyQuery>;
export type TotalPaymentsDataQueryResult = Apollo.QueryResult<TotalPaymentsDataQuery, TotalPaymentsDataQueryVariables>;
export const TotalPaymentsDetailsDataDocument = gql`
    query totalPaymentsDetailsData($input: DataGridInput!) {
  dataGrid(input: $input) {
    headers
    rows
    query {
      resultingRecords
    }
  }
}
    `;

/**
 * __useTotalPaymentsDetailsDataQuery__
 *
 * To run a query within a React component, call `useTotalPaymentsDetailsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useTotalPaymentsDetailsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTotalPaymentsDetailsDataQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTotalPaymentsDetailsDataQuery(baseOptions: Apollo.QueryHookOptions<TotalPaymentsDetailsDataQuery, TotalPaymentsDetailsDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TotalPaymentsDetailsDataQuery, TotalPaymentsDetailsDataQueryVariables>(TotalPaymentsDetailsDataDocument, options);
      }
export function useTotalPaymentsDetailsDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TotalPaymentsDetailsDataQuery, TotalPaymentsDetailsDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TotalPaymentsDetailsDataQuery, TotalPaymentsDetailsDataQueryVariables>(TotalPaymentsDetailsDataDocument, options);
        }
export type TotalPaymentsDetailsDataQueryHookResult = ReturnType<typeof useTotalPaymentsDetailsDataQuery>;
export type TotalPaymentsDetailsDataLazyQueryHookResult = ReturnType<typeof useTotalPaymentsDetailsDataLazyQuery>;
export type TotalPaymentsDetailsDataQueryResult = Apollo.QueryResult<TotalPaymentsDetailsDataQuery, TotalPaymentsDetailsDataQueryVariables>;
export const UserBillingDetailsDocument = gql`
    query userBillingDetails {
  userBillingDetails {
    gmvPrecommit
    gmvUsage
    subscriptionId
    subscriptionStartTime
    subscriptionEndTime
    lastUpdated
  }
}
    `;

/**
 * __useUserBillingDetailsQuery__
 *
 * To run a query within a React component, call `useUserBillingDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserBillingDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserBillingDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserBillingDetailsQuery(baseOptions?: Apollo.QueryHookOptions<UserBillingDetailsQuery, UserBillingDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserBillingDetailsQuery, UserBillingDetailsQueryVariables>(UserBillingDetailsDocument, options);
      }
export function useUserBillingDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserBillingDetailsQuery, UserBillingDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserBillingDetailsQuery, UserBillingDetailsQueryVariables>(UserBillingDetailsDocument, options);
        }
export type UserBillingDetailsQueryHookResult = ReturnType<typeof useUserBillingDetailsQuery>;
export type UserBillingDetailsLazyQueryHookResult = ReturnType<typeof useUserBillingDetailsLazyQuery>;
export type UserBillingDetailsQueryResult = Apollo.QueryResult<UserBillingDetailsQuery, UserBillingDetailsQueryVariables>;
export const PropelPaymentsGroupByMetricReportDocument = gql`
    query PropelPaymentsGroupByMetricReport($input: MetricReportInput!) {
  metricReport(input: $input) {
    headers
    rows
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    query {
      resultingRecords
    }
  }
}
    `;

/**
 * __usePropelPaymentsGroupByMetricReportQuery__
 *
 * To run a query within a React component, call `usePropelPaymentsGroupByMetricReportQuery` and pass it any options that fit your needs.
 * When your component renders, `usePropelPaymentsGroupByMetricReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePropelPaymentsGroupByMetricReportQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePropelPaymentsGroupByMetricReportQuery(baseOptions: Apollo.QueryHookOptions<PropelPaymentsGroupByMetricReportQuery, PropelPaymentsGroupByMetricReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PropelPaymentsGroupByMetricReportQuery, PropelPaymentsGroupByMetricReportQueryVariables>(PropelPaymentsGroupByMetricReportDocument, options);
      }
export function usePropelPaymentsGroupByMetricReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PropelPaymentsGroupByMetricReportQuery, PropelPaymentsGroupByMetricReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PropelPaymentsGroupByMetricReportQuery, PropelPaymentsGroupByMetricReportQueryVariables>(PropelPaymentsGroupByMetricReportDocument, options);
        }
export type PropelPaymentsGroupByMetricReportQueryHookResult = ReturnType<typeof usePropelPaymentsGroupByMetricReportQuery>;
export type PropelPaymentsGroupByMetricReportLazyQueryHookResult = ReturnType<typeof usePropelPaymentsGroupByMetricReportLazyQuery>;
export type PropelPaymentsGroupByMetricReportQueryResult = Apollo.QueryResult<PropelPaymentsGroupByMetricReportQuery, PropelPaymentsGroupByMetricReportQueryVariables>;
export const PaymentQueryInputParamsDocument = gql`
    query PaymentQueryInputParams {
  currentUser {
    id
    vendor {
      id
      vendor_type
    }
  }
}
    `;

/**
 * __usePaymentQueryInputParamsQuery__
 *
 * To run a query within a React component, call `usePaymentQueryInputParamsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentQueryInputParamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentQueryInputParamsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePaymentQueryInputParamsQuery(baseOptions?: Apollo.QueryHookOptions<PaymentQueryInputParamsQuery, PaymentQueryInputParamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentQueryInputParamsQuery, PaymentQueryInputParamsQueryVariables>(PaymentQueryInputParamsDocument, options);
      }
export function usePaymentQueryInputParamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentQueryInputParamsQuery, PaymentQueryInputParamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentQueryInputParamsQuery, PaymentQueryInputParamsQueryVariables>(PaymentQueryInputParamsDocument, options);
        }
export type PaymentQueryInputParamsQueryHookResult = ReturnType<typeof usePaymentQueryInputParamsQuery>;
export type PaymentQueryInputParamsLazyQueryHookResult = ReturnType<typeof usePaymentQueryInputParamsLazyQuery>;
export type PaymentQueryInputParamsQueryResult = Apollo.QueryResult<PaymentQueryInputParamsQuery, PaymentQueryInputParamsQueryVariables>;
export const ProspectSingleCompanyDetailsDocument = gql`
    query ProspectSingleCompanyDetails($vendorId: String!, $domain: String!) {
  prospectCompanyDetails(vendor_id: $vendorId, domain: $domain) {
    data {
      domain
      score_aws
      score_azure
      score_gcp
      company_name
      new_high_info {
        clouds
        domain
        new_score
      }
    }
  }
}
    `;

/**
 * __useProspectSingleCompanyDetailsQuery__
 *
 * To run a query within a React component, call `useProspectSingleCompanyDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProspectSingleCompanyDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProspectSingleCompanyDetailsQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *      domain: // value for 'domain'
 *   },
 * });
 */
export function useProspectSingleCompanyDetailsQuery(baseOptions: Apollo.QueryHookOptions<ProspectSingleCompanyDetailsQuery, ProspectSingleCompanyDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProspectSingleCompanyDetailsQuery, ProspectSingleCompanyDetailsQueryVariables>(ProspectSingleCompanyDetailsDocument, options);
      }
export function useProspectSingleCompanyDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProspectSingleCompanyDetailsQuery, ProspectSingleCompanyDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProspectSingleCompanyDetailsQuery, ProspectSingleCompanyDetailsQueryVariables>(ProspectSingleCompanyDetailsDocument, options);
        }
export type ProspectSingleCompanyDetailsQueryHookResult = ReturnType<typeof useProspectSingleCompanyDetailsQuery>;
export type ProspectSingleCompanyDetailsLazyQueryHookResult = ReturnType<typeof useProspectSingleCompanyDetailsLazyQuery>;
export type ProspectSingleCompanyDetailsQueryResult = Apollo.QueryResult<ProspectSingleCompanyDetailsQuery, ProspectSingleCompanyDetailsQueryVariables>;
export const ProspectHasAgreedToTermsDocument = gql`
    query ProspectHasAgreedToTerms($vendorId: String!) {
  prospectHasAgreedToTerms(vendor_id: $vendorId) {
    has_agreed
  }
}
    `;

/**
 * __useProspectHasAgreedToTermsQuery__
 *
 * To run a query within a React component, call `useProspectHasAgreedToTermsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProspectHasAgreedToTermsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProspectHasAgreedToTermsQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *   },
 * });
 */
export function useProspectHasAgreedToTermsQuery(baseOptions: Apollo.QueryHookOptions<ProspectHasAgreedToTermsQuery, ProspectHasAgreedToTermsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProspectHasAgreedToTermsQuery, ProspectHasAgreedToTermsQueryVariables>(ProspectHasAgreedToTermsDocument, options);
      }
export function useProspectHasAgreedToTermsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProspectHasAgreedToTermsQuery, ProspectHasAgreedToTermsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProspectHasAgreedToTermsQuery, ProspectHasAgreedToTermsQueryVariables>(ProspectHasAgreedToTermsDocument, options);
        }
export type ProspectHasAgreedToTermsQueryHookResult = ReturnType<typeof useProspectHasAgreedToTermsQuery>;
export type ProspectHasAgreedToTermsLazyQueryHookResult = ReturnType<typeof useProspectHasAgreedToTermsLazyQuery>;
export type ProspectHasAgreedToTermsQueryResult = Apollo.QueryResult<ProspectHasAgreedToTermsQuery, ProspectHasAgreedToTermsQueryVariables>;
export const ProspectScoringJobDocument = gql`
    query ProspectScoringJob($vendorId: String!) {
  prospectScoringJob(vendor_id: $vendorId) {
    data {
      job_id
      batch_id
      vendor_id
      status
      domain_count
      create_date
      complete_date
    }
  }
}
    `;

/**
 * __useProspectScoringJobQuery__
 *
 * To run a query within a React component, call `useProspectScoringJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useProspectScoringJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProspectScoringJobQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *   },
 * });
 */
export function useProspectScoringJobQuery(baseOptions: Apollo.QueryHookOptions<ProspectScoringJobQuery, ProspectScoringJobQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProspectScoringJobQuery, ProspectScoringJobQueryVariables>(ProspectScoringJobDocument, options);
      }
export function useProspectScoringJobLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProspectScoringJobQuery, ProspectScoringJobQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProspectScoringJobQuery, ProspectScoringJobQueryVariables>(ProspectScoringJobDocument, options);
        }
export type ProspectScoringJobQueryHookResult = ReturnType<typeof useProspectScoringJobQuery>;
export type ProspectScoringJobLazyQueryHookResult = ReturnType<typeof useProspectScoringJobLazyQuery>;
export type ProspectScoringJobQueryResult = Apollo.QueryResult<ProspectScoringJobQuery, ProspectScoringJobQueryVariables>;
export const ProspectOpportunitiesCountByMarketplaceDocument = gql`
    query ProspectOpportunitiesCountByMarketplace($vendorId: String!) {
  prospectOpportunitiesCountByMarketplace(vendor_id: $vendorId) {
    data {
      aws
      azure
      gcp
      not_listed_on
    }
  }
}
    `;

/**
 * __useProspectOpportunitiesCountByMarketplaceQuery__
 *
 * To run a query within a React component, call `useProspectOpportunitiesCountByMarketplaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useProspectOpportunitiesCountByMarketplaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProspectOpportunitiesCountByMarketplaceQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *   },
 * });
 */
export function useProspectOpportunitiesCountByMarketplaceQuery(baseOptions: Apollo.QueryHookOptions<ProspectOpportunitiesCountByMarketplaceQuery, ProspectOpportunitiesCountByMarketplaceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProspectOpportunitiesCountByMarketplaceQuery, ProspectOpportunitiesCountByMarketplaceQueryVariables>(ProspectOpportunitiesCountByMarketplaceDocument, options);
      }
export function useProspectOpportunitiesCountByMarketplaceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProspectOpportunitiesCountByMarketplaceQuery, ProspectOpportunitiesCountByMarketplaceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProspectOpportunitiesCountByMarketplaceQuery, ProspectOpportunitiesCountByMarketplaceQueryVariables>(ProspectOpportunitiesCountByMarketplaceDocument, options);
        }
export type ProspectOpportunitiesCountByMarketplaceQueryHookResult = ReturnType<typeof useProspectOpportunitiesCountByMarketplaceQuery>;
export type ProspectOpportunitiesCountByMarketplaceLazyQueryHookResult = ReturnType<typeof useProspectOpportunitiesCountByMarketplaceLazyQuery>;
export type ProspectOpportunitiesCountByMarketplaceQueryResult = Apollo.QueryResult<ProspectOpportunitiesCountByMarketplaceQuery, ProspectOpportunitiesCountByMarketplaceQueryVariables>;
export const ProspectCompanyDetailsDocument = gql`
    query ProspectCompanyDetails($vendorId: String!, $domain: String!) {
  prospectCompanyDetails(vendor_id: $vendorId, domain: $domain) {
    data {
      domain
      score_aws
      score_azure
      score_gcp
      company_name
      region
      revenue_band
      primary_industry
      new_high_info {
        clouds
        domain
      }
      offerCount
      offers {
        cloud
        status
        id
        po_id
      }
    }
  }
}
    `;

/**
 * __useProspectCompanyDetailsQuery__
 *
 * To run a query within a React component, call `useProspectCompanyDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProspectCompanyDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProspectCompanyDetailsQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *      domain: // value for 'domain'
 *   },
 * });
 */
export function useProspectCompanyDetailsQuery(baseOptions: Apollo.QueryHookOptions<ProspectCompanyDetailsQuery, ProspectCompanyDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProspectCompanyDetailsQuery, ProspectCompanyDetailsQueryVariables>(ProspectCompanyDetailsDocument, options);
      }
export function useProspectCompanyDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProspectCompanyDetailsQuery, ProspectCompanyDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProspectCompanyDetailsQuery, ProspectCompanyDetailsQueryVariables>(ProspectCompanyDetailsDocument, options);
        }
export type ProspectCompanyDetailsQueryHookResult = ReturnType<typeof useProspectCompanyDetailsQuery>;
export type ProspectCompanyDetailsLazyQueryHookResult = ReturnType<typeof useProspectCompanyDetailsLazyQuery>;
export type ProspectCompanyDetailsQueryResult = Apollo.QueryResult<ProspectCompanyDetailsQuery, ProspectCompanyDetailsQueryVariables>;
export const ProspectExplainabilityByCloudDocument = gql`
    query ProspectExplainabilityByCloud($vendorId: String!, $cloud: String!) {
  prospectDefaultFeatureImportance(vendor_id: $vendorId, cloud: $cloud) {
    data {
      bucket_definition
      bucket
    }
  }
}
    `;

/**
 * __useProspectExplainabilityByCloudQuery__
 *
 * To run a query within a React component, call `useProspectExplainabilityByCloudQuery` and pass it any options that fit your needs.
 * When your component renders, `useProspectExplainabilityByCloudQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProspectExplainabilityByCloudQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *      cloud: // value for 'cloud'
 *   },
 * });
 */
export function useProspectExplainabilityByCloudQuery(baseOptions: Apollo.QueryHookOptions<ProspectExplainabilityByCloudQuery, ProspectExplainabilityByCloudQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProspectExplainabilityByCloudQuery, ProspectExplainabilityByCloudQueryVariables>(ProspectExplainabilityByCloudDocument, options);
      }
export function useProspectExplainabilityByCloudLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProspectExplainabilityByCloudQuery, ProspectExplainabilityByCloudQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProspectExplainabilityByCloudQuery, ProspectExplainabilityByCloudQueryVariables>(ProspectExplainabilityByCloudDocument, options);
        }
export type ProspectExplainabilityByCloudQueryHookResult = ReturnType<typeof useProspectExplainabilityByCloudQuery>;
export type ProspectExplainabilityByCloudLazyQueryHookResult = ReturnType<typeof useProspectExplainabilityByCloudLazyQuery>;
export type ProspectExplainabilityByCloudQueryResult = Apollo.QueryResult<ProspectExplainabilityByCloudQuery, ProspectExplainabilityByCloudQueryVariables>;
export const SubmitProspectAccountForScoringDocument = gql`
    mutation SubmitProspectAccountForScoring($data: ProspectAccountForScoringInput!) {
  submitProspectAccountForScoring(data: $data) {
    data {
      __typename
      ... on ProspectAccountResult {
        domain
        score_aws
        score_azure
        score_gcp
        region
        revenue_band
        primary_industry
        company_name
      }
    }
    metadata
  }
}
    `;
export type SubmitProspectAccountForScoringMutationFn = Apollo.MutationFunction<SubmitProspectAccountForScoringMutation, SubmitProspectAccountForScoringMutationVariables>;

/**
 * __useSubmitProspectAccountForScoringMutation__
 *
 * To run a mutation, you first call `useSubmitProspectAccountForScoringMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitProspectAccountForScoringMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitProspectAccountForScoringMutation, { data, loading, error }] = useSubmitProspectAccountForScoringMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSubmitProspectAccountForScoringMutation(baseOptions?: Apollo.MutationHookOptions<SubmitProspectAccountForScoringMutation, SubmitProspectAccountForScoringMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitProspectAccountForScoringMutation, SubmitProspectAccountForScoringMutationVariables>(SubmitProspectAccountForScoringDocument, options);
      }
export type SubmitProspectAccountForScoringMutationHookResult = ReturnType<typeof useSubmitProspectAccountForScoringMutation>;
export type SubmitProspectAccountForScoringMutationResult = Apollo.MutationResult<SubmitProspectAccountForScoringMutation>;
export type SubmitProspectAccountForScoringMutationOptions = Apollo.BaseMutationOptions<SubmitProspectAccountForScoringMutation, SubmitProspectAccountForScoringMutationVariables>;
export const PostProspectAgreeToTermsDocument = gql`
    mutation PostProspectAgreeToTerms($data: ProspectAgreeToTermsInput!) {
  postProspectAgreeToTerms(data: $data) {
    has_agreed
  }
}
    `;
export type PostProspectAgreeToTermsMutationFn = Apollo.MutationFunction<PostProspectAgreeToTermsMutation, PostProspectAgreeToTermsMutationVariables>;

/**
 * __usePostProspectAgreeToTermsMutation__
 *
 * To run a mutation, you first call `usePostProspectAgreeToTermsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostProspectAgreeToTermsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postProspectAgreeToTermsMutation, { data, loading, error }] = usePostProspectAgreeToTermsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function usePostProspectAgreeToTermsMutation(baseOptions?: Apollo.MutationHookOptions<PostProspectAgreeToTermsMutation, PostProspectAgreeToTermsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PostProspectAgreeToTermsMutation, PostProspectAgreeToTermsMutationVariables>(PostProspectAgreeToTermsDocument, options);
      }
export type PostProspectAgreeToTermsMutationHookResult = ReturnType<typeof usePostProspectAgreeToTermsMutation>;
export type PostProspectAgreeToTermsMutationResult = Apollo.MutationResult<PostProspectAgreeToTermsMutation>;
export type PostProspectAgreeToTermsMutationOptions = Apollo.BaseMutationOptions<PostProspectAgreeToTermsMutation, PostProspectAgreeToTermsMutationVariables>;
export const CreateProspectPresignedUrlDocument = gql`
    mutation CreateProspectPresignedUrl($data: ProspectPresignedUrlInput!) {
  createProspectPresignedUrl(data: $data) {
    data {
      expires_in
      s3_key
      url
      use
      batch_metadata {
        batch_id
        batch_name
      }
    }
  }
}
    `;
export type CreateProspectPresignedUrlMutationFn = Apollo.MutationFunction<CreateProspectPresignedUrlMutation, CreateProspectPresignedUrlMutationVariables>;

/**
 * __useCreateProspectPresignedUrlMutation__
 *
 * To run a mutation, you first call `useCreateProspectPresignedUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProspectPresignedUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProspectPresignedUrlMutation, { data, loading, error }] = useCreateProspectPresignedUrlMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateProspectPresignedUrlMutation(baseOptions?: Apollo.MutationHookOptions<CreateProspectPresignedUrlMutation, CreateProspectPresignedUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProspectPresignedUrlMutation, CreateProspectPresignedUrlMutationVariables>(CreateProspectPresignedUrlDocument, options);
      }
export type CreateProspectPresignedUrlMutationHookResult = ReturnType<typeof useCreateProspectPresignedUrlMutation>;
export type CreateProspectPresignedUrlMutationResult = Apollo.MutationResult<CreateProspectPresignedUrlMutation>;
export type CreateProspectPresignedUrlMutationOptions = Apollo.BaseMutationOptions<CreateProspectPresignedUrlMutation, CreateProspectPresignedUrlMutationVariables>;
export const SubmitProspectFileForScoringDocument = gql`
    mutation SubmitProspectFileForScoring($data: ProspectFileForScoringInput!) {
  submitProspectFileForScoring(data: $data) {
    data {
      batch_id
      raw_file_key
      raw_file_bucket
      scored_file_key
      scored_file_bucket
    }
    metadata {
      warnings {
        message
        invalid_domains
      }
    }
  }
}
    `;
export type SubmitProspectFileForScoringMutationFn = Apollo.MutationFunction<SubmitProspectFileForScoringMutation, SubmitProspectFileForScoringMutationVariables>;

/**
 * __useSubmitProspectFileForScoringMutation__
 *
 * To run a mutation, you first call `useSubmitProspectFileForScoringMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitProspectFileForScoringMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitProspectFileForScoringMutation, { data, loading, error }] = useSubmitProspectFileForScoringMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSubmitProspectFileForScoringMutation(baseOptions?: Apollo.MutationHookOptions<SubmitProspectFileForScoringMutation, SubmitProspectFileForScoringMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitProspectFileForScoringMutation, SubmitProspectFileForScoringMutationVariables>(SubmitProspectFileForScoringDocument, options);
      }
export type SubmitProspectFileForScoringMutationHookResult = ReturnType<typeof useSubmitProspectFileForScoringMutation>;
export type SubmitProspectFileForScoringMutationResult = Apollo.MutationResult<SubmitProspectFileForScoringMutation>;
export type SubmitProspectFileForScoringMutationOptions = Apollo.BaseMutationOptions<SubmitProspectFileForScoringMutation, SubmitProspectFileForScoringMutationVariables>;
export const ProspectRollupStatisticsDocument = gql`
    query ProspectRollupStatistics($data: FilterProspectAccountsInput!) {
  prospectRollupStatisticsV2(data: $data) {
    data {
      total_domains
      aws: aws_rollup {
        count_high
        count_medium
        count_low
      }
      microsoft: azure_rollup {
        count_high
        count_medium
        count_low
      }
      gcp: gcp_rollup {
        count_high
        count_medium
        count_low
      }
    }
  }
}
    `;

/**
 * __useProspectRollupStatisticsQuery__
 *
 * To run a query within a React component, call `useProspectRollupStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProspectRollupStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProspectRollupStatisticsQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useProspectRollupStatisticsQuery(baseOptions: Apollo.QueryHookOptions<ProspectRollupStatisticsQuery, ProspectRollupStatisticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProspectRollupStatisticsQuery, ProspectRollupStatisticsQueryVariables>(ProspectRollupStatisticsDocument, options);
      }
export function useProspectRollupStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProspectRollupStatisticsQuery, ProspectRollupStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProspectRollupStatisticsQuery, ProspectRollupStatisticsQueryVariables>(ProspectRollupStatisticsDocument, options);
        }
export type ProspectRollupStatisticsQueryHookResult = ReturnType<typeof useProspectRollupStatisticsQuery>;
export type ProspectRollupStatisticsLazyQueryHookResult = ReturnType<typeof useProspectRollupStatisticsLazyQuery>;
export type ProspectRollupStatisticsQueryResult = Apollo.QueryResult<ProspectRollupStatisticsQuery, ProspectRollupStatisticsQueryVariables>;
export const ProspectScoringBatchesDocument = gql`
    query ProspectScoringBatches($vendorId: String!) {
  prospectScoringBatches(vendor_id: $vendorId) {
    data {
      batch_id
      batch_name
      domain_count
      run_date
    }
  }
}
    `;

/**
 * __useProspectScoringBatchesQuery__
 *
 * To run a query within a React component, call `useProspectScoringBatchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProspectScoringBatchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProspectScoringBatchesQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *   },
 * });
 */
export function useProspectScoringBatchesQuery(baseOptions: Apollo.QueryHookOptions<ProspectScoringBatchesQuery, ProspectScoringBatchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProspectScoringBatchesQuery, ProspectScoringBatchesQueryVariables>(ProspectScoringBatchesDocument, options);
      }
export function useProspectScoringBatchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProspectScoringBatchesQuery, ProspectScoringBatchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProspectScoringBatchesQuery, ProspectScoringBatchesQueryVariables>(ProspectScoringBatchesDocument, options);
        }
export type ProspectScoringBatchesQueryHookResult = ReturnType<typeof useProspectScoringBatchesQuery>;
export type ProspectScoringBatchesLazyQueryHookResult = ReturnType<typeof useProspectScoringBatchesLazyQuery>;
export type ProspectScoringBatchesQueryResult = Apollo.QueryResult<ProspectScoringBatchesQuery, ProspectScoringBatchesQueryVariables>;
export const ProspectAccountScoresDocument = gql`
    query ProspectAccountScores($data: FilterProspectAccountsInput!) {
  prospectScoresByVendorIdV2(data: $data) {
    data {
      domain
      company_name
      score_aws
      score_azure
      score_gcp
      newHighs {
        aws
        gcp
        azure
      }
      region
      revenue_band
      primary_industry
      offerCount
      offers {
        id
        po_id
      }
    }
    metadata {
      next_page
      previous_page
      current_page_number
      current_page_record_count
      total_record_count
    }
  }
}
    `;

/**
 * __useProspectAccountScoresQuery__
 *
 * To run a query within a React component, call `useProspectAccountScoresQuery` and pass it any options that fit your needs.
 * When your component renders, `useProspectAccountScoresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProspectAccountScoresQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useProspectAccountScoresQuery(baseOptions: Apollo.QueryHookOptions<ProspectAccountScoresQuery, ProspectAccountScoresQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProspectAccountScoresQuery, ProspectAccountScoresQueryVariables>(ProspectAccountScoresDocument, options);
      }
export function useProspectAccountScoresLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProspectAccountScoresQuery, ProspectAccountScoresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProspectAccountScoresQuery, ProspectAccountScoresQueryVariables>(ProspectAccountScoresDocument, options);
        }
export type ProspectAccountScoresQueryHookResult = ReturnType<typeof useProspectAccountScoresQuery>;
export type ProspectAccountScoresLazyQueryHookResult = ReturnType<typeof useProspectAccountScoresLazyQuery>;
export type ProspectAccountScoresQueryResult = Apollo.QueryResult<ProspectAccountScoresQuery, ProspectAccountScoresQueryVariables>;
export const ProspectRollupStatisticsTotalDomainsDocument = gql`
    query ProspectRollupStatisticsTotalDomains($vendorId: String!) {
  prospectRollupStatistics(vendor_id: $vendorId) {
    data {
      total_domains
      newHighs: new_highs
    }
  }
}
    `;

/**
 * __useProspectRollupStatisticsTotalDomainsQuery__
 *
 * To run a query within a React component, call `useProspectRollupStatisticsTotalDomainsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProspectRollupStatisticsTotalDomainsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProspectRollupStatisticsTotalDomainsQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *   },
 * });
 */
export function useProspectRollupStatisticsTotalDomainsQuery(baseOptions: Apollo.QueryHookOptions<ProspectRollupStatisticsTotalDomainsQuery, ProspectRollupStatisticsTotalDomainsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProspectRollupStatisticsTotalDomainsQuery, ProspectRollupStatisticsTotalDomainsQueryVariables>(ProspectRollupStatisticsTotalDomainsDocument, options);
      }
export function useProspectRollupStatisticsTotalDomainsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProspectRollupStatisticsTotalDomainsQuery, ProspectRollupStatisticsTotalDomainsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProspectRollupStatisticsTotalDomainsQuery, ProspectRollupStatisticsTotalDomainsQueryVariables>(ProspectRollupStatisticsTotalDomainsDocument, options);
        }
export type ProspectRollupStatisticsTotalDomainsQueryHookResult = ReturnType<typeof useProspectRollupStatisticsTotalDomainsQuery>;
export type ProspectRollupStatisticsTotalDomainsLazyQueryHookResult = ReturnType<typeof useProspectRollupStatisticsTotalDomainsLazyQuery>;
export type ProspectRollupStatisticsTotalDomainsQueryResult = Apollo.QueryResult<ProspectRollupStatisticsTotalDomainsQuery, ProspectRollupStatisticsTotalDomainsQueryVariables>;
export const ProspectMiissingOpportunitiesDocument = gql`
    query ProspectMiissingOpportunities($vendorId: String!) {
  prospectMissingOpportunities(vendor_id: $vendorId) {
    data
  }
}
    `;

/**
 * __useProspectMiissingOpportunitiesQuery__
 *
 * To run a query within a React component, call `useProspectMiissingOpportunitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProspectMiissingOpportunitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProspectMiissingOpportunitiesQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *   },
 * });
 */
export function useProspectMiissingOpportunitiesQuery(baseOptions: Apollo.QueryHookOptions<ProspectMiissingOpportunitiesQuery, ProspectMiissingOpportunitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProspectMiissingOpportunitiesQuery, ProspectMiissingOpportunitiesQueryVariables>(ProspectMiissingOpportunitiesDocument, options);
      }
export function useProspectMiissingOpportunitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProspectMiissingOpportunitiesQuery, ProspectMiissingOpportunitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProspectMiissingOpportunitiesQuery, ProspectMiissingOpportunitiesQueryVariables>(ProspectMiissingOpportunitiesDocument, options);
        }
export type ProspectMiissingOpportunitiesQueryHookResult = ReturnType<typeof useProspectMiissingOpportunitiesQuery>;
export type ProspectMiissingOpportunitiesLazyQueryHookResult = ReturnType<typeof useProspectMiissingOpportunitiesLazyQuery>;
export type ProspectMiissingOpportunitiesQueryResult = Apollo.QueryResult<ProspectMiissingOpportunitiesQuery, ProspectMiissingOpportunitiesQueryVariables>;
export const ProspectFilterValuesDocument = gql`
    query ProspectFilterValues($vendorId: String!) {
  prospectFilterValues(vendor_id: $vendorId) {
    data {
      primary_industries
      revenue_bands
      regions
    }
  }
}
    `;

/**
 * __useProspectFilterValuesQuery__
 *
 * To run a query within a React component, call `useProspectFilterValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProspectFilterValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProspectFilterValuesQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *   },
 * });
 */
export function useProspectFilterValuesQuery(baseOptions: Apollo.QueryHookOptions<ProspectFilterValuesQuery, ProspectFilterValuesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProspectFilterValuesQuery, ProspectFilterValuesQueryVariables>(ProspectFilterValuesDocument, options);
      }
export function useProspectFilterValuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProspectFilterValuesQuery, ProspectFilterValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProspectFilterValuesQuery, ProspectFilterValuesQueryVariables>(ProspectFilterValuesDocument, options);
        }
export type ProspectFilterValuesQueryHookResult = ReturnType<typeof useProspectFilterValuesQuery>;
export type ProspectFilterValuesLazyQueryHookResult = ReturnType<typeof useProspectFilterValuesLazyQuery>;
export type ProspectFilterValuesQueryResult = Apollo.QueryResult<ProspectFilterValuesQuery, ProspectFilterValuesQueryVariables>;
export const BillingInfoDocument = gql`
    query BillingInfo($metricNameTackleManaged: String!, $timeRange: TimeRangeInput!, $filterSql: String!) {
  tackleManaged: metricByName(uniqueName: $metricNameTackleManaged) {
    id
    counter(input: {timeRange: $timeRange, filterSql: $filterSql}) {
      value
    }
  }
}
    `;

/**
 * __useBillingInfoQuery__
 *
 * To run a query within a React component, call `useBillingInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillingInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillingInfoQuery({
 *   variables: {
 *      metricNameTackleManaged: // value for 'metricNameTackleManaged'
 *      timeRange: // value for 'timeRange'
 *      filterSql: // value for 'filterSql'
 *   },
 * });
 */
export function useBillingInfoQuery(baseOptions: Apollo.QueryHookOptions<BillingInfoQuery, BillingInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BillingInfoQuery, BillingInfoQueryVariables>(BillingInfoDocument, options);
      }
export function useBillingInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BillingInfoQuery, BillingInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BillingInfoQuery, BillingInfoQueryVariables>(BillingInfoDocument, options);
        }
export type BillingInfoQueryHookResult = ReturnType<typeof useBillingInfoQuery>;
export type BillingInfoLazyQueryHookResult = ReturnType<typeof useBillingInfoLazyQuery>;
export type BillingInfoQueryResult = Apollo.QueryResult<BillingInfoQuery, BillingInfoQueryVariables>;
export const BillingInfoContainerDocument = gql`
    query BillingInfoContainer {
  currentUser {
    id
    vendor {
      id
      vendor_type
    }
  }
}
    `;

/**
 * __useBillingInfoContainerQuery__
 *
 * To run a query within a React component, call `useBillingInfoContainerQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillingInfoContainerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillingInfoContainerQuery({
 *   variables: {
 *   },
 * });
 */
export function useBillingInfoContainerQuery(baseOptions?: Apollo.QueryHookOptions<BillingInfoContainerQuery, BillingInfoContainerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BillingInfoContainerQuery, BillingInfoContainerQueryVariables>(BillingInfoContainerDocument, options);
      }
export function useBillingInfoContainerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BillingInfoContainerQuery, BillingInfoContainerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BillingInfoContainerQuery, BillingInfoContainerQueryVariables>(BillingInfoContainerDocument, options);
        }
export type BillingInfoContainerQueryHookResult = ReturnType<typeof useBillingInfoContainerQuery>;
export type BillingInfoContainerLazyQueryHookResult = ReturnType<typeof useBillingInfoContainerLazyQuery>;
export type BillingInfoContainerQueryResult = Apollo.QueryResult<BillingInfoContainerQuery, BillingInfoContainerQueryVariables>;
export const CanAccessBillingDocument = gql`
    query canAccessBilling {
  currentUser {
    id
    isSuperAdmin
    vendor {
      id
      feature_flags {
        is_co_sell_enabled
        is_co_sell_enabled_for_microsoft
        is_prospect_enabled
        is_marketplace_enabled
        is_listings_enabled
      }
    }
  }
}
    `;

/**
 * __useCanAccessBillingQuery__
 *
 * To run a query within a React component, call `useCanAccessBillingQuery` and pass it any options that fit your needs.
 * When your component renders, `useCanAccessBillingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCanAccessBillingQuery({
 *   variables: {
 *   },
 * });
 */
export function useCanAccessBillingQuery(baseOptions?: Apollo.QueryHookOptions<CanAccessBillingQuery, CanAccessBillingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CanAccessBillingQuery, CanAccessBillingQueryVariables>(CanAccessBillingDocument, options);
      }
export function useCanAccessBillingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CanAccessBillingQuery, CanAccessBillingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CanAccessBillingQuery, CanAccessBillingQueryVariables>(CanAccessBillingDocument, options);
        }
export type CanAccessBillingQueryHookResult = ReturnType<typeof useCanAccessBillingQuery>;
export type CanAccessBillingLazyQueryHookResult = ReturnType<typeof useCanAccessBillingLazyQuery>;
export type CanAccessBillingQueryResult = Apollo.QueryResult<CanAccessBillingQuery, CanAccessBillingQueryVariables>;
export const CoSellSettingsAwsBackfillMapCoSellsToSalesforceGetVendorDocument = gql`
    query CoSellSettingsAwsBackfillMapCoSellsToSalesforceGetVendor {
  currentUser {
    id
    vendor {
      id
      coSell {
        id
        vendorId
      }
    }
  }
}
    `;

/**
 * __useCoSellSettingsAwsBackfillMapCoSellsToSalesforceGetVendorQuery__
 *
 * To run a query within a React component, call `useCoSellSettingsAwsBackfillMapCoSellsToSalesforceGetVendorQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoSellSettingsAwsBackfillMapCoSellsToSalesforceGetVendorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoSellSettingsAwsBackfillMapCoSellsToSalesforceGetVendorQuery({
 *   variables: {
 *   },
 * });
 */
export function useCoSellSettingsAwsBackfillMapCoSellsToSalesforceGetVendorQuery(baseOptions?: Apollo.QueryHookOptions<CoSellSettingsAwsBackfillMapCoSellsToSalesforceGetVendorQuery, CoSellSettingsAwsBackfillMapCoSellsToSalesforceGetVendorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CoSellSettingsAwsBackfillMapCoSellsToSalesforceGetVendorQuery, CoSellSettingsAwsBackfillMapCoSellsToSalesforceGetVendorQueryVariables>(CoSellSettingsAwsBackfillMapCoSellsToSalesforceGetVendorDocument, options);
      }
export function useCoSellSettingsAwsBackfillMapCoSellsToSalesforceGetVendorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CoSellSettingsAwsBackfillMapCoSellsToSalesforceGetVendorQuery, CoSellSettingsAwsBackfillMapCoSellsToSalesforceGetVendorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CoSellSettingsAwsBackfillMapCoSellsToSalesforceGetVendorQuery, CoSellSettingsAwsBackfillMapCoSellsToSalesforceGetVendorQueryVariables>(CoSellSettingsAwsBackfillMapCoSellsToSalesforceGetVendorDocument, options);
        }
export type CoSellSettingsAwsBackfillMapCoSellsToSalesforceGetVendorQueryHookResult = ReturnType<typeof useCoSellSettingsAwsBackfillMapCoSellsToSalesforceGetVendorQuery>;
export type CoSellSettingsAwsBackfillMapCoSellsToSalesforceGetVendorLazyQueryHookResult = ReturnType<typeof useCoSellSettingsAwsBackfillMapCoSellsToSalesforceGetVendorLazyQuery>;
export type CoSellSettingsAwsBackfillMapCoSellsToSalesforceGetVendorQueryResult = Apollo.QueryResult<CoSellSettingsAwsBackfillMapCoSellsToSalesforceGetVendorQuery, CoSellSettingsAwsBackfillMapCoSellsToSalesforceGetVendorQueryVariables>;
export const CoSellSettingsAwsBackfillMapCoSellsToSalesforceDocument = gql`
    mutation CoSellSettingsAwsBackfillMapCoSellsToSalesforce($vendorId: ID!, $cloud: String!, $data: String!) {
  linkCloudOpportunitiesToSalesforceOpportunities(
    id: $vendorId
    cloud: $cloud
    data: $data
  ) {
    success
    failure
    errors {
      row
      error
    }
  }
}
    `;
export type CoSellSettingsAwsBackfillMapCoSellsToSalesforceMutationFn = Apollo.MutationFunction<CoSellSettingsAwsBackfillMapCoSellsToSalesforceMutation, CoSellSettingsAwsBackfillMapCoSellsToSalesforceMutationVariables>;

/**
 * __useCoSellSettingsAwsBackfillMapCoSellsToSalesforceMutation__
 *
 * To run a mutation, you first call `useCoSellSettingsAwsBackfillMapCoSellsToSalesforceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCoSellSettingsAwsBackfillMapCoSellsToSalesforceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [coSellSettingsAwsBackfillMapCoSellsToSalesforceMutation, { data, loading, error }] = useCoSellSettingsAwsBackfillMapCoSellsToSalesforceMutation({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *      cloud: // value for 'cloud'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCoSellSettingsAwsBackfillMapCoSellsToSalesforceMutation(baseOptions?: Apollo.MutationHookOptions<CoSellSettingsAwsBackfillMapCoSellsToSalesforceMutation, CoSellSettingsAwsBackfillMapCoSellsToSalesforceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CoSellSettingsAwsBackfillMapCoSellsToSalesforceMutation, CoSellSettingsAwsBackfillMapCoSellsToSalesforceMutationVariables>(CoSellSettingsAwsBackfillMapCoSellsToSalesforceDocument, options);
      }
export type CoSellSettingsAwsBackfillMapCoSellsToSalesforceMutationHookResult = ReturnType<typeof useCoSellSettingsAwsBackfillMapCoSellsToSalesforceMutation>;
export type CoSellSettingsAwsBackfillMapCoSellsToSalesforceMutationResult = Apollo.MutationResult<CoSellSettingsAwsBackfillMapCoSellsToSalesforceMutation>;
export type CoSellSettingsAwsBackfillMapCoSellsToSalesforceMutationOptions = Apollo.BaseMutationOptions<CoSellSettingsAwsBackfillMapCoSellsToSalesforceMutation, CoSellSettingsAwsBackfillMapCoSellsToSalesforceMutationVariables>;
export const CoSellSettingsAwsAceDocument = gql`
    query CoSellSettingsAwsAce {
  currentUser {
    id
    vendor {
      id
      configuration {
        aws {
          assume_role {
            role_arn
          }
        }
      }
      coSell {
        id
        ace_bucket
        ace_spms_id
        ace_kms_key
        sandbox_arn
      }
    }
  }
}
    `;

/**
 * __useCoSellSettingsAwsAceQuery__
 *
 * To run a query within a React component, call `useCoSellSettingsAwsAceQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoSellSettingsAwsAceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoSellSettingsAwsAceQuery({
 *   variables: {
 *   },
 * });
 */
export function useCoSellSettingsAwsAceQuery(baseOptions?: Apollo.QueryHookOptions<CoSellSettingsAwsAceQuery, CoSellSettingsAwsAceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CoSellSettingsAwsAceQuery, CoSellSettingsAwsAceQueryVariables>(CoSellSettingsAwsAceDocument, options);
      }
export function useCoSellSettingsAwsAceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CoSellSettingsAwsAceQuery, CoSellSettingsAwsAceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CoSellSettingsAwsAceQuery, CoSellSettingsAwsAceQueryVariables>(CoSellSettingsAwsAceDocument, options);
        }
export type CoSellSettingsAwsAceQueryHookResult = ReturnType<typeof useCoSellSettingsAwsAceQuery>;
export type CoSellSettingsAwsAceLazyQueryHookResult = ReturnType<typeof useCoSellSettingsAwsAceLazyQuery>;
export type CoSellSettingsAwsAceQueryResult = Apollo.QueryResult<CoSellSettingsAwsAceQuery, CoSellSettingsAwsAceQueryVariables>;
export const UpdateCoSellVendorCoSellSettingsAwsAceDocument = gql`
    mutation UpdateCoSellVendorCoSellSettingsAwsAce($updates: CoSellVendorInput!) {
  updateCoSellVendor(updates: $updates) {
    id
    ace_bucket
    ace_spms_id
    ace_kms_key
  }
}
    `;
export type UpdateCoSellVendorCoSellSettingsAwsAceMutationFn = Apollo.MutationFunction<UpdateCoSellVendorCoSellSettingsAwsAceMutation, UpdateCoSellVendorCoSellSettingsAwsAceMutationVariables>;

/**
 * __useUpdateCoSellVendorCoSellSettingsAwsAceMutation__
 *
 * To run a mutation, you first call `useUpdateCoSellVendorCoSellSettingsAwsAceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCoSellVendorCoSellSettingsAwsAceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCoSellVendorCoSellSettingsAwsAceMutation, { data, loading, error }] = useUpdateCoSellVendorCoSellSettingsAwsAceMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateCoSellVendorCoSellSettingsAwsAceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCoSellVendorCoSellSettingsAwsAceMutation, UpdateCoSellVendorCoSellSettingsAwsAceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCoSellVendorCoSellSettingsAwsAceMutation, UpdateCoSellVendorCoSellSettingsAwsAceMutationVariables>(UpdateCoSellVendorCoSellSettingsAwsAceDocument, options);
      }
export type UpdateCoSellVendorCoSellSettingsAwsAceMutationHookResult = ReturnType<typeof useUpdateCoSellVendorCoSellSettingsAwsAceMutation>;
export type UpdateCoSellVendorCoSellSettingsAwsAceMutationResult = Apollo.MutationResult<UpdateCoSellVendorCoSellSettingsAwsAceMutation>;
export type UpdateCoSellVendorCoSellSettingsAwsAceMutationOptions = Apollo.BaseMutationOptions<UpdateCoSellVendorCoSellSettingsAwsAceMutation, UpdateCoSellVendorCoSellSettingsAwsAceMutationVariables>;
export const UpdateAwsVendorCoSellSettingsAwsAceDocument = gql`
    mutation UpdateAwsVendorCoSellSettingsAwsAce($updates: VendorInput!) {
  updateVendor(updates: $updates) {
    id
    onboarding {
      cosell {
        aws_has_launch_stack_button_been_clicked
      }
    }
  }
}
    `;
export type UpdateAwsVendorCoSellSettingsAwsAceMutationFn = Apollo.MutationFunction<UpdateAwsVendorCoSellSettingsAwsAceMutation, UpdateAwsVendorCoSellSettingsAwsAceMutationVariables>;

/**
 * __useUpdateAwsVendorCoSellSettingsAwsAceMutation__
 *
 * To run a mutation, you first call `useUpdateAwsVendorCoSellSettingsAwsAceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAwsVendorCoSellSettingsAwsAceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAwsVendorCoSellSettingsAwsAceMutation, { data, loading, error }] = useUpdateAwsVendorCoSellSettingsAwsAceMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateAwsVendorCoSellSettingsAwsAceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAwsVendorCoSellSettingsAwsAceMutation, UpdateAwsVendorCoSellSettingsAwsAceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAwsVendorCoSellSettingsAwsAceMutation, UpdateAwsVendorCoSellSettingsAwsAceMutationVariables>(UpdateAwsVendorCoSellSettingsAwsAceDocument, options);
      }
export type UpdateAwsVendorCoSellSettingsAwsAceMutationHookResult = ReturnType<typeof useUpdateAwsVendorCoSellSettingsAwsAceMutation>;
export type UpdateAwsVendorCoSellSettingsAwsAceMutationResult = Apollo.MutationResult<UpdateAwsVendorCoSellSettingsAwsAceMutation>;
export type UpdateAwsVendorCoSellSettingsAwsAceMutationOptions = Apollo.BaseMutationOptions<UpdateAwsVendorCoSellSettingsAwsAceMutation, UpdateAwsVendorCoSellSettingsAwsAceMutationVariables>;
export const CoSellSettingsAwsGetStartedDocument = gql`
    query CoSellSettingsAwsGetStarted {
  currentUser {
    id
    vendor {
      id
      onboarding {
        aws {
          account_setup
        }
      }
    }
  }
}
    `;

/**
 * __useCoSellSettingsAwsGetStartedQuery__
 *
 * To run a query within a React component, call `useCoSellSettingsAwsGetStartedQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoSellSettingsAwsGetStartedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoSellSettingsAwsGetStartedQuery({
 *   variables: {
 *   },
 * });
 */
export function useCoSellSettingsAwsGetStartedQuery(baseOptions?: Apollo.QueryHookOptions<CoSellSettingsAwsGetStartedQuery, CoSellSettingsAwsGetStartedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CoSellSettingsAwsGetStartedQuery, CoSellSettingsAwsGetStartedQueryVariables>(CoSellSettingsAwsGetStartedDocument, options);
      }
export function useCoSellSettingsAwsGetStartedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CoSellSettingsAwsGetStartedQuery, CoSellSettingsAwsGetStartedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CoSellSettingsAwsGetStartedQuery, CoSellSettingsAwsGetStartedQueryVariables>(CoSellSettingsAwsGetStartedDocument, options);
        }
export type CoSellSettingsAwsGetStartedQueryHookResult = ReturnType<typeof useCoSellSettingsAwsGetStartedQuery>;
export type CoSellSettingsAwsGetStartedLazyQueryHookResult = ReturnType<typeof useCoSellSettingsAwsGetStartedLazyQuery>;
export type CoSellSettingsAwsGetStartedQueryResult = Apollo.QueryResult<CoSellSettingsAwsGetStartedQuery, CoSellSettingsAwsGetStartedQueryVariables>;
export const UpdateCoSellSettingsAwsGetStartedDocument = gql`
    mutation UpdateCoSellSettingsAwsGetStarted($updates: VendorInput!) {
  updateVendor(updates: $updates) {
    id
    onboarding {
      aws {
        account_setup
      }
    }
  }
}
    `;
export type UpdateCoSellSettingsAwsGetStartedMutationFn = Apollo.MutationFunction<UpdateCoSellSettingsAwsGetStartedMutation, UpdateCoSellSettingsAwsGetStartedMutationVariables>;

/**
 * __useUpdateCoSellSettingsAwsGetStartedMutation__
 *
 * To run a mutation, you first call `useUpdateCoSellSettingsAwsGetStartedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCoSellSettingsAwsGetStartedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCoSellSettingsAwsGetStartedMutation, { data, loading, error }] = useUpdateCoSellSettingsAwsGetStartedMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateCoSellSettingsAwsGetStartedMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCoSellSettingsAwsGetStartedMutation, UpdateCoSellSettingsAwsGetStartedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCoSellSettingsAwsGetStartedMutation, UpdateCoSellSettingsAwsGetStartedMutationVariables>(UpdateCoSellSettingsAwsGetStartedDocument, options);
      }
export type UpdateCoSellSettingsAwsGetStartedMutationHookResult = ReturnType<typeof useUpdateCoSellSettingsAwsGetStartedMutation>;
export type UpdateCoSellSettingsAwsGetStartedMutationResult = Apollo.MutationResult<UpdateCoSellSettingsAwsGetStartedMutation>;
export type UpdateCoSellSettingsAwsGetStartedMutationOptions = Apollo.BaseMutationOptions<UpdateCoSellSettingsAwsGetStartedMutation, UpdateCoSellSettingsAwsGetStartedMutationVariables>;
export const UpdateCoSellSettingsAwsPcEventsDocument = gql`
    mutation UpdateCoSellSettingsAwsPCEvents($updates: VendorInput!) {
  updateVendor(updates: $updates) {
    id
    onboarding {
      cosell {
        aws_has_pc_events_launch_stack_button_been_clicked
      }
    }
  }
}
    `;
export type UpdateCoSellSettingsAwsPcEventsMutationFn = Apollo.MutationFunction<UpdateCoSellSettingsAwsPcEventsMutation, UpdateCoSellSettingsAwsPcEventsMutationVariables>;

/**
 * __useUpdateCoSellSettingsAwsPcEventsMutation__
 *
 * To run a mutation, you first call `useUpdateCoSellSettingsAwsPcEventsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCoSellSettingsAwsPcEventsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCoSellSettingsAwsPcEventsMutation, { data, loading, error }] = useUpdateCoSellSettingsAwsPcEventsMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateCoSellSettingsAwsPcEventsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCoSellSettingsAwsPcEventsMutation, UpdateCoSellSettingsAwsPcEventsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCoSellSettingsAwsPcEventsMutation, UpdateCoSellSettingsAwsPcEventsMutationVariables>(UpdateCoSellSettingsAwsPcEventsDocument, options);
      }
export type UpdateCoSellSettingsAwsPcEventsMutationHookResult = ReturnType<typeof useUpdateCoSellSettingsAwsPcEventsMutation>;
export type UpdateCoSellSettingsAwsPcEventsMutationResult = Apollo.MutationResult<UpdateCoSellSettingsAwsPcEventsMutation>;
export type UpdateCoSellSettingsAwsPcEventsMutationOptions = Apollo.BaseMutationOptions<UpdateCoSellSettingsAwsPcEventsMutation, UpdateCoSellSettingsAwsPcEventsMutationVariables>;
export const CoSellSettingsAwsPcEventsDocument = gql`
    query CoSellSettingsAwsPCEvents {
  currentUser {
    id
    vendor {
      id
      configuration {
        aws {
          assume_role {
            role_arn
          }
        }
      }
      onboarding {
        cosell {
          aws_has_pc_events_launch_stack_button_been_clicked
        }
      }
    }
  }
}
    `;

/**
 * __useCoSellSettingsAwsPcEventsQuery__
 *
 * To run a query within a React component, call `useCoSellSettingsAwsPcEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoSellSettingsAwsPcEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoSellSettingsAwsPcEventsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCoSellSettingsAwsPcEventsQuery(baseOptions?: Apollo.QueryHookOptions<CoSellSettingsAwsPcEventsQuery, CoSellSettingsAwsPcEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CoSellSettingsAwsPcEventsQuery, CoSellSettingsAwsPcEventsQueryVariables>(CoSellSettingsAwsPcEventsDocument, options);
      }
export function useCoSellSettingsAwsPcEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CoSellSettingsAwsPcEventsQuery, CoSellSettingsAwsPcEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CoSellSettingsAwsPcEventsQuery, CoSellSettingsAwsPcEventsQueryVariables>(CoSellSettingsAwsPcEventsDocument, options);
        }
export type CoSellSettingsAwsPcEventsQueryHookResult = ReturnType<typeof useCoSellSettingsAwsPcEventsQuery>;
export type CoSellSettingsAwsPcEventsLazyQueryHookResult = ReturnType<typeof useCoSellSettingsAwsPcEventsLazyQuery>;
export type CoSellSettingsAwsPcEventsQueryResult = Apollo.QueryResult<CoSellSettingsAwsPcEventsQuery, CoSellSettingsAwsPcEventsQueryVariables>;
export const RegistrationTokenCoSellSettingsAwsPcEventsDocument = gql`
    query RegistrationTokenCoSellSettingsAwsPCEvents {
  awsRegistrationToken
}
    `;

/**
 * __useRegistrationTokenCoSellSettingsAwsPcEventsQuery__
 *
 * To run a query within a React component, call `useRegistrationTokenCoSellSettingsAwsPcEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistrationTokenCoSellSettingsAwsPcEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegistrationTokenCoSellSettingsAwsPcEventsQuery({
 *   variables: {
 *   },
 * });
 */
export function useRegistrationTokenCoSellSettingsAwsPcEventsQuery(baseOptions?: Apollo.QueryHookOptions<RegistrationTokenCoSellSettingsAwsPcEventsQuery, RegistrationTokenCoSellSettingsAwsPcEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RegistrationTokenCoSellSettingsAwsPcEventsQuery, RegistrationTokenCoSellSettingsAwsPcEventsQueryVariables>(RegistrationTokenCoSellSettingsAwsPcEventsDocument, options);
      }
export function useRegistrationTokenCoSellSettingsAwsPcEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RegistrationTokenCoSellSettingsAwsPcEventsQuery, RegistrationTokenCoSellSettingsAwsPcEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RegistrationTokenCoSellSettingsAwsPcEventsQuery, RegistrationTokenCoSellSettingsAwsPcEventsQueryVariables>(RegistrationTokenCoSellSettingsAwsPcEventsDocument, options);
        }
export type RegistrationTokenCoSellSettingsAwsPcEventsQueryHookResult = ReturnType<typeof useRegistrationTokenCoSellSettingsAwsPcEventsQuery>;
export type RegistrationTokenCoSellSettingsAwsPcEventsLazyQueryHookResult = ReturnType<typeof useRegistrationTokenCoSellSettingsAwsPcEventsLazyQuery>;
export type RegistrationTokenCoSellSettingsAwsPcEventsQueryResult = Apollo.QueryResult<RegistrationTokenCoSellSettingsAwsPcEventsQuery, RegistrationTokenCoSellSettingsAwsPcEventsQueryVariables>;
export const UpdateAwsVendorCoSellSettingsAwsPartnerCentralLinkedDocument = gql`
    mutation UpdateAwsVendorCoSellSettingsAwsPartnerCentralLinked($updates: VendorInput!) {
  updateVendor(updates: $updates) {
    id
    onboarding {
      cosell {
        has_completed_partner_central_linking
      }
    }
  }
}
    `;
export type UpdateAwsVendorCoSellSettingsAwsPartnerCentralLinkedMutationFn = Apollo.MutationFunction<UpdateAwsVendorCoSellSettingsAwsPartnerCentralLinkedMutation, UpdateAwsVendorCoSellSettingsAwsPartnerCentralLinkedMutationVariables>;

/**
 * __useUpdateAwsVendorCoSellSettingsAwsPartnerCentralLinkedMutation__
 *
 * To run a mutation, you first call `useUpdateAwsVendorCoSellSettingsAwsPartnerCentralLinkedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAwsVendorCoSellSettingsAwsPartnerCentralLinkedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAwsVendorCoSellSettingsAwsPartnerCentralLinkedMutation, { data, loading, error }] = useUpdateAwsVendorCoSellSettingsAwsPartnerCentralLinkedMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateAwsVendorCoSellSettingsAwsPartnerCentralLinkedMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAwsVendorCoSellSettingsAwsPartnerCentralLinkedMutation, UpdateAwsVendorCoSellSettingsAwsPartnerCentralLinkedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAwsVendorCoSellSettingsAwsPartnerCentralLinkedMutation, UpdateAwsVendorCoSellSettingsAwsPartnerCentralLinkedMutationVariables>(UpdateAwsVendorCoSellSettingsAwsPartnerCentralLinkedDocument, options);
      }
export type UpdateAwsVendorCoSellSettingsAwsPartnerCentralLinkedMutationHookResult = ReturnType<typeof useUpdateAwsVendorCoSellSettingsAwsPartnerCentralLinkedMutation>;
export type UpdateAwsVendorCoSellSettingsAwsPartnerCentralLinkedMutationResult = Apollo.MutationResult<UpdateAwsVendorCoSellSettingsAwsPartnerCentralLinkedMutation>;
export type UpdateAwsVendorCoSellSettingsAwsPartnerCentralLinkedMutationOptions = Apollo.BaseMutationOptions<UpdateAwsVendorCoSellSettingsAwsPartnerCentralLinkedMutation, UpdateAwsVendorCoSellSettingsAwsPartnerCentralLinkedMutationVariables>;
export const CoSellSettingsAwsProductionDocument = gql`
    query CoSellSettingsAwsProduction {
  currentUser {
    id
    vendor {
      id
      configuration {
        aws {
          assume_role {
            role_arn
          }
        }
      }
      reporting {
        health {
          tkl_iam_role_status {
            status
          }
        }
      }
      external_id
    }
  }
}
    `;

/**
 * __useCoSellSettingsAwsProductionQuery__
 *
 * To run a query within a React component, call `useCoSellSettingsAwsProductionQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoSellSettingsAwsProductionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoSellSettingsAwsProductionQuery({
 *   variables: {
 *   },
 * });
 */
export function useCoSellSettingsAwsProductionQuery(baseOptions?: Apollo.QueryHookOptions<CoSellSettingsAwsProductionQuery, CoSellSettingsAwsProductionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CoSellSettingsAwsProductionQuery, CoSellSettingsAwsProductionQueryVariables>(CoSellSettingsAwsProductionDocument, options);
      }
export function useCoSellSettingsAwsProductionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CoSellSettingsAwsProductionQuery, CoSellSettingsAwsProductionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CoSellSettingsAwsProductionQuery, CoSellSettingsAwsProductionQueryVariables>(CoSellSettingsAwsProductionDocument, options);
        }
export type CoSellSettingsAwsProductionQueryHookResult = ReturnType<typeof useCoSellSettingsAwsProductionQuery>;
export type CoSellSettingsAwsProductionLazyQueryHookResult = ReturnType<typeof useCoSellSettingsAwsProductionLazyQuery>;
export type CoSellSettingsAwsProductionQueryResult = Apollo.QueryResult<CoSellSettingsAwsProductionQuery, CoSellSettingsAwsProductionQueryVariables>;
export const UpdateAwsVendorCoSellSettingsAwsProductionDocument = gql`
    mutation UpdateAwsVendorCoSellSettingsAwsProduction($updates: VendorInput!) {
  updateVendor(updates: $updates) {
    id
    configuration {
      aws {
        assume_role {
          role_arn
        }
      }
    }
    onboarding {
      cosell {
        aws_has_launch_stack_button_been_clicked
      }
    }
  }
}
    `;
export type UpdateAwsVendorCoSellSettingsAwsProductionMutationFn = Apollo.MutationFunction<UpdateAwsVendorCoSellSettingsAwsProductionMutation, UpdateAwsVendorCoSellSettingsAwsProductionMutationVariables>;

/**
 * __useUpdateAwsVendorCoSellSettingsAwsProductionMutation__
 *
 * To run a mutation, you first call `useUpdateAwsVendorCoSellSettingsAwsProductionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAwsVendorCoSellSettingsAwsProductionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAwsVendorCoSellSettingsAwsProductionMutation, { data, loading, error }] = useUpdateAwsVendorCoSellSettingsAwsProductionMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateAwsVendorCoSellSettingsAwsProductionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAwsVendorCoSellSettingsAwsProductionMutation, UpdateAwsVendorCoSellSettingsAwsProductionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAwsVendorCoSellSettingsAwsProductionMutation, UpdateAwsVendorCoSellSettingsAwsProductionMutationVariables>(UpdateAwsVendorCoSellSettingsAwsProductionDocument, options);
      }
export type UpdateAwsVendorCoSellSettingsAwsProductionMutationHookResult = ReturnType<typeof useUpdateAwsVendorCoSellSettingsAwsProductionMutation>;
export type UpdateAwsVendorCoSellSettingsAwsProductionMutationResult = Apollo.MutationResult<UpdateAwsVendorCoSellSettingsAwsProductionMutation>;
export type UpdateAwsVendorCoSellSettingsAwsProductionMutationOptions = Apollo.BaseMutationOptions<UpdateAwsVendorCoSellSettingsAwsProductionMutation, UpdateAwsVendorCoSellSettingsAwsProductionMutationVariables>;
export const CoSellSettingsAwsS3Document = gql`
    query CoSellSettingsAwsS3 {
  currentUser {
    id
    vendor {
      id
      configuration {
        aws {
          assume_role {
            role_arn
          }
        }
      }
      coSell {
        id
        ace_bucket
        ace_kms_key
        ace_connected
      }
      onboarding {
        cosell {
          aws_has_launch_stack_button_been_clicked
        }
      }
    }
  }
}
    `;

/**
 * __useCoSellSettingsAwsS3Query__
 *
 * To run a query within a React component, call `useCoSellSettingsAwsS3Query` and pass it any options that fit your needs.
 * When your component renders, `useCoSellSettingsAwsS3Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoSellSettingsAwsS3Query({
 *   variables: {
 *   },
 * });
 */
export function useCoSellSettingsAwsS3Query(baseOptions?: Apollo.QueryHookOptions<CoSellSettingsAwsS3Query, CoSellSettingsAwsS3QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CoSellSettingsAwsS3Query, CoSellSettingsAwsS3QueryVariables>(CoSellSettingsAwsS3Document, options);
      }
export function useCoSellSettingsAwsS3LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CoSellSettingsAwsS3Query, CoSellSettingsAwsS3QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CoSellSettingsAwsS3Query, CoSellSettingsAwsS3QueryVariables>(CoSellSettingsAwsS3Document, options);
        }
export type CoSellSettingsAwsS3QueryHookResult = ReturnType<typeof useCoSellSettingsAwsS3Query>;
export type CoSellSettingsAwsS3LazyQueryHookResult = ReturnType<typeof useCoSellSettingsAwsS3LazyQuery>;
export type CoSellSettingsAwsS3QueryResult = Apollo.QueryResult<CoSellSettingsAwsS3Query, CoSellSettingsAwsS3QueryVariables>;
export const TestAceConnectionDocument = gql`
    mutation testAceConnection($vendorId: String!) {
  testCoSellAceConnection(vendorId: $vendorId)
}
    `;
export type TestAceConnectionMutationFn = Apollo.MutationFunction<TestAceConnectionMutation, TestAceConnectionMutationVariables>;

/**
 * __useTestAceConnectionMutation__
 *
 * To run a mutation, you first call `useTestAceConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTestAceConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [testAceConnectionMutation, { data, loading, error }] = useTestAceConnectionMutation({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *   },
 * });
 */
export function useTestAceConnectionMutation(baseOptions?: Apollo.MutationHookOptions<TestAceConnectionMutation, TestAceConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TestAceConnectionMutation, TestAceConnectionMutationVariables>(TestAceConnectionDocument, options);
      }
export type TestAceConnectionMutationHookResult = ReturnType<typeof useTestAceConnectionMutation>;
export type TestAceConnectionMutationResult = Apollo.MutationResult<TestAceConnectionMutation>;
export type TestAceConnectionMutationOptions = Apollo.BaseMutationOptions<TestAceConnectionMutation, TestAceConnectionMutationVariables>;
export const UpdateAwsVendorCoSellSettingsAwsS3Document = gql`
    mutation UpdateAwsVendorCoSellSettingsAwsS3($updates: VendorInput!) {
  updateVendor(updates: $updates) {
    id
    onboarding {
      cosell {
        aws_has_launch_stack_button_been_clicked
      }
    }
  }
}
    `;
export type UpdateAwsVendorCoSellSettingsAwsS3MutationFn = Apollo.MutationFunction<UpdateAwsVendorCoSellSettingsAwsS3Mutation, UpdateAwsVendorCoSellSettingsAwsS3MutationVariables>;

/**
 * __useUpdateAwsVendorCoSellSettingsAwsS3Mutation__
 *
 * To run a mutation, you first call `useUpdateAwsVendorCoSellSettingsAwsS3Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAwsVendorCoSellSettingsAwsS3Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAwsVendorCoSellSettingsAwsS3Mutation, { data, loading, error }] = useUpdateAwsVendorCoSellSettingsAwsS3Mutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateAwsVendorCoSellSettingsAwsS3Mutation(baseOptions?: Apollo.MutationHookOptions<UpdateAwsVendorCoSellSettingsAwsS3Mutation, UpdateAwsVendorCoSellSettingsAwsS3MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAwsVendorCoSellSettingsAwsS3Mutation, UpdateAwsVendorCoSellSettingsAwsS3MutationVariables>(UpdateAwsVendorCoSellSettingsAwsS3Document, options);
      }
export type UpdateAwsVendorCoSellSettingsAwsS3MutationHookResult = ReturnType<typeof useUpdateAwsVendorCoSellSettingsAwsS3Mutation>;
export type UpdateAwsVendorCoSellSettingsAwsS3MutationResult = Apollo.MutationResult<UpdateAwsVendorCoSellSettingsAwsS3Mutation>;
export type UpdateAwsVendorCoSellSettingsAwsS3MutationOptions = Apollo.BaseMutationOptions<UpdateAwsVendorCoSellSettingsAwsS3Mutation, UpdateAwsVendorCoSellSettingsAwsS3MutationVariables>;
export const CoSellSettingsAwsSandboxDocument = gql`
    query CoSellSettingsAwsSandbox {
  currentUser {
    id
    vendor {
      id
      coSell {
        id
        sandbox_arn
      }
    }
  }
}
    `;

/**
 * __useCoSellSettingsAwsSandboxQuery__
 *
 * To run a query within a React component, call `useCoSellSettingsAwsSandboxQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoSellSettingsAwsSandboxQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoSellSettingsAwsSandboxQuery({
 *   variables: {
 *   },
 * });
 */
export function useCoSellSettingsAwsSandboxQuery(baseOptions?: Apollo.QueryHookOptions<CoSellSettingsAwsSandboxQuery, CoSellSettingsAwsSandboxQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CoSellSettingsAwsSandboxQuery, CoSellSettingsAwsSandboxQueryVariables>(CoSellSettingsAwsSandboxDocument, options);
      }
export function useCoSellSettingsAwsSandboxLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CoSellSettingsAwsSandboxQuery, CoSellSettingsAwsSandboxQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CoSellSettingsAwsSandboxQuery, CoSellSettingsAwsSandboxQueryVariables>(CoSellSettingsAwsSandboxDocument, options);
        }
export type CoSellSettingsAwsSandboxQueryHookResult = ReturnType<typeof useCoSellSettingsAwsSandboxQuery>;
export type CoSellSettingsAwsSandboxLazyQueryHookResult = ReturnType<typeof useCoSellSettingsAwsSandboxLazyQuery>;
export type CoSellSettingsAwsSandboxQueryResult = Apollo.QueryResult<CoSellSettingsAwsSandboxQuery, CoSellSettingsAwsSandboxQueryVariables>;
export const UpdateCoSellVendorCoSellSettingsAwsSandboxDocument = gql`
    mutation UpdateCoSellVendorCoSellSettingsAwsSandbox($updates: CoSellVendorInput!) {
  updateCoSellVendor(updates: $updates) {
    id
    sandbox_arn
  }
}
    `;
export type UpdateCoSellVendorCoSellSettingsAwsSandboxMutationFn = Apollo.MutationFunction<UpdateCoSellVendorCoSellSettingsAwsSandboxMutation, UpdateCoSellVendorCoSellSettingsAwsSandboxMutationVariables>;

/**
 * __useUpdateCoSellVendorCoSellSettingsAwsSandboxMutation__
 *
 * To run a mutation, you first call `useUpdateCoSellVendorCoSellSettingsAwsSandboxMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCoSellVendorCoSellSettingsAwsSandboxMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCoSellVendorCoSellSettingsAwsSandboxMutation, { data, loading, error }] = useUpdateCoSellVendorCoSellSettingsAwsSandboxMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateCoSellVendorCoSellSettingsAwsSandboxMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCoSellVendorCoSellSettingsAwsSandboxMutation, UpdateCoSellVendorCoSellSettingsAwsSandboxMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCoSellVendorCoSellSettingsAwsSandboxMutation, UpdateCoSellVendorCoSellSettingsAwsSandboxMutationVariables>(UpdateCoSellVendorCoSellSettingsAwsSandboxDocument, options);
      }
export type UpdateCoSellVendorCoSellSettingsAwsSandboxMutationHookResult = ReturnType<typeof useUpdateCoSellVendorCoSellSettingsAwsSandboxMutation>;
export type UpdateCoSellVendorCoSellSettingsAwsSandboxMutationResult = Apollo.MutationResult<UpdateCoSellVendorCoSellSettingsAwsSandboxMutation>;
export type UpdateCoSellVendorCoSellSettingsAwsSandboxMutationOptions = Apollo.BaseMutationOptions<UpdateCoSellVendorCoSellSettingsAwsSandboxMutation, UpdateCoSellVendorCoSellSettingsAwsSandboxMutationVariables>;
export const CoSellSettingsAwsSolutionsDocument = gql`
    query CoSellSettingsAwsSolutions {
  currentUser {
    id
    vendor {
      id
      coSell {
        id
        awsSolutions {
          id
          externalId
          name: solutionName
          isADefaultSolution
        }
        custom_workflows
      }
    }
  }
}
    `;

/**
 * __useCoSellSettingsAwsSolutionsQuery__
 *
 * To run a query within a React component, call `useCoSellSettingsAwsSolutionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoSellSettingsAwsSolutionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoSellSettingsAwsSolutionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCoSellSettingsAwsSolutionsQuery(baseOptions?: Apollo.QueryHookOptions<CoSellSettingsAwsSolutionsQuery, CoSellSettingsAwsSolutionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CoSellSettingsAwsSolutionsQuery, CoSellSettingsAwsSolutionsQueryVariables>(CoSellSettingsAwsSolutionsDocument, options);
      }
export function useCoSellSettingsAwsSolutionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CoSellSettingsAwsSolutionsQuery, CoSellSettingsAwsSolutionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CoSellSettingsAwsSolutionsQuery, CoSellSettingsAwsSolutionsQueryVariables>(CoSellSettingsAwsSolutionsDocument, options);
        }
export type CoSellSettingsAwsSolutionsQueryHookResult = ReturnType<typeof useCoSellSettingsAwsSolutionsQuery>;
export type CoSellSettingsAwsSolutionsLazyQueryHookResult = ReturnType<typeof useCoSellSettingsAwsSolutionsLazyQuery>;
export type CoSellSettingsAwsSolutionsQueryResult = Apollo.QueryResult<CoSellSettingsAwsSolutionsQuery, CoSellSettingsAwsSolutionsQueryVariables>;
export const CreateCoSellCloudSolutionDocument = gql`
    mutation CreateCoSellCloudSolution($solution: CoSellCloudSolutionCreateInput!) {
  createCoSellCloudSolution(solution: $solution) {
    id
    externalId
    solutionName
    isADefaultSolution
  }
}
    `;
export type CreateCoSellCloudSolutionMutationFn = Apollo.MutationFunction<CreateCoSellCloudSolutionMutation, CreateCoSellCloudSolutionMutationVariables>;

/**
 * __useCreateCoSellCloudSolutionMutation__
 *
 * To run a mutation, you first call `useCreateCoSellCloudSolutionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCoSellCloudSolutionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCoSellCloudSolutionMutation, { data, loading, error }] = useCreateCoSellCloudSolutionMutation({
 *   variables: {
 *      solution: // value for 'solution'
 *   },
 * });
 */
export function useCreateCoSellCloudSolutionMutation(baseOptions?: Apollo.MutationHookOptions<CreateCoSellCloudSolutionMutation, CreateCoSellCloudSolutionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCoSellCloudSolutionMutation, CreateCoSellCloudSolutionMutationVariables>(CreateCoSellCloudSolutionDocument, options);
      }
export type CreateCoSellCloudSolutionMutationHookResult = ReturnType<typeof useCreateCoSellCloudSolutionMutation>;
export type CreateCoSellCloudSolutionMutationResult = Apollo.MutationResult<CreateCoSellCloudSolutionMutation>;
export type CreateCoSellCloudSolutionMutationOptions = Apollo.BaseMutationOptions<CreateCoSellCloudSolutionMutation, CreateCoSellCloudSolutionMutationVariables>;
export const UpdateCoSellCloudSolutionDocument = gql`
    mutation UpdateCoSellCloudSolution($updates: CoSellCloudSolutionUpdateInput!) {
  updateCoSellCloudSolution(updates: $updates) {
    id
    externalId
    solutionName
    isADefaultSolution
  }
}
    `;
export type UpdateCoSellCloudSolutionMutationFn = Apollo.MutationFunction<UpdateCoSellCloudSolutionMutation, UpdateCoSellCloudSolutionMutationVariables>;

/**
 * __useUpdateCoSellCloudSolutionMutation__
 *
 * To run a mutation, you first call `useUpdateCoSellCloudSolutionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCoSellCloudSolutionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCoSellCloudSolutionMutation, { data, loading, error }] = useUpdateCoSellCloudSolutionMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateCoSellCloudSolutionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCoSellCloudSolutionMutation, UpdateCoSellCloudSolutionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCoSellCloudSolutionMutation, UpdateCoSellCloudSolutionMutationVariables>(UpdateCoSellCloudSolutionDocument, options);
      }
export type UpdateCoSellCloudSolutionMutationHookResult = ReturnType<typeof useUpdateCoSellCloudSolutionMutation>;
export type UpdateCoSellCloudSolutionMutationResult = Apollo.MutationResult<UpdateCoSellCloudSolutionMutation>;
export type UpdateCoSellCloudSolutionMutationOptions = Apollo.BaseMutationOptions<UpdateCoSellCloudSolutionMutation, UpdateCoSellCloudSolutionMutationVariables>;
export const DeleteCoSellCloudSolutionDocument = gql`
    mutation DeleteCoSellCloudSolution($solution: CoSellCloudSolutionDeleteInput!) {
  deleteCoSellCloudSolution(solution: $solution) {
    id
    externalId
    solutionName
    archivedAt
  }
}
    `;
export type DeleteCoSellCloudSolutionMutationFn = Apollo.MutationFunction<DeleteCoSellCloudSolutionMutation, DeleteCoSellCloudSolutionMutationVariables>;

/**
 * __useDeleteCoSellCloudSolutionMutation__
 *
 * To run a mutation, you first call `useDeleteCoSellCloudSolutionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCoSellCloudSolutionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCoSellCloudSolutionMutation, { data, loading, error }] = useDeleteCoSellCloudSolutionMutation({
 *   variables: {
 *      solution: // value for 'solution'
 *   },
 * });
 */
export function useDeleteCoSellCloudSolutionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCoSellCloudSolutionMutation, DeleteCoSellCloudSolutionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCoSellCloudSolutionMutation, DeleteCoSellCloudSolutionMutationVariables>(DeleteCoSellCloudSolutionDocument, options);
      }
export type DeleteCoSellCloudSolutionMutationHookResult = ReturnType<typeof useDeleteCoSellCloudSolutionMutation>;
export type DeleteCoSellCloudSolutionMutationResult = Apollo.MutationResult<DeleteCoSellCloudSolutionMutation>;
export type DeleteCoSellCloudSolutionMutationOptions = Apollo.BaseMutationOptions<DeleteCoSellCloudSolutionMutation, DeleteCoSellCloudSolutionMutationVariables>;
export const ToggleCompletedSaasDocumentationDocument = gql`
    mutation ToggleCompletedSaasDocumentation($vendorId: ID!, $status: Boolean!) {
  toggleCompletedSaasDocumentation(vendorId: $vendorId, status: $status) {
    id
    custom_workflows
  }
}
    `;
export type ToggleCompletedSaasDocumentationMutationFn = Apollo.MutationFunction<ToggleCompletedSaasDocumentationMutation, ToggleCompletedSaasDocumentationMutationVariables>;

/**
 * __useToggleCompletedSaasDocumentationMutation__
 *
 * To run a mutation, you first call `useToggleCompletedSaasDocumentationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleCompletedSaasDocumentationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleCompletedSaasDocumentationMutation, { data, loading, error }] = useToggleCompletedSaasDocumentationMutation({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useToggleCompletedSaasDocumentationMutation(baseOptions?: Apollo.MutationHookOptions<ToggleCompletedSaasDocumentationMutation, ToggleCompletedSaasDocumentationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleCompletedSaasDocumentationMutation, ToggleCompletedSaasDocumentationMutationVariables>(ToggleCompletedSaasDocumentationDocument, options);
      }
export type ToggleCompletedSaasDocumentationMutationHookResult = ReturnType<typeof useToggleCompletedSaasDocumentationMutation>;
export type ToggleCompletedSaasDocumentationMutationResult = Apollo.MutationResult<ToggleCompletedSaasDocumentationMutation>;
export type ToggleCompletedSaasDocumentationMutationOptions = Apollo.BaseMutationOptions<ToggleCompletedSaasDocumentationMutation, ToggleCompletedSaasDocumentationMutationVariables>;
export const UpdateAwsVendorCoSellSettingsAwsAceEligibleDocument = gql`
    mutation UpdateAwsVendorCoSellSettingsAwsAceEligible($updates: VendorInput!) {
  updateVendor(updates: $updates) {
    id
    onboarding {
      cosell {
        ace_eligible_selection
      }
    }
  }
}
    `;
export type UpdateAwsVendorCoSellSettingsAwsAceEligibleMutationFn = Apollo.MutationFunction<UpdateAwsVendorCoSellSettingsAwsAceEligibleMutation, UpdateAwsVendorCoSellSettingsAwsAceEligibleMutationVariables>;

/**
 * __useUpdateAwsVendorCoSellSettingsAwsAceEligibleMutation__
 *
 * To run a mutation, you first call `useUpdateAwsVendorCoSellSettingsAwsAceEligibleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAwsVendorCoSellSettingsAwsAceEligibleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAwsVendorCoSellSettingsAwsAceEligibleMutation, { data, loading, error }] = useUpdateAwsVendorCoSellSettingsAwsAceEligibleMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateAwsVendorCoSellSettingsAwsAceEligibleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAwsVendorCoSellSettingsAwsAceEligibleMutation, UpdateAwsVendorCoSellSettingsAwsAceEligibleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAwsVendorCoSellSettingsAwsAceEligibleMutation, UpdateAwsVendorCoSellSettingsAwsAceEligibleMutationVariables>(UpdateAwsVendorCoSellSettingsAwsAceEligibleDocument, options);
      }
export type UpdateAwsVendorCoSellSettingsAwsAceEligibleMutationHookResult = ReturnType<typeof useUpdateAwsVendorCoSellSettingsAwsAceEligibleMutation>;
export type UpdateAwsVendorCoSellSettingsAwsAceEligibleMutationResult = Apollo.MutationResult<UpdateAwsVendorCoSellSettingsAwsAceEligibleMutation>;
export type UpdateAwsVendorCoSellSettingsAwsAceEligibleMutationOptions = Apollo.BaseMutationOptions<UpdateAwsVendorCoSellSettingsAwsAceEligibleMutation, UpdateAwsVendorCoSellSettingsAwsAceEligibleMutationVariables>;
export const CoSellSettingsMicrosoftSolutionsDocument = gql`
    query CoSellSettingsMicrosoftSolutions {
  currentUser {
    id
    vendor {
      id
      coSell {
        id
        microsoftSolutions {
          id
          externalId
          solutionName
        }
      }
    }
  }
}
    `;

/**
 * __useCoSellSettingsMicrosoftSolutionsQuery__
 *
 * To run a query within a React component, call `useCoSellSettingsMicrosoftSolutionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoSellSettingsMicrosoftSolutionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoSellSettingsMicrosoftSolutionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCoSellSettingsMicrosoftSolutionsQuery(baseOptions?: Apollo.QueryHookOptions<CoSellSettingsMicrosoftSolutionsQuery, CoSellSettingsMicrosoftSolutionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CoSellSettingsMicrosoftSolutionsQuery, CoSellSettingsMicrosoftSolutionsQueryVariables>(CoSellSettingsMicrosoftSolutionsDocument, options);
      }
export function useCoSellSettingsMicrosoftSolutionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CoSellSettingsMicrosoftSolutionsQuery, CoSellSettingsMicrosoftSolutionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CoSellSettingsMicrosoftSolutionsQuery, CoSellSettingsMicrosoftSolutionsQueryVariables>(CoSellSettingsMicrosoftSolutionsDocument, options);
        }
export type CoSellSettingsMicrosoftSolutionsQueryHookResult = ReturnType<typeof useCoSellSettingsMicrosoftSolutionsQuery>;
export type CoSellSettingsMicrosoftSolutionsLazyQueryHookResult = ReturnType<typeof useCoSellSettingsMicrosoftSolutionsLazyQuery>;
export type CoSellSettingsMicrosoftSolutionsQueryResult = Apollo.QueryResult<CoSellSettingsMicrosoftSolutionsQuery, CoSellSettingsMicrosoftSolutionsQueryVariables>;
export const CreateCoSellMicrosoftSolutionDocument = gql`
    mutation CreateCoSellMicrosoftSolution($solution: CoSellMicrosoftSolutionCreateInput!) {
  createCoSellMicrosoftSolution(solution: $solution) {
    id
    externalId
    solutionName
  }
}
    `;
export type CreateCoSellMicrosoftSolutionMutationFn = Apollo.MutationFunction<CreateCoSellMicrosoftSolutionMutation, CreateCoSellMicrosoftSolutionMutationVariables>;

/**
 * __useCreateCoSellMicrosoftSolutionMutation__
 *
 * To run a mutation, you first call `useCreateCoSellMicrosoftSolutionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCoSellMicrosoftSolutionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCoSellMicrosoftSolutionMutation, { data, loading, error }] = useCreateCoSellMicrosoftSolutionMutation({
 *   variables: {
 *      solution: // value for 'solution'
 *   },
 * });
 */
export function useCreateCoSellMicrosoftSolutionMutation(baseOptions?: Apollo.MutationHookOptions<CreateCoSellMicrosoftSolutionMutation, CreateCoSellMicrosoftSolutionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCoSellMicrosoftSolutionMutation, CreateCoSellMicrosoftSolutionMutationVariables>(CreateCoSellMicrosoftSolutionDocument, options);
      }
export type CreateCoSellMicrosoftSolutionMutationHookResult = ReturnType<typeof useCreateCoSellMicrosoftSolutionMutation>;
export type CreateCoSellMicrosoftSolutionMutationResult = Apollo.MutationResult<CreateCoSellMicrosoftSolutionMutation>;
export type CreateCoSellMicrosoftSolutionMutationOptions = Apollo.BaseMutationOptions<CreateCoSellMicrosoftSolutionMutation, CreateCoSellMicrosoftSolutionMutationVariables>;
export const UpdateCoSellMicrosoftSolutionDocument = gql`
    mutation UpdateCoSellMicrosoftSolution($updates: CoSellMicrosoftSolutionUpdateInput!) {
  updateCoSellMicrosoftSolution(updates: $updates) {
    id
    externalId
    solutionName
  }
}
    `;
export type UpdateCoSellMicrosoftSolutionMutationFn = Apollo.MutationFunction<UpdateCoSellMicrosoftSolutionMutation, UpdateCoSellMicrosoftSolutionMutationVariables>;

/**
 * __useUpdateCoSellMicrosoftSolutionMutation__
 *
 * To run a mutation, you first call `useUpdateCoSellMicrosoftSolutionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCoSellMicrosoftSolutionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCoSellMicrosoftSolutionMutation, { data, loading, error }] = useUpdateCoSellMicrosoftSolutionMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateCoSellMicrosoftSolutionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCoSellMicrosoftSolutionMutation, UpdateCoSellMicrosoftSolutionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCoSellMicrosoftSolutionMutation, UpdateCoSellMicrosoftSolutionMutationVariables>(UpdateCoSellMicrosoftSolutionDocument, options);
      }
export type UpdateCoSellMicrosoftSolutionMutationHookResult = ReturnType<typeof useUpdateCoSellMicrosoftSolutionMutation>;
export type UpdateCoSellMicrosoftSolutionMutationResult = Apollo.MutationResult<UpdateCoSellMicrosoftSolutionMutation>;
export type UpdateCoSellMicrosoftSolutionMutationOptions = Apollo.BaseMutationOptions<UpdateCoSellMicrosoftSolutionMutation, UpdateCoSellMicrosoftSolutionMutationVariables>;
export const DeleteCoSellMicrosoftSolutionDocument = gql`
    mutation DeleteCoSellMicrosoftSolution($solution: CoSellMicrosoftSolutionDeleteInput!) {
  deleteCoSellMicrosoftSolution(solution: $solution) {
    id
    externalId
    solutionName
    archivedAt
  }
}
    `;
export type DeleteCoSellMicrosoftSolutionMutationFn = Apollo.MutationFunction<DeleteCoSellMicrosoftSolutionMutation, DeleteCoSellMicrosoftSolutionMutationVariables>;

/**
 * __useDeleteCoSellMicrosoftSolutionMutation__
 *
 * To run a mutation, you first call `useDeleteCoSellMicrosoftSolutionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCoSellMicrosoftSolutionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCoSellMicrosoftSolutionMutation, { data, loading, error }] = useDeleteCoSellMicrosoftSolutionMutation({
 *   variables: {
 *      solution: // value for 'solution'
 *   },
 * });
 */
export function useDeleteCoSellMicrosoftSolutionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCoSellMicrosoftSolutionMutation, DeleteCoSellMicrosoftSolutionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCoSellMicrosoftSolutionMutation, DeleteCoSellMicrosoftSolutionMutationVariables>(DeleteCoSellMicrosoftSolutionDocument, options);
      }
export type DeleteCoSellMicrosoftSolutionMutationHookResult = ReturnType<typeof useDeleteCoSellMicrosoftSolutionMutation>;
export type DeleteCoSellMicrosoftSolutionMutationResult = Apollo.MutationResult<DeleteCoSellMicrosoftSolutionMutation>;
export type DeleteCoSellMicrosoftSolutionMutationOptions = Apollo.BaseMutationOptions<DeleteCoSellMicrosoftSolutionMutation, DeleteCoSellMicrosoftSolutionMutationVariables>;
export const CoSellSettingsStartDocument = gql`
    query CoSellSettingsStart {
  currentUser {
    id
    vendor {
      id
      feature_flags {
        is_co_sell_enabled
        is_co_sell_enabled_for_microsoft
      }
      coSell {
        id
        ace_auto_submit
        mspc_auto_submit
      }
    }
  }
}
    `;

/**
 * __useCoSellSettingsStartQuery__
 *
 * To run a query within a React component, call `useCoSellSettingsStartQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoSellSettingsStartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoSellSettingsStartQuery({
 *   variables: {
 *   },
 * });
 */
export function useCoSellSettingsStartQuery(baseOptions?: Apollo.QueryHookOptions<CoSellSettingsStartQuery, CoSellSettingsStartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CoSellSettingsStartQuery, CoSellSettingsStartQueryVariables>(CoSellSettingsStartDocument, options);
      }
export function useCoSellSettingsStartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CoSellSettingsStartQuery, CoSellSettingsStartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CoSellSettingsStartQuery, CoSellSettingsStartQueryVariables>(CoSellSettingsStartDocument, options);
        }
export type CoSellSettingsStartQueryHookResult = ReturnType<typeof useCoSellSettingsStartQuery>;
export type CoSellSettingsStartLazyQueryHookResult = ReturnType<typeof useCoSellSettingsStartLazyQuery>;
export type CoSellSettingsStartQueryResult = Apollo.QueryResult<CoSellSettingsStartQuery, CoSellSettingsStartQueryVariables>;
export const CoSellSettingsStartAutoSubmitToCloudPartnerDocument = gql`
    mutation CoSellSettingsStartAutoSubmitToCloudPartner($updates: CoSellVendorInput!) {
  updateCoSellVendor(updates: $updates) {
    id
    ace_auto_submit
    mspc_auto_submit
  }
}
    `;
export type CoSellSettingsStartAutoSubmitToCloudPartnerMutationFn = Apollo.MutationFunction<CoSellSettingsStartAutoSubmitToCloudPartnerMutation, CoSellSettingsStartAutoSubmitToCloudPartnerMutationVariables>;

/**
 * __useCoSellSettingsStartAutoSubmitToCloudPartnerMutation__
 *
 * To run a mutation, you first call `useCoSellSettingsStartAutoSubmitToCloudPartnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCoSellSettingsStartAutoSubmitToCloudPartnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [coSellSettingsStartAutoSubmitToCloudPartnerMutation, { data, loading, error }] = useCoSellSettingsStartAutoSubmitToCloudPartnerMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useCoSellSettingsStartAutoSubmitToCloudPartnerMutation(baseOptions?: Apollo.MutationHookOptions<CoSellSettingsStartAutoSubmitToCloudPartnerMutation, CoSellSettingsStartAutoSubmitToCloudPartnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CoSellSettingsStartAutoSubmitToCloudPartnerMutation, CoSellSettingsStartAutoSubmitToCloudPartnerMutationVariables>(CoSellSettingsStartAutoSubmitToCloudPartnerDocument, options);
      }
export type CoSellSettingsStartAutoSubmitToCloudPartnerMutationHookResult = ReturnType<typeof useCoSellSettingsStartAutoSubmitToCloudPartnerMutation>;
export type CoSellSettingsStartAutoSubmitToCloudPartnerMutationResult = Apollo.MutationResult<CoSellSettingsStartAutoSubmitToCloudPartnerMutation>;
export type CoSellSettingsStartAutoSubmitToCloudPartnerMutationOptions = Apollo.BaseMutationOptions<CoSellSettingsStartAutoSubmitToCloudPartnerMutation, CoSellSettingsStartAutoSubmitToCloudPartnerMutationVariables>;
export const CreateCoSellCloudSolutionBulkDocument = gql`
    mutation CreateCoSellCloudSolutionBulk($solution: CoSellCloudSolutionCreateInput!) {
  createCoSellCloudSolution(solution: $solution) {
    id
    externalId
    solutionName
  }
}
    `;
export type CreateCoSellCloudSolutionBulkMutationFn = Apollo.MutationFunction<CreateCoSellCloudSolutionBulkMutation, CreateCoSellCloudSolutionBulkMutationVariables>;

/**
 * __useCreateCoSellCloudSolutionBulkMutation__
 *
 * To run a mutation, you first call `useCreateCoSellCloudSolutionBulkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCoSellCloudSolutionBulkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCoSellCloudSolutionBulkMutation, { data, loading, error }] = useCreateCoSellCloudSolutionBulkMutation({
 *   variables: {
 *      solution: // value for 'solution'
 *   },
 * });
 */
export function useCreateCoSellCloudSolutionBulkMutation(baseOptions?: Apollo.MutationHookOptions<CreateCoSellCloudSolutionBulkMutation, CreateCoSellCloudSolutionBulkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCoSellCloudSolutionBulkMutation, CreateCoSellCloudSolutionBulkMutationVariables>(CreateCoSellCloudSolutionBulkDocument, options);
      }
export type CreateCoSellCloudSolutionBulkMutationHookResult = ReturnType<typeof useCreateCoSellCloudSolutionBulkMutation>;
export type CreateCoSellCloudSolutionBulkMutationResult = Apollo.MutationResult<CreateCoSellCloudSolutionBulkMutation>;
export type CreateCoSellCloudSolutionBulkMutationOptions = Apollo.BaseMutationOptions<CreateCoSellCloudSolutionBulkMutation, CreateCoSellCloudSolutionBulkMutationVariables>;
export const CoSellSettingsAwsHasIdentifiedAllianceAccountDocument = gql`
    query CoSellSettingsAwsHasIdentifiedAllianceAccount {
  currentUser {
    id
    vendor {
      id
      onboarding {
        cosell {
          has_identified_alliance_account
        }
      }
      coSell {
        ace_connected
      }
    }
  }
}
    `;

/**
 * __useCoSellSettingsAwsHasIdentifiedAllianceAccountQuery__
 *
 * To run a query within a React component, call `useCoSellSettingsAwsHasIdentifiedAllianceAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoSellSettingsAwsHasIdentifiedAllianceAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoSellSettingsAwsHasIdentifiedAllianceAccountQuery({
 *   variables: {
 *   },
 * });
 */
export function useCoSellSettingsAwsHasIdentifiedAllianceAccountQuery(baseOptions?: Apollo.QueryHookOptions<CoSellSettingsAwsHasIdentifiedAllianceAccountQuery, CoSellSettingsAwsHasIdentifiedAllianceAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CoSellSettingsAwsHasIdentifiedAllianceAccountQuery, CoSellSettingsAwsHasIdentifiedAllianceAccountQueryVariables>(CoSellSettingsAwsHasIdentifiedAllianceAccountDocument, options);
      }
export function useCoSellSettingsAwsHasIdentifiedAllianceAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CoSellSettingsAwsHasIdentifiedAllianceAccountQuery, CoSellSettingsAwsHasIdentifiedAllianceAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CoSellSettingsAwsHasIdentifiedAllianceAccountQuery, CoSellSettingsAwsHasIdentifiedAllianceAccountQueryVariables>(CoSellSettingsAwsHasIdentifiedAllianceAccountDocument, options);
        }
export type CoSellSettingsAwsHasIdentifiedAllianceAccountQueryHookResult = ReturnType<typeof useCoSellSettingsAwsHasIdentifiedAllianceAccountQuery>;
export type CoSellSettingsAwsHasIdentifiedAllianceAccountLazyQueryHookResult = ReturnType<typeof useCoSellSettingsAwsHasIdentifiedAllianceAccountLazyQuery>;
export type CoSellSettingsAwsHasIdentifiedAllianceAccountQueryResult = Apollo.QueryResult<CoSellSettingsAwsHasIdentifiedAllianceAccountQuery, CoSellSettingsAwsHasIdentifiedAllianceAccountQueryVariables>;
export const UpdateVendorCoSellSettingsAwsHasIdentifiedAllianceAccountDocument = gql`
    mutation UpdateVendorCoSellSettingsAwsHasIdentifiedAllianceAccount($updates: VendorInput!) {
  updateVendor(updates: $updates) {
    id
    onboarding {
      cosell {
        has_identified_alliance_account
      }
    }
  }
}
    `;
export type UpdateVendorCoSellSettingsAwsHasIdentifiedAllianceAccountMutationFn = Apollo.MutationFunction<UpdateVendorCoSellSettingsAwsHasIdentifiedAllianceAccountMutation, UpdateVendorCoSellSettingsAwsHasIdentifiedAllianceAccountMutationVariables>;

/**
 * __useUpdateVendorCoSellSettingsAwsHasIdentifiedAllianceAccountMutation__
 *
 * To run a mutation, you first call `useUpdateVendorCoSellSettingsAwsHasIdentifiedAllianceAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVendorCoSellSettingsAwsHasIdentifiedAllianceAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVendorCoSellSettingsAwsHasIdentifiedAllianceAccountMutation, { data, loading, error }] = useUpdateVendorCoSellSettingsAwsHasIdentifiedAllianceAccountMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateVendorCoSellSettingsAwsHasIdentifiedAllianceAccountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVendorCoSellSettingsAwsHasIdentifiedAllianceAccountMutation, UpdateVendorCoSellSettingsAwsHasIdentifiedAllianceAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVendorCoSellSettingsAwsHasIdentifiedAllianceAccountMutation, UpdateVendorCoSellSettingsAwsHasIdentifiedAllianceAccountMutationVariables>(UpdateVendorCoSellSettingsAwsHasIdentifiedAllianceAccountDocument, options);
      }
export type UpdateVendorCoSellSettingsAwsHasIdentifiedAllianceAccountMutationHookResult = ReturnType<typeof useUpdateVendorCoSellSettingsAwsHasIdentifiedAllianceAccountMutation>;
export type UpdateVendorCoSellSettingsAwsHasIdentifiedAllianceAccountMutationResult = Apollo.MutationResult<UpdateVendorCoSellSettingsAwsHasIdentifiedAllianceAccountMutation>;
export type UpdateVendorCoSellSettingsAwsHasIdentifiedAllianceAccountMutationOptions = Apollo.BaseMutationOptions<UpdateVendorCoSellSettingsAwsHasIdentifiedAllianceAccountMutation, UpdateVendorCoSellSettingsAwsHasIdentifiedAllianceAccountMutationVariables>;
export const CoSellSettingsAwsAceEligibleDocument = gql`
    query CoSellSettingsAwsAceEligible {
  currentUser {
    id
    vendor {
      id
      onboarding {
        cosell {
          ace_eligible_selection
          has_completed_partner_central_linking
        }
      }
      coSell {
        ace_connected
      }
    }
  }
}
    `;

/**
 * __useCoSellSettingsAwsAceEligibleQuery__
 *
 * To run a query within a React component, call `useCoSellSettingsAwsAceEligibleQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoSellSettingsAwsAceEligibleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoSellSettingsAwsAceEligibleQuery({
 *   variables: {
 *   },
 * });
 */
export function useCoSellSettingsAwsAceEligibleQuery(baseOptions?: Apollo.QueryHookOptions<CoSellSettingsAwsAceEligibleQuery, CoSellSettingsAwsAceEligibleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CoSellSettingsAwsAceEligibleQuery, CoSellSettingsAwsAceEligibleQueryVariables>(CoSellSettingsAwsAceEligibleDocument, options);
      }
export function useCoSellSettingsAwsAceEligibleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CoSellSettingsAwsAceEligibleQuery, CoSellSettingsAwsAceEligibleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CoSellSettingsAwsAceEligibleQuery, CoSellSettingsAwsAceEligibleQueryVariables>(CoSellSettingsAwsAceEligibleDocument, options);
        }
export type CoSellSettingsAwsAceEligibleQueryHookResult = ReturnType<typeof useCoSellSettingsAwsAceEligibleQuery>;
export type CoSellSettingsAwsAceEligibleLazyQueryHookResult = ReturnType<typeof useCoSellSettingsAwsAceEligibleLazyQuery>;
export type CoSellSettingsAwsAceEligibleQueryResult = Apollo.QueryResult<CoSellSettingsAwsAceEligibleQuery, CoSellSettingsAwsAceEligibleQueryVariables>;
export const CreateEmailCustomBrandDocument = gql`
    mutation CreateEmailCustomBrand($body: EmailCustomBrandInput!) {
  createEmailCustomBrand(body: $body) {
    id
    name
    colors {
      primary
      secondary
      tertiary
    }
    logo {
      image
    }
    status
    custom_text
    updated_at
  }
}
    `;
export type CreateEmailCustomBrandMutationFn = Apollo.MutationFunction<CreateEmailCustomBrandMutation, CreateEmailCustomBrandMutationVariables>;

/**
 * __useCreateEmailCustomBrandMutation__
 *
 * To run a mutation, you first call `useCreateEmailCustomBrandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEmailCustomBrandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEmailCustomBrandMutation, { data, loading, error }] = useCreateEmailCustomBrandMutation({
 *   variables: {
 *      body: // value for 'body'
 *   },
 * });
 */
export function useCreateEmailCustomBrandMutation(baseOptions?: Apollo.MutationHookOptions<CreateEmailCustomBrandMutation, CreateEmailCustomBrandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEmailCustomBrandMutation, CreateEmailCustomBrandMutationVariables>(CreateEmailCustomBrandDocument, options);
      }
export type CreateEmailCustomBrandMutationHookResult = ReturnType<typeof useCreateEmailCustomBrandMutation>;
export type CreateEmailCustomBrandMutationResult = Apollo.MutationResult<CreateEmailCustomBrandMutation>;
export type CreateEmailCustomBrandMutationOptions = Apollo.BaseMutationOptions<CreateEmailCustomBrandMutation, CreateEmailCustomBrandMutationVariables>;
export const UpdateEmailCustomBrandDocument = gql`
    mutation UpdateEmailCustomBrand($body: EmailCustomBrandInput!, $updateEmailCustomBrandId: String!) {
  updateEmailCustomBrand(body: $body, id: $updateEmailCustomBrandId) {
    id
    name
    colors {
      primary
      secondary
      tertiary
    }
    logo {
      image
    }
    status
    custom_text
    updated_at
  }
}
    `;
export type UpdateEmailCustomBrandMutationFn = Apollo.MutationFunction<UpdateEmailCustomBrandMutation, UpdateEmailCustomBrandMutationVariables>;

/**
 * __useUpdateEmailCustomBrandMutation__
 *
 * To run a mutation, you first call `useUpdateEmailCustomBrandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmailCustomBrandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmailCustomBrandMutation, { data, loading, error }] = useUpdateEmailCustomBrandMutation({
 *   variables: {
 *      body: // value for 'body'
 *      updateEmailCustomBrandId: // value for 'updateEmailCustomBrandId'
 *   },
 * });
 */
export function useUpdateEmailCustomBrandMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEmailCustomBrandMutation, UpdateEmailCustomBrandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEmailCustomBrandMutation, UpdateEmailCustomBrandMutationVariables>(UpdateEmailCustomBrandDocument, options);
      }
export type UpdateEmailCustomBrandMutationHookResult = ReturnType<typeof useUpdateEmailCustomBrandMutation>;
export type UpdateEmailCustomBrandMutationResult = Apollo.MutationResult<UpdateEmailCustomBrandMutation>;
export type UpdateEmailCustomBrandMutationOptions = Apollo.BaseMutationOptions<UpdateEmailCustomBrandMutation, UpdateEmailCustomBrandMutationVariables>;
export const TestEmailCustomBrandDocument = gql`
    mutation TestEmailCustomBrand($body: EmailCustomBrandTestInput!) {
  testEmailCustomBrand(body: $body) {
    Message
  }
}
    `;
export type TestEmailCustomBrandMutationFn = Apollo.MutationFunction<TestEmailCustomBrandMutation, TestEmailCustomBrandMutationVariables>;

/**
 * __useTestEmailCustomBrandMutation__
 *
 * To run a mutation, you first call `useTestEmailCustomBrandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTestEmailCustomBrandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [testEmailCustomBrandMutation, { data, loading, error }] = useTestEmailCustomBrandMutation({
 *   variables: {
 *      body: // value for 'body'
 *   },
 * });
 */
export function useTestEmailCustomBrandMutation(baseOptions?: Apollo.MutationHookOptions<TestEmailCustomBrandMutation, TestEmailCustomBrandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TestEmailCustomBrandMutation, TestEmailCustomBrandMutationVariables>(TestEmailCustomBrandDocument, options);
      }
export type TestEmailCustomBrandMutationHookResult = ReturnType<typeof useTestEmailCustomBrandMutation>;
export type TestEmailCustomBrandMutationResult = Apollo.MutationResult<TestEmailCustomBrandMutation>;
export type TestEmailCustomBrandMutationOptions = Apollo.BaseMutationOptions<TestEmailCustomBrandMutation, TestEmailCustomBrandMutationVariables>;
export const GetEmailCustomBrandsDocument = gql`
    query GetEmailCustomBrands {
  emailCustomBrands {
    id
    name
    colors {
      primary
      secondary
      tertiary
    }
    logo {
      image
    }
    status
    custom_text
    updated_at
  }
}
    `;

/**
 * __useGetEmailCustomBrandsQuery__
 *
 * To run a query within a React component, call `useGetEmailCustomBrandsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailCustomBrandsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailCustomBrandsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEmailCustomBrandsQuery(baseOptions?: Apollo.QueryHookOptions<GetEmailCustomBrandsQuery, GetEmailCustomBrandsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmailCustomBrandsQuery, GetEmailCustomBrandsQueryVariables>(GetEmailCustomBrandsDocument, options);
      }
export function useGetEmailCustomBrandsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmailCustomBrandsQuery, GetEmailCustomBrandsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmailCustomBrandsQuery, GetEmailCustomBrandsQueryVariables>(GetEmailCustomBrandsDocument, options);
        }
export type GetEmailCustomBrandsQueryHookResult = ReturnType<typeof useGetEmailCustomBrandsQuery>;
export type GetEmailCustomBrandsLazyQueryHookResult = ReturnType<typeof useGetEmailCustomBrandsLazyQuery>;
export type GetEmailCustomBrandsQueryResult = Apollo.QueryResult<GetEmailCustomBrandsQuery, GetEmailCustomBrandsQueryVariables>;
export const ProspectAutoScoringGetRulesDocument = gql`
    query ProspectAutoScoringGetRules($vendorId: String!) {
  prospectAutoScoringGetRules(vendor_id: $vendorId) {
    data {
      vendorId
      name
      description
      active
      visible
      ruleSetId
      pk
      sk
      rules {
        ... on CloseDateRule {
          ruleType
          closeDateFilter {
            ... on CloseDateWithin {
              selector
              quantity
              unit
            }
            ... on CloseDateAfter {
              selector
              date
            }
            ... on CloseDateBefore {
              selector
              date
            }
          }
          ruleId
          ruleSetId
          pk
          sk
        }
        ... on SalesStageRule {
          ruleType
          salesStages
          ruleId
          ruleSetId
          pk
          sk
        }
        ... on OpportunityRule {
          ruleType
          opportunityTypes
          ruleId
          ruleSetId
          pk
          sk
        }
        ... on TCVRule {
          ruleType
          selector
          amount
          ruleId
          ruleSetId
          pk
          sk
        }
        ... on OpportunitiesExistRule {
          ruleType
          opportunitiesExist
          ruleId
          ruleSetId
          pk
          sk
        }
      }
    }
  }
}
    `;

/**
 * __useProspectAutoScoringGetRulesQuery__
 *
 * To run a query within a React component, call `useProspectAutoScoringGetRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProspectAutoScoringGetRulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProspectAutoScoringGetRulesQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *   },
 * });
 */
export function useProspectAutoScoringGetRulesQuery(baseOptions: Apollo.QueryHookOptions<ProspectAutoScoringGetRulesQuery, ProspectAutoScoringGetRulesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProspectAutoScoringGetRulesQuery, ProspectAutoScoringGetRulesQueryVariables>(ProspectAutoScoringGetRulesDocument, options);
      }
export function useProspectAutoScoringGetRulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProspectAutoScoringGetRulesQuery, ProspectAutoScoringGetRulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProspectAutoScoringGetRulesQuery, ProspectAutoScoringGetRulesQueryVariables>(ProspectAutoScoringGetRulesDocument, options);
        }
export type ProspectAutoScoringGetRulesQueryHookResult = ReturnType<typeof useProspectAutoScoringGetRulesQuery>;
export type ProspectAutoScoringGetRulesLazyQueryHookResult = ReturnType<typeof useProspectAutoScoringGetRulesLazyQuery>;
export type ProspectAutoScoringGetRulesQueryResult = Apollo.QueryResult<ProspectAutoScoringGetRulesQuery, ProspectAutoScoringGetRulesQueryVariables>;
export const ProspectAutoScoringOpportunityTypeFilteringValuesDocument = gql`
    query ProspectAutoScoringOpportunityTypeFilteringValues($vendorId: String!) {
  prospectAutoScoringOpportunityTypeFilteringValues(vendor_id: $vendorId) {
    data
  }
}
    `;

/**
 * __useProspectAutoScoringOpportunityTypeFilteringValuesQuery__
 *
 * To run a query within a React component, call `useProspectAutoScoringOpportunityTypeFilteringValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProspectAutoScoringOpportunityTypeFilteringValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProspectAutoScoringOpportunityTypeFilteringValuesQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *   },
 * });
 */
export function useProspectAutoScoringOpportunityTypeFilteringValuesQuery(baseOptions: Apollo.QueryHookOptions<ProspectAutoScoringOpportunityTypeFilteringValuesQuery, ProspectAutoScoringOpportunityTypeFilteringValuesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProspectAutoScoringOpportunityTypeFilteringValuesQuery, ProspectAutoScoringOpportunityTypeFilteringValuesQueryVariables>(ProspectAutoScoringOpportunityTypeFilteringValuesDocument, options);
      }
export function useProspectAutoScoringOpportunityTypeFilteringValuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProspectAutoScoringOpportunityTypeFilteringValuesQuery, ProspectAutoScoringOpportunityTypeFilteringValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProspectAutoScoringOpportunityTypeFilteringValuesQuery, ProspectAutoScoringOpportunityTypeFilteringValuesQueryVariables>(ProspectAutoScoringOpportunityTypeFilteringValuesDocument, options);
        }
export type ProspectAutoScoringOpportunityTypeFilteringValuesQueryHookResult = ReturnType<typeof useProspectAutoScoringOpportunityTypeFilteringValuesQuery>;
export type ProspectAutoScoringOpportunityTypeFilteringValuesLazyQueryHookResult = ReturnType<typeof useProspectAutoScoringOpportunityTypeFilteringValuesLazyQuery>;
export type ProspectAutoScoringOpportunityTypeFilteringValuesQueryResult = Apollo.QueryResult<ProspectAutoScoringOpportunityTypeFilteringValuesQuery, ProspectAutoScoringOpportunityTypeFilteringValuesQueryVariables>;
export const ProspectAutoScoringSalesStageFilteringValuesDocument = gql`
    query ProspectAutoScoringSalesStageFilteringValues($vendorId: String!) {
  prospectAutoScoringSalesStageFilteringValues(vendor_id: $vendorId) {
    data
  }
}
    `;

/**
 * __useProspectAutoScoringSalesStageFilteringValuesQuery__
 *
 * To run a query within a React component, call `useProspectAutoScoringSalesStageFilteringValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProspectAutoScoringSalesStageFilteringValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProspectAutoScoringSalesStageFilteringValuesQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *   },
 * });
 */
export function useProspectAutoScoringSalesStageFilteringValuesQuery(baseOptions: Apollo.QueryHookOptions<ProspectAutoScoringSalesStageFilteringValuesQuery, ProspectAutoScoringSalesStageFilteringValuesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProspectAutoScoringSalesStageFilteringValuesQuery, ProspectAutoScoringSalesStageFilteringValuesQueryVariables>(ProspectAutoScoringSalesStageFilteringValuesDocument, options);
      }
export function useProspectAutoScoringSalesStageFilteringValuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProspectAutoScoringSalesStageFilteringValuesQuery, ProspectAutoScoringSalesStageFilteringValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProspectAutoScoringSalesStageFilteringValuesQuery, ProspectAutoScoringSalesStageFilteringValuesQueryVariables>(ProspectAutoScoringSalesStageFilteringValuesDocument, options);
        }
export type ProspectAutoScoringSalesStageFilteringValuesQueryHookResult = ReturnType<typeof useProspectAutoScoringSalesStageFilteringValuesQuery>;
export type ProspectAutoScoringSalesStageFilteringValuesLazyQueryHookResult = ReturnType<typeof useProspectAutoScoringSalesStageFilteringValuesLazyQuery>;
export type ProspectAutoScoringSalesStageFilteringValuesQueryResult = Apollo.QueryResult<ProspectAutoScoringSalesStageFilteringValuesQuery, ProspectAutoScoringSalesStageFilteringValuesQueryVariables>;
export const ProspectAutoScoringGetDomainCountDocument = gql`
    query ProspectAutoScoringGetDomainCount($vendorId: String!, $rules: AllRulesInput!) {
  prospectAutoScoringGetDomainCount(vendor_id: $vendorId, rules: $rules) {
    domainCount
  }
}
    `;

/**
 * __useProspectAutoScoringGetDomainCountQuery__
 *
 * To run a query within a React component, call `useProspectAutoScoringGetDomainCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useProspectAutoScoringGetDomainCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProspectAutoScoringGetDomainCountQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *      rules: // value for 'rules'
 *   },
 * });
 */
export function useProspectAutoScoringGetDomainCountQuery(baseOptions: Apollo.QueryHookOptions<ProspectAutoScoringGetDomainCountQuery, ProspectAutoScoringGetDomainCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProspectAutoScoringGetDomainCountQuery, ProspectAutoScoringGetDomainCountQueryVariables>(ProspectAutoScoringGetDomainCountDocument, options);
      }
export function useProspectAutoScoringGetDomainCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProspectAutoScoringGetDomainCountQuery, ProspectAutoScoringGetDomainCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProspectAutoScoringGetDomainCountQuery, ProspectAutoScoringGetDomainCountQueryVariables>(ProspectAutoScoringGetDomainCountDocument, options);
        }
export type ProspectAutoScoringGetDomainCountQueryHookResult = ReturnType<typeof useProspectAutoScoringGetDomainCountQuery>;
export type ProspectAutoScoringGetDomainCountLazyQueryHookResult = ReturnType<typeof useProspectAutoScoringGetDomainCountLazyQuery>;
export type ProspectAutoScoringGetDomainCountQueryResult = Apollo.QueryResult<ProspectAutoScoringGetDomainCountQuery, ProspectAutoScoringGetDomainCountQueryVariables>;
export const ProspectAutoScoringGetOrCreateDefaultRuleDocument = gql`
    mutation ProspectAutoScoringGetOrCreateDefaultRule($vendorId: String!) {
  prospectAutoScoringGetOrCreateDefaultRule(vendor_id: $vendorId) {
    data {
      vendorId
      name
      visible
      description
      active
      ruleSetId
      rules {
        ... on CloseDateRule {
          ruleType
          closeDateFilter {
            ... on CloseDateWithin {
              selector
              quantity
              unit
            }
            ... on CloseDateAfter {
              selector
              date
            }
            ... on CloseDateBefore {
              selector
              date
            }
          }
          ruleId
          ruleSetId
        }
        ... on SalesStageRule {
          ruleType
          salesStages
          ruleId
          ruleSetId
        }
        ... on OpportunityRule {
          ruleType
          opportunityTypes
          ruleId
          ruleSetId
        }
        ... on TCVRule {
          ruleType
          selector
          amount
          ruleId
          ruleSetId
        }
        ... on OpportunitiesExistRule {
          ruleType
          opportunitiesExist
          ruleId
          ruleSetId
        }
      }
    }
  }
}
    `;
export type ProspectAutoScoringGetOrCreateDefaultRuleMutationFn = Apollo.MutationFunction<ProspectAutoScoringGetOrCreateDefaultRuleMutation, ProspectAutoScoringGetOrCreateDefaultRuleMutationVariables>;

/**
 * __useProspectAutoScoringGetOrCreateDefaultRuleMutation__
 *
 * To run a mutation, you first call `useProspectAutoScoringGetOrCreateDefaultRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProspectAutoScoringGetOrCreateDefaultRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [prospectAutoScoringGetOrCreateDefaultRuleMutation, { data, loading, error }] = useProspectAutoScoringGetOrCreateDefaultRuleMutation({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *   },
 * });
 */
export function useProspectAutoScoringGetOrCreateDefaultRuleMutation(baseOptions?: Apollo.MutationHookOptions<ProspectAutoScoringGetOrCreateDefaultRuleMutation, ProspectAutoScoringGetOrCreateDefaultRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProspectAutoScoringGetOrCreateDefaultRuleMutation, ProspectAutoScoringGetOrCreateDefaultRuleMutationVariables>(ProspectAutoScoringGetOrCreateDefaultRuleDocument, options);
      }
export type ProspectAutoScoringGetOrCreateDefaultRuleMutationHookResult = ReturnType<typeof useProspectAutoScoringGetOrCreateDefaultRuleMutation>;
export type ProspectAutoScoringGetOrCreateDefaultRuleMutationResult = Apollo.MutationResult<ProspectAutoScoringGetOrCreateDefaultRuleMutation>;
export type ProspectAutoScoringGetOrCreateDefaultRuleMutationOptions = Apollo.BaseMutationOptions<ProspectAutoScoringGetOrCreateDefaultRuleMutation, ProspectAutoScoringGetOrCreateDefaultRuleMutationVariables>;
export const ProspectAutoScoringPersistRulesDocument = gql`
    mutation ProspectAutoScoringPersistRules($vendorId: String!, $ruleSets: [RuleSetInput!]!) {
  prospectAutoScoringPersistRules(vendor_id: $vendorId, ruleSets: $ruleSets)
}
    `;
export type ProspectAutoScoringPersistRulesMutationFn = Apollo.MutationFunction<ProspectAutoScoringPersistRulesMutation, ProspectAutoScoringPersistRulesMutationVariables>;

/**
 * __useProspectAutoScoringPersistRulesMutation__
 *
 * To run a mutation, you first call `useProspectAutoScoringPersistRulesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProspectAutoScoringPersistRulesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [prospectAutoScoringPersistRulesMutation, { data, loading, error }] = useProspectAutoScoringPersistRulesMutation({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *      ruleSets: // value for 'ruleSets'
 *   },
 * });
 */
export function useProspectAutoScoringPersistRulesMutation(baseOptions?: Apollo.MutationHookOptions<ProspectAutoScoringPersistRulesMutation, ProspectAutoScoringPersistRulesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProspectAutoScoringPersistRulesMutation, ProspectAutoScoringPersistRulesMutationVariables>(ProspectAutoScoringPersistRulesDocument, options);
      }
export type ProspectAutoScoringPersistRulesMutationHookResult = ReturnType<typeof useProspectAutoScoringPersistRulesMutation>;
export type ProspectAutoScoringPersistRulesMutationResult = Apollo.MutationResult<ProspectAutoScoringPersistRulesMutation>;
export type ProspectAutoScoringPersistRulesMutationOptions = Apollo.BaseMutationOptions<ProspectAutoScoringPersistRulesMutation, ProspectAutoScoringPersistRulesMutationVariables>;
export const ProspectAutoScoringDeleteRuleSetsDocument = gql`
    mutation ProspectAutoScoringDeleteRuleSets($vendorId: String!, $ruleSets: [RuleSetInput!]!) {
  prospectAutoScoringDeleteRuleSets(vendor_id: $vendorId, ruleSets: $ruleSets)
}
    `;
export type ProspectAutoScoringDeleteRuleSetsMutationFn = Apollo.MutationFunction<ProspectAutoScoringDeleteRuleSetsMutation, ProspectAutoScoringDeleteRuleSetsMutationVariables>;

/**
 * __useProspectAutoScoringDeleteRuleSetsMutation__
 *
 * To run a mutation, you first call `useProspectAutoScoringDeleteRuleSetsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProspectAutoScoringDeleteRuleSetsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [prospectAutoScoringDeleteRuleSetsMutation, { data, loading, error }] = useProspectAutoScoringDeleteRuleSetsMutation({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *      ruleSets: // value for 'ruleSets'
 *   },
 * });
 */
export function useProspectAutoScoringDeleteRuleSetsMutation(baseOptions?: Apollo.MutationHookOptions<ProspectAutoScoringDeleteRuleSetsMutation, ProspectAutoScoringDeleteRuleSetsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProspectAutoScoringDeleteRuleSetsMutation, ProspectAutoScoringDeleteRuleSetsMutationVariables>(ProspectAutoScoringDeleteRuleSetsDocument, options);
      }
export type ProspectAutoScoringDeleteRuleSetsMutationHookResult = ReturnType<typeof useProspectAutoScoringDeleteRuleSetsMutation>;
export type ProspectAutoScoringDeleteRuleSetsMutationResult = Apollo.MutationResult<ProspectAutoScoringDeleteRuleSetsMutation>;
export type ProspectAutoScoringDeleteRuleSetsMutationOptions = Apollo.BaseMutationOptions<ProspectAutoScoringDeleteRuleSetsMutation, ProspectAutoScoringDeleteRuleSetsMutationVariables>;
export const ProspectAutoScoringDeleteRulesDocument = gql`
    mutation ProspectAutoScoringDeleteRules($vendorId: String!, $rules: AllRulesInput!) {
  prospectAutoScoringDeleteRules(vendor_id: $vendorId, rules: $rules)
}
    `;
export type ProspectAutoScoringDeleteRulesMutationFn = Apollo.MutationFunction<ProspectAutoScoringDeleteRulesMutation, ProspectAutoScoringDeleteRulesMutationVariables>;

/**
 * __useProspectAutoScoringDeleteRulesMutation__
 *
 * To run a mutation, you first call `useProspectAutoScoringDeleteRulesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProspectAutoScoringDeleteRulesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [prospectAutoScoringDeleteRulesMutation, { data, loading, error }] = useProspectAutoScoringDeleteRulesMutation({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *      rules: // value for 'rules'
 *   },
 * });
 */
export function useProspectAutoScoringDeleteRulesMutation(baseOptions?: Apollo.MutationHookOptions<ProspectAutoScoringDeleteRulesMutation, ProspectAutoScoringDeleteRulesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProspectAutoScoringDeleteRulesMutation, ProspectAutoScoringDeleteRulesMutationVariables>(ProspectAutoScoringDeleteRulesDocument, options);
      }
export type ProspectAutoScoringDeleteRulesMutationHookResult = ReturnType<typeof useProspectAutoScoringDeleteRulesMutation>;
export type ProspectAutoScoringDeleteRulesMutationResult = Apollo.MutationResult<ProspectAutoScoringDeleteRulesMutation>;
export type ProspectAutoScoringDeleteRulesMutationOptions = Apollo.BaseMutationOptions<ProspectAutoScoringDeleteRulesMutation, ProspectAutoScoringDeleteRulesMutationVariables>;
export const AccountSettingsDocument = gql`
    query accountSettings {
  currentUser {
    id
    vendor {
      id
      feature_flags {
        is_co_sell_enabled
        is_co_sell_enabled_for_microsoft
      }
    }
  }
}
    `;

/**
 * __useAccountSettingsQuery__
 *
 * To run a query within a React component, call `useAccountSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccountSettingsQuery(baseOptions?: Apollo.QueryHookOptions<AccountSettingsQuery, AccountSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountSettingsQuery, AccountSettingsQueryVariables>(AccountSettingsDocument, options);
      }
export function useAccountSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountSettingsQuery, AccountSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountSettingsQuery, AccountSettingsQueryVariables>(AccountSettingsDocument, options);
        }
export type AccountSettingsQueryHookResult = ReturnType<typeof useAccountSettingsQuery>;
export type AccountSettingsLazyQueryHookResult = ReturnType<typeof useAccountSettingsLazyQuery>;
export type AccountSettingsQueryResult = Apollo.QueryResult<AccountSettingsQuery, AccountSettingsQueryVariables>;
export const GetMarketplaceSettingsDocument = gql`
    query getMarketplaceSettings {
  currentUser {
    id
    vendor {
      id
      configuration {
        id
        aws {
          assume_role {
            role_arn
          }
          data_feed {
            S3_bucket
            sqs {
              url
            }
          }
        }
      }
      email
      listingsByChannel {
        id
        aws {
          id
          marketplace_url
          status
        }
        azure {
          id
          marketplace_url
          status
        }
        gcp {
          id
          marketplace_url
          status
        }
      }
      onboarding {
        aws {
          account_setup
          stacks
        }
      }
    }
  }
}
    `;

/**
 * __useGetMarketplaceSettingsQuery__
 *
 * To run a query within a React component, call `useGetMarketplaceSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMarketplaceSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMarketplaceSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMarketplaceSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GetMarketplaceSettingsQuery, GetMarketplaceSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMarketplaceSettingsQuery, GetMarketplaceSettingsQueryVariables>(GetMarketplaceSettingsDocument, options);
      }
export function useGetMarketplaceSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMarketplaceSettingsQuery, GetMarketplaceSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMarketplaceSettingsQuery, GetMarketplaceSettingsQueryVariables>(GetMarketplaceSettingsDocument, options);
        }
export type GetMarketplaceSettingsQueryHookResult = ReturnType<typeof useGetMarketplaceSettingsQuery>;
export type GetMarketplaceSettingsLazyQueryHookResult = ReturnType<typeof useGetMarketplaceSettingsLazyQuery>;
export type GetMarketplaceSettingsQueryResult = Apollo.QueryResult<GetMarketplaceSettingsQuery, GetMarketplaceSettingsQueryVariables>;
export const UpdateMarketplaceSettingsDocument = gql`
    mutation updateMarketplaceSettings($updates: VendorInput!) {
  updateVendor(updates: $updates) {
    email
    id
  }
}
    `;
export type UpdateMarketplaceSettingsMutationFn = Apollo.MutationFunction<UpdateMarketplaceSettingsMutation, UpdateMarketplaceSettingsMutationVariables>;

/**
 * __useUpdateMarketplaceSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateMarketplaceSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMarketplaceSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMarketplaceSettingsMutation, { data, loading, error }] = useUpdateMarketplaceSettingsMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateMarketplaceSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMarketplaceSettingsMutation, UpdateMarketplaceSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMarketplaceSettingsMutation, UpdateMarketplaceSettingsMutationVariables>(UpdateMarketplaceSettingsDocument, options);
      }
export type UpdateMarketplaceSettingsMutationHookResult = ReturnType<typeof useUpdateMarketplaceSettingsMutation>;
export type UpdateMarketplaceSettingsMutationResult = Apollo.MutationResult<UpdateMarketplaceSettingsMutation>;
export type UpdateMarketplaceSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateMarketplaceSettingsMutation, UpdateMarketplaceSettingsMutationVariables>;
export const AwsVendorCasIamPolicyFormSectionDocument = gql`
    query AwsVendorCasIamPolicyFormSection {
  currentUser {
    id
    vendor {
      id
      configuration {
        aws {
          assume_role {
            role_arn
          }
        }
      }
      onboarding {
        aws {
          stacks
        }
      }
    }
  }
}
    `;

/**
 * __useAwsVendorCasIamPolicyFormSectionQuery__
 *
 * To run a query within a React component, call `useAwsVendorCasIamPolicyFormSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAwsVendorCasIamPolicyFormSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAwsVendorCasIamPolicyFormSectionQuery({
 *   variables: {
 *   },
 * });
 */
export function useAwsVendorCasIamPolicyFormSectionQuery(baseOptions?: Apollo.QueryHookOptions<AwsVendorCasIamPolicyFormSectionQuery, AwsVendorCasIamPolicyFormSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AwsVendorCasIamPolicyFormSectionQuery, AwsVendorCasIamPolicyFormSectionQueryVariables>(AwsVendorCasIamPolicyFormSectionDocument, options);
      }
export function useAwsVendorCasIamPolicyFormSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AwsVendorCasIamPolicyFormSectionQuery, AwsVendorCasIamPolicyFormSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AwsVendorCasIamPolicyFormSectionQuery, AwsVendorCasIamPolicyFormSectionQueryVariables>(AwsVendorCasIamPolicyFormSectionDocument, options);
        }
export type AwsVendorCasIamPolicyFormSectionQueryHookResult = ReturnType<typeof useAwsVendorCasIamPolicyFormSectionQuery>;
export type AwsVendorCasIamPolicyFormSectionLazyQueryHookResult = ReturnType<typeof useAwsVendorCasIamPolicyFormSectionLazyQuery>;
export type AwsVendorCasIamPolicyFormSectionQueryResult = Apollo.QueryResult<AwsVendorCasIamPolicyFormSectionQuery, AwsVendorCasIamPolicyFormSectionQueryVariables>;
export const UpdateAwsVendorCasIamPolicyFormSectionDocument = gql`
    mutation UpdateAwsVendorCasIamPolicyFormSection($updates: VendorInput!) {
  updateVendor(updates: $updates) {
    id
    onboarding {
      aws {
        stacks
      }
    }
  }
}
    `;
export type UpdateAwsVendorCasIamPolicyFormSectionMutationFn = Apollo.MutationFunction<UpdateAwsVendorCasIamPolicyFormSectionMutation, UpdateAwsVendorCasIamPolicyFormSectionMutationVariables>;

/**
 * __useUpdateAwsVendorCasIamPolicyFormSectionMutation__
 *
 * To run a mutation, you first call `useUpdateAwsVendorCasIamPolicyFormSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAwsVendorCasIamPolicyFormSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAwsVendorCasIamPolicyFormSectionMutation, { data, loading, error }] = useUpdateAwsVendorCasIamPolicyFormSectionMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateAwsVendorCasIamPolicyFormSectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAwsVendorCasIamPolicyFormSectionMutation, UpdateAwsVendorCasIamPolicyFormSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAwsVendorCasIamPolicyFormSectionMutation, UpdateAwsVendorCasIamPolicyFormSectionMutationVariables>(UpdateAwsVendorCasIamPolicyFormSectionDocument, options);
      }
export type UpdateAwsVendorCasIamPolicyFormSectionMutationHookResult = ReturnType<typeof useUpdateAwsVendorCasIamPolicyFormSectionMutation>;
export type UpdateAwsVendorCasIamPolicyFormSectionMutationResult = Apollo.MutationResult<UpdateAwsVendorCasIamPolicyFormSectionMutation>;
export type UpdateAwsVendorCasIamPolicyFormSectionMutationOptions = Apollo.BaseMutationOptions<UpdateAwsVendorCasIamPolicyFormSectionMutation, UpdateAwsVendorCasIamPolicyFormSectionMutationVariables>;
export const AwsVendorEnrollInSddsFormSectionDocument = gql`
    query AwsVendorEnrollInSddsFormSection {
  currentUser {
    id
    vendor {
      id
      configuration {
        aws {
          data_feed {
            kms_key_arn
            S3_bucket
            sns_topic_arn
          }
        }
      }
      onboarding {
        aws {
          stacks
        }
      }
    }
  }
}
    `;

/**
 * __useAwsVendorEnrollInSddsFormSectionQuery__
 *
 * To run a query within a React component, call `useAwsVendorEnrollInSddsFormSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAwsVendorEnrollInSddsFormSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAwsVendorEnrollInSddsFormSectionQuery({
 *   variables: {
 *   },
 * });
 */
export function useAwsVendorEnrollInSddsFormSectionQuery(baseOptions?: Apollo.QueryHookOptions<AwsVendorEnrollInSddsFormSectionQuery, AwsVendorEnrollInSddsFormSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AwsVendorEnrollInSddsFormSectionQuery, AwsVendorEnrollInSddsFormSectionQueryVariables>(AwsVendorEnrollInSddsFormSectionDocument, options);
      }
export function useAwsVendorEnrollInSddsFormSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AwsVendorEnrollInSddsFormSectionQuery, AwsVendorEnrollInSddsFormSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AwsVendorEnrollInSddsFormSectionQuery, AwsVendorEnrollInSddsFormSectionQueryVariables>(AwsVendorEnrollInSddsFormSectionDocument, options);
        }
export type AwsVendorEnrollInSddsFormSectionQueryHookResult = ReturnType<typeof useAwsVendorEnrollInSddsFormSectionQuery>;
export type AwsVendorEnrollInSddsFormSectionLazyQueryHookResult = ReturnType<typeof useAwsVendorEnrollInSddsFormSectionLazyQuery>;
export type AwsVendorEnrollInSddsFormSectionQueryResult = Apollo.QueryResult<AwsVendorEnrollInSddsFormSectionQuery, AwsVendorEnrollInSddsFormSectionQueryVariables>;
export const UpdateAwsVendorEnrollInSddsFormSectionDocument = gql`
    mutation UpdateAwsVendorEnrollInSddsFormSection($updates: VendorInput!) {
  updateVendor(updates: $updates) {
    id
    configuration {
      aws {
        data_feed {
          kms_key_arn
          S3_bucket
          sns_topic_arn
        }
      }
    }
    onboarding {
      aws {
        stacks
      }
    }
  }
}
    `;
export type UpdateAwsVendorEnrollInSddsFormSectionMutationFn = Apollo.MutationFunction<UpdateAwsVendorEnrollInSddsFormSectionMutation, UpdateAwsVendorEnrollInSddsFormSectionMutationVariables>;

/**
 * __useUpdateAwsVendorEnrollInSddsFormSectionMutation__
 *
 * To run a mutation, you first call `useUpdateAwsVendorEnrollInSddsFormSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAwsVendorEnrollInSddsFormSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAwsVendorEnrollInSddsFormSectionMutation, { data, loading, error }] = useUpdateAwsVendorEnrollInSddsFormSectionMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateAwsVendorEnrollInSddsFormSectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAwsVendorEnrollInSddsFormSectionMutation, UpdateAwsVendorEnrollInSddsFormSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAwsVendorEnrollInSddsFormSectionMutation, UpdateAwsVendorEnrollInSddsFormSectionMutationVariables>(UpdateAwsVendorEnrollInSddsFormSectionDocument, options);
      }
export type UpdateAwsVendorEnrollInSddsFormSectionMutationHookResult = ReturnType<typeof useUpdateAwsVendorEnrollInSddsFormSectionMutation>;
export type UpdateAwsVendorEnrollInSddsFormSectionMutationResult = Apollo.MutationResult<UpdateAwsVendorEnrollInSddsFormSectionMutation>;
export type UpdateAwsVendorEnrollInSddsFormSectionMutationOptions = Apollo.BaseMutationOptions<UpdateAwsVendorEnrollInSddsFormSectionMutation, UpdateAwsVendorEnrollInSddsFormSectionMutationVariables>;
export const AwsVendorAccountSetupFormSectionDocument = gql`
    query AwsVendorAccountSetupFormSection {
  currentUser {
    id
    vendor {
      id
      onboarding {
        aws {
          account_setup
        }
      }
    }
  }
}
    `;

/**
 * __useAwsVendorAccountSetupFormSectionQuery__
 *
 * To run a query within a React component, call `useAwsVendorAccountSetupFormSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAwsVendorAccountSetupFormSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAwsVendorAccountSetupFormSectionQuery({
 *   variables: {
 *   },
 * });
 */
export function useAwsVendorAccountSetupFormSectionQuery(baseOptions?: Apollo.QueryHookOptions<AwsVendorAccountSetupFormSectionQuery, AwsVendorAccountSetupFormSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AwsVendorAccountSetupFormSectionQuery, AwsVendorAccountSetupFormSectionQueryVariables>(AwsVendorAccountSetupFormSectionDocument, options);
      }
export function useAwsVendorAccountSetupFormSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AwsVendorAccountSetupFormSectionQuery, AwsVendorAccountSetupFormSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AwsVendorAccountSetupFormSectionQuery, AwsVendorAccountSetupFormSectionQueryVariables>(AwsVendorAccountSetupFormSectionDocument, options);
        }
export type AwsVendorAccountSetupFormSectionQueryHookResult = ReturnType<typeof useAwsVendorAccountSetupFormSectionQuery>;
export type AwsVendorAccountSetupFormSectionLazyQueryHookResult = ReturnType<typeof useAwsVendorAccountSetupFormSectionLazyQuery>;
export type AwsVendorAccountSetupFormSectionQueryResult = Apollo.QueryResult<AwsVendorAccountSetupFormSectionQuery, AwsVendorAccountSetupFormSectionQueryVariables>;
export const UpdateAwsVendorAccountSetupFormSectionDocument = gql`
    mutation UpdateAwsVendorAccountSetupFormSection($updates: VendorInput!) {
  updateVendor(updates: $updates) {
    id
    onboarding {
      aws {
        account_setup
      }
    }
  }
}
    `;
export type UpdateAwsVendorAccountSetupFormSectionMutationFn = Apollo.MutationFunction<UpdateAwsVendorAccountSetupFormSectionMutation, UpdateAwsVendorAccountSetupFormSectionMutationVariables>;

/**
 * __useUpdateAwsVendorAccountSetupFormSectionMutation__
 *
 * To run a mutation, you first call `useUpdateAwsVendorAccountSetupFormSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAwsVendorAccountSetupFormSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAwsVendorAccountSetupFormSectionMutation, { data, loading, error }] = useUpdateAwsVendorAccountSetupFormSectionMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateAwsVendorAccountSetupFormSectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAwsVendorAccountSetupFormSectionMutation, UpdateAwsVendorAccountSetupFormSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAwsVendorAccountSetupFormSectionMutation, UpdateAwsVendorAccountSetupFormSectionMutationVariables>(UpdateAwsVendorAccountSetupFormSectionDocument, options);
      }
export type UpdateAwsVendorAccountSetupFormSectionMutationHookResult = ReturnType<typeof useUpdateAwsVendorAccountSetupFormSectionMutation>;
export type UpdateAwsVendorAccountSetupFormSectionMutationResult = Apollo.MutationResult<UpdateAwsVendorAccountSetupFormSectionMutation>;
export type UpdateAwsVendorAccountSetupFormSectionMutationOptions = Apollo.BaseMutationOptions<UpdateAwsVendorAccountSetupFormSectionMutation, UpdateAwsVendorAccountSetupFormSectionMutationVariables>;
export const AwsVendorGrantTackleAccessFormSectionDocument = gql`
    query AwsVendorGrantTackleAccessFormSection {
  currentUser {
    id
    vendor {
      id
      configuration {
        id
        aws {
          assume_role {
            role_arn
          }
        }
      }
      onboarding {
        aws {
          stacks
          admin_contacts {
            name
            email
          }
        }
      }
      external_id
    }
  }
}
    `;

/**
 * __useAwsVendorGrantTackleAccessFormSectionQuery__
 *
 * To run a query within a React component, call `useAwsVendorGrantTackleAccessFormSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAwsVendorGrantTackleAccessFormSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAwsVendorGrantTackleAccessFormSectionQuery({
 *   variables: {
 *   },
 * });
 */
export function useAwsVendorGrantTackleAccessFormSectionQuery(baseOptions?: Apollo.QueryHookOptions<AwsVendorGrantTackleAccessFormSectionQuery, AwsVendorGrantTackleAccessFormSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AwsVendorGrantTackleAccessFormSectionQuery, AwsVendorGrantTackleAccessFormSectionQueryVariables>(AwsVendorGrantTackleAccessFormSectionDocument, options);
      }
export function useAwsVendorGrantTackleAccessFormSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AwsVendorGrantTackleAccessFormSectionQuery, AwsVendorGrantTackleAccessFormSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AwsVendorGrantTackleAccessFormSectionQuery, AwsVendorGrantTackleAccessFormSectionQueryVariables>(AwsVendorGrantTackleAccessFormSectionDocument, options);
        }
export type AwsVendorGrantTackleAccessFormSectionQueryHookResult = ReturnType<typeof useAwsVendorGrantTackleAccessFormSectionQuery>;
export type AwsVendorGrantTackleAccessFormSectionLazyQueryHookResult = ReturnType<typeof useAwsVendorGrantTackleAccessFormSectionLazyQuery>;
export type AwsVendorGrantTackleAccessFormSectionQueryResult = Apollo.QueryResult<AwsVendorGrantTackleAccessFormSectionQuery, AwsVendorGrantTackleAccessFormSectionQueryVariables>;
export const UpdateAwsVendorGrantTackleAccessFormSectionDocument = gql`
    mutation UpdateAwsVendorGrantTackleAccessFormSection($id: ID!, $updates: VendorInput!) {
  updateVendor(updates: $updates) {
    id
    configuration {
      id
      aws {
        assume_role {
          role_arn
        }
      }
    }
    onboarding {
      aws {
        stacks
        admin_contacts {
          name
          email
        }
      }
    }
  }
  validateVendor(id: $id) {
    id
    configuration {
      id
      status {
        aws {
          value
          last_connected_at
          updated_at
          error
        }
        events_sqs {
          value
          last_connected_at
          updated_at
          error
        }
        sdds {
          value
          last_connected_at
          updated_at
          error
        }
      }
    }
  }
}
    `;
export type UpdateAwsVendorGrantTackleAccessFormSectionMutationFn = Apollo.MutationFunction<UpdateAwsVendorGrantTackleAccessFormSectionMutation, UpdateAwsVendorGrantTackleAccessFormSectionMutationVariables>;

/**
 * __useUpdateAwsVendorGrantTackleAccessFormSectionMutation__
 *
 * To run a mutation, you first call `useUpdateAwsVendorGrantTackleAccessFormSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAwsVendorGrantTackleAccessFormSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAwsVendorGrantTackleAccessFormSectionMutation, { data, loading, error }] = useUpdateAwsVendorGrantTackleAccessFormSectionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateAwsVendorGrantTackleAccessFormSectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAwsVendorGrantTackleAccessFormSectionMutation, UpdateAwsVendorGrantTackleAccessFormSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAwsVendorGrantTackleAccessFormSectionMutation, UpdateAwsVendorGrantTackleAccessFormSectionMutationVariables>(UpdateAwsVendorGrantTackleAccessFormSectionDocument, options);
      }
export type UpdateAwsVendorGrantTackleAccessFormSectionMutationHookResult = ReturnType<typeof useUpdateAwsVendorGrantTackleAccessFormSectionMutation>;
export type UpdateAwsVendorGrantTackleAccessFormSectionMutationResult = Apollo.MutationResult<UpdateAwsVendorGrantTackleAccessFormSectionMutation>;
export type UpdateAwsVendorGrantTackleAccessFormSectionMutationOptions = Apollo.BaseMutationOptions<UpdateAwsVendorGrantTackleAccessFormSectionMutation, UpdateAwsVendorGrantTackleAccessFormSectionMutationVariables>;
export const AwsVendorSetupOrderNotificationsFormSectionDocument = gql`
    query AwsVendorSetupOrderNotificationsFormSection {
  currentUser {
    id
    vendor {
      id
      configuration {
        id
        vendor_events {
          url
        }
        aws {
          assume_role {
            role_arn
          }
        }
      }
      onboarding {
        aws {
          stacks
        }
      }
      name
    }
  }
}
    `;

/**
 * __useAwsVendorSetupOrderNotificationsFormSectionQuery__
 *
 * To run a query within a React component, call `useAwsVendorSetupOrderNotificationsFormSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAwsVendorSetupOrderNotificationsFormSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAwsVendorSetupOrderNotificationsFormSectionQuery({
 *   variables: {
 *   },
 * });
 */
export function useAwsVendorSetupOrderNotificationsFormSectionQuery(baseOptions?: Apollo.QueryHookOptions<AwsVendorSetupOrderNotificationsFormSectionQuery, AwsVendorSetupOrderNotificationsFormSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AwsVendorSetupOrderNotificationsFormSectionQuery, AwsVendorSetupOrderNotificationsFormSectionQueryVariables>(AwsVendorSetupOrderNotificationsFormSectionDocument, options);
      }
export function useAwsVendorSetupOrderNotificationsFormSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AwsVendorSetupOrderNotificationsFormSectionQuery, AwsVendorSetupOrderNotificationsFormSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AwsVendorSetupOrderNotificationsFormSectionQuery, AwsVendorSetupOrderNotificationsFormSectionQueryVariables>(AwsVendorSetupOrderNotificationsFormSectionDocument, options);
        }
export type AwsVendorSetupOrderNotificationsFormSectionQueryHookResult = ReturnType<typeof useAwsVendorSetupOrderNotificationsFormSectionQuery>;
export type AwsVendorSetupOrderNotificationsFormSectionLazyQueryHookResult = ReturnType<typeof useAwsVendorSetupOrderNotificationsFormSectionLazyQuery>;
export type AwsVendorSetupOrderNotificationsFormSectionQueryResult = Apollo.QueryResult<AwsVendorSetupOrderNotificationsFormSectionQuery, AwsVendorSetupOrderNotificationsFormSectionQueryVariables>;
export const UpdateAwsVendorSetupOrderNotificationsFormSectionDocument = gql`
    mutation UpdateAwsVendorSetupOrderNotificationsFormSection($updates: VendorInput!) {
  updateVendor(updates: $updates) {
    id
    configuration {
      aws {
        assume_role {
          role_arn
        }
      }
      vendor_events {
        url
      }
    }
    onboarding {
      aws {
        stacks
      }
    }
  }
}
    `;
export type UpdateAwsVendorSetupOrderNotificationsFormSectionMutationFn = Apollo.MutationFunction<UpdateAwsVendorSetupOrderNotificationsFormSectionMutation, UpdateAwsVendorSetupOrderNotificationsFormSectionMutationVariables>;

/**
 * __useUpdateAwsVendorSetupOrderNotificationsFormSectionMutation__
 *
 * To run a mutation, you first call `useUpdateAwsVendorSetupOrderNotificationsFormSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAwsVendorSetupOrderNotificationsFormSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAwsVendorSetupOrderNotificationsFormSectionMutation, { data, loading, error }] = useUpdateAwsVendorSetupOrderNotificationsFormSectionMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateAwsVendorSetupOrderNotificationsFormSectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAwsVendorSetupOrderNotificationsFormSectionMutation, UpdateAwsVendorSetupOrderNotificationsFormSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAwsVendorSetupOrderNotificationsFormSectionMutation, UpdateAwsVendorSetupOrderNotificationsFormSectionMutationVariables>(UpdateAwsVendorSetupOrderNotificationsFormSectionDocument, options);
      }
export type UpdateAwsVendorSetupOrderNotificationsFormSectionMutationHookResult = ReturnType<typeof useUpdateAwsVendorSetupOrderNotificationsFormSectionMutation>;
export type UpdateAwsVendorSetupOrderNotificationsFormSectionMutationResult = Apollo.MutationResult<UpdateAwsVendorSetupOrderNotificationsFormSectionMutation>;
export type UpdateAwsVendorSetupOrderNotificationsFormSectionMutationOptions = Apollo.BaseMutationOptions<UpdateAwsVendorSetupOrderNotificationsFormSectionMutation, UpdateAwsVendorSetupOrderNotificationsFormSectionMutationVariables>;
export const AwsVendorSetupSddsFormSectionDocument = gql`
    query AwsVendorSetupSddsFormSection {
  currentUser {
    id
    vendor {
      id
      configuration {
        aws {
          assume_role {
            role_arn
          }
          data_feed {
            kms_key_arn
            S3_bucket
            sns_topic_arn
            sqs {
              url
            }
          }
        }
      }
      onboarding {
        aws {
          stacks
        }
      }
      name
    }
  }
}
    `;

/**
 * __useAwsVendorSetupSddsFormSectionQuery__
 *
 * To run a query within a React component, call `useAwsVendorSetupSddsFormSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAwsVendorSetupSddsFormSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAwsVendorSetupSddsFormSectionQuery({
 *   variables: {
 *   },
 * });
 */
export function useAwsVendorSetupSddsFormSectionQuery(baseOptions?: Apollo.QueryHookOptions<AwsVendorSetupSddsFormSectionQuery, AwsVendorSetupSddsFormSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AwsVendorSetupSddsFormSectionQuery, AwsVendorSetupSddsFormSectionQueryVariables>(AwsVendorSetupSddsFormSectionDocument, options);
      }
export function useAwsVendorSetupSddsFormSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AwsVendorSetupSddsFormSectionQuery, AwsVendorSetupSddsFormSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AwsVendorSetupSddsFormSectionQuery, AwsVendorSetupSddsFormSectionQueryVariables>(AwsVendorSetupSddsFormSectionDocument, options);
        }
export type AwsVendorSetupSddsFormSectionQueryHookResult = ReturnType<typeof useAwsVendorSetupSddsFormSectionQuery>;
export type AwsVendorSetupSddsFormSectionLazyQueryHookResult = ReturnType<typeof useAwsVendorSetupSddsFormSectionLazyQuery>;
export type AwsVendorSetupSddsFormSectionQueryResult = Apollo.QueryResult<AwsVendorSetupSddsFormSectionQuery, AwsVendorSetupSddsFormSectionQueryVariables>;
export const UpdateAwsVendorSetupSddsFormSectionDocument = gql`
    mutation UpdateAwsVendorSetupSddsFormSection($updates: VendorInput!) {
  updateVendor(updates: $updates) {
    id
    configuration {
      aws {
        assume_role {
          role_arn
        }
        data_feed {
          kms_key_arn
          S3_bucket
          sns_topic_arn
          sqs {
            url
          }
        }
      }
    }
    onboarding {
      aws {
        stacks
      }
    }
    name
  }
}
    `;
export type UpdateAwsVendorSetupSddsFormSectionMutationFn = Apollo.MutationFunction<UpdateAwsVendorSetupSddsFormSectionMutation, UpdateAwsVendorSetupSddsFormSectionMutationVariables>;

/**
 * __useUpdateAwsVendorSetupSddsFormSectionMutation__
 *
 * To run a mutation, you first call `useUpdateAwsVendorSetupSddsFormSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAwsVendorSetupSddsFormSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAwsVendorSetupSddsFormSectionMutation, { data, loading, error }] = useUpdateAwsVendorSetupSddsFormSectionMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateAwsVendorSetupSddsFormSectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAwsVendorSetupSddsFormSectionMutation, UpdateAwsVendorSetupSddsFormSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAwsVendorSetupSddsFormSectionMutation, UpdateAwsVendorSetupSddsFormSectionMutationVariables>(UpdateAwsVendorSetupSddsFormSectionDocument, options);
      }
export type UpdateAwsVendorSetupSddsFormSectionMutationHookResult = ReturnType<typeof useUpdateAwsVendorSetupSddsFormSectionMutation>;
export type UpdateAwsVendorSetupSddsFormSectionMutationResult = Apollo.MutationResult<UpdateAwsVendorSetupSddsFormSectionMutation>;
export type UpdateAwsVendorSetupSddsFormSectionMutationOptions = Apollo.BaseMutationOptions<UpdateAwsVendorSetupSddsFormSectionMutation, UpdateAwsVendorSetupSddsFormSectionMutationVariables>;
export const ValidateVendorConfigurationButtonDocument = gql`
    query ValidateVendorConfigurationButton {
  currentUser {
    id
    vendor {
      id
      configuration {
        aws {
          assume_role {
            role_arn
          }
        }
      }
    }
  }
}
    `;

/**
 * __useValidateVendorConfigurationButtonQuery__
 *
 * To run a query within a React component, call `useValidateVendorConfigurationButtonQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateVendorConfigurationButtonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateVendorConfigurationButtonQuery({
 *   variables: {
 *   },
 * });
 */
export function useValidateVendorConfigurationButtonQuery(baseOptions?: Apollo.QueryHookOptions<ValidateVendorConfigurationButtonQuery, ValidateVendorConfigurationButtonQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateVendorConfigurationButtonQuery, ValidateVendorConfigurationButtonQueryVariables>(ValidateVendorConfigurationButtonDocument, options);
      }
export function useValidateVendorConfigurationButtonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateVendorConfigurationButtonQuery, ValidateVendorConfigurationButtonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateVendorConfigurationButtonQuery, ValidateVendorConfigurationButtonQueryVariables>(ValidateVendorConfigurationButtonDocument, options);
        }
export type ValidateVendorConfigurationButtonQueryHookResult = ReturnType<typeof useValidateVendorConfigurationButtonQuery>;
export type ValidateVendorConfigurationButtonLazyQueryHookResult = ReturnType<typeof useValidateVendorConfigurationButtonLazyQuery>;
export type ValidateVendorConfigurationButtonQueryResult = Apollo.QueryResult<ValidateVendorConfigurationButtonQuery, ValidateVendorConfigurationButtonQueryVariables>;
export const ValidateVendorConfigurationDocument = gql`
    mutation ValidateVendorConfiguration($id: ID!) {
  validateVendor(id: $id) {
    id
    configuration {
      id
      status {
        aws {
          value
          last_connected_at
          updated_at
          error
        }
        events_sqs {
          value
          last_connected_at
          updated_at
          error
        }
        sdds {
          value
          last_connected_at
          updated_at
          error
        }
      }
    }
  }
}
    `;
export type ValidateVendorConfigurationMutationFn = Apollo.MutationFunction<ValidateVendorConfigurationMutation, ValidateVendorConfigurationMutationVariables>;

/**
 * __useValidateVendorConfigurationMutation__
 *
 * To run a mutation, you first call `useValidateVendorConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateVendorConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateVendorConfigurationMutation, { data, loading, error }] = useValidateVendorConfigurationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useValidateVendorConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<ValidateVendorConfigurationMutation, ValidateVendorConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateVendorConfigurationMutation, ValidateVendorConfigurationMutationVariables>(ValidateVendorConfigurationDocument, options);
      }
export type ValidateVendorConfigurationMutationHookResult = ReturnType<typeof useValidateVendorConfigurationMutation>;
export type ValidateVendorConfigurationMutationResult = Apollo.MutationResult<ValidateVendorConfigurationMutation>;
export type ValidateVendorConfigurationMutationOptions = Apollo.BaseMutationOptions<ValidateVendorConfigurationMutation, ValidateVendorConfigurationMutationVariables>;
export const AzureVendorAdditionalServicesFormSectionDocument = gql`
    query AzureVendorAdditionalServicesFormSection {
  currentUser {
    id
    vendor {
      id
      onboarding {
        azure {
          commercial_marketplace
        }
      }
    }
  }
}
    `;

/**
 * __useAzureVendorAdditionalServicesFormSectionQuery__
 *
 * To run a query within a React component, call `useAzureVendorAdditionalServicesFormSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAzureVendorAdditionalServicesFormSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAzureVendorAdditionalServicesFormSectionQuery({
 *   variables: {
 *   },
 * });
 */
export function useAzureVendorAdditionalServicesFormSectionQuery(baseOptions?: Apollo.QueryHookOptions<AzureVendorAdditionalServicesFormSectionQuery, AzureVendorAdditionalServicesFormSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AzureVendorAdditionalServicesFormSectionQuery, AzureVendorAdditionalServicesFormSectionQueryVariables>(AzureVendorAdditionalServicesFormSectionDocument, options);
      }
export function useAzureVendorAdditionalServicesFormSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AzureVendorAdditionalServicesFormSectionQuery, AzureVendorAdditionalServicesFormSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AzureVendorAdditionalServicesFormSectionQuery, AzureVendorAdditionalServicesFormSectionQueryVariables>(AzureVendorAdditionalServicesFormSectionDocument, options);
        }
export type AzureVendorAdditionalServicesFormSectionQueryHookResult = ReturnType<typeof useAzureVendorAdditionalServicesFormSectionQuery>;
export type AzureVendorAdditionalServicesFormSectionLazyQueryHookResult = ReturnType<typeof useAzureVendorAdditionalServicesFormSectionLazyQuery>;
export type AzureVendorAdditionalServicesFormSectionQueryResult = Apollo.QueryResult<AzureVendorAdditionalServicesFormSectionQuery, AzureVendorAdditionalServicesFormSectionQueryVariables>;
export const UpdateAzureVendorAdditionalServicesFormSectionDocument = gql`
    mutation UpdateAzureVendorAdditionalServicesFormSection($updates: VendorInput!) {
  updateVendor(updates: $updates) {
    id
    onboarding {
      azure {
        commercial_marketplace
      }
    }
  }
}
    `;
export type UpdateAzureVendorAdditionalServicesFormSectionMutationFn = Apollo.MutationFunction<UpdateAzureVendorAdditionalServicesFormSectionMutation, UpdateAzureVendorAdditionalServicesFormSectionMutationVariables>;

/**
 * __useUpdateAzureVendorAdditionalServicesFormSectionMutation__
 *
 * To run a mutation, you first call `useUpdateAzureVendorAdditionalServicesFormSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAzureVendorAdditionalServicesFormSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAzureVendorAdditionalServicesFormSectionMutation, { data, loading, error }] = useUpdateAzureVendorAdditionalServicesFormSectionMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateAzureVendorAdditionalServicesFormSectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAzureVendorAdditionalServicesFormSectionMutation, UpdateAzureVendorAdditionalServicesFormSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAzureVendorAdditionalServicesFormSectionMutation, UpdateAzureVendorAdditionalServicesFormSectionMutationVariables>(UpdateAzureVendorAdditionalServicesFormSectionDocument, options);
      }
export type UpdateAzureVendorAdditionalServicesFormSectionMutationHookResult = ReturnType<typeof useUpdateAzureVendorAdditionalServicesFormSectionMutation>;
export type UpdateAzureVendorAdditionalServicesFormSectionMutationResult = Apollo.MutationResult<UpdateAzureVendorAdditionalServicesFormSectionMutation>;
export type UpdateAzureVendorAdditionalServicesFormSectionMutationOptions = Apollo.BaseMutationOptions<UpdateAzureVendorAdditionalServicesFormSectionMutation, UpdateAzureVendorAdditionalServicesFormSectionMutationVariables>;
export const AzureVendorMarketplaceAccountFormSectionDocument = gql`
    query AzureVendorMarketplaceAccountFormSection {
  currentUser {
    id
    vendor {
      id
      onboarding {
        azure {
          account_setup
          commercial_marketplace
          admin_contacts {
            name
            email
          }
        }
      }
    }
  }
}
    `;

/**
 * __useAzureVendorMarketplaceAccountFormSectionQuery__
 *
 * To run a query within a React component, call `useAzureVendorMarketplaceAccountFormSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAzureVendorMarketplaceAccountFormSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAzureVendorMarketplaceAccountFormSectionQuery({
 *   variables: {
 *   },
 * });
 */
export function useAzureVendorMarketplaceAccountFormSectionQuery(baseOptions?: Apollo.QueryHookOptions<AzureVendorMarketplaceAccountFormSectionQuery, AzureVendorMarketplaceAccountFormSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AzureVendorMarketplaceAccountFormSectionQuery, AzureVendorMarketplaceAccountFormSectionQueryVariables>(AzureVendorMarketplaceAccountFormSectionDocument, options);
      }
export function useAzureVendorMarketplaceAccountFormSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AzureVendorMarketplaceAccountFormSectionQuery, AzureVendorMarketplaceAccountFormSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AzureVendorMarketplaceAccountFormSectionQuery, AzureVendorMarketplaceAccountFormSectionQueryVariables>(AzureVendorMarketplaceAccountFormSectionDocument, options);
        }
export type AzureVendorMarketplaceAccountFormSectionQueryHookResult = ReturnType<typeof useAzureVendorMarketplaceAccountFormSectionQuery>;
export type AzureVendorMarketplaceAccountFormSectionLazyQueryHookResult = ReturnType<typeof useAzureVendorMarketplaceAccountFormSectionLazyQuery>;
export type AzureVendorMarketplaceAccountFormSectionQueryResult = Apollo.QueryResult<AzureVendorMarketplaceAccountFormSectionQuery, AzureVendorMarketplaceAccountFormSectionQueryVariables>;
export const UpdateAzureVendorMarketplaceAccountFormSectionDocument = gql`
    mutation UpdateAzureVendorMarketplaceAccountFormSection($updates: VendorInput!) {
  updateVendor(updates: $updates) {
    id
    onboarding {
      azure {
        account_setup
        commercial_marketplace
        admin_contacts {
          name
          email
        }
      }
    }
  }
}
    `;
export type UpdateAzureVendorMarketplaceAccountFormSectionMutationFn = Apollo.MutationFunction<UpdateAzureVendorMarketplaceAccountFormSectionMutation, UpdateAzureVendorMarketplaceAccountFormSectionMutationVariables>;

/**
 * __useUpdateAzureVendorMarketplaceAccountFormSectionMutation__
 *
 * To run a mutation, you first call `useUpdateAzureVendorMarketplaceAccountFormSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAzureVendorMarketplaceAccountFormSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAzureVendorMarketplaceAccountFormSectionMutation, { data, loading, error }] = useUpdateAzureVendorMarketplaceAccountFormSectionMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateAzureVendorMarketplaceAccountFormSectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAzureVendorMarketplaceAccountFormSectionMutation, UpdateAzureVendorMarketplaceAccountFormSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAzureVendorMarketplaceAccountFormSectionMutation, UpdateAzureVendorMarketplaceAccountFormSectionMutationVariables>(UpdateAzureVendorMarketplaceAccountFormSectionDocument, options);
      }
export type UpdateAzureVendorMarketplaceAccountFormSectionMutationHookResult = ReturnType<typeof useUpdateAzureVendorMarketplaceAccountFormSectionMutation>;
export type UpdateAzureVendorMarketplaceAccountFormSectionMutationResult = Apollo.MutationResult<UpdateAzureVendorMarketplaceAccountFormSectionMutation>;
export type UpdateAzureVendorMarketplaceAccountFormSectionMutationOptions = Apollo.BaseMutationOptions<UpdateAzureVendorMarketplaceAccountFormSectionMutation, UpdateAzureVendorMarketplaceAccountFormSectionMutationVariables>;
export const AzureVendorTackleAndAzureFormSectionDocument = gql`
    query AzureVendorTackleAndAzureFormSection {
  currentUser {
    id
    vendor {
      id
      configuration {
        azure {
          exp_date
        }
      }
      onboarding {
        azure {
          account_setup
          commercial_marketplace
        }
      }
      coSell {
        id
        mspc_connected
        microsoftPartnerCenterConsentLink
        microsoftSolutions {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useAzureVendorTackleAndAzureFormSectionQuery__
 *
 * To run a query within a React component, call `useAzureVendorTackleAndAzureFormSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAzureVendorTackleAndAzureFormSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAzureVendorTackleAndAzureFormSectionQuery({
 *   variables: {
 *   },
 * });
 */
export function useAzureVendorTackleAndAzureFormSectionQuery(baseOptions?: Apollo.QueryHookOptions<AzureVendorTackleAndAzureFormSectionQuery, AzureVendorTackleAndAzureFormSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AzureVendorTackleAndAzureFormSectionQuery, AzureVendorTackleAndAzureFormSectionQueryVariables>(AzureVendorTackleAndAzureFormSectionDocument, options);
      }
export function useAzureVendorTackleAndAzureFormSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AzureVendorTackleAndAzureFormSectionQuery, AzureVendorTackleAndAzureFormSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AzureVendorTackleAndAzureFormSectionQuery, AzureVendorTackleAndAzureFormSectionQueryVariables>(AzureVendorTackleAndAzureFormSectionDocument, options);
        }
export type AzureVendorTackleAndAzureFormSectionQueryHookResult = ReturnType<typeof useAzureVendorTackleAndAzureFormSectionQuery>;
export type AzureVendorTackleAndAzureFormSectionLazyQueryHookResult = ReturnType<typeof useAzureVendorTackleAndAzureFormSectionLazyQuery>;
export type AzureVendorTackleAndAzureFormSectionQueryResult = Apollo.QueryResult<AzureVendorTackleAndAzureFormSectionQuery, AzureVendorTackleAndAzureFormSectionQueryVariables>;
export const AzureVendorTackleAndAzureFormSectionMspcConnectedDocument = gql`
    query AzureVendorTackleAndAzureFormSectionMspcConnected {
  currentUser {
    id
    vendor {
      id
      coSell {
        id
        mspc_connected
      }
    }
  }
}
    `;

/**
 * __useAzureVendorTackleAndAzureFormSectionMspcConnectedQuery__
 *
 * To run a query within a React component, call `useAzureVendorTackleAndAzureFormSectionMspcConnectedQuery` and pass it any options that fit your needs.
 * When your component renders, `useAzureVendorTackleAndAzureFormSectionMspcConnectedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAzureVendorTackleAndAzureFormSectionMspcConnectedQuery({
 *   variables: {
 *   },
 * });
 */
export function useAzureVendorTackleAndAzureFormSectionMspcConnectedQuery(baseOptions?: Apollo.QueryHookOptions<AzureVendorTackleAndAzureFormSectionMspcConnectedQuery, AzureVendorTackleAndAzureFormSectionMspcConnectedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AzureVendorTackleAndAzureFormSectionMspcConnectedQuery, AzureVendorTackleAndAzureFormSectionMspcConnectedQueryVariables>(AzureVendorTackleAndAzureFormSectionMspcConnectedDocument, options);
      }
export function useAzureVendorTackleAndAzureFormSectionMspcConnectedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AzureVendorTackleAndAzureFormSectionMspcConnectedQuery, AzureVendorTackleAndAzureFormSectionMspcConnectedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AzureVendorTackleAndAzureFormSectionMspcConnectedQuery, AzureVendorTackleAndAzureFormSectionMspcConnectedQueryVariables>(AzureVendorTackleAndAzureFormSectionMspcConnectedDocument, options);
        }
export type AzureVendorTackleAndAzureFormSectionMspcConnectedQueryHookResult = ReturnType<typeof useAzureVendorTackleAndAzureFormSectionMspcConnectedQuery>;
export type AzureVendorTackleAndAzureFormSectionMspcConnectedLazyQueryHookResult = ReturnType<typeof useAzureVendorTackleAndAzureFormSectionMspcConnectedLazyQuery>;
export type AzureVendorTackleAndAzureFormSectionMspcConnectedQueryResult = Apollo.QueryResult<AzureVendorTackleAndAzureFormSectionMspcConnectedQuery, AzureVendorTackleAndAzureFormSectionMspcConnectedQueryVariables>;
export const UpdateAzureVendorTackleAndAzureFormSectionDocument = gql`
    mutation UpdateAzureVendorTackleAndAzureFormSection($updates: VendorInput!) {
  updateVendor(updates: $updates) {
    id
    configuration {
      azure {
        exp_date
      }
    }
    onboarding {
      azure {
        account_setup
        commercial_marketplace
      }
    }
    coSell {
      id
      mspc_connected
      microsoftPartnerCenterConsentLink
    }
  }
}
    `;
export type UpdateAzureVendorTackleAndAzureFormSectionMutationFn = Apollo.MutationFunction<UpdateAzureVendorTackleAndAzureFormSectionMutation, UpdateAzureVendorTackleAndAzureFormSectionMutationVariables>;

/**
 * __useUpdateAzureVendorTackleAndAzureFormSectionMutation__
 *
 * To run a mutation, you first call `useUpdateAzureVendorTackleAndAzureFormSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAzureVendorTackleAndAzureFormSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAzureVendorTackleAndAzureFormSectionMutation, { data, loading, error }] = useUpdateAzureVendorTackleAndAzureFormSectionMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateAzureVendorTackleAndAzureFormSectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAzureVendorTackleAndAzureFormSectionMutation, UpdateAzureVendorTackleAndAzureFormSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAzureVendorTackleAndAzureFormSectionMutation, UpdateAzureVendorTackleAndAzureFormSectionMutationVariables>(UpdateAzureVendorTackleAndAzureFormSectionDocument, options);
      }
export type UpdateAzureVendorTackleAndAzureFormSectionMutationHookResult = ReturnType<typeof useUpdateAzureVendorTackleAndAzureFormSectionMutation>;
export type UpdateAzureVendorTackleAndAzureFormSectionMutationResult = Apollo.MutationResult<UpdateAzureVendorTackleAndAzureFormSectionMutation>;
export type UpdateAzureVendorTackleAndAzureFormSectionMutationOptions = Apollo.BaseMutationOptions<UpdateAzureVendorTackleAndAzureFormSectionMutation, UpdateAzureVendorTackleAndAzureFormSectionMutationVariables>;
export const GcpVendorAdditionalServicesFormSectionDocument = gql`
    query GcpVendorAdditionalServicesFormSection {
  currentUser {
    id
    vendor {
      id
      configuration {
        gcp {
          projects {
            id: name
            report_bucket
          }
        }
      }
      onboarding {
        gcp {
          gc_payment_is_configured
        }
      }
    }
  }
}
    `;

/**
 * __useGcpVendorAdditionalServicesFormSectionQuery__
 *
 * To run a query within a React component, call `useGcpVendorAdditionalServicesFormSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGcpVendorAdditionalServicesFormSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGcpVendorAdditionalServicesFormSectionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGcpVendorAdditionalServicesFormSectionQuery(baseOptions?: Apollo.QueryHookOptions<GcpVendorAdditionalServicesFormSectionQuery, GcpVendorAdditionalServicesFormSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GcpVendorAdditionalServicesFormSectionQuery, GcpVendorAdditionalServicesFormSectionQueryVariables>(GcpVendorAdditionalServicesFormSectionDocument, options);
      }
export function useGcpVendorAdditionalServicesFormSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GcpVendorAdditionalServicesFormSectionQuery, GcpVendorAdditionalServicesFormSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GcpVendorAdditionalServicesFormSectionQuery, GcpVendorAdditionalServicesFormSectionQueryVariables>(GcpVendorAdditionalServicesFormSectionDocument, options);
        }
export type GcpVendorAdditionalServicesFormSectionQueryHookResult = ReturnType<typeof useGcpVendorAdditionalServicesFormSectionQuery>;
export type GcpVendorAdditionalServicesFormSectionLazyQueryHookResult = ReturnType<typeof useGcpVendorAdditionalServicesFormSectionLazyQuery>;
export type GcpVendorAdditionalServicesFormSectionQueryResult = Apollo.QueryResult<GcpVendorAdditionalServicesFormSectionQuery, GcpVendorAdditionalServicesFormSectionQueryVariables>;
export const UpdateGcpVendorAdditionalServicesFormSectionDocument = gql`
    mutation UpdateGcpVendorAdditionalServicesFormSection($updates: VendorInput!) {
  updateVendor(updates: $updates) {
    id
    configuration {
      gcp {
        projects {
          id: name
          report_bucket
        }
      }
    }
    onboarding {
      gcp {
        gc_payment_is_configured
      }
    }
  }
}
    `;
export type UpdateGcpVendorAdditionalServicesFormSectionMutationFn = Apollo.MutationFunction<UpdateGcpVendorAdditionalServicesFormSectionMutation, UpdateGcpVendorAdditionalServicesFormSectionMutationVariables>;

/**
 * __useUpdateGcpVendorAdditionalServicesFormSectionMutation__
 *
 * To run a mutation, you first call `useUpdateGcpVendorAdditionalServicesFormSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGcpVendorAdditionalServicesFormSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGcpVendorAdditionalServicesFormSectionMutation, { data, loading, error }] = useUpdateGcpVendorAdditionalServicesFormSectionMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateGcpVendorAdditionalServicesFormSectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGcpVendorAdditionalServicesFormSectionMutation, UpdateGcpVendorAdditionalServicesFormSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGcpVendorAdditionalServicesFormSectionMutation, UpdateGcpVendorAdditionalServicesFormSectionMutationVariables>(UpdateGcpVendorAdditionalServicesFormSectionDocument, options);
      }
export type UpdateGcpVendorAdditionalServicesFormSectionMutationHookResult = ReturnType<typeof useUpdateGcpVendorAdditionalServicesFormSectionMutation>;
export type UpdateGcpVendorAdditionalServicesFormSectionMutationResult = Apollo.MutationResult<UpdateGcpVendorAdditionalServicesFormSectionMutation>;
export type UpdateGcpVendorAdditionalServicesFormSectionMutationOptions = Apollo.BaseMutationOptions<UpdateGcpVendorAdditionalServicesFormSectionMutation, UpdateGcpVendorAdditionalServicesFormSectionMutationVariables>;
export const GcpVendorMarketplaceAccountFormSectionDocument = gql`
    query GcpVendorMarketplaceAccountFormSection {
  currentUser {
    id
    vendor {
      id
      configuration {
        gcp {
          projects {
            id: name
            name
            service_account
            service_account_name
            service_account_email_address
            project_name
            project_number
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGcpVendorMarketplaceAccountFormSectionQuery__
 *
 * To run a query within a React component, call `useGcpVendorMarketplaceAccountFormSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGcpVendorMarketplaceAccountFormSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGcpVendorMarketplaceAccountFormSectionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGcpVendorMarketplaceAccountFormSectionQuery(baseOptions?: Apollo.QueryHookOptions<GcpVendorMarketplaceAccountFormSectionQuery, GcpVendorMarketplaceAccountFormSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GcpVendorMarketplaceAccountFormSectionQuery, GcpVendorMarketplaceAccountFormSectionQueryVariables>(GcpVendorMarketplaceAccountFormSectionDocument, options);
      }
export function useGcpVendorMarketplaceAccountFormSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GcpVendorMarketplaceAccountFormSectionQuery, GcpVendorMarketplaceAccountFormSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GcpVendorMarketplaceAccountFormSectionQuery, GcpVendorMarketplaceAccountFormSectionQueryVariables>(GcpVendorMarketplaceAccountFormSectionDocument, options);
        }
export type GcpVendorMarketplaceAccountFormSectionQueryHookResult = ReturnType<typeof useGcpVendorMarketplaceAccountFormSectionQuery>;
export type GcpVendorMarketplaceAccountFormSectionLazyQueryHookResult = ReturnType<typeof useGcpVendorMarketplaceAccountFormSectionLazyQuery>;
export type GcpVendorMarketplaceAccountFormSectionQueryResult = Apollo.QueryResult<GcpVendorMarketplaceAccountFormSectionQuery, GcpVendorMarketplaceAccountFormSectionQueryVariables>;
export const UpdateGcpVendorMarketplaceAccountFormSectionDocument = gql`
    mutation UpdateGcpVendorMarketplaceAccountFormSection($updates: VendorInput!) {
  updateVendor(updates: $updates) {
    id
    configuration {
      gcp {
        projects {
          id: name
          name
          service_account
          service_account_name
          service_account_email_address
          project_name
          project_number
        }
      }
    }
  }
}
    `;
export type UpdateGcpVendorMarketplaceAccountFormSectionMutationFn = Apollo.MutationFunction<UpdateGcpVendorMarketplaceAccountFormSectionMutation, UpdateGcpVendorMarketplaceAccountFormSectionMutationVariables>;

/**
 * __useUpdateGcpVendorMarketplaceAccountFormSectionMutation__
 *
 * To run a mutation, you first call `useUpdateGcpVendorMarketplaceAccountFormSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGcpVendorMarketplaceAccountFormSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGcpVendorMarketplaceAccountFormSectionMutation, { data, loading, error }] = useUpdateGcpVendorMarketplaceAccountFormSectionMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateGcpVendorMarketplaceAccountFormSectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGcpVendorMarketplaceAccountFormSectionMutation, UpdateGcpVendorMarketplaceAccountFormSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGcpVendorMarketplaceAccountFormSectionMutation, UpdateGcpVendorMarketplaceAccountFormSectionMutationVariables>(UpdateGcpVendorMarketplaceAccountFormSectionDocument, options);
      }
export type UpdateGcpVendorMarketplaceAccountFormSectionMutationHookResult = ReturnType<typeof useUpdateGcpVendorMarketplaceAccountFormSectionMutation>;
export type UpdateGcpVendorMarketplaceAccountFormSectionMutationResult = Apollo.MutationResult<UpdateGcpVendorMarketplaceAccountFormSectionMutation>;
export type UpdateGcpVendorMarketplaceAccountFormSectionMutationOptions = Apollo.BaseMutationOptions<UpdateGcpVendorMarketplaceAccountFormSectionMutation, UpdateGcpVendorMarketplaceAccountFormSectionMutationVariables>;
export const GcpVendorTackleAndGcpFormSectionDocument = gql`
    query GcpVendorTackleAndGcpFormSection {
  currentUser {
    vendor {
      id
      onboarding {
        gcp {
          gc_project_access_is_granted
          gc_tackle_permissions_for_offers_granted
          gc_marketplace_form_is_submitted
          admin_contacts {
            name
            email
          }
        }
      }
      reporting {
        health {
          gcp_status {
            status
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGcpVendorTackleAndGcpFormSectionQuery__
 *
 * To run a query within a React component, call `useGcpVendorTackleAndGcpFormSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGcpVendorTackleAndGcpFormSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGcpVendorTackleAndGcpFormSectionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGcpVendorTackleAndGcpFormSectionQuery(baseOptions?: Apollo.QueryHookOptions<GcpVendorTackleAndGcpFormSectionQuery, GcpVendorTackleAndGcpFormSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GcpVendorTackleAndGcpFormSectionQuery, GcpVendorTackleAndGcpFormSectionQueryVariables>(GcpVendorTackleAndGcpFormSectionDocument, options);
      }
export function useGcpVendorTackleAndGcpFormSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GcpVendorTackleAndGcpFormSectionQuery, GcpVendorTackleAndGcpFormSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GcpVendorTackleAndGcpFormSectionQuery, GcpVendorTackleAndGcpFormSectionQueryVariables>(GcpVendorTackleAndGcpFormSectionDocument, options);
        }
export type GcpVendorTackleAndGcpFormSectionQueryHookResult = ReturnType<typeof useGcpVendorTackleAndGcpFormSectionQuery>;
export type GcpVendorTackleAndGcpFormSectionLazyQueryHookResult = ReturnType<typeof useGcpVendorTackleAndGcpFormSectionLazyQuery>;
export type GcpVendorTackleAndGcpFormSectionQueryResult = Apollo.QueryResult<GcpVendorTackleAndGcpFormSectionQuery, GcpVendorTackleAndGcpFormSectionQueryVariables>;
export const UpdateGcpVendorTackleAndGcpFormSectionDocument = gql`
    mutation UpdateGcpVendorTackleAndGcpFormSection($updates: VendorInput!) {
  updateVendor(updates: $updates) {
    id
    onboarding {
      gcp {
        gc_project_access_is_granted
        gc_tackle_permissions_for_offers_granted
        gc_marketplace_form_is_submitted
        admin_contacts {
          name
          email
        }
      }
    }
  }
}
    `;
export type UpdateGcpVendorTackleAndGcpFormSectionMutationFn = Apollo.MutationFunction<UpdateGcpVendorTackleAndGcpFormSectionMutation, UpdateGcpVendorTackleAndGcpFormSectionMutationVariables>;

/**
 * __useUpdateGcpVendorTackleAndGcpFormSectionMutation__
 *
 * To run a mutation, you first call `useUpdateGcpVendorTackleAndGcpFormSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGcpVendorTackleAndGcpFormSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGcpVendorTackleAndGcpFormSectionMutation, { data, loading, error }] = useUpdateGcpVendorTackleAndGcpFormSectionMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateGcpVendorTackleAndGcpFormSectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGcpVendorTackleAndGcpFormSectionMutation, UpdateGcpVendorTackleAndGcpFormSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGcpVendorTackleAndGcpFormSectionMutation, UpdateGcpVendorTackleAndGcpFormSectionMutationVariables>(UpdateGcpVendorTackleAndGcpFormSectionDocument, options);
      }
export type UpdateGcpVendorTackleAndGcpFormSectionMutationHookResult = ReturnType<typeof useUpdateGcpVendorTackleAndGcpFormSectionMutation>;
export type UpdateGcpVendorTackleAndGcpFormSectionMutationResult = Apollo.MutationResult<UpdateGcpVendorTackleAndGcpFormSectionMutation>;
export type UpdateGcpVendorTackleAndGcpFormSectionMutationOptions = Apollo.BaseMutationOptions<UpdateGcpVendorTackleAndGcpFormSectionMutation, UpdateGcpVendorTackleAndGcpFormSectionMutationVariables>;
export const GetAccountSettingsUsersQueryDocument = gql`
    query getAccountSettingsUsersQuery {
  currentUser {
    id
    name
    email
    role
    organizationId
    vendor {
      id
      name
      vendor_type
    }
  }
}
    `;

/**
 * __useGetAccountSettingsUsersQueryQuery__
 *
 * To run a query within a React component, call `useGetAccountSettingsUsersQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountSettingsUsersQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountSettingsUsersQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAccountSettingsUsersQueryQuery(baseOptions?: Apollo.QueryHookOptions<GetAccountSettingsUsersQueryQuery, GetAccountSettingsUsersQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountSettingsUsersQueryQuery, GetAccountSettingsUsersQueryQueryVariables>(GetAccountSettingsUsersQueryDocument, options);
      }
export function useGetAccountSettingsUsersQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountSettingsUsersQueryQuery, GetAccountSettingsUsersQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountSettingsUsersQueryQuery, GetAccountSettingsUsersQueryQueryVariables>(GetAccountSettingsUsersQueryDocument, options);
        }
export type GetAccountSettingsUsersQueryQueryHookResult = ReturnType<typeof useGetAccountSettingsUsersQueryQuery>;
export type GetAccountSettingsUsersQueryLazyQueryHookResult = ReturnType<typeof useGetAccountSettingsUsersQueryLazyQuery>;
export type GetAccountSettingsUsersQueryQueryResult = Apollo.QueryResult<GetAccountSettingsUsersQueryQuery, GetAccountSettingsUsersQueryQueryVariables>;
export const UpsertRoleDocument = gql`
    mutation UpsertRole($body: RoleInput!) {
  upsertRole(body: $body) {
    id
    name
    organization_id
    permissions
    global
    built_in
    allowed_vendors
    created_at
    updated_at
  }
}
    `;
export type UpsertRoleMutationFn = Apollo.MutationFunction<UpsertRoleMutation, UpsertRoleMutationVariables>;

/**
 * __useUpsertRoleMutation__
 *
 * To run a mutation, you first call `useUpsertRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertRoleMutation, { data, loading, error }] = useUpsertRoleMutation({
 *   variables: {
 *      body: // value for 'body'
 *   },
 * });
 */
export function useUpsertRoleMutation(baseOptions?: Apollo.MutationHookOptions<UpsertRoleMutation, UpsertRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertRoleMutation, UpsertRoleMutationVariables>(UpsertRoleDocument, options);
      }
export type UpsertRoleMutationHookResult = ReturnType<typeof useUpsertRoleMutation>;
export type UpsertRoleMutationResult = Apollo.MutationResult<UpsertRoleMutation>;
export type UpsertRoleMutationOptions = Apollo.BaseMutationOptions<UpsertRoleMutation, UpsertRoleMutationVariables>;
export const CurrentVendorsDocument = gql`
    query CurrentVendors {
  currentVendors {
    vendorid
    name
  }
}
    `;

/**
 * __useCurrentVendorsQuery__
 *
 * To run a query within a React component, call `useCurrentVendorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentVendorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentVendorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentVendorsQuery(baseOptions?: Apollo.QueryHookOptions<CurrentVendorsQuery, CurrentVendorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentVendorsQuery, CurrentVendorsQueryVariables>(CurrentVendorsDocument, options);
      }
export function useCurrentVendorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentVendorsQuery, CurrentVendorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentVendorsQuery, CurrentVendorsQueryVariables>(CurrentVendorsDocument, options);
        }
export type CurrentVendorsQueryHookResult = ReturnType<typeof useCurrentVendorsQuery>;
export type CurrentVendorsLazyQueryHookResult = ReturnType<typeof useCurrentVendorsLazyQuery>;
export type CurrentVendorsQueryResult = Apollo.QueryResult<CurrentVendorsQuery, CurrentVendorsQueryVariables>;
export const EditRoleDrawerRoleDetailsDocument = gql`
    query editRoleDrawerRoleDetails($roleDetailsId: String!) {
  roleDetails(id: $roleDetailsId) {
    in_use
    in_use_count
  }
}
    `;

/**
 * __useEditRoleDrawerRoleDetailsQuery__
 *
 * To run a query within a React component, call `useEditRoleDrawerRoleDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditRoleDrawerRoleDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditRoleDrawerRoleDetailsQuery({
 *   variables: {
 *      roleDetailsId: // value for 'roleDetailsId'
 *   },
 * });
 */
export function useEditRoleDrawerRoleDetailsQuery(baseOptions: Apollo.QueryHookOptions<EditRoleDrawerRoleDetailsQuery, EditRoleDrawerRoleDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EditRoleDrawerRoleDetailsQuery, EditRoleDrawerRoleDetailsQueryVariables>(EditRoleDrawerRoleDetailsDocument, options);
      }
export function useEditRoleDrawerRoleDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EditRoleDrawerRoleDetailsQuery, EditRoleDrawerRoleDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EditRoleDrawerRoleDetailsQuery, EditRoleDrawerRoleDetailsQueryVariables>(EditRoleDrawerRoleDetailsDocument, options);
        }
export type EditRoleDrawerRoleDetailsQueryHookResult = ReturnType<typeof useEditRoleDrawerRoleDetailsQuery>;
export type EditRoleDrawerRoleDetailsLazyQueryHookResult = ReturnType<typeof useEditRoleDrawerRoleDetailsLazyQuery>;
export type EditRoleDrawerRoleDetailsQueryResult = Apollo.QueryResult<EditRoleDrawerRoleDetailsQuery, EditRoleDrawerRoleDetailsQueryVariables>;
export const EditRoleDrawerDeleteRoleDocument = gql`
    mutation editRoleDrawerDeleteRole($roleDeleteId: String!) {
  deleteRole(id: $roleDeleteId) {
    id
    name
  }
}
    `;
export type EditRoleDrawerDeleteRoleMutationFn = Apollo.MutationFunction<EditRoleDrawerDeleteRoleMutation, EditRoleDrawerDeleteRoleMutationVariables>;

/**
 * __useEditRoleDrawerDeleteRoleMutation__
 *
 * To run a mutation, you first call `useEditRoleDrawerDeleteRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditRoleDrawerDeleteRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editRoleDrawerDeleteRoleMutation, { data, loading, error }] = useEditRoleDrawerDeleteRoleMutation({
 *   variables: {
 *      roleDeleteId: // value for 'roleDeleteId'
 *   },
 * });
 */
export function useEditRoleDrawerDeleteRoleMutation(baseOptions?: Apollo.MutationHookOptions<EditRoleDrawerDeleteRoleMutation, EditRoleDrawerDeleteRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditRoleDrawerDeleteRoleMutation, EditRoleDrawerDeleteRoleMutationVariables>(EditRoleDrawerDeleteRoleDocument, options);
      }
export type EditRoleDrawerDeleteRoleMutationHookResult = ReturnType<typeof useEditRoleDrawerDeleteRoleMutation>;
export type EditRoleDrawerDeleteRoleMutationResult = Apollo.MutationResult<EditRoleDrawerDeleteRoleMutation>;
export type EditRoleDrawerDeleteRoleMutationOptions = Apollo.BaseMutationOptions<EditRoleDrawerDeleteRoleMutation, EditRoleDrawerDeleteRoleMutationVariables>;
export const GetRolesDocument = gql`
    query GetRoles {
  roles {
    id
    name
    organization_id
    permissions
    global
    built_in
    allowed_vendors
    created_at
    updated_at
  }
}
    `;

/**
 * __useGetRolesQuery__
 *
 * To run a query within a React component, call `useGetRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRolesQuery(baseOptions?: Apollo.QueryHookOptions<GetRolesQuery, GetRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRolesQuery, GetRolesQueryVariables>(GetRolesDocument, options);
      }
export function useGetRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRolesQuery, GetRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRolesQuery, GetRolesQueryVariables>(GetRolesDocument, options);
        }
export type GetRolesQueryHookResult = ReturnType<typeof useGetRolesQuery>;
export type GetRolesLazyQueryHookResult = ReturnType<typeof useGetRolesLazyQuery>;
export type GetRolesQueryResult = Apollo.QueryResult<GetRolesQuery, GetRolesQueryVariables>;
export const GetUsersFromOrganizationDocument = gql`
    query GetUsersFromOrganization($organizationId: String!) {
  usersFromOrganization(organizationId: $organizationId) {
    id: user_id
    user_id
    name
    email
    picture
    role_id
    role_name
    allowed_vendors_rbac
    vendor_names
    sso_user
    superadmin
    supportapi
    vendorid
    organization_id
    vendor_type
    allowed_vendors_auth0
    logins_count
    global
    created_at
    updated_at
    last_login
    deactivated_at
  }
}
    `;

/**
 * __useGetUsersFromOrganizationQuery__
 *
 * To run a query within a React component, call `useGetUsersFromOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersFromOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersFromOrganizationQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetUsersFromOrganizationQuery(baseOptions: Apollo.QueryHookOptions<GetUsersFromOrganizationQuery, GetUsersFromOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersFromOrganizationQuery, GetUsersFromOrganizationQueryVariables>(GetUsersFromOrganizationDocument, options);
      }
export function useGetUsersFromOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersFromOrganizationQuery, GetUsersFromOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersFromOrganizationQuery, GetUsersFromOrganizationQueryVariables>(GetUsersFromOrganizationDocument, options);
        }
export type GetUsersFromOrganizationQueryHookResult = ReturnType<typeof useGetUsersFromOrganizationQuery>;
export type GetUsersFromOrganizationLazyQueryHookResult = ReturnType<typeof useGetUsersFromOrganizationLazyQuery>;
export type GetUsersFromOrganizationQueryResult = Apollo.QueryResult<GetUsersFromOrganizationQuery, GetUsersFromOrganizationQueryVariables>;
export const GetOrganizationVendorIdsDocument = gql`
    query GetOrganizationVendorIds($organizationId: String!) {
  organizationVendors(organization_id: $organizationId) {
    id
    name
    vendors {
      id
      name
      vendor_type
    }
  }
}
    `;

/**
 * __useGetOrganizationVendorIdsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationVendorIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationVendorIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationVendorIdsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetOrganizationVendorIdsQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationVendorIdsQuery, GetOrganizationVendorIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationVendorIdsQuery, GetOrganizationVendorIdsQueryVariables>(GetOrganizationVendorIdsDocument, options);
      }
export function useGetOrganizationVendorIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationVendorIdsQuery, GetOrganizationVendorIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationVendorIdsQuery, GetOrganizationVendorIdsQueryVariables>(GetOrganizationVendorIdsDocument, options);
        }
export type GetOrganizationVendorIdsQueryHookResult = ReturnType<typeof useGetOrganizationVendorIdsQuery>;
export type GetOrganizationVendorIdsLazyQueryHookResult = ReturnType<typeof useGetOrganizationVendorIdsLazyQuery>;
export type GetOrganizationVendorIdsQueryResult = Apollo.QueryResult<GetOrganizationVendorIdsQuery, GetOrganizationVendorIdsQueryVariables>;
export const DeleteUserDocument = gql`
    mutation DeleteUser($userId: String!) {
  deleteUser(userId: $userId)
}
    `;
export type DeleteUserMutationFn = Apollo.MutationFunction<DeleteUserMutation, DeleteUserMutationVariables>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useDeleteUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserMutation, DeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument, options);
      }
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = Apollo.MutationResult<DeleteUserMutation>;
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<DeleteUserMutation, DeleteUserMutationVariables>;
export const SignUpDocument = gql`
    mutation SignUp($input: SignUpInput!) {
  signUp(input: $input) {
    user {
      id
      vendorid
      email
    }
  }
}
    `;
export type SignUpMutationFn = Apollo.MutationFunction<SignUpMutation, SignUpMutationVariables>;

/**
 * __useSignUpMutation__
 *
 * To run a mutation, you first call `useSignUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signUpMutation, { data, loading, error }] = useSignUpMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSignUpMutation(baseOptions?: Apollo.MutationHookOptions<SignUpMutation, SignUpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignUpMutation, SignUpMutationVariables>(SignUpDocument, options);
      }
export type SignUpMutationHookResult = ReturnType<typeof useSignUpMutation>;
export type SignUpMutationResult = Apollo.MutationResult<SignUpMutation>;
export type SignUpMutationOptions = Apollo.BaseMutationOptions<SignUpMutation, SignUpMutationVariables>;
export const CheckEmailDocument = gql`
    query CheckEmail($email: String!) {
  checkEmail(email: $email) {
    valid
  }
}
    `;

/**
 * __useCheckEmailQuery__
 *
 * To run a query within a React component, call `useCheckEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckEmailQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useCheckEmailQuery(baseOptions: Apollo.QueryHookOptions<CheckEmailQuery, CheckEmailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckEmailQuery, CheckEmailQueryVariables>(CheckEmailDocument, options);
      }
export function useCheckEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckEmailQuery, CheckEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckEmailQuery, CheckEmailQueryVariables>(CheckEmailDocument, options);
        }
export type CheckEmailQueryHookResult = ReturnType<typeof useCheckEmailQuery>;
export type CheckEmailLazyQueryHookResult = ReturnType<typeof useCheckEmailLazyQuery>;
export type CheckEmailQueryResult = Apollo.QueryResult<CheckEmailQuery, CheckEmailQueryVariables>;
export const CosellDashboardDocument = gql`
    query CosellDashboard {
  currentUser {
    id
    vendor {
      id
      vendor_type
      coSell {
        id
        ace_connected
        ace_entitled_status
        mspc_entitled_status
        mspc_connected
        microsoftSolutions {
          archivedAt
          externalId
          id
          solutionName
        }
      }
    }
  }
}
    `;

/**
 * __useCosellDashboardQuery__
 *
 * To run a query within a React component, call `useCosellDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useCosellDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCosellDashboardQuery({
 *   variables: {
 *   },
 * });
 */
export function useCosellDashboardQuery(baseOptions?: Apollo.QueryHookOptions<CosellDashboardQuery, CosellDashboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CosellDashboardQuery, CosellDashboardQueryVariables>(CosellDashboardDocument, options);
      }
export function useCosellDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CosellDashboardQuery, CosellDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CosellDashboardQuery, CosellDashboardQueryVariables>(CosellDashboardDocument, options);
        }
export type CosellDashboardQueryHookResult = ReturnType<typeof useCosellDashboardQuery>;
export type CosellDashboardLazyQueryHookResult = ReturnType<typeof useCosellDashboardLazyQuery>;
export type CosellDashboardQueryResult = Apollo.QueryResult<CosellDashboardQuery, CosellDashboardQueryVariables>;
export const PlatformRbacProviderDocument = gql`
    query PlatformRbacProvider {
  currentUser {
    id
    role_details {
      id
      permissions
    }
  }
}
    `;

/**
 * __usePlatformRbacProviderQuery__
 *
 * To run a query within a React component, call `usePlatformRbacProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlatformRbacProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlatformRbacProviderQuery({
 *   variables: {
 *   },
 * });
 */
export function usePlatformRbacProviderQuery(baseOptions?: Apollo.QueryHookOptions<PlatformRbacProviderQuery, PlatformRbacProviderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlatformRbacProviderQuery, PlatformRbacProviderQueryVariables>(PlatformRbacProviderDocument, options);
      }
export function usePlatformRbacProviderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlatformRbacProviderQuery, PlatformRbacProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlatformRbacProviderQuery, PlatformRbacProviderQueryVariables>(PlatformRbacProviderDocument, options);
        }
export type PlatformRbacProviderQueryHookResult = ReturnType<typeof usePlatformRbacProviderQuery>;
export type PlatformRbacProviderLazyQueryHookResult = ReturnType<typeof usePlatformRbacProviderLazyQuery>;
export type PlatformRbacProviderQueryResult = Apollo.QueryResult<PlatformRbacProviderQuery, PlatformRbacProviderQueryVariables>;

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "AggregationValue": [
      "LanguageAggregation",
      "StatsAggregation"
    ],
    "AllRules": [
      "CloseDateRule",
      "OpportunitiesExistRule",
      "OpportunityRule",
      "SalesStageRule",
      "TCVRule"
    ],
    "CloseDateFilter": [
      "CloseDateAfter",
      "CloseDateBefore",
      "CloseDateWithin"
    ],
    "Common": [
      "Application",
      "DataPool",
      "DataPoolAccessPolicy",
      "DataSource",
      "Metric"
    ],
    "ConnectionSettings": [
      "ClickHouseConnectionSettings",
      "HttpConnectionSettings",
      "InternalConnectionSettings",
      "KafkaConnectionSettings",
      "S3ConnectionSettings",
      "SnowflakeConnectionSettings",
      "WebhookConnectionSettings"
    ],
    "DimensionOrPlan": [
      "PrivateOfferMetadataPricingAzurePlan",
      "PrivateOfferMetadataPricingDimension"
    ],
    "HasTableEngineType": [
      "AggregatingMergeTreeTableEngine",
      "MergeTreeTableEngine",
      "ReplacingMergeTreeTableEngine",
      "SummingMergeTreeTableEngine"
    ],
    "Job": [
      "AddColumnToDataPoolJob",
      "DeletionJob",
      "UpdateDataPoolRecordsJob"
    ],
    "MetricSettings": [
      "AverageMetricSettings",
      "CountDistinctMetricSettings",
      "CountMetricSettings",
      "CustomMetricSettings",
      "MaxMetricSettings",
      "MinMetricSettings",
      "SumMetricSettings"
    ],
    "Node": [
      "AddColumnToDataPoolJob",
      "Application",
      "Booster",
      "DataPool",
      "DataPoolAccessPolicy",
      "DataSource",
      "DeletionJob",
      "Metric",
      "Policy",
      "Sync",
      "UpdateDataPoolRecordsJob"
    ],
    "ProductVertical": [
      "CoSellVertical",
      "OffersVertical",
      "ProspectVertical"
    ],
    "TableEngine": [
      "AggregatingMergeTreeTableEngine",
      "MergeTreeTableEngine",
      "ReplacingMergeTreeTableEngine",
      "SummingMergeTreeTableEngine"
    ]
  }
};
      export default result;
    